[
	{
		":id": "row-b3iy-7srj-rkd8",
		":version": "rv-vf86_xyaf-d6q8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina d'estiu d'Abrera",
		"indicador_refugi": "080018|PISCINA_D_ESTIU_D_ABRERA",
		"municipi": "Abrera",
		"codi_municipi": "080018",
		"latitud": "41.51957423",
		"longitud": "1.90278811",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pg. de l'Esglèsia",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-j3tp~a9gp_mx9u",
		":version": "rv-hetd_xkiv_39q6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casa de Cultura",
		"indicador_refugi": "080018|CASA_DE_CULTURA",
		"municipi": "Abrera",
		"codi_municipi": "080018",
		"latitud": "41.521503",
		"longitud": "1.901389",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C/ Federico García Lorca, núm. 17",
		"tipologia": "Biblioteca",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-15T12:12:00.000"
	},
	{
		":id": "row-aiua.j38w.cuxu",
		":version": "rv-yj5n~5mhi.vy4f",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal d'Avis",
		"indicador_refugi": "080018|CASAL_DAVIS",
		"municipi": "Abrera",
		"codi_municipi": "080018",
		"latitud": "41.517303",
		"longitud": "1.900264",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C/ Rosers, núm. 11",
		"tipologia": "Casal de Gent Gran",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-15T12:14:00.000"
	},
	{
		":id": "row-pxwm.f3ng.rvws",
		":version": "rv-9b3b-7vnw-tt6c",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Residència Canigó",
		"indicador_refugi": "080018|RESIDENCIA_CANIGO",
		"municipi": "Abrera",
		"codi_municipi": "080018",
		"latitud": "41.521033",
		"longitud": "1.905128",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C/ Menorca, núm. 16",
		"tipologia": "Casal de Gent Gran",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-15T12:16:00.000"
	},
	{
		":id": "row-nvjk~ccgh-85ae",
		":version": "rv-z2hn.wjer_xewq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Amèlia Claverol",
		"indicador_refugi": "250024|BIBLIOTECA_AMELIA_CLAVEROL",
		"municipi": "Àger",
		"codi_municipi": "250024",
		"latitud": "41.99888810552947",
		"longitud": "0.7632239186358284",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C/Sant Martí nº9 d'Àger",
		"informacio_web": "https://www.ager.cat/el-municipi/biblioteca-i-punt-tic",
		"tipologia": "Biblioteca",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-09T12:38:00.000"
	},
	{
		":id": "row-h34k_6342.fmqm",
		":version": "rv-3yjn~v7yg-g8wf",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Ajuntament",
		"indicador_refugi": "250024|AJUNTAMENT",
		"municipi": "Àger",
		"codi_municipi": "250024",
		"latitud": "41.99917314744526",
		"longitud": "0.7636383199423508",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça Major 1",
		"informacio_web": "www.ager.cat",
		"tipologia": "Ajuntament / Equipament Administratiu",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-09T12:39:00.000"
	},
	{
		":id": "row-nchv~fmic_cimh",
		":version": "rv-sxy3.mrc8-eg9h",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina",
		"indicador_refugi": "250024|PISCINA",
		"municipi": "Àger",
		"codi_municipi": "250024",
		"latitud": "42.003047242017686",
		"longitud": "0.7656257257316074",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C/del Cos s/n",
		"informacio_web": "www.ager.cat",
		"tipologia": "Piscines descobertes",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-09T12:43:00.000"
	},
	{
		":id": "row-hqx8~7245_cxyu",
		":version": "rv-scpi-42xm~q7y9",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casa del Montsec",
		"indicador_refugi": "250024|CASA_DEL_MONTSEC",
		"municipi": "Àger",
		"codi_municipi": "250024",
		"latitud": "42.00242270075832",
		"longitud": "0.7587987192880282",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "No",
		"adreca": "C/Calvari sn",
		"informacio_web": "www.turismeager.cat",
		"tipologia": "Sala Polivalent",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-09T12:46:00.000"
	},
	{
		":id": "row-jjjt-ci3t~3rt5",
		":version": "rv-agjz.fqa9~sv5j",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "ESPAI CÍVIC D'AGRAMUNT",
		"indicador_refugi": "250030|ESPAI_CIVIC_DAGRAMUNT",
		"municipi": "Agramunt",
		"codi_municipi": "250030",
		"latitud": "41.781815",
		"longitud": "1.0989",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. ENSENYAMENT, 17",
		"informacio_web": "agramunt.cat   (dilluns 15:00 a 20:00 - dimarts, dimecres, dijous i divendres 09:00 a 12:00h i de 15:00 a 20:00h)",
		"tipologia": "Centre Cívic",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-22T14:55:00.000"
	},
	{
		":id": "row-x6iu~gte3~zqrh",
		":version": "rv-7qc2-sxse-tfga",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "BIBLIOTECA MUNICIPAL GUILLEM VILADOT",
		"indicador_refugi": "250030|BIBLIOTECA_MUNICIPAL_GUILLEM_VILADOT",
		"municipi": "Agramunt",
		"codi_municipi": "250030",
		"latitud": "41.785954",
		"longitud": "1.099161",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "PL. MERCADAL, 7",
		"informacio_web": "agramunt.cat (HORARI HIVERN Matins: dimecres, divendres i dissabte de 9 a 13h Tardes: de dilluns a divendres de 16.00 a 20.00h HORARI ESTIU (del 15 de juny al 15 de setembre) Matins: de dilluns a divendres de 9 a 13h Tardes: dimarts i dijous de 17.00 a 20.00h)",
		"tipologia": "Biblioteca",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-22T14:59:00.000"
	},
	{
		":id": "row-vuex.euu6_87v8",
		":version": "rv-raax~92bf.cb2r",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal d'Aiguafreda",
		"indicador_refugi": "080142|PISCINA_MUNICIPAL_D_AIGUAFREDA",
		"municipi": "Aiguafreda",
		"codi_municipi": "080142",
		"latitud": "41.7704127",
		"longitud": "2.25046554",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Nostra Senyora de Núria, s/n",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-zet2.w67h.q4jc",
		":version": "rv-z2jp~rtg7~vtgv",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "430017|PISCINA_MUNICIPAL",
		"municipi": "Aiguamúrcia",
		"codi_municipi": "430017",
		"latitud": "41.34122395",
		"longitud": "1.36192448",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Plana del Moli",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-7r6j~95wb~edcw",
		":version": "rv-7q8s~2ci4~q3pp",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Local Cultural \"Ca la Neus\"",
		"indicador_refugi": "170025|LOCAL_CULTURAL_\"CA_LA_NEUS\"",
		"municipi": "Aiguaviva",
		"codi_municipi": "170025",
		"latitud": "41.93824339853728",
		"longitud": "2.7619074175520324",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça de l'u d'octubre núm. 2",
		"informacio_web": "horari d'obertura de 10h a 14h",
		"tipologia": "Equipament Cultural (teatre, auditori, museu)",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-09T13:49:00.000"
	},
	{
		":id": "row-pd7t.rz8v.zzfu",
		":version": "rv-hnms.87hn-phzc",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Poliesportiu",
		"indicador_refugi": "250387|POLIESPORTIU",
		"municipi": "Aitona",
		"codi_municipi": "250387",
		"latitud": "41.49146158",
		"longitud": "0.45956051",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Joan XXIII, s/n",
		"tipologia": "Poliesportiu",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-d3dg.v24p.ur2v",
		":version": "rv-weuv_6amc~uj3q",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Llar de jubilats Sant Josep",
		"indicador_refugi": "250083|LLAR_DE_JUBILATS_SANT_JOSEP",
		"municipi": "Albesa",
		"codi_municipi": "250083",
		"latitud": "41.751902",
		"longitud": "0.6572",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C/ La creu 13-15",
		"tipologia": "Casal de Gent Gran",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-01T10:02:00.000"
	},
	{
		":id": "row-nqaj-v3ub_zddm",
		":version": "rv-qa7f.6r2p.sp9h",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Sala polivalent",
		"indicador_refugi": "170046|SALA_POLIVALENT",
		"municipi": "Albons",
		"codi_municipi": "170046",
		"latitud": "42.10232719",
		"longitud": "3.08330863",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de Tor, 1",
		"tipologia": "Sala polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-hjba_6qhm_v3jd",
		":version": "rv-n96z.5zj2-3bkq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Sala de ball",
		"indicador_refugi": "170046|SALA_DE_BALL",
		"municipi": "Albons",
		"codi_municipi": "170046",
		"latitud": "42.1030954",
		"longitud": "3.08599195",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. dels donants, s/n",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-be77~q4bz_q5ww",
		":version": "rv-ivmr~heyi~mqzw",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Alcanar",
		"indicador_refugi": "430043|CASAL_CIVIC_I_COMUNITARI_ALCANAR",
		"municipi": "Alcanar",
		"codi_municipi": "430043",
		"latitud": "40.5403296",
		"longitud": "0.4605183",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. de Lluís Companys, s/n",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-v6ny~6t2n~h48k",
		":version": "rv-qjzv_dbxp~9p69",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casa de la Vila",
		"indicador_refugi": "250100|CASA_DE_LA_VILA",
		"municipi": "Alcanó",
		"codi_municipi": "250100",
		"latitud": "41.48047396",
		"longitud": "0.61737839",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Major, 13",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-efct_vr4i-sw4x",
		":version": "rv-wd5n~gg46-4wk8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscines municipals",
		"indicador_refugi": "250100|PISCINES_MUNICIPALS",
		"municipi": "Alcanó",
		"codi_municipi": "250100",
		"latitud": "41.48065251",
		"longitud": "0.61889805",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Zona esportiva",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-rkt6~ywbx_uaq4",
		":version": "rv-gx4f.sxr2.riss",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de joves de L'Aldea",
		"indicador_refugi": "439044|CASAL_DE_JOVES_DE_L_ALDEA",
		"municipi": "Aldea, l'",
		"codi_municipi": "439044",
		"latitud": "40.74497457",
		"longitud": "0.62132173",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. Francesc Robert Graupera, s/n",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-vi5d_i2cr_gnrd",
		":version": "rv-ts4p~he2c_49xm",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscines municipals",
		"indicador_refugi": "439044|PISCINES_MUNICIPALS",
		"municipi": "Aldea, l'",
		"codi_municipi": "439044",
		"latitud": "40.744418",
		"longitud": "0.621424",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "43896",
		"informacio_web": "www.laldea.cat",
		"tipologia": "Piscines descobertes",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-05-29T13:59:00.000"
	},
	{
		":id": "row-x4fz.8fu4~9v2i",
		":version": "rv-2y64.axks.7qii",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça dels Segadors",
		"indicador_refugi": "439044|PLACA_DELS_SEGADORS",
		"municipi": "Aldea, l'",
		"codi_municipi": "439044",
		"latitud": "40.741838",
		"longitud": "0.613479",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "43896",
		"informacio_web": "www.laldea.cat",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-05-29T14:03:00.000"
	},
	{
		":id": "row-ytwg~3awp-q7ib",
		":version": "rv-czer.eis3~iawb",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "La Pèrgola",
		"indicador_refugi": "439044|LA_PERGOLA",
		"municipi": "Aldea, l'",
		"codi_municipi": "439044",
		"latitud": "40.748934",
		"longitud": "0.627165",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "43896",
		"informacio_web": "www.laldea.cat",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-05-29T14:05:00.000"
	},
	{
		":id": "row-jdgx_pwgh_z3e4",
		":version": "rv-gu4p_vhpc~wj7m",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça dels Països Catalans",
		"indicador_refugi": "439044|PLACA_DELS_PAISOS_CATALANS",
		"municipi": "Aldea, l'",
		"codi_municipi": "439044",
		"latitud": "40.747232",
		"longitud": "0.622392",
		"accessibilitat": "Sí",
		"aigua": "No",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "43896",
		"informacio_web": "www.laldea.cat",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-05-29T14:07:00.000"
	},
	{
		":id": "row-eatq_4fya_kub7",
		":version": "rv-s5uk.xzgn-hkkn",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal d'Aldover",
		"indicador_refugi": "430069|PISCINA_MUNICIPAL_D_ALDOVER",
		"municipi": "Aldover",
		"codi_municipi": "430069",
		"latitud": "40.88051256",
		"longitud": "0.50427274",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "No",
		"adreca": "Part. \"El Riu\"",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-uzrf-bkgj~4zhe",
		":version": "rv-knfj.e8yd.bmx3",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bar del Casal municipal Sant Jordi d'Aldover",
		"indicador_refugi": "430069|BAR_DEL_CASAL_MUNICIPAL_SANT_JORDI_D_ALDOVER",
		"municipi": "Aldover",
		"codi_municipi": "430069",
		"latitud": "40.88103883",
		"longitud": "0.49932268",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Av. Catalunya, s/n",
		"tipologia": "Sala polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-si4b~8imi-7jn8",
		":version": "rv-rcrh~tbxu_emfu",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Ferrer i Guàrdia",
		"indicador_refugi": "080039|BIBLIOTECA_FERRER_I_GUARDIA",
		"municipi": "Alella",
		"codi_municipi": "080039",
		"latitud": "41.49332515",
		"longitud": "2.2948243",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Hort de la Rectoria, s/n",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-rpf4~snr5_hn7g",
		":version": "rv-e8up~yyqn~jwvn",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Antigues Escoles Fabra",
		"indicador_refugi": "080039|ANTIGUES_ESCOLES_FABRA",
		"municipi": "Alella",
		"codi_municipi": "080039",
		"latitud": "41.49296351",
		"longitud": "2.29552972",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. Ferran Fabra, 1",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-sw4h~2x4c-vd5s",
		":version": "rv-upug-zxzi~zr84",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Can Lleonart",
		"indicador_refugi": "080039|CAN_LLEONART",
		"municipi": "Alella",
		"codi_municipi": "080039",
		"latitud": "41.49275859",
		"longitud": "2.29480553",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. dels Germans Lleonart, 1",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-8kci.x2ap~dk86",
		":version": "rv-paqx_7xdy.cs6q",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Serveis a les Persones",
		"indicador_refugi": "080039|SERVEIS_A_LES_PERSONES",
		"municipi": "Alella",
		"codi_municipi": "080039",
		"latitud": "41.49783843",
		"longitud": "2.29292591",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Torrent de Vallbona, 75",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-m7fe~pbt7~p399",
		":version": "rv-5zyv.pmrb-69x8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscines municipals",
		"indicador_refugi": "250143|PISCINES_MUNICIPALS",
		"municipi": "Alfés",
		"codi_municipi": "250143",
		"latitud": "41.52171764",
		"longitud": "0.61634633",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Camí de Sunyer, s/n",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-528n~4ai5_fncw",
		":version": "rv-rcne.ica8~gevg",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina pública municipal d'Alforja",
		"indicador_refugi": "430094|PISCINA_PUBLICA_MUNICIPAL_D_ALFORJA",
		"municipi": "Alforja",
		"codi_municipi": "430094",
		"latitud": "41.21177223",
		"longitud": "0.98063319",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "No",
		"adreca": "Camí de l'Aleixar, s/n, 43365 Alforja",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-586p-2f6n.gxef",
		":version": "rv-u3tu~m7br~772m",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Local social",
		"indicador_refugi": "430108|LOCAL_SOCIAL",
		"municipi": "Alió",
		"codi_municipi": "430108",
		"latitud": "41.29373433",
		"longitud": "1.30561406",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Germà Saperas, 15",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-gtev_munb-mr88",
		":version": "rv-ysqd-i6zj-p86n",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Màgic d'Almenar",
		"indicador_refugi": "250215|PARC_MAGIC_D_ALMENAR",
		"municipi": "Almenar",
		"codi_municipi": "250215",
		"latitud": "41.79293188",
		"longitud": "0.57391037",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Pont de l'Almúnia, 1",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-mr8k_v9u2-3puq",
		":version": "rv-ifbv-kjzf_mnrz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscines municipals d'Almenar",
		"indicador_refugi": "250215|PISCINES_MUNICIPALS_D_ALMENAR",
		"municipi": "Almenar",
		"codi_municipi": "250215",
		"latitud": "41.80257898",
		"longitud": "0.57469992",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. Pirineus",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-9ytx_uecg-cb5y",
		":version": "rv-tt32-g635.d597",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca municipal Ramon Berenguer IV",
		"indicador_refugi": "250215|BIBLIOTECA_MUNICIPAL_RAMON_BERENGUER_IV",
		"municipi": "Almenar",
		"codi_municipi": "250215",
		"latitud": "41.79701906",
		"longitud": "0.56837529",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Espadós, 2",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-mrzw.6zpx-pmnh",
		":version": "rv-9bmi_amg3_ai4k",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Recinte de les piscines municipals",
		"indicador_refugi": "250220|RECINTE_DE_LES_PISCINES_MUNICIPALS",
		"municipi": "Alòs de Balaguer",
		"codi_municipi": "250220",
		"latitud": "41.91245568",
		"longitud": "0.96162867",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Camí del Vall",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-n5c7.ggvt.mev9",
		":version": "rv-hrat_7pus.8qbr",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Consultori",
		"indicador_refugi": "250220|CONSULTORI",
		"municipi": "Alòs de Balaguer",
		"codi_municipi": "250220",
		"latitud": "41.91210044",
		"longitud": "0.9609584",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Major",
		"tipologia": "Sala polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-iq2j-47tv.2mpi",
		":version": "rv-787m~u5sp.mx7h",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jardins de la Torre",
		"indicador_refugi": "080044|JARDINS_DE_LA_TORRE",
		"municipi": "Alpens",
		"codi_municipi": "080044",
		"latitud": "42.11959363",
		"longitud": "2.10278121",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Ctra. Berga, 10-12",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-ie9x~67c4~ntyw",
		":version": "rv-hrr5_giiw_skwz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal municipal",
		"indicador_refugi": "250236|CASAL_MUNICIPAL",
		"municipi": "Alpicat",
		"codi_municipi": "250236",
		"latitud": "41.66625571",
		"longitud": "0.55776138",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Farraginals, 1",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-kjz2-arzc_g9t9",
		":version": "rv-is7a-2xub_ew3f",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca municipal",
		"indicador_refugi": "250236|BIBLIOTECA_MUNICIPAL",
		"municipi": "Alpicat",
		"codi_municipi": "250236",
		"latitud": "41.66597087098389",
		"longitud": "0.5571289606469516",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Països Catalans 1",
		"informacio_web": "https://participa.alpicat.cat/index_web.php?ap=czo3OiJwb3J0YWRhIjs=&idw=czoyOiIyNSI7&idi=czozOiJjYXQiOw==",
		"tipologia": "Biblioteca",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-01T11:53:00.000"
	},
	{
		":id": "row-yvaz.676q~cziu",
		":version": "rv-3xua~rnpn_ttbt",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "PISCINA MUNICIPAL",
		"indicador_refugi": "430120|PISCINA_MUNICIPAL",
		"municipi": "Altafulla",
		"codi_municipi": "430120",
		"latitud": "41.139255",
		"longitud": "1.373532",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "CARRER ALCALDE PIJUAN S/N",
		"informacio_web": "www.altafulla.cat",
		"tipologia": "Piscines descobertes",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-02T11:26:00.000"
	},
	{
		":id": "row-nsrd_m4jw.sde6",
		":version": "rv-8zaj.cdfs~xwur",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "BIBLIOTECA MUNICIPAL",
		"indicador_refugi": "430120|BIBLIOTECA_MUNICIPAL",
		"municipi": "Altafulla",
		"codi_municipi": "430120",
		"latitud": "41.1374534158927",
		"longitud": "1.3755799820910846",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "CARRER DEL VINYET, 1",
		"informacio_web": "www.altafulla.cat",
		"tipologia": "Biblioteca",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-02T11:31:00.000"
	},
	{
		":id": "row-w6ue.hde5~ttvu",
		":version": "rv-69c2~mgbh~kz6i",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Ermita de Sant Antoni",
		"indicador_refugi": "430120|ERMITA_DE_SANT_ANTONI",
		"municipi": "Altafulla",
		"codi_municipi": "430120",
		"latitud": "41.14801642375902",
		"longitud": "1.3726623287180746",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Camí de l'Ermita 35",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-02T11:35:00.000"
	},
	{
		":id": "row-3vrs~323u~3gxc",
		":version": "rv-x48y-dk6p-zy33",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Llar de jubilats Sant Miquel",
		"indicador_refugi": "170078|LLAR_DE_JUBILATS_SANT_MIQUEL",
		"municipi": "Amer",
		"codi_municipi": "170078",
		"latitud": "42.00829506986679",
		"longitud": "2.6025278811190224",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça Sant Miquel, 18",
		"informacio_web": "De dilluns a diumenge de 10 a 19 h",
		"tipologia": "Casal de Gent Gran",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-04T12:51:00.000"
	},
	{
		":id": "row-rmts_tr4a.dcfw",
		":version": "rv-2q8y~5hfs-pv7p",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Ca l'Arenys",
		"indicador_refugi": "080057|CA_L_ARENYS",
		"municipi": "Ametlla del Vallès, l'",
		"codi_municipi": "080057",
		"latitud": "41.66951086",
		"longitud": "2.2671855",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Ca l'Arenys, s/n",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-cunp-fc93.v7cf",
		":version": "rv-gijc~nntp_qk5q",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina de can Camp",
		"indicador_refugi": "080057|PISCINA_DE_CAN_CAMP",
		"municipi": "Ametlla del Vallès, l'",
		"codi_municipi": "080057",
		"latitud": "41.66166101",
		"longitud": "2.25674552",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. La Vinya, s/n",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-cgix_7mqg.w67m",
		":version": "rv-zgh5_gn74_h32w",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca municipal Josep Badia i Moret",
		"indicador_refugi": "080057|BIBLIOTECA_MUNICIPAL_JOSEP_BADIA_I_MORET",
		"municipi": "Ametlla del Vallès, l'",
		"codi_municipi": "080057",
		"latitud": "41.66948397",
		"longitud": "2.26258755",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Torregassa, 35-37",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-68iv_z42c-ui37",
		":version": "rv-2wsb_q8ca-rde4",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Ajuntament de l'Ametlla del Vallès",
		"indicador_refugi": "080057|AJUNTAMENT_DE_L_AMETLLA_DEL_VALLES",
		"municipi": "Ametlla del Vallès, l'",
		"codi_municipi": "080057",
		"latitud": "41.66955886",
		"longitud": "2.26142753",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Ajuntament, 1",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-9gpz~jsbj_mwfg",
		":version": "rv-vc8m~na58-6j36",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "439060|PISCINA_MUNICIPAL",
		"municipi": "Ampolla, l'",
		"codi_municipi": "439060",
		"latitud": "40.81370609",
		"longitud": "0.71013736",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "No",
		"adreca": "Av. Generalitat, s/n (zona d'equipaments)",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-wwvk-nra2~rh9v",
		":version": "rv-jd2p~jq59.msh7",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Valletes",
		"indicador_refugi": "430141|PARC_VALLETES",
		"municipi": "Amposta",
		"codi_municipi": "430141",
		"latitud": "40.704505",
		"longitud": "0.574594",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Brasil, 103, 43870 Amposta, Tarragona",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-25T08:30:00.000"
	},
	{
		":id": "row-tpir-i4wd.67kh",
		":version": "rv-n6hf-uijx_r7br",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc dels Xiribecs",
		"indicador_refugi": "430141|PARC_DELS_XIRIBECS",
		"municipi": "Amposta",
		"codi_municipi": "430141",
		"latitud": "40.705188",
		"longitud": "0.582645",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Avinguda Josep Tarradellas, 36-94, 43870 Amposta, Tarragona",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-25T08:32:00.000"
	},
	{
		":id": "row-f8ar-9nat~vg6y",
		":version": "rv-pur8.yb4t.quhv",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Municipal",
		"indicador_refugi": "430141|PARC_MUNICIPAL",
		"municipi": "Amposta",
		"codi_municipi": "430141",
		"latitud": "40.709002",
		"longitud": "0.577591",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "43870 Amposta, Tarragona",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-25T08:37:00.000"
	},
	{
		":id": "row-d2n2.8kxs_tvk6",
		":version": "rv-cy4i_xat3-6vhn",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc dels Sequers de Carvallo",
		"indicador_refugi": "430141|PARC_DELS_SEQUERS_DE_CARVALLO",
		"municipi": "Amposta",
		"codi_municipi": "430141",
		"latitud": "40.713012",
		"longitud": "0.577245",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Dos de Maig, 2, 43870 Amposta, Tarragona",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-25T08:39:00.000"
	},
	{
		":id": "row-zbqz-etb9.qrpe",
		":version": "rv-iccq-ehg4.guy9",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de l'Agustinet",
		"indicador_refugi": "430141|PARC_DE_LAGUSTINET",
		"municipi": "Amposta",
		"codi_municipi": "430141",
		"latitud": "40.713012",
		"longitud": "0.577245",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Madrid, 38, 43870 Amposta, Tarragona",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-25T08:41:00.000"
	},
	{
		":id": "row-ifv9.8a3d_dxhz",
		":version": "rv-wsqd~5szc.kdh7",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Pista poliesportiva de Poble Nou del Delta",
		"indicador_refugi": "430141|PISTA_POLIESPORTIVA_DE_POBLE_NOU_DEL_DELTA",
		"municipi": "Amposta",
		"codi_municipi": "430141",
		"latitud": "40.646066",
		"longitud": "0.688724",
		"accessibilitat": "Sí",
		"aigua": "No",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Ronda dels Pins, 0, 43549 Poble Nou, Tarragona",
		"tipologia": "Pavelló Esportiu",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-25T08:45:00.000"
	},
	{
		":id": "row-pyg5_kfw3.ncmp",
		":version": "rv-k4kc-93c6_mnzq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc d'Eucaliptus",
		"indicador_refugi": "430141|PARC_DEUCALIPTUS",
		"municipi": "Amposta",
		"codi_municipi": "430141",
		"latitud": "40.660572",
		"longitud": "0.785997",
		"accessibilitat": "Sí",
		"aigua": "No",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Eucaliptus, 115, 43870 Eucaliptus, Tarragona",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-25T08:48:00.000"
	},
	{
		":id": "row-ewar_f82p-scm7",
		":version": "rv-pvjt-77ti-ysnh",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal d'Amposta",
		"indicador_refugi": "430141|PISCINA_MUNICIPAL_DAMPOSTA",
		"municipi": "Amposta",
		"codi_municipi": "430141",
		"latitud": "40.706968",
		"longitud": "0.582407",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer de França, 61, 73, 43870 Amposta, Tarragona",
		"informacio_web": "Dilluns a Divendres: 7-22h\tDissabtes: 9-14 h i 16-20 h\tDiumenges: 10-14 h",
		"tipologia": "Piscina Coberta",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-25T08:50:00.000"
	},
	{
		":id": "row-8br4~e2ta.btk6",
		":version": "rv-pt8h-uyvw.24zr",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal de Poble Nou del Delta",
		"indicador_refugi": "430141|PISCINA_MUNICIPAL_DE_POBLE_NOU_DEL_DELTA",
		"municipi": "Amposta",
		"codi_municipi": "430141",
		"latitud": "40.64668",
		"longitud": "0.688619",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Ronda dels Pins, 27, 43549 Poble Nou, Tarragona",
		"tipologia": "Piscines descobertes",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-25T08:52:00.000"
	},
	{
		":id": "row-yrai.qqeu-kzqz",
		":version": "rv-f5fc_phxg~8xx9",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Passeig del Canal Marítim",
		"indicador_refugi": "430141|PASSEIG_DEL_CANAL_MARITIM",
		"municipi": "Amposta",
		"codi_municipi": "430141",
		"latitud": "40.70704",
		"longitud": "0.585309",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Passeig del Canal Marítim, 24-30, 43870 Amposta, Tarragona",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-25T08:56:00.000"
	},
	{
		":id": "row-xedn_r65i-hz5n",
		":version": "rv-tp6z~fieb~rzfp",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jardí del Bou",
		"indicador_refugi": "430141|JARDI_DEL_BOU",
		"municipi": "Amposta",
		"codi_municipi": "430141",
		"latitud": "40.718159",
		"longitud": "0.572522",
		"accessibilitat": "Sí",
		"aigua": "No",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "43870 Amposta, Tarragona",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-25T08:58:00.000"
	},
	{
		":id": "row-9ayh.4mer~fgui",
		":version": "rv-qrcy~cejs_z46g",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Passeig del Riu",
		"indicador_refugi": "430141|PASSEIG_DEL_RIU",
		"municipi": "Amposta",
		"codi_municipi": "430141",
		"latitud": "40.709014",
		"longitud": "0.588937",
		"accessibilitat": "Sí",
		"aigua": "No",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Passeig del Riu, 43870 Amposta, Tarragona",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-25T09:00:00.000"
	},
	{
		":id": "row-usci.fktm.9y9s",
		":version": "rv-svpj_tqmr~uvmt",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Comarcal Sebastià Juan Arbó",
		"indicador_refugi": "430141|BIBLIOTECA_COMARCAL_SEBASTIA_JUAN_ARBO",
		"municipi": "Amposta",
		"codi_municipi": "430141",
		"latitud": "40.714333",
		"longitud": "0.580233",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça del Castell, 13-15, 43870 Amposta, Tarragona",
		"informacio_web": "Juliol i agost: de dilluns a dimarts de 9 a 14h i dimarts de 16 a 19h. Tanca la setmana de festes",
		"tipologia": "Biblioteca",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-25T09:02:00.000"
	},
	{
		":id": "row-ahs9-ra7u~kr2n",
		":version": "rv-y6fx_qgxf_8mm9",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Museu de les Terres de l'Ebre",
		"indicador_refugi": "430141|MUSEU_DE_LES_TERRES_DE_LEBRE",
		"municipi": "Amposta",
		"codi_municipi": "430141",
		"latitud": "40.70899",
		"longitud": "0.577009",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Gran Capità, 34, 43870 Amposta, Tarragona",
		"informacio_web": "\"De dimarts a dissabte: d’11 a 14 h i de 17.30 a 20.00 h Diumenges i festius: d’11.30 a 14 h\"",
		"tipologia": "Equipament Cultural (teatre, auditori, museu)",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-25T09:03:00.000"
	},
	{
		":id": "row-nhus.wtcy~g4g5",
		":version": "rv-g9pq_2z4c.83j2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic Ruiz Salgado",
		"indicador_refugi": "430141|CASAL_CIVIC_RUIZ_SALGADO",
		"municipi": "Amposta",
		"codi_municipi": "430141",
		"latitud": "40.705877",
		"longitud": "0.572036",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Sebastià Juan Arbó, 159, 43870 Amposta, Tarragona",
		"informacio_web": "Juliol: de dilluns a diumenge, de 9 h a 19 h",
		"tipologia": "Centre Cívic",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-25T09:05:00.000"
	},
	{
		":id": "row-mej7~s4f3~3bup",
		":version": "rv-kpae~f7rb_mndb",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Oficina de cultura i festes",
		"indicador_refugi": "430141|OFICINA_DE_CULTURA_I_FESTES",
		"municipi": "Amposta",
		"codi_municipi": "430141",
		"latitud": "40.712344",
		"longitud": "0.578765",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Palau i Quer, 6, 43870 Amposta, Tarragona",
		"informacio_web": "De dimarts a divendres de 9 a 13h",
		"tipologia": "Ajuntament / Equipament Administratiu",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-25T09:08:00.000"
	},
	{
		":id": "row-cu6u~gx2n~vewz",
		":version": "rv-xeve~mvy7.ah5p",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Hospital Comarcal d'Amposta",
		"indicador_refugi": "430141|HOSPITAL_COMARCAL_DAMPOSTA",
		"municipi": "Amposta",
		"codi_municipi": "430141",
		"latitud": "40.708901",
		"longitud": "0.578089",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Jacint Verdaguer, 11, 13, 43870 Amposta, Tarragona",
		"informacio_web": "De dilluns a divendres, de 8 a 20 h",
		"tipologia": "Equipament Sanitari",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-25T09:09:00.000"
	},
	{
		":id": "row-2bv8_vrgg-265d",
		":version": "rv-2ny5.tyqm.6igc",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Oficina de Turisme",
		"indicador_refugi": "430141|OFICINA_DE_TURISME",
		"municipi": "Amposta",
		"codi_municipi": "430141",
		"latitud": "40.710394",
		"longitud": "0.585619",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Avinguda de Sant Jaume, 42-52, 43870 Amposta, Tarragona",
		"informacio_web": "De dilluns a dissabte, de 9 a 15 h. Diumenge de 9,30 a 13,30",
		"tipologia": "Ajuntament / Equipament Administratiu",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-25T09:12:00.000"
	},
	{
		":id": "row-rysc_trwp-anrp",
		":version": "rv-yhem-bhfw~8paj",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Ajuntament de Poble Nou del Delta",
		"indicador_refugi": "430141|AJUNTAMENT_DE_POBLE_NOU_DEL_DELTA",
		"municipi": "Amposta",
		"codi_municipi": "430141",
		"latitud": "40.645286",
		"longitud": "0.686696",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça del Jardí, 6, 43549 Poble Nou, Tarragona",
		"informacio_web": "\"De dimecres a diumenge De 9.00 h a 15.00 h Divendres i dissabte, de 16:30 h a 19 h\"",
		"tipologia": "Ajuntament / Equipament Administratiu",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-25T09:14:00.000"
	},
	{
		":id": "row-fbmc_4t5w-cgn8",
		":version": "rv-zbq9.crvx.qsbn",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Mercat municipal",
		"indicador_refugi": "430141|MERCAT_MUNICIPAL",
		"municipi": "Amposta",
		"codi_municipi": "430141",
		"latitud": "40.71217",
		"longitud": "0.57868",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Avinguda Alcalde Palau, 68, 43870 Amposta, Tarragona",
		"informacio_web": "De dilluns a dissabte de 8h a 14h",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-25T09:15:00.000"
	},
	{
		":id": "row-8nj5~jkf4-qb4b",
		":version": "rv-c4wu~cdhh-hqy9",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Ajuntament d'Amposta",
		"indicador_refugi": "430141|AJUNTAMENT_DAMPOSTA",
		"municipi": "Amposta",
		"codi_municipi": "430141",
		"latitud": "40.713463",
		"longitud": "0.580916",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "4, Plaça de l'Ajuntament, 3, 43870 Amposta, Tarragona",
		"informacio_web": "De dilluns a divendres, de 9 a 14h",
		"tipologia": "Ajuntament / Equipament Administratiu",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-25T09:17:00.000"
	},
	{
		":id": "row-giv2~xqyc.ath4",
		":version": "rv-9e9a~s85h_g46f",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca municipal",
		"indicador_refugi": "170084|BIBLIOTECA_MUNICIPAL",
		"municipi": "Anglès",
		"codi_municipi": "170084",
		"latitud": "41.955776",
		"longitud": "2.637883",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Cr. de la Industria, número 6, 17160 Anglès",
		"informacio_web": "https://www.bibgirona.cat/biblioteca/angles",
		"tipologia": "Biblioteca",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-23T13:41:00.000"
	},
	{
		":id": "row-rdw8_ean8-bpyh",
		":version": "rv-t9k3.xgb8.rx26",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jardins de Can Cendra",
		"indicador_refugi": "170084|JARDINS_DE_CAN_CENDRA",
		"municipi": "Anglès",
		"codi_municipi": "170084",
		"latitud": "41.955698",
		"longitud": "2.639542",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Girona, número 19, 17160 Anglès",
		"informacio_web": "http://www.angles.cat",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-23T13:44:00.000"
	},
	{
		":id": "row-yh3j_fvga_v63g",
		":version": "rv-hhs4_5vdp~keza",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de la Font del Canyo",
		"indicador_refugi": "170084|PARC_DE_LA_FONT_DEL_CANYO",
		"municipi": "Anglès",
		"codi_municipi": "170084",
		"latitud": "41.951503",
		"longitud": "2.639398",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaza de Salvador Costa 5, 17160 Anglès, Gerona, España",
		"informacio_web": "http://www.angles.cat",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-23T13:53:00.000"
	},
	{
		":id": "row-9a7x~gbgc~ehb2",
		":version": "rv-jqd4-2y3r~y2gs",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Sala de ball",
		"indicador_refugi": "430154|SALA_DE_BALL",
		"municipi": "Arbolí",
		"codi_municipi": "430154",
		"latitud": "41.2422771",
		"longitud": "0.9468225",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "No",
		"adreca": "Av. la Vall, s/n",
		"tipologia": "Sala Polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-30T07:59:00.000"
	},
	{
		":id": "row-8qy8_qrzw_6uvy",
		":version": "rv-cd8q-qsh3~fui6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina d’Arbolí",
		"indicador_refugi": "430154|PISCINA_D_ARBOLI",
		"municipi": "Arbolí",
		"codi_municipi": "430154",
		"latitud": "41.2426434",
		"longitud": "0.9495395",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Pl. de la font, s/n",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-ac39-46im-9xhk",
		":version": "rv-a9h5_c69y~6idw",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Prat Rodó",
		"indicador_refugi": "170097|PRAT_RODO",
		"municipi": "Arbúcies",
		"codi_municipi": "170097",
		"latitud": "41.81679747",
		"longitud": "2.51240888",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pg. de la riera, s/n",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-5ceu.tjz8_m9zq",
		":version": "rv-fgjx_d8e5-8cy7",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal d'Arenys de Munt",
		"indicador_refugi": "080076|PISCINA_MUNICIPAL_D_ARENYS_DE_MUNT",
		"municipi": "Arenys de Munt",
		"codi_municipi": "080076",
		"latitud": "41.61649241",
		"longitud": "2.52943732",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Ctra. Lourdes, 25, 08358 Arenys de Munt, Barcelona",
		"tipologia": "Piscines descobertes",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-06-11T09:58:00.000"
	},
	{
		":id": "row-thsz_avjr_5wuh",
		":version": "rv-vdx7.45nw-i8fp",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Antònia Torrent i Martori",
		"indicador_refugi": "080076|BIBLIOTECA_ANTONIA_TORRENT_I_MARTORI",
		"municipi": "Arenys de Munt",
		"codi_municipi": "080076",
		"latitud": "41.610274790968404",
		"longitud": "2.5411695566947583",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Rial de Can Bellsolell, 5, 08358 Arenys de Munt, Barcelona",
		"tipologia": "Biblioteca",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-22T10:20:00.000"
	},
	{
		":id": "row-m39h-zgcc_3m5f",
		":version": "rv-b5es~5a57.67ev",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Cívic Can Mallol",
		"indicador_refugi": "080076|CENTRE_CIVIC_CAN_MALLOL",
		"municipi": "Arenys de Munt",
		"codi_municipi": "080076",
		"latitud": "41.60649475109133",
		"longitud": "2.5418073989153807",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Jacint Verdaguer, 08358 Arenys de Munt, Barcelona",
		"tipologia": "Centre Cívic",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-11T10:05:00.000"
	},
	{
		":id": "row-wg39~awr5_vyk8",
		":version": "rv-cj6p~tker~kmqv",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Esplai de Jubilats",
		"indicador_refugi": "080076|ESPLAI_DE_JUBILATS",
		"municipi": "Arenys de Munt",
		"codi_municipi": "080076",
		"latitud": "41.609372313460575",
		"longitud": "2.5403684288358175",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça de l'Església, 5, Baixos, 08358 Arenys de Munt, Barcelona",
		"tipologia": "Casal de Gent Gran",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-25T11:58:00.000"
	},
	{
		":id": "row-2nv3~wpn4.xyu9",
		":version": "rv-rgc5_4wph~scxg",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Mercat Municipal",
		"indicador_refugi": "080076|MERCAT_MUNICIPAL",
		"municipi": "Arenys de Munt",
		"codi_municipi": "080076",
		"latitud": "41.60878931720985",
		"longitud": "2.5405429584654766",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Rambla Sant Martí, 17, 08358 Arenys de Munt, Barcelona",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-25T12:05:00.000"
	},
	{
		":id": "row-ihz6-z7my~rmhp",
		":version": "rv-8m9j-vevf.d8fp",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Sala Municipal",
		"indicador_refugi": "080076|SALA_MUNICIPAL",
		"municipi": "Arenys de Munt",
		"codi_municipi": "080076",
		"latitud": "41.611479285965174",
		"longitud": "2.539548486456809",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Rambla Francesc Macià, 59, 08358 Arenys de Munt, Barcelona",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-25T12:10:00.000"
	},
	{
		":id": "row-bhg9.yj49~2q9f",
		":version": "rv-r43d~c26c-469x",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina pública municipal",
		"indicador_refugi": "430173|PISCINA_PUBLICA_MUNICIPAL",
		"municipi": "Argentera, l'",
		"codi_municipi": "430173",
		"latitud": "41.13834434",
		"longitud": "0.90800404",
		"accessibilitat": "No",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Primavera, s/n",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-2hvs_apiu-9unq",
		":version": "rv-dcvx_38mp~i7ae",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Ajuntamnet Argentona - oficines OAC",
		"indicador_refugi": "080095|AJUNTAMNET_ARGENTONA_OFICINES_OAC",
		"municipi": "Argentona",
		"codi_municipi": "080095",
		"latitud": "41.55558797",
		"longitud": "2.40026238",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Gran, 59",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-iyny-4bgj_j47q",
		":version": "rv-pz4g~s7y6-bzdz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de la gent gran",
		"indicador_refugi": "080095|CASAL_DE_LA_GENT_GRAN",
		"municipi": "Argentona",
		"codi_municipi": "080095",
		"latitud": "41.55468909",
		"longitud": "2.40242911",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Av. Puig i Cadafalch, 2-4",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-kbi7-7jw2_cigm",
		":version": "rv-bpi3-qzc3_pv7q",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Oficina d'atenció del Cros",
		"indicador_refugi": "080095|OFICINA_D_ATENCIO_DEL_CROS",
		"municipi": "Argentona",
		"codi_municipi": "080095",
		"latitud": "41.53304",
		"longitud": "2.41944",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Local 17, barri Sant Miquel del Cros",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-jtf7_udmj-ypkv",
		":version": "rv-sg3m-g44m-qd7k",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca d'Argentona - Joan Fontcuberta i Gel",
		"indicador_refugi": "080095|BIBLIOTECA_D_ARGENTONA_JOAN_FONTCUBERTA_I_GEL",
		"municipi": "Argentona",
		"codi_municipi": "080095",
		"latitud": "41.55450194",
		"longitud": "2.40209",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Gran, 3-5",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-kv8h-s78u.cbhn",
		":version": "rv-pcag_a3xc-vjue",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre civic de les Ginesteres",
		"indicador_refugi": "080095|CENTRE_CIVIC_DE_LES_GINESTERES",
		"municipi": "Argentona",
		"codi_municipi": "080095",
		"latitud": "41.57357688",
		"longitud": "2.38127979",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Ignasi Barraquer i Barraquer, 14, 8 (Urb. les Ginesteres)",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-gxix~kcfc-28z2",
		":version": "rv-2svx-kt9j-htzq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Museu del  Cantir",
		"indicador_refugi": "080095|MUSEU_DEL_CANTIR",
		"municipi": "Argentona",
		"codi_municipi": "080095",
		"latitud": "41.55419955",
		"longitud": "2.40039937",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "No",
		"adreca": "Pl. Esglesia, 9",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-hk8v.9myc~inf2",
		":version": "rv-km53.nqs2.qc3i",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscines municipals d'Artesa de Segre",
		"indicador_refugi": "250349|PISCINES_MUNICIPALS_D_ARTESA_DE_SEGRE",
		"municipi": "Artesa de Segre",
		"codi_municipi": "250349",
		"latitud": "41.89586851",
		"longitud": "1.0424715",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Camp de Futbol, 1, Artesa de Segre",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-nsxs~zu9e.j9sn",
		":version": "rv-xjtp-hxz5-dcrp",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Edifici cultural",
		"indicador_refugi": "250349|EDIFICI_CULTURAL",
		"municipi": "Artesa de Segre",
		"codi_municipi": "250349",
		"latitud": "41.89613372",
		"longitud": "1.04542603",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Av. de Maria Anzizu, 30, Artesa de Segre",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-dgpe-62wn.hf3i",
		":version": "rv-q2hq.p3rw.3a69",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "430192|PISCINA_MUNICIPAL",
		"municipi": "Ascó",
		"codi_municipi": "430192",
		"latitud": "41.18623048",
		"longitud": "0.56743697",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Margarita Sevil, s/n",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-8688_zaff-gque",
		":version": "rv-rjux_fe7r.mzgu",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Ajuntament",
		"indicador_refugi": "430192|AJUNTAMENT",
		"municipi": "Ascó",
		"codi_municipi": "430192",
		"latitud": "41.18101287",
		"longitud": "0.56702381",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Hospital, 2",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-pmxn-yek3_jv3n",
		":version": "rv-8278.cxqi-fhga",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Pavelló",
		"indicador_refugi": "430192|PAVELLO",
		"municipi": "Ascó",
		"codi_municipi": "430192",
		"latitud": "41.18565254",
		"longitud": "0.56852545",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Alcalde Tomàs Biarnés, s/n",
		"tipologia": "Poliesportiu",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-bs5w~9bmx~q8ew",
		":version": "rv-ugx3_8bjw-gsxs",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Local de joves",
		"indicador_refugi": "430192|LOCAL_DE_JOVES",
		"municipi": "Ascó",
		"codi_municipi": "430192",
		"latitud": "41.1802996",
		"longitud": "0.56823366",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de Baix, 1",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-ges2-m289-ms24",
		":version": "rv-w7f7_6j2h_5k2i",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca municipal",
		"indicador_refugi": "430192|BIBLIOTECA_MUNICIPAL",
		"municipi": "Ascó",
		"codi_municipi": "430192",
		"latitud": "41.18171617",
		"longitud": "0.568401",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Molins, 4",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-9whu.626a_tkvb",
		":version": "rv-p5gq.unh2_kgku",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "250365|PISCINA_MUNICIPAL",
		"municipi": "Aspa",
		"codi_municipi": "250365",
		"latitud": "41.49428837",
		"longitud": "0.67306876",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. portal de les Garrigues, 5",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-iiyb_kfi5.vcur",
		":version": "rv-sx4p-5jpd.cky6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "080116|PISCINA_MUNICIPAL",
		"municipi": "Avià",
		"codi_municipi": "080116",
		"latitud": "42.07602112",
		"longitud": "1.82145024",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de la Piscina, s/n, 08610 Avià",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-rtsc.fe7u.82qn",
		":version": "rv-jdh8~afmi.mn59",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscines municipals",
		"indicador_refugi": "080121|PISCINES_MUNICIPALS",
		"municipi": "Avinyó",
		"codi_municipi": "080121",
		"latitud": "41.86566353",
		"longitud": "1.97431709",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Industria",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-h587~pmgt~y38z",
		":version": "rv-mvp8~w592~jq76",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca",
		"indicador_refugi": "080121|BIBLIOTECA",
		"municipi": "Avinyó",
		"codi_municipi": "080121",
		"latitud": "41.86524067",
		"longitud": "1.97060421",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Passeig, 19",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-kacx-5xj6_vgyg",
		":version": "rv-542a.n4xf-iass",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Vicente Aleixandre",
		"indicador_refugi": "089045|BIBLIOTECA_VICENTE_ALEIXANDRE",
		"municipi": "Badia del Vallès",
		"codi_municipi": "089045",
		"latitud": "41.50649985200654",
		"longitud": "2.116923454495086",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Av. de la Mediterrània, S/N, 08214 Badia del Vallès, Barcelona",
		"informacio_web": "https://bibliotecabadia.blogspot.com/p/disponibilitat-espais.html",
		"tipologia": "Biblioteca",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-01T11:15:00.000"
	},
	{
		":id": "row-6bvp~sejk-ghxq",
		":version": "rv-u5kx.kc3j.7yiq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de les Illes Balears",
		"indicador_refugi": "089045|PARC_DE_LES_ILLES_BALEARS",
		"municipi": "Badia del Vallès",
		"codi_municipi": "089045",
		"latitud": "41.50612914744454",
		"longitud": "2.120303036154363",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Mallorca 2, 08214 Badia del Vallès",
		"informacio_web": "Obert tots els dies",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-01T12:15:00.000"
	},
	{
		":id": "row-cnyj_sa9j-85bp",
		":version": "rv-b76b-cz4d.qt2d",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Nou Casal d'avis",
		"indicador_refugi": "089045|NOU_CASAL_DAVIS",
		"municipi": "Badia del Vallès",
		"codi_municipi": "089045",
		"latitud": "41.50880918426751",
		"longitud": "2.1143261946591267",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Av. de Burgos cantonada C/ Bética s/n",
		"informacio_web": "https://www.badiadelvalles.cat/document.php?id=178",
		"tipologia": "Casal de Gent Gran",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-01T12:25:00.000"
	},
	{
		":id": "row-qnii~zuc7.gvdk",
		":version": "rv-yev7~hqk7.epjs",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscines exteriors de les instal·lacions Esportives Municipals",
		"indicador_refugi": "089045|PISCINES_EXTERIORS_DE_LES_INSTALLACIONS_ESPORTIVES_MUNICIPALS",
		"municipi": "Badia del Vallès",
		"codi_municipi": "089045",
		"latitud": "41.514714024972875",
		"longitud": "2.1139882246829416",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer del Tibidabo",
		"informacio_web": "https://www.badiadelvalles.cat/",
		"tipologia": "Piscines descobertes",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-01T12:37:00.000"
	},
	{
		":id": "row-hkfx_e6cz_5rbk",
		":version": "rv-e5ye-67up-7i3d",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Joan Oliver, zona sota pèrgola",
		"indicador_refugi": "089045|PARC_JOAN_OLIVER_ZONA_SOTA_PERGOLA",
		"municipi": "Badia del Vallès",
		"codi_municipi": "089045",
		"latitud": "41.507364522540605",
		"longitud": "2.115804972334199",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer de la Manxa 11",
		"informacio_web": "https://www.badiadelvalles.cat/",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-01T12:47:00.000"
	},
	{
		":id": "row-na77.y9sd_tzgq",
		":version": "rv-zrd9.6gna-trnp",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de Joves",
		"indicador_refugi": "080168|CASAL_DE_JOVES",
		"municipi": "Bagà",
		"codi_municipi": "080168",
		"latitud": "42.25255063",
		"longitud": "1.8597652",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Pere Tomic, 1 baixos",
		"tipologia": "Sala polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-zp2w~27dq~k2xf",
		":version": "rv-jxa4.irau~7spf",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Museu de la Sal",
		"indicador_refugi": "250390|MUSEU_DE_LA_SAL",
		"municipi": "Baix Pallars",
		"codi_municipi": "250390",
		"latitud": "42.3233",
		"longitud": "1.0642",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça Àngel esteve, 10, 25590 Gerri de la Sal",
		"informacio_web": "www.museudegerri.cat",
		"tipologia": "Equipament Cultural (teatre, auditori, museu)",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-22T13:26:00.000"
	},
	{
		":id": "row-g8kr~yhr7_b6ys",
		":version": "rv-qrav~z2h2-qn8g",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Claustre Convent Sant Domènec",
		"indicador_refugi": "250404|CLAUSTRE_CONVENT_SANT_DOMENEC",
		"municipi": "Balaguer",
		"codi_municipi": "250404",
		"latitud": "41.79399795",
		"longitud": "0.80909597",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. d'Urgell, 1",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-4ixj-vvum_rd45",
		":version": "rv-4538_q2uc-6v74",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Balaguer - Eixample",
		"indicador_refugi": "250404|CASAL_CIVIC_I_COMUNITARI_BALAGUER_EIXAMPLE",
		"municipi": "Balaguer",
		"codi_municipi": "250404",
		"latitud": "41.4088959",
		"longitud": "0.8678702",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. d'Urgell, 5",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-v5mm_r2qh_iray",
		":version": "rv-a4et~wf27-mah8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Margarida de Montferrat",
		"indicador_refugi": "250404|BIBLIOTECA_MARGARIDA_DE_MONTFERRAT",
		"municipi": "Balaguer",
		"codi_municipi": "250404",
		"latitud": "41.78838236",
		"longitud": "0.80556804",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Miracle, 23, 2n pis",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-4aqu_a28q-6566",
		":version": "rv-nc8q.b7yr.mbmp",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc del Reial",
		"indicador_refugi": "250404|PARC_DEL_REIAL",
		"municipi": "Balaguer",
		"codi_municipi": "250404",
		"latitud": "41.79686514",
		"longitud": "0.80001381",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Pla d'Almatà",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-7kbk~3dn3-xsx4",
		":version": "rv-wis8~f4fq-b386",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Museu de la Noguera",
		"indicador_refugi": "250404|MUSEU_DE_LA_NOGUERA",
		"municipi": "Balaguer",
		"codi_municipi": "250404",
		"latitud": "41.78885985",
		"longitud": "0.80488975",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. dels Comptes d'Urgell, 5",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-94ae_4bf2-tejn",
		":version": "rv-zcu2_xedu_ahwq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Església de Santa Maria de Balaguer",
		"indicador_refugi": "250404|ESGLESIA_DE_SANTA_MARIA_DE_BALAGUER",
		"municipi": "Balaguer",
		"codi_municipi": "250404",
		"latitud": "41.79189467",
		"longitud": "0.80428317",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Pl. Cecília Comenge, 1",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-cyhp_jt9t-238w",
		":version": "rv-zp48.vbya.ftj9",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal de Balaguer",
		"indicador_refugi": "250404|PISCINA_MUNICIPAL_DE_BALAGUER",
		"municipi": "Balaguer",
		"codi_municipi": "250404",
		"latitud": "41.78994361",
		"longitud": "0.8176104",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. d'Urgell, 96",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-jwcz.yp9q~qxkw",
		":version": "rv-zj9q_8j77.vtmt",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "La Bultra de les Franqueses",
		"indicador_refugi": "250404|LA_BULTRA_DE_LES_FRANQUESES",
		"municipi": "Balaguer",
		"codi_municipi": "250404",
		"latitud": "41.75629",
		"longitud": "0.79704",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Marge dret del riu Segre (entre Balaguer i el Monestir Cistercenc de les Franqueses)",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-eyn9.4ykw_pyp8",
		":version": "rv-xcsk-735z.buqm",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Balaguer - El Miracle",
		"indicador_refugi": "250404|CASAL_CIVIC_I_COMUNITARI_BALAGUER_EL_MIRACLE",
		"municipi": "Balaguer",
		"codi_municipi": "250404",
		"latitud": "41.7883262",
		"longitud": "0.803015",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. del Miracle, 23 (cant. Germà Peralba)",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-62mi-f465-693z",
		":version": "rv-uawv.f7m6-4f2b",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal d'avis",
		"indicador_refugi": "080174|CASAL_D_AVIS",
		"municipi": "Balenyà",
		"codi_municipi": "080174",
		"latitud": "41.81560499",
		"longitud": "2.23600851",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Bosch i Jover, 1",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-xpf8.kjhd.c7eg",
		":version": "rv-gdh2_xrdf-2chx",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Sala El Sindicat",
		"indicador_refugi": "080180|SALA_EL_SINDICAT",
		"municipi": "Balsareny",
		"codi_municipi": "080180",
		"latitud": "41.86313179",
		"longitud": "1.87476454",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. de Ponent, 7, 08660 Balsareny, Barcelona",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-57ub~rqbw_szi9",
		":version": "rv-jaut_ckq8-t8uy",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Balsareny",
		"indicador_refugi": "080180|CASAL_CIVIC_I_COMUNITARI_BALSARENY",
		"municipi": "Balsareny",
		"codi_municipi": "080180",
		"latitud": "41.8632281",
		"longitud": "1.8742206",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. del Rector Roc Garcia, 1",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-jxen_p6xn.kzpz",
		":version": "rv-4pyy.8fbf-9d3z",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Local social Esplai",
		"indicador_refugi": "430206|LOCAL_SOCIAL_ESPLAI",
		"municipi": "Banyeres del Penedès",
		"codi_municipi": "430206",
		"latitud": "41.2618118",
		"longitud": "1.46153282",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. de l'esplai, 50",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-7h55_j5e5.rci6",
		":version": "rv-9cr9_gcau.b4vi",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina pública municipal de Banyeres del Penedès",
		"indicador_refugi": "430206|PISCINA_PUBLICA_MUNICIPAL_DE_BANYERES_DEL_PENEDES",
		"municipi": "Banyeres del Penedès",
		"codi_municipi": "430206",
		"latitud": "41.27648383",
		"longitud": "1.5824701",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Dos Hermanas, 2",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-sgrv.gs4k-suig",
		":version": "rv-eu6d-zc72.hvk3",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca municipal de Banyeres del Penedès Ernest Lluch",
		"indicador_refugi": "430206|BIBLIOTECA_MUNICIPAL_DE_BANYERES_DEL_PENEDES_ERNEST_LLUCH",
		"municipi": "Banyeres del Penedès",
		"codi_municipi": "430206",
		"latitud": "41.2789843",
		"longitud": "1.5807527",
		"accessibilitat": "No",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Saragossa, s/n",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-ah3k_d8ch~mz2h",
		":version": "rv-k4da.m3u4_gj3c",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Espai jove",
		"indicador_refugi": "430206|ESPAI_JOVE",
		"municipi": "Banyeres del Penedès",
		"codi_municipi": "430206",
		"latitud": "41.28060354",
		"longitud": "1.58087211",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Montserrat, 5-7",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-c4t6-ct4k-974w",
		":version": "rv-y45n.wv46~uc8u",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de l'escola Mare de Déu del Priorat",
		"indicador_refugi": "430206|PARC_DE_LESCOLA_MARE_DE_DEU_DEL_PRIORAT",
		"municipi": "Banyeres del Penedès",
		"codi_municipi": "430206",
		"latitud": "41.2764",
		"longitud": "1.5813",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Avinguda Verge del Priorat, 41",
		"informacio_web": "www.banyeresdelpenedes.cat",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-01T08:54:00.000"
	},
	{
		":id": "row-bzyh-uqnj.ixs4",
		":version": "rv-aa78~7a2f_quz9",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "PARC DEL PATUFET",
		"indicador_refugi": "430206|PARC_DEL_PATUFET",
		"municipi": "Banyeres del Penedès",
		"codi_municipi": "430206",
		"latitud": "41.2778",
		"longitud": "1.5787",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer La Granja cantonada carrer Penedès",
		"informacio_web": "www.banyeresdelpenedes.cat",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-01T08:57:00.000"
	},
	{
		":id": "row-xdst~kj3q~mib9",
		":version": "rv-d9mf-aum7.gzci",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "PARC PRÍNCEP D'ASTÚRIES",
		"indicador_refugi": "430206|PARC_PRINCEP_DASTURIES",
		"municipi": "Banyeres del Penedès",
		"codi_municipi": "430206",
		"latitud": "41.27844",
		"longitud": "1.5843",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Josep Maria Biarnés, 9",
		"informacio_web": "www.banyeresdelpenedes.cat",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-01T09:01:00.000"
	},
	{
		":id": "row-7yty_ahre-yu3p",
		":version": "rv-4xbi-3hmz~mvz2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "PATI DE L'ESCOLA MARE DE DÉU DEL PRIORAT",
		"indicador_refugi": "430206|PATI_DE_LESCOLA_MARE_DE_DEU_DEL_PRIORAT",
		"municipi": "Banyeres del Penedès",
		"codi_municipi": "430206",
		"latitud": "41.2764",
		"longitud": "1.5813",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Avinguda Verge del Priorat, 41",
		"informacio_web": "www.banyeresdelpenedes.cat",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-01T09:07:00.000"
	},
	{
		":id": "row-ttfx.ajw5_ihnz",
		":version": "rv-7ugn~azin~9hzp",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "PARC DEL PRIORAT",
		"indicador_refugi": "430206|PARC_DEL_PRIORAT",
		"municipi": "Banyeres del Penedès",
		"codi_municipi": "430206",
		"latitud": "41.2741",
		"longitud": "1.5447",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Avinguda Marquesa de Grinyi, 63",
		"informacio_web": "www.banyeresdelpenedes.cat",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-01T09:12:00.000"
	},
	{
		":id": "row-7t7p~5ym5~dr35",
		":version": "rv-3prm-di94~mda9",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "PARC DELS BOSCOS",
		"indicador_refugi": "430206|PARC_DELS_BOSCOS",
		"municipi": "Banyeres del Penedès",
		"codi_municipi": "430206",
		"latitud": "41.2695",
		"longitud": "1.5708",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Salvador Espriu, 14",
		"informacio_web": "www.banyeresdelpenedes.cat",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-01T09:25:00.000"
	},
	{
		":id": "row-vpvn.g4qe_n59c",
		":version": "rv-m2mc~mk7j~bv58",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "PARC DE LES MASIES DE SANT MIQUEL",
		"indicador_refugi": "430206|PARC_DE_LES_MASIES_DE_SANT_MIQUEL",
		"municipi": "Banyeres del Penedès",
		"codi_municipi": "430206",
		"latitud": "41.2698",
		"longitud": "1.5604",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "CARRER TOMOVÍ , 57, CARRER SANT MIQUEL 2",
		"informacio_web": "ww.banyeresdelpenedes.cat",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-01T09:40:00.000"
	},
	{
		":id": "row-78j3.mzu4_ihq5",
		":version": "rv-at3s~djq5-q4yz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "ESCOLA MARE DE DÉU DEL PRIORAT",
		"indicador_refugi": "430206|ESCOLA_MARE_DE_DEU_DEL_PRIORAT",
		"municipi": "Banyeres del Penedès",
		"codi_municipi": "430206",
		"latitud": "41.276",
		"longitud": "1.5818",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Avinguda Verge del Priorat, 41",
		"informacio_web": "www.banyeresdelpenedes.cat",
		"tipologia": "Escola / Institut",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-01T10:09:00.000"
	},
	{
		":id": "row-9fab-u9q8.bpka",
		":version": "rv-fbcc.b23u_i6cw",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca de Banyoles",
		"indicador_refugi": "170157|BIBLIOTECA_DE_BANYOLES",
		"municipi": "Banyoles",
		"codi_municipi": "170157",
		"latitud": "42.12375512",
		"longitud": "2.76306577",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Llibertat, 155",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-b6qw_sc6v_ymis",
		":version": "rv-69es~di2w~vzmr",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça Cruyff Court Andreu Fontàs/ barri Canaleta",
		"indicador_refugi": "170157|PLACA_CRUYFF_COURT_ANDREU_FONTAS_BARRI_CANALETA",
		"municipi": "Banyoles",
		"codi_municipi": "170157",
		"latitud": "42.12469162",
		"longitud": "2.76993171",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "No",
		"adreca": "Pl. Cruyff Court Andreu Fontàs",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-q63c_jmfp-2bj7",
		":version": "rv-p4n8_yyye.dmr3",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de barri de Can Puig",
		"indicador_refugi": "170157|CASAL_DE_BARRI_DE_CAN_PUIG",
		"municipi": "Banyoles",
		"codi_municipi": "170157",
		"latitud": "42.18206045",
		"longitud": "2.79145058",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Figueres, 47",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-xwqb-y8nu.iei5",
		":version": "rv-8i88-utvt_m9m4",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Museu Darder",
		"indicador_refugi": "170157|MUSEU_DARDER",
		"municipi": "Banyoles",
		"codi_municipi": "170157",
		"latitud": "42.11930919",
		"longitud": "2.76506978",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Pl. dels estudis, 2",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-gfuf_qzty.u8i7",
		":version": "rv-7wsf-3tp8~jdna",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça de les Rodes",
		"indicador_refugi": "170157|PLACA_DE_LES_RODES",
		"municipi": "Banyoles",
		"codi_municipi": "170157",
		"latitud": "42.11808599",
		"longitud": "2.7617097",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. de les rodes",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-urue-m5jj~xa2a",
		":version": "rv-9jwj_58vx_idyw",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de barri de la Farga",
		"indicador_refugi": "170157|CASAL_DE_BARRI_DE_LA_FARGA",
		"municipi": "Banyoles",
		"codi_municipi": "170157",
		"latitud": "42.11500611",
		"longitud": "2.7725514",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Barcelona, 58",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-p29t_rayb.ne55",
		":version": "rv-d7h3-a6y4-6wsi",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Banyoles",
		"indicador_refugi": "170157|CASAL_CIVIC_I_COMUNITARI_BANYOLES",
		"municipi": "Banyoles",
		"codi_municipi": "170157",
		"latitud": "42.1188999",
		"longitud": "2.7613251",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de Josep Maria Bohigas i Masoliver, 19",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-snkq-pgp2_t544",
		":version": "rv-wwft~4csn~ub6s",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça de la Pau, Barri de la Farga",
		"indicador_refugi": "170157|PLACA_DE_LA_PAU_BARRI_DE_LA_FARGA",
		"municipi": "Banyoles",
		"codi_municipi": "170157",
		"latitud": "42.11496132",
		"longitud": "2.77318934",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. de la Pau",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-ds48_fatn-qxc8",
		":version": "rv-c96z_y2ka_n56u",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "La Caseta de fusta",
		"indicador_refugi": "170157|LA_CASETA_DE_FUSTA",
		"municipi": "Banyoles",
		"codi_municipi": "170157",
		"latitud": "42.12151898",
		"longitud": "2.75808085",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Pg. Lluís Maria Vidal, 1",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-4un6.28au-whgt",
		":version": "rv-v2kc_sija~npkx",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de barri Mas Palau",
		"indicador_refugi": "170157|CASAL_DE_BARRI_MAS_PALAU",
		"municipi": "Banyoles",
		"codi_municipi": "170157",
		"latitud": "42.12532229",
		"longitud": "2.76694862",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Sant Narcís, 12",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-uxxm_3x2d.id42",
		":version": "rv-cgvx_bmjr-rbnu",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de barri de Sant Pere",
		"indicador_refugi": "170157|CASAL_DE_BARRI_DE_SANT_PERE",
		"municipi": "Banyoles",
		"codi_municipi": "170157",
		"latitud": "42.1110772",
		"longitud": "2.76777015",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Maria Montesori, s/n",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-nv4b.3z82-rgwd",
		":version": "rv-k2j6.y7b6.vezn",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Caseta De Fusta",
		"indicador_refugi": "170157|CASETA_DE_FUSTA",
		"municipi": "Banyoles",
		"codi_municipi": "170157",
		"latitud": "42.13073612",
		"longitud": "2.75992693",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "No",
		"adreca": "Estany de Banyoles, 17820 Banyoles, Girona",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-m9dk.e6ut.psp3",
		":version": "rv-6xvi_jusk-6k67",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "430213|PISCINA_MUNICIPAL",
		"municipi": "Barberà de la Conca",
		"codi_municipi": "430213",
		"latitud": "41.4092116",
		"longitud": "1.2282938",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Valldemur",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-j6jk~ks3e-pdin",
		":version": "rv-tnai~n9gb-cizj",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Local social",
		"indicador_refugi": "170182|LOCAL_SOCIAL",
		"municipi": "Bellcaire d'Empordà",
		"codi_municipi": "170182",
		"latitud": "42.08243058",
		"longitud": "3.09588494",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Orient, s/n - Zona esportiva",
		"tipologia": "Sala polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-ninm_9bt4~abr5",
		":version": "rv-xtp2~pehw_v4vg",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscines municipals",
		"indicador_refugi": "250479|PISCINES_MUNICIPALS",
		"municipi": "Bellcaire d'Urgell",
		"codi_municipi": "250479",
		"latitud": "41.75733474",
		"longitud": "0.90437059",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Catalunya, 45, 25337 Bellcaire d'Urgell",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-s3rg-gqqf-vmd7",
		":version": "rv-xjaf.kg3c-6wbi",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca",
		"indicador_refugi": "250479|BIBLIOTECA",
		"municipi": "Bellcaire d'Urgell",
		"codi_municipi": "250479",
		"latitud": "41.75965262",
		"longitud": "0.90603535",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Major, 1-CP, 25337 Bellcaire d'Urgell",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-kzny-def5_324q",
		":version": "rv-vv5k-bqkt-imqx",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "LLAR DEL JUBILAT",
		"indicador_refugi": "250485|LLAR_DEL_JUBILAT",
		"municipi": "Bell-lloc d'Urgell",
		"codi_municipi": "250485",
		"latitud": "41.629879",
		"longitud": "0.781194",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "PLAÇA CATALUNYA, 2",
		"tipologia": "Casal de Gent Gran",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-01T08:41:00.000"
	},
	{
		":id": "row-bb5g-3brd_9gug",
		":version": "rv-g2jn.x76j~k984",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "PISCINES MUNICIPALS",
		"indicador_refugi": "250485|PISCINES_MUNICIPALS",
		"municipi": "Bell-lloc d'Urgell",
		"codi_municipi": "250485",
		"latitud": "41.632946",
		"longitud": "0.781854",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C/ DELS CUPS S/N",
		"tipologia": "Piscines descobertes",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-01T08:43:00.000"
	},
	{
		":id": "row-scnm.izie.n7h9",
		":version": "rv-yfw4-bwmi_wgz9",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "BIBLIOTECA",
		"indicador_refugi": "250485|BIBLIOTECA",
		"municipi": "Bell-lloc d'Urgell",
		"codi_municipi": "250485",
		"latitud": "41.631762",
		"longitud": "0.778374",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C/VIA FERREA, 5",
		"informacio_web": "https://cercadorbiblioteques.cultura.gencat.cat/biblio.do?reqCode=view&codiBiblio=P0044&pos=0",
		"tipologia": "Biblioteca",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-01T08:47:00.000"
	},
	{
		":id": "row-ssbp.y9sz-d5br",
		":version": "rv-4x9r_der8.ymzs",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "PLAÇA LLUÍS COMPANYS",
		"indicador_refugi": "250485|PLACA_LLUIS_COMPANYS",
		"municipi": "Bell-lloc d'Urgell",
		"codi_municipi": "250485",
		"latitud": "41.631668",
		"longitud": "0.776713",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "PLAÇA LLUÍS COMPANYS",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-01T08:48:00.000"
	},
	{
		":id": "row-8fvf.a982_xt8d",
		":version": "rv-mxzm_dauq-ae8k",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Local social de Bellmunt d'Urgell",
		"indicador_refugi": "250498|LOCAL_SOCIAL_DE_BELLMUNT_D_URGELL",
		"municipi": "Bellmunt d'Urgell",
		"codi_municipi": "250498",
		"latitud": "41.773538",
		"longitud": "0.95345458",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Escoles",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-g9ee~ayai-x499",
		":version": "rv-4ees_32u6.hy8u",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "250518|PISCINA_MUNICIPAL",
		"municipi": "Bellver de Cerdanya",
		"codi_municipi": "250518",
		"latitud": "42.36800711236008",
		"longitud": "1.7776521370887721",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer del Berguedà, 19,",
		"informacio_web": "www.esportsbellver.org",
		"tipologia": "Piscines descobertes",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-04T12:48:00.000"
	},
	{
		":id": "row-3tm8-2s44-995r",
		":version": "rv-8cam_jxef_4uk9",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic 'Escoles velles'",
		"indicador_refugi": "250518|CENTRE_CIVIC_ESCOLES_VELLES",
		"municipi": "Bellver de Cerdanya",
		"codi_municipi": "250518",
		"latitud": "42.36901365520093",
		"longitud": "1.7765089254428792",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Escoles, 6",
		"informacio_web": "www.bellver.org",
		"tipologia": "Centre Cívic",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-04T12:55:00.000"
	},
	{
		":id": "row-48md.38re~ietb",
		":version": "rv-735y.mcy8-wuqx",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Pavelló poliesportiu",
		"indicador_refugi": "250518|PAVELLO_POLIESPORTIU",
		"municipi": "Bellver de Cerdanya",
		"codi_municipi": "250518",
		"latitud": "42.36705588861876",
		"longitud": "1.7773410008619641",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer de l'Esport, 5",
		"informacio_web": "www.bellver.org",
		"tipologia": "Pavelló Esportiu",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-04T13:01:00.000"
	},
	{
		":id": "row-wmdy-3zgv~mmnn",
		":version": "rv-u2mu~7ni2_xwgf",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "430252|PISCINA_MUNICIPAL",
		"municipi": "Benifallet",
		"codi_municipi": "430252",
		"latitud": "40.97243408",
		"longitud": "0.51584758",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Marcel·lí Domingo, 27",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-wwyc~2bex~js49",
		":version": "rv-5iy3_wscp.3m53",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Refugi climàtic del pati de l'Escola Antoni Nat",
		"indicador_refugi": "430265|REFUGI_CLIMATIC_DEL_PATI_DE_LESCOLA_ANTONI_NAT",
		"municipi": "Benissanet",
		"codi_municipi": "430265",
		"latitud": "41.0567403",
		"longitud": "0.6350701",
		"accessibilitat": "No",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "No",
		"lavabo": "No",
		"adreca": "Carrer Reus, 43747, Benissanet",
		"tipologia": "Escola / Institut",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-23T09:09:00.000"
	},
	{
		":id": "row-i5bv_yphz~z9gs",
		":version": "rv-vb67~nxst.ssim",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Municipal",
		"indicador_refugi": "430265|BIBLIOTECA_MUNICIPAL",
		"municipi": "Benissanet",
		"codi_municipi": "430265",
		"latitud": "41.0580906",
		"longitud": "0.6329984",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Antoni Gaudí, 1",
		"informacio_web": "https://tauler.seu-e.cat/detall?idEns=4302650006&idEdicte=637735",
		"tipologia": "Biblioteca",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-07T09:31:00.000"
	},
	{
		":id": "row-2sby-tehq_6cd2",
		":version": "rv-ry44_6aft-xzd5",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Sala Entitats",
		"indicador_refugi": "430265|SALA_ENTITATS",
		"municipi": "Benissanet",
		"codi_municipi": "430265",
		"latitud": "41.05",
		"longitud": "0.6333",
		"accessibilitat": "Sí",
		"aigua": "No",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Josep Serra, 14",
		"informacio_web": "https://tauler.seu-e.cat/detall?idEns=4302650006&idEdicte=637735",
		"tipologia": "Centre Cívic",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-07T09:33:00.000"
	},
	{
		":id": "row-yiwz_8tak_36mz",
		":version": "rv-ug53.fgqb_hxs3",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Berga",
		"indicador_refugi": "080229|CASAL_CIVIC_I_COMUNITARI_BERGA",
		"municipi": "Berga",
		"codi_municipi": "080229",
		"latitud": "42.1022529",
		"longitud": "1.2352668",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. de Sant Joan, s/n",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-s2wm-sweh_swhi",
		":version": "rv-qf4s_b2n5.qgdp",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscines municipals d'estiu",
		"indicador_refugi": "080229|PISCINES_MUNICIPALS_D_ESTIU",
		"municipi": "Berga",
		"codi_municipi": "080229",
		"latitud": "42.09870412",
		"longitud": "1.84863395",
		"accessibilitat": "No",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Guillem de Berguedà, s/n",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-gixw~ieme-3dfy",
		":version": "rv-2645_3qr5_rgwb",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Ramon Vidal - Can Cambó",
		"indicador_refugi": "170195|BIBLIOTECA_RAMON_VIDAL_CAN_CAMBO",
		"municipi": "Besalú",
		"codi_municipi": "170195",
		"latitud": "42.1992681",
		"longitud": "2.698946",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C.Major 13 2n",
		"informacio_web": "Estiu de 10 a 13 de dilluns a divendres i dimarts i dijous també tarda de 16 a 18:30",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-06-05T12:14:00.000"
	},
	{
		":id": "row-i5b7~e3fj~964q",
		":version": "rv-6x4b~ep93_a2ks",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Local Comunitari Can Cambó",
		"indicador_refugi": "170195|LOCAL_COMUNITARI_CAN_CAMBO",
		"municipi": "Besalú",
		"codi_municipi": "170195",
		"latitud": "42.1992681",
		"longitud": "2.698946",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Major 13 1r",
		"informacio_web": "Tardes",
		"tipologia": "Centre Cívic",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-05T12:19:00.000"
	},
	{
		":id": "row-emjs-sm4k_hky5",
		":version": "rv-y4ep.yr57~w7ur",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Sala polivalent Baixos Can Cambó",
		"indicador_refugi": "170195|SALA_POLIVALENT_BAIXOS_CAN_CAMBO",
		"municipi": "Besalú",
		"codi_municipi": "170195",
		"latitud": "42.1992681",
		"longitud": "2.698946",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Major 13 Baixos",
		"tipologia": "Sala Polivalent",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-05T12:24:00.000"
	},
	{
		":id": "row-cicd_2bcx-dv5y",
		":version": "rv-i7hx~qkic~h58f",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal d'avis",
		"indicador_refugi": "170209|CASAL_D_AVIS",
		"municipi": "Bescanó",
		"codi_municipi": "170209",
		"latitud": "41.96238668",
		"longitud": "2.7380545",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pg. de la Torre, s/n",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-9e8c-eak3~ygut",
		":version": "rv-w6x9_tjmf.uzj6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Josep Fontbernat i Verdaguer",
		"indicador_refugi": "170209|BIBLIOTECA_JOSEP_FONTBERNAT_I_VERDAGUER",
		"municipi": "Bescanó",
		"codi_municipi": "170209",
		"latitud": "41.96367981",
		"longitud": "2.73764038",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. de les Nacions, 10",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-7e55-tf2v~ssaa",
		":version": "rv-aggk_7v9z_e6e3",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal d'avis centre cívic i cultural El Rieral",
		"indicador_refugi": "080235|CASAL_D_AVIS_CENTRE_CIVIC_I_CULTURAL_EL_RIERAL",
		"municipi": "Bigues i Riells del Fai",
		"codi_municipi": "080235",
		"latitud": "41.68150904",
		"longitud": "2.20615009",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Anna Mogas, 130, 08510 Bigues i Riells del Fai",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-ais7.s7ki~a3h7",
		":version": "rv-a39a~diq4_6x94",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Local social Can Gordei",
		"indicador_refugi": "430287|LOCAL_SOCIAL_CAN_GORDEI",
		"municipi": "Bisbal del Penedès, la",
		"codi_municipi": "430287",
		"latitud": "41.26376012",
		"longitud": "1.47451555",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. Can Gordei, 25",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-4rj9_34w6_eqmq",
		":version": "rv-8xdd~gwfz-yutg",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "430287|PISCINA_MUNICIPAL",
		"municipi": "Bisbal del Penedès, la",
		"codi_municipi": "430287",
		"latitud": "41.27494888",
		"longitud": "1.49114524",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Av. Diputació, 16",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-h454_8wvv.hdja",
		":version": "rv-ktts_89ek.kn7r",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Local social Priorat",
		"indicador_refugi": "430287|LOCAL_SOCIAL_PRIORAT",
		"municipi": "Bisbal del Penedès, la",
		"codi_municipi": "430287",
		"latitud": "41.28530938",
		"longitud": "1.47242342",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. Priorat",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-u8be.2c68~azdg",
		":version": "rv-vn9z-9tux~m3yu",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Local social La Miralba",
		"indicador_refugi": "430287|LOCAL_SOCIAL_LA_MIRALBA",
		"municipi": "Bisbal del Penedès, la",
		"codi_municipi": "430287",
		"latitud": "41.26461197",
		"longitud": "1.49240948",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Gladiol, s/n",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-23jc-27cf-zjsk",
		":version": "rv-b5ep-tsas-gmsr",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Font de l'Arbre",
		"indicador_refugi": "170221|FONT_DE_L_ARBRE",
		"municipi": "Bisbal d'Empordà, la",
		"codi_municipi": "170221",
		"latitud": "41.95250774",
		"longitud": "3.02996244",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Camí de la Font de l'Arbre",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-q7eb.3qgi-x7xm",
		":version": "rv-pfyu_m7jf_cxkx",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "El passeig Marimon Asprer",
		"indicador_refugi": "170221|EL_PASSEIG_MARIMON_ASPRER",
		"municipi": "Bisbal d'Empordà, la",
		"codi_municipi": "170221",
		"latitud": "41.96221026",
		"longitud": "3.03774645",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pg. Marimon Asprer",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-t5s3.5j8h.7ptt",
		":version": "rv-2uhj-4un6.racc",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jardins de Torre Maria",
		"indicador_refugi": "170221|JARDINS_DE_TORRE_MARIA",
		"municipi": "Bisbal d'Empordà, la",
		"codi_municipi": "170221",
		"latitud": "41.96257672",
		"longitud": "3.0360942",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Aigüeta, 17",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-tqvf.qhb8.a7en",
		":version": "rv-fc3z~6urm~scuz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Zona arbrada del pàrquing del CAP",
		"indicador_refugi": "170221|ZONA_ARBRADA_DEL_PARQUING_DEL_CAP",
		"municipi": "Bisbal d'Empordà, la",
		"codi_municipi": "170221",
		"latitud": "41.96269175",
		"longitud": "3.03502405",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de Marcel Ralló",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-v9f2.wxns_kran",
		":version": "rv-pvxs-mmbi.uevz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc 8 de març",
		"indicador_refugi": "170221|PARC_8_DE_MARC",
		"municipi": "Bisbal d'Empordà, la",
		"codi_municipi": "170221",
		"latitud": "41.95657056",
		"longitud": "3.03908368",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. de Josep Irla, 11",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-z8er_ggj4.nyec",
		":version": "rv-qajz-88yq_ptf6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Blanes - Benet Ribas",
		"indicador_refugi": "170237|CASAL_CIVIC_I_COMUNITARI_BLANES_BENET_RIBAS",
		"municipi": "Blanes",
		"codi_municipi": "170237",
		"latitud": "41.6746178",
		"longitud": "2.7900147",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. d'Espanya, 3",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-eqmv-vubp-6yqt",
		":version": "rv-kv8r_uj8q_rff9",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "170242|PISCINA_MUNICIPAL",
		"municipi": "Bolvir",
		"codi_municipi": "170242",
		"latitud": "42.42031493",
		"longitud": "1.88125142",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "No",
		"adreca": "C. Torrent dels Agustins, s/n",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-mdsn~kega-r8ny",
		":version": "rv-8wzw-y2he~wjz7",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Poliesportiu",
		"indicador_refugi": "250576|POLIESPORTIU",
		"municipi": "Bòrdes, Es",
		"codi_municipi": "250576",
		"latitud": "42.73751618",
		"longitud": "0.71966274",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. de l'esglesia",
		"tipologia": "Poliesportiu",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-eexq~n2u9-nc39",
		":version": "rv-h3ta_xm4n.xf7r",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari les Borges Blanques",
		"indicador_refugi": "250582|CASAL_CIVIC_I_COMUNITARI_LES_BORGES_BLANQUES",
		"municipi": "Borges Blanques, les",
		"codi_municipi": "250582",
		"latitud": "41.5184596",
		"longitud": "0.8523082",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de Màrius Torres, 3",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-s26m~r2z5.3h39",
		":version": "rv-6szs_uaix~ug3c",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "430332|PISCINA_MUNICIPAL",
		"municipi": "Botarell",
		"codi_municipi": "430332",
		"latitud": "41.13679054",
		"longitud": "0.98813643",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. del Corralot, s/n",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-8i6h-kvsa-hws8",
		":version": "rv-j3n8-q7tx.svr8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal de Bràfim",
		"indicador_refugi": "430347|PISCINA_MUNICIPAL_DE_BRAFIM",
		"municipi": "Bràfim",
		"codi_municipi": "430347",
		"latitud": "41.26692707",
		"longitud": "1.34823067",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Camí de l'Ermita",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-ita4~nuy2~ifq3",
		":version": "rv-x5ex.kks5-6zgk",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic El Centru",
		"indicador_refugi": "430347|CENTRE_CIVIC_EL_CENTRU",
		"municipi": "Bràfim",
		"codi_municipi": "430347",
		"latitud": "41.26791774",
		"longitud": "1.33972879",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "No",
		"adreca": "Av. Catalunya, 30",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-hi7x.3nt5_h8k8",
		":version": "rv-wxjk-pji9_57ug",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal social",
		"indicador_refugi": "430347|CASAL_SOCIAL",
		"municipi": "Bràfim",
		"codi_municipi": "430347",
		"latitud": "41.26721209",
		"longitud": "1.3393324",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Av. Catalunya, 43 (pl. Prayssac)",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-8dcy_hzer-gfdz",
		":version": "rv-bdpp~ptm2_bn39",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscines municipals de Breda",
		"indicador_refugi": "170274|PISCINES_MUNICIPALS_DE_BREDA",
		"municipi": "Breda",
		"codi_municipi": "170274",
		"latitud": "41.74685199",
		"longitud": "2.56384435",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Av. Catalunya, 46",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-syni-2axa.ymym",
		":version": "rv-p5qg~d8zs_jgec",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "080253|PISCINA_MUNICIPAL",
		"municipi": "Bruc, el",
		"codi_municipi": "080253",
		"latitud": "41.5841057",
		"longitud": "1.77678205",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Zona esportiva, s/n",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-qmq4~e95j_u7uu",
		":version": "rv-rvz7-ewg9~u576",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Sala 1 d'octubre",
		"indicador_refugi": "170280|SALA_1_DOCTUBRE",
		"municipi": "Brunyola i Sant Martí Sapresa",
		"codi_municipi": "170280",
		"latitud": "41.9045",
		"longitud": "2.6842",
		"accessibilitat": "Sí",
		"aigua": "No",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça del Castell de Brunyola, 5, 17441, Brunyola i Sant Martí Sapresa (Girona)",
		"tipologia": "Ajuntament / Equipament Administratiu",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-22T18:50:00.000"
	},
	{
		":id": "row-63hs-xrgf.3fth",
		":version": "rv-uijc_y8hw_ebvm",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "La Sala",
		"indicador_refugi": "170314|LA_SALA",
		"municipi": "Cabanelles",
		"codi_municipi": "170314",
		"latitud": "42.22915535",
		"longitud": "2.81950988",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Ctra. GIV-5238 km 1",
		"informacio_web": "https://cabanelles.cat/coneix/local-polivalent-la-sala/",
		"tipologia": "Sala Polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-06-04T07:21:00.000"
	},
	{
		":id": "row-zfh6_bts2.35xc",
		":version": "rv-fytn-yfdk-g994",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Sala 1 d'octubre",
		"indicador_refugi": "430363|SALA_1_D_OCTUBRE",
		"municipi": "Cabra del Camp",
		"codi_municipi": "430363",
		"latitud": "41.395593",
		"longitud": "1.275454",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Raval de la Creu, 9",
		"tipologia": "Sala polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-ctfp.rvpf~yxcn",
		":version": "rv-fth4-r5kv.8xfp",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal el Castellet",
		"indicador_refugi": "080291|CASAL_EL_CASTELLET",
		"municipi": "Cabrera de Mar",
		"codi_municipi": "080291",
		"latitud": "41.523255",
		"longitud": "2.396703",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Agustí Vendrell i Solé 11",
		"tipologia": "Casal de Gent Gran",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-10T09:54:00.000"
	},
	{
		":id": "row-vzae.byzy.xid2",
		":version": "rv-hh8f~r2y8.tjja",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "080291|PISCINA_MUNICIPAL",
		"municipi": "Cabrera de Mar",
		"codi_municipi": "080291",
		"latitud": "41.524924",
		"longitud": "2.39318",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Riera s/n",
		"tipologia": "Piscina Coberta",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-10T09:56:00.000"
	},
	{
		":id": "row-h9s2_62pg~u4gg",
		":version": "rv-32xw~xpz4.44ix",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Ilturo",
		"indicador_refugi": "080291|BIBLIOTECA_ILTURO",
		"municipi": "Cabrera de Mar",
		"codi_municipi": "080291",
		"latitud": "41.528643",
		"longitud": "2.392569",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Sant Joan, 8",
		"tipologia": "Biblioteca",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-10T09:58:00.000"
	},
	{
		":id": "row-rxke.mgub.dmb7",
		":version": "rv-7vt2_m2wn_evff",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Cívic Pla de l'Avellà",
		"indicador_refugi": "080291|CENTRE_CIVIC_PLA_DE_LAVELLA",
		"municipi": "Cabrera de Mar",
		"codi_municipi": "080291",
		"latitud": "41.510319153244424",
		"longitud": "2.4002677862480377",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Joan XXIII, 1",
		"tipologia": "Centre Cívic",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-10T10:02:00.000"
	},
	{
		":id": "row-q2qm_ng34~j5ez",
		":version": "rv-2jqh.esbs-qnmq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal de Calaf",
		"indicador_refugi": "080312|PISCINA_MUNICIPAL_DE_CALAF",
		"municipi": "Calaf",
		"codi_municipi": "080312",
		"latitud": "41.73493059",
		"longitud": "1.52094693",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Camí de Manresa, 27, 08280 Calaf, Barcelona",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-23kz~6t3g-bws4",
		":version": "rv-asvp_7y5g-z48j",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Sala d'actes Municipal Teresa Escolà i Torra",
		"indicador_refugi": "080312|SALA_DACTES_MUNICIPAL_TERESA_ESCOLA_I_TORRA",
		"municipi": "Calaf",
		"codi_municipi": "080312",
		"latitud": "41.7339",
		"longitud": "1.51594",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Mestre Manel Giralt, 4",
		"tipologia": "Sala Polivalent",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-04T11:32:00.000"
	},
	{
		":id": "row-d6jy-bh8j~w922",
		":version": "rv-ixny-p2cq.kjfj",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casa Bertran - Esplai de la Gent Gran",
		"indicador_refugi": "080312|CASA_BERTRAN_-_ESPLAI_DE_LA_GENT_GRAN",
		"municipi": "Calaf",
		"codi_municipi": "080312",
		"latitud": "41.7315",
		"longitud": "1.5138",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Passeig Santa Calamanda, 6",
		"informacio_web": "https://www.calaf.cat/adreces-i-telefons/1517-casa-bertran-esplai-de-la-gent-gran.html",
		"tipologia": "Casal de Gent Gran",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-04T11:58:00.000"
	},
	{
		":id": "row-9wud.tbsh~pwce",
		":version": "rv-vgpn_u2vw_tkk2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal social",
		"indicador_refugi": "080348|CASAL_SOCIAL",
		"municipi": "Calders",
		"codi_municipi": "080348",
		"latitud": "41.78985606",
		"longitud": "1.99174475",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Països Catalans, s/n",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-rutg~gnu5.539y",
		":version": "rv-ua3c_9jqr-v2t8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "080348|PISCINA_MUNICIPAL",
		"municipi": "Calders",
		"codi_municipi": "080348",
		"latitud": "41.78662065",
		"longitud": "1.97851754",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Pedraforca, s/n",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-ybc7-56sq-v6em",
		":version": "rv-p2f7-fs7j-666n",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Sala Cavallerisses (Ajuntament de Caldes de Malavella)",
		"indicador_refugi": "170335|SALA_CAVALLERISSES_AJUNTAMENT_DE_CALDES_DE_MALAVELLA",
		"municipi": "Caldes de Malavella",
		"codi_municipi": "170335",
		"latitud": "41.83899472",
		"longitud": "2.80945001",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. de l'Ajuntament, 20",
		"tipologia": "Sala polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-x2r9~fwhs.sr7t",
		":version": "rv-9bm5-pstj~wqcq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Teatre-Casino municipal",
		"indicador_refugi": "170335|TEATRE_CASINO_MUNICIPAL",
		"municipi": "Caldes de Malavella",
		"codi_municipi": "170335",
		"latitud": "41.83589524",
		"longitud": "2.8090881",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de Mossèn Cinto Verdaguer, 11",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-7pf9.9zwy_jy3s",
		":version": "rv-x29m-sxp2.vqdi",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Francesc Ferrer i Guàrdia",
		"indicador_refugi": "170335|BIBLIOTECA_FRANCESC_FERRER_I_GUARDIA",
		"municipi": "Caldes de Malavella",
		"codi_municipi": "170335",
		"latitud": "41.83869116",
		"longitud": "2.80972652",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de la Llibertat, 6",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-ttc2.diix-tumx",
		":version": "rv-tszv-s34s_fsyk",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casa Rosa",
		"indicador_refugi": "170335|CASA_ROSA",
		"municipi": "Caldes de Malavella",
		"codi_municipi": "170335",
		"latitud": "41.83847579",
		"longitud": "2.80858726",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. de Vall-Llobera, 4",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-vt8k~fhyw~zwcu",
		":version": "rv-wnr9.m9k5_zfwm",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina Caldes De Malavella",
		"indicador_refugi": "170335|PISCINA_CALDES_DE_MALAVELLA",
		"municipi": "Caldes de Malavella",
		"codi_municipi": "170335",
		"latitud": "41.8388576",
		"longitud": "2.80072005",
		"accessibilitat": "No",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de Caldes de Malavella, s/n",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-ftu3_9g2n~mkjs",
		":version": "rv-amm2-qv6a_6mqs",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Complex esportiu municipal Les Cremades",
		"indicador_refugi": "080333|COMPLEX_ESPORTIU_MUNICIPAL_LES_CREMADES",
		"municipi": "Caldes de Montbui",
		"codi_municipi": "080333",
		"latitud": "41.63681919",
		"longitud": "2.15940458",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Zona esportiva, s/n",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-uhbg_3vd4~spkb",
		":version": "rv-6e4z.565x~ys3x",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Ajuntament De Caldes De Montbui",
		"indicador_refugi": "080333|AJUNTAMENT_DE_CALDES_DE_MONTBUI",
		"municipi": "Caldes de Montbui",
		"codi_municipi": "080333",
		"latitud": "41.63452522",
		"longitud": "2.16222295",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. de la Font del Lleó, 11",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-wy39.y2sr_ei59",
		":version": "rv-ybkz~x574.7czt",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Les Cases Dels Metres, Cafeteria",
		"indicador_refugi": "080333|LES_CASES_DELS_METRES_CAFETERIA",
		"municipi": "Caldes de Montbui",
		"codi_municipi": "080333",
		"latitud": "41.63091502",
		"longitud": "2.16425064",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Mestre Gregori Montserrat, 4",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-wr4r.v7bk.vwuj",
		":version": "rv-ti9d.sj75~c5m7",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca de Caldes de Montbui",
		"indicador_refugi": "080333|BIBLIOTECA_DE_CALDES_DE_MONTBUI",
		"municipi": "Caldes de Montbui",
		"codi_municipi": "080333",
		"latitud": "41.62956185",
		"longitud": "2.16560755",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. de Santa Teresa, 3-5",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-es44~h9xh~z5ai",
		":version": "rv-kt8w.4rwk-ngjt",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Esplai de les Escoles velles",
		"indicador_refugi": "080386|ESPLAI_DE_LES_ESCOLES_VELLES",
		"municipi": "Callús",
		"codi_municipi": "080386",
		"latitud": "41.78224035",
		"longitud": "1.78473483",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Jacint Verdaguer, 20, 08262 Callús",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-5in2-uu7q~g3ci",
		":version": "rv-dihz_vrfq.dxvp",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Callús",
		"indicador_refugi": "080386|PARC_CALLUS",
		"municipi": "Callús",
		"codi_municipi": "080386",
		"latitud": "41.7807",
		"longitud": "1.78411013",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pg. Anselm Clavé, s/n",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-jb5b-wtht.ck5t",
		":version": "rv-pakp_5bac.h8xd",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Passeig del riu",
		"indicador_refugi": "080386|PASSEIG_DEL_RIU",
		"municipi": "Callús",
		"codi_municipi": "080386",
		"latitud": "41.78416013",
		"longitud": "1.78156587",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "No",
		"adreca": "C. del riu, s/n",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-9pzp.dxf8.c7zh",
		":version": "rv-w7p4~gdev~cjwz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "080386|PISCINA_MUNICIPAL",
		"municipi": "Callús",
		"codi_municipi": "080386",
		"latitud": "41.77976658",
		"longitud": "1.78195699",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. de Joaquim Blume, 08262 Callús",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-gipq_nj7c~epr2",
		":version": "rv-pihk_47mz-4xj8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal del poble",
		"indicador_refugi": "080386|CASAL_DEL_POBLE",
		"municipi": "Callús",
		"codi_municipi": "080386",
		"latitud": "41.7812482",
		"longitud": "1.78314821",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pg. Anselm Clavé, 21, 08262 Callús",
		"tipologia": "Sala polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-2cus~izdu~jtvg",
		":version": "rv-ftbp~rffe.c5gr",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Passeig Anselm Clavé",
		"indicador_refugi": "080386|PASSEIG_ANSELM_CLAVE",
		"municipi": "Callús",
		"codi_municipi": "080386",
		"latitud": "41.7812683",
		"longitud": "1.78353069",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pg. Anselm Clavé",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-dcqf.ib4t.vbyq",
		":version": "rv-4g8j-7gtz_wwaz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Pisicina municipal Camarles",
		"indicador_refugi": "439039|PISICINA_MUNICIPAL_CAMARLES",
		"municipi": "Camarles",
		"codi_municipi": "439039",
		"latitud": "40.77431618",
		"longitud": "0.66944925",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Camí de la Gravera",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-y723~metp_e4zx",
		":version": "rv-pshs~ausa_azcx",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Local social",
		"indicador_refugi": "170353|LOCAL_SOCIAL",
		"municipi": "Camós",
		"codi_municipi": "170353",
		"latitud": "42.09453246",
		"longitud": "2.76653499",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de Can Ponç, 2",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-2qfj_ptvs-t66i",
		":version": "rv-75mh-5acy.keqa",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Pavelló municipal",
		"indicador_refugi": "170405|PAVELLO_MUNICIPAL",
		"municipi": "Canet d'Adri",
		"codi_municipi": "170405",
		"latitud": "42.03321122",
		"longitud": "2.73418311",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Ctra. Vella",
		"tipologia": "Poliesportiu",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-n792_m3iq_8u59",
		":version": "rv-iy7g~7vt8-78mc",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Zones d'ombra passeig marítim",
		"indicador_refugi": "080403|ZONES_D_OMBRA_PASSEIG_MARITIM",
		"municipi": "Canet de Mar",
		"codi_municipi": "080403",
		"latitud": "41.58750669",
		"longitud": "2.58477282",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pg. Marítim de Canet de Mar, s/n",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-c8ke_5urq_xpfa",
		":version": "rv-b8pk~bhcn-28i9",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casa Museu Lluís Domènech i Montaner",
		"indicador_refugi": "080403|CASA_MUSEU_LLUIS_DOMENECH_I_MONTANER",
		"municipi": "Canet de Mar",
		"codi_municipi": "080403",
		"latitud": "41.58907045",
		"longitud": "2.58126852",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Ra. Gavarra, 2",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-npni-thxv~x5t7",
		":version": "rv-4b9x_qhvp~79uh",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de Can Santinyà",
		"indicador_refugi": "080403|PARC_DE_CAN_SANTINYA",
		"municipi": "Canet de Mar",
		"codi_municipi": "080403",
		"latitud": "41.5916589",
		"longitud": "2.58687325",
		"accessibilitat": "No",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Mas el Grau, s/n",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-qixp.r3pw_4mmj",
		":version": "rv-v8b8~8afq.mxic",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bosquet de Vil·la Flora",
		"indicador_refugi": "080403|BOSQUET_DE_VIL_LA_FLORA",
		"municipi": "Canet de Mar",
		"codi_municipi": "080403",
		"latitud": "41.59100204",
		"longitud": "2.57257022",
		"accessibilitat": "No",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Via Cannetum, 4",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-iie3.hjrx~bk5s",
		":version": "rv-f2dk_gksj-968p",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca de Canet de Mar - P. Gual i Pujadas",
		"indicador_refugi": "080403|BIBLIOTECA_DE_CANET_DE_MAR_P_GUAL_I_PUJADAS",
		"municipi": "Canet de Mar",
		"codi_municipi": "080403",
		"latitud": "41.58820301",
		"longitud": "2.58173917",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Ra. Sant Domènec, 1A",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-78sv.igc9.8hm5",
		":version": "rv-8yh5_qi3j.xwj5",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "La Masoveria de Vil·la Flora",
		"indicador_refugi": "080403|LA_MASOVERIA_DE_VIL_LA_FLORA",
		"municipi": "Canet de Mar",
		"codi_municipi": "080403",
		"latitud": "41.59159928",
		"longitud": "2.57262419",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Ra. Gavarra, s/n",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-btud_jjsp-8u2s",
		":version": "rv-469e_3asi~cttm",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Turó del Drac",
		"indicador_refugi": "080403|PARC_TURO_DEL_DRAC",
		"municipi": "Canet de Mar",
		"codi_municipi": "080403",
		"latitud": "41.59343975",
		"longitud": "2.57213183",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Pl. Busquets, s/n",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-i4ne~x7yc-w78z",
		":version": "rv-vdj2-bspc-fxy3",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "ÈPOCA (Espai polivalent de la Canonja)",
		"indicador_refugi": "439076|EPOCA_ESPAI_POLIVALENT_DE_LA_CANONJA",
		"municipi": "Canonja, la",
		"codi_municipi": "439076",
		"latitud": "41.1203806",
		"longitud": "1.1804432",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Rbla. 15 d'Abril, 43110 la Canonja",
		"tipologia": "Sala polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-w2nk-ydid.xxfx",
		":version": "rv-i4cw-ydsm_vfuj",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca La Canonja",
		"indicador_refugi": "439076|BIBLIOTECA_LA_CANONJA",
		"municipi": "Canonja, la",
		"codi_municipi": "439076",
		"latitud": "41.11949404",
		"longitud": "1.18320823",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. del Castell, 1, 43110 la Canonja",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-xuh3_4mnj.gzsk",
		":version": "rv-s8xy-hh5b-d34e",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Poliesportiu Josep Canadell i Veciana",
		"indicador_refugi": "439076|POLIESPORTIU_JOSEP_CANADELL_I_VECIANA",
		"municipi": "Canonja, la",
		"codi_municipi": "439076",
		"latitud": "41.12298563",
		"longitud": "1.18152939",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Alcalde Marian Fonts, s/n, 43110 la Canonja",
		"tipologia": "Poliesportiu",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-iejv~6hay~unde",
		":version": "rv-rv8v.kw2f.ecej",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Canovelles - veïnat Pau Casals",
		"indicador_refugi": "080410|CASAL_CIVIC_I_COMUNITARI_CANOVELLES_VEINAT_PAU_CASALS",
		"municipi": "Canovelles",
		"codi_municipi": "080410",
		"latitud": "41.6167578",
		"longitud": "2.274642",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. de Pau Casals, s/n",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-ru2q_tcay-v46u",
		":version": "rv-z4cc~6g9t.yhfi",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Canovelles - Can Palots",
		"indicador_refugi": "080410|CASAL_CIVIC_I_COMUNITARI_CANOVELLES_CAN_PALOTS",
		"municipi": "Canovelles",
		"codi_municipi": "080410",
		"latitud": "41.61821",
		"longitud": "2.2789029",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Sant Jordi - ctda. Pg. de Lluís Companys",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-5mv8-ckwk.y8ig",
		":version": "rv-kh7d~bfgm-tp42",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "430402|PISCINA_MUNICIPAL",
		"municipi": "Capçanes",
		"codi_municipi": "430402",
		"latitud": "41.10111175",
		"longitud": "0.78341391",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Llaberia, 5",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-xcqa-itir.4ijq",
		":version": "rv-6s85_v5i3-bthf",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de la Font Cuitora",
		"indicador_refugi": "080446|PARC_DE_LA_FONT_CUITORA",
		"municipi": "Capellades",
		"codi_municipi": "080446",
		"latitud": "41.52688",
		"longitud": "1.6839",
		"accessibilitat": "No",
		"aigua": "No",
		"climatitzacio": "No",
		"area_descans": "No",
		"lavabo": "No",
		"adreca": "C.Pau Casals, s/n",
		"informacio_web": "www.capellades.cat",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-06-02T09:47:00.000"
	},
	{
		":id": "row-qr7a~zs9f_meyn",
		":version": "rv-vkmg_v8wk-9nzp",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "La Cova- Espai jove",
		"indicador_refugi": "080446|LA_COVA_ESPAI_JOVE",
		"municipi": "Capellades",
		"codi_municipi": "080446",
		"latitud": "41.52881",
		"longitud": "1.68379",
		"accessibilitat": "No",
		"aigua": "No",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "No",
		"adreca": "Pg. Immaculada Concepció 28",
		"informacio_web": "www.capellades.cat",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-06-02T09:53:00.000"
	},
	{
		":id": "row-wf3d-npta-5k4v",
		":version": "rv-jkx3.bjyi_etdg",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca el Safareig de Capellades",
		"indicador_refugi": "080446|BIBLIOTECA_EL_SAFAREIG_DE_CAPELLADES",
		"municipi": "Capellades",
		"codi_municipi": "080446",
		"latitud": "41.53091",
		"longitud": "1.6858",
		"accessibilitat": "No",
		"aigua": "No",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "No",
		"adreca": "C. Pilar 2",
		"informacio_web": "www.capellades.cat",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-06-02T09:56:00.000"
	},
	{
		":id": "row-5mdm_vbgz_anjf",
		":version": "rv-kps6~ze6f~sqf7",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina blava municipal",
		"indicador_refugi": "080446|PISCINA_BLAVA_MUNICIPAL",
		"municipi": "Capellades",
		"codi_municipi": "080446",
		"latitud": "41.52896",
		"longitud": "1.6844",
		"accessibilitat": "No",
		"aigua": "No",
		"climatitzacio": "No",
		"area_descans": "No",
		"lavabo": "No",
		"adreca": "C. Rec del Corronaire, 8",
		"informacio_web": "www.capellades.cat",
		"tipologia": "Piscines descobertes",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-06-02T10:01:00.000"
	},
	{
		":id": "row-au8y~y3en_u9sd",
		":version": "rv-g425_gvbd.sgk8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Punt de lectura Ibañez Escofet",
		"indicador_refugi": "170427|PUNT_DE_LECTURA_IBANEZ_ESCOFET",
		"municipi": "Capmany",
		"codi_municipi": "170427",
		"latitud": "42.37355551",
		"longitud": "2.92079081",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Major, 8",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-i8sn~cdxj.tk7c",
		":version": "rv-tkq5-h7qa~dafe",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "170427|PISCINA_MUNICIPAL",
		"municipi": "Capmany",
		"codi_municipi": "170427",
		"latitud": "42.37306453",
		"longitud": "2.92274011",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Orient, 8",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-wzrw~uasn~r25n",
		":version": "rv-p945.7v7x.k4k7",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de la gent gran",
		"indicador_refugi": "080462|CASAL_DE_LA_GENT_GRAN",
		"municipi": "Cardedeu",
		"codi_municipi": "080462",
		"latitud": "41.6371375",
		"longitud": "2.35544466",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Av. Rei en Jaume, 55",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-uaej-babm~itf4",
		":version": "rv-pa8i_y7bv.p3mq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal d’avis de la Fàbrica Vella-Sala polivalent Tèxtil Rase",
		"indicador_refugi": "080462|CASAL_D_AVIS_DE_LA_FABRICA_VELLA_SALA_POLIVALENT_TEXTIL_RASE",
		"municipi": "Cardedeu",
		"codi_municipi": "080462",
		"latitud": "41.6381964",
		"longitud": "2.3628596",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Llinars, 61 (Pl. de les dones treballadores)",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-c95w_43pu_3p5d",
		":version": "rv-n7fi~tetc~gdhs",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Marc de Vilalba",
		"indicador_refugi": "080462|BIBLIOTECA_MARC_DE_VILALBA",
		"municipi": "Cardedeu",
		"codi_municipi": "080462",
		"latitud": "41.63951798",
		"longitud": "2.36093097",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Dr. Klein, 101",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-2c2b~squt.ust5",
		":version": "rv-jgx7-msij-t55r",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Museu Arxiu Tomàs Balvey",
		"indicador_refugi": "080462|MUSEU_ARXIU_TOMAS_BALVEY",
		"municipi": "Cardedeu",
		"codi_municipi": "080462",
		"latitud": "41.63792548",
		"longitud": "2.35487785",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Doctor Daurella, 1",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-8hzf~hwsq~7he2",
		":version": "rv-jcw8_vcs8-haxd",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Fàbrica de Cultura- Tèxtil Rase",
		"indicador_refugi": "080462|FABRICA_DE_CULTURA_TEXTIL_RASE",
		"municipi": "Cardedeu",
		"codi_municipi": "080462",
		"latitud": "41.63801664",
		"longitud": "2.36258306",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Llinars, 61",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-xb2s-9pms.zb5e",
		":version": "rv-jxek_43gg_kc9m",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Espai jove La Paki",
		"indicador_refugi": "080462|ESPAI_JOVE_LA_PAKI",
		"municipi": "Cardedeu",
		"codi_municipi": "080462",
		"latitud": "41.63733185705523",
		"longitud": "2.3614781833252434",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Av. Rei en Jaume 116",
		"informacio_web": "https://www.espaijovelapaki.cat/",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-29T11:43:00.000"
	},
	{
		":id": "row-epe8.vd4j_mm3y",
		":version": "rv-kvuh.njyp_3gmy",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Mercat Municipal de Cardedeu",
		"indicador_refugi": "080462|MERCAT_MUNICIPAL_DE_CARDEDEU",
		"municipi": "Cardedeu",
		"codi_municipi": "080462",
		"latitud": "41.64018162344824",
		"longitud": "2.3560179103160794",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carretera de Cànoves, 28",
		"informacio_web": "De dilluns a dissabte de 8 a 14h i divendres tarda de 17 a 20h",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-29T11:48:00.000"
	},
	{
		":id": "row-tiyd.y7bm.p3ff",
		":version": "rv-msxx-vw8b~8ztu",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "AAVV Barri de la Granada",
		"indicador_refugi": "080462|AAVV_BARRI_DE_LA_GRANADA",
		"municipi": "Cardedeu",
		"codi_municipi": "080462",
		"latitud": "41.637305983593905",
		"longitud": "2.365414198664757",
		"accessibilitat": "No",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Joaquim Blume, 9",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-29T11:50:00.000"
	},
	{
		":id": "row-wrwm.zhit_98ss",
		":version": "rv-rcjy-2uaq_zd6h",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina exterior GIM10",
		"indicador_refugi": "080462|PISCINA_EXTERIOR_GIM10",
		"municipi": "Cardedeu",
		"codi_municipi": "080462",
		"latitud": "41.64952860832077",
		"longitud": "2.3633481949769077",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Avinguda Jaume Morató 22",
		"informacio_web": "https://gim10.cat/",
		"tipologia": "Piscines descobertes",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-29T11:53:00.000"
	},
	{
		":id": "row-abpq-kptc_m9c5",
		":version": "rv-4y5y_gugf_85vy",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Font lúdica Cardedeu",
		"indicador_refugi": "080462|FONT_LUDICA_CARDEDEU",
		"municipi": "Cardedeu",
		"codi_municipi": "080462",
		"latitud": "41.63851856280014",
		"longitud": "2.373231612160162",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Parc Bellavista",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-29T11:54:00.000"
	},
	{
		":id": "row-q2wq.dxf7.iav5",
		":version": "rv-3t6v_gt3g_2ug8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Cardona",
		"indicador_refugi": "080478|CASAL_CIVIC_I_COMUNITARI_CARDONA",
		"municipi": "Cardona",
		"codi_municipi": "080478",
		"latitud": "41.9127851",
		"longitud": "1.6750597",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. de Pau Casals, s/n",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-69i4-mnfy.awv6",
		":version": "rv-a5db-336w_ny74",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Sala Galà",
		"indicador_refugi": "170448|SALA_GALA",
		"municipi": "Cassà de la Selva",
		"codi_municipi": "170448",
		"latitud": "41.88906137",
		"longitud": "2.87517145",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. del Molí, 9, 17244 Cassà de la Selva, Girona",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-ynmq-728p_48is",
		":version": "rv-nym6-38t4.8rq5",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscines de Casserres",
		"indicador_refugi": "080497|PISCINES_DE_CASSERRES",
		"municipi": "Casserres",
		"codi_municipi": "080497",
		"latitud": "42.01343951",
		"longitud": "1.8331343",
		"accessibilitat": "No",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Ctra. de l'Espunyola, s/n",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-rv9q-kv6v~4cne",
		":version": "rv-442m_vcmg-xb2j",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Mercat municipal",
		"indicador_refugi": "080517|MERCAT_MUNICIPAL",
		"municipi": "Castellar del Vallès",
		"codi_municipi": "080517",
		"latitud": "41.6163319",
		"longitud": "2.08767706",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Pl. mercat, s/n",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-8sxn~76fz-33ic",
		":version": "rv-eat6_sbx3-viqk",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Catalunya",
		"indicador_refugi": "080517|CASAL_CATALUNYA",
		"municipi": "Castellar del Vallès",
		"codi_municipi": "080517",
		"latitud": "41.61145983",
		"longitud": "2.0915889",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Prat de la Riba, 17",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-zz9g~sf29-bhps",
		":version": "rv-2uc9-y5ve_dr7a",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal Casino del Racó",
		"indicador_refugi": "080517|PISCINA_MUNICIPAL_CASINO_DEL_RACO",
		"municipi": "Castellar del Vallès",
		"codi_municipi": "080517",
		"latitud": "41.62169259",
		"longitud": "2.06878386",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Brutau, 19",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-3d9s~3ugw_qncs",
		":version": "rv-q6ew_fn6e_uhce",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Edifici El Mirador",
		"indicador_refugi": "080517|EDIFICI_EL_MIRADOR",
		"municipi": "Castellar del Vallès",
		"codi_municipi": "080517",
		"latitud": "41.61646793",
		"longitud": "2.08725318",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Mirador, s/n",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-vxvj~hps7_dak3",
		":version": "rv-6z7t_u985.gk97",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal Puigvert",
		"indicador_refugi": "080517|PISCINA_MUNICIPAL_PUIGVERT",
		"municipi": "Castellar del Vallès",
		"codi_municipi": "080517",
		"latitud": "41.61385646",
		"longitud": "2.09166949",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. País Valencià, 1",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-etnb-7gyc~wtph",
		":version": "rv-fdcg_pshb-6k53",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Penya arlequinada sports",
		"indicador_refugi": "080517|PENYA_ARLEQUINADA_SPORTS",
		"municipi": "Castellar del Vallès",
		"codi_municipi": "080517",
		"latitud": "41.59377989",
		"longitud": "2.06563694",
		"accessibilitat": "No",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Ca n'avellaneda, 4",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-ap3z-28ih_nccg",
		":version": "rv-ybcu.56su-kgrs",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca municipal Antoni Tort",
		"indicador_refugi": "080517|BIBLIOTECA_MUNICIPAL_ANTONI_TORT",
		"municipi": "Castellar del Vallès",
		"codi_municipi": "080517",
		"latitud": "41.61542334",
		"longitud": "2.08789077",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Sala Boadella, 6",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-skvw-2qj3-iwdp",
		":version": "rv-y4bs-grny.f3rq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal gent gran plaça major",
		"indicador_refugi": "080517|CASAL_GENT_GRAN_PLACA_MAJOR",
		"municipi": "Castellar del Vallès",
		"codi_municipi": "080517",
		"latitud": "41.61695682",
		"longitud": "2.08704093",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Major, s/n",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-cs6v_97fh_vx5n",
		":version": "rv-rth8.fica.javx",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jocs d'aigua platja de la balena",
		"indicador_refugi": "080517|JOCS_D_AIGUA_PLATJA_DE_LA_BALENA",
		"municipi": "Castellar del Vallès",
		"codi_municipi": "080517",
		"latitud": "41.61218561",
		"longitud": "2.09092253",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Prat de la Riba, 13",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-iuhv~w4rj.h8g2",
		":version": "rv-dha2.uzkb-dza8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Cal Salvador",
		"indicador_refugi": "080556|CAL_SALVADOR",
		"municipi": "Castellcir",
		"codi_municipi": "080556",
		"latitud": "41.760466",
		"longitud": "2.149922",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Major, 37",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-4fxe.m4ku_sk2i",
		":version": "rv-mzp9~gr5u.ap77",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de la Quintana",
		"indicador_refugi": "080556|PARC_DE_LA_QUINTANA",
		"municipi": "Castellcir",
		"codi_municipi": "080556",
		"latitud": "41.764659",
		"longitud": "2.147096",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. Moianès, s/n",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-v2xg.74ag.kjh8",
		":version": "rv-vbuj~hhjp-dyhc",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "PARC LA GORNAL",
		"indicador_refugi": "080581|PARC_LA_GORNAL",
		"municipi": "Castellet i la Gornal",
		"codi_municipi": "080581",
		"latitud": "41.253845",
		"longitud": "1.590039",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Cr. del Camp. LA  GORNAL",
		"informacio_web": "Obert de forma permanent",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-08T13:49:00.000"
	},
	{
		":id": "row-b9ei~hz3v.7drq",
		":version": "rv-6ig2_hx2b-9f3h",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "PISCINA DE CLARIANA",
		"indicador_refugi": "080581|PISCINA_DE_CLARIANA",
		"municipi": "Castellet i la Gornal",
		"codi_municipi": "080581",
		"latitud": "41.245939",
		"longitud": "1.616942",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Cr. Sant Jaume. Clariana",
		"informacio_web": "https://www.castelletilagornal.cat/",
		"tipologia": "Piscines descobertes",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-08T13:53:00.000"
	},
	{
		":id": "row-b2bw_n53y.bj3j",
		":version": "rv-eqqv~6bi5.jpqe",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "080608|PISCINA_MUNICIPAL",
		"municipi": "Castellfollit de Riubregós",
		"codi_municipi": "080608",
		"latitud": "41.77407637",
		"longitud": "1.43682395",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Escorrals",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-zqfj_h65x~mva3",
		":version": "rv-dmki~md4x_k65w",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Edifici ajuntament",
		"indicador_refugi": "080594|EDIFICI_AJUNTAMENT",
		"municipi": "Castellfollit del Boix",
		"codi_municipi": "080594",
		"latitud": "41.66678253",
		"longitud": "1.68320373",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Ajuntament, s/n,  08255 Castellfollit del Boix",
		"tipologia": "Sala polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-rnnt-u689~h3ms",
		":version": "rv-4yu3~astp.4tsb",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de gent gran",
		"indicador_refugi": "250680|CASAL_DE_GENT_GRAN",
		"municipi": "Castellnou de Seana",
		"codi_municipi": "250680",
		"latitud": "41.64825099",
		"longitud": "0.97117649",
		"accessibilitat": "No",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Major, 1",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-p3f8.uig8~dmdy",
		":version": "rv-f5dn~9wjj_xmtu",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscines municipals",
		"indicador_refugi": "250680|PISCINES_MUNICIPALS",
		"municipi": "Castellnou de Seana",
		"codi_municipi": "250680",
		"latitud": "41.6429494",
		"longitud": "0.9698684",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Ctra. Diputació, s/n",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-99kg.pbsv-dnp5",
		":version": "rv-fudh.e6nu_8jqe",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Cooperativa",
		"indicador_refugi": "080636|COOPERATIVA",
		"municipi": "Castellolí",
		"codi_municipi": "080636",
		"latitud": "41.598281",
		"longitud": "1.700475",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "av Unió 29",
		"informacio_web": "Horari consultable al ajuntament",
		"tipologia": "Sala Polivalent",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-11T10:27:00.000"
	},
	{
		":id": "row-qqd4.i8tr_8exq",
		":version": "rv-65ih~b6xw-ry67",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal de Castellolí",
		"indicador_refugi": "080636|PISCINA_MUNICIPAL_DE_CASTELLOLI",
		"municipi": "Castellolí",
		"codi_municipi": "080636",
		"latitud": "41.597793",
		"longitud": "1.70219",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer de la Font, 08719 Castellolí, Barcelona",
		"tipologia": "Piscines descobertes",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-11T10:31:00.000"
	},
	{
		":id": "row-seff.vac8.uixg",
		":version": "rv-pet9.drsm.37b6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Escoles Velles (sala Polivalent)",
		"indicador_refugi": "080641|ESCOLES_VELLES_SALA_POLIVALENT",
		"municipi": "Castellterçol",
		"codi_municipi": "080641",
		"latitud": "41.75075335",
		"longitud": "2.12005363",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. dels estudis, s/n",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-guji~axf4~7grt",
		":version": "rv-ivzd~xzku~65re",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jardins 1 D'octubre",
		"indicador_refugi": "080641|JARDINS_1_D_OCTUBRE",
		"municipi": "Castellterçol",
		"codi_municipi": "080641",
		"latitud": "41.75132341",
		"longitud": "2.11971074",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Prat de la Riba",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-fx5f_qhi7_3erz",
		":version": "rv-4bke-ski5.aqpx",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Edifici del Bosquet De Can Sedó",
		"indicador_refugi": "080641|EDIFICI_DEL_BOSQUET_DE_CAN_SEDO",
		"municipi": "Castellterçol",
		"codi_municipi": "080641",
		"latitud": "41.74967913",
		"longitud": "2.12013094",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Rocacorba, s/n (dins del Bosquet de Can Sedó)",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-xsih_hpeb_tnc6",
		":version": "rv-ppm3_s8x7_ddaa",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Complex de les piscines municipals d'estiu",
		"indicador_refugi": "080641|COMPLEX_DE_LES_PISCINES_MUNICIPALS_D_ESTIU",
		"municipi": "Castellterçol",
		"codi_municipi": "080641",
		"latitud": "41.75476113",
		"longitud": "2.12249464",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Sant Jordi, s/n",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-yqqi-63gj-yrxd",
		":version": "rv-aey2.cipu.42vw",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bosquet de Can Sedó",
		"indicador_refugi": "080641|BOSQUET_DE_CAN_SEDO",
		"municipi": "Castellterçol",
		"codi_municipi": "080641",
		"latitud": "41.75020705",
		"longitud": "2.12016282",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Rocacorba, s/n",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-dv6n_kzc2-kt44",
		":version": "rv-st9q~esyw_9iwk",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Espai de lectura",
		"indicador_refugi": "080641|ESPAI_DE_LECTURA",
		"municipi": "Castellterçol",
		"codi_municipi": "080641",
		"latitud": "41.75148673",
		"longitud": "2.12039359",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. vella, 5",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-wt9h_gdbs.vx3i",
		":version": "rv-u2bj~aswr_hwz8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Pavelló municipal d'esports Joan Casanovas",
		"indicador_refugi": "080641|PAVELLO_MUNICIPAL_DESPORTS_JOAN_CASANOVAS",
		"municipi": "Castellterçol",
		"codi_municipi": "080641",
		"latitud": "41.74968011740977",
		"longitud": "2.1184140761405588",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "c/ Diputació s/n",
		"informacio_web": "https://www.castelltersol.cat/",
		"tipologia": "Pavelló Esportiu",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-15T14:07:00.000"
	},
	{
		":id": "row-paty_xp9a-urv5",
		":version": "rv-rnds_j9yg~6h8d",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jardins de Cal Recader",
		"indicador_refugi": "080641|JARDINS_DE_CAL_RECADER",
		"municipi": "Castellterçol",
		"codi_municipi": "080641",
		"latitud": "41.75135605044313",
		"longitud": "2.120593494980946",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Accés per les escoles velles, plaça dels Estudis",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-16T12:08:00.000"
	},
	{
		":id": "row-47mu~ef5c.trhe",
		":version": "rv-27h6~kap6_r7c3",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "430424|PISCINA_MUNICIPAL",
		"municipi": "Castellvell del Camp",
		"codi_municipi": "430424",
		"latitud": "41.17975873",
		"longitud": "1.09936283",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Ctra. de Castellvell del Camp a Reus, 1",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-nxq7~f5fs~39te",
		":version": "rv-a47g-n6hk~8dwf",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca municipal Marina Capdevila",
		"indicador_refugi": "430424|BIBLIOTECA_MUNICIPAL_MARINA_CAPDEVILA",
		"municipi": "Castellvell del Camp",
		"codi_municipi": "430424",
		"latitud": "41.18127172",
		"longitud": "1.09608697",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Sant Joaquim, 1",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-z9c6_22j3_m9hc",
		":version": "rv-cks8.85rj-55nh",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal d'entitats",
		"indicador_refugi": "430424|CASAL_D_ENTITATS",
		"municipi": "Castellvell del Camp",
		"codi_municipi": "430424",
		"latitud": "41.18072642",
		"longitud": "1.09801469",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Pompeu Fabra, 1",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-ekte-ukht.ehym",
		":version": "rv-xm2d~j9ks.xrzr",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "080654|PISCINA_MUNICIPAL",
		"municipi": "Castellví de la Marca",
		"codi_municipi": "080654",
		"latitud": "41.32670052",
		"longitud": "1.61618937",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de l'esport, s/n",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-ijrq-9myn.vqw7",
		":version": "rv-tc9v.c4he_6gnv",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre social",
		"indicador_refugi": "080667|CENTRE_SOCIAL",
		"municipi": "Castellví de Rosanes",
		"codi_municipi": "080667",
		"latitud": "41.452391",
		"longitud": "1.898324",
		"accessibilitat": "No",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Av. Mare de Déu de Montserrat, 29 (sala 2 - planta superior)",
		"informacio_web": "https://www.castellviderosanes.cat/",
		"tipologia": "Sala Polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-06-17T11:38:00.000"
	},
	{
		":id": "row-i4xq.7p66~cf9b",
		":version": "rv-mjud.jnk4~f3kt",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic de Can Sunyer i Valldaina",
		"indicador_refugi": "080667|CENTRE_CIVIC_DE_CAN_SUNYER_I_VALLDAINA",
		"municipi": "Castellví de Rosanes",
		"codi_municipi": "080667",
		"latitud": "41.456128",
		"longitud": "1.949213",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Sant Llorenç de Morunys, 6 bis",
		"informacio_web": "https://www.castellviderosanes.cat/",
		"tipologia": "Centre Cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-06-17T11:40:00.000"
	},
	{
		":id": "row-bpi6-y52d_sy2k",
		":version": "rv-z2ve-euhj-f5dd",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal",
		"indicador_refugi": "080667|CASAL",
		"municipi": "Castellví de Rosanes",
		"codi_municipi": "080667",
		"latitud": "41.44978098",
		"longitud": "1.90003081",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça d'Europa, s/n",
		"informacio_web": "https://www.castellviderosanes.cat/",
		"tipologia": "Sala Polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-06-17T11:42:00.000"
	},
	{
		":id": "row-nt6u_u2ts~iyw4",
		":version": "rv-uakx-fcrj_tzi8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cultural",
		"indicador_refugi": "430430|CENTRE_CULTURAL",
		"municipi": "Catllar, el",
		"codi_municipi": "430430",
		"latitud": "41.17575238",
		"longitud": "1.32765961",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. de l'1 d'Octubre",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-daz6-bb2v-fvas",
		":version": "rv-rvjc.8wxf~apk3",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Sala polivalent Urb. Pins Manous",
		"indicador_refugi": "430430|SALA_POLIVALENT_URB_PINS_MANOUS",
		"municipi": "Catllar, el",
		"codi_municipi": "430430",
		"latitud": "41.15033865",
		"longitud": "1.27579549",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Barcelonès, 5, Urb. Pins Manous",
		"tipologia": "Sala polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-giec.zx2v_etwu",
		":version": "rv-ya6t.a64v.257y",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal Torre d'en Guiu",
		"indicador_refugi": "430430|PISCINA_MUNICIPAL_TORRE_D_EN_GUIU",
		"municipi": "Catllar, el",
		"codi_municipi": "430430",
		"latitud": "41.1766407",
		"longitud": "1.3281783",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Masieta Queralt, 506",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-wyd6~wtab-ukpw",
		":version": "rv-rq3x_q25g~hcft",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal Mas de Pallarès",
		"indicador_refugi": "430430|PISCINA_MUNICIPAL_MAS_DE_PALLARES",
		"municipi": "Catllar, el",
		"codi_municipi": "430430",
		"latitud": "41.17919964",
		"longitud": "1.28361495",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "No",
		"adreca": "Av. Tercera, 4, Urb. Mas de Pallarès",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-tc8q~57sg.cs3k",
		":version": "rv-ntux-mt8r~3bqy",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Llar de jubilats La Fraternal",
		"indicador_refugi": "171899|LLAR_DE_JUBILATS_LA_FRATERNAL",
		"municipi": "Cellera de Ter, la",
		"codi_municipi": "171899",
		"latitud": "41.96719705",
		"longitud": "2.62188538",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. Montserrat, 20",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-8ibc_3r7r-q2ng",
		":version": "rv-qna4-uypw_pyjh",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal gent gran can Ponac",
		"indicador_refugi": "170499|CASAL_GENT_GRAN_CAN_PONAC",
		"municipi": "Celrà",
		"codi_municipi": "170499",
		"latitud": "42.02763733",
		"longitud": "2.87593168",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. de la Fàbrica, 31",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-06-11T10:32:00.000"
	},
	{
		":id": "row-c9vj-je7q.efkp",
		":version": "rv-9bzz-tvvd-tbhu",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca de Celrà",
		"indicador_refugi": "170499|BIBLIOTECA_DE_CELRA",
		"municipi": "Celrà",
		"codi_municipi": "170499",
		"latitud": "42.0269",
		"longitud": "2.8737",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Ctra. de Juià, 46",
		"tipologia": "Biblioteca",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-11T11:23:00.000"
	},
	{
		":id": "row-n5vk_dzdb_e2g3",
		":version": "rv-gi9q_q5qn_smcr",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "082687|PISCINA_MUNICIPAL",
		"municipi": "Cercs",
		"codi_municipi": "082687",
		"latitud": "42.14994735",
		"longitud": "1.8584818",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. de Sant Salvador, 2B, Sant Jordi de Cercs",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-xfzw_uddc-rg45",
		":version": "rv-bhmv~whsd.hm89",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Complex esportiu municipal",
		"indicador_refugi": "250729|COMPLEX_ESPORTIU_MUNICIPAL",
		"municipi": "Cervera",
		"codi_municipi": "250729",
		"latitud": "41.67732713",
		"longitud": "1.2715636",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. de l'esport, 1",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-f5mp.4z22_t7nv",
		":version": "rv-s4ff-67ig.g4xk",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Cervera",
		"indicador_refugi": "250729|CASAL_CIVIC_I_COMUNITARI_CERVERA",
		"municipi": "Cervera",
		"codi_municipi": "250729",
		"latitud": "42.0150629",
		"longitud": "1.0375184",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de Manuel Ibarra, s/n (cant. Pare Claret)",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-uckq~hsgd~dahp",
		":version": "rv-e3i9_gm8v-2ajz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CLAUSTRE MONESTIR",
		"indicador_refugi": "170502|CLAUSTRE_MONESTIR",
		"municipi": "Cervià de Ter",
		"codi_municipi": "170502",
		"latitud": "42.0676",
		"longitud": "2.9123",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "No",
		"lavabo": "No",
		"adreca": "C/ PRIORAT, 29",
		"informacio_web": "Horaris oficina ajuntament",
		"tipologia": "Ajuntament / Equipament Administratiu",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-08T18:24:00.000"
	},
	{
		":id": "row-bvtc.j6uh.i5yi",
		":version": "rv-q8i5_ztkt-kn9i",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic El Trull",
		"indicador_refugi": "170519|CENTRE_CIVIC_EL_TRULL",
		"municipi": "Cistella",
		"codi_municipi": "170519",
		"latitud": "42.26832756",
		"longitud": "2.84745429",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Major, 4",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-99v7_52w9-qzyb",
		":version": "rv-xp8r-44n5-x9z6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "170519|PISCINA_MUNICIPAL",
		"municipi": "Cistella",
		"codi_municipi": "170519",
		"latitud": "42.27014629",
		"longitud": "2.84741268",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Sant Baldiri",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-avi9.7r2c-zfm6",
		":version": "rv-3ac6.gj36~ieik",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Sala Polivalent de l'Ajuntament",
		"indicador_refugi": "250772|SALA_POLIVALENT_DE_LAJUNTAMENT",
		"municipi": "Coll de Nargó",
		"codi_municipi": "250772",
		"latitud": "42.173639038015146",
		"longitud": "1.3156677545116096",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça de l'ajuntament, 1 (baixos)",
		"tipologia": "Sala Polivalent",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-09T10:37:00.000"
	},
	{
		":id": "row-5jk7.ywky-yxuz",
		":version": "rv-uxi8-epkb_nfzv",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "250772|PISCINA_MUNICIPAL",
		"municipi": "Coll de Nargó",
		"codi_municipi": "250772",
		"latitud": "42.17319526106643",
		"longitud": "1.311955055397028",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Xavier Marot",
		"tipologia": "Piscines descobertes",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-09T10:39:00.000"
	},
	{
		":id": "row-6qkd-p6yt~npbn",
		":version": "rv-bjzu_5as4.imbf",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Local de Gent Gran",
		"indicador_refugi": "250772|LOCAL_DE_GENT_GRAN",
		"municipi": "Coll de Nargó",
		"codi_municipi": "250772",
		"latitud": "42.17350476675045",
		"longitud": "1.3156571324184547",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "No",
		"lavabo": "No",
		"adreca": "Plaça de l'ajuntament, 1  - edifici annex a l'ajuntament",
		"tipologia": "Casal de Gent Gran",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-09T10:41:00.000"
	},
	{
		":id": "row-6sb4_mp82_xb6t",
		":version": "rv-rrn9-xrzu.2vc5",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Sala Dinosfera",
		"indicador_refugi": "250772|SALA_DINOSFERA",
		"municipi": "Coll de Nargó",
		"codi_municipi": "250772",
		"latitud": "42.173658299691645",
		"longitud": "1.3122050410162356",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Xavier Marot",
		"tipologia": "Equipament Cultural (teatre, auditori, museu)",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-09T10:42:00.000"
	},
	{
		":id": "row-xkdk.mgnh~hszg",
		":version": "rv-6pxq.94hs_qs2z",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "080692|PISCINA_MUNICIPAL",
		"municipi": "Collbató",
		"codi_municipi": "080692",
		"latitud": "41.56616654",
		"longitud": "1.82452484",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Av. Centenari Amadeu Vives, 38",
		"informacio_web": "www.collbato.cat",
		"tipologia": "Piscines descobertes",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-06-02T11:59:00.000"
	},
	{
		":id": "row-w9gy_yz8j-zjsu",
		":version": "rv-xrgz-bgjp_qhvu",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de cultura - Biblioteca Sibil·la Durfort",
		"indicador_refugi": "080692|CASAL_DE_CULTURA_BIBLIOTECA_SIBIL_LA_DURFORT",
		"municipi": "Collbató",
		"codi_municipi": "080692",
		"latitud": "41.56848695",
		"longitud": "1.82942919",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pg. Mansuet, 9",
		"informacio_web": "www.collbato.cat",
		"tipologia": "Centre Cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-06-02T11:56:00.000"
	},
	{
		":id": "row-ssbd~f3ch-tdkw",
		":version": "rv-9cw6.f7f5_ars9",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CASAL",
		"indicador_refugi": "430458|CASAL",
		"municipi": "Colldejou",
		"codi_municipi": "430458",
		"latitud": "41.09907",
		"longitud": "0.8875",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer de Baix, 42",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-10T12:33:00.000"
	},
	{
		":id": "row-fqnr~kmkt.x3kh",
		":version": "rv-vqru_xkkk_ucar",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "PISCINA MUNICIPAL",
		"indicador_refugi": "430458|PISCINA_MUNICIPAL",
		"municipi": "Colldejou",
		"codi_municipi": "430458",
		"latitud": "41.09903",
		"longitud": "0.88811",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer de Baix SN",
		"tipologia": "Piscines descobertes",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-10T12:36:00.000"
	},
	{
		":id": "row-vcmv_8rxd_jec9",
		":version": "rv-ssb2.3jha~r6zk",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal de Collsuspina",
		"indicador_refugi": "080706|PISCINA_MUNICIPAL_DE_COLLSUSPINA",
		"municipi": "Collsuspina",
		"codi_municipi": "080706",
		"latitud": "41.82685382",
		"longitud": "2.17676259",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de l'esport",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-md2j-n9ki_q6av",
		":version": "rv-z5w3_6s3n~9u9f",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic",
		"indicador_refugi": "170558|CENTRE_CIVIC",
		"municipi": "Colomers",
		"codi_municipi": "170558",
		"latitud": "42.08732289",
		"longitud": "2.98443797",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Catalunya, s/n",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-bab6_vf7p_hwvk",
		":version": "rv-gb5u_ys4e_hexr",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Local social - piscina municipal",
		"indicador_refugi": "251636|LOCAL_SOCIAL_PISCINA_MUNICIPAL",
		"municipi": "Coma i la Pedra, la",
		"codi_municipi": "251636",
		"latitud": "42.17856958",
		"longitud": "1.59085288",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Ctra. de Tuixent, 13",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-pfdw-ygdz~t8rg",
		":version": "rv-47hq_gmrx.j8rr",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bar local social de Conesa",
		"indicador_refugi": "430461|BAR_LOCAL_SOCIAL_DE_CONESA",
		"municipi": "Conesa",
		"codi_municipi": "430461",
		"latitud": "41.518616",
		"longitud": "1.29139",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça Major 5, 43427 Conesa",
		"informacio_web": "De dimarts a diumenge de 8 a 20h",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-12T13:07:00.000"
	},
	{
		":id": "row-p9cd~dtqu~6s8f",
		":version": "rv-9emi_hkb3~y7ut",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca municipal de Constantí",
		"indicador_refugi": "430477|BIBLIOTECA_MUNICIPAL_DE_CONSTANTI",
		"municipi": "Constantí",
		"codi_municipi": "430477",
		"latitud": "41.15346752",
		"longitud": "1.21174107",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. de l'hospital, 1",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-wjr6-9b46.hp7g",
		":version": "rv-jdk2-c5p5~yi7g",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Sala polivalent",
		"indicador_refugi": "080713|SALA_POLIVALENT",
		"municipi": "Copons",
		"codi_municipi": "080713",
		"latitud": "41.63631484",
		"longitud": "1.51925496",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Sala Polivalent, 08289, Copons, Barcelona",
		"tipologia": "Sala polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-yxqc~3v4f.sisv",
		":version": "rv-89zh~r4bj-98zc",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "080713|PISCINA_MUNICIPAL",
		"municipi": "Copons",
		"codi_municipi": "080713",
		"latitud": "41.63678861",
		"longitud": "1.51968407",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Folquer a Jorba, s/n, Copons",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-9ufg~iazq_7e2v",
		":version": "rv-v5h3_kb5z.c4h9",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "BIBLIOTECA MUNICIPAL CAN BARÓ",
		"indicador_refugi": "080728|BIBLIOTECA_MUNICIPAL_CAN_BARO",
		"municipi": "Corbera de Llobregat",
		"codi_municipi": "080728",
		"latitud": "41.415141",
		"longitud": "1.931187",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "CARRER DE SANT SALVADOR, 25",
		"informacio_web": "https://bibliotecavirtual.diba.cat/es/corbera-de-llobregat-biblioteca-can-baro",
		"tipologia": "Biblioteca",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-09T14:47:00.000"
	},
	{
		":id": "row-tag6~xg6f-95au",
		":version": "rv-bb6h_y998-qde2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CASAL DE LA GENT GRAN LES MAGNÒLIES",
		"indicador_refugi": "080728|CASAL_DE_LA_GENT_GRAN_LES_MAGNOLIES",
		"municipi": "Corbera de Llobregat",
		"codi_municipi": "080728",
		"latitud": "41.413052",
		"longitud": "1.928214",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "CARRER PROGRÉS, 1",
		"informacio_web": "https://www.corberadellobregat.cat/municipi/equipaments/casal-de-la-gent-gran-les-magnolies-.html",
		"tipologia": "Casal de Gent Gran",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-09T14:50:00.000"
	},
	{
		":id": "row-2tfj~2bbx~w6ui",
		":version": "rv-7xi2~xsb9~uzu6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "PARC DEL CARRER PAU BRUNA",
		"indicador_refugi": "080728|PARC_DEL_CARRER_PAU_BRUNA",
		"municipi": "Corbera de Llobregat",
		"codi_municipi": "080728",
		"latitud": "41.415196464236004",
		"longitud": "1.9309388694302372",
		"accessibilitat": "Sí",
		"aigua": "No",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "CARRER DE SANT ANTONI, 24",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-10T11:17:00.000"
	},
	{
		":id": "row-yvba.ea6q.cq4x",
		":version": "rv-8c2b_gcis_fyix",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "PARC DE LES PALMERES",
		"indicador_refugi": "080728|PARC_DE_LES_PALMERES",
		"municipi": "Corbera de Llobregat",
		"codi_municipi": "080728",
		"latitud": "41.41683534891275",
		"longitud": "1.9207141082401706",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "CARRER DEL RAVAL, 26",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-10T11:23:00.000"
	},
	{
		":id": "row-dmm9-4yqz_strj",
		":version": "rv-bg8m~a66t~z3ck",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "PARC MIQUEL PARTÍ I POL",
		"indicador_refugi": "080728|PARC_MIQUEL_PARTI_I_POL",
		"municipi": "Corbera de Llobregat",
		"codi_municipi": "080728",
		"latitud": "41.415135406532386",
		"longitud": "1.9231559524208195",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "CARRER DE JOSEP TARRADELLES, 24",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-10T11:24:00.000"
	},
	{
		":id": "row-r3qd~3qia.xxpq",
		":version": "rv-kfip~57wc_zpi4",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca municipal",
		"indicador_refugi": "250788|BIBLIOTECA_MUNICIPAL",
		"municipi": "Corbins",
		"codi_municipi": "250788",
		"latitud": "41.69",
		"longitud": "0.695",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pl. de la Sardana, 3",
		"informacio_web": "https://www.corbins.cat/ca/administracio/ajuntamentcorbins/serveis-municipals/biblioteca/115161.html",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-06-01T12:10:00.000"
	},
	{
		":id": "row-tq2y_ukey.hmwq",
		":version": "rv-63h3-bc7q-9949",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal d'avis",
		"indicador_refugi": "250788|CASAL_D_AVIS",
		"municipi": "Corbins",
		"codi_municipi": "250788",
		"latitud": "41.69059645",
		"longitud": "0.69279113",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Pl. de la Vila, s/n",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-6auu.wysz-dnx5",
		":version": "rv-k29a~dkqe_fphn",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Sala d'exposicions 1 d'octubre",
		"indicador_refugi": "430496|SALA_D_EXPOSICIONS_1_D_OCTUBRE",
		"municipi": "Cornudella de Montsant",
		"codi_municipi": "430496",
		"latitud": "41.26483199",
		"longitud": "0.90520501",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Comte de Rius, 10",
		"tipologia": "Sala polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-xqzx-bpca~gwyc",
		":version": "rv-udgi.vma6.fh8z",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscines municipals",
		"indicador_refugi": "430496|PISCINES_MUNICIPALS",
		"municipi": "Cornudella de Montsant",
		"codi_municipi": "430496",
		"latitud": "41.26733061",
		"longitud": "0.90437623",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. del Bassot, s/n",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-yvrj-sysj~hhw9",
		":version": "rv-rzkn.adjj-ku6u",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Delta de l'Ebre",
		"indicador_refugi": "439018|BIBLIOTECA_DELTA_DE_L_EBRE",
		"municipi": "Deltebre",
		"codi_municipi": "439018",
		"latitud": "40.72123953",
		"longitud": "0.72165573",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. 1 d'octubre",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-nip5~ku5k~f3h8",
		":version": "rv-ejzp.9vt7_dk97",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc del riu",
		"indicador_refugi": "439018|PARC_DEL_RIU",
		"municipi": "Deltebre",
		"codi_municipi": "439018",
		"latitud": "40.72130681",
		"longitud": "0.69973254",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Parc del Riu",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-wph4.r3kt_abj9",
		":version": "rv-yfye.ucmc_h8ty",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre esportiu del Delta",
		"indicador_refugi": "439018|CENTRE_ESPORTIU_DEL_DELTA",
		"municipi": "Deltebre",
		"codi_municipi": "439018",
		"latitud": "40.72478676",
		"longitud": "0.72649401",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. del Canal",
		"tipologia": "Poliesportiu",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-cb38.f5gn-rpaw",
		":version": "rv-njed.btyc~wtnd",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Zona pícnic Passeig Marítim",
		"indicador_refugi": "439018|ZONA_PICNIC_PASSEIG_MARITIM",
		"municipi": "Deltebre",
		"codi_municipi": "439018",
		"latitud": "40.72822369",
		"longitud": "0.83996974",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pg. Marítim - Riumar",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-5ei8.szyw~k76s",
		":version": "rv-xr8r-9x8j_mik4",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc José del Pas",
		"indicador_refugi": "439018|PARC_JOSE_DEL_PAS",
		"municipi": "Deltebre",
		"codi_municipi": "439018",
		"latitud": "40.71152759",
		"longitud": "0.73976364",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pg. Paco del Chapero",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-xzcv_ruv6~kjih",
		":version": "rv-59e2_mtu5.vu36",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Molí dels Mirons",
		"indicador_refugi": "439018|MOLI_DELS_MIRONS",
		"municipi": "Deltebre",
		"codi_municipi": "439018",
		"latitud": "40.72392967",
		"longitud": "0.68225204",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Reis Catòlics",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-3grk.86k2-ubzd",
		":version": "rv-ik5j-pxuq_ht7r",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça Eliseo Vives - Riumar",
		"indicador_refugi": "439018|PLACA_ELISEO_VIVES_RIUMAR",
		"municipi": "Deltebre",
		"codi_municipi": "439018",
		"latitud": "40.72379212",
		"longitud": "0.83788163",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Pl. Eliseo Vives",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-hwfi.bxs7-kugk",
		":version": "rv-9byx~mp2h~y4gy",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Instal·lacions esportives Claudio Flores",
		"indicador_refugi": "439018|INSTAL_LACIONS_ESPORTIVES_CLAUDIO_FLORES",
		"municipi": "Deltebre",
		"codi_municipi": "439018",
		"latitud": "40.72730123",
		"longitud": "0.70044645",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. de la Pau",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-xxmt_vagh-cmg6",
		":version": "rv-j7ej~jsf3-d5b8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Pont Lo Passador",
		"indicador_refugi": "439018|PONT_LO_PASSADOR",
		"municipi": "Deltebre",
		"codi_municipi": "439018",
		"latitud": "40.71415675",
		"longitud": "0.71784204",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Pont Lo Passador",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-74z3~fgag.6f58",
		":version": "rv-qjmq~8yxz~kgms",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Entorn del Pou de Glaç de Canyamars",
		"indicador_refugi": "080752|ENTORN_DEL_POU_DE_GLAC_DE_CANYAMARS",
		"municipi": "Dosrius",
		"codi_municipi": "080752",
		"latitud": "41.60415043",
		"longitud": "2.45435641",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "No",
		"adreca": "Pou de Glaç de Canyamars",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-n9k5_sspy.tdfe",
		":version": "rv-y5qv_f3fj.y2tz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Camins saludables de la Zona esportiva de Can Massuet del Far",
		"indicador_refugi": "080752|CAMINS_SALUDABLES_DE_LA_ZONA_ESPORTIVA_DE_CAN_MASSUET_DEL_FAR",
		"municipi": "Dosrius",
		"codi_municipi": "080752",
		"latitud": "41.61986942",
		"longitud": "2.42754294",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Zona esportiva de Can Massuet del Far",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-24cg-5irm_ykwx",
		":version": "rv-scyc_miap-htj2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Pla del Molinot",
		"indicador_refugi": "080752|PLA_DEL_MOLINOT",
		"municipi": "Dosrius",
		"codi_municipi": "080752",
		"latitud": "41.60119049",
		"longitud": "2.44875576",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Pla del Molinot",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-xtw4_ariw-kgmb",
		":version": "rv-ecxe-r6rd~v2i5",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal del Centre Esportiu de Dosrius",
		"indicador_refugi": "080752|PISCINA_MUNICIPAL_DEL_CENTRE_ESPORTIU_DE_DOSRIUS",
		"municipi": "Dosrius",
		"codi_municipi": "080752",
		"latitud": "41.59763299",
		"longitud": "2.41174605",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. de Can Batlle, 2",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-vurd_b3sq-kwp9",
		":version": "rv-davm.6z9h_rbk5",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Sala de Plens Ajuntament de Dosrius",
		"indicador_refugi": "080752|SALA_DE_PLENS_AJUNTAMENT_DE_DOSRIUS",
		"municipi": "Dosrius",
		"codi_municipi": "080752",
		"latitud": "41.59468696",
		"longitud": "2.40604281",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Sant Antoni, 1",
		"tipologia": "Sala polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-4wqh~vws7.25wx",
		":version": "rv-iwza-ufez-kxan",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça de Can Torres",
		"indicador_refugi": "080752|PLACA_DE_CAN_TORRES",
		"municipi": "Dosrius",
		"codi_municipi": "080752",
		"latitud": "41.59518731",
		"longitud": "2.40820921",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. de Can Torres",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-cbki-eyyr_t2m9",
		":version": "rv-2j5u-42st_84rf",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça de la Germandat",
		"indicador_refugi": "080752|PLACA_DE_LA_GERMANDAT",
		"municipi": "Dosrius",
		"codi_municipi": "080752",
		"latitud": "41.60090734",
		"longitud": "2.44675635",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Pl. de la Germandat",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-6w6e_3gpv.ucfy",
		":version": "rv-mxba_a5mt_7s6u",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina pública municipal de Duesaigües",
		"indicador_refugi": "430537|PISCINA_PUBLICA_MUNICIPAL_DE_DUESAIGUES",
		"municipi": "Duesaigües",
		"codi_municipi": "430537",
		"latitud": "41.14554736",
		"longitud": "0.93129974",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. de Baix, 30",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-f6mn-3q7v_6s9e",
		":version": "rv-96h4-kf6n.mnu4",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Alfolí Museu de L'Escala",
		"indicador_refugi": "170622|ALFOLI_MUSEU_DE_L_ESCALA",
		"municipi": "Escala, l'",
		"codi_municipi": "170622",
		"latitud": "42.07206",
		"longitud": "3.07531",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Alfolí, 6",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-des7.9yc2.v6bt",
		":version": "rv-bc7d-kvhk~m6fu",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Llar dels Jubilats",
		"indicador_refugi": "170622|BIBLIOTECA_LLAR_DELS_JUBILATS",
		"municipi": "Escala, l'",
		"codi_municipi": "170622",
		"latitud": "42.122377",
		"longitud": "3.13141",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Escoles, 5",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-pqww-kx7n_7ekk",
		":version": "rv-qaup~a5nf-kequ",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Víctor Català",
		"indicador_refugi": "170622|BIBLIOTECA_VICTOR_CATALA",
		"municipi": "Escala, l'",
		"codi_municipi": "170622",
		"latitud": "42.125845",
		"longitud": "3.132564",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Pl. Víctor Català, 10",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-ijnw.ia47.jgyp",
		":version": "rv-wcvs~wbbs_iui5",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca municipal Mn. Ramon Muntanyola",
		"indicador_refugi": "430542|BIBLIOTECA_MUNICIPAL_MN_RAMON_MUNTANYOLA",
		"municipi": "Espluga de Francolí, l'",
		"codi_municipi": "430542",
		"latitud": "41.39632894",
		"longitud": "1.10366417",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. de Torres Jordi, 16",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-i2e7~7pbf~ivvb",
		":version": "rv-skf6-6kfx.7kpz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Llar de Jubilats i Pensionistes",
		"indicador_refugi": "430542|LLAR_DE_JUBILATS_I_PENSIONISTES",
		"municipi": "Espluga de Francolí, l'",
		"codi_municipi": "430542",
		"latitud": "41.39655932",
		"longitud": "1.10376743",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. de l'Església, 5, 1a planta",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-2zhq_bkfw_nwdx",
		":version": "rv-rzim.drrk-zjcb",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "430542|PISCINA_MUNICIPAL",
		"municipi": "Espluga de Francolí, l'",
		"codi_municipi": "430542",
		"latitud": "41.39531004",
		"longitud": "1.09663901",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. de Prat de la Riba, 1",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-7u6n.hb96.wk39",
		":version": "rv-x4g6_mcf7-if4b",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Sala de la societat La Fraternal",
		"indicador_refugi": "170643|SALA_DE_LA_SOCIETAT_LA_FRATERNAL",
		"municipi": "Espolla",
		"codi_municipi": "170643",
		"latitud": "42.39072451",
		"longitud": "3.00081304",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. del Carme, 1",
		"tipologia": "Sala polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-4mkx.b37f~d9bk",
		":version": "rv-wqhy~zqim-a9ac",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal d'Espolla",
		"indicador_refugi": "170643|PISCINA_MUNICIPAL_D_ESPOLLA",
		"municipi": "Espolla",
		"codi_municipi": "170643",
		"latitud": "42.39305609",
		"longitud": "2.99773974",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Figueres, 18",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-qbzh.d4n3-ct9b",
		":version": "rv-x8z5~32am.vhgx",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Espai 1 d'octubre",
		"indicador_refugi": "170656|ESPAI_1_D_OCTUBRE",
		"municipi": "Esponellà",
		"codi_municipi": "170656",
		"latitud": "42.17737935159",
		"longitud": "2.79543657",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Pl. U d'Ocutbre, 1",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-pqd6_ki9k-a34d",
		":version": "rv-3p9h~32f5_r5gi",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Local entitats",
		"indicador_refugi": "080787|LOCAL_ENTITATS",
		"municipi": "Espunyola, l'",
		"codi_municipi": "080787",
		"latitud": "42.0541426",
		"longitud": "1.76793475",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Ctra. de Solsona C26, Km 136",
		"tipologia": "Sala polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-sgr2.expw.8h8g",
		":version": "rv-ehcz~jgsg_8ha7",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Local de la gent gran",
		"indicador_refugi": "080790|LOCAL_DE_LA_GENT_GRAN",
		"municipi": "Estany, l'",
		"codi_municipi": "080790",
		"latitud": "41.86848462",
		"longitud": "2.11126359",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Balmes, 30",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-a77n_u893-aghw",
		":version": "rv-h7ui_ti2n.mp32",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça de la Nevera",
		"indicador_refugi": "430555|PLACA_DE_LA_NEVERA",
		"municipi": "Falset",
		"codi_municipi": "430555",
		"latitud": "41.143924",
		"longitud": "0.822558",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Francesc Rispa i Perpinyà",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-9p2n-s9hk_27kn",
		":version": "rv-m3da_4k3d.rai3",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bosquet del Tancat",
		"indicador_refugi": "430555|BOSQUET_DEL_TANCAT",
		"municipi": "Falset",
		"codi_municipi": "430555",
		"latitud": "41.1467852",
		"longitud": "0.82479773",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Av. de Reus, s/n",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-x7qu.sf2c_xqtq",
		":version": "rv-py7m-97wh~j3hz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca pública Salvador Estrem i Fa",
		"indicador_refugi": "430555|BIBLIOTECA_PUBLICA_SALVADOR_ESTREM_I_FA",
		"municipi": "Falset",
		"codi_municipi": "430555",
		"latitud": "41.14535775",
		"longitud": "0.81878812",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Baix, 41",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-s4kd_grxt-yvix",
		":version": "rv-dcgi~8pfv~6qug",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Euterpe - zona esportiva",
		"indicador_refugi": "430555|EUTERPE_ZONA_ESPORTIVA",
		"municipi": "Falset",
		"codi_municipi": "430555",
		"latitud": "41.144596",
		"longitud": "0.819118",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Josep Campàs, s/n",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-6yjh.5nhk_iit2",
		":version": "rv-ztf3.2r53-pvbx",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Refugi Climàtic Barranc de la Vila",
		"indicador_refugi": "430555|REFUGI_CLIMATIC_BARRANC_DE_LA_VILA",
		"municipi": "Falset",
		"codi_municipi": "430555",
		"latitud": "41.145067",
		"longitud": "0.818427",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça de Neus Català s/n",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-02T12:03:00.000"
	},
	{
		":id": "row-z8ig-g3ty_uqz2",
		":version": "rv-9vj9-zjrr~9yei",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Sala polivalent",
		"indicador_refugi": "430574|SALA_POLIVALENT",
		"municipi": "Febró, la",
		"codi_municipi": "430574",
		"latitud": "41.27715159",
		"longitud": "1.0033987",
		"accessibilitat": "No",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. canyada, 7",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-267k.8phw~t4kp",
		":version": "rv-ir4k.dkg6_fvw4",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "081347|PISCINA_MUNICIPAL",
		"municipi": "Figaró-Montmany",
		"codi_municipi": "081347",
		"latitud": "41.71485491",
		"longitud": "2.26999693",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Ctra. de Ribes, s/n",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-smvf_tpr7_fc9u",
		":version": "rv-hemj.bx5a.ybvh",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Sala Nou Casino",
		"indicador_refugi": "081347|SALA_NOU_CASINO",
		"municipi": "Figaró-Montmany",
		"codi_municipi": "081347",
		"latitud": "41.720814",
		"longitud": "2.272708",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Anna Bosch, s/n",
		"tipologia": "Sala polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-mpug-3d8d_mw4x",
		":version": "rv-dawp_v3z3~yd79",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "430580|PISCINA_MUNICIPAL",
		"municipi": "Figuera, la",
		"codi_municipi": "430580",
		"latitud": "41.21515523",
		"longitud": "0.73001309",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de la piscina, s/n",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-92q2-vern.qd4c",
		":version": "rv-c4sc.jdsi-uzp4",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Cívic Joaquim Xirau",
		"indicador_refugi": "170669|CENTRE_CIVIC_JOAQUIM_XIRAU",
		"municipi": "Figueres",
		"codi_municipi": "170669",
		"latitud": "42.26974",
		"longitud": "2.98018",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Vilatenim, 45",
		"informacio_web": "https://www.figueres.cat/temes/accio-civica/centrescivicsmunicipals/centrecivicjoaquimxirau",
		"tipologia": "Centre Cívic",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-09T14:27:00.000"
	},
	{
		":id": "row-jivk.f7rv~eg49",
		":version": "rv-va6e-rtah~rw3z",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Fages de Climent",
		"indicador_refugi": "170669|BIBLIOTECA_FAGES_DE_CLIMENT",
		"municipi": "Figueres",
		"codi_municipi": "170669",
		"latitud": "42.26576",
		"longitud": "2.95711",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça del Sol, 11, 17600 FIGUERES",
		"informacio_web": "https://www.bibliotecadefigueres.cat/",
		"tipologia": "Biblioteca",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-09T14:31:00.000"
	},
	{
		":id": "row-83vs.z626.kbz9",
		":version": "rv-t5dm_3twz_x66h",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Museu de l'Empordà",
		"indicador_refugi": "170669|MUSEU_DE_LEMPORDA",
		"municipi": "Figueres",
		"codi_municipi": "170669",
		"latitud": "42.26679",
		"longitud": "2.962",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Rambla, 2, 17600 Figueres",
		"informacio_web": "https://www.museuemporda.org/",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-09T14:50:00.000"
	},
	{
		":id": "row-857k~fdkv-rh8f",
		":version": "rv-m4ap_6djy-tu9r",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Cívic Creu de la Ma",
		"indicador_refugi": "170669|CENTRE_CIVIC_CREU_DE_LA_MA",
		"municipi": "Figueres",
		"codi_municipi": "170669",
		"latitud": "42.26042",
		"longitud": "2.96569",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça Remei Bosch, sn",
		"informacio_web": "https://www.figueres.cat/temes/accio-civica/centrescivicsmunicipals/centre-civic-creu-de-la-ma",
		"tipologia": "Centre Cívic",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-10T08:04:00.000"
	},
	{
		":id": "row-6hpy~z9x2-mb6x",
		":version": "rv-g4xy_gg69.h3r4",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Seu del Consell Municipal de Vilatenim",
		"indicador_refugi": "170669|SEU_DEL_CONSELL_MUNICIPAL_DE_VILATENIM",
		"municipi": "Figueres",
		"codi_municipi": "170669",
		"latitud": "42.26861",
		"longitud": "2.99441",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C/ Nou, 9 de Vilatenim 17484",
		"informacio_web": "https://www.figueres.cat/figueres/equipaments/551986",
		"tipologia": "Ajuntament / Equipament Administratiu",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-10T08:17:00.000"
	},
	{
		":id": "row-yaqf.fnmt~zfxh",
		":version": "rv-bpf6_kwp2-iqpv",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Església de Sant Pere",
		"indicador_refugi": "170669|ESGLESIA_DE_SANT_PERE",
		"municipi": "Figueres",
		"codi_municipi": "170669",
		"latitud": "42.2679969192312",
		"longitud": "2.959966865480408",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer de l'Església, 8, 17600 Figueres, Girona",
		"informacio_web": "http://www.bisbatgirona.cat/ca/parroquies/c/1277-figueres-sant-pere.html",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-19T12:09:00.000"
	},
	{
		":id": "row-7ncq_bwfp_jyug",
		":version": "rv-hg5g~nw6b~6ufg",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Font lluminosa",
		"indicador_refugi": "170669|FONT_LLUMINOSA",
		"municipi": "Figueres",
		"codi_municipi": "170669",
		"latitud": "42.266089964459944",
		"longitud": "2.9634607121850323",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça Doctor Ernest Vila, 17600 Figueres, Girona",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-19T12:38:00.000"
	},
	{
		":id": "row-wtje.645p.r3zm",
		":version": "rv-qz6z~3s87_6hb7",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça Palmera",
		"indicador_refugi": "170669|PLACA_PALMERA",
		"municipi": "Figueres",
		"codi_municipi": "170669",
		"latitud": "42.26737046123455",
		"longitud": "2.9643729256804328",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "17600 Figueres, Girona",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-19T12:39:00.000"
	},
	{
		":id": "row-y5m2_8vgf-r6m9",
		":version": "rv-u2y4-r9fe~9d55",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Bosc",
		"indicador_refugi": "170669|PARC_BOSC",
		"municipi": "Figueres",
		"codi_municipi": "170669",
		"latitud": "42.26807658251675",
		"longitud": "2.955221185582616",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Avinguda de Salvador Dalí i Domènech, 117, 17600 Figueres, Girona",
		"informacio_web": "http://www.figueres.cat/",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-19T12:41:00.000"
	},
	{
		":id": "row-5jc4_nay3.wsen",
		":version": "rv-wnzz~uj4c~vner",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "la pineda de la Pujada del Castell",
		"indicador_refugi": "170669|LA_PINEDA_DE_LA_PUJADA_DEL_CASTELL",
		"municipi": "Figueres",
		"codi_municipi": "170669",
		"latitud": "42.27239098238683",
		"longitud": "2.9512133619481893",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pujada del Castell, s/n, 17600 Figueres, Girona",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-19T12:43:00.000"
	},
	{
		":id": "row-zw6x-bwgv~vang",
		":version": "rv-m8mw-s5f8~ecj8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "el Parc de les Aigües",
		"indicador_refugi": "170669|EL_PARC_DE_LES_AIGUES",
		"municipi": "Figueres",
		"codi_municipi": "170669",
		"latitud": "42.27248035403553",
		"longitud": "2.95962455635969",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Avinguda de la Costa Brava, 6, 17600 Figueres, Girona",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-19T12:45:00.000"
	},
	{
		":id": "row-j3m4.8z7h-irbt",
		":version": "rv-a24y.ga2f_knzc",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "els Jardins Puig Pujades",
		"indicador_refugi": "170669|ELS_JARDINS_PUIG_PUJADES",
		"municipi": "Figueres",
		"codi_municipi": "170669",
		"latitud": "42.26521488495962",
		"longitud": "2.9624260851942665",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Sant Llàtzer, 7I, 17600 Figueres, Girona",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-19T12:46:00.000"
	},
	{
		":id": "row-444k~37c2~38jn",
		":version": "rv-ipq7_2ptp.skss",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Auditori Museu Empordà",
		"indicador_refugi": "170669|AUDITORI_MUSEU_EMPORDA",
		"municipi": "Figueres",
		"codi_municipi": "170669",
		"latitud": "42.26682657863993",
		"longitud": "2.9619754740103597",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "La Rambla, 2, 17600 Figueres, Girona",
		"informacio_web": "http://www.museuemporda.org/",
		"tipologia": "Equipament Cultural (teatre, auditori, museu)",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-19T12:50:00.000"
	},
	{
		":id": "row-umvp-ac4r_qn8i",
		":version": "rv-76wf_sjdr~q3ni",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Local Social",
		"indicador_refugi": "250925|LOCAL_SOCIAL",
		"municipi": "Floresta, la",
		"codi_municipi": "250925",
		"latitud": "41.509475",
		"longitud": "0.920055",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Sant Blai, 20",
		"tipologia": "Sala Polivalent",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-09T11:39:00.000"
	},
	{
		":id": "row-dyjd_vnw4_b9bw",
		":version": "rv-n7xj.mjc2~tq49",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "\"Les Escoles\"",
		"indicador_refugi": "170681|LES_ESCOLES",
		"municipi": "Foixà",
		"codi_municipi": "170681",
		"latitud": "42.03954247",
		"longitud": "2.99831402",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Pl. de les Escoles, 1",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-vf5f-wgpn.d58m",
		":version": "rv-ixcy.ztkt~468f",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscines municipals de Folgueroles",
		"indicador_refugi": "080832|PISCINES_MUNICIPALS_DE_FOLGUEROLES",
		"municipi": "Folgueroles",
		"codi_municipi": "080832",
		"latitud": "41.93945202",
		"longitud": "2.31291308",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Sajolida, 1",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-tpcp-2rcf_hsvp",
		":version": "rv-2jtq_nmk6~8bj2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "PISCINA MUNICIPAL FONTCOBERTA",
		"indicador_refugi": "170715|PISCINA_MUNICIPAL_FONTCOBERTA",
		"municipi": "Fontcoberta",
		"codi_municipi": "170715",
		"latitud": "42.1419",
		"longitud": "2.7742",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Pau Casals 16",
		"informacio_web": "https://turisme.plaestany.cat/item-turistic/piscina-municipal-de-melianta/",
		"tipologia": "Piscines descobertes",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-08T18:11:00.000"
	},
	{
		":id": "row-dm6n_68jj~2v2n",
		":version": "rv-59cs-y7ri-pifz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina de Foradada",
		"indicador_refugi": "250946|PISCINA_DE_FORADADA",
		"municipi": "Foradada",
		"codi_municipi": "250946",
		"latitud": "41.87612959",
		"longitud": "1.01082501",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Afores, s/n",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-9ikr.4hjk.sig8",
		":version": "rv-xkib_hvfr.p2mb",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Local cultural de Forès",
		"indicador_refugi": "430614|LOCAL_CULTURAL_DE_FORES",
		"municipi": "Forès",
		"codi_municipi": "430614",
		"latitud": "41.49338564",
		"longitud": "1.23560438",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Pla de la bassa, 21",
		"tipologia": "Sala polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-jkn7~69ua_i46i",
		":version": "rv-er9b~d7n4.xaf7",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Social",
		"indicador_refugi": "170736|CENTRE_SOCIAL",
		"municipi": "Fornells de la Selva",
		"codi_municipi": "170736",
		"latitud": "41.93435189",
		"longitud": "2.81204352",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Vicens Vives, 1 1r pis - 17458 Fornells de la Selva",
		"tipologia": "Sala polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-8htw.68n5~giz6",
		":version": "rv-ug96~9bri~54sh",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça Païssos Catalans",
		"indicador_refugi": "170736|PLACA_PAISSOS_CATALANS",
		"municipi": "Fornells de la Selva",
		"codi_municipi": "170736",
		"latitud": "41.93137683254071",
		"longitud": "2.810152218450131",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça Païssos Catalans",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-06T16:27:00.000"
	},
	{
		":id": "row-khau.ny8e-rihh",
		":version": "rv-ajcu~w5c2_y9rv",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Passatge Torola",
		"indicador_refugi": "170736|PARC_PASSATGE_TOROLA",
		"municipi": "Fornells de la Selva",
		"codi_municipi": "170736",
		"latitud": "41.932334831240055",
		"longitud": "2.8045128552777885",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Passatge Torola",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-06T16:30:00.000"
	},
	{
		":id": "row-pxkz-rqaz-6h8m",
		":version": "rv-e42r-he34_8uui",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "PISCINA MUNICIPAL",
		"indicador_refugi": "170741|PISCINA_MUNICIPAL",
		"municipi": "Fortià",
		"codi_municipi": "170741",
		"latitud": "42.2405",
		"longitud": "3.0425",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Camí de la Gallinera, sn",
		"informacio_web": "fortia.cat",
		"tipologia": "Piscines descobertes",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-04T16:53:00.000"
	},
	{
		":id": "row-n3zi_5t3r~dpzq",
		":version": "rv-xjfn-3ah8.heek",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de la Gent Gran Miquel Ruiz",
		"indicador_refugi": "170741|CASAL_DE_LA_GENT_GRAN_MIQUEL_RUIZ",
		"municipi": "Fortià",
		"codi_municipi": "170741",
		"latitud": "42.2421",
		"longitud": "3.0407",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça de l'Església, 2",
		"informacio_web": "fortia.cat",
		"tipologia": "Casal de Gent Gran",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-18T16:43:00.000"
	},
	{
		":id": "row-a7x4_zpm2~a5ya",
		":version": "rv-uz8n_uutn-e6p4",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal d'avis i centre social de Bellavista",
		"indicador_refugi": "080863|CASAL_D_AVIS_I_CENTRE_SOCIAL_DE_BELLAVISTA",
		"municipi": "Franqueses del Vallès, les",
		"codi_municipi": "080863",
		"latitud": "41.61920035",
		"longitud": "2.29674694",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. d'Extremadura, 32-38 (interior d'illa)",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-k849_v9uf.cbxx",
		":version": "rv-esxf~7hhu.2szw",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Les Franqueses del Vallès",
		"indicador_refugi": "080863|CASAL_CIVIC_I_COMUNITARI_LES_FRANQUESES_DEL_VALLES",
		"municipi": "Franqueses del Vallès, les",
		"codi_municipi": "080863",
		"latitud": "41.62887483",
		"longitud": "2.29599608",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. de Santa Eulàlia, 7",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-swii_zxav.p76i",
		":version": "rv-55uk_rm35-id4e",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal municipal",
		"indicador_refugi": "430629|CASAL_MUNICIPAL",
		"municipi": "Freginals",
		"codi_municipi": "430629",
		"latitud": "40.67165396",
		"longitud": "0.52087754",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Mossèn Miquel, 18",
		"tipologia": "Sala polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-jgh9.pueh-9pmv",
		":version": "rv-tezz_96bi~bn54",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "430629|PISCINA_MUNICIPAL",
		"municipi": "Freginals",
		"codi_municipi": "430629",
		"latitud": "40.67095924",
		"longitud": "0.51723431",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Pla de Corany, 34",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-men9_5fc6-ekb9",
		":version": "rv-7xcu_ymu4_xcvf",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Pavelló municipal",
		"indicador_refugi": "430629|PAVELLO_MUNICIPAL",
		"municipi": "Freginals",
		"codi_municipi": "430629",
		"latitud": "40.66997854",
		"longitud": "0.51959679",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Sant Antoni, s/n",
		"tipologia": "Poliesportiu",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-9srm_57fu_7jw9",
		":version": "rv-n8hk.w2a2.37d9",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Sala polivalent de l'ajuntament",
		"indicador_refugi": "080902|SALA_POLIVALENT_DE_L_AJUNTAMENT",
		"municipi": "Gaià",
		"codi_municipi": "080902",
		"latitud": "41.91653221",
		"longitud": "1.92523955",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. de l'Ajuntament, 1 (bx)",
		"tipologia": "Sala polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-neqn_25e9_u56s",
		":version": "rv-3jdq.v3fd_tni5",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal de Gandesa",
		"indicador_refugi": "430640|PISCINA_MUNICIPAL_DE_GANDESA",
		"municipi": "Gandesa",
		"codi_municipi": "430640",
		"latitud": "41.05858967",
		"longitud": "0.4398056",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Av. Joan Perucho, 1",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-pz4m-diwc.jpdv",
		":version": "rv-mhaq_k7zs-ccy4",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal del Maig",
		"indicador_refugi": "430653|CASAL_DEL_MAIG",
		"municipi": "Garcia",
		"codi_municipi": "430653",
		"latitud": "41.13696156",
		"longitud": "0.6495972",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Centre, 6",
		"tipologia": "Sala polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-kvbg-9392-aisd",
		":version": "rv-vnt7~zcq7-9vdb",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal municipal",
		"indicador_refugi": "430666|CASAL_MUNICIPAL",
		"municipi": "Garidells, els",
		"codi_municipi": "430666",
		"latitud": "41.2073674",
		"longitud": "1.24749148",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Av. Catalunya, 2",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-4dvh_uw6y-jtwm",
		":version": "rv-75i2~inzh.27tw",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "080885|PISCINA_MUNICIPAL",
		"municipi": "Garriga, la",
		"codi_municipi": "080885",
		"latitud": "41.68841194030479",
		"longitud": "2.282217153618451",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Bassal s/n, 08530 La Garriga",
		"informacio_web": "https://www.egoralagarriga.cat/",
		"tipologia": "Piscines descobertes",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-22T08:40:00.000"
	},
	{
		":id": "row-bqqq.nw35_7u5u",
		":version": "rv-7r3y-7j8n~7285",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Núria Albó",
		"indicador_refugi": "080885|BIBLIOTECA_NURIA_ALBO",
		"municipi": "Garriga, la",
		"codi_municipi": "080885",
		"latitud": "41.685701534764746",
		"longitud": "2.2853785951369545",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer del Centra núm. 49, 08530 La Garriga",
		"informacio_web": "https://bibliotecavirtual.diba.cat/ca/garriga-la-biblioteca-nuria-albo",
		"tipologia": "Biblioteca",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-22T08:44:00.000"
	},
	{
		":id": "row-9ieq.nxvv~87xx",
		":version": "rv-4i5n~6srm-id4f",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Sala La Llar",
		"indicador_refugi": "170754|SALA_LA_LLAR",
		"municipi": "Garrigàs",
		"codi_municipi": "170754",
		"latitud": "42.1909072",
		"longitud": "2.954752",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Gran, 26, Edifici 1 d'octubre, 17476 Garrigàs",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-ucvr.yq6y~482h",
		":version": "rv-6uic~ydne~zixs",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic de l'Escorxador",
		"indicador_refugi": "080919|CENTRE_CIVIC_DE_L_ESCORXADOR",
		"municipi": "Gelida",
		"codi_municipi": "080919",
		"latitud": "41.44165714",
		"longitud": "1.85805068",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Escorxador, s/n",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-ktbg_3itn_yxj7",
		":version": "rv-vu5r-x3gd_erbb",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de la gent gran",
		"indicador_refugi": "080919|CASAL_DE_LA_GENT_GRAN",
		"municipi": "Gelida",
		"codi_municipi": "080919",
		"latitud": "41.44022426",
		"longitud": "1.86434101",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Major, 10",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-mm3x~r7cs~bj3h",
		":version": "rv-krme-wpxz_2jeq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre d'iniciatives culturals (cic)",
		"indicador_refugi": "080919|CENTRE_D_INICIATIVES_CULTURALS_CIC",
		"municipi": "Gelida",
		"codi_municipi": "080919",
		"latitud": "41.4398337",
		"longitud": "1.86393882",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. del Mossèn Jaume Via, 17",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-ztg8.pucy-xjis",
		":version": "rv-84dk_mdah.7cjw",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CENTRE CULTURAL / BIBLIOTECA",
		"indicador_refugi": "080919|CENTRE_CULTURAL_-_BIBLIOTECA",
		"municipi": "Gelida",
		"codi_municipi": "080919",
		"latitud": "41.440249",
		"longitud": "1.862851",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "No",
		"adreca": "CARRER MAJOR,",
		"tipologia": "Biblioteca",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-03T09:30:00.000"
	},
	{
		":id": "row-u3aq_3nxy-7jxr",
		":version": "rv-tzub.hxp6-zz85",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Local social Sant Isidre De Gimenells",
		"indicador_refugi": "259123|LOCAL_SOCIAL_SANT_ISIDRE_DE_GIMENELLS",
		"municipi": "Gimenells i el Pla de la Font",
		"codi_municipi": "259123",
		"latitud": "41.65366757",
		"longitud": "0.38937456",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C./ Parc, s/n    25112 - Gimenells (Lleida)",
		"tipologia": "Sala Polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-06-02T10:01:00.000"
	},
	{
		":id": "row-rmx9-e5gw_935b",
		":version": "rv-aqk8~q5n9_hcec",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Abacus Cooperativa",
		"indicador_refugi": "170792|ABACUS_COOPERATIVA",
		"municipi": "Girona",
		"codi_municipi": "170792",
		"latitud": "41.98498253",
		"longitud": "2.82300466",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Rda. Sant Antoni Maria Claret, 39-41, 17002 Girona",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-gutf-fmsf.ypch",
		":version": "rv-qtjp-mxnv~2wfz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Escola Àgora",
		"indicador_refugi": "170792|ESCOLA_AGORA",
		"municipi": "Girona",
		"codi_municipi": "170792",
		"latitud": "41.97116915",
		"longitud": "2.81013778",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Pg. Ramon Berenguer II, 4 17005 Girona",
		"tipologia": "Centre educatiu",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-pky8_mg2u~3hvc",
		":version": "rv-iyx8~jbv3_wr5x",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Església parroquial de Sant Narcís",
		"indicador_refugi": "170792|ESGLESIA_PARROQUIAL_DE_SANT_NARCIS",
		"municipi": "Girona",
		"codi_municipi": "170792",
		"latitud": "41.97536399",
		"longitud": "2.81071131",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Assumpció, 18",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-ekem_9pw2-zv3g",
		":version": "rv-nt4i-cnvm_6m6h",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Museu del cinema de Girona (zona vestíbul i sales d'exposicions temporals)",
		"indicador_refugi": "170792|MUSEU_DEL_CINEMA_DE_GIRONA_ZONA_VESTIBUL_I_SALES_D_EXPOSICIONS_TEMPORALS",
		"municipi": "Girona",
		"codi_municipi": "170792",
		"latitud": "41.98381651",
		"longitud": "2.82325239",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. de la Séquia, 1, 17001 Girona",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-mczu~erjp_fxsd",
		":version": "rv-txt7-rgjq_7y4a",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic Pla de Palau",
		"indicador_refugi": "170792|CENTRE_CIVIC_PLA_DE_PALAU",
		"municipi": "Girona",
		"codi_municipi": "170792",
		"latitud": "41.97117832",
		"longitud": "2.81904264",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Saragossa, 27, 17002 Girona",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-c5kg~scgy-ectc",
		":version": "rv-xwzq.tikw-iv7t",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jardins d'en Pablito",
		"indicador_refugi": "170792|JARDINS_D_EN_PABLITO",
		"municipi": "Girona",
		"codi_municipi": "170792",
		"latitud": "41.97720089",
		"longitud": "2.8239443",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Jdins. d'en Pablito",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-q4t7~a3x2_adeb",
		":version": "rv-kskq_7rnn~egg5",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Espai cívic Can Gibert del Pla",
		"indicador_refugi": "170792|ESPAI_CIVIC_CAN_GIBERT_DEL_PLA",
		"municipi": "Girona",
		"codi_municipi": "170792",
		"latitud": "41.97156559",
		"longitud": "2.80711284",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Taga, 4, 17006 Girona",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-2tij-frv2.6ie5",
		":version": "rv-h4jh~tica.j4ay",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc del Migdia",
		"indicador_refugi": "170792|PARC_DEL_MIGDIA",
		"municipi": "Girona",
		"codi_municipi": "170792",
		"latitud": "41.97356121",
		"longitud": "2.81793983",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de Pau Vila i Dinarès, 17003 Girona",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-4n7n~3ap2-x94e",
		":version": "rv-hsnh.4h7z_hdms",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Passeig Arqueològic",
		"indicador_refugi": "170792|PASSEIG_ARQUEOLOGIC",
		"municipi": "Girona",
		"codi_municipi": "170792",
		"latitud": "41.98822954",
		"longitud": "2.82678441",
		"accessibilitat": "No",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Pg. Arqueològic",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-5676.f9pk~2mub",
		":version": "rv-rcic_w442-u3zg",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Museu d'Història dels Jueus (vestíbul)",
		"indicador_refugi": "170792|MUSEU_D_HISTORIA_DELS_JUEUS_VESTIBUL",
		"municipi": "Girona",
		"codi_municipi": "170792",
		"latitud": "41.98614738",
		"longitud": "2.82463485",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. de la Força 8, 17004 Girona",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-2aav~ugdk~qjn7",
		":version": "rv-g7xv_bgjk~xn8n",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic Ter",
		"indicador_refugi": "170792|CENTRE_CIVIC_TER",
		"municipi": "Girona",
		"codi_municipi": "170792",
		"latitud": "41.99397547",
		"longitud": "2.80881092",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Can Sunyer, 46, 17007 Girona",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-drm2-kfbg~yuzq",
		":version": "rv-5gqq-8bwf-3nx2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic Pedret",
		"indicador_refugi": "170792|CENTRE_CIVIC_PEDRET",
		"municipi": "Girona",
		"codi_municipi": "170792",
		"latitud": "41.99723561",
		"longitud": "2.82470673",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Pedret, 152-156, 17007 Girona",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-suej-i7ny.knib",
		":version": "rv-ympc~nd46_9z4t",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de la Devesa",
		"indicador_refugi": "170792|PARC_DE_LA_DEVESA",
		"municipi": "Girona",
		"codi_municipi": "170792",
		"latitud": "41.98763788",
		"longitud": "2.81557407",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Pg. de la Devesa, 38, 17007 Girona",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-k2uj_49zu-qqj9",
		":version": "rv-qpmr-a22v_tdb9",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Just M. Casero",
		"indicador_refugi": "170792|BIBLIOTECA_JUST_M_CASERO",
		"municipi": "Girona",
		"codi_municipi": "170792",
		"latitud": "42.01247562",
		"longitud": "2.82522842",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Pl. de l'Om, 1, 17007 Girona",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-ayes.f4mt~8gxb",
		":version": "rv-d6p7.wfhx.pc7s",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic Santa Eugènia",
		"indicador_refugi": "170792|CENTRE_CIVIC_SANTA_EUGENIA",
		"municipi": "Girona",
		"codi_municipi": "170792",
		"latitud": "41.97801237",
		"longitud": "2.80697762",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Santa Eugènia, 146, 17006 Girona",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-y7fp_sf7b~y343",
		":version": "rv-2jm2~i9df~87s6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Mercat del Lleó",
		"indicador_refugi": "170792|MERCAT_DEL_LLEO",
		"municipi": "Girona",
		"codi_municipi": "170792",
		"latitud": "41.97982048",
		"longitud": "2.82382294",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Pl. Calvet i Rubalcaba, 15,  17002 Girona",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-2bpe.jfr4-y44g",
		":version": "rv-5h8v~f2ba.889y",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Arxiu municipal de Girona",
		"indicador_refugi": "170792|ARXIU_MUNICIPAL_DE_GIRONA",
		"municipi": "Girona",
		"codi_municipi": "170792",
		"latitud": "41.98715957",
		"longitud": "2.82503781",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Plta. de l'Institut Vell, 1, 17004 Girona",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-aumu_ea6m-c7pc",
		":version": "rv-f85n-qrb9_7uq8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Girona - Montilivi",
		"indicador_refugi": "170792|CASAL_CIVIC_I_COMUNITARI_GIRONA_MONTILIVI",
		"municipi": "Girona",
		"codi_municipi": "170792",
		"latitud": "41.6862232",
		"longitud": "2.0832848",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. del Doctor Josep Ametller Viñas, 56",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-xfkq~ib9z.h6b3",
		":version": "rv-uf6u_vyqt-6wg5",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Ernest Lluch",
		"indicador_refugi": "170792|BIBLIOTECA_ERNEST_LLUCH",
		"municipi": "Girona",
		"codi_municipi": "170792",
		"latitud": "41.97109572",
		"longitud": "2.81950838",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Saragossa, 27, 17003 Girona",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-zjvw~nwk4.wvse",
		":version": "rv-ji35.8dta~yxib",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Sala d'espera OAMR",
		"indicador_refugi": "170792|SALA_D_ESPERA_OAMR",
		"municipi": "Girona",
		"codi_municipi": "170792",
		"latitud": "41.98357097",
		"longitud": "2.82473135",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Pl. del Vi, 1, 17004 Girona",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-8t7v.mhn4~xv4b",
		":version": "rv-ixv7-rjpk~4d9i",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic Sant Narcís",
		"indicador_refugi": "170792|CENTRE_CIVIC_SANT_NARCIS",
		"municipi": "Girona",
		"codi_municipi": "170792",
		"latitud": "41.97539263",
		"longitud": "2.81142888",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Pl. Assumpció, 26-27, 17005 Girona",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-9bwa.5yea-cuvq",
		":version": "rv-f6ph.as49-8kbd",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic Pont Major",
		"indicador_refugi": "170792|CENTRE_CIVIC_PONT_MAJOR",
		"municipi": "Girona",
		"codi_municipi": "170792",
		"latitud": "42.01238244",
		"longitud": "2.8254044",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Pont Major, 67-73, 17007 Girona",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-ccd7_vf5b~h5x9",
		":version": "rv-jrt3.hf8t~sarz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Salvador Allende",
		"indicador_refugi": "170792|BIBLIOTECA_SALVADOR_ALLENDE",
		"municipi": "Girona",
		"codi_municipi": "170792",
		"latitud": "41.97873294",
		"longitud": "2.80677017",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. de Baix, 2, 17006 Girona",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-q6v6_f8i9-x5hj",
		":version": "rv-chqp-q9sf.avc2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Museu d'Història de Girona (vestíbul)",
		"indicador_refugi": "170792|MUSEU_D_HISTORIA_DE_GIRONA_VESTIBUL",
		"municipi": "Girona",
		"codi_municipi": "170792",
		"latitud": "41.98706798",
		"longitud": "2.82618017",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. de la Força, 27, 17004 Girona",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-29um.guvj-cwdu",
		":version": "rv-czve_sfp9~w4r2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Soterrani de la Catedral",
		"indicador_refugi": "170792|SOTERRANI_DE_LA_CATEDRAL",
		"municipi": "Girona",
		"codi_municipi": "170792",
		"latitud": "41.98779927",
		"longitud": "2.8263022",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Catedral, s/n",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-txdg-daw4.ih2x",
		":version": "rv-uaei-anr7.jsnv",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bòlit. Centre d'art contemporani",
		"indicador_refugi": "170792|BOLIT_CENTRE_D_ART_CONTEMPORANI",
		"municipi": "Girona",
		"codi_municipi": "170792",
		"latitud": "41.98871219",
		"longitud": "2.82561201",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Pl. del Pou Rodó, 7-9 17004 Girona",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-bprb_fbca.vpe5",
		":version": "rv-s2b8~hcpy.8yb3",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic Barri Vell - Mercadal",
		"indicador_refugi": "170792|CENTRE_CIVIC_BARRI_VELL_MERCADAL",
		"municipi": "Girona",
		"codi_municipi": "170792",
		"latitud": "41.98475435",
		"longitud": "2.82498114",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Cort Reial, 7, 17004 Girona",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-an2u.i72y_ddfw",
		":version": "rv-qcqb-2uhr-22vg",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Antònia Adroher",
		"indicador_refugi": "170792|BIBLIOTECA_ANTONIA_ADROHER",
		"municipi": "Girona",
		"codi_municipi": "170792",
		"latitud": "41.99387891",
		"longitud": "2.80936853",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Can Sunyer, 46 (Taialà) 17007 Girona",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-wqcs~xatq_2ncq",
		":version": "rv-ruqa~em8h_xug8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "La Mercè Girona",
		"indicador_refugi": "170792|LA_MERCE_GIRONA",
		"municipi": "Girona",
		"codi_municipi": "170792",
		"latitud": "41.98189528",
		"longitud": "2.82530771",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Pujada de la Mercè, 12, 17004 Girona",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-8ruq.pbtc-dt63",
		":version": "rv-j92c-7j8q.s7sb",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Escola Josep Dalmau Carles",
		"indicador_refugi": "170792|ESCOLA_JOSEP_DALMAU_CARLES",
		"municipi": "Girona",
		"codi_municipi": "170792",
		"latitud": "41.97167595",
		"longitud": "2.80596648",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Taga, 1, 17006 Girona",
		"tipologia": "Centre educatiu",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-xi7x_dex9_xggq",
		":version": "rv-d74y~pvtg.h22h",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de Domeny",
		"indicador_refugi": "170792|PARC_DE_DOMENY",
		"municipi": "Girona",
		"codi_municipi": "170792",
		"latitud": "41.98972731",
		"longitud": "2.80017964",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Parc de Domeny",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-52sg-uazk.sgdd",
		":version": "rv-gmj5.tpzc_mazx",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Espai cívic Mercadal",
		"indicador_refugi": "170792|ESPAI_CIVIC_MERCADAL",
		"municipi": "Girona",
		"codi_municipi": "170792",
		"latitud": "41.98492097",
		"longitud": "2.82280004",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Pl. Jordi de Sant Jordi, 1, 17001 Girona",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-ph6p~kekb-ei6c",
		":version": "rv-3esj~j66x_upgv",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de Vista Alegre",
		"indicador_refugi": "170792|PARC_DE_VISTA_ALEGRE",
		"municipi": "Girona",
		"codi_municipi": "170792",
		"latitud": "41.97715179",
		"longitud": "2.82600594",
		"accessibilitat": "No",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Parc de Vista Alegre",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-6gpf.9q9u-w5bi",
		":version": "rv-6h7z-4em4-j3cj",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Església parroquial del Mercadal",
		"indicador_refugi": "170792|ESGLESIA_PARROQUIAL_DEL_MERCADAL",
		"municipi": "Girona",
		"codi_municipi": "170792",
		"latitud": "41.98555454",
		"longitud": "2.83137536",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Obra, 6",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-777h~mwhb-8r64",
		":version": "rv-ieh5.fxfm~z6a4",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca de Gironella",
		"indicador_refugi": "080924|BIBLIOTECA_DE_GIRONELLA",
		"municipi": "Gironella",
		"codi_municipi": "080924",
		"latitud": "42.03168253",
		"longitud": "1.88350719",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Av. Països Catalans, s/n",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-rtti-rn3j~p723",
		":version": "rv-g64n_juw5-nvqg",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casa de cultura",
		"indicador_refugi": "080945|CASA_DE_CULTURA",
		"municipi": "Granada, la",
		"codi_municipi": "080945",
		"latitud": "41.37714",
		"longitud": "1.72099281",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Dr. Cuscó, 9",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-x4vi_wwde~u3ha",
		":version": "rv-gzen~f6nz.ykkg",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic",
		"indicador_refugi": "080945|CENTRE_CIVIC",
		"municipi": "Granada, la",
		"codi_municipi": "080945",
		"latitud": "41.37573255",
		"longitud": "1.71344819",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Av. Catalunya, 135",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-zg6w~t7fx~ky6q",
		":version": "rv-wqe4-vudm-d8qd",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "PISCINA MUNICIPAL",
		"indicador_refugi": "080945|PISCINA_MUNICIPAL",
		"municipi": "Granada, la",
		"codi_municipi": "080945",
		"latitud": "41.223525",
		"longitud": "1.425163",
		"accessibilitat": "Sí",
		"aigua": "No",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Crta santa fe del Penedès BV2156",
		"informacio_web": "www.lagranada.cat",
		"tipologia": "Piscines descobertes",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-04T10:46:00.000"
	},
	{
		":id": "row-igfr-ngmb_u28e",
		":version": "rv-nvjq_hw5k_d56h",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Granollers - Font verda",
		"indicador_refugi": "080961|CASAL_CIVIC_I_COMUNITARI_GRANOLLERS_FONT_VERDA",
		"municipi": "Granollers",
		"codi_municipi": "080961",
		"latitud": "41.6067968",
		"longitud": "2.2894579",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pg. de la Muntanya, 23",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-bpgg~h9y7~ssim",
		":version": "rv-phru~4bgw.vej4",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Granollers - Casal",
		"indicador_refugi": "080961|CASAL_CIVIC_I_COMUNITARI_GRANOLLERS_CASAL",
		"municipi": "Granollers",
		"codi_municipi": "080961",
		"latitud": "41.6071671",
		"longitud": "2.2839107",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Nou, 22",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-3nfv.a78v~z8za",
		":version": "rv-ms2f_scep_z79e",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de la Riera de Gualba",
		"indicador_refugi": "080977|PARC_DE_LA_RIERA_DE_GUALBA",
		"municipi": "Gualba",
		"codi_municipi": "080977",
		"latitud": "41.73410504",
		"longitud": "2.50162557",
		"accessibilitat": "No",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Darrera escola CEIP Aqua Alba",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-s9bu~zgxi_pmiw",
		":version": "rv-mfha_mjbj-ccia",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Oac Ajuntament",
		"indicador_refugi": "080977|OAC_AJUNTAMENT",
		"municipi": "Gualba",
		"codi_municipi": "080977",
		"latitud": "41.73218128",
		"longitud": "2.50185108",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pg. Montseny, 13",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-msca_5i4u_kz4t",
		":version": "rv-f2vp-3jfp-b6fb",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "080977|PISCINA_MUNICIPAL",
		"municipi": "Gualba",
		"codi_municipi": "080977",
		"latitud": "41.71045368",
		"longitud": "2.53049772",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de la serradora, 2",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-bgpu.hsmi.gta7",
		":version": "rv-zu9n~qn84_496m",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Can Sanmarti",
		"indicador_refugi": "080977|CAN_SANMARTI",
		"municipi": "Gualba",
		"codi_municipi": "080977",
		"latitud": "41.72980786",
		"longitud": "2.50499685",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pg. Montseny, 60",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-dgxm.4vre_gybj",
		":version": "rv-azyi.pvss-mudu",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CASAL DE GUALBA DE BAIX",
		"indicador_refugi": "080977|CASAL_DE_GUALBA_DE_BAIX",
		"municipi": "Gualba",
		"codi_municipi": "080977",
		"latitud": "41.71033",
		"longitud": "2.53056",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "No",
		"adreca": "CAMÍ RAL, 167",
		"informacio_web": "NO",
		"tipologia": "Sala Polivalent",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-11T17:03:00.000"
	},
	{
		":id": "row-kywp~qi4j-87wp",
		":version": "rv-83c4.fy9j.hbeu",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Entrada ajuntament",
		"indicador_refugi": "170813|ENTRADA_AJUNTAMENT",
		"municipi": "Gualta",
		"codi_municipi": "170813",
		"latitud": "42.02843726254579",
		"longitud": "3.1034932381926903",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça Major, 1   17257 Gualta (Girona)",
		"informacio_web": "www.gualta.cat",
		"tipologia": "Ajuntament / Equipament Administratiu",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-01T16:59:00.000"
	},
	{
		":id": "row-328z.ht5f.qisy",
		":version": "rv-fi8x~wmia~eusz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de l'Era",
		"indicador_refugi": "430705|CASAL_DE_L_ERA",
		"municipi": "Guiamets, els",
		"codi_municipi": "430705",
		"latitud": "41.10134976",
		"longitud": "0.75254093",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Av. Carretera, 35, Els Guiamets",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-5uck-6jsa.c88j",
		":version": "rv-n3e4.zpbb_9ezt",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca municipal",
		"indicador_refugi": "251109|BIBLIOTECA_MUNICIPAL",
		"municipi": "Guissona",
		"codi_municipi": "251109",
		"latitud": "41.78694816",
		"longitud": "1.28955057",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. Onze de Setembre, 1",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-cuuz.zsti~u2as",
		":version": "rv-c6gb.mmc4-kvxg",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "MUSEU DE GUISSONA",
		"indicador_refugi": "251109|MUSEU_DE_GUISSONA",
		"municipi": "Guissona",
		"codi_municipi": "251109",
		"latitud": "41.787156",
		"longitud": "1.289189",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer del Tint, 41",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-10T15:57:00.000"
	},
	{
		":id": "row-yeqh-inri-ch5t",
		":version": "rv-ewut~nstm-888j",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Àrea recreativa del Codó",
		"indicador_refugi": "251116|AREA_RECREATIVA_DEL_CODO",
		"municipi": "Guixers",
		"codi_municipi": "251116",
		"latitud": "42.13567394",
		"longitud": "1.55710237",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Creu del Codó",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-zabe_x7e3_n9g7",
		":version": "rv-ja4m.tzaq.bvri",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Local social/cultural",
		"indicador_refugi": "251116|LOCAL_SOCIAL_CULTURAL",
		"municipi": "Guixers",
		"codi_municipi": "251116",
		"latitud": "42.13258039",
		"longitud": "1.66729587",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Casa Nova de Valls, s/n",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-jvc9_bqd5-qba5",
		":version": "rv-waqh~3giv~h2ae",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de la gent gran",
		"indicador_refugi": "081000|CASAL_DE_LA_GENT_GRAN",
		"municipi": "Gurb",
		"codi_municipi": "081000",
		"latitud": "41.94011202",
		"longitud": "2.24386005",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Mas l'Esperança, s/n",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-dqnd_nnhd.yra6",
		":version": "rv-ksjg.v2dh.nnzd",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic de Fàtima",
		"indicador_refugi": "081022|CENTRE_CIVIC_DE_FATIMA",
		"municipi": "Igualada",
		"codi_municipi": "081022",
		"latitud": "41.58618081",
		"longitud": "1.6050156",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. Nostra Sra. de la Pietat, 42",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-34zw_ezd2.fmgv",
		":version": "rv-hrj4_v5rc~g8e7",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Espai cívic Centre",
		"indicador_refugi": "081022|ESPAI_CIVIC_CENTRE",
		"municipi": "Igualada",
		"codi_municipi": "081022",
		"latitud": "41.58003448",
		"longitud": "1.62207865",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Trinitat, 12",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-gyea-djrj-vsiv",
		":version": "rv-hba8-n83b-wa7z",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Igualada - Montserrat",
		"indicador_refugi": "081022|CASAL_CIVIC_I_COMUNITARI_IGUALADA_MONTSERRAT",
		"municipi": "Igualada",
		"codi_municipi": "081022",
		"latitud": "41.5805831",
		"longitud": "1.6298735",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de les Orquídies, 7",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-fy38-ki22.zu8b",
		":version": "rv-axnm_wzzb~f46w",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Igualada - Casal del passeig",
		"indicador_refugi": "081022|CASAL_CIVIC_I_COMUNITARI_IGUALADA_CASAL_DEL_PASSEIG",
		"municipi": "Igualada",
		"codi_municipi": "081022",
		"latitud": "41.5809838",
		"longitud": "1.6191757",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pg. de Mossèn Jacint Verdaguer, 67",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-ng7n.h55h~qiv5",
		":version": "rv-gyqb~i5wn-qvxa",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic Nord",
		"indicador_refugi": "081022|CENTRE_CIVIC_NORD",
		"municipi": "Igualada",
		"codi_municipi": "081022",
		"latitud": "41.58842166",
		"longitud": "1.617245",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Sant Martí de Tous, 8",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-kuk8-ipyr-deev",
		":version": "rv-c9uz_csrp-6nd5",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal d'Isona i Conca Dellà",
		"indicador_refugi": "251155|PISCINA_MUNICIPAL_D_ISONA_I_CONCA_DELLA",
		"municipi": "Isona i Conca Dellà",
		"codi_municipi": "251155",
		"latitud": "42.12146777",
		"longitud": "1.05141003",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. de Sant Vicenç, 81, Isona",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-5n29~ayww.kr9k",
		":version": "rv-3stn.3hf6.xacj",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Local social d'All",
		"indicador_refugi": "170849|LOCAL_SOCIAL_D_ALL",
		"municipi": "Isòvol",
		"codi_municipi": "170849",
		"latitud": "42.39850243",
		"longitud": "1.84085434",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Major, s/n, 17539 All",
		"tipologia": "Sala polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-qrze~agjc_8ynq",
		":version": "rv-eede-8nux-jtih",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Sala de plens de l'ajuntament d'Isòvol",
		"indicador_refugi": "170849|SALA_DE_PLENS_DE_L_AJUNTAMENT_D_ISOVOL",
		"municipi": "Isòvol",
		"codi_municipi": "170849",
		"latitud": "42.39759943",
		"longitud": "1.83703781",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Major d'All, 2, 17539 All",
		"tipologia": "Sala polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-rgaa_62av~qkfx",
		":version": "rv-7yce_t634_v7ge",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Local social d'Ivorra",
		"indicador_refugi": "251142|LOCAL_SOCIAL_D_IVORRA",
		"municipi": "Ivorra",
		"codi_municipi": "251142",
		"latitud": "41.7719106",
		"longitud": "1.39630801",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Major, 1, Ivorra",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-xjrg_ddxs~t7xe",
		":version": "rv-yhaq~i7qf_2zag",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Local social de Jafre",
		"indicador_refugi": "170852|LOCAL_SOCIAL_DE_JAFRE",
		"municipi": "Jafre",
		"codi_municipi": "170852",
		"latitud": "42.07518572",
		"longitud": "3.01153362",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Zona del Padró",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-regu_vway.e9dt",
		":version": "rv-uezj-zu2v-3fzd",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Sala polivalent de Jafre",
		"indicador_refugi": "170852|SALA_POLIVALENT_DE_JAFRE",
		"municipi": "Jafre",
		"codi_municipi": "170852",
		"latitud": "42.07206682",
		"longitud": "3.0107577",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Major, 1",
		"tipologia": "Sala polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-drja~u3zx.e4pz",
		":version": "rv-2fhp~ztwt~gx4s",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "170865|PISCINA_MUNICIPAL",
		"municipi": "Jonquera, la",
		"codi_municipi": "170865",
		"latitud": "42.41266",
		"longitud": "2.87354",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. 11 de setembre",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-nf7a~6cv9~7548",
		":version": "rv-tbxv.s67y_vdc6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Porxos de Can Laporta",
		"indicador_refugi": "170865|PORXOS_DE_CAN_LAPORTA",
		"municipi": "Jonquera, la",
		"codi_municipi": "170865",
		"latitud": "42.4159",
		"longitud": "2.87393",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Major, 2",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-chae~53a4.5ump",
		":version": "rv-ewz7_av2w-9jhd",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Salvador Espriu",
		"indicador_refugi": "251229|BIBLIOTECA_SALVADOR_ESPRIU",
		"municipi": "Linyola",
		"codi_municipi": "251229",
		"latitud": "41.71080996",
		"longitud": "0.90291821",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Pau Casals",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-mvmj~ym6u~mucv",
		":version": "rv-q3tq_tzs6_2ec2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Pavelló municipal de Linyola",
		"indicador_refugi": "251229|PAVELLO_MUNICIPAL_DE_LINYOLA",
		"municipi": "Linyola",
		"codi_municipi": "251229",
		"latitud": "41.7103357",
		"longitud": "0.89694713",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Creueta",
		"tipologia": "Poliesportiu",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-zjyh-rmc6.frxz",
		":version": "rv-rhzv-4q9h~8mjv",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Teatre Sindicat De Lladó",
		"indicador_refugi": "170887|TEATRE_SINDICAT_DE_LLADO",
		"municipi": "Lladó",
		"codi_municipi": "170887",
		"latitud": "42.24793446",
		"longitud": "2.81389114",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Major, 2",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-gng9-trz6_w9gu",
		":version": "rv-gv5f-xkrt-kbrx",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "251235|PISCINA_MUNICIPAL",
		"municipi": "Lladorre",
		"codi_municipi": "251235",
		"latitud": "42.64473386",
		"longitud": "1.25693057",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Únic, s/n",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-qdjf_syix~r4v5",
		":version": "rv-253i_y9gc-zh5f",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Julià Cutiller",
		"indicador_refugi": "170890|BIBLIOTECA_JULIA_CUTILLER",
		"municipi": "Llagostera",
		"codi_municipi": "170890",
		"latitud": "41.82681554",
		"longitud": "2.8963298",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Lleó I, 2",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-kn72.2yre~m7we",
		":version": "rv-n37j_8s5k_7bgs",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Cívic l'Estació",
		"indicador_refugi": "170904|CENTRE_CIVIC_LESTACIO",
		"municipi": "Llambilles",
		"codi_municipi": "170904",
		"latitud": "41.91955",
		"longitud": "2.84983",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Passeig del Carrilet, 14",
		"informacio_web": "de dimarts a diumenge de 9h a 20h",
		"tipologia": "Centre Cívic",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-04T14:27:00.000"
	},
	{
		":id": "row-y8f5~qpku-ttyg",
		":version": "rv-ssin.kbef.3upe",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Pèrgola solar Parc de l'Estació",
		"indicador_refugi": "170904|PERGOLA_SOLAR_PARC_DE_LESTACIO",
		"municipi": "Llambilles",
		"codi_municipi": "170904",
		"latitud": "41.919942",
		"longitud": "2.849874",
		"accessibilitat": "Sí",
		"aigua": "No",
		"climatitzacio": "No",
		"area_descans": "No",
		"lavabo": "No",
		"adreca": "Passeig del Carrilet",
		"informacio_web": "No hi ha horaris, és una pèrgola solar al Parc de l'Estació.",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-05T08:02:00.000"
	},
	{
		":id": "row-ahmw_3s9u.7tb8",
		":version": "rv-a4uf.bw27-vqan",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Edifici de serveis",
		"indicador_refugi": "170926|EDIFICI_DE_SERVEIS",
		"municipi": "Llançà",
		"codi_municipi": "170926",
		"latitud": "42.36251702",
		"longitud": "3.15353688",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. La Selva, 17-19",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-z4cp_kfxp-hdw4",
		":version": "rv-8b82-9pzw.2tq2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casa de cultura",
		"indicador_refugi": "170926|CASA_DE_CULTURA",
		"municipi": "Llançà",
		"codi_municipi": "170926",
		"latitud": "42.36362576",
		"longitud": "3.1521153",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Major, 3",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-prix~gtpe-xwbf",
		":version": "rv-bsfz_f4sh.pfst",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Ajuntament de Llançà",
		"indicador_refugi": "170926|AJUNTAMENT_DE_LLANCA",
		"municipi": "Llançà",
		"codi_municipi": "170926",
		"latitud": "42.36600502",
		"longitud": "3.15439518",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. Europa, 37",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-phkw-ksd7.qfyy",
		":version": "rv-xhe9-cwib_9jnw",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de gent gran",
		"indicador_refugi": "170926|CASAL_DE_GENT_GRAN",
		"municipi": "Llançà",
		"codi_municipi": "170926",
		"latitud": "42.36350002",
		"longitud": "3.15399889",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Cabrafiga, 15",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-yh8c-55bg_p9fa",
		":version": "rv-ysac_w3v7.fxc7",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Espai jove",
		"indicador_refugi": "170926|ESPAI_JOVE",
		"municipi": "Llançà",
		"codi_municipi": "170926",
		"latitud": "42.36376906",
		"longitud": "3.15431874",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Rafael Estela, 18",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-xcfb.a5ez~3pvv",
		":version": "rv-jy3u-83qy_dxyy",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca-Fonoteca de l'Auditori",
		"indicador_refugi": "251207|BIBLIOTECA_FONOTECA_DE_L_AUDITORI",
		"municipi": "Lleida",
		"codi_municipi": "251207",
		"latitud": "41.62003237",
		"longitud": "0.62842066",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pç. Josep Prenafeta, s/n",
		"informacio_web": "Del 15 de setembre al 15 juny (dilluns, dimarts i dimecres de 10.00 a 12.00 h- de dilluns a dijous de 16 a 20.30 h) Del 16 de juny al 15 de setembre (de dilluns a dijous de 10.00 a 13.30 h) De l'01 d'agost a 06 de setembre tancat",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-06-18T11:54:00.000"
	},
	{
		":id": "row-tsd3-76qa~cpxv",
		":version": "rv-xah7-cisc-z2xb",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre sènior Secà Sant Pere",
		"indicador_refugi": "251207|CENTRE_SENIOR_SECA_SANT_PERE",
		"municipi": "Lleida",
		"codi_municipi": "251207",
		"latitud": "41.63632961",
		"longitud": "0.62975604",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Sant Pere, 3",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-nr9m.8kpd~nb3t",
		":version": "rv-yjav_uusq-sftb",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic Balàfia",
		"indicador_refugi": "251207|CENTRE_CIVIC_BALAFIA",
		"municipi": "Lleida",
		"codi_municipi": "251207",
		"latitud": "41.62774314",
		"longitud": "0.62631271",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "No",
		"adreca": "C. Terrassa, 1",
		"informacio_web": "De dilluns a dijous (de 9.00 h a 14.00 h i de 16.00 h a 18.00 h) Divendres (de 09.00 h a 14:00 h tardes tancat)",
		"tipologia": "Centre Cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-06-18T12:14:00.000"
	},
	{
		":id": "row-ivn6-yhei.3m48",
		":version": "rv-wdiz.2crp.5g56",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre sènior de Bonaire",
		"indicador_refugi": "251207|CENTRE_SENIOR_DE_BONAIRE",
		"municipi": "Lleida",
		"codi_municipi": "251207",
		"latitud": "41.61971016",
		"longitud": "0.62226939",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Bonaire, 37",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-xz25~pjfr~qezn",
		":version": "rv-guav-5rh9_n7tv",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre d'Art La Panera",
		"indicador_refugi": "251207|CENTRE_D_ART_LA_PANERA",
		"municipi": "Lleida",
		"codi_municipi": "251207",
		"latitud": "41.61727618",
		"longitud": "0.62250939",
		"accessibilitat": "Sí",
		"aigua": "No",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pl. de la Panera, 2",
		"informacio_web": "De dimarts a dissabte, de 10.00 a 14.00 h i de 17.00 a 19.00 h  Diumenges i festius, d’11.00 a 14.00 h  Dilluns tancat",
		"tipologia": "Equipament Cultural (teatre, auditori, museu)",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-06-18T12:31:00.000"
	},
	{
		":id": "row-9dzu-tga3.brbm",
		":version": "rv-aqu3_ie2t~8g8u",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre sènior de la Bordeta",
		"indicador_refugi": "251207|CENTRE_SENIOR_DE_LA_BORDETA",
		"municipi": "Lleida",
		"codi_municipi": "251207",
		"latitud": "41.60530085",
		"longitud": "0.64253936",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Sant Jaume, 1",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-9vja.35rb-65kp",
		":version": "rv-agk2~prkm_7na8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "MORERA, Museu d'Art Modern i Contemporani de Lleida",
		"indicador_refugi": "251207|MORERA_MUSEU_D_ART_MODERN_I_CONTEMPORANI_DE_LLEIDA",
		"municipi": "Lleida",
		"codi_municipi": "251207",
		"latitud": "41.61770473",
		"longitud": "0.62959902",
		"accessibilitat": "Sí",
		"aigua": "No",
		"climatitzacio": "No",
		"area_descans": "No",
		"lavabo": "No",
		"adreca": "Rbla. de Ferran, 13",
		"tipologia": "Equipament Cultural (teatre, auditori, museu)",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-06-18T12:59:00.000"
	},
	{
		":id": "row-c7p8-g95e-f8fb",
		":version": "rv-ce2z-vwib~vngs",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre sènior de Santa Cecília",
		"indicador_refugi": "251207|CENTRE_SENIOR_DE_SANTA_CECILIA",
		"municipi": "Lleida",
		"codi_municipi": "251207",
		"latitud": "41.61296357",
		"longitud": "0.63290668",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Eduardo Velasco, 5",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-ydwn~n52q.rfdn",
		":version": "rv-jeb8-fd6w~v9rh",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic Mariola",
		"indicador_refugi": "251207|CENTRE_CIVIC_MARIOLA",
		"municipi": "Lleida",
		"codi_municipi": "251207",
		"latitud": "41.61313546",
		"longitud": "0.61143631",
		"accessibilitat": "No",
		"aigua": "No",
		"climatitzacio": "No",
		"area_descans": "No",
		"lavabo": "No",
		"adreca": "C. Artur Mor, 1",
		"informacio_web": "De dilluns a dijous (de 09.00 h a 14 h i de 16.00 h a 18.00 h) Divendres (de 09.00 h a 14.00, tardes tancat)",
		"tipologia": "Centre Cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-06-18T13:06:00.000"
	},
	{
		":id": "row-ydrg-ygk3_pgvn",
		":version": "rv-tb92-w3i3~ibnt",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre sènior de Democràcia",
		"indicador_refugi": "251207|CENTRE_SENIOR_DE_DEMOCRACIA",
		"municipi": "Lleida",
		"codi_municipi": "251207",
		"latitud": "41.6184704",
		"longitud": "0.63128043",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Comerç, 38",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-625c-itm6.i9vh",
		":version": "rv-399h-7pew-8iy3",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Museu de l'Aigua",
		"indicador_refugi": "251207|MUSEU_DE_L_AIGUA",
		"municipi": "Lleida",
		"codi_municipi": "251207",
		"latitud": "41.60374567",
		"longitud": "0.63587546",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. Miquel Batllori, 52",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-nt3i~gpn8_weev",
		":version": "rv-3kxf_yhvi_acp8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Cafeteria Centre cívic Pardinyes",
		"indicador_refugi": "251207|CAFETERIA_CENTRE_CIVIC_PARDINYES",
		"municipi": "Lleida",
		"codi_municipi": "251207",
		"latitud": "41.62615597",
		"longitud": "0.63799104",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Sant Pere Claver, 5",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-9be5_r47x_kpds",
		":version": "rv-z3fq-93q4~mvi9",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Cafeteria Centre cívic Secà Sant Pere",
		"indicador_refugi": "251207|CAFETERIA_CENTRE_CIVIC_SECA_SANT_PERE",
		"municipi": "Lleida",
		"codi_municipi": "251207",
		"latitud": "41.63605262",
		"longitud": "0.62904213",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Sant Pere, s/n",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-qqad_tykc.aj3b",
		":version": "rv-gkpu~ycwb-xvnp",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Lleida",
		"indicador_refugi": "251207|CASAL_CIVIC_I_COMUNITARI_LLEIDA",
		"municipi": "Lleida",
		"codi_municipi": "251207",
		"latitud": "41.6138154",
		"longitud": "0.6086086",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de la Mercè, 1",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-ig7s-ymbm.zdqz",
		":version": "rv-axe6~uw8j.65u6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Llar de Magraners",
		"indicador_refugi": "251207|LLAR_DE_MAGRANERS",
		"municipi": "Lleida",
		"codi_municipi": "251207",
		"latitud": "41.60983781",
		"longitud": "0.66253868",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Joan XXIII, 1",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-xag6-8cdr-xna3",
		":version": "rv-npxr~znzs.fmji",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Llar de Sucs",
		"indicador_refugi": "251207|LLAR_DE_SUCS",
		"municipi": "Lleida",
		"codi_municipi": "251207",
		"latitud": "41.70218156",
		"longitud": "0.41150841",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. del Bou, 2",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-3rg3-85vc.6gwu",
		":version": "rv-8kyc~j3uw.348b",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic Pl. Ereta",
		"indicador_refugi": "251207|CENTRE_CIVIC_PL_ERETA",
		"municipi": "Lleida",
		"codi_municipi": "251207",
		"latitud": "41.61519604",
		"longitud": "0.62289511",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Ereta, 10",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-f3iw-hw3y.9uh3",
		":version": "rv-gcsq-hthv_jvqg",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Museu de l'Automoció Roda Roda",
		"indicador_refugi": "251207|MUSEU_DE_L_AUTOMOCIO_RODA_RODA",
		"municipi": "Lleida",
		"codi_municipi": "251207",
		"latitud": "41.61350172",
		"longitud": "0.63279926",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Santa Cecília, 22 (davant dels Camps Elisis)",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-jj4v_3zxe-b2fx",
		":version": "rv-biq2-v389_nsxy",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre sènior Santa Teresina",
		"indicador_refugi": "251207|CENTRE_SENIOR_SANTA_TERESINA",
		"municipi": "Lleida",
		"codi_municipi": "251207",
		"latitud": "41.61688621",
		"longitud": "0.61519268",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Pica d'Estats, 4",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-x5jz.54u9-ziy2",
		":version": "rv-kt6a-q2jt.uqx4",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casa dels Gegants",
		"indicador_refugi": "251207|CASA_DELS_GEGANTS",
		"municipi": "Lleida",
		"codi_municipi": "251207",
		"latitud": "41.61278576",
		"longitud": "0.6241373",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Av. Blondel, 64",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-ekr4_3pyh-icnb",
		":version": "rv-vdzk~c2h5-btyq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca municipal de Pardinyes",
		"indicador_refugi": "251207|BIBLIOTECA_MUNICIPAL_DE_PARDINYES",
		"municipi": "Lleida",
		"codi_municipi": "251207",
		"latitud": "41.62644752",
		"longitud": "0.63797426",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Sant Pere Claver, 1",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-68st-2isz_nu4g",
		":version": "rv-maqj.si6p_6aa3",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre sènior el Pilar",
		"indicador_refugi": "251207|CENTRE_SENIOR_EL_PILAR",
		"municipi": "Lleida",
		"codi_municipi": "251207",
		"latitud": "41.62291793",
		"longitud": "0.61852094",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Tamarit de Llitera, 6",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-ngga_muic-d9pc",
		":version": "rv-nhyn~jafb_vwu6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic Pardinyes",
		"indicador_refugi": "251207|CENTRE_CIVIC_PARDINYES",
		"municipi": "Lleida",
		"codi_municipi": "251207",
		"latitud": "41.62615597",
		"longitud": "0.63799104",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Sant Pere Claver, 5",
		"informacio_web": "De dilluns a divendres de 09.00 h a 21.00 h (Excepte del 03 al 31 d'agost. tancat)",
		"tipologia": "Centre Cívic",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-18T13:31:00.000"
	},
	{
		":id": "row-c4m5_mwur~z7pv",
		":version": "rv-esvi_yyvz_r3b6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Residència Emera Ponent",
		"indicador_refugi": "251207|RESIDENCIA_EMERA_PONENT",
		"municipi": "Lleida",
		"codi_municipi": "251207",
		"latitud": "41.610593356000486",
		"longitud": "0.6256075815436868",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Jaume II, 55 (Cappont)",
		"informacio_web": "Dilluns, dimecres i divendres de 10.00 h a 15.00 h",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-25T12:38:00.000"
	},
	{
		":id": "row-cqw6~4r46.kev7",
		":version": "rv-jbdu-6jm2-wjxf",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc dels Camps Elisis",
		"indicador_refugi": "251207|PARC_DELS_CAMPS_ELISIS",
		"municipi": "Lleida",
		"codi_municipi": "251207",
		"latitud": "41.61399851358183",
		"longitud": "0.6316709518432618",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Av. de les Garrigues",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-25T13:19:00.000"
	},
	{
		":id": "row-am6i-pwsb.m3nz",
		":version": "rv-prxn_9u8m-y3jc",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de l'Aigua",
		"indicador_refugi": "251207|PARC_DE_LAIGUA",
		"municipi": "Lleida",
		"codi_municipi": "251207",
		"latitud": "41.604044489039914",
		"longitud": "0.6344251109367169",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça de Joan Oró, 51",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-25T13:30:00.000"
	},
	{
		":id": "row-bude~2t8j.fid3",
		":version": "rv-eeer~t2pn.n7y4",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça de les Magnòlies, alta",
		"indicador_refugi": "251207|PLACA_DE_LES_MAGNOLIES_ALTA",
		"municipi": "Lleida",
		"codi_municipi": "251207",
		"latitud": "41.62935787476094",
		"longitud": "0.6242295551195366",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Jardins de les Magnòlies",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-25T13:50:00.000"
	},
	{
		":id": "row-gjzm~3a76_i8bf",
		":version": "rv-ycr6-sjgy_2wqw",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de la Mitjana",
		"indicador_refugi": "251207|PARC_DE_LA_MITJANA",
		"municipi": "Lleida",
		"codi_municipi": "251207",
		"latitud": "41.62894165954645",
		"longitud": "0.6424608244286822",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Parc de la Mitjana",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-25T13:56:00.000"
	},
	{
		":id": "row-k58k~4kvz_b2c3",
		":version": "rv-hybp_haq8~b3ut",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Pardinyes-Av.Pearson",
		"indicador_refugi": "251207|PARDINYES-AVPEARSON",
		"municipi": "Lleida",
		"codi_municipi": "251207",
		"latitud": "41.62617418046948",
		"longitud": "0.6414029416689877",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Avinguda Pearson",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-26T09:15:00.000"
	},
	{
		":id": "row-k7ge_hfw9_6a38",
		":version": "rv-egbr-5dpq~d8mc",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Pardinyes-Carrer Xavier Puig Andreu",
		"indicador_refugi": "251207|PARDINYES-CARRER_XAVIER_PUIG_ANDREU",
		"municipi": "Lleida",
		"codi_municipi": "251207",
		"latitud": "41.62839923886911",
		"longitud": "0.6397325532649851",
		"accessibilitat": "Sí",
		"aigua": "No",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Xavier Puig Andreu",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-26T09:35:00.000"
	},
	{
		":id": "row-ucjf~b6xe-apej",
		":version": "rv-tgny~kbc8-uwzk",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Balàfia-Pl.Maria Aurèlia Capmany",
		"indicador_refugi": "251207|BALAFIA-PLMARIA_AURELIA_CAPMANY",
		"municipi": "Lleida",
		"codi_municipi": "251207",
		"latitud": "41.62739840454327",
		"longitud": "0.6274471821013134",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Maria Aurèlia Capmany",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-26T09:54:00.000"
	},
	{
		":id": "row-7f6x~kjem~zbzg",
		":version": "rv-2ied-5nnt~uv6c",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bosc Urbà de Balàfia",
		"indicador_refugi": "251207|BOSC_URBA_DE_BALAFIA",
		"municipi": "Lleida",
		"codi_municipi": "251207",
		"latitud": "41.62980583128363",
		"longitud": "0.6291862397741136",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Av. Torrevicens -C. Corregidor Escofet",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-26T10:07:00.000"
	},
	{
		":id": "row-3xiz~bq9m_afxv",
		":version": "rv-ug7d.c6tb~95sp",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Clot i confluències (vianants)",
		"indicador_refugi": "251207|CLOT_I_CONFLUENCIES_(VIANANTS)",
		"municipi": "Lleida",
		"codi_municipi": "251207",
		"latitud": "41.62091610281549",
		"longitud": "0.6221395384130501",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Humbert Torres  (zona vianants)",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-26T10:24:00.000"
	},
	{
		":id": "row-vte5.6hg7_2y2u",
		":version": "rv-nz5r.xbms~3rec",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Seu Vella-Sta. Cecília",
		"indicador_refugi": "251207|PARC_SEU_VELLA-STA_CECILIA",
		"municipi": "Lleida",
		"codi_municipi": "251207",
		"latitud": "41.619993749979535",
		"longitud": "0.6257658851020031",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Darrera Sant Marti",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-26T10:45:00.000"
	},
	{
		":id": "row-9fne-uqay~dibv",
		":version": "rv-hgvm_b5mz-98qj",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Mariola-Pl. Galícia",
		"indicador_refugi": "251207|MARIOLA-PL_GALICIA",
		"municipi": "Lleida",
		"codi_municipi": "251207",
		"latitud": "41.613074549261185",
		"longitud": "0.611812297446157",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pl. Galícia",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-26T11:00:00.000"
	},
	{
		":id": "row-idje_zdtw.qnvv",
		":version": "rv-8gww_9ny4-8tv5",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Mariola-Espai de les Moreres i Jardins Primer de Maig",
		"indicador_refugi": "251207|MARIOLA-ESPAI_DE_LES_MORERES_I_JARDINS_PRIMER_DE_MAIG",
		"municipi": "Lleida",
		"codi_municipi": "251207",
		"latitud": "41.615548077231665",
		"longitud": "0.6110421839552875",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. de la Mercè",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-26T11:10:00.000"
	},
	{
		":id": "row-h4kx-mbx5.h3pe",
		":version": "rv-nr2t_gzxa_q9m8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Universitat-Jardins UDL-Pl. Victor Siurana",
		"indicador_refugi": "251207|UNIVERSITAT-JARDINS_UDL-PL_VICTOR_SIURANA",
		"municipi": "Lleida",
		"codi_municipi": "251207",
		"latitud": "41.61480122467979",
		"longitud": "0.6196099363437211",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça Victor Siurana",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-26T11:13:00.000"
	},
	{
		":id": "row-ymu6~dtfx~bi5v",
		":version": "rv-ie68~vipi~tt59",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Escorxador/Instituts-Av. Joana Raspall",
		"indicador_refugi": "251207|ESCORXADOR-INSTITUTS-AV_JOANA_RASPALL",
		"municipi": "Lleida",
		"codi_municipi": "251207",
		"latitud": "41.608793765044865",
		"longitud": "0.6202482015182395",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Av. Joana Raspall",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-26T11:20:00.000"
	},
	{
		":id": "row-7f39.4u4x_y72u",
		":version": "rv-7zs5_e292.nnkd",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Escorxador/Instituts-C. Ton Sirera",
		"indicador_refugi": "251207|ESCORXADOR-INSTITUTS-C_TON_SIRERA",
		"municipi": "Lleida",
		"codi_municipi": "251207",
		"latitud": "41.606106416347465",
		"longitud": "0.6167313109367989",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Ton Sirera",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-26T12:09:00.000"
	},
	{
		":id": "row-stdn~pgdx_vcft",
		":version": "rv-yx4y~4zuc~agz5",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Històric/Noguerola: Rambla Ferran-Pl.de la Pau",
		"indicador_refugi": "251207|CENTRE_HISTORIC-NOGUEROLA_RAMBLA_FERRAN-PLDE_LA_PAU",
		"municipi": "Lleida",
		"codi_municipi": "251207",
		"latitud": "41.61588714992888",
		"longitud": "0.6288167397735558",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pl. de la Pau",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-26T12:12:00.000"
	},
	{
		":id": "row-22bm-3q2p.37ge",
		":version": "rv-e453~6yfi_v9ie",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Cappont: C. Doctora Castells",
		"indicador_refugi": "251207|CAPPONT_C_DOCTORA_CASTELLS",
		"municipi": "Lleida",
		"codi_municipi": "251207",
		"latitud": "41.610264814751226",
		"longitud": "0.629114597446046",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Doctora Castells",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-26T12:17:00.000"
	},
	{
		":id": "row-z9z9-26qy-mx8j",
		":version": "rv-fqdm-ax5v_6buh",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Cappont: C. Jaume II",
		"indicador_refugi": "251207|CAPPONT_C_JAUME_II",
		"municipi": "Lleida",
		"codi_municipi": "251207",
		"latitud": "41.609786250810174",
		"longitud": "0.6245837127914635",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Jaume II",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-26T12:20:00.000"
	},
	{
		":id": "row-md5k-q9nc~zi3f",
		":version": "rv-4a3e~sp2q~dv7f",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Cappont:  Parc Fluvial del Segre",
		"indicador_refugi": "251207|CAPPONT__PARC_FLUVIAL_DEL_SEGRE",
		"municipi": "Lleida",
		"codi_municipi": "251207",
		"latitud": "41.61148608433256",
		"longitud": "0.6245629888910584",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Jaume II",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-26T12:41:00.000"
	},
	{
		":id": "row-vfa5_7qc8_67a8",
		":version": "rv-dmxm~xjyn_6a87",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Cappont: Pl. Blas Infante",
		"indicador_refugi": "251207|CAPPONT_PL_BLAS_INFANTE",
		"municipi": "Lleida",
		"codi_municipi": "251207",
		"latitud": "41.612148936787115",
		"longitud": "0.6280764109370633",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pl. Blas Infante",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-26T12:43:00.000"
	},
	{
		":id": "row-655w~m722-k753",
		":version": "rv-jmn8~66mn~qtfn",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Cappont: Bosc Urbà de Cappont",
		"indicador_refugi": "251207|CAPPONT_BOSC_URBA_DE_CAPPONT",
		"municipi": "Lleida",
		"codi_municipi": "251207",
		"latitud": "41.60944709510147",
		"longitud": "0.6320155958519994",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer d'Esperanza González, 13",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-26T12:46:00.000"
	},
	{
		":id": "row-n5gd_xqqj.u5i7",
		":version": "rv-4xj7~7a46-awnj",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Magraners: C. Vila Rodona",
		"indicador_refugi": "251207|MAGRANERS_C_VILA_RODONA",
		"municipi": "Lleida",
		"codi_municipi": "251207",
		"latitud": "41.60771151553867",
		"longitud": "0.6653192534624223",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Vila Rodona",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-26T12:53:00.000"
	},
	{
		":id": "row-xf4j.zkpe~cmv8",
		":version": "rv-63fx_h7qn_bphe",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Magraners:  Pl. Joan XXIII",
		"indicador_refugi": "251207|MAGRANERS__PL_JOAN_XXIII",
		"municipi": "Lleida",
		"codi_municipi": "251207",
		"latitud": "41.60915295254288",
		"longitud": "0.663371082100581",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pl. Joan XXIII",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-26T12:56:00.000"
	},
	{
		":id": "row-rcks~nkn2.q2ps",
		":version": "rv-nyq6.ic7s.ivpq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Magraners: Bosc Urbà de Mangraners",
		"indicador_refugi": "251207|MAGRANERS_BOSC_URBA_DE_MANGRANERS",
		"municipi": "Lleida",
		"codi_municipi": "251207",
		"latitud": "41.607266953515094",
		"longitud": "0.6619156815477095",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Camp",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-26T13:01:00.000"
	},
	{
		":id": "row-288f_tisr-ddph",
		":version": "rv-hfrb.v8kb-iw37",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bordeta: Pl. Sant Jordi",
		"indicador_refugi": "251207|BORDETA_PL_SANT_JORDI",
		"municipi": "Lleida",
		"codi_municipi": "251207",
		"latitud": "41.602092925994945",
		"longitud": "0.6424038031719569",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pl. Sant Jordi",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-26T13:06:00.000"
	},
	{
		":id": "row-dx42_628j.8g3f",
		":version": "rv-qrhg_9ds9-awej",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bordeta: Plaça Major",
		"indicador_refugi": "251207|BORDETA_PLACA_MAJOR",
		"municipi": "Lleida",
		"codi_municipi": "251207",
		"latitud": "41.60260883855064",
		"longitud": "0.6448309686093769",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça Major",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-26T13:12:00.000"
	},
	{
		":id": "row-pxn9~5xwx-2bf9",
		":version": "rv-hv5p_gqha.jct6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bosquet de la Bordeta",
		"indicador_refugi": "251207|BOSQUET_DE_LA_BORDETA",
		"municipi": "Lleida",
		"codi_municipi": "251207",
		"latitud": "41.60955402960903",
		"longitud": "0.6483622416277872",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Palauet, 119",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-26T13:15:00.000"
	},
	{
		":id": "row-3ma5~d4a9-mbzf",
		":version": "rv-rf2h.89it-wqbi",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bordeta: C. del Campament",
		"indicador_refugi": "251207|BORDETA_C_DEL_CAMPAMENT",
		"municipi": "Lleida",
		"codi_municipi": "251207",
		"latitud": "41.60588752773614",
		"longitud": "0.6366869262822252",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. del Campament",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-26T13:19:00.000"
	},
	{
		":id": "row-4r7f-na96_dkag",
		":version": "rv-cyb9_ebxr~s9rc",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bordeta: Plaça del Molí de Sant Anastasi",
		"indicador_refugi": "251207|BORDETA_PLACA_DEL_MOLI_DE_SANT_ANASTASI",
		"municipi": "Lleida",
		"codi_municipi": "251207",
		"latitud": "41.60560536224757",
		"longitud": "0.6388245839549547",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pl. del Molí de Sant Anastasi",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-26T13:30:00.000"
	},
	{
		":id": "row-i64f-3dbx-cqj5",
		":version": "rv-z7pa~ib2u-3vmg",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Secà Sant Pere:  Plaça Sant Pere",
		"indicador_refugi": "251207|SECA_SANT_PERE__PLACA_SANT_PERE",
		"municipi": "Lleida",
		"codi_municipi": "251207",
		"latitud": "41.63598656007599",
		"longitud": "0.6296190920881237",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pl. Sant Pere",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-26T13:35:00.000"
	},
	{
		":id": "row-k65b-tvws.g7vm",
		":version": "rv-pp6k_rzpd.nhma",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jardins de Francesc Solana",
		"indicador_refugi": "251207|JARDINS_DE_FRANCESC_SOLANA",
		"municipi": "Lleida",
		"codi_municipi": "251207",
		"latitud": "41.63102032024285",
		"longitud": "0.6293920821014647",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Av. Torre Vicens, 53",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-26T13:41:00.000"
	},
	{
		":id": "row-cug9.g7gb-dtrz",
		":version": "rv-ae6f.v5e9-dui8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de Sant Anastasi (Llivia)",
		"indicador_refugi": "251207|PARC_DE_SANT_ANASTASI_(LLIVIA)",
		"municipi": "Lleida",
		"codi_municipi": "251207",
		"latitud": "41.648423621186886",
		"longitud": "0.6394733598830484",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Gran (Llivia)",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-26T13:56:00.000"
	},
	{
		":id": "row-v6ca.jdbs.jbe2",
		":version": "rv-wcsg~zhj2.q6tt",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Arborètum",
		"indicador_refugi": "251207|ARBORETUM",
		"municipi": "Lleida",
		"codi_municipi": "251207",
		"latitud": "41.626988873052575",
		"longitud": "0.6020207434830004",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Enric Farreny, 49",
		"informacio_web": "De Juny a setembre de dimarts a diumenge (de les 10 a les 13 h i de les 16 a les 20h) excepte juliol i agost: de les 10 a les 13 h i de les 18 a les 20:30 h",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-26T14:12:00.000"
	},
	{
		":id": "row-qmmw.kbpb_c97q",
		":version": "rv-z4iq.c5tm_42ra",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de la Gent Gran de Palaudàries",
		"indicador_refugi": "081075|CASAL_DE_LA_GENT_GRAN_DE_PALAUDARIES",
		"municipi": "Lliçà d'Amunt",
		"codi_municipi": "081075",
		"latitud": "41.59191668",
		"longitud": "2.20289922",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Ctra. de Palaudàries, 88",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-axdd-q27g-v3di",
		":version": "rv-q9sm~3k9g-727n",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de la Gent Gran del Centre",
		"indicador_refugi": "081075|CASAL_DE_LA_GENT_GRAN_DEL_CENTRE",
		"municipi": "Lliçà d'Amunt",
		"codi_municipi": "081075",
		"latitud": "41.61225827",
		"longitud": "2.23930914",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Folch i Torres, 102",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-patw~rdpz_umbr",
		":version": "rv-jmrx~w6qv~tqk7",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "081075|PISCINA_MUNICIPAL",
		"municipi": "Lliçà d'Amunt",
		"codi_municipi": "081075",
		"latitud": "41.6089785",
		"longitud": "2.24282657",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. dels Països Catalans, s/n",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-cev2-m7hr_m3f8",
		":version": "rv-v2s6-a8ry~tdwx",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Local Social de Ca l'Artigues",
		"indicador_refugi": "081075|LOCAL_SOCIAL_DE_CA_L_ARTIGUES",
		"municipi": "Lliçà d'Amunt",
		"codi_municipi": "081075",
		"latitud": "41.61741224",
		"longitud": "2.21676117",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Ribera d'Ebre, 81, 08186 LLiçà d'Amunt",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-d4c2.b9kg~747z",
		":version": "rv-f4zz_me59-txg7",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de la gent gran",
		"indicador_refugi": "081081|CASAL_DE_LA_GENT_GRAN",
		"municipi": "Lliçà de Vall",
		"codi_municipi": "081081",
		"latitud": "41.58762814",
		"longitud": "2.23896406",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Montsià, 46",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-tyep.4ttw-4enp",
		":version": "rv-ytvh~xk56.cj7t",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de joves El Kaliu",
		"indicador_refugi": "081081|CASAL_DE_JOVES_EL_KALIU",
		"municipi": "Lliçà de Vall",
		"codi_municipi": "081081",
		"latitud": "41.58543728",
		"longitud": "2.23910584",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pg. de l'Església, 1",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-twqa~fv5v-26v8",
		":version": "rv-eee8_ge8u~juyw",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Oficina d'Atenció a la Ciutadania (Ajuntament)",
		"indicador_refugi": "081081|OFICINA_D_ATENCIO_A_LA_CIUTADANIA_AJUNTAMENT",
		"municipi": "Lliçà de Vall",
		"codi_municipi": "081081",
		"latitud": "41.58639733",
		"longitud": "2.23917166",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. de la Vila, s/n",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-2bse.5889-pss5",
		":version": "rv-trf9_4u57~e2db",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "251288|PISCINA_MUNICIPAL",
		"municipi": "Llimiana",
		"codi_municipi": "251288",
		"latitud": "42.07470596",
		"longitud": "0.91718659",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de la font, 1",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-mc3p-fcri~gwtg",
		":version": "rv-c6u9-tvth-rjzd",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Llinars del vallès",
		"indicador_refugi": "081069|CASAL_CIVIC_I_COMUNITARI_LLINARS_DEL_VALLES",
		"municipi": "Llinars del Vallès",
		"codi_municipi": "081069",
		"latitud": "41.6375444",
		"longitud": "2.3907059",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Ramon y Cajal - Av. de Granollers",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-zvzc_38j4.wtta",
		":version": "rv-8td7_wp6u-2m8s",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "La Devesa de l'Àrea Central",
		"indicador_refugi": "081069|LA_DEVESA_DE_L_AREA_CENTRAL",
		"municipi": "Llinars del Vallès",
		"codi_municipi": "081069",
		"latitud": "41.63985272",
		"longitud": "2.40252967",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. Pau Casals, 4",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-zb9m~39qk~xtym",
		":version": "rv-prb2-3g9s~xh7p",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Mas Bagà",
		"indicador_refugi": "081069|MAS_BAGA",
		"municipi": "Llinars del Vallès",
		"codi_municipi": "081069",
		"latitud": "41.64027455",
		"longitud": "2.40511934",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. Mas Bagà, 24",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-faku~97p5-uvmx",
		":version": "rv-cigd~f82f_7xvv",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "170947|PISCINA_MUNICIPAL",
		"municipi": "Llívia",
		"codi_municipi": "170947",
		"latitud": "42.46022899",
		"longitud": "1.98102865",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Parc de Sant Guillem",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-sbbg.7dfm.ucbp",
		":version": "rv-m2hc-ktqw_viwp",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "POLIESPORTIU DE LLÍVIA",
		"indicador_refugi": "170947|POLIESPORTIU_DE_LLIVIA",
		"municipi": "Llívia",
		"codi_municipi": "170947",
		"latitud": "42.46168080914811",
		"longitud": "1.9797081279748476",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer de l'Esport, 3, 17527 Llívia, Girona",
		"informacio_web": "POLIESPORTIU DE LLIVIA",
		"tipologia": "Pavelló Esportiu",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-03T09:31:00.000"
	},
	{
		":id": "row-cczi~2hjx-3pww",
		":version": "rv-ue5q_hhbj-qytx",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "LOCAL SOCIAL (MENJADOR)",
		"indicador_refugi": "251291|LOCAL_SOCIAL_(MENJADOR)",
		"municipi": "Llobera",
		"codi_municipi": "251291",
		"latitud": "41.5519",
		"longitud": "1.2749",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Local social de Llobera",
		"informacio_web": "horari oficina (de 09:00 a 14:00)",
		"tipologia": "Sala Polivalent",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-09T11:07:00.000"
	},
	{
		":id": "row-6u3i_54ig~5fqq",
		":version": "rv-56i5.nw8v~c73r",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Mestra Maria Rafecas",
		"indicador_refugi": "430748|BIBLIOTECA_MESTRA_MARIA_RAFECAS",
		"municipi": "Llorenç del Penedès",
		"codi_municipi": "430748",
		"latitud": "41.28194233214649",
		"longitud": "1.5515694551054264",
		"accessibilitat": "Sí",
		"aigua": "No",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Rb.Marinada, 27",
		"informacio_web": "https://llorenc.cat/biblioteca-2/",
		"tipologia": "Biblioteca",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-04T08:35:00.000"
	},
	{
		":id": "row-bf32.r6zi.2x9b",
		":version": "rv-pje3-s9tw_z8rg",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina Municipal de Llorenç del Penedès",
		"indicador_refugi": "430748|PISCINA_MUNICIPAL_DE_LLORENC_DEL_PENEDES",
		"municipi": "Llorenç del Penedès",
		"codi_municipi": "430748",
		"latitud": "41.280225886469466",
		"longitud": "1.54643426065344",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Zona Esportiva- Cami de Cal Prosset",
		"informacio_web": "https://llorenc.cat/piscina-municipal/",
		"tipologia": "Piscines descobertes",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-04T08:42:00.000"
	},
	{
		":id": "row-jeyd-85i4_s2g7",
		":version": "rv-c8yi.dgh9_tg23",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca municipal",
		"indicador_refugi": "170950|BIBLIOTECA_MUNICIPAL",
		"municipi": "Lloret de Mar",
		"codi_municipi": "170950",
		"latitud": "41.700302",
		"longitud": "2.84432",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pl. de Pere Torrent, 1",
		"informacio_web": "https://www.lloret.cat/ca/seccions/biblioteca-municipal",
		"tipologia": "Biblioteca",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-25T18:36:00.000"
	},
	{
		":id": "row-g7ji~355c.8zj8",
		":version": "rv-zufx.cvyi.wkju",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Punt d'informació juvenil El Puntet",
		"indicador_refugi": "170950|PUNT_DINFORMACIO_JUVENIL_EL_PUNTET",
		"municipi": "Lloret de Mar",
		"codi_municipi": "170950",
		"latitud": "41.705147",
		"longitud": "2.842544",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Av. de Vidreres, 58",
		"informacio_web": "https://www.lloret.cat/ca/seccions/joventut/pij-el-puntet",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-25T18:41:00.000"
	},
	{
		":id": "row-q4um_dkxu_dip4",
		":version": "rv-yaq7.ifwf.hbzg",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Punt d'informació juvenil El Puntet de Fenals",
		"indicador_refugi": "170950|PUNT_DINFORMACIO_JUVENIL_EL_PUNTET_DE_FENALS",
		"municipi": "Lloret de Mar",
		"codi_municipi": "170950",
		"latitud": "41.697082",
		"longitud": "2.830732",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pl. Esteve Fàbregas",
		"informacio_web": "https://www.lloret.cat/ca/seccions/joventut/",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-25T18:44:00.000"
	},
	{
		":id": "row-5vnd.84pn-kcqe",
		":version": "rv-cvwq_rsp7_vz3q",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Museu del Mar - Oficina de turisme",
		"indicador_refugi": "170950|MUSEU_DEL_MAR_-_OFICINA_DE_TURISME",
		"municipi": "Lloret de Mar",
		"codi_municipi": "170950",
		"latitud": "41.69959",
		"longitud": "2.850761",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pg. Camprodon i Arrieta, 1",
		"informacio_web": "https://patrimoni.lloret.cat/ca/moll-museu-obert-de-lloret/museu-del-mar",
		"tipologia": "Equipament Cultural (teatre, auditori, museu)",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-25T18:49:00.000"
	},
	{
		":id": "row-9jp7_qxh2.cbnh",
		":version": "rv-3gpa-8y5a_556e",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Cívic El Rieral",
		"indicador_refugi": "170950|CENTRE_CIVIC_EL_RIERAL",
		"municipi": "Lloret de Mar",
		"codi_municipi": "170950",
		"latitud": "41.706729",
		"longitud": "2.839468",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Joan Fuster i Ortells, 14",
		"informacio_web": "https://www.lloret.cat/ca/seccions/participacio-ciutadana/barris-i-centres-civics/el-rieral",
		"tipologia": "Centre Cívic",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-25T18:52:00.000"
	},
	{
		":id": "row-wm8b.fkgb_mb8e",
		":version": "rv-3fmf.sksv_czan",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic El Molí",
		"indicador_refugi": "170950|CENTRE_CIVIC_EL_MOLI",
		"municipi": "Lloret de Mar",
		"codi_municipi": "170950",
		"latitud": "41.708011",
		"longitud": "2.841374",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Av. de les Regions, 4",
		"informacio_web": "https://www.lloret.cat/ca/seccions/participacio-ciutadana/barris-i-centres-civics/el-moli-mas-vila-can-ribalaigua",
		"tipologia": "Centre Cívic",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-25T18:54:00.000"
	},
	{
		":id": "row-e3m6-349s.cjai",
		":version": "rv-yif4-f4zc-kqky",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Zona boscosa platja de Fenals",
		"indicador_refugi": "170950|ZONA_BOSCOSA_PLATJA_DE_FENALS",
		"municipi": "Lloret de Mar",
		"codi_municipi": "170950",
		"latitud": "41.69439",
		"longitud": "2.830404",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Platja de Fenals",
		"informacio_web": "https://lloretdemar.org/platja/platja-fenals/",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-25T19:10:00.000"
	},
	{
		":id": "row-d4zn-p9yy~4f8z",
		":version": "rv-xmwk_79vu_nwcv",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc urbà de can Xardó",
		"indicador_refugi": "170950|PARC_URBA_DE_CAN_XARDO",
		"municipi": "Lloret de Mar",
		"codi_municipi": "170950",
		"latitud": "41.704757",
		"longitud": "2.846036",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Av. Vila de Tossa, s/n",
		"informacio_web": "www.lloret.cat",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-25T19:12:00.000"
	},
	{
		":id": "row-jmef.kzmn-ztms",
		":version": "rv-m2hv-8hdn_iv9r",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Àrea d'esbarjo parc d'en Fofó",
		"indicador_refugi": "170950|AREA_DESBARJO_PARC_DEN_FOFO",
		"municipi": "Lloret de Mar",
		"codi_municipi": "170950",
		"latitud": "41.703634",
		"longitud": "2.842863",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. dels Mestres, 9",
		"informacio_web": "www.lloret.cat",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-25T19:14:00.000"
	},
	{
		":id": "row-nvse-s6ix_6wcs",
		":version": "rv-t25n.ivfn.sypr",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de jubilats de Residencial Parc",
		"indicador_refugi": "171030|CASAL_DE_JUBILATS_DE_RESIDENCIAL_PARC",
		"municipi": "Maçanet de la Selva",
		"codi_municipi": "171030",
		"latitud": "41.78180186",
		"longitud": "2.70209733",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Xiprer, 20",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-wzdj.23kg_6b8g",
		":version": "rv-xujm-2uxt~n8i6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal de Maçanet de la Selva",
		"indicador_refugi": "171030|PISCINA_MUNICIPAL_DE_MACANET_DE_LA_SELVA",
		"municipi": "Maçanet de la Selva",
		"codi_municipi": "171030",
		"latitud": "41.77599851",
		"longitud": "2.72952897",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Av. Passeig Sant Llorenç, 1",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-miqv~5676.duca",
		":version": "rv-bg5s~k3bv~eaan",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca municipal de Maçanet de la Selva",
		"indicador_refugi": "171030|BIBLIOTECA_MUNICIPAL_DE_MACANET_DE_LA_SELVA",
		"municipi": "Maçanet de la Selva",
		"codi_municipi": "171030",
		"latitud": "41.77790052",
		"longitud": "2.73121496",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Cabrera, 12",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-gued~vned_q6g4",
		":version": "rv-p2cb_23xv~a8ww",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal dels jubilats del Poble",
		"indicador_refugi": "171030|CASAL_DELS_JUBILATS_DEL_POBLE",
		"municipi": "Maçanet de la Selva",
		"codi_municipi": "171030",
		"latitud": "41.77841248",
		"longitud": "2.73437546",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Dolors, 48",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-ejmk-2n43.cbvm",
		":version": "rv-eyvf_4jmk.2vgb",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CIR de Madremanya",
		"indicador_refugi": "170979|CIR_DE_MADREMANYA",
		"municipi": "Madremanya",
		"codi_municipi": "170979",
		"latitud": "41.9914",
		"longitud": "2.9561",
		"accessibilitat": "No",
		"aigua": "No",
		"climatitzacio": "No",
		"area_descans": "No",
		"lavabo": "No",
		"adreca": "c/ del Quintar, 4",
		"informacio_web": "http://cirmadremanya.com",
		"tipologia": "Centre Cívic",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-09T11:05:00.000"
	},
	{
		":id": "row-qkrn.6ydv_t67m",
		":version": "rv-rrd2~72sf~jgjb",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Pavelló de Madremanya",
		"indicador_refugi": "170979|PAVELLO_DE_MADREMANYA",
		"municipi": "Madremanya",
		"codi_municipi": "170979",
		"latitud": "41.9913",
		"longitud": "2.9551",
		"accessibilitat": "No",
		"aigua": "No",
		"climatitzacio": "No",
		"area_descans": "No",
		"lavabo": "No",
		"adreca": "c/ del Quintar, 3",
		"informacio_web": "https://madremanya.cat/guia-del-poble/equipaments-publics/pavello-municipal/",
		"tipologia": "Pavelló Esportiu",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-09T11:06:00.000"
	},
	{
		":id": "row-t4dq.7x9j_ivx4",
		":version": "rv-6zad.qkwt.hnf8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal Ernest Lluch",
		"indicador_refugi": "170985|PISCINA_MUNICIPAL_ERNEST_LLUCH",
		"municipi": "Maià de Montcal",
		"codi_municipi": "170985",
		"latitud": "42.21933975",
		"longitud": "2.7459502",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Girona, 3",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-ncva.e6bk-rmny",
		":version": "rv-atvj~x7sf.ypc2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscines municipals de Maials",
		"indicador_refugi": "251333|PISCINES_MUNICIPALS_DE_MAIALS",
		"municipi": "Maials",
		"codi_municipi": "251333",
		"latitud": "41.36404758",
		"longitud": "0.50992985",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Barceloneta, s/n",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-tuhr_tjpb~rqq5",
		":version": "rv-hvkd_jfy6_nzsk",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de la Plaça (ASVAT)",
		"indicador_refugi": "081120|CASAL_DE_LA_PLACA_ASVAT",
		"municipi": "Manlleu",
		"codi_municipi": "081120",
		"latitud": "42.00077908",
		"longitud": "2.28365376",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Fra Bernadí, 4",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-ckcf~h3wt_46cj",
		":version": "rv-hwbh.kmcm-w9ci",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Sala exposicions Can Puget",
		"indicador_refugi": "081120|SALA_EXPOSICIONS_CAN_PUGET",
		"municipi": "Manlleu",
		"codi_municipi": "081120",
		"latitud": "42.0012186",
		"longitud": "2.28361007",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Pl. de Dalt Vila, 3",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-z3ny_dyax~9mnn",
		":version": "rv-3phs_6659.nck7",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca municipal de Manlleu",
		"indicador_refugi": "081120|BIBLIOTECA_MUNICIPAL_DE_MANLLEU",
		"municipi": "Manlleu",
		"codi_municipi": "081120",
		"latitud": "42.00021113",
		"longitud": "2.285109",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. del Pont, 16-18 2a planta",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-2gme_fddn.vipe",
		":version": "rv-qrpu_f67r_esey",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Mercat municipal de Manlleu",
		"indicador_refugi": "081120|MERCAT_MUNICIPAL_DE_MANLLEU",
		"municipi": "Manlleu",
		"codi_municipi": "081120",
		"latitud": "42.00496648",
		"longitud": "2.285371",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "No",
		"adreca": "C. Pintor Guàrdia, 6",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-7evq_xawj-xqbf",
		":version": "rv-mz6i.iikw_hamm",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic Selves i Carner",
		"indicador_refugi": "081136|CENTRE_CIVIC_SELVES_I_CARNER",
		"municipi": "Manresa",
		"codi_municipi": "081136",
		"latitud": "41.72740779",
		"longitud": "1.81923091",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Bernat i Oller, 14-16",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-rgwj_idjt.t54a",
		":version": "rv-vmdn_32rr-w22g",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Associació de veïns Passeig i rodalies",
		"indicador_refugi": "081136|ASSOCIACIO_DE_VEINS_PASSEIG_I_RODALIES",
		"municipi": "Manresa",
		"codi_municipi": "081136",
		"latitud": "41.72523958",
		"longitud": "1.82332377",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Jaume I, 8, entresòl",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-beem.4xf9-bvh6",
		":version": "rv-xbjj-6ntf_pkv9",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Oficina de turisme",
		"indicador_refugi": "081136|OFICINA_DE_TURISME",
		"municipi": "Manresa",
		"codi_municipi": "081136",
		"latitud": "41.72358836",
		"longitud": "1.82745709",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Major, 10",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-irui~38z4~v4gt",
		":version": "rv-975n-hgyv~5v6r",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Associació de veïns del barri de Sant Pau",
		"indicador_refugi": "081136|ASSOCIACIO_DE_VEINS_DEL_BARRI_DE_SANT_PAU",
		"municipi": "Manresa",
		"codi_municipi": "081136",
		"latitud": "41.7145811",
		"longitud": "1.82817842",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Cardener, 12 -14",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-jter_6fj8~rube",
		":version": "rv-f8w2-tedb-am6n",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Associació de veïns Font dels Capellans",
		"indicador_refugi": "081136|ASSOCIACIO_DE_VEINS_FONT_DELS_CAPELLANS",
		"municipi": "Manresa",
		"codi_municipi": "081136",
		"latitud": "41.7286496",
		"longitud": "1.83787812",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Font dels Capellans octogonal 14, local 75",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-vgum_tpnj.qwyk",
		":version": "rv-y2z5_drx9_wmtb",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "El Casino",
		"indicador_refugi": "081136|EL_CASINO",
		"municipi": "Manresa",
		"codi_municipi": "081136",
		"latitud": "41.7271055",
		"longitud": "1.82340831",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pg. Pere III, 29",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-a2pm~4g6u_7zee",
		":version": "rv-xshr~stzp-ftc6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Ateneu Les Bases",
		"indicador_refugi": "081136|BIBLIOTECA_ATENEU_LES_BASES",
		"municipi": "Manresa",
		"codi_municipi": "081136",
		"latitud": "41.73515831",
		"longitud": "1.83008622",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Cintaires, 30-32",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-uip9-re2v_x2nr",
		":version": "rv-4sz5.i8xr_tmwc",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Oficina d'Atenció Econòmica (OAE)",
		"indicador_refugi": "081136|OFICINA_D_ATENCIO_ECONOMICA_OAE",
		"municipi": "Manresa",
		"codi_municipi": "081136",
		"latitud": "41.72389101",
		"longitud": "1.82653503",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Major, 17",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-xb87_35nq-ijfj",
		":version": "rv-qm4f_kvv3_bygh",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Manresa - el Castell",
		"indicador_refugi": "081136|CASAL_CIVIC_I_COMUNITARI_MANRESA_EL_CASTELL",
		"municipi": "Manresa",
		"codi_municipi": "081136",
		"latitud": "41.7302173",
		"longitud": "1.8241549",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de Circumval·lació, 60",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-m6tv.yvp7-upm8",
		":version": "rv-zazr.wwjh_npr2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Oficines municipals de Serveis econòmics",
		"indicador_refugi": "081136|OFICINES_MUNICIPALS_DE_SERVEIS_ECONOMICS",
		"municipi": "Manresa",
		"codi_municipi": "081136",
		"latitud": "41.72342072",
		"longitud": "1.82733535",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Major, 5",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-hdug~984k_gxxx",
		":version": "rv-9e2p.z8zm_f2aa",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de les Escodines",
		"indicador_refugi": "081136|CASAL_DE_LES_ESCODINES",
		"municipi": "Manresa",
		"codi_municipi": "081136",
		"latitud": "41.72247854",
		"longitud": "1.83048432",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Sant Bartomeu, 50 - 54",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-qcxy~t4zv~tnih",
		":version": "rv-y3eg-42yb.mscs",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Palau Firal",
		"indicador_refugi": "081136|PALAU_FIRAL",
		"municipi": "Manresa",
		"codi_municipi": "081136",
		"latitud": "41.73880557",
		"longitud": "1.8471999",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Castelladral, 5 -7",
		"tipologia": "Espai firal",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-qnte-vvr8_4tw4",
		":version": "rv-a2ec.heg7-wh5u",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Alberg de Joventut",
		"indicador_refugi": "081136|ALBERG_DE_JOVENTUT",
		"municipi": "Manresa",
		"codi_municipi": "081136",
		"latitud": "41.7246376",
		"longitud": "1.8261963",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Mil centenari, s/n",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-idw9.sqcz-cduq",
		":version": "rv-57ww-3g6v~9m97",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal cívic i comunitari Font dels Capellans",
		"indicador_refugi": "081136|CASAL_CIVIC_I_COMUNITARI_FONT_DELS_CAPELLANS",
		"municipi": "Manresa",
		"codi_municipi": "081136",
		"latitud": "41.72987301",
		"longitud": "1.83882462",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Granollers, s/n",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-hvwe_ar4r.tum7",
		":version": "rv-6z97_ptpy_zaqv",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Manresa - Mion Puigberenguer",
		"indicador_refugi": "081136|CASAL_CIVIC_I_COMUNITARI_MANRESA_MION_PUIGBERENGUER",
		"municipi": "Manresa",
		"codi_municipi": "081136",
		"latitud": "41.738344",
		"longitud": "1.8041056",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. de la Democràcia, 1",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-3z6r_pw4p_d97p",
		":version": "rv-mrkd_uubz.dtm9",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Oficina d'Atenció al Ciutadà",
		"indicador_refugi": "081136|OFICINA_D_ATENCIO_AL_CIUTADA",
		"municipi": "Manresa",
		"codi_municipi": "081136",
		"latitud": "41.72317487",
		"longitud": "1.82697783",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Major, 1",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-q9xi.uzpa-itfc",
		":version": "rv-ty5w.wuvp-w2p5",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de joves la Kampana",
		"indicador_refugi": "081136|CASAL_DE_JOVES_LA_KAMPANA",
		"municipi": "Manresa",
		"codi_municipi": "081136",
		"latitud": "41.7222968",
		"longitud": "1.82291715",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Icària, s/n",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-9ff5-k3gc.rkez",
		":version": "rv-ehs9~8me2~ymnn",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Manresa - Pare Ignasi Puig",
		"indicador_refugi": "081136|CASAL_CIVIC_I_COMUNITARI_MANRESA_PARE_IGNASI_PUIG",
		"municipi": "Manresa",
		"codi_municipi": "081136",
		"latitud": "41.7259263",
		"longitud": "1.801194",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Grup d'Habitatges El Xup, s/n",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-u57t_z3gp~nqp5",
		":version": "rv-nx8g~a52u_ps2t",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic Joan Amades",
		"indicador_refugi": "081136|CENTRE_CIVIC_JOAN_AMADES",
		"municipi": "Manresa",
		"codi_municipi": "081136",
		"latitud": "41.72314004",
		"longitud": "1.83872346",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Sant Blai, 14",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-6a38~65at.gidw",
		":version": "rv-vf58_ip66-cubx",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Associació de veïns Valldaura",
		"indicador_refugi": "081136|ASSOCIACIO_DE_VEINS_VALLDAURA",
		"municipi": "Manresa",
		"codi_municipi": "081136",
		"latitud": "41.7243339",
		"longitud": "1.81756932",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Ausiàs March, 10",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-6u8x_26mw.yejk",
		":version": "rv-xvrv-zfpq-izq9",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Associació de veïns de Cal Gravat",
		"indicador_refugi": "081136|ASSOCIACIO_DE_VEINS_DE_CAL_GRAVAT",
		"municipi": "Manresa",
		"codi_municipi": "081136",
		"latitud": "41.7199929",
		"longitud": "1.84393072",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Cal Gravat, 2 i 5 baixos",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-7ne9_hcr8~bk5w",
		":version": "rv-xqwy~8ghv~eir3",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Associació de veïns Mion-Puigberenguer",
		"indicador_refugi": "081136|ASSOCIACIO_DE_VEINS_MION_PUIGBERENGUER",
		"municipi": "Manresa",
		"codi_municipi": "081136",
		"latitud": "41.7374814",
		"longitud": "1.82132022",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Florida, 24, 08242 Manresa",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-mmpm-k8w8.qwr8",
		":version": "rv-wz9g~k9b7-jqrh",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Espai cívic El Safareig",
		"indicador_refugi": "081154|ESPAI_CIVIC_EL_SAFAREIG",
		"municipi": "Martorelles",
		"codi_municipi": "081154",
		"latitud": "41.52600937",
		"longitud": "2.23661633",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Parc de Can Sunyer",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-hg5s_j4wb.whgk",
		":version": "rv-6yzd-bv7v-sn54",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Lolita Mila",
		"indicador_refugi": "081154|BIBLIOTECA_LOLITA_MILA",
		"municipi": "Martorelles",
		"codi_municipi": "081154",
		"latitud": "41.52936272",
		"longitud": "2.24127802",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. del Dr. Santiago Tiffon, 21",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-gmzu.nyz6_5mnn",
		":version": "rv-y56v-66xc-fjdu",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal de Martorelles",
		"indicador_refugi": "081154|PISCINA_MUNICIPAL_DE_MARTORELLES",
		"municipi": "Martorelles",
		"codi_municipi": "081154",
		"latitud": "41.52584789",
		"longitud": "2.23594325",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. del Parc, s/n",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-6kdw~j8z3_72qx",
		":version": "rv-777t.xrpd.9v46",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Espai polivalent La Vinya",
		"indicador_refugi": "081154|ESPAI_POLIVALENT_LA_VINYA",
		"municipi": "Martorelles",
		"codi_municipi": "081154",
		"latitud": "41.52813562",
		"longitud": "2.22946591",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Trav. de Carrencà, 8",
		"tipologia": "Sala polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-rfqb~fhpv~rk7t",
		":version": "rv-wbg2-j6d7.vdxc",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CENTRE CIVIC",
		"indicador_refugi": "430770|CENTRE_CIVIC",
		"municipi": "Mas de Barberans",
		"codi_municipi": "430770",
		"latitud": "40.73573440048861",
		"longitud": "0.739210072043808",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C/ MOLÍ, 26",
		"tipologia": "Centre Cívic",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-01T10:57:00.000"
	},
	{
		":id": "row-2zki~afc3~igrv",
		":version": "rv-b9is~xjes-maaa",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Masdenverge Actiu",
		"indicador_refugi": "430786|CENTRE_MASDENVERGE_ACTIU",
		"municipi": "Masdenverge",
		"codi_municipi": "430786",
		"latitud": "40.71910105",
		"longitud": "0.53131081",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Ctra. d'Amposta, 11, 43878 Masdenverge, Tarragona",
		"informacio_web": "www.masdenverge.cat",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-06-02T13:23:00.000"
	},
	{
		":id": "row-a49n~swd9~7d9v",
		":version": "rv-5g7t_m46v.7777",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Sala polivalent de les Masies de Roda",
		"indicador_refugi": "081167|SALA_POLIVALENT_DE_LES_MASIES_DE_RODA",
		"municipi": "Masies de Roda, les",
		"codi_municipi": "081167",
		"latitud": "41.99049201",
		"longitud": "2.30678342",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Ctra. de Manlleu, s/n",
		"tipologia": "Sala polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-6sfg_4ukx-8tez",
		":version": "rv-8qam-i46v.97ie",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Ajuntament de Les Masies de Voltregà",
		"indicador_refugi": "081173|AJUNTAMENT_DE_LES_MASIES_DE_VOLTREGA",
		"municipi": "Masies de Voltregà, les",
		"codi_municipi": "081173",
		"latitud": "42.01252738",
		"longitud": "2.25011556",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Ctra. c-17z pk 70.4, 08508 Les Masies de Voltregà",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-eukx-rvzp~4i9c",
		":version": "rv-5drn_rvvk.wy2v",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casa del Marquès",
		"indicador_refugi": "081189|CASA_DEL_MARQUES",
		"municipi": "Masnou, el",
		"codi_municipi": "081189",
		"latitud": "41.47807183",
		"longitud": "2.30445872",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pg. del Bellresguard, 12",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-sxpt_qq2j.bfih",
		":version": "rv-sv8y-uqjh.kcng",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jardins de Can Targa",
		"indicador_refugi": "081189|JARDINS_DE_CAN_TARGA",
		"municipi": "Masnou, el",
		"codi_municipi": "081189",
		"latitud": "41.47641871",
		"longitud": "2.3064563",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Can Targa, s/n",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-um8b_csw5.wnhd",
		":version": "rv-didf.db6a-g6tp",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de gent gran de Can Malet",
		"indicador_refugi": "081189|CASAL_DE_GENT_GRAN_DE_CAN_MALET",
		"municipi": "Masnou, el",
		"codi_municipi": "081189",
		"latitud": "41.47985316",
		"longitud": "2.31930974",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Sant Felip, 2",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-fca5~25cc-z72f",
		":version": "rv-cx94~2nej~nksh",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc del Llac",
		"indicador_refugi": "081189|PARC_DEL_LLAC",
		"municipi": "Masnou, el",
		"codi_municipi": "081189",
		"latitud": "41.47873777",
		"longitud": "2.30359728",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Ptge. Bellresguard, s/n",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-3ecg~4xsr-nis4",
		":version": "rv-mh2n~gmad.7iez",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jardins del Mestre Lluís Millet",
		"indicador_refugi": "081189|JARDINS_DEL_MESTRE_LLUIS_MILLET",
		"municipi": "Masnou, el",
		"codi_municipi": "081189",
		"latitud": "41.48309263",
		"longitud": "2.31989957",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. Cusí Fortunet, 21",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-spdb-3cmc_fd7c",
		":version": "rv-sjuy.i5rt-apq6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Passadís central Edifici Centre",
		"indicador_refugi": "081189|PASSADIS_CENTRAL_EDIFICI_CENTRE",
		"municipi": "Masnou, el",
		"codi_municipi": "081189",
		"latitud": "41.48243567",
		"longitud": "2.3161181",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Itàlia, 50",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-d95p-t32r_hhtc",
		":version": "rv-fpd7~nciv~tsm8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casa de la Vila",
		"indicador_refugi": "081189|CASA_DE_LA_VILA",
		"municipi": "Masnou, el",
		"codi_municipi": "081189",
		"latitud": "41.47919247",
		"longitud": "2.31914488",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Prat de la Riba, 1",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-zipe-dncm_i2qx",
		":version": "rv-hshy.fkap-zje8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de gent gran Can Mandri",
		"indicador_refugi": "081189|CASAL_DE_GENT_GRAN_CAN_MANDRI",
		"municipi": "Masnou, el",
		"codi_municipi": "081189",
		"latitud": "41.48752348",
		"longitud": "2.30777747",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Ametllers, 12",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-pxe6-syeh-j6eu",
		":version": "rv-g8gd-4h96~huda",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de Caramar",
		"indicador_refugi": "081189|PARC_DE_CARAMAR",
		"municipi": "Masnou, el",
		"codi_municipi": "081189",
		"latitud": "41.48248634",
		"longitud": "2.32051897",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Joan Miro, s/n",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-gk5m~3c2d_59v8",
		":version": "rv-6ew7-rqkg.e6ap",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jardins de Can Malet",
		"indicador_refugi": "081189|JARDINS_DE_CAN_MALET",
		"municipi": "Masnou, el",
		"codi_municipi": "081189",
		"latitud": "41.47959277",
		"longitud": "2.31943078",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Ptge. Maria Rossell, 9",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-yi6q-bxtv-cgcp",
		":version": "rv-iws3.rns7-mgxs",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jardins Països Catalans",
		"indicador_refugi": "081189|JARDINS_PAISOS_CATALANS",
		"municipi": "Masnou, el",
		"codi_municipi": "081189",
		"latitud": "41.48208715",
		"longitud": "2.32814555",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Manila, 19",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-t8c8.5ekr_j3ee",
		":version": "rv-fxbn-wkty_4nx6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Oficina Atenció Ciutadà (OAC)",
		"indicador_refugi": "081189|OFICINA_ATENCIO_CIUTADA_OAC",
		"municipi": "Masnou, el",
		"codi_municipi": "081189",
		"latitud": "41.47964465",
		"longitud": "2.31809242",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Igualtat, 1",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-3xjy_yjuc.8x92",
		":version": "rv-ep7p.2ner-27zg",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc dels Vivers",
		"indicador_refugi": "081189|PARC_DELS_VIVERS",
		"municipi": "Masnou, el",
		"codi_municipi": "081189",
		"latitud": "41.48747522",
		"longitud": "2.32254692",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Verge de Núria, s/n",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-m9w8_2k5t~9h7n",
		":version": "rv-h7m9~5rqk.hf6m",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Els Vienesos",
		"indicador_refugi": "081189|ELS_VIENESOS",
		"municipi": "Masnou, el",
		"codi_municipi": "081189",
		"latitud": "41.48511548",
		"longitud": "2.30727542",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Segarra, 12",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-dyp5_n9aw.6h46",
		":version": "rv-yu6s-5mkk.szg7",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Espai veïnal Masnou Alt",
		"indicador_refugi": "081189|ESPAI_VEINAL_MASNOU_ALT",
		"municipi": "Masnou, el",
		"codi_municipi": "081189",
		"latitud": "41.48643302",
		"longitud": "2.31123514",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Ramon i Cajal",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-fgun_wdam_3vtt",
		":version": "rv-x7qy-295z~yhe8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Museu municipal de Nàutica",
		"indicador_refugi": "081189|MUSEU_MUNICIPAL_DE_NAUTICA",
		"municipi": "Masnou, el",
		"codi_municipi": "081189",
		"latitud": "41.48277263",
		"longitud": "2.31574595",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Pujades Truch, 1",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-5vim~v6n9~sbem",
		":version": "rv-jv7w~t6tw_vdgk",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jardins de Lluís Companys",
		"indicador_refugi": "081189|JARDINS_DE_LLUIS_COMPANYS",
		"municipi": "Masnou, el",
		"codi_municipi": "081189",
		"latitud": "41.48539044",
		"longitud": "2.3097492",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. Joan XXIII, s/n",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-x9cj-rvit_dm6y",
		":version": "rv-h3hc.zqqb.nzfq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Carrer Esperança",
		"indicador_refugi": "081189|CARRER_ESPERANCA",
		"municipi": "Masnou, el",
		"codi_municipi": "081189",
		"latitud": "41.48024924",
		"longitud": "2.31861691",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Esperança, s/n",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-7t2s-pdnv_dt58",
		":version": "rv-tuxm-sc3a.wdts",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casa de Cultura",
		"indicador_refugi": "081189|CASA_DE_CULTURA",
		"municipi": "Masnou, el",
		"codi_municipi": "081189",
		"latitud": "41.47949016",
		"longitud": "2.32044155",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Prat de la Riba, 16",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-9rbu-djj8_ssrg",
		":version": "rv-xi9u~dsdx_i6es",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jardins de les Nacions",
		"indicador_refugi": "081189|JARDINS_DE_LES_NACIONS",
		"municipi": "Masnou, el",
		"codi_municipi": "081189",
		"latitud": "41.48763875",
		"longitud": "2.30891485",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Can Mandri, 2",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-rkbs_if3w~ctk5",
		":version": "rv-w866~jmv5~aww2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Vallmora",
		"indicador_refugi": "081189|PARC_VALLMORA",
		"municipi": "Masnou, el",
		"codi_municipi": "081189",
		"latitud": "41.48492496",
		"longitud": "2.31496159",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Montevideo, 56",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-kzyw~hbgn_xkqa",
		":version": "rv-nw49-de9d.sma2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de gent gran Ocata",
		"indicador_refugi": "081189|CASAL_DE_GENT_GRAN_OCATA",
		"municipi": "Masnou, el",
		"codi_municipi": "081189",
		"latitud": "41.48230652",
		"longitud": "2.3248057",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Jaume I, 121",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-nkuv-3yym-jqhm",
		":version": "rv-8ztk-vu66.3wiy",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Creu Roja Masnou",
		"indicador_refugi": "081189|CREU_ROJA_MASNOU",
		"municipi": "Masnou, el",
		"codi_municipi": "081189",
		"latitud": "41.48347287",
		"longitud": "2.33687596",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pg. de la Riera, s/n",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-3spt~wpjp-bdte",
		":version": "rv-j749_jygc.j7dz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Mercat municipal",
		"indicador_refugi": "081189|MERCAT_MUNICIPAL",
		"municipi": "Masnou, el",
		"codi_municipi": "081189",
		"latitud": "41.482648263080726",
		"longitud": "2.3164301189946186",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Itàlia, 50",
		"informacio_web": "https://www.mercatdelmasnou.cat/",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-12T09:33:00.000"
	},
	{
		":id": "row-i2rw~zibf-cuhy",
		":version": "rv-qwh8~hu46-g7ee",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Joan Coromines",
		"indicador_refugi": "081189|BIBLIOTECA_JOAN_COROMINES",
		"municipi": "Masnou, el",
		"codi_municipi": "081189",
		"latitud": "41.48284647760909",
		"longitud": "2.3159647039420066",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Josep Pujadas Truch, 1 A, 08320 El Masnou, Barcelona",
		"informacio_web": "http://bibliotecavirtual.diba.cat/masnou-el-biblioteca-joan-coromines",
		"tipologia": "Biblioteca",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-12T10:28:00.000"
	},
	{
		":id": "row-b4ti_7uhx.udxk",
		":version": "rv-nqjk~aenw.krhs",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Equipament Cívic Els Masovers",
		"indicador_refugi": "081189|EQUIPAMENT_CIVIC_ELS_MASOVERS",
		"municipi": "Masnou, el",
		"codi_municipi": "081189",
		"latitud": "41.48010514638161",
		"longitud": "2.3046301198380026",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Rosa Sensat, 08320 Barcelona",
		"tipologia": "Centre Cívic",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-12T10:30:00.000"
	},
	{
		":id": "row-rewp~ymaq_mctu",
		":version": "rv-ch8u.hqth-ge2m",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Espai veïnal del Cul d’Ocata",
		"indicador_refugi": "081189|ESPAI_VEINAL_DEL_CUL_D’OCATA",
		"municipi": "Masnou, el",
		"codi_municipi": "081189",
		"latitud": "41.48317815834714",
		"longitud": "2.3284454298076724",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Paraguai, 10, 08320 El Masnou, Barcelona",
		"tipologia": "Centre Cívic",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-12T10:31:00.000"
	},
	{
		":id": "row-ze63~4irb_qixn",
		":version": "rv-j2zs_gqwm~j35u",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça Ramon i Cajal",
		"indicador_refugi": "081189|PLACA_RAMON_I_CAJAL",
		"municipi": "Masnou, el",
		"codi_municipi": "081189",
		"latitud": "41.486793165875795",
		"longitud": "2.311743596005727",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça Ramon i Cajal",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-12T11:05:00.000"
	},
	{
		":id": "row-xngi.yyrv.bnrd",
		":version": "rv-zxx2.9na9-3h2p",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc dels Pinetons",
		"indicador_refugi": "081189|PARC_DELS_PINETONS",
		"municipi": "Masnou, el",
		"codi_municipi": "081189",
		"latitud": "41.482598460961704",
		"longitud": "2.3124361800638233",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Av. Joan XXIII, 60, 08320 El Masnou, Barcelona",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-12T11:08:00.000"
	},
	{
		":id": "row-u8gk.vj6f.dm4v",
		":version": "rv-pxdx_qe7c_zm7z",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jardins de la Nimfa",
		"indicador_refugi": "081189|JARDINS_DE_LA_NIMFA",
		"municipi": "Masnou, el",
		"codi_municipi": "081189",
		"latitud": "41.48232231878614",
		"longitud": "2.3327303785744395",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Jardins de la Nimfa",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-12T11:09:00.000"
	},
	{
		":id": "row-hesq.vnuq~9t9u",
		":version": "rv-v6uz.hsyz.as5d",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça Vila de Madrid",
		"indicador_refugi": "081189|PLACA_VILA_DE_MADRID",
		"municipi": "Masnou, el",
		"codi_municipi": "081189",
		"latitud": "41.48210852787594",
		"longitud": "2.32798004697873",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça Vila de Madrid",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-12T11:12:00.000"
	},
	{
		":id": "row-cg43~8dht.8a33",
		":version": "rv-s7an~a29s_gv7q",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça Miquel Martí i Pol",
		"indicador_refugi": "081189|PLACA_MIQUEL_MARTI_I_POL",
		"municipi": "Masnou, el",
		"codi_municipi": "081189",
		"latitud": "41.48309364220762",
		"longitud": "2.317132992060575",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça Miquel Martí i Pol",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-12T11:13:00.000"
	},
	{
		":id": "row-afuk-nuv6.zu3u",
		":version": "rv-8d8c-fmei~ui3h",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça d'Ocata",
		"indicador_refugi": "081189|PLACA_DOCATA",
		"municipi": "Masnou, el",
		"codi_municipi": "081189",
		"latitud": "41.481803773008416",
		"longitud": "2.3252753080292554",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça d'Ocata",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-12T11:16:00.000"
	},
	{
		":id": "row-2wmu-s4pb_843f",
		":version": "rv-rr6h.jkxt~a6pf",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça Espanya",
		"indicador_refugi": "081189|PLACA_ESPANYA",
		"municipi": "Masnou, el",
		"codi_municipi": "081189",
		"latitud": "41.4827670061434",
		"longitud": "2.3153727205904837",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça Espanya",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-12T11:17:00.000"
	},
	{
		":id": "row-wyxr_72hx_cg9y",
		":version": "rv-mh4y_944m-zwxi",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça Jaume Bertran",
		"indicador_refugi": "081189|PLACA_JAUME_BERTRAN",
		"municipi": "Masnou, el",
		"codi_municipi": "081189",
		"latitud": "41.480066293126455",
		"longitud": "2.321750188386581",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça Jaume Bertran",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-12T11:18:00.000"
	},
	{
		":id": "row-tj59-y7wz.wwti",
		":version": "rv-mu8q~gszy~23fz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc del Mil·lenari",
		"indicador_refugi": "081189|PARC_DEL_MILLENARI",
		"municipi": "Masnou, el",
		"codi_municipi": "081189",
		"latitud": "41.482404823480316",
		"longitud": "2.326760435334349",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Jaume I, 119, 08320 El Masnou,",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-18T14:22:00.000"
	},
	{
		":id": "row-iru8.z7b2-azv6",
		":version": "rv-qi93.mw2m.xgdm",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Pista poliesportiva",
		"indicador_refugi": "430810|PISTA_POLIESPORTIVA",
		"municipi": "Maspujols",
		"codi_municipi": "430810",
		"latitud": "41.18044230664091",
		"longitud": "1.046271482450014",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "No",
		"lavabo": "No",
		"adreca": "Avinguda poliesportiu S/N",
		"informacio_web": "https://maspujols.cat/",
		"tipologia": "Pavelló Esportiu",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-02T12:25:00.000"
	},
	{
		":id": "row-ekvf~m3gr~u93x",
		":version": "rv-fcgq.e738.nctc",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Oficina d'Atenció al Vilatà de l'Ajuntament de Masquefa",
		"indicador_refugi": "081192|OFICINA_DATENCIO_AL_VILATA_DE_LAJUNTAMENT_DE_MASQUEFA",
		"municipi": "Masquefa",
		"codi_municipi": "081192",
		"latitud": "41.50221",
		"longitud": "1.811215",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Major, 93",
		"informacio_web": "https://masquefa.cat/oficina-atencio-vilata/",
		"tipologia": "Ajuntament / Equipament Administratiu",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-01T12:32:00.000"
	},
	{
		":id": "row-q9hz-2hxm_srjf",
		":version": "rv-3ejf-vpa4~jkix",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Tecnològic Comunitari (CTC)",
		"indicador_refugi": "081192|CENTRE_TECNOLOGIC_COMUNITARI_(CTC)",
		"municipi": "Masquefa",
		"codi_municipi": "081192",
		"latitud": "41.500461",
		"longitud": "1.81424",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Avinguda Catalunya 56-62",
		"informacio_web": "https://masquefa.cat/tic/",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-01T12:37:00.000"
	},
	{
		":id": "row-yckz.e3m3~itsq",
		":version": "rv-qczs_d789.dkk4",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca M. Carme Junyent Figueras",
		"indicador_refugi": "081192|BIBLIOTECA_M_CARME_JUNYENT_FIGUERAS",
		"municipi": "Masquefa",
		"codi_municipi": "081192",
		"latitud": "41.50036",
		"longitud": "1.81375",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Rogelio Rojo,5-9",
		"informacio_web": "https://masquefa.cat/cultura/",
		"tipologia": "Biblioteca",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-01T12:42:00.000"
	},
	{
		":id": "row-hhff.ervc.jvut",
		":version": "rv-83yw.vjc8-fja5",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de Joves Masquefa",
		"indicador_refugi": "081192|CASAL_DE_JOVES_MASQUEFA",
		"municipi": "Masquefa",
		"codi_municipi": "081192",
		"latitud": "41.49969",
		"longitud": "1.81456",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Santa Clara 16-22",
		"informacio_web": "https://masquefa.cat/joventut/",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-01T12:46:00.000"
	},
	{
		":id": "row-h3x3-jtcf_kz69",
		":version": "rv-x4ji_sstm-fia2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal d'Avis de Masquefa",
		"indicador_refugi": "081192|CASAL_DAVIS_DE_MASQUEFA",
		"municipi": "Masquefa",
		"codi_municipi": "081192",
		"latitud": "41.50208",
		"longitud": "1.81245",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Escoles, 6",
		"informacio_web": "https://masquefa.cat/gent-gran/",
		"tipologia": "Casal de Gent Gran",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-01T12:49:00.000"
	},
	{
		":id": "row-surv.gzzz~e8bs",
		":version": "rv-ybsp.jv3k-hr4k",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Fisart",
		"indicador_refugi": "081192|FISART",
		"municipi": "Masquefa",
		"codi_municipi": "081192",
		"latitud": "41.50077",
		"longitud": "1.81328",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Avinguda Catalunya 68-74 local 2",
		"informacio_web": "https://fisart.es",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-02T11:18:00.000"
	},
	{
		":id": "row-685q~btpt_4vxb",
		":version": "rv-5ck8-6cxa.bj2f",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Kushala",
		"indicador_refugi": "081192|KUSHALA",
		"municipi": "Masquefa",
		"codi_municipi": "081192",
		"latitud": "41.49928",
		"longitud": "1.8173",
		"accessibilitat": "No",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Avinguda la Línia 4-6 local 1",
		"informacio_web": "https://kushalaayurveda.es/",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-02T12:45:00.000"
	},
	{
		":id": "row-fqt3-btzu~vefn",
		":version": "rv-7496_2ry8.xapk",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Farmàcia Masquefa",
		"indicador_refugi": "081192|FARMACIA_MASQUEFA",
		"municipi": "Masquefa",
		"codi_municipi": "081192",
		"latitud": "41.50178",
		"longitud": "1.81393",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Major 1",
		"informacio_web": "https://www.farmaciamasquefa.com/",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-02T12:50:00.000"
	},
	{
		":id": "row-dnqb-swj2~sviv",
		":version": "rv-3bcy~gm8t~2phj",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Punt Taronja (Hiper Galícia Can Parellada)",
		"indicador_refugi": "081192|PUNT_TARONJA_(HIPER_GALICIA_CAN_PARELLADA)",
		"municipi": "Masquefa",
		"codi_municipi": "081192",
		"latitud": "41.5004515",
		"longitud": "1.8294492",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carretera B-224 Km. 17.5 Can Parellada",
		"informacio_web": "https://punttaronja.com/",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-02T13:51:00.000"
	},
	{
		":id": "row-tpzp_cwuy~maf3",
		":version": "rv-tiur-9z5h_ytjk",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Farmàcia Durban",
		"indicador_refugi": "081192|FARMACIA_DURBAN",
		"municipi": "Masquefa",
		"codi_municipi": "081192",
		"latitud": "41.49987",
		"longitud": "1.81633",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Doctor Rotllant 43",
		"informacio_web": "https://www.farmaciaclotildedurbanfmas.com/",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-02T13:55:00.000"
	},
	{
		":id": "row-q37w_uqgk~gg4f",
		":version": "rv-fr7s-hxq9~838w",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Cafeteria CTC",
		"indicador_refugi": "081192|CAFETERIA_CTC",
		"municipi": "Masquefa",
		"codi_municipi": "081192",
		"latitud": "41.50063",
		"longitud": "1.81452",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Avinguda Catalunya 58",
		"informacio_web": "ctc.cafeteria.bar.masquefa",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-02T14:24:00.000"
	},
	{
		":id": "row-9bgz~f2hn-bghk",
		":version": "rv-pw42-e7by.b3f4",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Mora Tradició Fornera",
		"indicador_refugi": "081192|MORA_TRADICIO_FORNERA",
		"municipi": "Masquefa",
		"codi_municipi": "081192",
		"latitud": "41.49907",
		"longitud": "1.8162",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Avinguda Línia 7",
		"informacio_web": "https://panaderiaminutos.es/12485-mora-tradicio-fornera-panaderia-en-masquefa-barcelona/",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-02T14:28:00.000"
	},
	{
		":id": "row-nvze-7dza_ntmb",
		":version": "rv-gfqx.jj9h-j35q",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "La Lluna Cafeteria",
		"indicador_refugi": "081192|LA_LLUNA_CAFETERIA",
		"municipi": "Masquefa",
		"codi_municipi": "081192",
		"latitud": "41.49919",
		"longitud": "1.81506",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Avinguda Línia 15",
		"informacio_web": "https://cafeterisimos.com/la-lluna-cafeteria-masquefa/",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-02T14:33:00.000"
	},
	{
		":id": "row-s3st-9yt9.qp9d",
		":version": "rv-9svq-vxaw_ttfr",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Mora Tradició Fornera Can Parellada",
		"indicador_refugi": "081192|MORA_TRADICIO_FORNERA_CAN_PARELLADA",
		"municipi": "Masquefa",
		"codi_municipi": "081192",
		"latitud": "41.50025",
		"longitud": "1.83049",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carretera de Martorell a Capellades 29 Can Parellada",
		"informacio_web": "https://pamora.net/",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-03T11:20:00.000"
	},
	{
		":id": "row-ym2h~neyg_ip7n",
		":version": "rv-6y5m~ucuk-p7ys",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal social",
		"indicador_refugi": "251312|CASAL_SOCIAL",
		"municipi": "Massalcoreig",
		"codi_municipi": "251312",
		"latitud": "41.45777718",
		"longitud": "0.3584095",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. del Casal, s/n",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-awzg-4s5p~hx5e",
		":version": "rv-niy9~rea8_japs",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Local social 1 d'octubre",
		"indicador_refugi": "171019|LOCAL_SOCIAL_1_D_OCTUBRE",
		"municipi": "Massanes",
		"codi_municipi": "171019",
		"latitud": "41.76667433",
		"longitud": "2.6519036",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Montseny, 1",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-t8ua-c8eq~bpvn",
		":version": "rv-9bcv_butc-9p6n",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de la Gent Gran",
		"indicador_refugi": "081206|CASAL_DE_LA_GENT_GRAN",
		"municipi": "Matadepera",
		"codi_municipi": "081206",
		"latitud": "41.59741942",
		"longitud": "2.02643738",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Ctra Terrassa, 35",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-x87k_a554~jtis",
		":version": "rv-tb54.4wwi-kg8u",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscines municipals",
		"indicador_refugi": "081206|PISCINES_MUNICIPALS",
		"municipi": "Matadepera",
		"codi_municipi": "081206",
		"latitud": "41.60413023",
		"longitud": "2.02063561",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Mariapfarr, 8",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-db5p-adjg.qj36",
		":version": "rv-ing7.za7j-j5up",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "L'Hotel - Punt Jove",
		"indicador_refugi": "081206|L_HOTEL_PUNT_JOVE",
		"municipi": "Matadepera",
		"codi_municipi": "081206",
		"latitud": "41.5989415",
		"longitud": "2.02710847",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Sant Isidre, 35",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-b7eb_sesu~h6tu",
		":version": "rv-tfm4-4deb~u8ey",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de Cultura",
		"indicador_refugi": "081206|CASAL_DE_CULTURA",
		"municipi": "Matadepera",
		"codi_municipi": "081206",
		"latitud": "41.59949061",
		"longitud": "2.02823356",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Pere Aldavert, 4",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-yswz.7gfi-8hef",
		":version": "rv-rkgb_yshu_dspx",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Pompeu Fabra",
		"indicador_refugi": "081213|BIBLIOTECA_POMPEU_FABRA",
		"municipi": "Mataró",
		"codi_municipi": "081213",
		"latitud": "41.53842258",
		"longitud": "2.43371181",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Pl. d'Occitania, s/n",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-8kw6-vjad.7w5y",
		":version": "rv-7fza~4buj_5j3a",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de la gent gran Del Parc",
		"indicador_refugi": "081213|CASAL_DE_LA_GENT_GRAN_DEL_PARC",
		"municipi": "Mataró",
		"codi_municipi": "081213",
		"latitud": "41.54541559",
		"longitud": "2.44022183",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Av. Corregiment de Mataró, 28",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-wc8d~rdba~k4s2",
		":version": "rv-hpps_cs2p.yfns",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic Espai Gatassa",
		"indicador_refugi": "081213|CENTRE_CIVIC_ESPAI_GATASSA",
		"municipi": "Mataró",
		"codi_municipi": "081213",
		"latitud": "41.53785968",
		"longitud": "2.42847476",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. de Josep Montserrat i Cuadrada, 1",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-56uz_7xzd.7qaa",
		":version": "rv-qyks.biw6-vxu8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Antoni Comas",
		"indicador_refugi": "081213|BIBLIOTECA_ANTONI_COMAS",
		"municipi": "Mataró",
		"codi_municipi": "081213",
		"latitud": "41.54481449",
		"longitud": "2.45323949",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. d'Enric Pla de la Riba, 110",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-n9w7.9bvw.3reu",
		":version": "rv-4a35~nead-7vrq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Cívic Rocafonda",
		"indicador_refugi": "081213|CENTRE_CIVIC_ROCAFONDA",
		"municipi": "Mataró",
		"codi_municipi": "081213",
		"latitud": "41.548953",
		"longitud": "2.450807",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Santiago Rusiñol, 23",
		"tipologia": "Centre Cívic",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-25T16:01:00.000"
	},
	{
		":id": "row-584x~xyn4_4jnq",
		":version": "rv-sycq-tp89_qbqd",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal d'avis Casa Nostra",
		"indicador_refugi": "081228|CASAL_D_AVIS_CASA_NOSTRA",
		"municipi": "Mediona",
		"codi_municipi": "081228",
		"latitud": "41.47674843",
		"longitud": "1.61136295",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Dr. Trueta, 10",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-ebmf~t8pp~9ygc",
		":version": "rv-npnd_f5rs-s2jr",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "PANTINKILLO",
		"indicador_refugi": "081228|PANTINKILLO",
		"municipi": "Mediona",
		"codi_municipi": "081228",
		"latitud": "41.475653755894285",
		"longitud": "1.61247757375623",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "No",
		"adreca": "C/ MOLÍ, 25 SANT JOAN DE MEDIONA (MEDIONA)",
		"informacio_web": "https://www.dinamo.cat/equipaments-municipals/mediona/equipaments/pantinkillo",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-09T09:21:00.000"
	},
	{
		":id": "row-a3ce.et5r_6sfc",
		":version": "rv-3g39.jvu6.f3ij",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal municipal del Milà",
		"indicador_refugi": "430831|CASAL_MUNICIPAL_DEL_MILA",
		"municipi": "Milà, el",
		"codi_municipi": "430831",
		"latitud": "41.248384",
		"longitud": "1.20723972",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Santa Úrsula, 4",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-kdj5.ekyn~2zha",
		":version": "rv-8wir.8nsa.ucca",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscines municipals de Miralcamp",
		"indicador_refugi": "251351|PISCINES_MUNICIPALS_DE_MIRALCAMP",
		"municipi": "Miralcamp",
		"codi_municipi": "251351",
		"latitud": "41.60584188",
		"longitud": "0.87753698",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Jacint Verdaguer, s/n",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-3qj6_zt4n_655b",
		":version": "rv-jtsz_iy24.kc5q",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Llar de jubilats de Miralcamp",
		"indicador_refugi": "251351|LLAR_DE_JUBILATS_DE_MIRALCAMP",
		"municipi": "Miralcamp",
		"codi_municipi": "251351",
		"latitud": "41.60607275",
		"longitud": "0.87971558",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. Països Catalans, 1",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-ufea-y8uv_ipau",
		":version": "rv-q6hx.3p4r~ty27",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina muncipal de Miravet",
		"indicador_refugi": "430846|PISCINA_MUNCIPAL_DE_MIRAVET",
		"municipi": "Miravet",
		"codi_municipi": "430846",
		"latitud": "41.04161964",
		"longitud": "0.60055501",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "No",
		"adreca": "C. Creu, 49",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-e45s-ssdf~acng",
		":version": "rv-pidu.v7ft_cr7d",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "430859|PISCINA_MUNICIPAL",
		"municipi": "Molar, el",
		"codi_municipi": "430859",
		"latitud": "41.16345134",
		"longitud": "0.70361532",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Ctra. del Molar a Garcia, s/n",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-fmme.n8n5.9snn",
		":version": "rv-whag_q4x7.byj9",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Llar dels jubilats",
		"indicador_refugi": "430859|LLAR_DELS_JUBILATS",
		"municipi": "Molar, el",
		"codi_municipi": "430859",
		"latitud": "41.16364277",
		"longitud": "0.70608343",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Marquès de Tamarit, 1",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-zbgr-hv8r-yw2n",
		":version": "rv-vinj_m5pg.xj63",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Cívic",
		"indicador_refugi": "171061|CENTRE_CIVIC",
		"municipi": "Mollet de Peralada",
		"codi_municipi": "171061",
		"latitud": "42.35857815220418",
		"longitud": "3.0006881482393752",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Figueres, 19",
		"tipologia": "Centre Cívic",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-05-31T20:13:00.000"
	},
	{
		":id": "row-cm94-5g35~8aua",
		":version": "rv-esg6-wzry-gfvr",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Mollet del Vallès",
		"indicador_refugi": "081249|CASAL_CIVIC_I_COMUNITARI_MOLLET_DEL_VALLES",
		"municipi": "Mollet del Vallès",
		"codi_municipi": "081249",
		"latitud": "41.5372812",
		"longitud": "2.2099815",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Rbla. de Balmes, 2",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-fb4a-x55s-pjdk",
		":version": "rv-5rmg~sajb~fbt3",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CC Can Pantiquet",
		"indicador_refugi": "081249|CC_CAN_PANTIQUET",
		"municipi": "Mollet del Vallès",
		"codi_municipi": "081249",
		"latitud": "41.5451",
		"longitud": "2.2201",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Can Flequer 25",
		"informacio_web": "https://www.molletvalles.cat/",
		"tipologia": "Centre Cívic",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-09T13:43:00.000"
	},
	{
		":id": "row-kgff.kh6g_u9sc",
		":version": "rv-juug_76mg-s93t",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CC Lourdes",
		"indicador_refugi": "081249|CC_LOURDES",
		"municipi": "Mollet del Vallès",
		"codi_municipi": "081249",
		"latitud": "41.5557",
		"longitud": "2.2205",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Miguel de Cervantes 4",
		"informacio_web": "https://www.molletvalles.cat/",
		"tipologia": "Centre Cívic",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-10T12:42:00.000"
	},
	{
		":id": "row-tz5e-6afd.egcv",
		":version": "rv-ft5n-3567_328b",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CC Can Borrell",
		"indicador_refugi": "081249|CC_CAN_BORRELL",
		"municipi": "Mollet del Vallès",
		"codi_municipi": "081249",
		"latitud": "41.5466",
		"longitud": "2.205",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Avinguda Caldes de Montbui 23",
		"informacio_web": "https://www.molletvalles.cat/",
		"tipologia": "Centre Cívic",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-10T12:46:00.000"
	},
	{
		":id": "row-j4y3.krwd-bsqx",
		":version": "rv-acki~dr8p.9ykj",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Espai Sant Jordi",
		"indicador_refugi": "081249|ESPAI_SANT_JORDI",
		"municipi": "Mollet del Vallès",
		"codi_municipi": "081249",
		"latitud": "41.5438",
		"longitud": "2.2068",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Avinguda Caldes de Montbui 9",
		"informacio_web": "https://www.molletvalles.cat/",
		"tipologia": "Casal de Gent Gran",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-10T12:49:00.000"
	},
	{
		":id": "row-g89q~x8nu.ghm7",
		":version": "rv-uq2i.pbd8.vf98",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Can Mulà - Jordi Solé Tura",
		"indicador_refugi": "081249|BIBLIOTECA_CAN_MULA_-_JORDI_SOLE_TURA",
		"municipi": "Mollet del Vallès",
		"codi_municipi": "081249",
		"latitud": "41.5373",
		"longitud": "2.2097",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Alsina 1",
		"informacio_web": "https://www.molletvalles.cat/",
		"tipologia": "Biblioteca",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-10T12:51:00.000"
	},
	{
		":id": "row-v7v5~23cx.ucxt",
		":version": "rv-pzqy-wvas-jpwj",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Museu Abelló",
		"indicador_refugi": "081249|MUSEU_ABELLO",
		"municipi": "Mollet del Vallès",
		"codi_municipi": "081249",
		"latitud": "41.5355",
		"longitud": "2.216",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Berenguer III 122",
		"informacio_web": "https://www.molletvalles.cat/",
		"tipologia": "Equipament Cultural (teatre, auditori, museu)",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-10T12:53:00.000"
	},
	{
		":id": "row-m4gt_6pym~grmp",
		":version": "rv-kdps~frub.fni6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "OAC Casa de la Vila",
		"indicador_refugi": "081249|OAC_CASA_DE_LA_VILA",
		"municipi": "Mollet del Vallès",
		"codi_municipi": "081249",
		"latitud": "41.5354",
		"longitud": "2.2105",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça Major 1",
		"informacio_web": "https://www.molletvalles.cat/",
		"tipologia": "Ajuntament / Equipament Administratiu",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-10T13:02:00.000"
	},
	{
		":id": "row-fv3x~3bju~5ayd",
		":version": "rv-gtdz_zvnu~m47w",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Seu de Creu Roja",
		"indicador_refugi": "081249|SEU_DE_CREU_ROJA",
		"municipi": "Mollet del Vallès",
		"codi_municipi": "081249",
		"latitud": "41.5478",
		"longitud": "2.2187",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça d'Enric Rosés 5",
		"informacio_web": "https://www.molletvalles.cat/",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-10T13:05:00.000"
	},
	{
		":id": "row-f7kk_xbtr.md3w",
		":version": "rv-7n66_jvfd-eyf6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Mercat Municipal",
		"indicador_refugi": "081249|MERCAT_MUNICIPAL",
		"municipi": "Mollet del Vallès",
		"codi_municipi": "081249",
		"latitud": "41.5365",
		"longitud": "2.2114",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Avinguda Llibertat 12",
		"informacio_web": "https://www.molletvalles.cat/",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-10T13:07:00.000"
	},
	{
		":id": "row-3mvv_96e3~xs78",
		":version": "rv-8fi8-wufc-rkxt",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de Can Borrell",
		"indicador_refugi": "081249|PARC_DE_CAN_BORRELL",
		"municipi": "Mollet del Vallès",
		"codi_municipi": "081249",
		"latitud": "41.5465",
		"longitud": "2.2059",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Parc de Can Borrell",
		"informacio_web": "https://www.molletvalles.cat/",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-10T13:11:00.000"
	},
	{
		":id": "row-4inz_vd4e-evnr",
		":version": "rv-bbqv~78s2~4rcq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça Frederica Montseny",
		"indicador_refugi": "081249|PLACA_FREDERICA_MONTSENY",
		"municipi": "Mollet del Vallès",
		"codi_municipi": "081249",
		"latitud": "41.5476",
		"longitud": "2.2055",
		"accessibilitat": "Sí",
		"aigua": "No",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça Frederica Montseny",
		"informacio_web": "https://www.molletvalles.cat/",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-10T13:14:00.000"
	},
	{
		":id": "row-gygi.pw4p-a698",
		":version": "rv-2wxu.sn9s.628r",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça de Dolores Ibárruri",
		"indicador_refugi": "081249|PLACA_DE_DOLORES_IBARRURI",
		"municipi": "Mollet del Vallès",
		"codi_municipi": "081249",
		"latitud": "41.548",
		"longitud": "2.2069",
		"accessibilitat": "Sí",
		"aigua": "No",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça de Dolores Ibárruri",
		"informacio_web": "https://www.molletvalles.cat/",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-10T13:21:00.000"
	},
	{
		":id": "row-mw73~e7my-k5ce",
		":version": "rv-szmi-h37g.ekd8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça de Maria Aurèlia Capmany",
		"indicador_refugi": "081249|PLACA_DE_MARIA_AURELIA_CAPMANY",
		"municipi": "Mollet del Vallès",
		"codi_municipi": "081249",
		"latitud": "41.4578",
		"longitud": "2.2437",
		"accessibilitat": "Sí",
		"aigua": "No",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça de Maria Aurèlia Capmany",
		"informacio_web": "https://www.molletvalles.cat/",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-10T13:23:00.000"
	},
	{
		":id": "row-ci4y_c2n5.zqzu",
		":version": "rv-a6eq.k7c5-5w6r",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de la Plana Lledó",
		"indicador_refugi": "081249|PARC_DE_LA_PLANA_LLEDO",
		"municipi": "Mollet del Vallès",
		"codi_municipi": "081249",
		"latitud": "41.5464",
		"longitud": "2.2127",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Avinguda Parc 15",
		"informacio_web": "https://www.molletvalles.cat/",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-10T13:26:00.000"
	},
	{
		":id": "row-qmuj.mszz-u2e7",
		":version": "rv-k3w6~ih8v.hghv",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jardí de la Farinera",
		"indicador_refugi": "081249|JARDI_DE_LA_FARINERA",
		"municipi": "Mollet del Vallès",
		"codi_municipi": "081249",
		"latitud": "41.5382",
		"longitud": "2.2057",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Via Ronda 85",
		"informacio_web": "https://www.molletvalles.cat/",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-10T13:32:00.000"
	},
	{
		":id": "row-a7ma.7dmc-4kmx",
		":version": "rv-8gs7_zvbs~mv49",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de Can Mulà",
		"indicador_refugi": "081249|PARC_DE_CAN_MULA",
		"municipi": "Mollet del Vallès",
		"codi_municipi": "081249",
		"latitud": "41.537",
		"longitud": "2.2101",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Avinguda Rafael Casanova 15",
		"informacio_web": "https://www.molletvalles.cat/",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-10T13:37:00.000"
	},
	{
		":id": "row-rjn4_vvuu_5pm6",
		":version": "rv-erhs~qzjs.uw5g",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça de Pau Casals",
		"indicador_refugi": "081249|PLACA_DE_PAU_CASALS",
		"municipi": "Mollet del Vallès",
		"codi_municipi": "081249",
		"latitud": "41.5349",
		"longitud": "2.2102",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça de Pau Casals",
		"informacio_web": "https://www.molletvalles.cat/",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-10T13:42:00.000"
	},
	{
		":id": "row-g57h_jfaa-qaiz",
		":version": "rv-2m6w-8e5q_gavw",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça de la Constitució",
		"indicador_refugi": "081249|PLACA_DE_LA_CONSTITUCIO",
		"municipi": "Mollet del Vallès",
		"codi_municipi": "081249",
		"latitud": "41.5339",
		"longitud": "2.2125",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça de la Constitució",
		"informacio_web": "https://www.molletvalles.cat/",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-11T13:13:00.000"
	},
	{
		":id": "row-r4ft.6z75_bfjj",
		":version": "rv-g79u~k5e2~dp2a",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça Nelson Mandela",
		"indicador_refugi": "081249|PLACA_NELSON_MANDELA",
		"municipi": "Mollet del Vallès",
		"codi_municipi": "081249",
		"latitud": "41.5338",
		"longitud": "2.211",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça Nelson Mandela",
		"informacio_web": "https://www.molletvalles.cat/",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-11T13:16:00.000"
	},
	{
		":id": "row-jqb6_i4im_mb2e",
		":version": "rv-3ym2~kkzr~vhp7",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça d'Antoni Suñé",
		"indicador_refugi": "081249|PLACA_DANTONI_SUÑE",
		"municipi": "Mollet del Vallès",
		"codi_municipi": "081249",
		"latitud": "41.5339",
		"longitud": "2.2158",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça d'Antoni Suñé",
		"informacio_web": "https://www.molletvalles.cat/",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-11T13:19:00.000"
	},
	{
		":id": "row-appu.6cbt.466x",
		":version": "rv-rw66~zez9.xzs8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de les Pruneres",
		"indicador_refugi": "081249|PARC_DE_LES_PRUNERES",
		"municipi": "Mollet del Vallès",
		"codi_municipi": "081249",
		"latitud": "41.5383",
		"longitud": "2.2151",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Pau 35",
		"informacio_web": "https://www.molletvalles.cat/",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-11T13:21:00.000"
	},
	{
		":id": "row-z9rz.p93e.jhci",
		":version": "rv-bbe7-pweu_vnnd",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça Voluntaris Olímplics i Paralímpics",
		"indicador_refugi": "081249|PLACA_VOLUNTARIS_OLIMPLICS_I_PARALIMPICS",
		"municipi": "Mollet del Vallès",
		"codi_municipi": "081249",
		"latitud": "41.5435",
		"longitud": "2.2196",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça Voluntaris Olímplics i Paralímpics",
		"informacio_web": "https://www.molletvalles.cat/",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-11T13:24:00.000"
	},
	{
		":id": "row-p7gj~evky~bxze",
		":version": "rv-ehna~zbzy~agfg",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça dels Mercaders",
		"indicador_refugi": "081249|PLACA_DELS_MERCADERS",
		"municipi": "Mollet del Vallès",
		"codi_municipi": "081249",
		"latitud": "41.5386",
		"longitud": "2.2177",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça dels Mercaders",
		"informacio_web": "https://www.molletvalles.cat/",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-11T13:26:00.000"
	},
	{
		":id": "row-hbnc.fvaf~8426",
		":version": "rv-mwgy.cswp.zr3i",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça dels Ramaders",
		"indicador_refugi": "081249|PLACA_DELS_RAMADERS",
		"municipi": "Mollet del Vallès",
		"codi_municipi": "081249",
		"latitud": "41.5393",
		"longitud": "2.2183",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça dels Ramaders",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-11T13:28:00.000"
	},
	{
		":id": "row-mphb.pd9v~qccf",
		":version": "rv-66ru_fvs5~ny4v",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça dels Pagesos de Remença",
		"indicador_refugi": "081249|PLACA_DELS_PAGESOS_DE_REMENCA",
		"municipi": "Mollet del Vallès",
		"codi_municipi": "081249",
		"latitud": "41.5404",
		"longitud": "2.2192",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça dels Pagesos de Remença",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-11T13:30:00.000"
	},
	{
		":id": "row-wanq.aq8p_g3ba",
		":version": "rv-bzuw.997x-dqzu",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça dels Ferrers",
		"indicador_refugi": "081249|PLACA_DELS_FERRERS",
		"municipi": "Mollet del Vallès",
		"codi_municipi": "081249",
		"latitud": "41.5413",
		"longitud": "2.2199",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça dels Ferrers",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-11T13:31:00.000"
	},
	{
		":id": "row-qghr~gm4k_4s9j",
		":version": "rv-k5bj_rcw5~iusg",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bosc de Can Pantiquet",
		"indicador_refugi": "081249|BOSC_DE_CAN_PANTIQUET",
		"municipi": "Mollet del Vallès",
		"codi_municipi": "081249",
		"latitud": "41.5485",
		"longitud": "2.2173",
		"accessibilitat": "Sí",
		"aigua": "No",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Lluís Millet 15",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-11T13:35:00.000"
	},
	{
		":id": "row-v2yn~6zmv.6kea",
		":version": "rv-mn7r_9skp-mg8h",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc dels Colors",
		"indicador_refugi": "081249|PARC_DELS_COLORS",
		"municipi": "Mollet del Vallès",
		"codi_municipi": "081249",
		"latitud": "41.5442",
		"longitud": "2.2055",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Parc dels Colors",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-11T13:38:00.000"
	},
	{
		":id": "row-tniz.arqk.skax",
		":version": "rv-zv2f.f9xg-pefz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça Rafael Alberti",
		"indicador_refugi": "081249|PLACA_RAFAEL_ALBERTI",
		"municipi": "Mollet del Vallès",
		"codi_municipi": "081249",
		"latitud": "41.5543",
		"longitud": "2.2215",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça Rafael Alberti",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-11T13:39:00.000"
	},
	{
		":id": "row-2ayj_85zt.sygc",
		":version": "rv-a6hb-ph7t~8nte",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Dona d'Aigua",
		"indicador_refugi": "081249|DONA_DAIGUA",
		"municipi": "Mollet del Vallès",
		"codi_municipi": "081249",
		"latitud": "41.5379",
		"longitud": "2.212",
		"accessibilitat": "Sí",
		"aigua": "No",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Avinguda Jaume I 2",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-12T12:15:00.000"
	},
	{
		":id": "row-9bqk_53fq.br65",
		":version": "rv-itxt_pzg4.938g",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Font de Rambla Balmes",
		"indicador_refugi": "081249|FONT_DE_RAMBLA_BALMES",
		"municipi": "Mollet del Vallès",
		"codi_municipi": "081249",
		"latitud": "41.5364",
		"longitud": "2.2165",
		"accessibilitat": "Sí",
		"aigua": "No",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Rambla Balmes 41",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-12T12:21:00.000"
	},
	{
		":id": "row-qgwh.cf97~zaax",
		":version": "rv-8dmw.7r47_jrby",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Fonts del Parc dels Colors",
		"indicador_refugi": "081249|FONTS_DEL_PARC_DELS_COLORS",
		"municipi": "Mollet del Vallès",
		"codi_municipi": "081249",
		"latitud": "41.544",
		"longitud": "2.2054",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Parc dels Colors",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-12T12:23:00.000"
	},
	{
		":id": "row-xauc-6e2a_kx29",
		":version": "rv-i745~z9mz-ses7",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Font del Parc de les Pruneres",
		"indicador_refugi": "081249|FONT_DEL_PARC_DE_LES_PRUNERES",
		"municipi": "Mollet del Vallès",
		"codi_municipi": "081249",
		"latitud": "41.5385",
		"longitud": "2.2148",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Pau 35",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-12T12:25:00.000"
	},
	{
		":id": "row-93dm-c4um_724n",
		":version": "rv-zgz4.6g9i.uph3",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal de Molló",
		"indicador_refugi": "171077|PISCINA_MUNICIPAL_DE_MOLLO",
		"municipi": "Molló",
		"codi_municipi": "171077",
		"latitud": "42.34553476",
		"longitud": "2.40451678",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Ptge. del Serrat, 3",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-qdsd.79ib~j5fw",
		":version": "rv-eq4b_33hz~99q7",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Sala de plens de la Casa de la vila",
		"indicador_refugi": "430884|SALA_DE_PLENS_DE_LA_CASA_DE_LA_VILA",
		"municipi": "Montbrió del Camp",
		"codi_municipi": "430884",
		"latitud": "41.12082169",
		"longitud": "1.0033502",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. de la Vila, 1",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-atpg~n7vk.sfq5",
		":version": "rv-idwg-bz8f~jf4x",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casa de Cultura de Mont-roig",
		"indicador_refugi": "430884|CASA_DE_CULTURA_DE_MONT_ROIG",
		"municipi": "Montbrió del Camp",
		"codi_municipi": "430884",
		"latitud": "41.08747805",
		"longitud": "0.9579948",
		"accessibilitat": "No",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Mare de Deu de la Roca, 5",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-6km2_j8kq~nvt6",
		":version": "rv-p5nv_p3b5~s5ym",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casa de cultura",
		"indicador_refugi": "430884|CASA_DE_CULTURA",
		"municipi": "Montbrió del Camp",
		"codi_municipi": "430884",
		"latitud": "41.12111618",
		"longitud": "1.00461955",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Av. de Sant Jordi, 4",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-f4gh.fw6p~bjgy",
		":version": "rv-wubd.ah5f_6n8b",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "430884|PISCINA_MUNICIPAL",
		"municipi": "Montbrió del Camp",
		"codi_municipi": "430884",
		"latitud": "41.11714695",
		"longitud": "1.00841768",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "No",
		"adreca": "Ctra. de Cambrils, s/n",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-5sju_2tsh.etpv",
		":version": "rv-yqaj.92ff.j3tp",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Coworking de Montclar",
		"indicador_refugi": "081304|COWORKING_DE_MONTCLAR",
		"municipi": "Montclar",
		"codi_municipi": "081304",
		"latitud": "42.01823774",
		"longitud": "1.76512402",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "CASA DE LA VILA, SN",
		"informacio_web": "www.montclar.cat",
		"tipologia": "Ajuntament / Equipament Administratiu",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-06-01T11:41:00.000"
	},
	{
		":id": "row-bng4~83m5.asvq",
		":version": "rv-3t3m~rp43_3vyv",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Sala d'actes de Montferrer",
		"indicador_refugi": "251403|SALA_D_ACTES_DE_MONTFERRER",
		"municipi": "Montferrer i Castellbò",
		"codi_municipi": "251403",
		"latitud": "42.34625194",
		"longitud": "1.42426916",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. la Coma, 4",
		"tipologia": "Sala polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-jqzr~6q7m_fkb8",
		":version": "rv-2n4p_bszz.xrvv",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Ajuntament de Montferri",
		"indicador_refugi": "430897|AJUNTAMENT_DE_MONTFERRI",
		"municipi": "Montferri",
		"codi_municipi": "430897",
		"latitud": "41.26554",
		"longitud": "1.36516",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Major, 35",
		"informacio_web": "https://montferri.altanet.org/",
		"tipologia": "Ajuntament / Equipament Administratiu",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-05-29T14:34:00.000"
	},
	{
		":id": "row-p9sx.e577.tejj",
		":version": "rv-aegx~bqws~jtqq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina Municipal",
		"indicador_refugi": "430897|PISCINA_MUNICIPAL",
		"municipi": "Montferri",
		"codi_municipi": "430897",
		"latitud": "41.26601",
		"longitud": "1.36461",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Puigtinyós, s/n",
		"informacio_web": "https://montferri.altanet.org/",
		"tipologia": "Piscines descobertes",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-05-29T14:36:00.000"
	},
	{
		":id": "row-vxwa_6nsd_pi7y",
		":version": "rv-um3y_wvaw-h276",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Lokal Social",
		"indicador_refugi": "430897|LOKAL_SOCIAL",
		"municipi": "Montferri",
		"codi_municipi": "430897",
		"latitud": "41.26556",
		"longitud": "1.36519",
		"accessibilitat": "Sí",
		"aigua": "No",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer de la bassa, s/n",
		"informacio_web": "https://montferri.altanet.org/",
		"tipologia": "Sala Polivalent",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-05-29T14:39:00.000"
	},
	{
		":id": "row-ggzz_ht96~p8eu",
		":version": "rv-kk5b~5jz8.4zmt",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Local Social Alzineta",
		"indicador_refugi": "430897|LOCAL_SOCIAL_ALZINETA",
		"municipi": "Montferri",
		"codi_municipi": "430897",
		"latitud": "41.28556",
		"longitud": "1.38467",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Assutzena, 27",
		"informacio_web": "https://montferri.altanet.org/",
		"tipologia": "Sala Polivalent",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-02T10:28:00.000"
	},
	{
		":id": "row-pxew~vf59-863s",
		":version": "rv-4ww6.rzbc.87ma",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Font lúdica plaça Santa Maria",
		"indicador_refugi": "081350|FONT_LUDICA_PLACA_SANTA_MARIA",
		"municipi": "Montmeló",
		"codi_municipi": "081350",
		"latitud": "41.5494571795802",
		"longitud": "2.249240682769789",
		"accessibilitat": "No",
		"aigua": "No",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça Santa Maria",
		"informacio_web": "https://www.montmelo.cat/actualitat/noticies/activem-els-refugis-climatics-per-a-lestiu-2026.html",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-25T14:16:00.000"
	},
	{
		":id": "row-cshq_ru2s~4wfr",
		":version": "rv-s9er_dnmm~7cyf",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscines municipals",
		"indicador_refugi": "081350|PISCINES_MUNICIPALS",
		"municipi": "Montmeló",
		"codi_municipi": "081350",
		"latitud": "41.54888864944643",
		"longitud": "2.2498560183832774",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Folch i Torres 6",
		"informacio_web": "https://www.montmelo.cat/actualitat/noticies/activem-els-refugis-climatics-per-a-lestiu-2026.html",
		"tipologia": "Piscines descobertes",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-25T14:22:00.000"
	},
	{
		":id": "row-mqmd.bsib_9hj2",
		":version": "rv-w3xi.9hmt-vmtz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jardí de la Torreta",
		"indicador_refugi": "081350|JARDI_DE_LA_TORRETA",
		"municipi": "Montmeló",
		"codi_municipi": "081350",
		"latitud": "41.54967045018549",
		"longitud": "2.2501046512877605",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Folch i Torres 2",
		"informacio_web": "https://www.montmelo.cat/actualitat/noticies/activem-els-refugis-climatics-per-a-lestiu-2026.html",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-25T14:24:00.000"
	},
	{
		":id": "row-g2cc-rrd8~nbus",
		":version": "rv-9dvq_sk9u~wgy5",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca",
		"indicador_refugi": "081350|BIBLIOTECA",
		"municipi": "Montmeló",
		"codi_municipi": "081350",
		"latitud": "41.55173965720554",
		"longitud": "2.246038736578799",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Francesc Macià 11",
		"informacio_web": "https://www.montmelo.cat/actualitat/noticies/activem-els-refugis-climatics-per-a-lestiu-2026.html",
		"tipologia": "Biblioteca",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-25T14:27:00.000"
	},
	{
		":id": "row-m27v-cwmf~ghmx",
		":version": "rv-hcg3_qaek_9qki",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de la Gent Gran",
		"indicador_refugi": "081350|CASAL_DE_LA_GENT_GRAN",
		"municipi": "Montmeló",
		"codi_municipi": "081350",
		"latitud": "41.552262973397106",
		"longitud": "2.247690350910736",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Timbalerdel Bruc 2",
		"informacio_web": "https://www.montmelo.cat/actualitat/noticies/activem-els-refugis-climatics-per-a-lestiu-2026.html",
		"tipologia": "Casal de Gent Gran",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-25T14:31:00.000"
	},
	{
		":id": "row-zm77-dpjq~ejhm",
		":version": "rv-6jsc_9nb6-uaqh",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Estació Jove",
		"indicador_refugi": "081350|ESTACIO_JOVE",
		"municipi": "Montmeló",
		"codi_municipi": "081350",
		"latitud": "41.55033505148589",
		"longitud": "2.2468808137765204",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Passeig Miquel Biada",
		"informacio_web": "https://www.montmelo.cat/actualitat/noticies/activem-els-refugis-climatics-per-a-lestiu-2026.html",
		"tipologia": "Centre Cívic",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-25T14:33:00.000"
	},
	{
		":id": "row-8q3t-yeer~r888",
		":version": "rv-kb8c.vfw4-fuws",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bar Llar del poble de Montoliu de Lleida",
		"indicador_refugi": "251425|BAR_LLAR_DEL_POBLE_DE_MONTOLIU_DE_LLEIDA",
		"municipi": "Montoliu de Lleida",
		"codi_municipi": "251425",
		"latitud": "41.56053481",
		"longitud": "0.58842222",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. La Creu",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-whg2~ism9_cnua",
		":version": "rv-2yh3~cjaj.me2n",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscines municipals",
		"indicador_refugi": "251425|PISCINES_MUNICIPALS",
		"municipi": "Montoliu de Lleida",
		"codi_municipi": "251425",
		"latitud": "41.55928015",
		"longitud": "0.59307303",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Afores, s/n",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-944e.gpqv_bdvq",
		":version": "rv-f4nz-q3em.vkav",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Local social Vilagrasseta (antigues Escoles)",
		"indicador_refugi": "251410|LOCAL_SOCIAL_VILAGRASSETA_ANTIGUES_ESCOLES",
		"municipi": "Montoliu de Segarra",
		"codi_municipi": "251410",
		"latitud": "41.605551",
		"longitud": "1.28223",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de l'esglèsia, s/n",
		"tipologia": "Sala polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-nyyd_zxha.eqnb",
		":version": "rv-ufti-ia7b-tghi",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca municipal Rosa Leveroni",
		"indicador_refugi": "081363|BIBLIOTECA_MUNICIPAL_ROSA_LEVERONI",
		"municipi": "Montornès del Vallès",
		"codi_municipi": "081363",
		"latitud": "41.546726",
		"longitud": "2.268833",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Can Parera, 34",
		"informacio_web": "https://www.montornes.cat/municipi/equipaments/biblioteca-rosa-leveroni",
		"tipologia": "Biblioteca",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-16T12:06:00.000"
	},
	{
		":id": "row-nxji-kt46~8bvu",
		":version": "rv-gy9b-i6hx-db4c",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal d’Avis Centre",
		"indicador_refugi": "081363|CASAL_D’AVIS_CENTRE",
		"municipi": "Montornès del Vallès",
		"codi_municipi": "081363",
		"latitud": "41.545671",
		"longitud": "2.266082",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Av. Llibertat, 3",
		"informacio_web": "https://www.montornes.cat/municipi/equipaments/casal-de-la-gent-gran-centre",
		"tipologia": "Casal de Gent Gran",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-16T12:10:00.000"
	},
	{
		":id": "row-bev3~uaqj.teeb",
		":version": "rv-t5uq.vagq.tvxs",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal d’Avis Nord",
		"indicador_refugi": "081363|CASAL_D’AVIS_NORD",
		"municipi": "Montornès del Vallès",
		"codi_municipi": "081363",
		"latitud": "41.553071",
		"longitud": "2.265574",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer de les Hermanas de la Virgen Niña, 4-6,",
		"informacio_web": "https://www.montornes.cat/municipi/equipaments/casal-de-la-gent-gran-nord",
		"tipologia": "Casal de Gent Gran",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-16T12:13:00.000"
	},
	{
		":id": "row-qtfz-tn8n~3wkn",
		":version": "rv-a6e2_6x73.nuv8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc del Torrent de Vinyes Velles",
		"indicador_refugi": "081363|PARC_DEL_TORRENT_DE_VINYES_VELLES",
		"municipi": "Montornès del Vallès",
		"codi_municipi": "081363",
		"latitud": "41.543802",
		"longitud": "2.264125",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Parc del Torrent de Vinyes Velles",
		"informacio_web": "Sense web. Parc sempre obert",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-16T12:17:00.000"
	},
	{
		":id": "row-tcs5.3fwi.tmd7",
		":version": "rv-3bhr-j8y9.2f9f",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc dels Castanyers",
		"indicador_refugi": "081363|PARC_DELS_CASTANYERS",
		"municipi": "Montornès del Vallès",
		"codi_municipi": "081363",
		"latitud": "41.545843",
		"longitud": "2.269072",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Parc dels Castanyers",
		"informacio_web": "https://www.montornes.cat/municipi/llocs-d-interes/parc-dels-castanyers",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-16T12:20:00.000"
	},
	{
		":id": "row-xvak_eyim.wpej",
		":version": "rv-pfhx~cmax-zsqe",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Pineda del Espai Socioesportiu de Montornès Nord",
		"indicador_refugi": "081363|PINEDA_DEL_ESPAI_SOCIOESPORTIU_DE_MONTORNES_NORD",
		"municipi": "Montornès del Vallès",
		"codi_municipi": "081363",
		"latitud": "41.553414",
		"longitud": "2.262371",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pineda del Espai Socioesportiu de Montornès Nord. c. de les Tres Creus s/n",
		"informacio_web": "Sense web. Parc obert.",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-16T12:24:00.000"
	},
	{
		":id": "row-xup8~cv4k~i76y",
		":version": "rv-87r8_n6sk_7h6q",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscines cobertes i Centre Esportiu Municipal (només hivern)",
		"indicador_refugi": "081363|PISCINES_COBERTES_I_CENTRE_ESPORTIU_MUNICIPAL_(NOMES_HIVERN)",
		"municipi": "Montornès del Vallès",
		"codi_municipi": "081363",
		"latitud": "41.545986",
		"longitud": "2.263106",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Gran Vial, 3",
		"informacio_web": "https://www.montornes.cat/municipi/equipaments/zona-esportiva-municipal-les-vernedes-complex-esportiu",
		"tipologia": "Piscina Coberta",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-16T12:26:00.000"
	},
	{
		":id": "row-n46e_pdmi_vyqb",
		":version": "rv-jxu4-3zrh_8t2z",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscines municipals d'Estiu. ZEM Les Vernedes",
		"indicador_refugi": "081363|PISCINES_MUNICIPALS_DESTIU_ZEM_LES_VERNEDES",
		"municipi": "Montornès del Vallès",
		"codi_municipi": "081363",
		"latitud": "41.545772",
		"longitud": "2.261206",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Gran Vial, 3",
		"informacio_web": "https://www.cemlesvernedes.cat/el-cem/calendari-i-horaris",
		"tipologia": "Piscines descobertes",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-16T12:41:00.000"
	},
	{
		":id": "row-52si.d6vi_573v",
		":version": "rv-w627-zer8_knvr",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Polivalent de Miami-platja",
		"indicador_refugi": "430923|CENTRE_POLIVALENT_DE_MIAMI_PLATJA",
		"municipi": "Mont-roig del Camp",
		"codi_municipi": "430923",
		"latitud": "41.00401079",
		"longitud": "0.92807339",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Soria, 16",
		"tipologia": "Sala polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-rb5n-s4rw.wcrn",
		":version": "rv-75db~b6ny-usby",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "PLAÇA DE LA VILA",
		"indicador_refugi": "081379|PLACA_DE_LA_VILA",
		"municipi": "Montseny",
		"codi_municipi": "081379",
		"latitud": "41.7849",
		"longitud": "2.401",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "08469",
		"informacio_web": "PLAÇA DE LA VILA, ESPAI AMB MOLT ARBRAT, FONT D'AIGUA POTABLE, ZONES DE DESCANS.",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-06T12:14:00.000"
	},
	{
		":id": "row-s4sx-y4q9.nm2f",
		":version": "rv-c28t.w8c3~t5fk",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "PASSEIG DELS ENAMORATS",
		"indicador_refugi": "081379|PASSEIG_DELS_ENAMORATS",
		"municipi": "Montseny",
		"codi_municipi": "081379",
		"latitud": "41.7627",
		"longitud": "2.3926",
		"accessibilitat": "Sí",
		"aigua": "No",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "08469",
		"informacio_web": "PASSEIG DELS ENAMORATS , PASSEIG AMB MOLT D'ARBRAT, FONT I ZONA DE DESCANS",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-06T12:27:00.000"
	},
	{
		":id": "row-93kr~mmcc.t8es",
		":version": "rv-nwfe_jhrh.zng9",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Estació d'autobusos",
		"indicador_refugi": "430939|ESTACIO_D_AUTOBUSOS",
		"municipi": "Móra d'Ebre",
		"codi_municipi": "430939",
		"latitud": "41.08864814",
		"longitud": "0.64457194",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Camí de les Hortes, 8",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-pptm.mb4v.6sft",
		":version": "rv-qz7m~xhw9.wcea",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Llar dels jubilats",
		"indicador_refugi": "430944|LLAR_DELS_JUBILATS",
		"municipi": "Móra la Nova",
		"codi_municipi": "430944",
		"latitud": "41.0978221",
		"longitud": "0.65348202",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Francesc Macià, 60",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-kcse.tx32-f63z",
		":version": "rv-66hu.6yrj~zyzd",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Ajuntament de la Morera de Montsant",
		"indicador_refugi": "430960|AJUNTAMENT_DE_LA_MORERA_DE_MONTSANT",
		"municipi": "Morera de Montsant, la",
		"codi_municipi": "430960",
		"latitud": "41.26498675",
		"longitud": "0.84187046",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. del Priorat, 6",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-z89q~6hc8.eevp",
		":version": "rv-mcri.5azn_zw5i",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "081290|PISCINA_MUNICIPAL",
		"municipi": "Muntanyola",
		"codi_municipi": "081290",
		"latitud": "41.87216381",
		"longitud": "2.18303437",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Serrarica, s/n",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-v2mm.rcxe-h6tg",
		":version": "rv-h9n6.kwww.56bj",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal de Mura",
		"indicador_refugi": "081398|PISCINA_MUNICIPAL_DE_MURA",
		"municipi": "Mura",
		"codi_municipi": "081398",
		"latitud": "41.70271638",
		"longitud": "1.97277463",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Ctra. de Rocafort, s/n, 08278 Mura",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-5z7d~x3tx-bgbr",
		":version": "rv-rjve-952u.uvf6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Sala Llevant",
		"indicador_refugi": "171117|SALA_LLEVANT",
		"municipi": "Navata",
		"codi_municipi": "171117",
		"latitud": "42.22364065",
		"longitud": "2.86198998",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. de la Creu, 13",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-sf9z-9ckn_tnnu",
		":version": "rv-vejf-7eeu_rnjq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "SALA 1 D'OCTUBRE",
		"indicador_refugi": "171117|SALA_1_DOCTUBRE",
		"municipi": "Navata",
		"codi_municipi": "171117",
		"latitud": "42.223983911587425",
		"longitud": "2.8628312332797385",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Escoles, 12 - 17774 Navata (Girona)",
		"tipologia": "Sala Polivalent",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-09T15:26:00.000"
	},
	{
		":id": "row-e8tf_33p6~22ri",
		":version": "rv-wwrf~33z4-cr4j",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Cívic de La Nou",
		"indicador_refugi": "081424|CENTRE_CIVIC_DE_LA_NOU",
		"municipi": "Nou de Berguedà, la",
		"codi_municipi": "081424",
		"latitud": "42.166814",
		"longitud": "1.885127",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça 1 d'octubre",
		"tipologia": "Centre Cívic",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-25T12:14:00.000"
	},
	{
		":id": "row-6zf5-qh28~fbxs",
		":version": "rv-vtnf.b4fk.42a4",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Municipal de la Nou de Gaià",
		"indicador_refugi": "430976|BIBLIOTECA_MUNICIPAL_DE_LA_NOU_DE_GAIA",
		"municipi": "Nou de Gaià, la",
		"codi_municipi": "430976",
		"latitud": "41.18327109",
		"longitud": "1.37326562",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Castell, 8, 2n pis",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-hh3g_bya7_j7r9",
		":version": "rv-qfns-vz2c-dke2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina de Nulles",
		"indicador_refugi": "430982|PISCINA_DE_NULLES",
		"municipi": "Nulles",
		"codi_municipi": "430982",
		"latitud": "41.25015963",
		"longitud": "1.29639011",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de la piscina, s/n",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-a7cd~u93i-cd3d",
		":version": "rv-djuf_25dj_vpvp",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca l'Atzavara",
		"indicador_refugi": "081430|BIBLIOTECA_LATZAVARA",
		"municipi": "Òdena",
		"codi_municipi": "081430",
		"latitud": "41.60658262955062",
		"longitud": "1.640061998390379",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Guixera, 8 08711",
		"informacio_web": "Dilluns a divendres de 15:30h a 20:00h, i els dimecres de 10:00h a 13.00h. Tancada del 5 al 18 d'agost.",
		"tipologia": "Biblioteca",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-02T12:06:00.000"
	},
	{
		":id": "row-darw.iszy.hbwc",
		":version": "rv-e4se.uwcj.9cdz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina Municipal d'Òdena",
		"indicador_refugi": "081430|PISCINA_MUNICIPAL_DODENA",
		"municipi": "Òdena",
		"codi_municipi": "081430",
		"latitud": "41.60225224480667",
		"longitud": "1.641444245691464",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Santa Olga, s/n",
		"informacio_web": "Del 6 de juny al 30 d'agost d'11:00h a 20:00h",
		"tipologia": "Piscines descobertes",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-02T12:10:00.000"
	},
	{
		":id": "row-ae8r~78gy.jhvk",
		":version": "rv-fnb7_u74a-vbcn",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Sala de Plens de l'Ajuntament",
		"indicador_refugi": "081430|SALA_DE_PLENS_DE_LAJUNTAMENT",
		"municipi": "Òdena",
		"codi_municipi": "081430",
		"latitud": "41.60654066239679",
		"longitud": "1.6421414204082274",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça Major, 2 08711",
		"informacio_web": "Dilluns a divendres de 8:30h a 14:00h",
		"tipologia": "Ajuntament / Equipament Administratiu",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-02T12:18:00.000"
	},
	{
		":id": "row-7bs2.5vsg-tdmi",
		":version": "rv-y4db-erdu-ri2w",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CCC Olesa de Montserrat",
		"indicador_refugi": "081477|CCC_OLESA_DE_MONTSERRAT",
		"municipi": "Olesa de Montserrat",
		"codi_municipi": "081477",
		"latitud": "41.54973906",
		"longitud": "1.88368974",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Ctra. de la Puda, 08640 Olesa de Montserrat, Barcelona",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-s238_67vc.bmh8",
		":version": "rv-2nb8.gkki-jp27",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Espai Fundació \"la Caixa\"",
		"indicador_refugi": "081477|ESPAI_FUNDACIO_LA_CAIXA",
		"municipi": "Olesa de Montserrat",
		"codi_municipi": "081477",
		"latitud": "41.54447437",
		"longitud": "1.89078648",
		"accessibilitat": "No",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Parc municipal",
		"informacio_web": "https://www.olesademontserrat.cat/sites/default/files/2026-06/pocs-2026-aprovat-per-decret-19062026.pdf",
		"tipologia": "Casal de Gent Gran",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-06-22T12:36:00.000"
	},
	{
		":id": "row-dv3b-55yx.sa9m",
		":version": "rv-zr3g~3dgj-7rn2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina d'estiu",
		"indicador_refugi": "081477|PISCINA_D_ESTIU",
		"municipi": "Olesa de Montserrat",
		"codi_municipi": "081477",
		"latitud": "41.55443421",
		"longitud": "1.89129347",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. de l'Urgell, 90, 08640 Olesa de Montserrat, Barcelona",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-k5iw.8atr_jbam",
		":version": "rv-hwcp~2btv-nweq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "AVV Rambla Eixample",
		"indicador_refugi": "081477|AVV_RAMBLA_EIXAMPLE",
		"municipi": "Olesa de Montserrat",
		"codi_municipi": "081477",
		"latitud": "41.54025405",
		"longitud": "1.89550544",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Mossèn Jacint Verdaguer, 30, 08640 Olesa de Montserrat, Barcelona",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-362w-2dxr.qfdk",
		":version": "rv-8z2b-eeqm-jvpt",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Policia Local",
		"indicador_refugi": "081477|POLICIA_LOCAL",
		"municipi": "Olesa de Montserrat",
		"codi_municipi": "081477",
		"latitud": "41.5440585",
		"longitud": "1.88560547",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Amadeu Paltor, 28",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-c9yb-bt8y.ksgn",
		":version": "rv-n6mj-jxfc_4phc",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Cal Rapissa - Servei de Promoció Econòmica",
		"indicador_refugi": "081477|CAL_RAPISSA_SERVEI_DE_PROMOCIO_ECONOMICA",
		"municipi": "Olesa de Montserrat",
		"codi_municipi": "081477",
		"latitud": "41.54556986",
		"longitud": "1.89436002",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Ample, 25, 08640 Olesa de Montserrat, Barcelona",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-jedt.vieh_3jiv",
		":version": "rv-qzq2.d55t.wncy",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "AVV La Central",
		"indicador_refugi": "081477|AVV_LA_CENTRAL",
		"municipi": "Olesa de Montserrat",
		"codi_municipi": "081477",
		"latitud": "41.53996114",
		"longitud": "1.89791363",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pl. dels Països Catalans, bxs bloc 1",
		"informacio_web": "https://www.olesademontserrat.cat/sites/default/files/2026-06/pocs-2026-aprovat-per-decret-19062026.pdf",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-06-22T13:33:00.000"
	},
	{
		":id": "row-46zn_xynf~juje",
		":version": "rv-n3e4_vzn4.abis",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Olesa de Montserrat",
		"indicador_refugi": "081477|CASAL_CIVIC_I_COMUNITARI_OLESA_DE_MONTSERRAT",
		"municipi": "Olesa de Montserrat",
		"codi_municipi": "081477",
		"latitud": "41.5495223",
		"longitud": "1.8656117",
		"accessibilitat": "No",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Crta. De la Puda s/n",
		"informacio_web": "https://www.olesademontserrat.cat/sites/default/files/2026-06/pocs-2026-aprovat-per-decret-19062026.pdf",
		"tipologia": "Centre Cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-06-22T13:00:00.000"
	},
	{
		":id": "row-ppvs_v9w2.bh76",
		":version": "rv-ppz4.64c5-iqmw",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Cal Puigjaner",
		"indicador_refugi": "081477|CAL_PUIGJANER",
		"municipi": "Olesa de Montserrat",
		"codi_municipi": "081477",
		"latitud": "41.54682283",
		"longitud": "1.89430695",
		"accessibilitat": "Sí",
		"aigua": "No",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Creu Real, 18",
		"informacio_web": "https://www.olesademontserrat.cat/sites/default/files/2026-06/pocs-2026-aprovat-per-decret-19062026.pdf",
		"tipologia": "Equipament Cultural (teatre, auditori, museu)",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-06-22T12:56:00.000"
	},
	{
		":id": "row-u37r.53i2-ti47",
		":version": "rv-iprj~kyav-cy6e",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca municipal",
		"indicador_refugi": "081477|BIBLIOTECA_MUNICIPAL",
		"municipi": "Olesa de Montserrat",
		"codi_municipi": "081477",
		"latitud": "41.54443817",
		"longitud": "1.89230514",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Salvador Cases, 26",
		"informacio_web": "https://www.olesademontserrat.cat/sites/default/files/2026-06/pocs-2026-aprovat-per-decret-19062026.pdf",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-06-22T12:42:00.000"
	},
	{
		":id": "row-ytbm_8nnc_t7pk",
		":version": "rv-tbj9_dtpf.am9g",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "AVV Poble Sec",
		"indicador_refugi": "081477|AVV_POBLE_SEC",
		"municipi": "Olesa de Montserrat",
		"codi_municipi": "081477",
		"latitud": "41.54354531",
		"longitud": "1.89954736",
		"accessibilitat": "Sí",
		"aigua": "No",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Germans Casals, s/n",
		"informacio_web": "https://www.olesademontserrat.cat/sites/default/files/2026-06/pocs-2026-aprovat-per-decret-19062026.pdf",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-06-22T13:35:00.000"
	},
	{
		":id": "row-jg4u-8z6h-q6c7",
		":version": "rv-cbp8-8j4t.swcs",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Ajuntament  (Casa consistorial)",
		"indicador_refugi": "081477|AJUNTAMENT_CASA_CONSISTORIAL",
		"municipi": "Olesa de Montserrat",
		"codi_municipi": "081477",
		"latitud": "41.54414966",
		"longitud": "1.89135802",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Fèlix Figueras i Aragay, s/n",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-y3vz~hspd.dc7k",
		":version": "rv-7k4n~aapp~x33c",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Mercat municipal",
		"indicador_refugi": "081477|MERCAT_MUNICIPAL",
		"municipi": "Olesa de Montserrat",
		"codi_municipi": "081477",
		"latitud": "41.543082",
		"longitud": "1.89350108",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Catalunya, 3",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-b3ht_bgtr_37e9",
		":version": "rv-23za~8cm6~an3q",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jocs d’aigua",
		"indicador_refugi": "081477|JOCS_D_AIGUA",
		"municipi": "Olesa de Montserrat",
		"codi_municipi": "081477",
		"latitud": "41.53951825",
		"longitud": "1.89434553",
		"accessibilitat": "No",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "No",
		"lavabo": "No",
		"adreca": "Plaça de l'Estatut",
		"informacio_web": "https://www.olesademontserrat.cat/sites/default/files/2026-06/pocs-2026-aprovat-per-decret-19062026.pdf",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-06-22T13:29:00.000"
	},
	{
		":id": "row-qtvs.et5t~q89p",
		":version": "rv-jxhh~iezu-mjzq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Local social Les Planes",
		"indicador_refugi": "081477|LOCAL_SOCIAL_LES_PLANES",
		"municipi": "Olesa de Montserrat",
		"codi_municipi": "081477",
		"latitud": "41.55029128531369",
		"longitud": "1.889475963380053",
		"accessibilitat": "Sí",
		"aigua": "No",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Vallès, s/n",
		"informacio_web": "https://www.olesademontserrat.cat/sites/default/files/2026-06/pocs-2026-aprovat-per-decret-19062026.pdf",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-22T13:39:00.000"
	},
	{
		":id": "row-csb2-ykkx_a29a",
		":version": "rv-thmh-a54f.j9wj",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina",
		"indicador_refugi": "251497|PISCINA",
		"municipi": "Oliana",
		"codi_municipi": "251497",
		"latitud": "42.0673848",
		"longitud": "1.3164511",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de l'Esport, s/n",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-hbtw-m927-vyyr",
		":version": "rv-36ex~kgvp_p4s5",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscines municipals pi",
		"indicador_refugi": "251517|PISCINES_MUNICIPALS_PI",
		"municipi": "Olius",
		"codi_municipi": "251517",
		"latitud": "41.97218124",
		"longitud": "1.56162993",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Urb. el pi de sant just 25280",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-9ufx~f9n5.gxmq",
		":version": "rv-m5ab.yyas.6ucy",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Sala polivalent",
		"indicador_refugi": "251517|SALA_POLIVALENT",
		"municipi": "Olius",
		"codi_municipi": "251517",
		"latitud": "41.97771991",
		"longitud": "1.5549301",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. gafarro",
		"tipologia": "Sala polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-xqxe~vzuz_ey8r",
		":version": "rv-shcz.qnw3~gust",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscines municipals",
		"indicador_refugi": "081496|PISCINES_MUNICIPALS",
		"municipi": "Olost",
		"codi_municipi": "081496",
		"latitud": "41.98423",
		"longitud": "2.10043",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Avda. de l'Esport, s/n",
		"informacio_web": "https://www.olost.cat",
		"tipologia": "Piscines descobertes",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-04T12:25:00.000"
	},
	{
		":id": "row-e7gf~tq96-sjf5",
		":version": "rv-rwhn_gsy3_apgj",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de la Gent Gran d'Olost i Santa Creu",
		"indicador_refugi": "081496|CASAL_DE_LA_GENT_GRAN_DOLOST_I_SANTA_CREU",
		"municipi": "Olost",
		"codi_municipi": "081496",
		"latitud": "41.98533",
		"longitud": "2.09607",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Passeig Dr. Lleopart, 7",
		"informacio_web": "https://www.olost.cat/",
		"tipologia": "Casal de Gent Gran",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-04T12:46:00.000"
	},
	{
		":id": "row-zrid_p3w9.udai",
		":version": "rv-awy2~6utt-4skn",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Local social de Santa Creu de Jutglar",
		"indicador_refugi": "081496|LOCAL_SOCIAL_DE_SANTA_CREU_DE_JUTGLAR",
		"municipi": "Olost",
		"codi_municipi": "081496",
		"latitud": "42.005707592401464",
		"longitud": "2.0604646336352213",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C/ Vell, 3",
		"informacio_web": "https://www.olost.cat/",
		"tipologia": "Sala Polivalent",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-04T13:04:00.000"
	},
	{
		":id": "row-ktsy-ns8m.h95u",
		":version": "rv-tq4d.zgkz~s2tc",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Sala cultural",
		"indicador_refugi": "081496|SALA_CULTURAL",
		"municipi": "Olost",
		"codi_municipi": "081496",
		"latitud": "41.98603428523596",
		"longitud": "2.095491971052418",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça Major, 1",
		"informacio_web": "https://www.olost.cat/",
		"tipologia": "Equipament Cultural (teatre, auditori, museu)",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-04T13:10:00.000"
	},
	{
		":id": "row-uj62~6699~r4tc",
		":version": "rv-3mer_24sv.c847",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Claustre de l'Hospici",
		"indicador_refugi": "171143|CLAUSTRE_DE_L_HOSPICI",
		"municipi": "Olot",
		"codi_municipi": "171143",
		"latitud": "42.18135414",
		"longitud": "2.48950113",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de l'Hospici, 8",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-89un~64hx~sg6y",
		":version": "rv-uywa.uwb3.r4v4",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc del Xiprer",
		"indicador_refugi": "171143|PARC_DEL_XIPRER",
		"municipi": "Olot",
		"codi_municipi": "171143",
		"latitud": "42.18297924",
		"longitud": "2.4702314",
		"accessibilitat": "No",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Rda. del xiprer, 1",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-ycf8.43mu-ssj7",
		":version": "rv-9bc3.dm4e~fry4",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc dels Ocells",
		"indicador_refugi": "171143|PARC_DELS_OCELLS",
		"municipi": "Olot",
		"codi_municipi": "171143",
		"latitud": "42.1922121",
		"longitud": "2.50866438",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Rda. de les Mates",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-tku3~u3y9.sk5m",
		":version": "rv-mwsi~vice~kvsy",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de les bisaroques",
		"indicador_refugi": "171143|PARC_DE_LES_BISAROQUES",
		"municipi": "Olot",
		"codi_municipi": "171143",
		"latitud": "42.18104521",
		"longitud": "2.49724857",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. Sant Jordi, 48",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-xbku~8cfh.m9nz",
		":version": "rv-iedn~eii4_bzsx",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça de Bonavista",
		"indicador_refugi": "171143|PLACA_DE_BONAVISTA",
		"municipi": "Olot",
		"codi_municipi": "171143",
		"latitud": "42.1650696",
		"longitud": "2.47760583",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. de Bonavista",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-ac5x.tfdt-8283",
		":version": "rv-v7ys.38bz.h8av",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca municipal",
		"indicador_refugi": "171143|BIBLIOTECA_MUNICIPAL",
		"municipi": "Olot",
		"codi_municipi": "171143",
		"latitud": "42.18213526",
		"longitud": "2.48935825",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Pati, 2",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-tmr5_cchu_5jsb",
		":version": "rv-wfjh_k59v_mnfh",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de Pequín (davant supermercat Carrefour)",
		"indicador_refugi": "171143|PARC_DE_PEQUIN_DAVANT_SUPERMERCAT_CARREFOUR",
		"municipi": "Olot",
		"codi_municipi": "171143",
		"latitud": "42.16971576",
		"longitud": "2.47737692",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. de Santa Coloma, 74",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-hgy9.wxai_vd9b",
		":version": "rv-cpmq-me9x~jd4x",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Nou",
		"indicador_refugi": "171143|PARC_NOU",
		"municipi": "Olot",
		"codi_municipi": "171143",
		"latitud": "42.17156132",
		"longitud": "2.47990946",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. de Santa Coloma, 43",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-v42r-dvqg-tpny",
		":version": "rv-bt8j_nsns.r3ct",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de la Moixina",
		"indicador_refugi": "171143|PARC_DE_LA_MOIXINA",
		"municipi": "Olot",
		"codi_municipi": "171143",
		"latitud": "42.16491472",
		"longitud": "2.48685184",
		"accessibilitat": "No",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Ctra. de la moixina, 1",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-6ex5_uvq5-pmaj",
		":version": "rv-9udh.5vht_ifkt",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc del Dr. Zamenhof",
		"indicador_refugi": "171143|PARC_DEL_DR_ZAMENHOF",
		"municipi": "Olot",
		"codi_municipi": "171143",
		"latitud": "42.18839776",
		"longitud": "2.49972939",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. del Compositor Serra",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-9run-22ci-8bss",
		":version": "rv-s2bm.n75b.ax2v",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de la Faja",
		"indicador_refugi": "171143|PARC_DE_LA_FAJA",
		"municipi": "Olot",
		"codi_municipi": "171143",
		"latitud": "42.18451919",
		"longitud": "2.46386336",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de la Ferradura, 1",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-t9uh~f7qi_8h4d",
		":version": "rv-kkrf~fzk7_6pf4",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jardins i parc dels pisos de la Caixa",
		"indicador_refugi": "171143|JARDINS_I_PARC_DELS_PISOS_DE_LA_CAIXA",
		"municipi": "Olot",
		"codi_municipi": "171143",
		"latitud": "42.17620642",
		"longitud": "2.48377373",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Ptge. dels pisos de la Caixa",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-szd7-uuye-nx7d",
		":version": "rv-uq4d~cq7g.c9u2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Museu dels Sants",
		"indicador_refugi": "171143|MUSEU_DELS_SANTS",
		"municipi": "Olot",
		"codi_municipi": "171143",
		"latitud": "42.17989308",
		"longitud": "2.48900407",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Joaquim Vayreda, 9",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-622q.jfud.gd4v",
		":version": "rv-nb2u_tasp-qn2f",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Passeig de Sant Roc i Fonts de Sant Roc",
		"indicador_refugi": "171143|PASSEIG_DE_SANT_ROC_I_FONTS_DE_SANT_ROC",
		"municipi": "Olot",
		"codi_municipi": "171143",
		"latitud": "42.17357444",
		"longitud": "2.47357496",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pg. de Sant Roc",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-hkdx~6pk4~6m3x",
		":version": "rv-ghcr_ztaj_qngu",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Espai cràter",
		"indicador_refugi": "171143|ESPAI_CRATER",
		"municipi": "Olot",
		"codi_municipi": "171143",
		"latitud": "42.16343416",
		"longitud": "2.47687927",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Macarnau, 55",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-zrqh_2dur.ivbp",
		":version": "rv-zrgx-bpr9-937v",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Firal d'Olot",
		"indicador_refugi": "171143|FIRAL_D_OLOT",
		"municipi": "Olot",
		"codi_municipi": "171143",
		"latitud": "42.1830364",
		"longitud": "2.48704984",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Firal-Firalet",
		"tipologia": "Espai firal",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-tqia.4ccd_f7fi",
		":version": "rv-pjnx~enpp-mbsp",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Carrer Esparg a l'Hostal del Sol",
		"indicador_refugi": "171143|PARC_CARRER_ESPARG_A_L_HOSTAL_DEL_SOL",
		"municipi": "Olot",
		"codi_municipi": "171143",
		"latitud": "42.19311465",
		"longitud": "2.47774361",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Esparg",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-9ppk~iumt-q889",
		":version": "rv-kv6t-eb5z~2va2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Rambla de Benavent, Jardins del mirador de la pubilla",
		"indicador_refugi": "171143|RAMBLA_DE_BENAVENT_JARDINS_DEL_MIRADOR_DE_LA_PUBILLA",
		"municipi": "Olot",
		"codi_municipi": "171143",
		"latitud": "42.17846957",
		"longitud": "2.49570793",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. Sant Jordi, 51",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-wiur~hqfp.3mrt",
		":version": "rv-xrvd~eqh4_f2ui",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de Matalosquer",
		"indicador_refugi": "171143|PARC_DE_MATALOSQUER",
		"municipi": "Olot",
		"codi_municipi": "171143",
		"latitud": "42.16807921",
		"longitud": "2.47308456",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Madrid, 220",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-juvu-48ye_az4j",
		":version": "rv-vite~umdj-ppit",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "171143|PISCINA_MUNICIPAL",
		"municipi": "Olot",
		"codi_municipi": "171143",
		"latitud": "42.16715121",
		"longitud": "2.48037536",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. Sant Jordi, 209",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-iu5x_azw8~8xjn",
		":version": "rv-a2fr~aw8f_psur",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc d'Arturo Simón",
		"indicador_refugi": "171143|PARC_D_ARTURO_SIMON",
		"municipi": "Olot",
		"codi_municipi": "171143",
		"latitud": "42.19226951",
		"longitud": "2.48715056",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de la Garrinada",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-j9bs-9iqd.e2cr",
		":version": "rv-2web-itsk_7qzd",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de les Mòres / Parc Espunya",
		"indicador_refugi": "171143|PARC_DE_LES_MORES_PARC_ESPUNYA",
		"municipi": "Olot",
		"codi_municipi": "171143",
		"latitud": "42.17548162",
		"longitud": "2.48868809",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Ronda Sometent, 17",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-6m4k~n6me-w9fm",
		":version": "rv-ry2n~ey8u-hjxf",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc del Pic del Bac",
		"indicador_refugi": "171143|PARC_DEL_PIC_DEL_BAC",
		"municipi": "Olot",
		"codi_municipi": "171143",
		"latitud": "42.18546222",
		"longitud": "2.47262102",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Alforja, 4",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-7a52.ghkg-zrcv",
		":version": "rv-pyht-gi8k~brrs",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de Miquel Martí Pol",
		"indicador_refugi": "171143|PARC_DE_MIQUEL_MARTI_POL",
		"municipi": "Olot",
		"codi_municipi": "171143",
		"latitud": "42.18282922",
		"longitud": "2.49459035",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pont de Palau",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-azam~gp8c.ffeg",
		":version": "rv-c2wn_yr2v.9bdu",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Olot",
		"indicador_refugi": "171143|CASAL_CIVIC_I_COMUNITARI_OLOT",
		"municipi": "Olot",
		"codi_municipi": "171143",
		"latitud": "41.864698",
		"longitud": "1.8568671",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. del Bisbe Lorenzana, 2",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-cgfp-wu7d_f6j2",
		":version": "rv-urni_p9gc-g4zs",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jardí Mossèn Lluís Planella",
		"indicador_refugi": "171143|JARDI_MOSSEN_LLUIS_PLANELLA",
		"municipi": "Olot",
		"codi_municipi": "171143",
		"latitud": "42.18168566",
		"longitud": "2.47720037",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. dels Clavells, 14",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-d8v2_n9ff_rcwa",
		":version": "rv-zcsj-jdtk.mqmv",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Àrea recreativa Tossols Basil",
		"indicador_refugi": "171143|AREA_RECREATIVA_TOSSOLS_BASIL",
		"municipi": "Olot",
		"codi_municipi": "171143",
		"latitud": "42.17505648",
		"longitud": "2.47037611",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Sant Narcís, 32",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-6fdr-2v76~jw48",
		":version": "rv-pywe~9vmv_zjag",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça del barri de Sant Miquel",
		"indicador_refugi": "171143|PLACA_DEL_BARRI_DE_SANT_MIQUEL",
		"municipi": "Olot",
		"codi_municipi": "171143",
		"latitud": "42.18738407",
		"longitud": "2.4953439",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. Rei Jaume II, 57",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-4967~4ng9.4vv7",
		":version": "rv-qczh_5xsk~fdd7",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jardí Carrer Macarnau (cementiri)",
		"indicador_refugi": "171143|JARDI_CARRER_MACARNAU_CEMENTIRI",
		"municipi": "Olot",
		"codi_municipi": "171143",
		"latitud": "42.18512143",
		"longitud": "2.48638002",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Macarnau, 46",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-gf7r~xkam.8k39",
		":version": "rv-trxc-5ii9~mut8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Passeig Basàltic",
		"indicador_refugi": "171143|PASSEIG_BASALTIC",
		"municipi": "Olot",
		"codi_municipi": "171143",
		"latitud": "42.18316827",
		"longitud": "2.4946218",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de Terrassa, 1",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-pqr6~m2ci_mbda",
		":version": "rv-7qhs~ebmk-i6x2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça Clarà",
		"indicador_refugi": "171143|PLACA_CLARA",
		"municipi": "Olot",
		"codi_municipi": "171143",
		"latitud": "42.18046",
		"longitud": "2.48507",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Clarà",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-z7ne_h4i7.kpdg",
		":version": "rv-3mwm~mf34.hex4",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de les Mates",
		"indicador_refugi": "171143|PARC_DE_LES_MATES",
		"municipi": "Olot",
		"codi_municipi": "171143",
		"latitud": "42.19295067",
		"longitud": "2.50307291",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. del Mestre Vives, 30",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-nei6~guiw.mrq6",
		":version": "rv-vqfr~c8dw.sj8a",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre social",
		"indicador_refugi": "171156|CENTRE_SOCIAL",
		"municipi": "Ordis",
		"codi_municipi": "171156",
		"latitud": "42.21803233",
		"longitud": "2.90900186",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. de l'Empordà, 14",
		"tipologia": "Sala polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-hzv2_4u5w.7gdh",
		":version": "rv-pc3z.jamz.3k6c",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CENTRE CIVIC",
		"indicador_refugi": "081516|CENTRE_CIVIC",
		"municipi": "Oristà",
		"codi_municipi": "081516",
		"latitud": "41.93311",
		"longitud": "2.05925",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "No",
		"adreca": "PLAÇA CATALUNYA,",
		"tipologia": "Centre Cívic",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-08T10:07:00.000"
	},
	{
		":id": "row-3c9u.fbp9.crfy",
		":version": "rv-pd73_tyrq~pihm",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal d'Osor",
		"indicador_refugi": "171169|PISCINA_MUNICIPAL_D_OSOR",
		"municipi": "Osor",
		"codi_municipi": "171169",
		"latitud": "41.94739183",
		"longitud": "2.55913052",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pg. de la Piscina, s/n, 17161 Osor, Girona",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-vcgq~ktzt-gkju",
		":version": "rv-7brn-h2m4.68uk",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Local social Barri Pla De Cavalls",
		"indicador_refugi": "081542|LOCAL_SOCIAL_BARRI_PLA_DE_CAVALLS",
		"municipi": "Pacs del Penedès",
		"codi_municipi": "081542",
		"latitud": "41.363759",
		"longitud": "1.64960678",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de l'esport, s/n",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-b7fn.5kfm_r2vi",
		":version": "rv-4qew~ihzc_pdya",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Pista coberta \"alcalde Josep Soler\"",
		"indicador_refugi": "081542|PISTA_COBERTA_ALCALDE_JOSEP_SOLER",
		"municipi": "Pacs del Penedès",
		"codi_municipi": "081542",
		"latitud": "41.36090004",
		"longitud": "1.6692437",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. Diputació, 11",
		"tipologia": "Sala polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-njha~upg8-qnfh",
		":version": "rv-vy93.kk6w~2cdp",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina Palafolls",
		"indicador_refugi": "081555|PISCINA_PALAFOLLS",
		"municipi": "Palafolls",
		"codi_municipi": "081555",
		"latitud": "41.67192409",
		"longitud": "2.75153803",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Trav. de les Esplanes, s/n",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-2g84~qs78_27x3",
		":version": "rv-mph6-yprr~npyq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Teatre de Palafolls",
		"indicador_refugi": "081555|TEATRE_DE_PALAFOLLS",
		"municipi": "Palafolls",
		"codi_municipi": "081555",
		"latitud": "41.66852999",
		"longitud": "2.7484143",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Francesc Macià, 1",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-haee~bguf-eqgd",
		":version": "rv-vk29~4nsq_ijvv",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca municipal Enric Miralles",
		"indicador_refugi": "081555|BIBLIOTECA_MUNICIPAL_ENRIC_MIRALLES",
		"municipi": "Palafolls",
		"codi_municipi": "081555",
		"latitud": "41.67099881",
		"longitud": "2.7527407",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Parc de les, Trav. de les Esplanes, s/n",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-tmg7_4k4s.if58",
		":version": "rv-r5gh-msdx.n2v7",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca municipal",
		"indicador_refugi": "171175|BIBLIOTECA_MUNICIPAL",
		"municipi": "Palafrugell",
		"codi_municipi": "171175",
		"latitud": "41.91583194",
		"longitud": "3.16436512",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. de Sant Martí, 18",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-3px2~b4vp~g4sx",
		":version": "rv-qa9w.mvpn_7ww7",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Cafeteria de la residència Palafrugell Gent Gran",
		"indicador_refugi": "171175|CAFETERIA_DE_LA_RESIDENCIA_PALAFRUGELL_GENT_GRAN",
		"municipi": "Palafrugell",
		"codi_municipi": "171175",
		"latitud": "41.92264959",
		"longitud": "3.16948144",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. Mestre Josep Bonay i Vidal, 15",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-bbfr-df7f_6f69",
		":version": "rv-zcih~c2y4~xpn8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre municipal d'Educació",
		"indicador_refugi": "171175|CENTRE_MUNICIPAL_D_EDUCACIO",
		"municipi": "Palafrugell",
		"codi_municipi": "171175",
		"latitud": "41.91516347",
		"longitud": "3.17226334",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Bruguerol, 12",
		"tipologia": "Centre educatiu",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-mx8s~qru9.ys6b",
		":version": "rv-kk2m_kbah.uieq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Museu del Suro de Catalunya",
		"indicador_refugi": "171175|MUSEU_DEL_SURO_DE_CATALUNYA",
		"municipi": "Palafrugell",
		"codi_municipi": "171175",
		"latitud": "41.91851458",
		"longitud": "3.16519368",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Begur, 15",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-564i-i6rv-rrhv",
		":version": "rv-c5zi~cfym-np4a",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Local Consell de la gent gran",
		"indicador_refugi": "171175|LOCAL_CONSELL_DE_LA_GENT_GRAN",
		"municipi": "Palafrugell",
		"codi_municipi": "171175",
		"latitud": "41.91829899",
		"longitud": "3.16421269",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Onze de Setembre, 11",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-e9dj-2bbz~w86t",
		":version": "rv-nbve-38cd_utxw",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Sala polivalent",
		"indicador_refugi": "171194|SALA_POLIVALENT",
		"municipi": "Palau de Santa Eulàlia",
		"codi_municipi": "171194",
		"latitud": "42.17391562",
		"longitud": "2.96432076",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Garrigàs, 4",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-k5c2.tkmb-9a9p",
		":version": "rv-mciw~7bqx~umw5",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic",
		"indicador_refugi": "171208|CENTRE_CIVIC",
		"municipi": "Palau-saverdera",
		"codi_municipi": "171208",
		"latitud": "42.3084179",
		"longitud": "3.14871642",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Tramuntana, 1",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-equ5-ifcq.ebp8",
		":version": "rv-txuw_umxc_m3n7",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "171208|PISCINA_MUNICIPAL",
		"municipi": "Palau-saverdera",
		"codi_municipi": "171208",
		"latitud": "42.30949365",
		"longitud": "3.14466326",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Av. Mas Oriol, s/n",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-u3p7-up98~yiif",
		":version": "rv-xwez_7di5~cg2p",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Torre Folch",
		"indicador_refugi": "081568|TORRE_FOLCH",
		"municipi": "Palau-solità i Plegamans",
		"codi_municipi": "081568",
		"latitud": "41.58537116",
		"longitud": "2.1808067",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. del Castell, 27",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-75ng-tg6t-qkf3",
		":version": "rv-sd9h.za2y.p9si",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca l'Alzina",
		"indicador_refugi": "081568|BIBLIOTECA_L_ALZINA",
		"municipi": "Palau-solità i Plegamans",
		"codi_municipi": "081568",
		"latitud": "41.58982203",
		"longitud": "2.17949174",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. Nostra Sra. de Montserrat",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-92ih-a6gg~p9ps",
		":version": "rv-kphr-pzv4_ip5b",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Espai Jove l'Escorxador",
		"indicador_refugi": "081568|ESPAI_JOVE_LESCORXADOR",
		"municipi": "Palau-solità i Plegamans",
		"codi_municipi": "081568",
		"latitud": "41.585373",
		"longitud": "2.174266",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Passeig de la Carrerada, 57",
		"informacio_web": "www.palauplegamans.cat",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-01T14:02:00.000"
	},
	{
		":id": "row-57v7-5e3s_cfef",
		":version": "rv-vzkr_emzw-an43",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça de la Sardana",
		"indicador_refugi": "081568|PLACA_DE_LA_SARDANA",
		"municipi": "Palau-solità i Plegamans",
		"codi_municipi": "081568",
		"latitud": "41.586941",
		"longitud": "2.17751",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça de la Sardana",
		"informacio_web": "www.palauplegamans.cat",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-01T14:11:00.000"
	},
	{
		":id": "row-sk8s~vfz9.cnb9",
		":version": "rv-gyvf.xqui-zp24",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jardins de Manuel Carrasco i Formiguera",
		"indicador_refugi": "081568|JARDINS_DE_MANUEL_CARRASCO_I_FORMIGUERA",
		"municipi": "Palau-solità i Plegamans",
		"codi_municipi": "081568",
		"latitud": "41.583547",
		"longitud": "2.175559",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer de Can Cortés",
		"informacio_web": "www.palauplegamans.cat",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-01T14:18:00.000"
	},
	{
		":id": "row-8trh_pptj-pzn4",
		":version": "rv-cq9h-8eh2_fwet",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de la Plana de Can Maiol",
		"indicador_refugi": "081568|PARC_DE_LA_PLANA_DE_CAN_MAIOL",
		"municipi": "Palau-solità i Plegamans",
		"codi_municipi": "081568",
		"latitud": "41.573535",
		"longitud": "2.179545",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Rambla St. Isidre",
		"informacio_web": "www.palauplegamans.cat",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-01T14:23:00.000"
	},
	{
		":id": "row-pg5r~f794_c8ym",
		":version": "rv-2tq9.mjs6-pyx4",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça del Bosc de Can Maiol",
		"indicador_refugi": "081568|PLACA_DEL_BOSC_DE_CAN_MAIOL",
		"municipi": "Palau-solità i Plegamans",
		"codi_municipi": "081568",
		"latitud": "41.57338",
		"longitud": "2.184407",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça del Bosc de Can Maiol",
		"informacio_web": "www.palauplegamans.cat",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-01T14:26:00.000"
	},
	{
		":id": "row-zfmy.afak_qia9",
		":version": "rv-b25g_5trz-mud4",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de la Sagrera",
		"indicador_refugi": "081568|PARC_DE_LA_SAGRERA",
		"municipi": "Palau-solità i Plegamans",
		"codi_municipi": "081568",
		"latitud": "41.584974",
		"longitud": "2.169443",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Camí de Can Riera",
		"informacio_web": "www.palauplegamans.cat",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-01T14:39:00.000"
	},
	{
		":id": "row-zsbd-f8ew.qggc",
		":version": "rv-mmix_r9qr_tb4m",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça 1 d'Octubre",
		"indicador_refugi": "081568|PLACA_1_DOCTUBRE",
		"municipi": "Palau-solità i Plegamans",
		"codi_municipi": "081568",
		"latitud": "41.588662",
		"longitud": "2.177966",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça 1 d'Octubre",
		"informacio_web": "www.palauplegamans.cat",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-01T14:43:00.000"
	},
	{
		":id": "row-yfvc-rz7g_6xwi",
		":version": "rv-4vsi~iv4y_jm8t",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça d'Ernest Lluch",
		"indicador_refugi": "081568|PLACA_DERNEST_LLUCH",
		"municipi": "Palau-solità i Plegamans",
		"codi_municipi": "081568",
		"latitud": "41.58989",
		"longitud": "2.1764",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça d'Ernest Lluch",
		"informacio_web": "www.palauplegamans.cat",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-01T14:50:00.000"
	},
	{
		":id": "row-je3u.sttt-zdrz",
		":version": "rv-i7iz_q2c5.k8gt",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Ajuntament",
		"indicador_refugi": "431009|AJUNTAMENT",
		"municipi": "Pallaresos, els",
		"codi_municipi": "431009",
		"latitud": "41.17418029",
		"longitud": "1.27258125",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. Catalunya, 8",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-q4uh~vs7f~d97a",
		":version": "rv-va4f-9wpz-ru4x",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "431009|PISCINA_MUNICIPAL",
		"municipi": "Pallaresos, els",
		"codi_municipi": "431009",
		"latitud": "41.17418979",
		"longitud": "1.27323572",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "No",
		"adreca": "Av. Catalunya",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-tfgz~75d6~tv4q",
		":version": "rv-vix7_hfei~9xqc",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca municipal Mercè Rodoreda Els Pallaresos",
		"indicador_refugi": "431009|BIBLIOTECA_MUNICIPAL_MERCE_RODOREDA_ELS_PALLARESOS",
		"municipi": "Pallaresos, els",
		"codi_municipi": "431009",
		"latitud": "41.17590007",
		"longitud": "1.27223633",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Alt, 23",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-q2xn~aa94-r3rp",
		":version": "rv-7hbd.uxab-kyiq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cultural",
		"indicador_refugi": "430995|CENTRE_CULTURAL",
		"municipi": "Palma d'Ebre, la",
		"codi_municipi": "430995",
		"latitud": "41.28221653",
		"longitud": "0.665758",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Catalunya, 7",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-xb32.br4p_bkcd",
		":version": "rv-rtd3_z4gq_negn",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de La Linera",
		"indicador_refugi": "081593|PARC_DE_LA_LINERA",
		"municipi": "Parets del Vallès",
		"codi_municipi": "081593",
		"latitud": "41.57529604",
		"longitud": "2.2331026",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pg. Joan Miró, 7, 08150 Parets del Vallès",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-m2cf_k8g5.78sr",
		":version": "rv-pri8~a3zv-vxhf",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal gent gran Ca n'Oms",
		"indicador_refugi": "081593|CASAL_GENT_GRAN_CA_N_OMS",
		"municipi": "Parets del Vallès",
		"codi_municipi": "081593",
		"latitud": "41.57597025",
		"longitud": "2.2310796",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Ponent, 14, 08150 Parets del Vallès",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-dupb-ncaz_iyw4",
		":version": "rv-z5mp-hyuq_uqcw",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Can Rajoler",
		"indicador_refugi": "081593|BIBLIOTECA_CAN_RAJOLER",
		"municipi": "Parets del Vallès",
		"codi_municipi": "081593",
		"latitud": "41.57246353",
		"longitud": "2.23404862",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Travessera, 1, 08150 Parets del Vallès",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-w9rh-9cuq_2dgb",
		":version": "rv-wa67_yqh5_kfsm",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina descoberta municipal",
		"indicador_refugi": "081593|PISCINA_DESCOBERTA_MUNICIPAL",
		"municipi": "Parets del Vallès",
		"codi_municipi": "081593",
		"latitud": "41.57085524",
		"longitud": "2.23526918",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Pg. Fluvial, s/n, 08150 Parets del Vallès",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-7ai7.w4pb_mesv",
		":version": "rv-9e86_kgdx_zuas",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal gent gran Sant Jordi",
		"indicador_refugi": "081593|CASAL_GENT_GRAN_SANT_JORDI",
		"municipi": "Parets del Vallès",
		"codi_municipi": "081593",
		"latitud": "41.5635118",
		"longitud": "2.22796745",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Galende, 1, 08150 Parets del Vallès",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-6g3f-hiww_7kcv",
		":version": "rv-fy66_ung5.xfmm",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Can Butjosa",
		"indicador_refugi": "081593|BIBLIOTECA_CAN_BUTJOSA",
		"municipi": "Parets del Vallès",
		"codi_municipi": "081593",
		"latitud": "41.56102883",
		"longitud": "2.21932712",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. de la Salut, 50, 08150 Parets del Vallès",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-zats-944k-7cq2",
		":version": "rv-tjyj~def5_z68g",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cal Jardiner",
		"indicador_refugi": "081593|CASAL_CAL_JARDINER",
		"municipi": "Parets del Vallès",
		"codi_municipi": "081593",
		"latitud": "41.57021131",
		"longitud": "2.22284051",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Montcau, s/n, 08150 Parets del Vallès",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-y9y9.peni_9da4",
		":version": "rv-afbj~wsvf.2h8v",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal gent gran Asoveen",
		"indicador_refugi": "081593|CASAL_GENT_GRAN_ASOVEEN",
		"municipi": "Parets del Vallès",
		"codi_municipi": "081593",
		"latitud": "41.55709215",
		"longitud": "2.2211032",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Bruc, 35, 08150 Parets del Vallès",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-9qyx.3w65~xg6x",
		":version": "rv-9miw-n63w_z2r4",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc del sot d'en Barriques",
		"indicador_refugi": "081593|PARC_DEL_SOT_D_EN_BARRIQUES",
		"municipi": "Parets del Vallès",
		"codi_municipi": "081593",
		"latitud": "41.56567084",
		"longitud": "2.22871293",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. Catalunya, 117, 08150 Parets del Vallès",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-dfkm-x37f-9icb",
		":version": "rv-f5pr_27g2-v9fw",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina muncipal",
		"indicador_refugi": "171289|PISCINA_MUNCIPAL",
		"municipi": "Pau",
		"codi_municipi": "171289",
		"latitud": "42.31652275",
		"longitud": "3.11830582",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Sant Pere, 12",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-pcdq~icje_4v66",
		":version": "rv-w72p.jtzn-dvr8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Municipal",
		"indicador_refugi": "431021|CASAL_MUNICIPAL",
		"municipi": "Paüls",
		"codi_municipi": "431021",
		"latitud": "40.921585198348176",
		"longitud": "0.40095475177253576",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Carretera 12",
		"tipologia": "Centre Cívic",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-01T11:31:00.000"
	},
	{
		":id": "row-n44i~y4wb~t3k2",
		":version": "rv-bx9u.ynyr-qyts",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic",
		"indicador_refugi": "171292|CENTRE_CIVIC",
		"municipi": "Pedret i Marzà",
		"codi_municipi": "171292",
		"latitud": "42.31087439",
		"longitud": "3.06596447",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Mar, 13",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-it4a.cykq_c3qx",
		":version": "rv-9cg9-cev8-2s43",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscines Municipals",
		"indicador_refugi": "251641|PISCINES_MUNICIPALS",
		"municipi": "Penelles",
		"codi_municipi": "251641",
		"latitud": "41.75819",
		"longitud": "0.96759",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça del Roser s/n",
		"informacio_web": "12.00 a 20.00 hores de dilluns a diumenge",
		"tipologia": "Piscines descobertes",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-02T10:44:00.000"
	},
	{
		":id": "row-jwce_dbu6_ezwi",
		":version": "rv-dxq8_miq5_b34t",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal d'avis",
		"indicador_refugi": "251641|CASAL_DAVIS",
		"municipi": "Penelles",
		"codi_municipi": "251641",
		"latitud": "41.75824",
		"longitud": "0.96556",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Rita Boldu, s/n",
		"informacio_web": "Horari de 15.00 a 18.00 de dilluns a divendres",
		"tipologia": "Casal de Gent Gran",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-02T10:55:00.000"
	},
	{
		":id": "row-9xbb-uqm9-6gcc",
		":version": "rv-xxk3-r6n6-bppq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Sala de plens ajuntament",
		"indicador_refugi": "251641|SALA_DE_PLENS_AJUNTAMENT",
		"municipi": "Penelles",
		"codi_municipi": "251641",
		"latitud": "41.75801",
		"longitud": "0.96544",
		"accessibilitat": "Sí",
		"aigua": "No",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça Major, 1",
		"informacio_web": "12.00 a 14.00 de dilluns a divendres",
		"tipologia": "Ajuntament / Equipament Administratiu",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-02T10:58:00.000"
	},
	{
		":id": "row-yfuy-jpbb-uz75",
		":version": "rv-qzez-d67x.sha8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal de Peralada",
		"indicador_refugi": "171328|PISCINA_MUNICIPAL_DE_PERALADA",
		"municipi": "Peralada",
		"codi_municipi": "171328",
		"latitud": "42.3119038",
		"longitud": "3.01379",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Aragó",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-3wnd~3wdy-r5u2",
		":version": "rv-cthw-te2d~2kp3",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscines municipals",
		"indicador_refugi": "251654|PISCINES_MUNICIPALS",
		"municipi": "Peramola",
		"codi_municipi": "251654",
		"latitud": "42.05858445",
		"longitud": "1.26672465",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Piscines Peramola",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-vw96-uv2e-7ha9",
		":version": "rv-f6fq_bis3_sec3",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "431042|PISCINA_MUNICIPAL",
		"municipi": "Perelló, el",
		"codi_municipi": "431042",
		"latitud": "40.87648979",
		"longitud": "0.70965886",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Av. Pla de la Fira, s/n",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-jgbh-iv8f.kigx",
		":version": "rv-8ngy_x8nc~ayzi",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal",
		"indicador_refugi": "081614|CASAL",
		"municipi": "Piera",
		"codi_municipi": "081614",
		"latitud": "41.521894",
		"longitud": "1.751512",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça Mar i Cel, 1",
		"informacio_web": "De dilluns a divendres, de 10.00 a 19.00",
		"tipologia": "Casal de Gent Gran",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-09T14:06:00.000"
	},
	{
		":id": "row-79cq.fw8c_cejm",
		":version": "rv-dypk_icn7_3zyi",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Ajuntament de Piera",
		"indicador_refugi": "081614|AJUNTAMENT_DE_PIERA",
		"municipi": "Piera",
		"codi_municipi": "081614",
		"latitud": "41.518011",
		"longitud": "1.743504",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Cr de la Plaça, 16-18",
		"informacio_web": "de dilluns a divendres de 9.00 a 14.00",
		"tipologia": "Ajuntament / Equipament Administratiu",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-09T14:09:00.000"
	},
	{
		":id": "row-tdxe_6ht6-qsnr",
		":version": "rv-yydd.3j83-sag6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "La Bòbila",
		"indicador_refugi": "081614|LA_BOBILA",
		"municipi": "Piera",
		"codi_municipi": "081614",
		"latitud": "41.523837",
		"longitud": "1.754658",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Av Carretera d'Igualada, 2",
		"informacio_web": "De dilluns a divendres de 9.00 a 14.00",
		"tipologia": "Ajuntament / Equipament Administratiu",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-09T14:11:00.000"
	},
	{
		":id": "row-vrxf~fsgm_bukj",
		":version": "rv-mfxz~ijzd_my5v",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca municipal",
		"indicador_refugi": "081614|BIBLIOTECA_MUNICIPAL",
		"municipi": "Piera",
		"codi_municipi": "081614",
		"latitud": "41.522262",
		"longitud": "1.754162",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Av del Gall Mullat, 7",
		"informacio_web": "De dilluns a divendres de 9 a 14, durant els mesos de juliol i agost",
		"tipologia": "Biblioteca",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-09T14:20:00.000"
	},
	{
		":id": "row-quxv_krgu~ibfn",
		":version": "rv-jjkv-9ruz_48b5",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Font del Prat",
		"indicador_refugi": "081614|FONT_DEL_PRAT",
		"municipi": "Piera",
		"codi_municipi": "081614",
		"latitud": "41.522946",
		"longitud": "1.742971",
		"accessibilitat": "Sí",
		"aigua": "No",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Font del Prat",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-09T14:30:00.000"
	},
	{
		":id": "row-xn9z_8amd~a2rt",
		":version": "rv-zqeb.xw78_w6bq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Isaac Berroya",
		"indicador_refugi": "081614|PARC_ISAAC_BERROYA",
		"municipi": "Piera",
		"codi_municipi": "081614",
		"latitud": "41.521988",
		"longitud": "1.744258",
		"accessibilitat": "No",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pg del Prat, s/n",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-09T14:32:00.000"
	},
	{
		":id": "row-5586-3hds~esyc",
		":version": "rv-qf4u.52ng.gkuk",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc del Gall Mullat",
		"indicador_refugi": "081614|PARC_DEL_GALL_MULLAT",
		"municipi": "Piera",
		"codi_municipi": "081614",
		"latitud": "41.521878",
		"longitud": "1.752942",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Parc del Gall Mullat",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-09T14:34:00.000"
	},
	{
		":id": "row-trbh.bysw.vk68",
		":version": "rv-ra48~av4i~fuht",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Avis Poble Nou",
		"indicador_refugi": "081635|CASAL_AVIS_POBLE_NOU",
		"municipi": "Pineda de Mar",
		"codi_municipi": "081635",
		"latitud": "41.62007292592604",
		"longitud": "2.6745370018478503",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Passeig de la Costa Brava, 47, 08397 Pineda de Mar, Barcelona",
		"informacio_web": "https://www.pinedademar.cat/serveis/gent-gran-activa/casal-de-gent-gran-poblenou",
		"tipologia": "Casal de Gent Gran",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-05T10:35:00.000"
	},
	{
		":id": "row-tv47-am7e~dn9s",
		":version": "rv-64mi.rd87~px3k",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de Gent Gran Les Mèlies",
		"indicador_refugi": "081635|CASAL_DE_GENT_GRAN_LES_MELIES",
		"municipi": "Pineda de Mar",
		"codi_municipi": "081635",
		"latitud": "41.626571631041955",
		"longitud": "2.6895674217239707",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pl. de Les Mèlies, número 7. 08397 Pineda de Mar",
		"informacio_web": "https://www.pinedademar.cat/serveis/gent-gran-activa/casal-de-gent-gran-les-melies",
		"tipologia": "Casal de Gent Gran",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-05T10:39:00.000"
	},
	{
		":id": "row-yxk5.jxs3.xwsr",
		":version": "rv-kp65~9jg4.kaea",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Oficina de Turisme",
		"indicador_refugi": "081635|OFICINA_DE_TURISME",
		"municipi": "Pineda de Mar",
		"codi_municipi": "081635",
		"latitud": "41.62758522104079",
		"longitud": "2.689665517189478",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça de Catalunya, 1 08397 Pineda de Mar",
		"informacio_web": "https://visitpineda.com/oficina-de-turisme/",
		"tipologia": "Ajuntament / Equipament Administratiu",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-05T10:49:00.000"
	},
	{
		":id": "row-ter6_mpum.mjv2",
		":version": "rv-accp_3fvc.mvvm",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca M. Serra i Moret",
		"indicador_refugi": "081635|BIBLIOTECA_M_SERRA_I_MORET",
		"municipi": "Pineda de Mar",
		"codi_municipi": "081635",
		"latitud": "41.62440558949214",
		"longitud": "2.693342311645928",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer del Progrés, 22 08397 Pineda de Mar",
		"informacio_web": "https://www.pinedademar.cat/serveis/cultura/biblioteques",
		"tipologia": "Biblioteca",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-05T11:00:00.000"
	},
	{
		":id": "row-mrrm.d2i4-c8qn",
		":version": "rv-hiv9_vvvh~jsu2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Poblenou",
		"indicador_refugi": "081635|BIBLIOTECA_POBLENOU",
		"municipi": "Pineda de Mar",
		"codi_municipi": "081635",
		"latitud": "41.61952693103608",
		"longitud": "2.6708709938976223",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Passeig d'Europa, 23-25",
		"informacio_web": "https://www.pinedademar.cat/serveis/cultura/biblioteques",
		"tipologia": "Biblioteca",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-05T11:09:00.000"
	},
	{
		":id": "row-w43x~s52z-n7tt",
		":version": "rv-e7ts~7efn-kmie",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Espai Cultural \"Sara Llorens\"",
		"indicador_refugi": "081635|ESPAI_CULTURAL_\"SARA_LLORENS\"",
		"municipi": "Pineda de Mar",
		"codi_municipi": "081635",
		"latitud": "41.625673407091",
		"longitud": "2.6899525523186",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça de les Mèlies 21",
		"informacio_web": "https://www.pinedademar.cat/serveis/cultura/espai-cultural-sara-llorens",
		"tipologia": "Sala Polivalent",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-05T11:14:00.000"
	},
	{
		":id": "row-ppmr-7bk7.qgyx",
		":version": "rv-w3sh_9meb~c2ii",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "AJUNTAMENT DE PINELL DE SOLSONÈS",
		"indicador_refugi": "251667|AJUNTAMENT_DE_PINELL_DE_SOLSONES",
		"municipi": "Pinell de Solsonès",
		"codi_municipi": "251667",
		"latitud": "41.949913",
		"longitud": "1.418172",
		"accessibilitat": "No",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "CASA CONSISTORIAL",
		"informacio_web": "http://www.pinelldesolsonès.cat",
		"tipologia": "Ajuntament / Equipament Administratiu",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-05T11:21:00.000"
	},
	{
		":id": "row-8qh5~mzwj_y2u4",
		":version": "rv-dh6k.zsha-7w8g",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina Ardèvol",
		"indicador_refugi": "251673|PISCINA_ARDEVOL",
		"municipi": "Pinós",
		"codi_municipi": "251673",
		"latitud": "41.85068887",
		"longitud": "1.51849395",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Ctra. Torà, s/n,  25287 Ardèvol",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-f4rv_i8un.nyis",
		":version": "rv-ws5i_7bd9~2f9f",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal pirenc",
		"indicador_refugi": "431074|CASAL_PIRENC",
		"municipi": "Pira",
		"codi_municipi": "431074",
		"latitud": "41.4237",
		"longitud": "1.20321",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Sant Sebastià, s/n",
		"tipologia": "Sala polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-4uin_6rz4-xtcf",
		":version": "rv-sy6d.jkph.ap4a",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "431074|PISCINA_MUNICIPAL",
		"municipi": "Pira",
		"codi_municipi": "431074",
		"latitud": "41.426463",
		"longitud": "1.203151",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Afores municipi, Part. ullastres, s/n",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-gbre-7n9f.vxdw",
		":version": "rv-j7h6-nfn9.vxu6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "171349|PISCINA_MUNICIPAL",
		"municipi": "Planoles",
		"codi_municipi": "171349",
		"latitud": "42.317288",
		"longitud": "2.10071462",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Camí de la Serreta, s/n",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-v84g_57ea_3ymj",
		":version": "rv-cwd4_9thm~cjnf",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "251692|PISCINA_MUNICIPAL",
		"municipi": "Pobla de Cérvoles, la",
		"codi_municipi": "251692",
		"latitud": "41.3646193",
		"longitud": "0.9172025",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Calvari, s/n",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-v5t4.znye_p3qm",
		":version": "rv-5pv4.6nyr-4wgd",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Mossen Cinto Verdaguer",
		"indicador_refugi": "081653|BIBLIOTECA_MOSSEN_CINTO_VERDAGUER",
		"municipi": "Pobla de Claramunt, la",
		"codi_municipi": "081653",
		"latitud": "41.55441419",
		"longitud": "1.6754238",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. Catalunya, 9",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-zfq2~uvpa-jbqv",
		":version": "rv-yjvt.eqjr_d6n2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal Pas Blau",
		"indicador_refugi": "081653|PISCINA_MUNICIPAL_PAS_BLAU",
		"municipi": "Pobla de Claramunt, la",
		"codi_municipi": "081653",
		"latitud": "41.55162598",
		"longitud": "1.67937527",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Josep Aguilera, 4",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-azyz.vbmp_3dsy",
		":version": "rv-g3d3-rhqs_phge",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "081666|PISCINA_MUNICIPAL",
		"municipi": "Pobla de Lillet, la",
		"codi_municipi": "081666",
		"latitud": "42.246387",
		"longitud": "1.973419",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C/ Comafiguera, s/n",
		"informacio_web": "Temporada d'estiu - Horari diürn",
		"tipologia": "Piscines descobertes",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-23T10:46:00.000"
	},
	{
		":id": "row-ghct-yhc8.7p3x",
		":version": "rv-dwe4.y3r9~h4cs",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça parc Xesco Boix",
		"indicador_refugi": "081666|PLACA_PARC_XESCO_BOIX",
		"municipi": "Pobla de Lillet, la",
		"codi_municipi": "081666",
		"latitud": "42.24441",
		"longitud": "1.975634",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Parc Xesco Boix",
		"informacio_web": "24 hores",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-23T10:49:00.000"
	},
	{
		":id": "row-66yx-92zm~4mij",
		":version": "rv-6pr5-wmdv_xjwy",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Zona font del Güell",
		"indicador_refugi": "081666|ZONA_FONT_DEL_GUELL",
		"municipi": "Pobla de Lillet, la",
		"codi_municipi": "081666",
		"latitud": "42.243869",
		"longitud": "1.975326",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Font del Güell",
		"informacio_web": "24 hores",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-23T10:52:00.000"
	},
	{
		":id": "row-67zs-a5kw_inyj",
		":version": "rv-t7ws.9dx2~j223",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Escola Pública Lillet a Güell",
		"indicador_refugi": "081666|ESCOLA_PUBLICA_LILLET_A_GUELL",
		"municipi": "Pobla de Lillet, la",
		"codi_municipi": "081666",
		"latitud": "42.246149",
		"longitud": "1.975401",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C/ Salvador Torrents, 11",
		"informacio_web": "24 hores",
		"tipologia": "Escola / Institut",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-23T10:55:00.000"
	},
	{
		":id": "row-6mih.6mph~59nr",
		":version": "rv-6ja8~pxkj~3msi",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Pavelló municipal",
		"indicador_refugi": "081666|PAVELLO_MUNICIPAL",
		"municipi": "Pobla de Lillet, la",
		"codi_municipi": "081666",
		"latitud": "42.245587",
		"longitud": "1.975725",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C/ Àngel Guimerà, 4",
		"informacio_web": "Temporada d'hivern - 24 hores",
		"tipologia": "Pavelló Esportiu",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-23T10:57:00.000"
	},
	{
		":id": "row-qayj~gt9a_tpfy",
		":version": "rv-pvqx~v75y-cgmc",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Gimnàs municipal",
		"indicador_refugi": "081666|GIMNAS_MUNICIPAL",
		"municipi": "Pobla de Lillet, la",
		"codi_municipi": "081666",
		"latitud": "42.245722",
		"longitud": "1.975945",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C/ Àngel Guimerà, 4",
		"informacio_web": "Tot l'any 24 hores",
		"tipologia": "Gimnàs Municipal",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-23T10:59:00.000"
	},
	{
		":id": "row-yuby.fcpc_nz2h",
		":version": "rv-dcv2~nd9y~5bmb",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Cívic",
		"indicador_refugi": "081666|CENTRE_CIVIC",
		"municipi": "Pobla de Lillet, la",
		"codi_municipi": "081666",
		"latitud": "42.24434",
		"longitud": "1.974705",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C/ Dr. Cisneros, 4",
		"informacio_web": "Temporada d'hivern - 24 hores",
		"tipologia": "Centre Cívic",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-23T11:01:00.000"
	},
	{
		":id": "row-fzm5.5bq7_24bg",
		":version": "rv-xzw4-s43k-hris",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Oficina de Turisme",
		"indicador_refugi": "081666|OFICINA_DE_TURISME",
		"municipi": "Pobla de Lillet, la",
		"codi_municipi": "081666",
		"latitud": "42.244366",
		"longitud": "1.975714",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Parc Xesco Boix",
		"informacio_web": "Tot l'any - Horari diürn",
		"tipologia": "Ajuntament / Equipament Administratiu",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-23T11:02:00.000"
	},
	{
		":id": "row-is2e_sdgi.7qbm",
		":version": "rv-9rfs~end7-6pr3",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Llar del Pensionista",
		"indicador_refugi": "081666|LLAR_DEL_PENSIONISTA",
		"municipi": "Pobla de Lillet, la",
		"codi_municipi": "081666",
		"latitud": "42.244943",
		"longitud": "1.975882",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Ctra. de Ripoll, 9",
		"informacio_web": "Temporada d'hivern - Horari diürn",
		"tipologia": "Casal de Gent Gran",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-23T11:05:00.000"
	},
	{
		":id": "row-pee6~2vce_imwm",
		":version": "rv-zv76-kuqc_9f69",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscines municipals",
		"indicador_refugi": "431107|PISCINES_MUNICIPALS",
		"municipi": "Pobla de Massaluca, la",
		"codi_municipi": "431107",
		"latitud": "41.17930447",
		"longitud": "0.35353707",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Santa Madrona, s/n",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-eiiw~x3w9-euqp",
		":version": "rv-tc93-neer_myer",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal cultural de la Pobla de Massaluca",
		"indicador_refugi": "431107|CASAL_CULTURAL_DE_LA_POBLA_DE_MASSALUCA",
		"municipi": "Pobla de Massaluca, la",
		"codi_municipi": "431107",
		"latitud": "41.18249286",
		"longitud": "0.35409167",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Nord, 2",
		"tipologia": "Sala polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-n964_w77d.rzdp",
		":version": "rv-tygx.2bek-jvfq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari la Pobla de Segur",
		"indicador_refugi": "251713|CASAL_CIVIC_I_COMUNITARI_LA_POBLA_DE_SEGUR",
		"municipi": "Pobla de Segur, la",
		"codi_municipi": "251713",
		"latitud": "42.2505339",
		"longitud": "0.9639951",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de Sant Miquel del Pui, 64",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-7bph-hpwy~dyzh",
		":version": "rv-jg9e.t8cr_2g95",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "431135|PISCINA_MUNICIPAL",
		"municipi": "Pont d'Armentera, el",
		"codi_municipi": "431135",
		"latitud": "41.38661831",
		"longitud": "1.36116074",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "T, C-37, 6, 43817 El Pont d'Armentera, Tarragona",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-qf9w_3n6p~3ref",
		":version": "rv-jjk6-jssn_wq33",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Ponts",
		"indicador_refugi": "251728|CASAL_CIVIC_I_COMUNITARI_PONTS",
		"municipi": "Ponts",
		"codi_municipi": "251728",
		"latitud": "41.9154801",
		"longitud": "1.1833158",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Planell, 7",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-gzz7-z5e4.3v7f",
		":version": "rv-vvdy_u3xp_57j2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscines municipals",
		"indicador_refugi": "251728|PISCINES_MUNICIPALS",
		"municipi": "Ponts",
		"codi_municipi": "251728",
		"latitud": "41.91427",
		"longitud": "1.17993",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. de les Piscines, 61",
		"informacio_web": "www.ponts.cat",
		"tipologia": "Piscines descobertes",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-04T13:59:00.000"
	},
	{
		":id": "row-p8wb-dd8z.zmzn",
		":version": "rv-rgm4_qvpr~s6qa",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc municipal La Roca del Call",
		"indicador_refugi": "251728|PARC_MUNICIPAL_LA_ROCA_DEL_CALL",
		"municipi": "Ponts",
		"codi_municipi": "251728",
		"latitud": "41.9217",
		"longitud": "1.18226",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Zona fluvial del Segre a Ponts",
		"informacio_web": "www.ponts.cat",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-04T14:02:00.000"
	},
	{
		":id": "row-ywzp_vqj6~hu3n",
		":version": "rv-pk8p_pdxa-jzbj",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Carles Fontserè",
		"indicador_refugi": "171371|BIBLIOTECA_CARLES_FONTSERE",
		"municipi": "Porqueres",
		"codi_municipi": "171371",
		"latitud": "42.10372786",
		"longitud": "2.77647244",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Jaume Balmes, 27",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-8pqi-fbw2.qkq6",
		":version": "rv-ysaz~tfn7~y4rd",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CASAL DE LA GENT GRAN",
		"indicador_refugi": "171371|CASAL_DE_LA_GENT_GRAN",
		"municipi": "Porqueres",
		"codi_municipi": "171371",
		"latitud": "42.107524",
		"longitud": "2.779808",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C/SANT ANDREU, 28-30",
		"informacio_web": "WWW.PORQUERES.CAT",
		"tipologia": "Casal de Gent Gran",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-03T12:49:00.000"
	},
	{
		":id": "row-aqyg.sbvg~iq5t",
		":version": "rv-d8vr~kwu4~jf7k",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "BAR DE LA ZONA ESPORTIVA",
		"indicador_refugi": "171371|BAR_DE_LA_ZONA_ESPORTIVA",
		"municipi": "Porqueres",
		"codi_municipi": "171371",
		"latitud": "42.104752",
		"longitud": "2.762455",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "PG. Mediterrània",
		"informacio_web": "www.porqueres.cat",
		"tipologia": "Sala Polivalent",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-03T12:51:00.000"
	},
	{
		":id": "row-yk2s-gty9.g7ya",
		":version": "rv-ce5k.xke3-7hmv",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic",
		"indicador_refugi": "171387|CENTRE_CIVIC",
		"municipi": "Portbou",
		"codi_municipi": "171387",
		"latitud": "42.42588714",
		"longitud": "3.16038533",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Mendez Nuñez, 2",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-gb5s_2zd3_wtja",
		":version": "rv-emhr~z957~8bzx",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Sala Congesta",
		"indicador_refugi": "171387|SALA_CONGESTA",
		"municipi": "Portbou",
		"codi_municipi": "171387",
		"latitud": "42.42604726",
		"longitud": "3.16194408",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "No",
		"adreca": "171387|SALA_CONGESTA",
		"tipologia": "Equipament Cultural (teatre, auditori, museu)",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-06-05T13:29:00.000"
	},
	{
		":id": "row-sbdv_82uz_yhgj",
		":version": "rv-9ggp~i8vh~mwvz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc del Castell",
		"indicador_refugi": "431153|PARC_DEL_CASTELL",
		"municipi": "Pradell de la Teixeta",
		"codi_municipi": "431153",
		"latitud": "41.15662199",
		"longitud": "0.87533054",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. del Castell",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-n8yj-8wds_kzh2",
		":version": "rv-6g5r~4yj5.3m6c",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal de Pratdip",
		"indicador_refugi": "431188|PISCINA_MUNICIPAL_DE_PRATDIP",
		"municipi": "Pratdip",
		"codi_municipi": "431188",
		"latitud": "41.05029776",
		"longitud": "0.87252059",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "No",
		"adreca": "Av. Catalunya, s/n",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-773m-rgb4~3zyf",
		":version": "rv-hby5-t2gw-q37r",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal de Planes del Rei",
		"indicador_refugi": "431188|PISCINA_MUNICIPAL_DE_PLANES_DEL_REI",
		"municipi": "Pratdip",
		"codi_municipi": "431188",
		"latitud": "41.02684625",
		"longitud": "0.90203425",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "No",
		"adreca": "Av. Pratdip, s/n",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-43jc_u43i~swtt",
		":version": "rv-2jqh~3245_eb58",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Espai del Cafè de les Persones Grans i Sala de Tallers",
		"indicador_refugi": "081705|ESPAI_DEL_CAFE_DE_LES_PERSONES_GRANS_I_SALA_DE_TALLERS",
		"municipi": "Prats de Rei, els",
		"codi_municipi": "081705",
		"latitud": "41.70619125",
		"longitud": "1.5417927",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Ravalet, 31",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-n9kk~jqwz_nwk8",
		":version": "rv-x6wx.3avt-ycjh",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal dels Prats de Rei",
		"indicador_refugi": "081705|PISCINA_MUNICIPAL_DELS_PRATS_DE_REI",
		"municipi": "Prats de Rei, els",
		"codi_municipi": "081705",
		"latitud": "41.70682065",
		"longitud": "1.54518758",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Països Catalans, s/n",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-f9tx-eafk.nuuq",
		":version": "rv-yrbk-amn4.mr5n",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "251765|PISCINA_MUNICIPAL",
		"municipi": "Preixana",
		"codi_municipi": "251765",
		"latitud": "41.605763",
		"longitud": "1.040316",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Catalunya, s/n",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-wqxb~kwer-wmwm",
		":version": "rv-zqay-z335-djpt",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal gent gran",
		"indicador_refugi": "251765|CASAL_GENT_GRAN",
		"municipi": "Preixana",
		"codi_municipi": "251765",
		"latitud": "41.60627629",
		"longitud": "1.03882822",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Catalunya, 1",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-3g7z-548s-scyy",
		":version": "rv-ibj7-guar~w4at",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Lo Cabildo",
		"indicador_refugi": "251771|LO_CABILDO",
		"municipi": "Preixens",
		"codi_municipi": "251771",
		"latitud": "41.79369058",
		"longitud": "1.0485752",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C.Sant Joan, 10",
		"tipologia": "Sala polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-bikc_96ax~2xjw",
		":version": "rv-7x6e_gfam.hxg6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Sala de plens ajuntament de Premia de Dalt",
		"indicador_refugi": "082303|SALA_DE_PLENS_AJUNTAMENT_DE_PREMIA_DE_DALT",
		"municipi": "Premià de Dalt",
		"codi_municipi": "082303",
		"latitud": "41.50565304",
		"longitud": "2.34562338",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. de la fàbrica, 1",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-jj7e.5m3p-a6fp",
		":version": "rv-mupt~ejww~d2vq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal d'avis Santa Anna - tio",
		"indicador_refugi": "082303|CASAL_D_AVIS_SANTA_ANNA_TIO",
		"municipi": "Premià de Dalt",
		"codi_municipi": "082303",
		"latitud": "41.49675994",
		"longitud": "2.36259179",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. del mil·lenari, 1",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-ziur.wkk4.6bhx",
		":version": "rv-wcds-2kk5-n8bj",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jaume Perich i Escala",
		"indicador_refugi": "082303|JAUME_PERICH_I_ESCALA",
		"municipi": "Premià de Dalt",
		"codi_municipi": "082303",
		"latitud": "41.50476366",
		"longitud": "2.34711179",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Riera Sant Pere, 88",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-hevz_hrwz-43e2",
		":version": "rv-4ftg-brnk_yk5u",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de gent gran La Benefica",
		"indicador_refugi": "082303|CASAL_DE_GENT_GRAN_LA_BENEFICA",
		"municipi": "Premià de Dalt",
		"codi_municipi": "082303",
		"latitud": "41.507288",
		"longitud": "2.34369976",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Sant Crist, 2",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-cfgz~5s34.wy5j",
		":version": "rv-kbsq_w8w4-2g5k",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de la gent gran i tendals en espais públics exteriors",
		"indicador_refugi": "081748|CASAL_DE_LA_GENT_GRAN_I_TENDALS_EN_ESPAIS_PUBLICS_EXTERIORS",
		"municipi": "Puigdàlber",
		"codi_municipi": "081748",
		"latitud": "41.40446031",
		"longitud": "1.70109485",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Pl. de la Vila, 1",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-vuhv-mukz.5zh2",
		":version": "rv-8ckz_qtxn_4395",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Puigpelatenc",
		"indicador_refugi": "431191|CASAL_PUIGPELATENC",
		"municipi": "Puigpelat",
		"codi_municipi": "431191",
		"latitud": "41.2775794",
		"longitud": "1.30007628",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Major, s/n",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-xvfz_m3qb-8mn8",
		":version": "rv-nmue-sbkm~89y3",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Llar d'avis Dr. Llaverias",
		"indicador_refugi": "081751|LLAR_D_AVIS_DR_LLAVERIAS",
		"municipi": "Puig-reig",
		"codi_municipi": "081751",
		"latitud": "41.97568568",
		"longitud": "1.87827878",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Lleida, 1",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-ia5u_cwj6~t9vx",
		":version": "rv-f24y~eauc-piwv",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Guillem de Berguedà",
		"indicador_refugi": "081751|BIBLIOTECA_GUILLEM_DE_BERGUEDA",
		"municipi": "Puig-reig",
		"codi_municipi": "081751",
		"latitud": "41.97418615",
		"longitud": "1.87416695",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. 1 d'octubre, 5-7",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-tw89_s9ng.u4e4",
		":version": "rv-z4hn-h92s~eaae",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Llar de jubilats Sant Jordi",
		"indicador_refugi": "251826|LLAR_DE_JUBILATS_SANT_JORDI",
		"municipi": "Puigverd de Lleida",
		"codi_municipi": "251826",
		"latitud": "41.54333226",
		"longitud": "0.733484",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Major, 10",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-ai33.eu7j_98ap",
		":version": "rv-q4av-zd7i-3jdy",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Sala polivalent bar piscines",
		"indicador_refugi": "251826|SALA_POLIVALENT_BAR_PISCINES",
		"municipi": "Puigverd de Lleida",
		"codi_municipi": "251826",
		"latitud": "41.54135985",
		"longitud": "0.73349473",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. la Bassa, s/n",
		"tipologia": "Sala polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-cxhc~2db8_63mz",
		":version": "rv-7tev~hsas-pivb",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Ajuntament",
		"indicador_refugi": "251826|AJUNTAMENT",
		"municipi": "Puigverd de Lleida",
		"codi_municipi": "251826",
		"latitud": "41.54342577",
		"longitud": "0.73320299",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Major, 7",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-6i6v~n5hu-ereg",
		":version": "rv-cd7d-j8g7.c2g4",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "La Sala",
		"indicador_refugi": "081786|LA_SALA",
		"municipi": "Rajadell",
		"codi_municipi": "081786",
		"latitud": "41.72758033",
		"longitud": "1.70593518",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Major, 14 08256 Rajadell",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-rfaq~852s~s9eb",
		":version": "rv-bhzr_jpqt~5u6x",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CASAL DE LA GENT GRAN",
		"indicador_refugi": "431212|CASAL_DE_LA_GENT_GRAN",
		"municipi": "Rasquera",
		"codi_municipi": "431212",
		"latitud": "41.00255498339078",
		"longitud": "0.6008258441833205",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C/ FIRAL 2",
		"informacio_web": "WWW.RASQUERA.CAT",
		"tipologia": "Casal de Gent Gran",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-02T11:20:00.000"
	},
	{
		":id": "row-hpyv~6tgf-zpc3",
		":version": "rv-rar9-3cj8.3ucu",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "PISCINES MUNICIPALS DE RASQUERA",
		"indicador_refugi": "431212|PISCINES_MUNICIPALS_DE_RASQUERA",
		"municipi": "Rasquera",
		"codi_municipi": "431212",
		"latitud": "41.00365311005596",
		"longitud": "0.6019561142985219",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C/ ESPORTS S/N",
		"informacio_web": "WWW.RASQUERA.CAT",
		"tipologia": "Piscines descobertes",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-02T11:27:00.000"
	},
	{
		":id": "row-ynpf-fdyc.bcgn",
		":version": "rv-i5s7-sjam.r77v",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Antigues escoles de Regencós",
		"indicador_refugi": "171447|ANTIGUES_ESCOLES_DE_REGENCOS",
		"municipi": "Regencós",
		"codi_municipi": "171447",
		"latitud": "41.95297079",
		"longitud": "3.17129221",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Torres Jonama, 3",
		"tipologia": "Sala polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-inab~7zdn~fz77",
		":version": "rv-bfjy-d5kr_nu6c",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Refugi climàtic del cami del Cementiri",
		"indicador_refugi": "171447|REFUGI_CLIMATIC_DEL_CAMI_DEL_CEMENTIRI",
		"municipi": "Regencós",
		"codi_municipi": "171447",
		"latitud": "41.95313206",
		"longitud": "3.16648264",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Camí del Cementiri, s/n, Regencòs",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-d7fw.uupy_d4kt",
		":version": "rv-xeci.bqgt-t6j8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de cultura L'escola",
		"indicador_refugi": "081799|CASAL_DE_CULTURA_L_ESCOLA",
		"municipi": "Rellinars",
		"codi_municipi": "081799",
		"latitud": "41.63767056",
		"longitud": "1.91139771",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. de l'ajuntament, s/n",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-rykc~6rzs.84iv",
		":version": "rv-8dqq.se4z_rpkq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic Mas Abelló",
		"indicador_refugi": "431233|CENTRE_CIVIC_MAS_ABELLO",
		"municipi": "Reus",
		"codi_municipi": "431233",
		"latitud": "41.15055967",
		"longitud": "1.11862606",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Mas del Carpa, 4, 43204 Reus, Tarragona",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-23q8_ycsp_u8yt",
		":version": "rv-si3v-zxdw_6gup",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Central Xavier Amorós",
		"indicador_refugi": "431233|BIBLIOTECA_CENTRAL_XAVIER_AMOROS",
		"municipi": "Reus",
		"codi_municipi": "431233",
		"latitud": "41.15403914",
		"longitud": "1.10014809",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de l'Escorxador, 1, 43202 Reus, Tarragona",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-2hau.8bph.ejqd",
		":version": "rv-ivxp~9w6a.web5",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "La Palma",
		"indicador_refugi": "431233|LA_PALMA",
		"municipi": "Reus",
		"codi_municipi": "431233",
		"latitud": "41.16083214",
		"longitud": "1.10277371",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Ample, 75, 43202 Reus, Tarragona",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-y69k_i5dq.abu4",
		":version": "rv-v22p.9wsd~s9qr",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal cívic Reus - La Rambla (GENCAT)",
		"indicador_refugi": "431233|CASAL_CIVIC_REUS_LA_RAMBLA_GENCAT",
		"municipi": "Reus",
		"codi_municipi": "431233",
		"latitud": "41.15447",
		"longitud": "1.11251035",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Riera d'Aragó, 11, 43204 Reus, Tarragona",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-bsqt_uttp-cjex",
		":version": "rv-gg3h~p5eg~wcvj",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc del Carrer de Romaní",
		"indicador_refugi": "431233|PARC_DEL_CARRER_DE_ROMANI",
		"municipi": "Reus",
		"codi_municipi": "431233",
		"latitud": "41.15297592",
		"longitud": "1.09486974",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. del Romaní, 21, 43206 Reus, Tarragona",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-85ze-pp23_vmdx",
		":version": "rv-2uxz-2txy~8vq9",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça Europa",
		"indicador_refugi": "431233|PLACA_EUROPA",
		"municipi": "Reus",
		"codi_municipi": "431233",
		"latitud": "41.14657027",
		"longitud": "1.11009157",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. d'Europa, 43205 Reus, Tarragona",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-b45y.fhn7~3kgp",
		":version": "rv-5bqn~ecjz-c8eb",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Reus - Sant Josep Obrer",
		"indicador_refugi": "431233|CASAL_CIVIC_I_COMUNITARI_REUS_SANT_JOSEP_OBRER",
		"municipi": "Reus",
		"codi_municipi": "431233",
		"latitud": "41.1475638",
		"longitud": "1.1173147",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Mas del Pellicer, bloc 55 (Sant Josep Obrer)",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-6369-3jpa_5x32",
		":version": "rv-uyf8_erwn.6rw2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre d'Art Cal Massó",
		"indicador_refugi": "431233|CENTRE_D_ART_CAL_MASSO",
		"municipi": "Reus",
		"codi_municipi": "431233",
		"latitud": "41.15855329",
		"longitud": "1.10196642",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de Pròsper de Bofarull, 7, 43202 Reus, Tarragona",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-wz62.fvgr.kgmc",
		":version": "rv-dqzc~hjqg_umhn",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Mas Carandell",
		"indicador_refugi": "431233|PARC_MAS_CARANDELL",
		"municipi": "Reus",
		"codi_municipi": "431233",
		"latitud": "41.16207275",
		"longitud": "1.09328731",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de Terol, 8",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-8af2-7xh4-jckn",
		":version": "rv-vfg9~vg3e~qaz3",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc del Santuari de Misericòrdia",
		"indicador_refugi": "431233|PARC_DEL_SANTUARI_DE_MISERICORDIA",
		"municipi": "Reus",
		"codi_municipi": "431233",
		"latitud": "41.14290671",
		"longitud": "1.09969558",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Santuari Misericòrdia, s/n",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-iprg.i2sk-56kg",
		":version": "rv-ccr6.7fjz.75f3",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Passeig Prim",
		"indicador_refugi": "431233|PASSEIG_PRIM",
		"municipi": "Reus",
		"codi_municipi": "431233",
		"latitud": "41.15223546",
		"longitud": "1.10315538",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pg. de Prim, 43202 Reus, Tarragona",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-suj3-imkq~vuck",
		":version": "rv-ssje-ypme~fcaj",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Mercat Central",
		"indicador_refugi": "431233|MERCAT_CENTRAL",
		"municipi": "Reus",
		"codi_municipi": "431233",
		"latitud": "41.15699738",
		"longitud": "1.10307016",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "No",
		"adreca": "C. de Josep Sardà i Cailà, s/n, 43201 Reus, Tarragona",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-kxxq-6sea_24q8",
		":version": "rv-pnyy_upqn~rbqg",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Pere Anguera",
		"indicador_refugi": "431233|BIBLIOTECA_PERE_ANGUERA",
		"municipi": "Reus",
		"codi_municipi": "431233",
		"latitud": "41.1441847",
		"longitud": "1.11758267",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de Joan Salvat Papasseit, 14, 43204 Reus, Tarragona",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-td5c.d2ux-9y5k",
		":version": "rv-e6dy~j5x4~2ren",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic Ponent",
		"indicador_refugi": "431233|CENTRE_CIVIC_PONENT",
		"municipi": "Reus",
		"codi_municipi": "431233",
		"latitud": "41.1515604",
		"longitud": "1.09805221",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. dels Països Catalans, 106, 43205 Reus, Tarragona",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-taay.bnq4_3ype",
		":version": "rv-ehf3.be32_byvt",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc d’Angel Guimerà",
		"indicador_refugi": "431233|PARC_D_ANGEL_GUIMERA",
		"municipi": "Reus",
		"codi_municipi": "431233",
		"latitud": "41.15816547",
		"longitud": "1.09737713",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. d'Àngel Guimerà, 31, 43202 Reus, Tarragona",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-rkff_up2e-5hdb",
		":version": "rv-mdwh-6ss9~5ed7",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Tirant lo Blanc",
		"indicador_refugi": "431233|PARC_TIRANT_LO_BLANC",
		"municipi": "Reus",
		"codi_municipi": "431233",
		"latitud": "41.15821866",
		"longitud": "1.08802869",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de Roger de Llúria, 43206 Reus, Tarragona",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-q2sx-2u2h_xmhg",
		":version": "rv-qvtd-yvns-yhic",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic municipal Llevant",
		"indicador_refugi": "431233|CENTRE_CIVIC_MUNICIPAL_LLEVANT",
		"municipi": "Reus",
		"codi_municipi": "431233",
		"latitud": "41.15634217",
		"longitud": "1.11425355",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Horts del Canonges, 1, 43204 Reus, Tarragona",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-dgqp_4jut.b5nq",
		":version": "rv-sgak_pyct_9hfy",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Passeig Sunyer",
		"indicador_refugi": "431233|PASSEIG_SUNYER",
		"municipi": "Reus",
		"codi_municipi": "431233",
		"latitud": "41.15673873",
		"longitud": "1.10156334",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pg. de Sunyer, 20-16, 43202 Reus, Tarragona",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-b43h~u7fb_ujev",
		":version": "rv-z9zt~3ey8-3j5p",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc del Trenet",
		"indicador_refugi": "431233|PARC_DEL_TRENET",
		"municipi": "Reus",
		"codi_municipi": "431233",
		"latitud": "41.14473388",
		"longitud": "1.0989199",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. dels Països Catalans, 209V, 43205 Reus, Tarragona",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-2hm2.9gww.qus8",
		":version": "rv-86yb-tx8s.pxa6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Mercat del Carrilet",
		"indicador_refugi": "431233|MERCAT_DEL_CARRILET",
		"municipi": "Reus",
		"codi_municipi": "431233",
		"latitud": "41.14879638",
		"longitud": "1.11128223",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "No",
		"adreca": "Av. Jaume I, s/n, 43204 Reus, Tarragona",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-ibcn~uszq-xjk7",
		":version": "rv-vf2k.rf5g-tu5f",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Museu de Reus ( Salvador Vilaseca)",
		"indicador_refugi": "431233|MUSEU_DE_REUS_SALVADOR_VILASECA",
		"municipi": "Reus",
		"codi_municipi": "431233",
		"latitud": "41.15665102",
		"longitud": "1.11059614",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "No",
		"adreca": "Raval de Santa Anna, 59, 43201 Reus, Tarragona",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-rbxw.9en7-jwy9",
		":version": "rv-5v7k-4db2.x4a6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic del Carme",
		"indicador_refugi": "431233|CENTRE_CIVIC_DEL_CARME",
		"municipi": "Reus",
		"codi_municipi": "431233",
		"latitud": "41.15457316",
		"longitud": "1.10494646",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. de la Patacada, 10, 43201 Reus, Tarragona",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-3pjx~c94r.gymk",
		":version": "rv-ajwm_h48s_wjz3",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de Sant Jordi",
		"indicador_refugi": "431233|PARC_DE_SANT_JORDI",
		"municipi": "Reus",
		"codi_municipi": "431233",
		"latitud": "41.16006222",
		"longitud": "1.10717017",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. de Sant Jordi, 2, 43201 Reus, Tarragona",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-4fb3-p59y~bwwd",
		":version": "rv-3bhi~kkkr.qrek",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Passeig de la Boca de la Mina",
		"indicador_refugi": "431233|PASSEIG_DE_LA_BOCA_DE_LA_MINA",
		"municipi": "Reus",
		"codi_municipi": "431233",
		"latitud": "41.16397926",
		"longitud": "1.09539105",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Barranc de la Mina, 7A, 43206 Reus, Tarragona",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-7phw.nrj4~277j",
		":version": "rv-rizv-n28x.tcjz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic Migjorn",
		"indicador_refugi": "431233|CENTRE_CIVIC_MIGJORN",
		"municipi": "Reus",
		"codi_municipi": "431233",
		"latitud": "41.13968019",
		"longitud": "1.11688077",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Riera de l'Escorial, 24, 43205 Reus, Tarragona",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-uej4.tvz6_baw7",
		":version": "rv-n3ub~c9xi-ezfd",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Carretera Pere Mata",
		"indicador_refugi": "431233|PARC_CARRETERA_PERE_MATA",
		"municipi": "Reus",
		"codi_municipi": "431233",
		"latitud": "41.16215181",
		"longitud": "1.08551133",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Ctra. Institut Pere Mata, 19V, 43206 Reus, Tarragona",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-jk3s_smz9-hpv7",
		":version": "rv-cnbt-uyt2_vc4i",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Museu Gaudí - Oficina de Turisme",
		"indicador_refugi": "431233|MUSEU_GAUDI_OFICINA_DE_TURISME",
		"municipi": "Reus",
		"codi_municipi": "431233",
		"latitud": "41.15534514",
		"longitud": "1.10831917",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "No",
		"adreca": "Pl. del Mercadal, 3, 43201 Reus, Tarragona",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-pfad~hjjm~mxsc",
		":version": "rv-i3gf.n7xw.agc5",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Passeig Misericòrdia",
		"indicador_refugi": "431233|PASSEIG_MISERICORDIA",
		"municipi": "Reus",
		"codi_municipi": "431233",
		"latitud": "41.14842638",
		"longitud": "1.10476266",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pg. de Misericòrdia, 43205 Reus, Tarragona",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-mgwz_gb42-fitf",
		":version": "rv-6ev8_ptek~sed3",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal municipal de Joves",
		"indicador_refugi": "431233|CASAL_MUNICIPAL_DE_JOVES",
		"municipi": "Reus",
		"codi_municipi": "431233",
		"latitud": "41.16679388",
		"longitud": "1.1021353",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de Castellvell, 24, 43202 Reus, Tarragona",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-zsbs-jh8a-hqvb",
		":version": "rv-hguf_fjvf_9bu6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Reus - la Rambla",
		"indicador_refugi": "431233|CASAL_CIVIC_I_COMUNITARI_REUS_LA_RAMBLA",
		"municipi": "Reus",
		"codi_municipi": "431233",
		"latitud": "41.15426",
		"longitud": "1.1079828",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de Riera d'Aragò, 11",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-i7b3.f78i_7ch3",
		":version": "rv-kgg3~ixx8.yggi",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic Mestral",
		"indicador_refugi": "431233|CENTRE_CIVIC_MESTRAL",
		"municipi": "Reus",
		"codi_municipi": "431233",
		"latitud": "41.16054434",
		"longitud": "1.09582151",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. de Barcelona, 6, 43206 Reus, Tarragona",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-i8rb.guhz.nn2n",
		":version": "rv-pxwg~6yzw_qsnp",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Ribetà",
		"indicador_refugi": "431248|CASAL_RIBETA",
		"municipi": "Riba, la",
		"codi_municipi": "431248",
		"latitud": "41.31770166",
		"longitud": "1.17781633",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Pagès, 14",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-bzkg.hbx6.uwxg",
		":version": "rv-vift~ubd4.wjzz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "431248|PISCINA_MUNICIPAL",
		"municipi": "Riba, la",
		"codi_municipi": "431248",
		"latitud": "41.3169246",
		"longitud": "1.17975971",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Pilats, 1",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-tftj_pdwh-dx5z",
		":version": "rv-5ugc~6vc8_5vk7",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "171485|PISCINA_MUNICIPAL",
		"municipi": "Riudarenes",
		"codi_municipi": "171485",
		"latitud": "41.819645",
		"longitud": "2.723792",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Camí de la Camparra, 4, Riudarenes",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-bqg8~w9bm_dqj3",
		":version": "rv-dxhk~3agi.8vtm",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Local Social",
		"indicador_refugi": "171498|LOCAL_SOCIAL",
		"municipi": "Riudaura",
		"codi_municipi": "171498",
		"latitud": "42.1889884315384",
		"longitud": "2.407193976510658",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C/ Joan Castanyer i Massegur, 12 (17179 Riudaura)",
		"tipologia": "Sala Polivalent",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-05T10:30:00.000"
	},
	{
		":id": "row-ufp8_g4q2~2n5j",
		":version": "rv-uyaw-grmv~3igr",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Poliesportiu Joan Mestre",
		"indicador_refugi": "431286|POLIESPORTIU_JOAN_MESTRE",
		"municipi": "Riudecols",
		"codi_municipi": "431286",
		"latitud": "41.16716186",
		"longitud": "0.97754947",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Ctra. Alcolea, s/n",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-stwg_yxrf_cup3",
		":version": "rv-7d3c.6sut-j8ea",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Llar dels Jubilats",
		"indicador_refugi": "431299|LLAR_DELS_JUBILATS",
		"municipi": "Riudoms",
		"codi_municipi": "431299",
		"latitud": "41.13914506",
		"longitud": "1.05078653",
		"accessibilitat": "No",
		"aigua": "No",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "No",
		"adreca": "C. Sant Jaume, 2",
		"tipologia": "Casal de Gent Gran",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-06-22T11:46:00.000"
	},
	{
		":id": "row-ba8n-ktz7~xtiy",
		":version": "rv-d3ry.eiqp~dhah",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Municipal Antoni Gaudí",
		"indicador_refugi": "431299|BIBLIOTECA_MUNICIPAL_ANTONI_GAUDI",
		"municipi": "Riudoms",
		"codi_municipi": "431299",
		"latitud": "41.13948150375201",
		"longitud": "1.0555250090563502",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça de l’Arbre, 5",
		"tipologia": "Biblioteca",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-22T11:45:00.000"
	},
	{
		":id": "row-tkji.pvgf_2sdq",
		":version": "rv-udp3.uwbr_pjgr",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jardins de l’escolale Música",
		"indicador_refugi": "081831|JARDINS_DE_L_ESCOLALE_MUSICA",
		"municipi": "Roda de Ter",
		"codi_municipi": "081831",
		"latitud": "41.98646779",
		"longitud": "2.31148821",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. Tecla Sala, 35",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-uxbb~89my~49cb",
		":version": "rv-wf23.yzdn-bmh2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Bac de roda",
		"indicador_refugi": "081831|BIBLIOTECA_BAC_DE_RODA",
		"municipi": "Roda de Ter",
		"codi_municipi": "081831",
		"latitud": "41.98145337",
		"longitud": "2.30917258",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Bac de roda, 1 bis",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-xrg7.fp84-g6yb",
		":version": "rv-cyg3~icsj_z7ga",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Fundació Miquel Martí I Pol",
		"indicador_refugi": "081831|FUNDACIO_MIQUEL_MARTI_I_POL",
		"municipi": "Roda de Ter",
		"codi_municipi": "081831",
		"latitud": "41.9773801",
		"longitud": "2.307016",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. costa del Ter, 13",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-2fx6_ycfw-8usd",
		":version": "rv-qiet_2dez-v4qk",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jardins de la Blava",
		"indicador_refugi": "081831|JARDINS_DE_LA_BLAVA",
		"municipi": "Roda de Ter",
		"codi_municipi": "081831",
		"latitud": "41.97779196",
		"longitud": "2.30782905",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Jardins de la Blava",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-9zeh-ud48_8ugw",
		":version": "rv-mywb.eqzw-xq46",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Museu de l’Esquerda",
		"indicador_refugi": "081831|MUSEU_DE_L_ESQUERDA",
		"municipi": "Roda de Ter",
		"codi_municipi": "081831",
		"latitud": "41.97716186",
		"longitud": "2.31271098",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "AV. Pere Baurier, 30",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-y4pr-9spv_zzkt",
		":version": "rv-zirj-nh76-i9yk",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bar de Can Planoles",
		"indicador_refugi": "081831|BAR_DE_CAN_PLANOLES",
		"municipi": "Roda de Ter",
		"codi_municipi": "081831",
		"latitud": "41.9819135",
		"longitud": "2.31149047",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Ramon Pujols i Caveras, 42",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-qub6.6wjz-ca7g",
		":version": "rv-pbh6_m25c-i97e",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscines municipals",
		"indicador_refugi": "081831|PISCINES_MUNICIPALS",
		"municipi": "Roda de Ter",
		"codi_municipi": "081831",
		"latitud": "41.98780614",
		"longitud": "2.31063708",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "No",
		"adreca": "Pg. de la Generalitat, s/n",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-c4ea.49hi-xk5n",
		":version": "rv-zfd4~b6rn_e397",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca municipal de Rodonyà \"Salvador de Tamarit i Vilanova\"",
		"indicador_refugi": "431325|BIBLIOTECA_MUNICIPAL_DE_RODONYA_\"SALVADOR_DE_TAMARIT_I_VILANOVA\"",
		"municipi": "Rodonyà",
		"codi_municipi": "431325",
		"latitud": "41.27978260770917",
		"longitud": "1.3987541581645004",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça Major, 1",
		"tipologia": "Biblioteca",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-02T09:10:00.000"
	},
	{
		":id": "row-x6ef-syfr_zmq5",
		":version": "rv-pn5s_7ayi.jxy9",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CMSS",
		"indicador_refugi": "431325|CMSS",
		"municipi": "Rodonyà",
		"codi_municipi": "431325",
		"latitud": "41.28223933058955",
		"longitud": "1.3978364922320647",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Diputació 4",
		"tipologia": "Casal de Gent Gran",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-02T09:14:00.000"
	},
	{
		":id": "row-reth.d8uq_ikf2",
		":version": "rv-sgrt_v7x2_h8jj",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça Raval Nova",
		"indicador_refugi": "431331|PLACA_RAVAL_NOVA",
		"municipi": "Roquetes",
		"codi_municipi": "431331",
		"latitud": "40.82304103",
		"longitud": "0.50108599",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Raval Nova",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-6pm8.vy75~xd2i",
		":version": "rv-tzem~kh22.yvrf",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Hort de Cruells",
		"indicador_refugi": "431331|PARC_HORT_DE_CRUELLS",
		"municipi": "Roquetes",
		"codi_municipi": "431331",
		"latitud": "40.8178798",
		"longitud": "0.50669657",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Parc Hort de Cruells",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-v9kt.npfk_nx3j",
		":version": "rv-6kzz-uqm5.sk7d",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Mercè Lleixà",
		"indicador_refugi": "431331|BIBLIOTECA_MERCE_LLEIXA",
		"municipi": "Roquetes",
		"codi_municipi": "431331",
		"latitud": "40.81996071",
		"longitud": "0.4953293",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Urb. Torre d'en Gil",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-nbtt-7sni-q3rn",
		":version": "rv-urje-zxka~ecce",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Manel Domenech",
		"indicador_refugi": "431331|PARC_MANEL_DOMENECH",
		"municipi": "Roquetes",
		"codi_municipi": "431331",
		"latitud": "40.82035514",
		"longitud": "0.49592082",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pg. Manel Cid",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-mejj.amdr~pkia",
		":version": "rv-28bp_fr7f_apsw",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Ajuntament de Roquetes",
		"indicador_refugi": "431331|AJUNTAMENT_DE_ROQUETES",
		"municipi": "Roquetes",
		"codi_municipi": "431331",
		"latitud": "40.81840757",
		"longitud": "0.50306486",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. Diputació, s/n",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-fui7~6e97_re54",
		":version": "rv-sru5_w93a~h28h",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça Pare Cirera",
		"indicador_refugi": "431331|PLACA_PARE_CIRERA",
		"municipi": "Roquetes",
		"codi_municipi": "431331",
		"latitud": "40.80908424",
		"longitud": "0.49524842",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Pare Cirera",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-z9uf~twpv-hu85",
		":version": "rv-ccz9.7ikp.ccpq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Passeig del Canal",
		"indicador_refugi": "431331|PASSEIG_DEL_CANAL",
		"municipi": "Roquetes",
		"codi_municipi": "431331",
		"latitud": "40.81957066",
		"longitud": "0.50458031",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pg. del Canal",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-edjq.ha88.ivgn",
		":version": "rv-4jfn-ak35_k9jw",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Jaume Vicens i Vives",
		"indicador_refugi": "171523|BIBLIOTECA_JAUME_VICENS_I_VIVES",
		"municipi": "Roses",
		"codi_municipi": "171523",
		"latitud": "42.26371064",
		"longitud": "3.17657",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. de Girona, 22-30",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-222p.7i6b~7z48",
		":version": "rv-i7sb_hgng-444i",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal de Roses",
		"indicador_refugi": "171523|PISCINA_MUNICIPAL_DE_ROSES",
		"municipi": "Roses",
		"codi_municipi": "171523",
		"latitud": "42.26940231",
		"longitud": "3.18128841",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Ctra. del Mas Oliva, 39",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-9fgd.fmn7-ygt2",
		":version": "rv-bfv3.dt98-guzm",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca de Rosselló",
		"indicador_refugi": "251898|BIBLIOTECA_DE_ROSSELLO",
		"municipi": "Rosselló",
		"codi_municipi": "251898",
		"latitud": "41.69609024",
		"longitud": "0.59594716",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. Catalunya, 2",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-fxn2_c9b3.bara",
		":version": "rv-zg7y.jip4-px3k",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc del carrer Aneto (Ximelis)",
		"indicador_refugi": "081846|PARC_DEL_CARRER_ANETO_XIMELIS",
		"municipi": "Rubí",
		"codi_municipi": "081846",
		"latitud": "41.4946474",
		"longitud": "2.00535784",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Parc del C. Aneto (Ximelis)",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-c73p-x5jq~uqb4",
		":version": "rv-rd4i~2e9c~dary",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Oficina d’Atenció Ciutadana de Les Torres (OADF, ODE i Sector II de Serveis Socials)",
		"indicador_refugi": "081846|OFICINA_D_ATENCIO_CIUTADANA_DE_LES_TORRES_OADF_ODE_I_SECTOR_II_DE_SERVEIS_SOCIALS",
		"municipi": "Rubí",
		"codi_municipi": "081846",
		"latitud": "41.48573096",
		"longitud": "2.03047463",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Rblt. de Joan Miró, s/n, 08191 Rubí",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-ch9k.te5g_ime7",
		":version": "rv-m2ys~6ifj~5yww",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça del Veïnat (zona de plataners)",
		"indicador_refugi": "081846|PLACA_DEL_VEINAT_ZONA_DE_PLATANERS",
		"municipi": "Rubí",
		"codi_municipi": "081846",
		"latitud": "41.48741041",
		"longitud": "2.04113431",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Terol, s/n",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-uwwx-jvtd_fkzb",
		":version": "rv-v4v7_jd96_vc9q",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça de les Moreres",
		"indicador_refugi": "081846|PLACA_DE_LES_MORERES",
		"municipi": "Rubí",
		"codi_municipi": "081846",
		"latitud": "41.49511648",
		"longitud": "2.0391695",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Mallorca, s/n",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-vfjf~dcnb.kmnu",
		":version": "rv-kfdy.8y7g_k9ax",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça de Pep Rovira",
		"indicador_refugi": "081846|PLACA_DE_PEP_ROVIRA",
		"municipi": "Rubí",
		"codi_municipi": "081846",
		"latitud": "41.48796776",
		"longitud": "2.02908438",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. de Pep Rovira",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-pu6h.j97q.jfz7",
		":version": "rv-ddnr_aqg2-839h",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Torrent de les Abelles",
		"indicador_refugi": "081846|TORRENT_DE_LES_ABELLES",
		"municipi": "Rubí",
		"codi_municipi": "081846",
		"latitud": "41.48354",
		"longitud": "2.02885",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Luxemburg - Pg. de la Riera",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-ewka.k2j6_m8ps",
		":version": "rv-rn3i_r925_k66x",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça d’Andalusia (zona de lledoners)",
		"indicador_refugi": "081846|PLACA_D_ANDALUSIA_ZONA_DE_LLEDONERS",
		"municipi": "Rubí",
		"codi_municipi": "081846",
		"latitud": "41.50220363",
		"longitud": "2.0366037",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. d’Andalusia (zona de lledoners)",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-ha38-4jws-tca8",
		":version": "rv-cn2m-a24p_qzre",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça dels Nens",
		"indicador_refugi": "081846|PLACA_DELS_NENS",
		"municipi": "Rubí",
		"codi_municipi": "081846",
		"latitud": "41.48356526",
		"longitud": "2.03096964",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. dels Nens",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-59gx-m92s_tevw",
		":version": "rv-7msy~85um~aqkj",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça dels Ocells (Els Avets)",
		"indicador_refugi": "081846|PLACA_DELS_OCELLS_ELS_AVETS",
		"municipi": "Rubí",
		"codi_municipi": "081846",
		"latitud": "41.48448134",
		"longitud": "2.01888071",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. dels Ocells (Els Avets)",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-yuhy-fjvj_tq4f",
		":version": "rv-fa2r.mg47.dnu2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de Ca n’Alzamora",
		"indicador_refugi": "081846|PARC_DE_CA_N_ALZAMORA",
		"municipi": "Rubí",
		"codi_municipi": "081846",
		"latitud": "41.47846908",
		"longitud": "2.03507911",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Parc de Ca n’Alzamora",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-9neb_mb2q~ki38",
		":version": "rv-g39g-j7cw.wpwy",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Rambleta de Joan Miró (zona de til·lers)",
		"indicador_refugi": "081846|RAMBLETA_DE_JOAN_MIRO_ZONA_DE_TIL_LERS",
		"municipi": "Rubí",
		"codi_municipi": "081846",
		"latitud": "41.48625451",
		"longitud": "2.03065831",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Rblt. de Joan Miró, 6",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-x6nw-m49h-mu7x",
		":version": "rv-abes~pdsb_7en9",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Residència Rubí",
		"indicador_refugi": "081846|RESIDENCIA_RUBI",
		"municipi": "Rubí",
		"codi_municipi": "081846",
		"latitud": "41.49994462",
		"longitud": "2.03477207",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. de Lepant 31, 08191 Rubí",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-ztrj_xyby.qts4",
		":version": "rv-zhak~6y8b.3zcf",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casa de la vila",
		"indicador_refugi": "081846|CASA_DE_LA_VILA",
		"municipi": "Rubí",
		"codi_municipi": "081846",
		"latitud": "41.49397012",
		"longitud": "2.0311326",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. de Pere Aguilera, 1, 08191 Rubí",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-igaq_qn7g_2jfw",
		":version": "rv-fx35-tu7j~zte3",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Torrent de Can Matalí",
		"indicador_refugi": "081846|TORRENT_DE_CAN_MATALI",
		"municipi": "Rubí",
		"codi_municipi": "081846",
		"latitud": "41.52936267",
		"longitud": "1.99940455",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Torrent de Can Matalí",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-hqbr.am2x_6fyy",
		":version": "rv-3pbj.jigu_x5wr",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal cívic i comunitari de Rubí",
		"indicador_refugi": "081846|CASAL_CIVIC_I_COMUNITARI_DE_RUBI",
		"municipi": "Rubí",
		"codi_municipi": "081846",
		"latitud": "41.49008458",
		"longitud": "2.03570031",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Magallanes, 60, 08191 Rubí",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-v3e6-ggs6.5ewp",
		":version": "rv-av7z_jk3q.bwt2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Rambla del Ferrocarril, a la zona on hi ha la pèrgola",
		"indicador_refugi": "081846|RAMBLA_DEL_FERROCARRIL_A_LA_ZONA_ON_HI_HA_LA_PERGOLA",
		"municipi": "Rubí",
		"codi_municipi": "081846",
		"latitud": "41.48496921",
		"longitud": "2.03468723",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pg. del Ferrocarril, 7",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-nvr2~z5tq.q6j8",
		":version": "rv-exmt_ceer-vemj",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Ibèric (Can Fatjó)",
		"indicador_refugi": "081846|PARC_IBERIC_CAN_FATJO",
		"municipi": "Rubí",
		"codi_municipi": "081846",
		"latitud": "41.49030528",
		"longitud": "2.0269476",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Parc Ibèric (Can Fatjó)",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-ykiq.9n4y~zyp3",
		":version": "rv-nd4f_n4gk-rzz2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc del carrer Chueca (Can Vallhonrat)",
		"indicador_refugi": "081846|PARC_DEL_CARRER_CHUECA_CAN_VALLHONRAT",
		"municipi": "Rubí",
		"codi_municipi": "081846",
		"latitud": "41.47289579",
		"longitud": "2.03349115",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Parc del C. Chueca (Can Vallhonrat)",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-ghbp-gquz_f9p5",
		":version": "rv-st3e~fnv8-4ntg",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Museu municipal el Castell MMUC",
		"indicador_refugi": "081846|MUSEU_MUNICIPAL_EL_CASTELL_MMUC",
		"municipi": "Rubí",
		"codi_municipi": "081846",
		"latitud": "41.49484427",
		"longitud": "2.02647308",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Castell, 35, 08191 Rubí",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-r27h.mbne~e6vd",
		":version": "rv-54tk_ecef_he42",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "La Cruïlla Centre cívic del Pinar",
		"indicador_refugi": "081846|LA_CRUILLA_CENTRE_CIVIC_DEL_PINAR",
		"municipi": "Rubí",
		"codi_municipi": "081846",
		"latitud": "41.50876468",
		"longitud": "2.04578946",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Urbanització El Pinar, 1, 08191 Rubí",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-3ci3~k77f-2aap",
		":version": "rv-4nuu-fdi7-gs45",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc dels Geranis (Av. Can Sucarrats)",
		"indicador_refugi": "081846|PARC_DELS_GERANIS_AV_CAN_SUCARRATS",
		"municipi": "Rubí",
		"codi_municipi": "081846",
		"latitud": "41.48647944",
		"longitud": "2.02047114",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Parc dels Geranis (Av. Can Sucarrats)",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-mwxi-qu6n.r6tk",
		":version": "rv-gnrk~8tzw~pi3k",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça de Santa Rosa",
		"indicador_refugi": "081846|PLACA_DE_SANTA_ROSA",
		"municipi": "Rubí",
		"codi_municipi": "081846",
		"latitud": "41.49561704",
		"longitud": "2.0373704",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. de Santa Rosa",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-xp9i.bqpy-xx75",
		":version": "rv-wf37_ymc5~ginb",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca municipal Mestre Martí Tauler",
		"indicador_refugi": "081846|BIBLIOTECA_MUNICIPAL_MESTRE_MARTI_TAULER",
		"municipi": "Rubí",
		"codi_municipi": "081846",
		"latitud": "41.49293502",
		"longitud": "2.03632107",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. d'Aribau, 5, 08191 Rubí",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-f67j-wyr7-faic",
		":version": "rv-2vnc~aimw-y5jd",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc per la Pau i la Natura (zona de pollancres)",
		"indicador_refugi": "081846|PARC_PER_LA_PAU_I_LA_NATURA_ZONA_DE_POLLANCRES",
		"municipi": "Rubí",
		"codi_municipi": "081846",
		"latitud": "41.48401329",
		"longitud": "2.03695711",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de Marconi, 18",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-uya9_cmd5_yj3y",
		":version": "rv-9rce_fpcq_rc45",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de Can Fatjó (àrees carrer Topazi, pineda amb una font).",
		"indicador_refugi": "081846|PARC_DE_CAN_FATJO_AREES_CARRER_TOPAZI_PINEDA_AMB_UNA_FONT",
		"municipi": "Rubí",
		"codi_municipi": "081846",
		"latitud": "41.49148982",
		"longitud": "2.02554107",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Parc de Can Fatjó",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-6uze.rst8.fhqv",
		":version": "rv-gifr~vv4k~xc2y",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Rubí",
		"indicador_refugi": "081846|CASAL_CIVIC_I_COMUNITARI_RUBI",
		"municipi": "Rubí",
		"codi_municipi": "081846",
		"latitud": "41.4899118",
		"longitud": "2.0330825",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de Magallanes, 60",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-f2qe.6tie.z7fb",
		":version": "rv-f3k8.d7na-fgkx",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça de l’Aragó",
		"indicador_refugi": "081846|PLACA_DE_L_ARAGO",
		"municipi": "Rubí",
		"codi_municipi": "081846",
		"latitud": "41.49640732",
		"longitud": "2.04078548",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. de l’Aragó",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-82bv.ycqx_ykrs",
		":version": "rv-dagd-nwgz~mbqb",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Ateneu municipal",
		"indicador_refugi": "081846|ATENEU_MUNICIPAL",
		"municipi": "Rubí",
		"codi_municipi": "081846",
		"latitud": "41.4926869",
		"longitud": "2.033071",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Xile, 1-3, 08191 Rubí",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-dmy9-hjfs-xpg5",
		":version": "rv-27tr_ngtk-6u4b",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de la Font de la Via",
		"indicador_refugi": "081846|PARC_DE_LA_FONT_DE_LA_VIA",
		"municipi": "Rubí",
		"codi_municipi": "081846",
		"latitud": "41.48949349",
		"longitud": "2.02730999",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Parc de la Font de la Via",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-jg6m-yazt_z3cw",
		":version": "rv-5mf3~npq3_s8ie",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Mercat municipal",
		"indicador_refugi": "081846|MERCAT_MUNICIPAL",
		"municipi": "Rubí",
		"codi_municipi": "081846",
		"latitud": "41.48938708",
		"longitud": "2.03501157",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Cal Gerrer, 1, 08191 Rubí",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-nzj9.b67c~kgnv",
		":version": "rv-qpay_d5sm-ia5b",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Arborètum del Castell",
		"indicador_refugi": "081846|ARBORETUM_DEL_CASTELL",
		"municipi": "Rubí",
		"codi_municipi": "081846",
		"latitud": "41.49491458",
		"longitud": "2.02682931",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. del Castell, 35",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-93gq_ibw9~ztd5",
		":version": "rv-y5rs.6xsr.q8x9",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Sala local social del Pla de Rubió",
		"indicador_refugi": "081859|SALA_LOCAL_SOCIAL_DEL_PLA_DE_RUBIO",
		"municipi": "Rubió",
		"codi_municipi": "081859",
		"latitud": "41.62581395",
		"longitud": "1.55095337",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Escoles, s/n",
		"tipologia": "Sala polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-mqks_5yg5_q2hp",
		":version": "rv-sz2i.igd4~wtdt",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre recreatiu Castell de Rubió",
		"indicador_refugi": "081859|CENTRE_RECREATIU_CASTELL_DE_RUBIO",
		"municipi": "Rubió",
		"codi_municipi": "081859",
		"latitud": "41.64408",
		"longitud": "1.56945",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Zona Castell de Rubió-Anoia",
		"informacio_web": "www.rubio.cat",
		"tipologia": "Sala Polivalent",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-02T15:49:00.000"
	},
	{
		":id": "row-dwbs_za4x_pbdb",
		":version": "rv-tfvv-kg7z_ghs9",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Zona esportiva municipal - El Pla de Rubió",
		"indicador_refugi": "081859|ZONA_ESPORTIVA_MUNICIPAL_-_EL_PLA_DE_RUBIO",
		"municipi": "Rubió",
		"codi_municipi": "081859",
		"latitud": "41.625997",
		"longitud": "1.551635",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Escoles, 3",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-02T15:53:00.000"
	},
	{
		":id": "row-3gv9~d5yg~9xrg",
		":version": "rv-qbag~fg2g~8ze2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Teatre de Rupià",
		"indicador_refugi": "171539|TEATRE_DE_RUPIA",
		"municipi": "Rupià",
		"codi_municipi": "171539",
		"latitud": "42.0201328",
		"longitud": "3.0114381",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Indústria, 2",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-jk87.6t8b.44az",
		":version": "rv-j7nb.xajn_enm5",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Espai Joan Font",
		"indicador_refugi": "089019|ESPAI_JOAN_FONT",
		"municipi": "Rupit i Pruit",
		"codi_municipi": "089019",
		"latitud": "42.02530798",
		"longitud": "2.46492864",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Camí Sant Joan de Fabregues, 1 bis",
		"tipologia": "Sala polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-m3k5_22c3-g252",
		":version": "rv-anwc-ere9~8ddc",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca de la Serra",
		"indicador_refugi": "081878|BIBLIOTECA_DE_LA_SERRA",
		"municipi": "Sabadell",
		"codi_municipi": "081878",
		"latitud": "41.54961554",
		"longitud": "2.12888061",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Pl. de Cristóbal Ramos, 1",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-3nwb-u6im.na5t",
		":version": "rv-ih6k_ztn7_qgbk",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Sabadell - Roureda",
		"indicador_refugi": "081878|CASAL_CIVIC_I_COMUNITARI_SABADELL_ROUREDA",
		"municipi": "Sabadell",
		"codi_municipi": "081878",
		"latitud": "41.5701946",
		"longitud": "2.0638516",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de Costabona, s/n",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-74y8-g4xs~rwzu",
		":version": "rv-rvi9~ayd4.eijc",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "La Bassa",
		"indicador_refugi": "081878|LA_BASSA",
		"municipi": "Sabadell",
		"codi_municipi": "081878",
		"latitud": "41.53779115",
		"longitud": "2.12563901",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Camí de Can Quadres, 179",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-gx76_9vg9.zfh4",
		":version": "rv-cn35~24nb~qvq2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Sud",
		"indicador_refugi": "081878|BIBLIOTECA_SUD",
		"municipi": "Sabadell",
		"codi_municipi": "081878",
		"latitud": "41.53023744",
		"longitud": "2.11965094",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Pg. dels Almogàvers, 49",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-37qk-gbbh~ap2m",
		":version": "rv-ndkx~akk7~dip5",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Sabadell - Gràcia",
		"indicador_refugi": "081878|CASAL_CIVIC_I_COMUNITARI_SABADELL_GRACIA",
		"municipi": "Sabadell",
		"codi_municipi": "081878",
		"latitud": "41.5383422",
		"longitud": "2.0987139",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de la Reina Elionor, 110",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-mu7g-gzrj_m3uc",
		":version": "rv-apyy-bgyt-ight",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Torrent de la Romeua",
		"indicador_refugi": "081878|PARC_TORRENT_DE_LA_ROMEUA",
		"municipi": "Sabadell",
		"codi_municipi": "081878",
		"latitud": "41.56608854",
		"longitud": "2.08311343",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "No",
		"adreca": "Torrent de la Romeua, 19, 08207 Sabadell, Barcelona",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-e4vb_se2k-sm79",
		":version": "rv-g382-u4sj-xcxn",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina Can Marcet",
		"indicador_refugi": "081878|PISCINA_CAN_MARCET",
		"municipi": "Sabadell",
		"codi_municipi": "081878",
		"latitud": "41.54171246",
		"longitud": "2.0994306",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de Riu-Sec, 54, 08205 Sabadell, Barcelona",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-3nt4~9icb_kisf",
		":version": "rv-mycm-8gt5~q24e",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic Concòrdia",
		"indicador_refugi": "081878|CENTRE_CIVIC_CONCORDIA",
		"municipi": "Sabadell",
		"codi_municipi": "081878",
		"latitud": "41.55850764",
		"longitud": "2.09448069",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. de la Lusitània, 3, 08206 Sabadell, Barcelona",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-b2fi.hwia.ivjw",
		":version": "rv-hudf-nqxp-6mcn",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Catalunya",
		"indicador_refugi": "081878|PARC_CATALUNYA",
		"municipi": "Sabadell",
		"codi_municipi": "081878",
		"latitud": "41.55314059",
		"longitud": "2.09383033",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Prat de la Riba, 104, 08206 Sabadell, Barcelona",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-i7n7_tw95-if8t",
		":version": "rv-5mf4-73ip-wfwg",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal cívic Creu Barbera",
		"indicador_refugi": "081878|CASAL_CIVIC_CREU_BARBERA",
		"municipi": "Sabadell",
		"codi_municipi": "081878",
		"latitud": "41.52625298",
		"longitud": "2.11846501",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "PLAÇA CASTELAO, 1",
		"informacio_web": "https://web.sabadell.cat/",
		"tipologia": "Centre Cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-06-05T14:28:00.000"
	},
	{
		":id": "row-kk4u_tu3y-pcb5",
		":version": "rv-wzqr~d9rv~vtc6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Sabadell - Torre Romeu",
		"indicador_refugi": "081878|CASAL_CIVIC_I_COMUNITARI_SABADELL_TORRE_ROMEU",
		"municipi": "Sabadell",
		"codi_municipi": "081878",
		"latitud": "41.551043",
		"longitud": "2.1230097",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. d'Anoia, s/n",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-jakb.bxg6~mryt",
		":version": "rv-eqa7-66t3-mk88",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Sabadell - Creu Alta",
		"indicador_refugi": "081878|CASAL_CIVIC_I_COMUNITARI_SABADELL_CREU_ALTA",
		"municipi": "Sabadell",
		"codi_municipi": "081878",
		"latitud": "41.5608069",
		"longitud": "2.0977664",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de Castellar del Vallès, 224",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-xtm3~wi2r.bw2k",
		":version": "rv-x3s5.ntzf.q65g",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic Can Puiggener",
		"indicador_refugi": "081878|CENTRE_CIVIC_CAN_PUIGGENER",
		"municipi": "Sabadell",
		"codi_municipi": "081878",
		"latitud": "41.56529696",
		"longitud": "2.10405628",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. d'Archidona, 3, 08208 Sabadell, Barcelona",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-9eaz.en4c_zse4",
		":version": "rv-izb6~hhxw.23jm",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic Arraona- Merinals",
		"indicador_refugi": "081878|CENTRE_CIVIC_ARRAONA_MERINALS",
		"municipi": "Sabadell",
		"codi_municipi": "081878",
		"latitud": "41.54241845",
		"longitud": "2.09082656",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "2, Pl. del Pla de l'Amor, 2, 08192 Sabadell, Barcelona",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-wk7s_cqti_xtvi",
		":version": "rv-kc2g~qktw_4xrv",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Ponent",
		"indicador_refugi": "081878|BIBLIOTECA_PONENT",
		"municipi": "Sabadell",
		"codi_municipi": "081878",
		"latitud": "41.55626443",
		"longitud": "2.08931708",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Pl. Ovidi Montllor, 5, 08206 Sabadell, Barcelona",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-acyd-hi7d-8md8",
		":version": "rv-pdtu-af9b~h5zs",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Central",
		"indicador_refugi": "081878|PARC_CENTRAL",
		"municipi": "Sabadell",
		"codi_municipi": "081878",
		"latitud": "41.52085749",
		"longitud": "2.11202027",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "No",
		"adreca": "Torrent, 101, 25, 08210 Barberà del Vallès, Barcelona",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-qja2.myyh.zmf5",
		":version": "rv-rk4b~yvrk.58bu",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina Ca N'oriach",
		"indicador_refugi": "081878|PISCINA_CA_N_ORIACH",
		"municipi": "Sabadell",
		"codi_municipi": "081878",
		"latitud": "41.57050706",
		"longitud": "2.09283615",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "No",
		"adreca": "Rbla. Navacerrada",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-e2p3~ucyk~29qa",
		":version": "rv-k4xv.d24g.x4iu",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblitoteca Vapor Badia",
		"indicador_refugi": "081878|BIBLITOTECA_VAPOR_BADIA",
		"municipi": "Sabadell",
		"codi_municipi": "081878",
		"latitud": "41.54673674",
		"longitud": "2.114503",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. de les Tres Creus, 127, 129, 08202 Sabadell, Barcelona",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-m44e~icq6~aecg",
		":version": "rv-cdt9_885e_xjpb",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Sabadell - Rogelio Soto",
		"indicador_refugi": "081878|CASAL_CIVIC_I_COMUNITARI_SABADELL_ROGELIO_SOTO",
		"municipi": "Sabadell",
		"codi_municipi": "081878",
		"latitud": "41.526220950776725",
		"longitud": "2.1104523914554654",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de Campoamor, 93-95",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-q9pk~34h3.9u79",
		":version": "rv-y459_ydcd_a3qp",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic Gràcia",
		"indicador_refugi": "081878|CENTRE_CIVIC_GRACIA",
		"municipi": "Sabadell",
		"codi_municipi": "081878",
		"latitud": "41.53749453",
		"longitud": "2.10271543",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Pl. del Treball, 1",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-w5z2~9ze8~zczd",
		":version": "rv-uibb_tgbn-44yw",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic Can Rull",
		"indicador_refugi": "081878|CENTRE_CIVIC_CAN_RULL",
		"municipi": "Sabadell",
		"codi_municipi": "081878",
		"latitud": "41.55390728",
		"longitud": "2.08482378",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. de Sant Isidor, 51, 08206 Sabadell, Barcelona",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-wki2.npt2~gmga",
		":version": "rv-qim2.3p7g_h8bk",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Sabadell - Creu de barberà",
		"indicador_refugi": "081878|CASAL_CIVIC_I_COMUNITARI_SABADELL_CREU_DE_BARBERA",
		"municipi": "Sabadell",
		"codi_municipi": "081878",
		"latitud": "41.5260842",
		"longitud": "2.113916",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de la Verge de la Paloma, 19-21 (cant. C. Salvat Papasseït, 65)",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-jmnw_xf2k~35jy",
		":version": "rv-6q3y-vkgn_esib",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic Creu Alta",
		"indicador_refugi": "081878|CENTRE_CIVIC_CREU_ALTA",
		"municipi": "Sabadell",
		"codi_municipi": "081878",
		"latitud": "41.55581467",
		"longitud": "2.1025735",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Ctra. de Prats de Lluçanès, 2, 08208 Sabadell, Barcelona",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-ndig_s96u~3qjr",
		":version": "rv-xpm4-nu2i.ypsu",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic Sant Oleguer",
		"indicador_refugi": "081878|CENTRE_CIVIC_SANT_OLEGUER",
		"municipi": "Sabadell",
		"codi_municipi": "081878",
		"latitud": "41.53760993",
		"longitud": "2.11897008",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. de Sol i Padrís, 93",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-q5ut~4s2v_w78c",
		":version": "rv-nkcz-tif5.x787",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic Can Llong-Castellarnau",
		"indicador_refugi": "081878|CENTRE_CIVIC_CAN_LLONG_CASTELLARNAU",
		"municipi": "Sabadell",
		"codi_municipi": "081878",
		"latitud": "41.56178262",
		"longitud": "2.08315404",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Av. d'Estrasburg, 82, 08206 Sabadell, Barcelona",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-8sjz~u25z-b32i",
		":version": "rv-9epx-pj9z~nk6u",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic Torre-romeu",
		"indicador_refugi": "081878|CENTRE_CIVIC_TORRE_ROMEU",
		"municipi": "Sabadell",
		"codi_municipi": "081878",
		"latitud": "41.54993436",
		"longitud": "2.12547805",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Pl. de Montcortès, 1",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-uqne_z6zi.fcar",
		":version": "rv-iufx-crbs.3g4r",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Nord",
		"indicador_refugi": "081878|BIBLIOTECA_NORD",
		"municipi": "Sabadell",
		"codi_municipi": "081878",
		"latitud": "41.57099445",
		"longitud": "2.09143437",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Rda. de Navacerrada, 60, 08207 Sabadell, Barcelona",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-8yxt.ix6r.mng8",
		":version": "rv-274u-fzg3~jkk4",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Taulí",
		"indicador_refugi": "081878|PARC_TAULI",
		"municipi": "Sabadell",
		"codi_municipi": "081878",
		"latitud": "41.55646607",
		"longitud": "2.11228518",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "No",
		"adreca": "C. del Vidal",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-c9ah.u7ts~4npf",
		":version": "rv-tpng.j5cw-7bun",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina Campoamor",
		"indicador_refugi": "081878|PISCINA_CAMPOAMOR",
		"municipi": "Sabadell",
		"codi_municipi": "081878",
		"latitud": "41.52536709",
		"longitud": "2.11198894",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de Pardo Bazán, 17, 08204 Sabadell, Barcelona",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-6x8k~yvcb_ftw7",
		":version": "rv-b8gr_snf7~2yac",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Odessa",
		"indicador_refugi": "081878|PARC_ODESSA",
		"municipi": "Sabadell",
		"codi_municipi": "081878",
		"latitud": "41.56243998",
		"longitud": "2.07959383",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Av. d'Estrasburg, 112, 08206 Sabadell, Barcelona",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-jv7q-mbmn_36bm",
		":version": "rv-vujc.i642_yqax",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Can Gambús",
		"indicador_refugi": "081878|PARC_CAN_GAMBUS",
		"municipi": "Sabadell",
		"codi_municipi": "081878",
		"latitud": "41.54763559",
		"longitud": "2.0808544",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. del Kurdistan, s/n, 08205 Sabadell, Barcelona",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-jeht.fr8v.wwm3",
		":version": "rv-g6fq_q8ii_4hi7",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Sabadell - Casal",
		"indicador_refugi": "081878|CASAL_CIVIC_I_COMUNITARI_SABADELL_CASAL",
		"municipi": "Sabadell",
		"codi_municipi": "081878",
		"latitud": "41.547914",
		"longitud": "2.1082504",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de Sant Josep, 22",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-7uwi~64dm~66v9",
		":version": "rv-hnm8~nr2t~k8he",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic Poblenou",
		"indicador_refugi": "081878|CENTRE_CIVIC_POBLENOU",
		"municipi": "Sabadell",
		"codi_municipi": "081878",
		"latitud": "41.56122268",
		"longitud": "2.1301371",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. del Remei, 1-9",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-y6es-7hbi-mmrt",
		":version": "rv-2ia5.yw9x-xisg",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CENTRE CÍVIC DE CA N'ORIAC",
		"indicador_refugi": "081878|CENTRE_CIVIC_DE_CA_NORIAC",
		"municipi": "Sabadell",
		"codi_municipi": "081878",
		"latitud": "41.56510654979748",
		"longitud": "2.0940159512475223",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C/Arousa, 2 08207 sabadell",
		"informacio_web": "https://web.sabadell.cat/",
		"tipologia": "Centre Cívic",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-05T14:35:00.000"
	},
	{
		":id": "row-8ep8-u69z.m5n2",
		":version": "rv-fccw.u2zg_xfx7",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "BIBLIOTECA SAFAREIGS",
		"indicador_refugi": "081878|BIBLIOTECA_SAFAREIGS",
		"municipi": "Sabadell",
		"codi_municipi": "081878",
		"latitud": "41.55447348660388",
		"longitud": "2.1011141230548565",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C/Papa Pius XI, 165 Sabadell",
		"informacio_web": "https://web.sabadell.cat/",
		"tipologia": "Biblioteca",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-05T16:24:00.000"
	},
	{
		":id": "row-srjn_jcem_jp6n",
		":version": "rv-ra3c-9egs-9f2q",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "BIBLIOTECA CAN PUIGGENER",
		"indicador_refugi": "081878|BIBLIOTECA_CAN_PUIGGENER",
		"municipi": "Sabadell",
		"codi_municipi": "081878",
		"latitud": "41.56517021730269",
		"longitud": "2.1040419960723997",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça Primer de Maig , 1 Sabadell",
		"informacio_web": "https://web.sabadell.cat/",
		"tipologia": "Biblioteca",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-05T16:27:00.000"
	},
	{
		":id": "row-rxpd-t35p_hnuv",
		":version": "rv-mnq6~iw4q_fie2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "PISCINA OLIMPIA",
		"indicador_refugi": "081878|PISCINA_OLIMPIA",
		"municipi": "Sabadell",
		"codi_municipi": "081878",
		"latitud": "41.556388367501185",
		"longitud": "2.092877367235714",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer de l'Apúlia, 40, 08206 Sabadell, Barcelona",
		"informacio_web": "https://web.sabadell.cat/",
		"tipologia": "Piscines descobertes",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-05T16:30:00.000"
	},
	{
		":id": "row-d3z3~23sv~x4s6",
		":version": "rv-h48i.n94b_7msh",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "PARC DE LES AIGÜES",
		"indicador_refugi": "081878|PARC_DE_LES_AIGUES",
		"municipi": "Sabadell",
		"codi_municipi": "081878",
		"latitud": "41.561380311280395",
		"longitud": "2.0828840591224385",
		"accessibilitat": "Sí",
		"aigua": "No",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "08206 Sabadell, Barcelona",
		"informacio_web": "https://web.sabadell.cat/",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-05T16:35:00.000"
	},
	{
		":id": "row-aack~pu9c_69nv",
		":version": "rv-dvqc.ri3j-dg95",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "PLAÇA DE GERNIKA",
		"indicador_refugi": "081878|PLACA_DE_GERNIKA",
		"municipi": "Sabadell",
		"codi_municipi": "081878",
		"latitud": "41.5587495784414",
		"longitud": "2.0848125577084256",
		"accessibilitat": "Sí",
		"aigua": "No",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "08206 Sabadell, Barcelona",
		"informacio_web": "https://web.sabadell.cat/",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-05T16:41:00.000"
	},
	{
		":id": "row-qbuq-ijij-3fr3",
		":version": "rv-92hw.uepd~cuvb",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "PARC DEL NORD",
		"indicador_refugi": "081878|PARC_DEL_NORD",
		"municipi": "Sabadell",
		"codi_municipi": "081878",
		"latitud": "41.57246277785154",
		"longitud": "2.0870409196526936",
		"accessibilitat": "Sí",
		"aigua": "No",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer de Feliu Elias, 5, 08207 Sabadell, Barcelona",
		"informacio_web": "https://web.sabadell.cat/",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-05T16:49:00.000"
	},
	{
		":id": "row-guq8~gj59_2h3k",
		":version": "rv-hgi4.23zq-ie9g",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "JOCS INFANTILS D'AIGUA PARC DE LES AIGÜES",
		"indicador_refugi": "081878|JOCS_INFANTILS_DAIGUA_PARC_DE_LES_AIGUES",
		"municipi": "Sabadell",
		"codi_municipi": "081878",
		"latitud": "41.559462248114656",
		"longitud": "2.086289182580513",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Av. d'Estrasburg, 81, 08206 Sabadell, Barcelona",
		"informacio_web": "https://web.sabadell.cat/",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-05T17:03:00.000"
	},
	{
		":id": "row-bwa4.g5rt.iedp",
		":version": "rv-55zu.7x27_zrfx",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "COMPLEX ALEXANDRA PER A LA GENT GRAN",
		"indicador_refugi": "081878|COMPLEX_ALEXANDRA_PER_A_LA_GENT_GRAN",
		"municipi": "Sabadell",
		"codi_municipi": "081878",
		"latitud": "41.556265983319925",
		"longitud": "2.089300653744132",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça Ovidi Montllor, 3, 08206 Sabadell, Barcelona",
		"informacio_web": "https://www.sabadell.cat/",
		"tipologia": "Casal de Gent Gran",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-05T17:15:00.000"
	},
	{
		":id": "row-d5bz.qc6q_qqpc",
		":version": "rv-wxw7~qgft-cdxc",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "COMPLEX PARC DENTRAL PER A LA GENT GRAN",
		"indicador_refugi": "081878|COMPLEX_PARC_DENTRAL_PER_A_LA_GENT_GRAN",
		"municipi": "Sabadell",
		"codi_municipi": "081878",
		"latitud": "41.52326963186867",
		"longitud": "2.113878211414407",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer de Diego de Almagro, 44, 08204 Sabadell, Barcelona",
		"informacio_web": "https://www.sabadell.cat/",
		"tipologia": "Casal de Gent Gran",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-05T17:17:00.000"
	},
	{
		":id": "row-est3_6r82-p7g8",
		":version": "rv-pyyn~2rwx~bpry",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "COMPLEX GENT GRAN SANT OLEGUER",
		"indicador_refugi": "081878|COMPLEX_GENT_GRAN_SANT_OLEGUER",
		"municipi": "Sabadell",
		"codi_municipi": "081878",
		"latitud": "41.53866164547575",
		"longitud": "2.1177595711735995",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "c. de Sol i Padrís, 56",
		"informacio_web": "https://www.sabadell.cat/",
		"tipologia": "Casal de Gent Gran",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-05T17:25:00.000"
	},
	{
		":id": "row-wbmg.hs9n_q3s7",
		":version": "rv-2nzx-swmc.jtan",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CENTRE CÍVIC DR J.M.PLANS",
		"indicador_refugi": "081878|CENTRE_CIVIC_DR_JMPLANS",
		"municipi": "Sabadell",
		"codi_municipi": "081878",
		"latitud": "41.57577669973758",
		"longitud": "2.0861911115938168",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C/Portal de la Floresta, 20 08207 Sabadell",
		"informacio_web": "https://web.sabadell.cat/",
		"tipologia": "Centre Cívic",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-05T17:41:00.000"
	},
	{
		":id": "row-it26_tweb~rvup",
		":version": "rv-qnk2_64vc~hhc8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "MERCAT DE SANT JOAN",
		"indicador_refugi": "081878|MERCAT_DE_SANT_JOAN",
		"municipi": "Sabadell",
		"codi_municipi": "081878",
		"latitud": "41.54211359802911",
		"longitud": "2.114861279644231",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pl. Sant Joan, 1A, 08202 Sabadell, Barcelona",
		"informacio_web": "https://web.sabadell.cat/",
		"tipologia": "Casal de Gent Gran",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-05T18:05:00.000"
	},
	{
		":id": "row-w5rz.bbjj-2px6",
		":version": "rv-vevh.vqbj-uje2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Sallent - Verge de Fussimanya",
		"indicador_refugi": "081918|CASAL_CIVIC_I_COMUNITARI_SALLENT_VERGE_DE_FUSSIMANYA",
		"municipi": "Sallent",
		"codi_municipi": "081918",
		"latitud": "41.8263045",
		"longitud": "1.8921835",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Serraima, s/n",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-gccq_dgue~hcd8",
		":version": "rv-jvs5~uyfj.d4wb",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Sallent - Casal",
		"indicador_refugi": "081918|CASAL_CIVIC_I_COMUNITARI_SALLENT_CASAL",
		"municipi": "Sallent",
		"codi_municipi": "081918",
		"latitud": "41.8247121",
		"longitud": "1.8917479",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de Santa Cristina, 2",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-yta7-2873~4uea",
		":version": "rv-6wgr-bxf9.vrca",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de la ciutat",
		"indicador_refugi": "439057|PARC_DE_LA_CIUTAT",
		"municipi": "Salou",
		"codi_municipi": "439057",
		"latitud": "41.07306655",
		"longitud": "1.14778466",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Carles Buigas",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-isk5_nkkh-6u2q",
		":version": "rv-mqr9_ejq2-cnfi",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça Bonet",
		"indicador_refugi": "439057|PLACA_BONET",
		"municipi": "Salou",
		"codi_municipi": "439057",
		"latitud": "41.07608943",
		"longitud": "1.13249548",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Barcelona",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-uanz_8qpf-5b49",
		":version": "rv-6ry8_3e9q~frik",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Arbreda carrer Tauste",
		"indicador_refugi": "439057|ARBREDA_CARRER_TAUSTE",
		"municipi": "Salou",
		"codi_municipi": "439057",
		"latitud": "41.0769993",
		"longitud": "1.12875103",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "No",
		"adreca": "C. Tauste",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-ejij-2ayn-vhgq",
		":version": "rv-t7xb.ctup.3twb",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jardins Platja De Llevant",
		"indicador_refugi": "439057|JARDINS_PLATJA_DE_LLEVANT",
		"municipi": "Salou",
		"codi_municipi": "439057",
		"latitud": "41.07454666",
		"longitud": "1.13617815",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pg. Jaume I, entre el Passeig i la Platja de Llevant",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-kxdd_rnxe~sgne",
		":version": "rv-ppim~exyf_siv4",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Manel Albinyana",
		"indicador_refugi": "439057|PARC_MANEL_ALBINYANA",
		"municipi": "Salou",
		"codi_municipi": "439057",
		"latitud": "41.08375824",
		"longitud": "1.13546259",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Tarragona",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-ttgy-8hvg-gbim",
		":version": "rv-yfpq-rv7x.nyr2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Salt - les Bernardes",
		"indicador_refugi": "171557|CASAL_CIVIC_I_COMUNITARI_SALT_LES_BERNARDES",
		"municipi": "Salt",
		"codi_municipi": "171557",
		"latitud": "41.9759048",
		"longitud": "2.7885998",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. de la Diputació, 2",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-36is.jsst~87jf",
		":version": "rv-iyvc-nm24.54mj",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Ajuntament",
		"indicador_refugi": "251919|AJUNTAMENT",
		"municipi": "Sanaüja",
		"codi_municipi": "251919",
		"latitud": "41.87578406",
		"longitud": "1.30957784",
		"accessibilitat": "No",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Bassal, 4",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-7s48.ew5v_kmkc",
		":version": "rv-b55k-qpjq-7iz8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal social",
		"indicador_refugi": "251919|CASAL_SOCIAL",
		"municipi": "Sanaüja",
		"codi_municipi": "251919",
		"latitud": "41.87544756",
		"longitud": "1.30978867",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. del Bassal, 22, 25753 Sanaüja, Lleida",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-39ug~yy89_m5ur",
		":version": "rv-n84z.j92f_nvmj",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casa de la Vila",
		"indicador_refugi": "081957|CASA_DE_LA_VILA",
		"municipi": "Sant Agustí de Lluçanès",
		"codi_municipi": "081957",
		"latitud": "42.09384278720021",
		"longitud": "2.1309436732147278",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Alou, 4 Sant Agustí de Lluçanès",
		"informacio_web": "https://www.santagustidellucanes.cat/",
		"tipologia": "Ajuntament / Equipament Administratiu",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-22T10:52:00.000"
	},
	{
		":id": "row-wkcf_h36t-bjx4",
		":version": "rv-mec9~4sxa-5hzd",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal jove - Can Rivière",
		"indicador_refugi": "081976|CASAL_JOVE_CAN_RIVIERE",
		"municipi": "Sant Andreu de Llavaneres",
		"codi_municipi": "081976",
		"latitud": "41.57213754",
		"longitud": "2.4846893",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Mare de Déu de Montserrat, 45",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-qj75-rrza_g4jb",
		":version": "rv-rymx.wnhx~q3pp",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Font i Daniel",
		"indicador_refugi": "081976|BIBLIOTECA_FONT_I_DANIEL",
		"municipi": "Sant Andreu de Llavaneres",
		"codi_municipi": "081976",
		"latitud": "41.57455747",
		"longitud": "2.48118366",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Clòsens, 65",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-efqi_dme8~7a5s",
		":version": "rv-cdi2.mcwu-n3yc",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Sala de plens de l'ajuntament",
		"indicador_refugi": "081976|SALA_DE_PLENS_DE_L_AJUNTAMENT",
		"municipi": "Sant Andreu de Llavaneres",
		"codi_municipi": "081976",
		"latitud": "41.57467051",
		"longitud": "2.48337001",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. de la Vila, 1",
		"tipologia": "Sala polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-88ak~nr2i~ctdu",
		":version": "rv-qthi_ppea-syxz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal gent gran",
		"indicador_refugi": "081976|CASAL_GENT_GRAN",
		"municipi": "Sant Andreu de Llavaneres",
		"codi_municipi": "081976",
		"latitud": "41.57323783",
		"longitud": "2.48472453",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Mare de Déu de Montserrat, 35",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-jk33_nhtu.q3ta",
		":version": "rv-9x5u~xm93_wzg2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Font Lúdica del Parc de Can Sauleda",
		"indicador_refugi": "081982|FONT_LUDICA_DEL_PARC_DE_CAN_SAULEDA",
		"municipi": "Sant Antoni de Vilamajor",
		"codi_municipi": "081982",
		"latitud": "41.63860856",
		"longitud": "2.37394644",
		"accessibilitat": "No",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Llinars, 325",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-w8sp~fkjc.krhs",
		":version": "rv-3qw5-d8kw_tiwx",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de la gent gran Can Monteys",
		"indicador_refugi": "081982|CASAL_DE_LA_GENT_GRAN_CAN_MONTEYS",
		"municipi": "Sant Antoni de Vilamajor",
		"codi_municipi": "081982",
		"latitud": "41.6718207",
		"longitud": "2.40120421",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de França, 26",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-r7qs.4rxh~8x32",
		":version": "rv-ec88_grvb.6ghr",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Joana Raspall i Juanola",
		"indicador_refugi": "081982|BIBLIOTECA_JOANA_RASPALL_I_JUANOLA",
		"municipi": "Sant Antoni de Vilamajor",
		"codi_municipi": "081982",
		"latitud": "41.67403588",
		"longitud": "2.40262079",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Pau Casals, 41",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-qw3u.3kh7~jemu",
		":version": "rv-3c3k_mvdw-j4kh",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "082016|PISCINA_MUNICIPAL",
		"municipi": "Sant Boi de Lluçanès",
		"codi_municipi": "082016",
		"latitud": "42.05977297",
		"longitud": "2.15315535",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Zona esportiva municipal",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-ertg_4q6f-3qvh",
		":version": "rv-hknp~6d7w.g4vk",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Refugi climàtic",
		"indicador_refugi": "082037|REFUGI_CLIMATIC",
		"municipi": "Sant Cebrià de Vallalta",
		"codi_municipi": "082037",
		"latitud": "41.618484",
		"longitud": "2.596987",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "08397",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-04T12:46:00.000"
	},
	{
		":id": "row-geh2_pdjw_meiw",
		":version": "rv-bpgs.xwqg_tjjd",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca l'Escorxador",
		"indicador_refugi": "082021|BIBLIOTECA_LESCORXADOR",
		"municipi": "Sant Celoni",
		"codi_municipi": "082021",
		"latitud": "41.6926",
		"longitud": "2.4913",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Passeig de Rectoria Vella 10",
		"informacio_web": "juliol i agost: dimecres i divendres de 9.30 a 13.30 h  i de dilluns a dijous de 15 a 20 h",
		"tipologia": "Biblioteca",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-21T10:54:00.000"
	},
	{
		":id": "row-d474~gr7g.6qzk",
		":version": "rv-idq6~gxw5_pqa7",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Sax Sala",
		"indicador_refugi": "082021|SAX_SALA",
		"municipi": "Sant Celoni",
		"codi_municipi": "082021",
		"latitud": "41.6845",
		"longitud": "2.486",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Montserrat, 28",
		"informacio_web": "https://santceloni.cat/area.php?id=34",
		"tipologia": "Sala Polivalent",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-21T10:59:00.000"
	},
	{
		":id": "row-fhkf.kt2v-5vpg",
		":version": "rv-iva9.pinj~xkdu",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de gent gran",
		"indicador_refugi": "082021|CASAL_DE_GENT_GRAN",
		"municipi": "Sant Celoni",
		"codi_municipi": "082021",
		"latitud": "41.6864",
		"longitud": "2.4898",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Ponent 9",
		"informacio_web": "De dilluns a divendres  de 9 a 12 i de 15 a 19 h Dissabtes de 9 a 12 h",
		"tipologia": "Casal de Gent Gran",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-21T11:08:00.000"
	},
	{
		":id": "row-vw28~jjnu_axby",
		":version": "rv-rz29_8f54~48ty",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Associació veïns Illes Belles",
		"indicador_refugi": "082021|ASSOCIACIO_VEINS_ILLES_BELLES",
		"municipi": "Sant Celoni",
		"codi_municipi": "082021",
		"latitud": "41.6889",
		"longitud": "2.4968",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "carrer Girona, 26",
		"informacio_web": "Juliol i agost:  Tardes de dilluns, dimecres i divendres",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-21T11:16:00.000"
	},
	{
		":id": "row-tkt6-uk3b_nja4",
		":version": "rv-vd3z.ymvb_922w",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "associació de Veïns Les Borrelles",
		"indicador_refugi": "082021|ASSOCIACIO_DE_VEINS_LES_BORRELLES",
		"municipi": "Sant Celoni",
		"codi_municipi": "082021",
		"latitud": "41.6934",
		"longitud": "2.5031",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Bisbe Irurita, 4",
		"informacio_web": "Juliol i agost:  Tardes de dilluns, dimecres i divendres",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-21T11:23:00.000"
	},
	{
		":id": "row-efg5_y7nk-n63r",
		":version": "rv-42qx.n73m.ybx8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal gent gran La Batllòria",
		"indicador_refugi": "082021|CASAL_GENT_GRAN_LA_BATLLORIA",
		"municipi": "Sant Celoni",
		"codi_municipi": "082021",
		"latitud": "41.7185",
		"longitud": "2.5478",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "carrer Major, 31",
		"informacio_web": "Tardes de dilluns a divendres de 17 a 20 h",
		"tipologia": "Casal de Gent Gran",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-21T11:27:00.000"
	},
	{
		":id": "row-58t5.pr7q~wyvm",
		":version": "rv-nce5~yqr5_4wjr",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Unió Batllorienca",
		"indicador_refugi": "082021|UNIO_BATLLORIENCA",
		"municipi": "Sant Celoni",
		"codi_municipi": "082021",
		"latitud": "41.7186",
		"longitud": "2.5476",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "carrer Breda, 2 La Batllòria (Sant Celoni)",
		"informacio_web": "Juliol i agost: de dilluns a  divendres de 10 a 14 h",
		"tipologia": "Centre Cívic",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-21T11:31:00.000"
	},
	{
		":id": "row-vgsk~brnr~6raj",
		":version": "rv-n5rk_jq8v~aqmq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Font Pudosa",
		"indicador_refugi": "171582|FONT_PUDOSA",
		"municipi": "Sant Climent Sescebes",
		"codi_municipi": "171582",
		"latitud": "42.36531384",
		"longitud": "2.97985351",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "No",
		"adreca": "Àrea de picnic Font Pudosa",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-7hbm-bwbv_3cc5",
		":version": "rv-gwi7-7tqi~m4hc",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jardins de l'Ajuntament",
		"indicador_refugi": "082080|JARDINS_DE_LAJUNTAMENT",
		"municipi": "Sant Esteve Sesrovires",
		"codi_municipi": "082080",
		"latitud": "41.49274642719316",
		"longitud": "1.8751126541835805",
		"accessibilitat": "Sí",
		"aigua": "No",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Cantonada Carrer Martorell amb Carrer de l'Alba",
		"informacio_web": "https://www.sesrovires.cat/",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-06T13:07:00.000"
	},
	{
		":id": "row-9368.2vsr~jbza",
		":version": "rv-kvd7~8v42~ajq5",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Ajuntament de Sant Esteve Sesrovires",
		"indicador_refugi": "082080|AJUNTAMENT_DE_SANT_ESTEVE_SESROVIRES",
		"municipi": "Sant Esteve Sesrovires",
		"codi_municipi": "082080",
		"latitud": "41.493168307494315",
		"longitud": "1.8744155175014519",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Major, 6-8 - 08635 Sant Esteve Sesrovires",
		"informacio_web": "https://www.sesrovires.cat/actualitat/noticies/lajuntament-activa-el-pla-de-proteccio-civil-municipal-davant-el-risc-extrem-dincendi-forestal-i-lonada-de-calor.html",
		"tipologia": "Ajuntament / Equipament Administratiu",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-07T08:49:00.000"
	},
	{
		":id": "row-7hjd_39bp.pbxc",
		":version": "rv-tjzj~2ptn_7d45",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Municipal",
		"indicador_refugi": "082080|BIBLIOTECA_MUNICIPAL",
		"municipi": "Sant Esteve Sesrovires",
		"codi_municipi": "082080",
		"latitud": "41.49448026175397",
		"longitud": "1.8732244910227869",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Avinguda Montserrat, 10 - 08635 Sant Esteve Sesrovires",
		"informacio_web": "https://www.sesrovires.cat/actualitat/noticies/lajuntament-activa-el-pla-de-proteccio-civil-municipal-davant-el-risc-extrem-dincendi-forestal-i-lonada-de-calor.html",
		"tipologia": "Biblioteca",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-07T08:50:00.000"
	},
	{
		":id": "row-5eec-yzw9~s8ny",
		":version": "rv-ccmp~vpxy.sk58",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Pista Coberta Francesc Castellet",
		"indicador_refugi": "082080|PISTA_COBERTA_FRANCESC_CASTELLET",
		"municipi": "Sant Esteve Sesrovires",
		"codi_municipi": "082080",
		"latitud": "41.495011368068475",
		"longitud": "1.8707073480075442",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Passatge Oliveres, S/N - 08635 Sant Esteve Sesrovires",
		"informacio_web": "https://www.sesrovires.cat/actualitat/noticies/lajuntament-activa-el-pla-de-proteccio-civil-municipal-davant-el-risc-extrem-dincendi-forestal-i-lonada-de-calor.html",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-07T08:53:00.000"
	},
	{
		":id": "row-cqsp-3unr-63wm",
		":version": "rv-snpv_c39n~6gwd",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal Solanes",
		"indicador_refugi": "082107|PISCINA_MUNICIPAL_SOLANES",
		"municipi": "Sant Feliu de Codines",
		"codi_municipi": "082107",
		"latitud": "41.68439546",
		"longitud": "2.15096336",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Muntanya Solanes, s/n",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-5fzf~9sic_5p3f",
		":version": "rv-s7ry~qtwx-da9z",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic \"La Fonteta\"",
		"indicador_refugi": "082107|CENTRE_CIVIC_LA_FONTETA",
		"municipi": "Sant Feliu de Codines",
		"codi_municipi": "082107",
		"latitud": "41.68799414",
		"longitud": "2.1626238",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Josep Umbert Rosàs, s/n",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-sea6-kmph.pixa",
		":version": "rv-ctzc~zd66.feyi",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal municipal de la Gent Gran",
		"indicador_refugi": "082107|CASAL_MUNICIPAL_DE_LA_GENT_GRAN",
		"municipi": "Sant Feliu de Codines",
		"codi_municipi": "082107",
		"latitud": "41.6894162",
		"longitud": "2.16485796",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. de la Generalitat, s/n",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-hckd-66hy.s98s",
		":version": "rv-9mky~aqs6~rqef",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca municipal Joan Petit i Aguilar",
		"indicador_refugi": "082107|BIBLIOTECA_MUNICIPAL_JOAN_PETIT_I_AGUILAR",
		"municipi": "Sant Feliu de Codines",
		"codi_municipi": "082107",
		"latitud": "41.68894231",
		"longitud": "2.16442913",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Josep Umbert Ventura, 3, 08182 Sant Feliu de Codines, Barcelona",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-52im~dfm8.g82q",
		":version": "rv-gnfb_nx9u_7qxc",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Complex Poliesportiu municipal",
		"indicador_refugi": "082107|COMPLEX_POLIESPORTIU_MUNICIPAL",
		"municipi": "Sant Feliu de Codines",
		"codi_municipi": "082107",
		"latitud": "41.69526099",
		"longitud": "2.16579226",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Ronda dels Esports, s/n",
		"tipologia": "Poliesportiu",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-sp4t.jje6.4dcp",
		":version": "rv-zbnn.8ncr-7syn",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Sala de Plens de L'Ajuntament",
		"indicador_refugi": "082107|SALA_DE_PLENS_DE_LAJUNTAMENT",
		"municipi": "Sant Feliu de Codines",
		"codi_municipi": "082107",
		"latitud": "41.683",
		"longitud": "2.161",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça Josep Umbert Ventura, 2, 08182 Sant Feliu de Codines, Barcelona",
		"informacio_web": "https://www.santfeliudecodines.cat/",
		"tipologia": "Ajuntament / Equipament Administratiu",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-29T09:34:00.000"
	},
	{
		":id": "row-ak9t_4ney_wavj",
		":version": "rv-zea2_hqgr-xrmw",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de Can Xifreda i de la Font dels Àlbers",
		"indicador_refugi": "082107|PARC_DE_CAN_XIFREDA_I_DE_LA_FONT_DELS_ALBERS",
		"municipi": "Sant Feliu de Codines",
		"codi_municipi": "082107",
		"latitud": "41.6863",
		"longitud": "2.1629",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Passatge Martina, 9, 08182 Sant Feliu de Codines, Barcelona",
		"informacio_web": "https://www.santfeliudecodines.cat/turisme/parcs-places-i-espais-verds/parc-municipal-can-xifreda.html",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-29T10:11:00.000"
	},
	{
		":id": "row-trf9~zu39~zwyf",
		":version": "rv-qsxe-z7r2~vdwe",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Cívic Tueda",
		"indicador_refugi": "171609|CENTRE_CIVIC_TUEDA",
		"municipi": "Sant Feliu de Guíxols",
		"codi_municipi": "171609",
		"latitud": "41.7845300718789",
		"longitud": "3.03560011290495",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Gravina, 39-41 - 17220 Sant Feliu de Guíxols",
		"informacio_web": "Tueda@guixols.cat 972 82 10 58 De diumenge a divendres de 8 a 20h",
		"tipologia": "Centre Cívic",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-02T12:25:00.000"
	},
	{
		":id": "row-y5kj_p26t-m8uf",
		":version": "rv-v99z_rmtd~s6cq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Cívic Vilartagues",
		"indicador_refugi": "171609|CENTRE_CIVIC_VILARTAGUES",
		"municipi": "Sant Feliu de Guíxols",
		"codi_municipi": "171609",
		"latitud": "41.7920261549428",
		"longitud": "3.02472399993368",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça de Salvador Espriu s/n - 17220 Sant Feliu de Guíxols",
		"informacio_web": "ccv@guixols.cat 972 82 01 01 De dilluns a divendres de 8 a 21h i Dissabtes i diumenges de 9 a 19:00h",
		"tipologia": "Centre Cívic",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-02T12:27:00.000"
	},
	{
		":id": "row-xd8c_bjxv_9x47",
		":version": "rv-wub5-sjxh.kgqq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Pública Octavi Viader i Margarit",
		"indicador_refugi": "171609|BIBLIOTECA_PUBLICA_OCTAVI_VIADER_I_MARGARIT",
		"municipi": "Sant Feliu de Guíxols",
		"codi_municipi": "171609",
		"latitud": "41.7839057723951",
		"longitud": "3.02696185048643",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Joan Surís, 28-34 - 17220 Sant Feliu de Guíxols",
		"informacio_web": "biblioteca@guixols.cat 972 32 40 57 De dilluns a divendres de 10 a 13h i de 15 a 19h. Dissabtes, de 10 a 13h",
		"tipologia": "Biblioteca",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-02T12:28:00.000"
	},
	{
		":id": "row-u5w4_7848.b2x2",
		":version": "rv-pdiw.zqxb.uawj",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jardins Juli Garreta",
		"indicador_refugi": "171609|JARDINS_JULI_GARRETA",
		"municipi": "Sant Feliu de Guíxols",
		"codi_municipi": "171609",
		"latitud": "41.781286180399",
		"longitud": "3.0327378687240594",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer de Cristòfol Colom - 17220 Sant Feliu de Guíxols",
		"informacio_web": "Horari indefinit",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-02T12:31:00.000"
	},
	{
		":id": "row-dnyi_h6ti.72k4",
		":version": "rv-weg6.ivmz.ppgj",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Platja de Sant Feliu de Guíxols",
		"indicador_refugi": "171609|PLATJA_DE_SANT_FELIU_DE_GUIXOLS",
		"municipi": "Sant Feliu de Guíxols",
		"codi_municipi": "171609",
		"latitud": "41.7794300549625",
		"longitud": "3.0297659811095654",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça Sant Pere, 4 - 17220 Sant Feliu de Guíxols",
		"informacio_web": "Horari indefinit",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-02T12:32:00.000"
	},
	{
		":id": "row-nqaz~us8t_rwrh",
		":version": "rv-tyv7~ypg2-2xn3",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Mercat Municipal de Sant Feliu de Guíxols",
		"indicador_refugi": "171609|MERCAT_MUNICIPAL_DE_SANT_FELIU_DE_GUIXOLS",
		"municipi": "Sant Feliu de Guíxols",
		"codi_municipi": "171609",
		"latitud": "41.78079658269786",
		"longitud": "3.0293753970401904",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça del Mercat - 17220 Sant Feliu de Guíxols",
		"informacio_web": "De dimarts a diumenge de 9 a 14h",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-02T12:34:00.000"
	},
	{
		":id": "row-naz8-dxmd-a8fb",
		":version": "rv-ejkr~j6ex_sxrk",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Central",
		"indicador_refugi": "171609|PARC_CENTRAL",
		"municipi": "Sant Feliu de Guíxols",
		"codi_municipi": "171609",
		"latitud": "41.7874914634843",
		"longitud": "3.02847351103452",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer de Sant Bonaventura, 57, 17220 Sant Feliu de Guíxols",
		"informacio_web": "Horari Indefinit",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-02T12:36:00.000"
	},
	{
		":id": "row-dq4c~wpxc_ti8b",
		":version": "rv-2ygp-g7d6-xjrg",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jardins del monestir",
		"indicador_refugi": "171609|JARDINS_DEL_MONESTIR",
		"municipi": "Sant Feliu de Guíxols",
		"codi_municipi": "171609",
		"latitud": "41.77990850437629",
		"longitud": "3.027325857867621",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "No",
		"lavabo": "No",
		"adreca": "Plaça del Monestir, 17220 Sant Feliu de Guíxols",
		"informacio_web": "Sempre que hi hagin activitats consultar www.guixols.cat",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-02T12:38:00.000"
	},
	{
		":id": "row-tpyg.5aik-iq86",
		":version": "rv-y2n5_vzvm-889s",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscines municipals Sant Feliu Sasserra",
		"indicador_refugi": "082129|PISCINES_MUNICIPALS_SANT_FELIU_SASSERRA",
		"municipi": "Sant Feliu Sasserra",
		"codi_municipi": "082129",
		"latitud": "41.94430608",
		"longitud": "2.0154441",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Zona esportiva Sant Roc",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-2pgh_99ak-hbmx",
		":version": "rv-fkjq_4cig-xeax",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Social l'Ateneu",
		"indicador_refugi": "082129|CENTRE_SOCIAL_LATENEU",
		"municipi": "Sant Feliu Sasserra",
		"codi_municipi": "082129",
		"latitud": "41.94507",
		"longitud": "2.02166",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Pas Nou, 8",
		"tipologia": "Casal de Gent Gran",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-02T14:02:00.000"
	},
	{
		":id": "row-9xue-6tzc-3tvn",
		":version": "rv-rm2z_9pjb-xjrf",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Sant Pere Almató",
		"indicador_refugi": "082129|BIBLIOTECA_SANT_PERE_ALMATO",
		"municipi": "Sant Feliu Sasserra",
		"codi_municipi": "082129",
		"latitud": "41.94378",
		"longitud": "2.02278",
		"accessibilitat": "Sí",
		"aigua": "No",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Avinguda Catalunya, 1",
		"tipologia": "Biblioteca",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-02T14:03:00.000"
	},
	{
		":id": "row-62bn~9h93~346x",
		":version": "rv-qcnm.evu9.gbzz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic Sant Gregori",
		"indicador_refugi": "171637|CENTRE_CIVIC_SANT_GREGORI",
		"municipi": "Sant Gregori",
		"codi_municipi": "171637",
		"latitud": "41.99023881",
		"longitud": "2.7602864",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Rocacorba, 2",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-r98t.uurf-6fg5",
		":version": "rv-er6j_exgv_ynbi",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Local avis",
		"indicador_refugi": "251924|LOCAL_AVIS",
		"municipi": "Sant Guim de Freixenet",
		"codi_municipi": "251924",
		"latitud": "41.655774",
		"longitud": "1.418365",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça Doctor Perelló, 12 baixos",
		"tipologia": "Centre Cívic",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-01T10:09:00.000"
	},
	{
		":id": "row-4rtb~b8re.bbth",
		":version": "rv-qkxa-aej7.wjsf",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscines Municipals",
		"indicador_refugi": "251924|PISCINES_MUNICIPALS",
		"municipi": "Sant Guim de Freixenet",
		"codi_municipi": "251924",
		"latitud": "41.649459",
		"longitud": "1.421726",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carretera de la Panadella, s/n",
		"informacio_web": "www.santguim.cat",
		"tipologia": "Piscines descobertes",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-01T10:12:00.000"
	},
	{
		":id": "row-53ik.sz2s.j4af",
		":version": "rv-kkf7~w58x-p7j4",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Oficina de Turisme Can Rovira",
		"indicador_refugi": "171642|OFICINA_DE_TURISME_CAN_ROVIRA",
		"municipi": "Sant Hilari Sacalm",
		"codi_municipi": "171642",
		"latitud": "41.87964847",
		"longitud": "2.50941409",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Pl. del Dr. Robert",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-didu~3iwb_2stk",
		":version": "rv-ejju.cz2d~gkjh",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Soledat Ridaura i Feixas",
		"indicador_refugi": "171642|BIBLIOTECA_SOLEDAT_RIDAURA_I_FEIXAS",
		"municipi": "Sant Hilari Sacalm",
		"codi_municipi": "171642",
		"latitud": "41.92885922",
		"longitud": "2.51205134",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Pl. del Doctor Gravalosa, 4",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-wz8w-abgg.z6pi",
		":version": "rv-8bfb.vv8t_d7xj",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de gent gran de Can Blat",
		"indicador_refugi": "171642|CASAL_DE_GENT_GRAN_DE_CAN_BLAT",
		"municipi": "Sant Hilari Sacalm",
		"codi_municipi": "171642",
		"latitud": "41.87981372",
		"longitud": "2.50915264",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Montsolis, 6-18",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-dyf7-gf6t~mgi2",
		":version": "rv-svmt_tgzz.3veg",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Ajuntament de Sant Hipòlit de Voltregà",
		"indicador_refugi": "082153|AJUNTAMENT_DE_SANT_HIPOLIT_DE_VOLTREGA",
		"municipi": "Sant Hipòlit de Voltregà",
		"codi_municipi": "082153",
		"latitud": "42.01559817",
		"longitud": "2.23649046",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. de la Vila, 1",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-n44y_tru4.rhrz",
		":version": "rv-i29q.jyaj~jbb2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casa del Mallol",
		"indicador_refugi": "082153|CASA_DEL_MALLOL",
		"municipi": "Sant Hipòlit de Voltregà",
		"codi_municipi": "082153",
		"latitud": "42.01703149",
		"longitud": "2.23588554",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. del Mallol, 6",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-6bgj~b9bi.kjsn",
		":version": "rv-e7k3.brqh~xjk9",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Marquès de Remisa",
		"indicador_refugi": "082153|BIBLIOTECA_MARQUES_DE_REMISA",
		"municipi": "Sant Hipòlit de Voltregà",
		"codi_municipi": "082153",
		"latitud": "42.01551748",
		"longitud": "2.23612432",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. de la Vinya, 2",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-5f8b.3bb4-2y6s",
		":version": "rv-ijfy~ncbx-srfy",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Alfons Maseras",
		"indicador_refugi": "431378|BIBLIOTECA_ALFONS_MASERAS",
		"municipi": "Sant Jaume dels Domenys",
		"codi_municipi": "431378",
		"latitud": "41.2979244",
		"longitud": "1.5600928",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Germanor, 8",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-2cqa~rsix_a8vb",
		":version": "rv-p3q7~afqv.yrm5",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "431378|PISCINA_MUNICIPAL",
		"municipi": "Sant Jaume dels Domenys",
		"codi_municipi": "431378",
		"latitud": "41.2944072",
		"longitud": "1.5628793",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Marinada, 8",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-2znu_e262.efwh",
		":version": "rv-srbd-78fj~ccgn",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Ajuntament",
		"indicador_refugi": "082188|AJUNTAMENT",
		"municipi": "Sant Joan de Vilatorrada",
		"codi_municipi": "082188",
		"latitud": "41.74561526",
		"longitud": "1.80546108",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Major, 91-93",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-nmuq-v629_qsc3",
		":version": "rv-ziiy.ft7p-vnmq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Ludoteca",
		"indicador_refugi": "082188|LUDOTECA",
		"municipi": "Sant Joan de Vilatorrada",
		"codi_municipi": "082188",
		"latitud": "41.74425993",
		"longitud": "1.8073214",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Pg. Gallifa, 1 baixos",
		"tipologia": "Ludoteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-cake~2fng_kaut",
		":version": "rv-963s_evxm_xisu",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Espai jove",
		"indicador_refugi": "082188|ESPAI_JOVE",
		"municipi": "Sant Joan de Vilatorrada",
		"codi_municipi": "082188",
		"latitud": "41.74211329",
		"longitud": "1.80206602",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Alzines, 53",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-hyk6-wp67~gmtb",
		":version": "rv-i6vb_xfjv_9vix",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Sant Joan de Vilatorrada",
		"indicador_refugi": "082188|CASAL_CIVIC_I_COMUNITARI_SANT_JOAN_DE_VILATORRADA",
		"municipi": "Sant Joan de Vilatorrada",
		"codi_municipi": "082188",
		"latitud": "41.743621",
		"longitud": "1.5182089",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pg. de Gallifa, 8",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-5rwx_9ivj.8vwy",
		":version": "rv-syj6.y2xh~dkhi",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Cal Gallifa",
		"indicador_refugi": "082188|BIBLIOTECA_CAL_GALLIFA",
		"municipi": "Sant Joan de Vilatorrada",
		"codi_municipi": "082188",
		"latitud": "41.74398818",
		"longitud": "1.80717402",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Pg. Gallifa, 1",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-gf8c_xd37.9ssq",
		":version": "rv-e8aj~wzmw~rpwg",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Zona esportiva",
		"indicador_refugi": "082188|ZONA_ESPORTIVA",
		"municipi": "Sant Joan de Vilatorrada",
		"codi_municipi": "082188",
		"latitud": "41.75121108",
		"longitud": "1.80323922",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Ctra/ BV-3008 a Calaf, km. 0.3",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-87my-hfn9_i5hb",
		":version": "rv-5hxi~6ix3-j6de",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CASAL CÍVIC DE LA CANYA (LLAR D'AVIS)",
		"indicador_refugi": "171851|CASAL_CIVIC_DE_LA_CANYA_(LLAR_DAVIS)",
		"municipi": "Sant Joan les Fonts",
		"codi_municipi": "171851",
		"latitud": "42.206",
		"longitud": "2.4954",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Avinguda de Les Escoles, 1",
		"informacio_web": "CADA DIA OBERT",
		"tipologia": "Centre Cívic",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-04T07:36:00.000"
	},
	{
		":id": "row-kpmf~nsjx_j4xn",
		":version": "rv-bgab_9gng-h7b2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "BIBLIOTECA MUNICIPAL \"CASTELL DE JUVINYÀ\"",
		"indicador_refugi": "171851|BIBLIOTECA_MUNICIPAL_\"CASTELL_DE_JUVINYA\"",
		"municipi": "Sant Joan les Fonts",
		"codi_municipi": "171851",
		"latitud": "42.2131",
		"longitud": "2.5075",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "CARRER JUVINYÀ, 2",
		"informacio_web": "OBERT DE DILLUNS A DIVENDRES",
		"tipologia": "Biblioteca",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-04T08:06:00.000"
	},
	{
		":id": "row-nq52~2tbd-69iw",
		":version": "rv-gkxr.93ek.nahc",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CASAL CIVIC \"EL CENTRE\"",
		"indicador_refugi": "171851|CASAL_CIVIC_\"EL_CENTRE\"",
		"municipi": "Sant Joan les Fonts",
		"codi_municipi": "171851",
		"latitud": "42.2131",
		"longitud": "2.5113",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "AV RAFEL TORRAS, 3",
		"informacio_web": "ESTÀ OBERT CADA DIA",
		"tipologia": "Centre Cívic",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-04T08:16:00.000"
	},
	{
		":id": "row-ew87_hzv2_73i7",
		":version": "rv-6xqe~v9b7-p8z7",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "El Polivalent",
		"indicador_refugi": "171668|EL_POLIVALENT",
		"municipi": "Sant Jordi Desvalls",
		"codi_municipi": "171668",
		"latitud": "42.07039443",
		"longitud": "2.95344764",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. DR. Joher, s/n",
		"tipologia": "Sala polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-a8zp-mfg3~b9w6",
		":version": "rv-38p5-mtwg~gde5",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Sala Nova",
		"indicador_refugi": "171668|SALA_NOVA",
		"municipi": "Sant Jordi Desvalls",
		"codi_municipi": "171668",
		"latitud": "42.07244521",
		"longitud": "2.95134898",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Francesc Macià, 3",
		"tipologia": "Sala polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-47mq-hvhx-x6zj",
		":version": "rv-xi5t-h8g4.ku6g",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bar El Social",
		"indicador_refugi": "171668|BAR_EL_SOCIAL",
		"municipi": "Sant Jordi Desvalls",
		"codi_municipi": "171668",
		"latitud": "42.07150128",
		"longitud": "2.95327246",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Dr. Messeguer, s/n",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-heqi~dwea~eym7",
		":version": "rv-u59n_cabw-3rd2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CAN BURCET",
		"indicador_refugi": "171668|CAN_BURCET",
		"municipi": "Sant Jordi Desvalls",
		"codi_municipi": "171668",
		"latitud": "42.071949",
		"longitud": "2.951407",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "No",
		"adreca": "CARRER FRANCESC MACIÀ, 4",
		"informacio_web": "https://santjordidesvalls.cat/",
		"tipologia": "Centre Cívic",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-02T12:09:00.000"
	},
	{
		":id": "row-ur8s-62s5_hvbj",
		":version": "rv-cijm-jhkr-k29k",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "AULA DE LECTURA MODEST PRATS DE MEDINYÀ",
		"indicador_refugi": "171693|AULA_DE_LECTURA_MODEST_PRATS_DE_MEDINYA",
		"municipi": "Sant Julià de Ramis",
		"codi_municipi": "171693",
		"latitud": "42.04828721594297",
		"longitud": "2.865864189101684",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "CARRER SANT SADURNÍ S.N.",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-03T12:22:00.000"
	},
	{
		":id": "row-7h5p.q7xg_5u5u",
		":version": "rv-4q6v-xvcn-jwy3",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Cívic de Bonmatí",
		"indicador_refugi": "179032|CENTRE_CIVIC_DE_BONMATI",
		"municipi": "Sant Julià del Llor i Bonmatí",
		"codi_municipi": "179032",
		"latitud": "41.96874",
		"longitud": "2.67028",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "c/ Ipso Lauro, 12 Sant Julià del Llor i Bonmatí",
		"informacio_web": "https://stjuliabonmati.cat/guia-del-poble/equipaments-publics-2/centre-civic-bonmati/    ( dimarts tancat)",
		"tipologia": "Centre Cívic",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-03T12:18:00.000"
	},
	{
		":id": "row-hug8~8jvt.mpzt",
		":version": "rv-n8mb_gt3s-whgh",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Gimnàs municipal",
		"indicador_refugi": "251930|GIMNAS_MUNICIPAL",
		"municipi": "Sant Llorenç de Morunys",
		"codi_municipi": "251930",
		"latitud": "42.13350028",
		"longitud": "1.5914873",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Creueta, s/n",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-2t5y_iddy~xpry",
		":version": "rv-krk5-6hht_v7sd",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "La Bassa Gran",
		"indicador_refugi": "082227|LA_BASSA_GRAN",
		"municipi": "Sant Llorenç d'Hortons",
		"codi_municipi": "082227",
		"latitud": "41.470025",
		"longitud": "1.824378",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. de la Bassa Gran, s/n",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-6jhy_ar2z~cctg",
		":version": "rv-ykia-3mbx.k6ic",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cultural Joana Raspall",
		"indicador_refugi": "082227|CENTRE_CULTURAL_JOANA_RASPALL",
		"municipi": "Sant Llorenç d'Hortons",
		"codi_municipi": "082227",
		"latitud": "41.46847852",
		"longitud": "1.82239988",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Generalitat, 47",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-4wkc~rcsu~dggj",
		":version": "rv-yqke-w5wk-zvif",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de Cal Sant Just",
		"indicador_refugi": "082227|PARC_DE_CAL_SANT_JUST",
		"municipi": "Sant Llorenç d'Hortons",
		"codi_municipi": "082227",
		"latitud": "41.46587216",
		"longitud": "1.81948605",
		"accessibilitat": "No",
		"aigua": "Sí",
		"area_descans": "No",
		"adreca": "Rda. de la font, 28",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-74ne_sygx-aqwv",
		":version": "rv-nbjh~t9td_7ikt",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça Marimon Llança",
		"indicador_refugi": "082227|PLACA_MARIMON_LLANCA",
		"municipi": "Sant Llorenç d'Hortons",
		"codi_municipi": "082227",
		"latitud": "41.4681409",
		"longitud": "1.82529677",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Marimon Llança",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-qv9n.yvia~sgib",
		":version": "rv-2emu~e9jh_qrn3",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça Petits Caramellaires",
		"indicador_refugi": "082227|PLACA_PETITS_CARAMELLAIRES",
		"municipi": "Sant Llorenç d'Hortons",
		"codi_municipi": "082227",
		"latitud": "41.465517",
		"longitud": "1.826094",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "No",
		"lavabo": "No",
		"adreca": "Rda. de la Pagesia, 27",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-23T14:10:00.000"
	},
	{
		":id": "row-9mb5.zf5p~p99a",
		":version": "rv-j3at~5ihi~7mxe",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de la gent gran",
		"indicador_refugi": "082233|CASAL_DE_LA_GENT_GRAN",
		"municipi": "Sant Llorenç Savall",
		"codi_municipi": "082233",
		"latitud": "41.68019658",
		"longitud": "2.05861125",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Canigó, 17",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-hswt-ksfs-wk3c",
		":version": "rv-q76e-jrcc.minb",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Pista poliesportiva coberta",
		"indicador_refugi": "082251|PISTA_POLIESPORTIVA_COBERTA",
		"municipi": "Sant Martí d'Albars",
		"codi_municipi": "082251",
		"latitud": "42.02841322",
		"longitud": "2.07383373",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "No",
		"adreca": "Zona esportiva del nucli de Sant Martí d'Albars",
		"tipologia": "Poliesportiu",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-r6cg-x47s_9zdn",
		":version": "rv-rq7z-nwkm-emtm",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Pavelló de Llorà",
		"indicador_refugi": "171729|PAVELLO_DE_LLORA",
		"municipi": "Sant Martí de Llémena",
		"codi_municipi": "171729",
		"latitud": "42.02250822005497",
		"longitud": "2.702606160694001",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer de la Fontanella, 130B, 17152 Llorà, Girona",
		"informacio_web": "https://smartillemena.cat/",
		"tipologia": "Pavelló Esportiu",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-02T12:16:00.000"
	},
	{
		":id": "row-pyy2_skb2_frnq",
		":version": "rv-4cqw-ngui.4a7u",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Sala de Plens Ajuntament de Sant Martí",
		"indicador_refugi": "171729|SALA_DE_PLENS_AJUNTAMENT_DE_SANT_MARTI",
		"municipi": "Sant Martí de Llémena",
		"codi_municipi": "171729",
		"latitud": "42.03647741952134",
		"longitud": "2.6475147366776657",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "No",
		"adreca": "Plaça San Martí, 1, 17153 Sant Martí de Llémena, Girona",
		"informacio_web": "https://smartillemena.cat/",
		"tipologia": "Ajuntament / Equipament Administratiu",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-02T13:13:00.000"
	},
	{
		":id": "row-tikq~4bpm_7b8f",
		":version": "rv-ycjc~fysf_prni",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Cal Frares",
		"indicador_refugi": "082264|CAL_FRARES",
		"municipi": "Sant Martí de Tous",
		"codi_municipi": "082264",
		"latitud": "41.56087244",
		"longitud": "1.52463544",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. de l'Esglèsia, 1",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-vdyh-t3ys_gtdb",
		":version": "rv-3vux.swun_7t8p",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Pavelló Municipal",
		"indicador_refugi": "082270|PAVELLO_MUNICIPAL",
		"municipi": "Sant Martí Sarroca",
		"codi_municipi": "082270",
		"latitud": "41.38573303615649",
		"longitud": "1.6066318894608207",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Passeig Esportiu, 15",
		"informacio_web": "https://www.santmartisarroca.cat/el-municipi/informacio-del-municipi/107-equipaments/pavello-poliesportiu.html",
		"tipologia": "Pavelló Esportiu",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-04T16:38:00.000"
	},
	{
		":id": "row-39u6.mr6v_9ne4",
		":version": "rv-m4vp~jw8m~ivg8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "082270|PISCINA_MUNICIPAL",
		"municipi": "Sant Martí Sarroca",
		"codi_municipi": "082270",
		"latitud": "41.3870346",
		"longitud": "1.6130884",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Passeig Esportiu, 17",
		"informacio_web": "https://www.santmartisarroca.cat/el-municipi/informacio-del-municipi/107-equipaments/piscina-municipal.html",
		"tipologia": "Piscines descobertes",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-04T16:51:00.000"
	},
	{
		":id": "row-vy7w-qqs3~heg7",
		":version": "rv-938i-gycg.icde",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Antic Ajuntament - Espai per la Gent Gran",
		"indicador_refugi": "082270|ANTIC_AJUNTAMENT_-_ESPAI_PER_LA_GENT_GRAN",
		"municipi": "Sant Martí Sarroca",
		"codi_municipi": "082270",
		"latitud": "41.385816",
		"longitud": "1.611584",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer de la Font, 11",
		"tipologia": "Casal de Gent Gran",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-04T16:54:00.000"
	},
	{
		":id": "row-fm92_enhu-q876",
		":version": "rv-hjcn~m6vv-khg3",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Social i Espai Juvenil",
		"indicador_refugi": "171735|CENTRE_SOCIAL_I_ESPAI_JUVENIL",
		"municipi": "Sant Martí Vell",
		"codi_municipi": "171735",
		"latitud": "42.01957852",
		"longitud": "2.93070963",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de Dalt, 8",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-qffj.s5cw~32qe",
		":version": "rv-2g64~z297_5n3u",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca (Can Massegú)",
		"indicador_refugi": "171735|BIBLIOTECA_CAN_MASSEGU",
		"municipi": "Sant Martí Vell",
		"codi_municipi": "171735",
		"latitud": "42.01980578",
		"longitud": "2.93045855",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. dels Àngels, 1A",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-9tdd.8239_qhj3",
		":version": "rv-h6pd.pwqx-miws",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Local Rectoria de Valls de Torroella",
		"indicador_refugi": "082299|LOCAL_RECTORIA_DE_VALLS_DE_TORROELLA",
		"municipi": "Sant Mateu de Bages",
		"codi_municipi": "082299",
		"latitud": "41.847477",
		"longitud": "1.719547",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Església del Sagrat Cor de la Colònia, Valls",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-rgx4~yjps.n4q3",
		":version": "rv-hr8b_qdg4~cuzf",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Sala d'oci-sala polivalent",
		"indicador_refugi": "171740|SALA_D_OCI_SALA_POLIVALENT",
		"municipi": "Sant Miquel de Campmajor",
		"codi_municipi": "171740",
		"latitud": "42.12607777",
		"longitud": "2.68417867",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pda. 1 d'octubre, s/n",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-pr64~q884.c97g",
		":version": "rv-uggd-mkrq_76jx",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Escoles velles",
		"indicador_refugi": "082325|ESCOLES_VELLES",
		"municipi": "Sant Pere de Riudebitlles",
		"codi_municipi": "082325",
		"latitud": "41.45117511",
		"longitud": "1.70215844",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Nou, 80",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-6sd6~pvhz~upj2",
		":version": "rv-h7sc.xidv_baf3",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Maria Àngels Torrents I Rosés",
		"indicador_refugi": "082325|BIBLIOTECA_MARIA_ANGELS_TORRENTS_I_ROSES",
		"municipi": "Sant Pere de Riudebitlles",
		"codi_municipi": "082325",
		"latitud": "41.45350783",
		"longitud": "1.70369771",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Major, 42",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-bw39~njq3_q357",
		":version": "rv-uvt3.89gt_i26f",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina d'estiu municipal",
		"indicador_refugi": "082325|PISCINA_D_ESTIU_MUNICIPAL",
		"municipi": "Sant Pere de Riudebitlles",
		"codi_municipi": "082325",
		"latitud": "41.44903113",
		"longitud": "1.69869582",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Pg. Sant Jeroni, s/n",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-8t8f~jf49.t5xc",
		":version": "rv-nnx3.hzeg_frc2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Ajuntament de Sant Pere de Riudebitlles",
		"indicador_refugi": "082325|AJUNTAMENT_DE_SANT_PERE_DE_RIUDEBITLLES",
		"municipi": "Sant Pere de Riudebitlles",
		"codi_municipi": "082325",
		"latitud": "41.45371883593103",
		"longitud": "1.7017463532579136",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça de les Eres, 1 08776",
		"informacio_web": "https://www.santperederiudebitlles.cat/",
		"tipologia": "Ajuntament / Equipament Administratiu",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-19T12:28:00.000"
	},
	{
		":id": "row-ek9u.tn79_8f9b",
		":version": "rv-vvzy_xm38.5zby",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Pavelló municipal",
		"indicador_refugi": "082331|PAVELLO_MUNICIPAL",
		"municipi": "Sant Pere de Torelló",
		"codi_municipi": "082331",
		"latitud": "42.075577",
		"longitud": "2.292936",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. St. Pere, s/n.",
		"informacio_web": "www.stpere.cat",
		"tipologia": "Pavelló Esportiu",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-11T17:09:00.000"
	},
	{
		":id": "row-drwh-a4nj_zm3w",
		":version": "rv-8mjv~bmvd-drv2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "PISCINA MUNICIPAL",
		"indicador_refugi": "082331|PISCINA_MUNICIPAL",
		"municipi": "Sant Pere de Torelló",
		"codi_municipi": "082331",
		"latitud": "42.07532",
		"longitud": "2.293184",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. ST PERE, S/N",
		"informacio_web": "WWW.STPERE.CAT",
		"tipologia": "Piscines descobertes",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-12T10:57:00.000"
	},
	{
		":id": "row-e65t.3jyt~rffn",
		":version": "rv-r8qa.umsy~7t4q",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "BAR CASAL AVIS",
		"indicador_refugi": "082331|BAR_CASAL_AVIS",
		"municipi": "Sant Pere de Torelló",
		"codi_municipi": "082331",
		"latitud": "42.075003",
		"longitud": "2.293694",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "PL. MONMANY, S/N.",
		"informacio_web": "WWW.STPERE.CAT",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-12T11:01:00.000"
	},
	{
		":id": "row-7dev.xz42-fc4j",
		":version": "rv-kqub.5zc2-sujy",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CASAL CULTURAL",
		"indicador_refugi": "082331|CASAL_CULTURAL",
		"municipi": "Sant Pere de Torelló",
		"codi_municipi": "082331",
		"latitud": "42.075108",
		"longitud": "2.297494",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. TERRICABRAS, 2",
		"informacio_web": "WWW.STPERE.CAT",
		"tipologia": "Equipament Cultural (teatre, auditori, museu)",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-12T11:16:00.000"
	},
	{
		":id": "row-z5sz-gbjw.cnbb",
		":version": "rv-6yi3~i83b.c854",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal d'avis",
		"indicador_refugi": "082384|CASAL_D_AVIS",
		"municipi": "Sant Quirze del Vallès",
		"codi_municipi": "082384",
		"latitud": "41.53373289",
		"longitud": "2.07998521",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Pintor Vila Puig, 22",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-zczy~8quz.varq",
		":version": "rv-2gah_tarf.ccs5",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca",
		"indicador_refugi": "082384|BIBLIOTECA",
		"municipi": "Sant Quirze del Vallès",
		"codi_municipi": "082384",
		"latitud": "41.53214086",
		"longitud": "2.07656293",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Eduarrd Toldrà, s/n",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-5yu6.9895-rifc",
		":version": "rv-yfta.if9p~e8nx",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina de les Fonts",
		"indicador_refugi": "082384|PISCINA_DE_LES_FONTS",
		"municipi": "Sant Quirze del Vallès",
		"codi_municipi": "082384",
		"latitud": "41.52528981",
		"longitud": "2.03465942",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pg. Ferrocarril, 28",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-rgyy.2b3i-bypf",
		":version": "rv-3mwg.dk54~qeub",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Poliesportiu Can Casablanques",
		"indicador_refugi": "082384|POLIESPORTIU_CAN_CASABLANQUES",
		"municipi": "Sant Quirze del Vallès",
		"codi_municipi": "082384",
		"latitud": "41.5359766",
		"longitud": "2.08263731",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Priorat, s/n",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-mc8d-t32a-6tp2",
		":version": "rv-s8tt.wnt2_qgsr",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Sala salut Pastor (Patronal)",
		"indicador_refugi": "082384|SALA_SALUT_PASTOR_PATRONAL",
		"municipi": "Sant Quirze del Vallès",
		"codi_municipi": "082384",
		"latitud": "41.53307182",
		"longitud": "2.08263549",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Barcelona, 65",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-dhvc_wbna~hx9m",
		":version": "rv-gvnr-9dur~tz3b",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Cívic",
		"indicador_refugi": "082397|CENTRE_CIVIC",
		"municipi": "Sant Quirze Safaja",
		"codi_municipi": "082397",
		"latitud": "41.732734",
		"longitud": "2.153731",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "No",
		"lavabo": "No",
		"adreca": "Parc de l'Aigua s/n",
		"informacio_web": "https://www.santquirzesafaja.cat/serveis/equipaments#",
		"tipologia": "Centre Cívic",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-01T11:01:00.000"
	},
	{
		":id": "row-dc57-npub_6ddj",
		":version": "rv-5wsz-5rgc_xbai",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Vilarnau",
		"indicador_refugi": "082401|CENTRE_VILARNAU",
		"municipi": "Sant Sadurní d'Anoia",
		"codi_municipi": "082401",
		"latitud": "41.43313583",
		"longitud": "1.78205712",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Germans Segura Viudas, s/n",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-6abv-cnwd~7tjy",
		":version": "rv-h5ep~fjc3~hhv2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc del Pont Romà",
		"indicador_refugi": "082401|PARC_DEL_PONT_ROMA",
		"municipi": "Sant Sadurní d'Anoia",
		"codi_municipi": "082401",
		"latitud": "41.42585284",
		"longitud": "1.79049457",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. del Pont Romà",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-4bk9.n28a~rg4y",
		":version": "rv-bquf_5hny.xn43",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de la gent gran",
		"indicador_refugi": "082401|CASAL_DE_LA_GENT_GRAN",
		"municipi": "Sant Sadurní d'Anoia",
		"codi_municipi": "082401",
		"latitud": "41.42980014",
		"longitud": "1.78535616",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pg. de Can ferrer del Mas, 11",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-z2tt-tk7y.dpje",
		":version": "rv-2mdp.sgy8~sktk",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça Manuel Raventós",
		"indicador_refugi": "082401|PLACA_MANUEL_RAVENTOS",
		"municipi": "Sant Sadurní d'Anoia",
		"codi_municipi": "082401",
		"latitud": "41.42273087",
		"longitud": "1.7908547",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Manuel Raventós",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-cp9t-h6yu~ac43",
		":version": "rv-v2bz.sp27.z5yz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca ramon Bosch de Noya",
		"indicador_refugi": "082401|BIBLIOTECA_RAMON_BOSCH_DE_NOYA",
		"municipi": "Sant Sadurní d'Anoia",
		"codi_municipi": "082401",
		"latitud": "41.42524996",
		"longitud": "1.78573554",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Homenatge a la vellesa, 10",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-stej.57be.mmwb",
		":version": "rv-ifek~pmw3~4m58",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Can Mas de la Riera",
		"indicador_refugi": "082401|CAN_MAS_DE_LA_RIERA",
		"municipi": "Sant Sadurní d'Anoia",
		"codi_municipi": "082401",
		"latitud": "41.42027318",
		"longitud": "1.78762851",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Can Mas de la Riera",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-c3zn~5g5c.g964",
		":version": "rv-vt54-7b5s~2fef",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "080983|PISCINA_MUNICIPAL",
		"municipi": "Sant Salvador de Guardiola",
		"codi_municipi": "080983",
		"latitud": "41.68686716",
		"longitud": "1.7816281",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Reina Sofia, s/n",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-nc3x~pnpb-f96f",
		":version": "rv-q95d~hpgd_6p78",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Sala Polivalent de La Masia del Calvet",
		"indicador_refugi": "080983|SALA_POLIVALENT_DE_LA_MASIA_DEL_CALVET",
		"municipi": "Sant Salvador de Guardiola",
		"codi_municipi": "080983",
		"latitud": "41.68657850524552",
		"longitud": "1.780850447910322",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Pau Casals, s/n",
		"informacio_web": "https://www.santsalvadordeguardiola.cat/temes/medi-ambient/refugis-climatics",
		"tipologia": "Sala Polivalent",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-18T14:16:00.000"
	},
	{
		":id": "row-dsbh.sv8r_nmjn",
		":version": "rv-cixy~94wh-9iaf",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Espai Cultural La Sala",
		"indicador_refugi": "080983|ESPAI_CULTURAL_LA_SALA",
		"municipi": "Sant Salvador de Guardiola",
		"codi_municipi": "080983",
		"latitud": "41.68039779241097",
		"longitud": "1.7675100452827204",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer de la Creu, 8",
		"informacio_web": "https://www.santsalvadordeguardiola.cat/temes/medi-ambient/refugis-climatics",
		"tipologia": "Equipament Cultural (teatre, auditori, museu)",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-18T15:27:00.000"
	},
	{
		":id": "row-acpc.rutf-a7cc",
		":version": "rv-pyyz.f67v-xijc",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc del Patufet",
		"indicador_refugi": "080983|PARC_DEL_PATUFET",
		"municipi": "Sant Salvador de Guardiola",
		"codi_municipi": "080983",
		"latitud": "41.67963729402103",
		"longitud": "1.7671692384315825",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "CARRER DE LES ALZINES",
		"informacio_web": "https://www.santsalvadordeguardiola.cat/temes/medi-ambient/refugis-climatics",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-18T15:31:00.000"
	},
	{
		":id": "row-5x97-2hkf-x6na",
		":version": "rv-jczb_5dai-5bnn",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "082628|PISCINA_MUNICIPAL",
		"municipi": "Sant Vicenç de Castellet",
		"codi_municipi": "082628",
		"latitud": "41.66221465",
		"longitud": "1.86366909",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "No",
		"adreca": "C. Alfons XIII, 24",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-6wn2-wpfa-wcck",
		":version": "rv-5d2r_pt7m~wf4d",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Salvador Vives Casajuana",
		"indicador_refugi": "082628|BIBLIOTECA_SALVADOR_VIVES_CASAJUANA",
		"municipi": "Sant Vicenç de Castellet",
		"codi_municipi": "082628",
		"latitud": "41.66554746",
		"longitud": "1.86252388",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Creixell, 6",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-mfvt~iggp-3mk6",
		":version": "rv-e2z3_2hr4.reur",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "082652|PISCINA_MUNICIPAL",
		"municipi": "Sant Vicenç de Torelló",
		"codi_municipi": "082652",
		"latitud": "42.06154382",
		"longitud": "2.2627802",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Ctra. Vilaseca",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-sdzh~r855.vwz9",
		":version": "rv-35j7_5cww~jq5i",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Punt jove",
		"indicador_refugi": "082652|PUNT_JOVE",
		"municipi": "Sant Vicenç de Torelló",
		"codi_municipi": "082652",
		"latitud": "42.06280646",
		"longitud": "2.27410373",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Major",
		"tipologia": "Sala polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-5hkt-9di3-y7dk",
		":version": "rv-wabn-6r6j_jwa3",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Torre de les Monges",
		"indicador_refugi": "082652|TORRE_DE_LES_MONGES",
		"municipi": "Sant Vicenç de Torelló",
		"codi_municipi": "082652",
		"latitud": "42.0599377",
		"longitud": "2.25484962",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Vilaseca",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-pijb~qm5x_v3sd",
		":version": "rv-s3s6.n9ha.ga87",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal avis Sant Vicenç",
		"indicador_refugi": "082652|CASAL_AVIS_SANT_VICENC",
		"municipi": "Sant Vicenç de Torelló",
		"codi_municipi": "082652",
		"latitud": "42.06224855",
		"longitud": "2.27339441",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Pl. Cal Ferrer",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-bsbg-jukg.9eh2",
		":version": "rv-n5nf~4pbg-a7e8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Teatre Borgonyà",
		"indicador_refugi": "082652|TEATRE_BORGONYA",
		"municipi": "Sant Vicenç de Torelló",
		"codi_municipi": "082652",
		"latitud": "42.06501193",
		"longitud": "2.24275916",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Borgonyà",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-twmy_jzpu-guzt",
		":version": "rv-i73n_ewti.n7tm",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de la Gent Gran Borgonyà",
		"indicador_refugi": "082652|CASAL_DE_LA_GENT_GRAN_BORGONYA",
		"municipi": "Sant Vicenç de Torelló",
		"codi_municipi": "082652",
		"latitud": "42.065121",
		"longitud": "2.242358",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Girona",
		"informacio_web": "info@svdt.cat",
		"tipologia": "Casal de Gent Gran",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-10T12:05:00.000"
	},
	{
		":id": "row-sfgu_mkag_5mux",
		":version": "rv-yp79.vn87.9x7p",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casa de la Vila",
		"indicador_refugi": "082634|CASA_DE_LA_VILA",
		"municipi": "Sant Vicenç dels Horts",
		"codi_municipi": "082634",
		"latitud": "41.39326523828432",
		"longitud": "2.009598101524632",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça de la Vila, 1",
		"informacio_web": "www.svh.cat",
		"tipologia": "Ajuntament / Equipament Administratiu",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-08T08:39:00.000"
	},
	{
		":id": "row-zgfk.vrkx_7urd",
		":version": "rv-x5af.7diz~j572",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Cívic La Guàrdia",
		"indicador_refugi": "082634|CENTRE_CIVIC_LA_GUARDIA",
		"municipi": "Sant Vicenç dels Horts",
		"codi_municipi": "082634",
		"latitud": "41.39108825154025",
		"longitud": "2.003681958600413",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer del Mestre Ramon Camps, 86, 08620 Sant Vicenç dels Horts, Barcelona",
		"informacio_web": "www.svh.cat",
		"tipologia": "Centre Cívic",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-08T08:43:00.000"
	},
	{
		":id": "row-5uvw.mnju.t977",
		":version": "rv-fk5a.5upb-f364",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CCC Virginia Amposta",
		"indicador_refugi": "082634|CCC_VIRGINIA_AMPOSTA",
		"municipi": "Sant Vicenç dels Horts",
		"codi_municipi": "082634",
		"latitud": "41.39829768057465",
		"longitud": "2.0092228869193693",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer d'Antoni Mampel, 1, 3, 08620 Sant Vicenç dels Horts, Barcelona",
		"informacio_web": "www.svh.cat",
		"tipologia": "Centre Cívic",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-08T08:45:00.000"
	},
	{
		":id": "row-4t34~wgqw.9hvy",
		":version": "rv-v25c~afad-dmym",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca municipal Les Voltes",
		"indicador_refugi": "082634|BIBLIOTECA_MUNICIPAL_LES_VOLTES",
		"municipi": "Sant Vicenç dels Horts",
		"codi_municipi": "082634",
		"latitud": "41.39300471774377",
		"longitud": "2.011474391020152",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Nou, 7, 08620 Sant Vicenç dels Horts, Barcelona",
		"informacio_web": "www.svh.cat",
		"tipologia": "Biblioteca",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-08T08:46:00.000"
	},
	{
		":id": "row-kk5n-43h6_8vib",
		":version": "rv-yre2.252r-9acp",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Molí dels Frares",
		"indicador_refugi": "082634|MOLI_DELS_FRARES",
		"municipi": "Sant Vicenç dels Horts",
		"codi_municipi": "082634",
		"latitud": "41.40334754478099",
		"longitud": "2.000893551017464",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer C, 1, 08620 Sant Vicenç dels Horts, Barcelona",
		"informacio_web": "www.svh.cat",
		"tipologia": "Ajuntament / Equipament Administratiu",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-08T08:48:00.000"
	},
	{
		":id": "row-3gbs_mze2_qjdk",
		":version": "rv-8e8p-bwq2~ckzd",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Can Comamala",
		"indicador_refugi": "082634|CAN_COMAMALA",
		"municipi": "Sant Vicenç dels Horts",
		"codi_municipi": "082634",
		"latitud": "41.396329687289615",
		"longitud": "2.0080807682978383",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer de Mossèn Jacint Verdaguer, 105, 113, 08620 Sant Vicenç dels Horts, Barcelona",
		"informacio_web": "www.svh.cat",
		"tipologia": "Ajuntament / Equipament Administratiu",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-08T08:49:00.000"
	},
	{
		":id": "row-5j38.8634-mv4w",
		":version": "rv-yfpt_n9tf~g9ar",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal de Sant Antoni - La Blava",
		"indicador_refugi": "082634|PISCINA_MUNICIPAL_DE_SANT_ANTONI_-_LA_BLAVA",
		"municipi": "Sant Vicenç dels Horts",
		"codi_municipi": "082634",
		"latitud": "41.38343640052182",
		"longitud": "1.9951948107850332",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Avinguda del Mas Picó, s/n, 08620 Sant Vicenç dels Horts, Barcelona",
		"informacio_web": "www.svh.cat",
		"tipologia": "Piscines descobertes",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-08T08:51:00.000"
	},
	{
		":id": "row-4arr~yspm-r9r9",
		":version": "rv-irnv-b4yn_3qdi",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc del Pi Gros",
		"indicador_refugi": "082634|PARC_DEL_PI_GROS",
		"municipi": "Sant Vicenç dels Horts",
		"codi_municipi": "082634",
		"latitud": "41.39584586153714",
		"longitud": "1.9995029975776797",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Parc del Pi Gros, 08620 Sant Vicenç dels Horts, Barcelona",
		"informacio_web": "www.svh.cat",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-08T08:53:00.000"
	},
	{
		":id": "row-ujqh_xafs_ypyn",
		":version": "rv-7ngy_vsqr.cwsx",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc del Mamut Vènux",
		"indicador_refugi": "082634|PARC_DEL_MAMUT_VENUX",
		"municipi": "Sant Vicenç dels Horts",
		"codi_municipi": "082634",
		"latitud": "41.39737586276352",
		"longitud": "2.009925043174255",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Passatge del Comerç, 2, 08620 Sant Vicenç dels Horts, Barcelona",
		"informacio_web": "www.svh.cat",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-08T08:54:00.000"
	},
	{
		":id": "row-yb29-jqap~ksxk",
		":version": "rv-z2p8~shqs~iagz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Llar de jubilats",
		"indicador_refugi": "171805|LLAR_DE_JUBILATS",
		"municipi": "Santa Coloma de Farners",
		"codi_municipi": "171805",
		"latitud": "41.86522243",
		"longitud": "2.66370272",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Anselm Clavé, 19",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-ihex.euf6-wn3q",
		":version": "rv-268f-mtzt-ee2v",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Pavelló els Saioners",
		"indicador_refugi": "171805|PAVELLO_ELS_SAIONERS",
		"municipi": "Santa Coloma de Farners",
		"codi_municipi": "171805",
		"latitud": "41.85716128",
		"longitud": "2.66395142",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. Salvador Espriu",
		"tipologia": "Poliesportiu",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-bq35.njb2_aka5",
		":version": "rv-ehcf_kwam_8t2r",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "La Font de l'Alemany",
		"indicador_refugi": "171805|LA_FONT_DE_L_ALEMANY",
		"municipi": "Santa Coloma de Farners",
		"codi_municipi": "171805",
		"latitud": "41.86605807",
		"longitud": "2.70072365",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Rbla. Catalunya",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-myai_75r3.fc2s",
		":version": "rv-4snc-2cgf-h5ud",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Joan Vinyoli",
		"indicador_refugi": "171805|BIBLIOTECA_JOAN_VINYOLI",
		"municipi": "Santa Coloma de Farners",
		"codi_municipi": "171805",
		"latitud": "41.86163819",
		"longitud": "2.66365454",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pg. Sant Salvador, 1",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-psrw_z4rq_kebd",
		":version": "rv-7ibv~i7n3_9jiy",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de Sant Salvador",
		"indicador_refugi": "171805|PARC_DE_SANT_SALVADOR",
		"municipi": "Santa Coloma de Farners",
		"codi_municipi": "171805",
		"latitud": "41.85796309",
		"longitud": "2.66042441",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Parc de Sant Salvador",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-9dun~v5zh.ji3a",
		":version": "rv-2a2c-af36-4wj9",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "431397|PISCINA_MUNICIPAL",
		"municipi": "Santa Coloma de Queralt",
		"codi_municipi": "431397",
		"latitud": "41.53286644",
		"longitud": "1.38716072",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Pg. de la Muralla",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-rjxe_xhug-t94a",
		":version": "rv-v38f_qjgp-ac4v",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CASAL DE LA GENT GRAN EL PUIG",
		"indicador_refugi": "082476|CASAL_DE_LA_GENT_GRAN_EL_PUIG",
		"municipi": "Santa Eulàlia de Riuprimer",
		"codi_municipi": "082476",
		"latitud": "41.910988",
		"longitud": "2.188067",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Major 28",
		"informacio_web": "https://www.santaeulaliariuprimer.cat/serveis-i-tramits/cataleg-de-serveis/casal-de-la-gent-gran.html",
		"tipologia": "Casal de Gent Gran",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-30T09:48:00.000"
	},
	{
		":id": "row-tsb5.xtpq-nada",
		":version": "rv-e67b.jips-5d9u",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "PISCINA MUNICIPAL",
		"indicador_refugi": "082476|PISCINA_MUNICIPAL",
		"municipi": "Santa Eulàlia de Riuprimer",
		"codi_municipi": "082476",
		"latitud": "41.913465",
		"longitud": "2.183473",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Major s/n",
		"informacio_web": "https://www.santaeulaliariuprimer.cat/serveis-i-tramits/cataleg-de-serveis/piscina-municipal.html",
		"tipologia": "Piscines descobertes",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-30T09:52:00.000"
	},
	{
		":id": "row-7wtz_wevj.s2sh",
		":version": "rv-srzg.e5je.bkix",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca municipal",
		"indicador_refugi": "082482|BIBLIOTECA_MUNICIPAL",
		"municipi": "Santa Eulàlia de Ronçana",
		"codi_municipi": "082482",
		"latitud": "41.65448593",
		"longitud": "2.22304278",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Mestre Joan Batlle, 6",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-mn6k-ridi-ev3y",
		":version": "rv-wxg3~vif2_ie5u",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscines municipals Pinedes Castellet",
		"indicador_refugi": "082482|PISCINES_MUNICIPALS_PINEDES_CASTELLET",
		"municipi": "Santa Eulàlia de Ronçana",
		"codi_municipi": "082482",
		"latitud": "41.63509943",
		"longitud": "2.22064327",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Joan I",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-3c6v.dgii~wdzd",
		":version": "rv-tqb8.8ska-5pzp",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic La Fàbrica",
		"indicador_refugi": "082482|CENTRE_CIVIC_LA_FABRICA",
		"municipi": "Santa Eulàlia de Ronçana",
		"codi_municipi": "082482",
		"latitud": "41.63886804",
		"longitud": "2.23740177",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Camí del Gual, s/n",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-gu5w-288f_zyx4",
		":version": "rv-nhvj-kxev.bqr8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CENTRE CIVIC MUNICIPAL \"SALVADOR BENACH\"",
		"indicador_refugi": "082495|CENTRE_CIVIC_MUNICIPAL_\"SALVADOR_BENACH\"",
		"municipi": "Santa Fe del Penedès",
		"codi_municipi": "082495",
		"latitud": "41.384498",
		"longitud": "1.721445",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "CARRER ESCOLES, 1",
		"informacio_web": "https://www.santafepenedes.cat",
		"tipologia": "Centre Cívic",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-08T20:15:00.000"
	},
	{
		":id": "row-z9t6_wptd~k4th",
		":version": "rv-s7bk-h9w8.hut3",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Sala polivalent",
		"indicador_refugi": "082536|SALA_POLIVALENT",
		"municipi": "Santa Maria de Besora",
		"codi_municipi": "082536",
		"latitud": "42.12633849",
		"longitud": "2.25699433",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pg. Pla de Teia, s/n",
		"tipologia": "Sala polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-aen3_r3vv.2uhw",
		":version": "rv-p5j2-kfc7_su83",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Local Social de les Antigues Escoles",
		"indicador_refugi": "082573|LOCAL_SOCIAL_DE_LES_ANTIGUES_ESCOLES",
		"municipi": "Santa Maria de Miralles",
		"codi_municipi": "082573",
		"latitud": "41.50063309",
		"longitud": "1.52772286",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Ctra. Igualada a Valls, s/n",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-4e4x-kczb.qb6q",
		":version": "rv-hcee_mj7f-apcv",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "082589|PISCINA_MUNICIPAL",
		"municipi": "Santa Maria d'Oló",
		"codi_municipi": "082589",
		"latitud": "41.87770896",
		"longitud": "2.03377588",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Pg. de Carme Vidal, 4",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-9eb8~mepy-9qsj",
		":version": "rv-6j9u_g8sr.xwvs",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic - Can Taiò",
		"indicador_refugi": "082606|CENTRE_CIVIC_CAN_TAIO",
		"municipi": "Santa Perpètua de Mogoda",
		"codi_municipi": "082606",
		"latitud": "41.52877781",
		"longitud": "2.18001935",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Parc de Catalunya, s/n, 08130 Santa Perpètua de Mogoda",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-6mxh_cc5i-7tpy",
		":version": "rv-5gf2_3n64-fhvb",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casa De La Vila",
		"indicador_refugi": "082606|CASA_DE_LA_VILA",
		"municipi": "Santa Perpètua de Mogoda",
		"codi_municipi": "082606",
		"latitud": "41.53449205",
		"longitud": "2.18355951",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. de la vila, 5",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-6e88~cpdf.hnai",
		":version": "rv-a33a-vhas~m3vb",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Josep Jardí",
		"indicador_refugi": "082606|BIBLIOTECA_JOSEP_JARDI",
		"municipi": "Santa Perpètua de Mogoda",
		"codi_municipi": "082606",
		"latitud": "41.52737311",
		"longitud": "2.18514109",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Ptge. del Mas Granollacs, s/n, 08130 Santa Perpètua de Mogoda",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-4m9p.kbci-5aam",
		":version": "rv-r4fn.en4c_n8ua",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc dels Ametllers",
		"indicador_refugi": "082606|PARC_DELS_AMETLLERS",
		"municipi": "Santa Perpètua de Mogoda",
		"codi_municipi": "082606",
		"latitud": "41.52555448",
		"longitud": "2.18884863",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pg. de la Florida, 08130 Santa Perpètua de Mogoda, Barcelona",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-uvtw-nzdu-uqjk",
		":version": "rv-5amv.ypsj~365v",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic - La Creueta",
		"indicador_refugi": "082606|CENTRE_CIVIC_LA_CREUETA",
		"municipi": "Santa Perpètua de Mogoda",
		"codi_municipi": "082606",
		"latitud": "41.53658202",
		"longitud": "2.17725323",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Parc del Doctor Miró, s/n, 08130 Santa Perpètua de Mogoda",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-exry-ifns~sv3h",
		":version": "rv-fnb3~bntk~ii4a",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bosc de la Torre",
		"indicador_refugi": "082606|BOSC_DE_LA_TORRE",
		"municipi": "Santa Perpètua de Mogoda",
		"codi_municipi": "082606",
		"latitud": "41.54599741",
		"longitud": "2.18060806",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Mar Adriàtic, 2, 08130 Santa Perpètua de Mogoda",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-8k4r.g7vp_f769",
		":version": "rv-hrer-s7ta~ecz3",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de Catalunya",
		"indicador_refugi": "082606|PARC_DE_CATALUNYA",
		"municipi": "Santa Perpètua de Mogoda",
		"codi_municipi": "082606",
		"latitud": "41.52794613",
		"longitud": "2.18026977",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de Josep Carner, 32, 08130 Santa Perpètua de Mogoda",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-c3hx_q5zf~84h9",
		":version": "rv-y24b-uf2w~gpag",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc municipal",
		"indicador_refugi": "082606|PARC_MUNICIPAL",
		"municipi": "Santa Perpètua de Mogoda",
		"codi_municipi": "082606",
		"latitud": "41.5360767",
		"longitud": "2.18308045",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. de Santiga, 2, 08130 Santa Perpètua de Mogoda",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-beb3_e6ta-hphx",
		":version": "rv-jyuq-metj.hm7r",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Cívic - La Rambla",
		"indicador_refugi": "082606|CENTRE_CIVIC_LA_RAMBLA",
		"municipi": "Santa Perpètua de Mogoda",
		"codi_municipi": "082606",
		"latitud": "41.53511033",
		"longitud": "2.18275469",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. de la Vila, 9, 08130 Santa Perpètua de Mogoda",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-yxf5~643t~6t8y",
		":version": "rv-xa84.hszu_qiqb",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça de Miquel Segura",
		"indicador_refugi": "082606|PLACA_DE_MIQUEL_SEGURA",
		"municipi": "Santa Perpètua de Mogoda",
		"codi_municipi": "082606",
		"latitud": "41.53748684",
		"longitud": "2.17950077",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de la Verge de Montserrat, 18, 08130 Santa Perpètua de Mogoda",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-pafh~8wk7_t2q9",
		":version": "rv-762t-q6rj.6uv8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de la Ribera",
		"indicador_refugi": "082606|PARC_DE_LA_RIBERA",
		"municipi": "Santa Perpètua de Mogoda",
		"codi_municipi": "082606",
		"latitud": "41.53307953",
		"longitud": "2.18942306",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. de les Minetes, 08130 Santa Perpètua de Mogoda",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-psmi_59t2_v8yw",
		":version": "rv-tbak.ngvg~6f5j",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic - Mas Costa",
		"indicador_refugi": "082606|CENTRE_CIVIC_MAS_COSTA",
		"municipi": "Santa Perpètua de Mogoda",
		"codi_municipi": "082606",
		"latitud": "41.52226666",
		"longitud": "2.18232824",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pg. de Can Taió, 83, 08130 Santa Perpètua de Mogoda",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-7sci~j2f4.yjqg",
		":version": "rv-yzud.2em9-udjh",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal cívic de la Gent Gran",
		"indicador_refugi": "082606|CASAL_CIVIC_DE_LA_GENT_GRAN",
		"municipi": "Santa Perpètua de Mogoda",
		"codi_municipi": "082606",
		"latitud": "41.53145403",
		"longitud": "2.18351655",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Ramon d'Abadal, s/n, 08130 Santa Perpètua de Mogoda",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-n4av_59s9_6hzd",
		":version": "rv-dmpd_32rt-ajdx",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de la Pesseta",
		"indicador_refugi": "082606|PARC_DE_LA_PESSETA",
		"municipi": "Santa Perpètua de Mogoda",
		"codi_municipi": "082606",
		"latitud": "41.52274541",
		"longitud": "2.18793778",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. setze, 08130 La Florida - Santa Perpètua de Mogoda",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-krxd_e6w8~yvax",
		":version": "rv-jsyu-xhqr~n35w",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Santa Perpètua de Mogoda",
		"indicador_refugi": "082606|CASAL_CIVIC_I_COMUNITARI_SANTA_PERPETUA_DE_MOGODA",
		"municipi": "Santa Perpètua de Mogoda",
		"codi_municipi": "082606",
		"latitud": "41.7876571",
		"longitud": "1.8898848",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de Ramon d'Abadal, s/n",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-cy7r.z4cp.jyf8",
		":version": "rv-xmmc_686d~aqcg",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bosc de Ca n'Oller",
		"indicador_refugi": "082606|BOSC_DE_CA_N_OLLER",
		"municipi": "Santa Perpètua de Mogoda",
		"codi_municipi": "082606",
		"latitud": "41.54709963",
		"longitud": "2.17487208",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "No",
		"adreca": "C. Sardenya, s/n, 08130 Santa Perpètua de Mogoda",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-m65w~p2v4_bqei",
		":version": "rv-su3b~8skp_bnb8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Espai natural de Santiga",
		"indicador_refugi": "082606|ESPAI_NATURAL_DE_SANTIGA",
		"municipi": "Santa Perpètua de Mogoda",
		"codi_municipi": "082606",
		"latitud": "41.53451739",
		"longitud": "2.15224473",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Nucli antic de Santiga - 08130 Santiga - Santa Perpètua de Mogoda",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-g2ai.shdn_mxvu",
		":version": "rv-58rq-baz4.xwuh",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc dels Països Catalans",
		"indicador_refugi": "082606|PARC_DELS_PAISOS_CATALANS",
		"municipi": "Santa Perpètua de Mogoda",
		"codi_municipi": "082606",
		"latitud": "41.53062886",
		"longitud": "2.18560382",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de Pablo Ruiz Picasso, 18, 08130 Santa Perpètua de Mogoda",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-i3vs~3m4s-pqax",
		":version": "rv-xtmh_3iq2.emnw",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Granja Soldevila",
		"indicador_refugi": "082606|GRANJA_SOLDEVILA",
		"municipi": "Santa Perpètua de Mogoda",
		"codi_municipi": "082606",
		"latitud": "41.52673937",
		"longitud": "2.18564803",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Camí de la Granja, s/n, 08130 Santa Perpètua de Mogoda",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-kzbg.b4mr.knbh",
		":version": "rv-6myj_xuq5-fimf",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Mercat municipal",
		"indicador_refugi": "082606|MERCAT_MUNICIPAL",
		"municipi": "Santa Perpètua de Mogoda",
		"codi_municipi": "082606",
		"latitud": "41.53604291",
		"longitud": "2.18266042",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. de Santiga, s/n, 08130 Santa Perpètua de Mogoda",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-tecg~5588-8p32",
		":version": "rv-x66k-9n7x~xj3x",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Museu del Treball i la Industria Viva - MTIV",
		"indicador_refugi": "082606|MUSEU_DEL_TREBALL_I_LA_INDUSTRIA_VIVA_MTIV",
		"municipi": "Santa Perpètua de Mogoda",
		"codi_municipi": "082606",
		"latitud": "41.53605066",
		"longitud": "2.18012221",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. d'Enric Granados, 8, 08130 Santa Perpètua de Mogoda",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-nxcv~dgt5~4fed",
		":version": "rv-7ufd-swrx.n9pw",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic - Can Folguera",
		"indicador_refugi": "082606|CENTRE_CIVIC_CAN_FOLGUERA",
		"municipi": "Santa Perpètua de Mogoda",
		"codi_municipi": "082606",
		"latitud": "41.53125462",
		"longitud": "2.18682903",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Pablo Ruiz Picasso, 32, 08130 Santa Perpètua de Mogoda",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-2ftz.62aw-9jku",
		":version": "rv-j3kj_ytm7.xam3",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Central",
		"indicador_refugi": "082606|PARC_CENTRAL",
		"municipi": "Santa Perpètua de Mogoda",
		"codi_municipi": "082606",
		"latitud": "41.52896674",
		"longitud": "2.18751247",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. de l' Onze de Setembre, 1-7, 08130 Santa Perpètua de Mogoda",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-mck5~88bn.i3c4",
		":version": "rv-y7a6-fzgk.zinr",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bosc Soldevila",
		"indicador_refugi": "082606|BOSC_SOLDEVILA",
		"municipi": "Santa Perpètua de Mogoda",
		"codi_municipi": "082606",
		"latitud": "41.52438733",
		"longitud": "2.18540345",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. la Font dels Joncs, 2, 08130 Santa Perpètua de Mogoda",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-yxub.dub8_jp4d",
		":version": "rv-rqxb~8nev-7ha2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Poliesportiu municipal",
		"indicador_refugi": "082606|POLIESPORTIU_MUNICIPAL",
		"municipi": "Santa Perpètua de Mogoda",
		"codi_municipi": "082606",
		"latitud": "41.52887423",
		"longitud": "2.18207275",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. de Girona, 7, 08130 Santa Perpètua de Mogoda",
		"tipologia": "Poliesportiu",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-n4rd-e4e9-k5jt",
		":version": "rv-5chx~hzqg~fjkb",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de la Riera Seca",
		"indicador_refugi": "082606|PARC_DE_LA_RIERA_SECA",
		"municipi": "Santa Perpètua de Mogoda",
		"codi_municipi": "082606",
		"latitud": "41.51626043",
		"longitud": "2.18909862",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Parc Riera Seca, 24, 08130 La Florida - Santa Perpètua de Mogoda",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-b996-kyyt.7yh9",
		":version": "rv-e9iq_3dns-c4t8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic - La Florida",
		"indicador_refugi": "082606|CENTRE_CIVIC_LA_FLORIDA",
		"municipi": "Santa Perpètua de Mogoda",
		"codi_municipi": "082606",
		"latitud": "41.51960611",
		"longitud": "2.1904094",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. Set, 20, 08130 La Florida - Santa Perpètua de Mogoda",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-jccu~cn57~cpbc",
		":version": "rv-pb4f-6rxf~vchx",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de Tesanj",
		"indicador_refugi": "082606|PARC_DE_TESANJ",
		"municipi": "Santa Perpètua de Mogoda",
		"codi_municipi": "082606",
		"latitud": "41.53392186",
		"longitud": "2.17629017",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de Ramon Casas, s/n, 08130 Santa Perpètua de Mogoda",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-3ua5_gsn7-2wdz",
		":version": "rv-tiu6.wcpc-77fw",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc d'Europa",
		"indicador_refugi": "082606|PARC_D_EUROPA",
		"municipi": "Santa Perpètua de Mogoda",
		"codi_municipi": "082606",
		"latitud": "41.52149702",
		"longitud": "2.18204831",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pg. de Can Taió, 75, 08130 Santa Perpètua de Mogoda",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-jfsw~hjmf~x2jn",
		":version": "rv-xkfa~y5wu.cvav",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Serveis Socials",
		"indicador_refugi": "082606|SERVEIS_SOCIALS",
		"municipi": "Santa Perpètua de Mogoda",
		"codi_municipi": "082606",
		"latitud": "41.53154195",
		"longitud": "2.17762569",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Salvador Espriu, 72, 08130 Santa Perpètua de Mogoda",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-w6uf_4r2z~qdup",
		":version": "rv-mg56-2enb.gwf6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Pare Ignasi Casanovas",
		"indicador_refugi": "081923|BIBLIOTECA_PARE_IGNASI_CASANOVAS",
		"municipi": "Santpedor",
		"codi_municipi": "081923",
		"latitud": "41.78262",
		"longitud": "1.83595",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "08251",
		"informacio_web": "https://bibliotecavirtual.diba.cat/santpedor-biblioteca-pare-ignasi-casanovas",
		"tipologia": "Biblioteca",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-06T08:10:00.000"
	},
	{
		":id": "row-nvsu_6ctj.tcx3",
		":version": "rv-3si4~d3rg~xxs7",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Llar d'avis Ca l'Arola",
		"indicador_refugi": "081923|LLAR_DAVIS_CA_LAROLA",
		"municipi": "Santpedor",
		"codi_municipi": "081923",
		"latitud": "41.78324",
		"longitud": "1.83937",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "08251",
		"informacio_web": "https://www.santpedor.cat/regidories-i-serveis/cultura/llar-davis-ca-larola.html",
		"tipologia": "Casal de Gent Gran",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-06T08:14:00.000"
	},
	{
		":id": "row-83gt~tjtj_m4r6",
		":version": "rv-2mre_n2ws~xyv7",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Ajuntament de Santpedor",
		"indicador_refugi": "081923|AJUNTAMENT_DE_SANTPEDOR",
		"municipi": "Santpedor",
		"codi_municipi": "081923",
		"latitud": "41.78324",
		"longitud": "1.83837",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "08251",
		"informacio_web": "https://www.santpedor.cat/municipi/oficines-municipals/oficina-atencio-al-ciutada.html",
		"tipologia": "Ajuntament / Equipament Administratiu",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-06T08:17:00.000"
	},
	{
		":id": "row-22g9-dxdx-fnpx",
		":version": "rv-8sum~fqnv.k9at",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Emília Xargay",
		"indicador_refugi": "171864|BIBLIOTECA_EMILIA_XARGAY",
		"municipi": "Sarrià de Ter",
		"codi_municipi": "171864",
		"latitud": "42.01091",
		"longitud": "2.49194",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Catalunya, 1",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-gdjt.fjqp~6zec",
		":version": "rv-x3yz.xv9t.7rs5",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Local Social de la Rasa",
		"indicador_refugi": "171864|LOCAL_SOCIAL_DE_LA_RASA",
		"municipi": "Sarrià de Ter",
		"codi_municipi": "171864",
		"latitud": "42.02195991644906",
		"longitud": "2.8225507946646546",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "No",
		"adreca": "Carrerr Flore de Neu, 6",
		"tipologia": "Centre Cívic",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-04T09:28:00.000"
	},
	{
		":id": "row-qva7~gu8e-uey7",
		":version": "rv-5yfk-8kmf-fzqg",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Cívic La Cooperativa",
		"indicador_refugi": "171864|CENTRE_CIVIC_LA_COOPERATIVA",
		"municipi": "Sarrià de Ter",
		"codi_municipi": "171864",
		"latitud": "42.01185117546791",
		"longitud": "2.814066765503671",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "No",
		"adreca": "Plaça Renaixença S/N",
		"tipologia": "Centre Cívic",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-04T09:30:00.000"
	},
	{
		":id": "row-naaq_aji2.5c9j",
		":version": "rv-jcti.38ea_8xjp",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "El Coro",
		"indicador_refugi": "171864|EL_CORO",
		"municipi": "Sarrià de Ter",
		"codi_municipi": "171864",
		"latitud": "42.018607525322075",
		"longitud": "2.825270593913159",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "No",
		"adreca": "Plaça de la Font, 9",
		"tipologia": "Casal de Gent Gran",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-04T09:33:00.000"
	},
	{
		":id": "row-hg6g_67yv_z2h8",
		":version": "rv-i7m2~gpz6-i68f",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Local Social del Pla de l’Horta",
		"indicador_refugi": "171864|LOCAL_SOCIAL_DEL_PLA_DE_L’HORTA",
		"municipi": "Sarrià de Ter",
		"codi_municipi": "171864",
		"latitud": "42.01519902687855",
		"longitud": "2.81506054708262",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "No",
		"adreca": "Carrer Rafael Casanova SN",
		"tipologia": "Centre Cívic",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-04T10:08:00.000"
	},
	{
		":id": "row-9u65-6cv8_3hyr",
		":version": "rv-64cw~z92e-yqzf",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Local Social",
		"indicador_refugi": "431439|LOCAL_SOCIAL",
		"municipi": "Savallà del Comtat",
		"codi_municipi": "431439",
		"latitud": "41.54305183",
		"longitud": "1.3009958",
		"accessibilitat": "No",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Major, 12",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-7m7x_y6rf~dmfj",
		":version": "rv-5rf3~px7f~rkur",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "casal de la gent gran",
		"indicador_refugi": "431444|CASAL_DE_LA_GENT_GRAN",
		"municipi": "Secuita, la",
		"codi_municipi": "431444",
		"latitud": "41.204837",
		"longitud": "1.281978",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Josep Gasssió, 7 43765 la Secuita",
		"informacio_web": "De dilluns a divendres, de 8.00 a 20.00 hores",
		"tipologia": "Casal de Gent Gran",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-09T13:58:00.000"
	},
	{
		":id": "row-2ery-7q9v.dbxc",
		":version": "rv-v33t~cxhf-456s",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Mas de l'Hort d'Iglésies",
		"indicador_refugi": "431457|MAS_DE_LHORT_DIGLESIES",
		"municipi": "Selva del Camp, la",
		"codi_municipi": "431457",
		"latitud": "41.22278325013513",
		"longitud": "1.138020929127775",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "c. Tarragona, 10",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-11T10:14:00.000"
	},
	{
		":id": "row-87ga-j8m6-gwgv",
		":version": "rv-2gu9-8yrm-f2ky",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Pública de la Selva del Camp",
		"indicador_refugi": "431457|BIBLIOTECA_PUBLICA_DE_LA_SELVA_DEL_CAMP",
		"municipi": "Selva del Camp, la",
		"codi_municipi": "431457",
		"latitud": "41.22226955199804",
		"longitud": "1.135271818174045",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "c. Tarragona, 10",
		"informacio_web": "https://biblioteca.laselvadelcamp.cat/",
		"tipologia": "Biblioteca",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-11T10:19:00.000"
	},
	{
		":id": "row-kcxb_kzf8.z32a",
		":version": "rv-5t2n~cqtw.esjy",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal d'Avis",
		"indicador_refugi": "431457|CASAL_DAVIS",
		"municipi": "Selva del Camp, la",
		"codi_municipi": "431457",
		"latitud": "41.21336644254618",
		"longitud": "1.1398075541794912",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Av. de Joan Puig i Ferrater, 6",
		"tipologia": "Casal de Gent Gran",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-11T10:26:00.000"
	},
	{
		":id": "row-duy3.h9ys.jp3u",
		":version": "rv-yp8d.536f.ngeb",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça del Portal d'Avall",
		"indicador_refugi": "431457|PLACA_DEL_PORTAL_DAVALL",
		"municipi": "Selva del Camp, la",
		"codi_municipi": "431457",
		"latitud": "41.215107950758316",
		"longitud": "1.1391214397005518",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça del Portal d'Avall",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-11T10:29:00.000"
	},
	{
		":id": "row-2dhr~nftu_8wwr",
		":version": "rv-p8ky~mtis~p56i",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jardins de la Rasa d'en Batlle",
		"indicador_refugi": "431457|JARDINS_DE_LA_RASA_DEN_BATLLE",
		"municipi": "Selva del Camp, la",
		"codi_municipi": "431457",
		"latitud": "41.21315710161594",
		"longitud": "1.1344734016075144",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "c. Gandhi",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-11T11:47:00.000"
	},
	{
		":id": "row-rypi-kpir.2qx5",
		":version": "rv-3gyt~n433.7cst",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Pavelló Municipal d'Esports de la Selva del Camp",
		"indicador_refugi": "431457|PAVELLO_MUNICIPAL_DESPORTS_DE_LA_SELVA_DEL_CAMP",
		"municipi": "Selva del Camp, la",
		"codi_municipi": "431457",
		"latitud": "41.213365215469004",
		"longitud": "1.142962336702021",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "c. de l'Horta, 39",
		"informacio_web": "https://laselvadelcamp.cat/equipaments/pavello-municipal-desports/",
		"tipologia": "Pavelló Esportiu",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-11T11:50:00.000"
	},
	{
		":id": "row-gway~uisp.kr2y",
		":version": "rv-casj.7r2d_skyi",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina d'estiu",
		"indicador_refugi": "431457|PISCINA_DESTIU",
		"municipi": "Selva del Camp, la",
		"codi_municipi": "431457",
		"latitud": "41.21391505650985",
		"longitud": "1.1427530060910407",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "c. Horta, 39",
		"tipologia": "Piscines descobertes",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-11T12:04:00.000"
	},
	{
		":id": "row-qiav~x63w~gvh7",
		":version": "rv-4dmt.fvmr_jkja",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc del c. Puig d'en Cama",
		"indicador_refugi": "431457|PARC_DEL_C_PUIG_DEN_CAMA",
		"municipi": "Selva del Camp, la",
		"codi_municipi": "431457",
		"latitud": "41.21680944900349",
		"longitud": "1.1347150263002879",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "c. Puig d'en Cama",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-11T12:07:00.000"
	},
	{
		":id": "row-khr9.cjks~8gej",
		":version": "rv-sxv7-tkwh_kgrz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça Major",
		"indicador_refugi": "431457|PLACA_MAJOR",
		"municipi": "Selva del Camp, la",
		"codi_municipi": "431457",
		"latitud": "41.21526118681679",
		"longitud": "1.1369672175715129",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça Major",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-11T12:19:00.000"
	},
	{
		":id": "row-c9t8_m4i5-9shd",
		":version": "rv-bf39.zdfr-em5v",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Ajuntament de la Selva del Camp",
		"indicador_refugi": "431457|AJUNTAMENT_DE_LA_SELVA_DEL_CAMP",
		"municipi": "Selva del Camp, la",
		"codi_municipi": "431457",
		"latitud": "41.21519395283302",
		"longitud": "1.1370012168848551",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça Major, 4",
		"informacio_web": "https://laselvadelcamp.cat/",
		"tipologia": "Ajuntament / Equipament Administratiu",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-11T12:22:00.000"
	},
	{
		":id": "row-fpgj~brju.s4e7",
		":version": "rv-n4fw-pm4r-6mn9",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça de Sant Andreu",
		"indicador_refugi": "431457|PLACA_DE_SANT_ANDREU",
		"municipi": "Selva del Camp, la",
		"codi_municipi": "431457",
		"latitud": "41.21629652839597",
		"longitud": "1.136536163310278",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça de Sant Andreu",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-11T12:24:00.000"
	},
	{
		":id": "row-cpce.rk58.tw9e",
		":version": "rv-xprr.yxnn~gnpe",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de l'Abel Ferrater",
		"indicador_refugi": "431457|PARC_DE_LABEL_FERRATER",
		"municipi": "Selva del Camp, la",
		"codi_municipi": "431457",
		"latitud": "41.210715034719705",
		"longitud": "1.1324363861961424",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "c. d'Abel Ferrater i Hortet, 3",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-11T12:41:00.000"
	},
	{
		":id": "row-meah_3ga8~r5ia",
		":version": "rv-4pkj_7a7p~tqif",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça Passatge amb Marie Curie i Marta Mata",
		"indicador_refugi": "431457|PLACA_PASSATGE_AMB_MARIE_CURIE_I_MARTA_MATA",
		"municipi": "Selva del Camp, la",
		"codi_municipi": "431457",
		"latitud": "41.214236957433435",
		"longitud": "1.1344885942599023",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Ptge. Marie Curie amb Ptge. Marta Mata",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-11T12:43:00.000"
	},
	{
		":id": "row-zkse-wxx6.pn98",
		":version": "rv-wc5f~6t5b.whr2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Local Social",
		"indicador_refugi": "431460|LOCAL_SOCIAL",
		"municipi": "Senan",
		"codi_municipi": "431460",
		"latitud": "41.47013082638465",
		"longitud": "1.0878422192951616",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C/ Major, 6",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-02T13:43:00.000"
	},
	{
		":id": "row-gb9t-bbwi-asrv",
		":version": "rv-v725.cpsu~3af9",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "250352|PISCINA_MUNICIPAL",
		"municipi": "Sentiu de Sió, la",
		"codi_municipi": "250352",
		"latitud": "41.80538491",
		"longitud": "0.88016076",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Escoles, s/n",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-bvay~qte6.7w27",
		":version": "rv-6fh4_g9j6_2chs",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre de serveis El Roser",
		"indicador_refugi": "250352|CENTRE_DE_SERVEIS_EL_ROSER",
		"municipi": "Sentiu de Sió, la",
		"codi_municipi": "250352",
		"latitud": "41.80662528",
		"longitud": "0.88531448",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. disset, s/n",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-8i42~6jkd-ih5x",
		":version": "rv-dydy-6z2t-nvpg",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Pavelló municipal",
		"indicador_refugi": "250352|PAVELLO_MUNICIPAL",
		"municipi": "Sentiu de Sió, la",
		"codi_municipi": "250352",
		"latitud": "41.805587",
		"longitud": "0.880683",
		"accessibilitat": "Sí",
		"aigua": "No",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C/ Escoles, 4",
		"tipologia": "Pavelló Esportiu",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-16T09:14:00.000"
	},
	{
		":id": "row-wzre-usbk.3eek",
		":version": "rv-r5s7.7avb_v4a4",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Frederic Alfonso i Orfila",
		"indicador_refugi": "082671|BIBLIOTECA_FREDERIC_ALFONSO_I_ORFILA",
		"municipi": "Sentmenat",
		"codi_municipi": "082671",
		"latitud": "41.60600318",
		"longitud": "2.13638228",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pg. de l'Església, 6",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-3d7p.tac8-dbk3",
		":version": "rv-n2vd.3eby_334j",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de l'Aigua",
		"indicador_refugi": "082671|PARC_DE_L_AIGUA",
		"municipi": "Sentmenat",
		"codi_municipi": "082671",
		"latitud": "41.61044019",
		"longitud": "2.13471264",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Francesc Moragues Barr, 2, 08181 Sentmenat, Barcelona",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-r5cp-2vef.d6d9",
		":version": "rv-4d52.rnx3~hm5p",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "La Platgeta",
		"indicador_refugi": "171925|LA_PLATGETA",
		"municipi": "Setcases",
		"codi_municipi": "171925",
		"latitud": "42.374958",
		"longitud": "2.302448",
		"accessibilitat": "Sí",
		"aigua": "No",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Espai Verd al costat Riu Ter - GIV5264",
		"informacio_web": "www.setcases.cat",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-10T09:58:00.000"
	},
	{
		":id": "row-e2jb.tt4c-mzjz",
		":version": "rv-vmva-dwmq_i3uc",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari la Seu d'Urgell",
		"indicador_refugi": "252038|CASAL_CIVIC_I_COMUNITARI_LA_SEU_D_URGELL",
		"municipi": "Seu d'Urgell, la",
		"codi_municipi": "252038",
		"latitud": "42.3596704",
		"longitud": "1.454723",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. de Joan Garriga i Massó, 22-26 baixos",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-8djm_8zr2~h4sm",
		":version": "rv-vh43-vp6q.nna5",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Els Roures Parc",
		"indicador_refugi": "082690|ELS_ROURES_PARC",
		"municipi": "Seva",
		"codi_municipi": "082690",
		"latitud": "41.83459075",
		"longitud": "2.27382264",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Ctra. de Viladrau, s/n, 08553 Seva, Barcelona",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-58pk-4cae-3et4",
		":version": "rv-kiku.2vin_8pjm",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre de serveis polivalent",
		"indicador_refugi": "252056|CENTRE_DE_SERVEIS_POLIVALENT",
		"municipi": "Sidamon",
		"codi_municipi": "252056",
		"latitud": "41.62865999",
		"longitud": "0.83118646",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Carretera, 21",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-ceqg_w3np.pmxd",
		":version": "rv-baq5.423i~srmu",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "piscina",
		"indicador_refugi": "252056|PISCINA",
		"municipi": "Sidamon",
		"codi_municipi": "252056",
		"latitud": "41.62754751",
		"longitud": "0.83174562",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Av. Generalitat",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-sbxh-rpk3.8wwq",
		":version": "rv-d6zw_2jbu.9vnv",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Santiago Rusiñol",
		"indicador_refugi": "082704|BIBLIOTECA_SANTIAGO_RUSINOL",
		"municipi": "Sitges",
		"codi_municipi": "082704",
		"latitud": "41.2353224",
		"longitud": "1.81223368",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. de l'ajuntament, 13, 08870 Sitges, Barcelona",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-2r7f.quut_pcs2",
		":version": "rv-ywqv_m2bz~6u5d",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de la gent gran Joan Maragall",
		"indicador_refugi": "082704|CASAL_DE_LA_GENT_GRAN_JOAN_MARAGALL",
		"municipi": "Sitges",
		"codi_municipi": "082704",
		"latitud": "41.23745559",
		"longitud": "1.81621454",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de Joan Maragall, 38, 08870 Sitges, Barcelona",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-38n3_7uep~aqcb",
		":version": "rv-i2i5-pz5i_uwbi",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Josep Roig i Raventós",
		"indicador_refugi": "082704|BIBLIOTECA_JOSEP_ROIG_I_RAVENTOS",
		"municipi": "Sitges",
		"codi_municipi": "082704",
		"latitud": "41.24169871",
		"longitud": "1.81095238",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Catalunya, s/n, 08870 Sitges, Barcelona",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-xvc3.ie2k-rgfs",
		":version": "rv-4uv9-yhz7~usvj",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de la gent gran Pau Casals",
		"indicador_refugi": "082704|CASAL_DE_LA_GENT_GRAN_PAU_CASALS",
		"municipi": "Sitges",
		"codi_municipi": "082704",
		"latitud": "41.24073838",
		"longitud": "1.80722785",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Pau Casals, 17, 08870 Sitges, Barcelona",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-9a5y.u8tb-j9fx",
		":version": "rv-az54-cemm~xtdv",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Sala polivalent de l'ajuntament",
		"indicador_refugi": "252069|SALA_POLIVALENT_DE_L_AJUNTAMENT",
		"municipi": "Soleràs, el",
		"codi_municipi": "252069",
		"latitud": "41.41408297",
		"longitud": "0.68286915",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Ctra. de Bellpuig, 23",
		"tipologia": "Sala polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-dy2k-nzif-napq",
		":version": "rv-xms3.4qrg_pyxu",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "431476|PISCINA_MUNICIPAL",
		"municipi": "Solivella",
		"codi_municipi": "431476",
		"latitud": "41.45290679",
		"longitud": "1.1773398",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Ctra. de Poblet",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-u7km~t3qf~ec9h",
		":version": "rv-6jap_p7ac~crai",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Societat",
		"indicador_refugi": "431476|SOCIETAT",
		"municipi": "Solivella",
		"codi_municipi": "431476",
		"latitud": "41.45951",
		"longitud": "1.17864",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Ctra. de Montblanc a Artesa, 78",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-tmrn.dzv8-r95n",
		":version": "rv-pmqh~hkmp.ne4r",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bar picina Solivella",
		"indicador_refugi": "431476|BAR_PICINA_SOLIVELLA",
		"municipi": "Solivella",
		"codi_municipi": "431476",
		"latitud": "41.45298",
		"longitud": "1.17732",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "carretera de Blancafort",
		"informacio_web": "del7 de juny al 30 de agost,de 11 a 24 horas",
		"tipologia": "Piscines descobertes",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-01T15:15:00.000"
	},
	{
		":id": "row-c89f.easb-azym",
		":version": "rv-tr4g_chyh-rdv3",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Solsona",
		"indicador_refugi": "252075|CASAL_CIVIC_I_COMUNITARI_SOLSONA",
		"municipi": "Solsona",
		"codi_municipi": "252075",
		"latitud": "41.9943696",
		"longitud": "1.5106318",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. d'Antoni Gaudí, 2-A (ctda. Pg. Sant Antoni Maria Claret)",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-b6qm.z8c5.9yxj",
		":version": "rv-bty7_2t2q_m9jy",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Sala polivalent",
		"indicador_refugi": "252075|SALA_POLIVALENT",
		"municipi": "Solsona",
		"codi_municipi": "252075",
		"latitud": "41.99459052",
		"longitud": "1.51365583",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Gaudí, 2",
		"tipologia": "Sala polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-7ga8_sy8p.d76b",
		":version": "rv-f8r5_3vdu_x8wf",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscines municipals de Solsona",
		"indicador_refugi": "252075|PISCINES_MUNICIPALS_DE_SOLSONA",
		"municipi": "Solsona",
		"codi_municipi": "252075",
		"latitud": "41.98904127",
		"longitud": "1.51776882",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Salvador Espriu, 8",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-dt84_xf5z_5wxk",
		":version": "rv-8kw8~zd7h-ugdn",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Carles Morató",
		"indicador_refugi": "252075|BIBLIOTECA_CARLES_MORATO",
		"municipi": "Solsona",
		"codi_municipi": "252075",
		"latitud": "41.99499313",
		"longitud": "1.51714903",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Pl. de Ramon Llumà, 1",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-pv94.7m83_jd6t",
		":version": "rv-u6s6_ndrt_ycjj",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "AJUNTAMENT DE SORA",
		"indicador_refugi": "082726|AJUNTAMENT_DE_SORA",
		"municipi": "Sora",
		"codi_municipi": "082726",
		"latitud": "42.11239",
		"longitud": "2.16085",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "No",
		"adreca": "08588",
		"informacio_web": "www.sora.cat",
		"tipologia": "Ajuntament / Equipament Administratiu",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-01T13:07:00.000"
	},
	{
		":id": "row-gph4~x3aq~g4qh",
		":version": "rv-m6mk~mkpc~9ygs",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "ESCOLES DE CUSSONS",
		"indicador_refugi": "082726|ESCOLES_DE_CUSSONS",
		"municipi": "Sora",
		"codi_municipi": "082726",
		"latitud": "42.09684",
		"longitud": "2.19713",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "No",
		"adreca": "Carrer de la Ribera, 2 - 08588  SORA",
		"informacio_web": "WWW.SORA.CAT",
		"tipologia": "Centre Cívic",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-01T13:13:00.000"
	},
	{
		":id": "row-tumx_vc2y_aqwg",
		":version": "rv-eeph_wjjy_yaxm",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Sort",
		"indicador_refugi": "252094|CASAL_CIVIC_I_COMUNITARI_SORT",
		"municipi": "Sort",
		"codi_municipi": "252094",
		"latitud": "42.4128182",
		"longitud": "1.1291667",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. del Doctor Carles Pol i Aleu, 8",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-gdru.g7eu~sxeb",
		":version": "rv-3k4i-i3zh-pkii",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "piscina municipal",
		"indicador_refugi": "082747|PISCINA_MUNICIPAL",
		"municipi": "Súria",
		"codi_municipi": "082747",
		"latitud": "41.8305636329025",
		"longitud": "1.7499336861286168",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Ignasi Abadal,13",
		"informacio_web": "https://www.suria.cat/espaismunicipals/espais-esportius-i-de-salut/piscinamunicipal2/",
		"tipologia": "Piscines descobertes",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-02T13:29:00.000"
	},
	{
		":id": "row-24p4.xhj4-chvm",
		":version": "rv-kvp5-s98y_836n",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Local social Empordanet",
		"indicador_refugi": "171959|LOCAL_SOCIAL_EMPORDANET",
		"municipi": "Tallada d'Empordà, la",
		"codi_municipi": "171959",
		"latitud": "42.08287526",
		"longitud": "3.05850142",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Figueres, s/n",
		"tipologia": "Sala polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-grap.t38d_xywu",
		":version": "rv-x97b_e2ud-6i6z",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal De La Tallada D'empordà",
		"indicador_refugi": "171959|PISCINA_MUNICIPAL_DE_LA_TALLADA_D_EMPORDA",
		"municipi": "Tallada d'Empordà, la",
		"codi_municipi": "171959",
		"latitud": "42.08324257",
		"longitud": "3.05903465",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Ctra. Figueres, s/n",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-gzrh~8inx~csf8",
		":version": "rv-9d82.z92z~yvb4",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Espai Canet",
		"indicador_refugi": "171959|ESPAI_CANET",
		"municipi": "Tallada d'Empordà, la",
		"codi_municipi": "171959",
		"latitud": "42.05258455",
		"longitud": "3.0656274",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Ctra. de l'espai Canet, 1",
		"tipologia": "Sala polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-3kgx.e8ph~knwq",
		":version": "rv-4jau_fq8m-3cf8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "La Pèrgola De Marenyà",
		"indicador_refugi": "171959|LA_PERGOLA_DE_MARENYA",
		"municipi": "Tallada d'Empordà, la",
		"codi_municipi": "171959",
		"latitud": "42.09059059",
		"longitud": "3.04822147",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. President Macià, Marenyà",
		"tipologia": "Sala polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-ejbf.ddse~pjqj",
		":version": "rv-uggt~9hrc_yure",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de Tor",
		"indicador_refugi": "171959|CASAL_DE_TOR",
		"municipi": "Tallada d'Empordà, la",
		"codi_municipi": "171959",
		"latitud": "42.08888378",
		"longitud": "3.06698958",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. del Corriol, 8",
		"tipologia": "Sala polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-kysh_i2fb-ukt8",
		":version": "rv-3mc5.de5b-d59y",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "La Font Gran",
		"indicador_refugi": "082785|LA_FONT_GRAN",
		"municipi": "Taradell",
		"codi_municipi": "082785",
		"latitud": "41.87721816",
		"longitud": "2.28676898",
		"accessibilitat": "No",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de la Font, s/n",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-c52r.pxyk-3hh6",
		":version": "rv-auyt-cf2r-qfks",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Antoni Pladevall i Font",
		"indicador_refugi": "082785|BIBLIOTECA_ANTONI_PLADEVALL_I_FONT",
		"municipi": "Taradell",
		"codi_municipi": "082785",
		"latitud": "41.87141523",
		"longitud": "2.28463039",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Ctra. de Balenyà, 101",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-fjv6~eysd_swry",
		":version": "rv-92su~iz3n.u84d",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "La Font del Ravató",
		"indicador_refugi": "082785|LA_FONT_DEL_RAVATO",
		"municipi": "Taradell",
		"codi_municipi": "082785",
		"latitud": "41.87996",
		"longitud": "2.29974",
		"accessibilitat": "No",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "c. Tagamanent, s/n",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-zztk_hbuz~d8y5",
		":version": "rv-sx4d-w89m-t4v2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bosc del Pujoló",
		"indicador_refugi": "082785|BOSC_DEL_PUJOLO",
		"municipi": "Taradell",
		"codi_municipi": "082785",
		"latitud": "41.8729083",
		"longitud": "2.28240046",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. Mn. Cinto Verdaguer, s/n",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-u4yu.ymjf-xj3k",
		":version": "rv-c6ai_xea7~2im2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Can Granada - Taradell Jove",
		"indicador_refugi": "082785|CAN_GRANADA_TARADELL_JOVE",
		"municipi": "Taradell",
		"codi_municipi": "082785",
		"latitud": "41.87277573",
		"longitud": "2.28596721",
		"accessibilitat": "No",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Ramon Pou, 60",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-zeun_2i72-a99k",
		":version": "rv-t49f_5hyy.u3e3",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal estiu",
		"indicador_refugi": "082785|PISCINA_MUNICIPAL_ESTIU",
		"municipi": "Taradell",
		"codi_municipi": "082785",
		"latitud": "41.87022929",
		"longitud": "2.2796028",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "No",
		"adreca": "C. Sant Jordi, s/n",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-wbq8.r2vi_5wtg",
		":version": "rv-6t8x~4j4s~axzb",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic Bonavista",
		"indicador_refugi": "431482|CENTRE_CIVIC_BONAVISTA",
		"municipi": "Tarragona",
		"codi_municipi": "431482",
		"latitud": "41.12070837",
		"longitud": "1.19370145",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Onze, 13, Bonavista, 43100 Tarragona",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-pzri.5jr8_feks",
		":version": "rv-wwnn.7wiv~7z89",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Camp de Mart",
		"indicador_refugi": "431482|CAMP_DE_MART",
		"municipi": "Tarragona",
		"codi_municipi": "431482",
		"latitud": "41.11992822",
		"longitud": "1.25514211",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. Catalunya, 43002 Tarragona",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-5gtw~4kkt.62xh",
		":version": "rv-yw9c.iedd.vu6z",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "OMAC Ponent",
		"indicador_refugi": "431482|OMAC_PONENT",
		"municipi": "Tarragona",
		"codi_municipi": "431482",
		"latitud": "41.12278168",
		"longitud": "1.21843055",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de Tortosa, 39, 43006 Tarragona",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-2vx2~6jek-q6xc",
		":version": "rv-s8nw~fitm.9sb9",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Tarragona",
		"indicador_refugi": "431482|CASAL_CIVIC_I_COMUNITARI_TARRAGONA",
		"municipi": "Tarragona",
		"codi_municipi": "431482",
		"latitud": "41.1135871",
		"longitud": "1.2411954",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. d'en Francesc Bastos, 19",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-psd3_cwm4~mg77",
		":version": "rv-dui8_9piv~h6nv",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Espai Jove KESSE",
		"indicador_refugi": "431482|ESPAI_JOVE_KESSE",
		"municipi": "Tarragona",
		"codi_municipi": "431482",
		"latitud": "41.11978362",
		"longitud": "1.24698313",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Sant Antoni Maria Claret, 12-14",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-62q2_heuh-xpgh",
		":version": "rv-cg8q_me2t~yad6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Institut municipal d'Educació (IMET)",
		"indicador_refugi": "431482|INSTITUT_MUNICIPAL_D_EDUCACIO_IMET",
		"municipi": "Tarragona",
		"codi_municipi": "431482",
		"latitud": "41.11621591",
		"longitud": "1.24195558",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Ramón y Cajal, 70, 43005 Tarragona",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-5p6x.dk8c-bgny",
		":version": "rv-3h5b-645s.7auj",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de Sant Pere i Sant Pau",
		"indicador_refugi": "431482|PARC_DE_SANT_PERE_I_SANT_PAU",
		"municipi": "Tarragona",
		"codi_municipi": "431482",
		"latitud": "41.13406753",
		"longitud": "1.25000366",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Urb. Pedrol, 13, 43007 Tarragona",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-f7un.dwpu_jn7r",
		":version": "rv-jqbq-h3q2_g6uy",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Fitolaca",
		"indicador_refugi": "431482|PARC_FITOLACA",
		"municipi": "Tarragona",
		"codi_municipi": "431482",
		"latitud": "41.1267614",
		"longitud": "1.24015564",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Josep Maria Alomà",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-n2bv_q495_jxvv",
		":version": "rv-jv5n.6hhv_iae4",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Palau municipal",
		"indicador_refugi": "431482|PALAU_MUNICIPAL",
		"municipi": "Tarragona",
		"codi_municipi": "431482",
		"latitud": "41.12470667",
		"longitud": "1.20452593",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. de la Font, 1",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-6key_9dk2_ycv8",
		":version": "rv-tcue_wb52_rbn8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic Sant Salvador",
		"indicador_refugi": "431482|CENTRE_CIVIC_SANT_SALVADOR",
		"municipi": "Tarragona",
		"codi_municipi": "431482",
		"latitud": "41.16195149",
		"longitud": "1.24349458",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. dels Pins, s/n, 43130 Sant Salvador, Tarragona",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-8efs~c6fi_ta86",
		":version": "rv-f22i-85w3~amv8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de la Reconciliació",
		"indicador_refugi": "431482|PARC_DE_LA_RECONCILIACIO",
		"municipi": "Tarragona",
		"codi_municipi": "431482",
		"latitud": "41.11609593",
		"longitud": "1.2579699",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Via Augusta, 43003 Tarragona",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-yw92-3vsn_wthw",
		":version": "rv-8k2w.r7zg~z83m",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "OMAC Centre",
		"indicador_refugi": "431482|OMAC_CENTRE",
		"municipi": "Tarragona",
		"codi_municipi": "431482",
		"latitud": "41.11694578",
		"longitud": "1.2527736",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Rbla. Nova, 59, 43003 Tarragona",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-tn6a-kh8g-x4qg",
		":version": "rv-mzuj_jh93_hjei",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de Bonavista",
		"indicador_refugi": "431482|PARC_DE_BONAVISTA",
		"municipi": "Tarragona",
		"codi_municipi": "431482",
		"latitud": "41.11507572",
		"longitud": "1.19900153",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Valencia, 227, 43006 Tarragona",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-7r4x_ak5c~9w7h",
		":version": "rv-bu9q-riny-pig9",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Rodriguez de la Fuente",
		"indicador_refugi": "431482|PARC_RODRIGUEZ_DE_LA_FUENTE",
		"municipi": "Tarragona",
		"codi_municipi": "431482",
		"latitud": "41.12132076",
		"longitud": "1.2143479",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Gran Canaria",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-k46w_pink-wx52",
		":version": "rv-xd96~q9xs-hyba",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre esportiu municipal Bonavista",
		"indicador_refugi": "431482|CENTRE_ESPORTIU_MUNICIPAL_BONAVISTA",
		"municipi": "Tarragona",
		"codi_municipi": "431482",
		"latitud": "41.12267081",
		"longitud": "1.19562433",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. W-Carretera de Reus, 2A, 43006 Tarragona",
		"tipologia": "Poliesportiu",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-axzd-dij9~kk9n",
		":version": "rv-c9bg_4hgv-7rpr",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre esportiu municipal Riu Clar",
		"indicador_refugi": "431482|CENTRE_ESPORTIU_MUNICIPAL_RIU_CLAR",
		"municipi": "Tarragona",
		"codi_municipi": "431482",
		"latitud": "41.11993024",
		"longitud": "1.22186605",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. B, 10A, 43006 Tarragona",
		"tipologia": "Poliesportiu",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-hx5c~dx73-4p4w",
		":version": "rv-qy25~txyt_auhz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de Saavedra",
		"indicador_refugi": "431482|PARC_DE_SAAVEDRA",
		"municipi": "Tarragona",
		"codi_municipi": "431482",
		"latitud": "41.11886214",
		"longitud": "1.25407955",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. Catalunya, 2C, 43002 Tarragona",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-tic2.67jk.n7s2",
		":version": "rv-ssg7.dyuu~ypvf",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de les Amèriques",
		"indicador_refugi": "431482|PARC_DE_LES_AMERIQUES",
		"municipi": "Tarragona",
		"codi_municipi": "431482",
		"latitud": "41.13699097",
		"longitud": "1.25084985",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Las Américas, 43007 Tarragona",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-ci2f~btnq.hgyd",
		":version": "rv-dynq.yp7v_9pii",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Francolí",
		"indicador_refugi": "431482|PARC_FRANCOLI",
		"municipi": "Tarragona",
		"codi_municipi": "431482",
		"latitud": "41.12530667",
		"longitud": "1.23340804",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Joan Miró, 9, 43006 Tarragona",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-b9ek.mub4_bu96",
		":version": "rv-8b3s-qf89~k26t",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre de dia del PASS",
		"indicador_refugi": "431482|CENTRE_DE_DIA_DEL_PASS",
		"municipi": "Tarragona",
		"codi_municipi": "431482",
		"latitud": "41.11121007",
		"longitud": "1.24847438",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de Misericòrdia, 14, Tarragona",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-usis~vpr8~n993",
		":version": "rv-efxq.bbuu-mdu3",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre esportiu municipal El Serrallo",
		"indicador_refugi": "431482|CENTRE_ESPORTIU_MUNICIPAL_EL_SERRALLO",
		"municipi": "Tarragona",
		"codi_municipi": "431482",
		"latitud": "41.11165752",
		"longitud": "1.24156025",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Josep Català Rufà, s/n, 43005 Tarragona",
		"tipologia": "Poliesportiu",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-dcqi_xzk7~frfe",
		":version": "rv-ah7z~jx46_vmkm",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc la Col·lectiva",
		"indicador_refugi": "431482|PARC_LA_COL_LECTIVA",
		"municipi": "Tarragona",
		"codi_municipi": "431482",
		"latitud": "41.12387164",
		"longitud": "1.2419006",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de Covadonga",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-79wg~7efr~rrk5",
		":version": "rv-jrst.kbwz~mdeh",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic Torreforta",
		"indicador_refugi": "431482|CENTRE_CIVIC_TORREFORTA",
		"municipi": "Tarragona",
		"codi_municipi": "431482",
		"latitud": "41.11724044",
		"longitud": "1.21599057",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Tarragonès, s/n, 43006 Tarragona",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-tcch-km9e.x856",
		":version": "rv-mjm4~b8q5-uyjx",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de la Ciutat - Parc Puig i Valls",
		"indicador_refugi": "431482|PARC_DE_LA_CIUTAT_PARC_PUIG_I_VALLS",
		"municipi": "Tarragona",
		"codi_municipi": "431482",
		"latitud": "41.11753369",
		"longitud": "1.24231043",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. Santiago Ramón y Cajal, 55, 43005 Tarragona",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-euhy~zd95-8n6t",
		":version": "rv-z8ip_de42-z345",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre esportiu municipal Campclar",
		"indicador_refugi": "431482|CENTRE_ESPORTIU_MUNICIPAL_CAMPCLAR",
		"municipi": "Tarragona",
		"codi_municipi": "431482",
		"latitud": "41.12095289",
		"longitud": "1.20699207",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Camí XXIII, 3, 43006 Tarragona",
		"tipologia": "Poliesportiu",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-wir9~5nfr.wn7d",
		":version": "rv-fyim.dj7g.q9km",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Tarragona - Campclar",
		"indicador_refugi": "431482|CASAL_CIVIC_I_COMUNITARI_TARRAGONA_CAMPCLAR",
		"municipi": "Tarragona",
		"codi_municipi": "431482",
		"latitud": "41.1173761",
		"longitud": "1.2019704",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. del Riu Llobregat, s/n -cantonada Riu Brugent-",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-6vnu-kjtv~2im6",
		":version": "rv-n9c6-5ce5~qut7",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic Sant Pere i Sant Pau",
		"indicador_refugi": "431482|CENTRE_CIVIC_SANT_PERE_I_SANT_PAU",
		"municipi": "Tarragona",
		"codi_municipi": "431482",
		"latitud": "41.14076165",
		"longitud": "1.24659037",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Camí Pont del Diable, s/n, 43007 Tarragona",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-57ja_zqwf-ncep",
		":version": "rv-xa84-w6qn.shxe",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de l'Amfiteatre Romà",
		"indicador_refugi": "431482|PARC_DE_L_AMFITEATRE_ROMA",
		"municipi": "Tarragona",
		"codi_municipi": "431482",
		"latitud": "41.11532474",
		"longitud": "1.25825519",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Via William J. Bryant, 2, 43003 Tarragona",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-xq9n_mce5_xdeu",
		":version": "rv-54v3~7sbm_iank",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc del Miracle",
		"indicador_refugi": "431482|PARC_DEL_MIRACLE",
		"municipi": "Tarragona",
		"codi_municipi": "431482",
		"latitud": "41.1154047",
		"longitud": "1.25836723",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pg. Maritim Rafael Casanova",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-knnx.dpez~wewy",
		":version": "rv-e2gc_yq6c~nvm8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de Sant Antoni",
		"indicador_refugi": "431482|PARC_DE_SANT_ANTONI",
		"municipi": "Tarragona",
		"codi_municipi": "431482",
		"latitud": "41.11928743",
		"longitud": "1.26051539",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pg. St. Antoni, 26, 43003 Tarragona",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-9nb6-xbsh-66f9",
		":version": "rv-v89s-vsqy.r94d",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre esportiu municipal Sant Salvador",
		"indicador_refugi": "431482|CENTRE_ESPORTIU_MUNICIPAL_SANT_SALVADOR",
		"municipi": "Tarragona",
		"codi_municipi": "431482",
		"latitud": "41.16301324",
		"longitud": "1.24368884",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Stadium, 43130 Sant Salvador, Tarragona",
		"tipologia": "Poliesportiu",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-vag7~k4ct_abaz",
		":version": "rv-dty5~drk5~382g",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca pública Germanes Güell",
		"indicador_refugi": "252173|BIBLIOTECA_PUBLICA_GERMANES_GUELL",
		"municipi": "Tàrrega",
		"codi_municipi": "252173",
		"latitud": "41.64522881",
		"longitud": "1.13855316",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Sant Antoni, 3",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-6ahx~w8xm.bnzp",
		":version": "rv-f6f2_xn7s-ispf",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscines municipals",
		"indicador_refugi": "252173|PISCINES_MUNICIPALS",
		"municipi": "Tàrrega",
		"codi_municipi": "252173",
		"latitud": "41.64507898",
		"longitud": "1.14584428",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pg. del parc esportiu",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-pv9r-c88e_myj6",
		":version": "rv-7i53_nb84~wnin",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Tàrrega",
		"indicador_refugi": "252173|CASAL_CIVIC_I_COMUNITARI_TARREGA",
		"municipi": "Tàrrega",
		"codi_municipi": "252173",
		"latitud": "41.6430826",
		"longitud": "1.1359135",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de Salvador Espriu, 9",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-tgkw-xq7m~9s2p",
		":version": "rv-r8g7-ynpg_bcav",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Ajuntament de Tàrrega",
		"indicador_refugi": "252173|AJUNTAMENT_DE_TARREGA",
		"municipi": "Tàrrega",
		"codi_municipi": "252173",
		"latitud": "41.646488810726275",
		"longitud": "1.1391902810078387",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça Major, 1",
		"informacio_web": "www.ciutadaniatarrega.cat",
		"tipologia": "Ajuntament / Equipament Administratiu",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-23T10:21:00.000"
	},
	{
		":id": "row-5py8-9a3u~d55w",
		":version": "rv-429t-x54i_w5qs",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Mas de Colom",
		"indicador_refugi": "252173|MAS_DE_COLOM",
		"municipi": "Tàrrega",
		"codi_municipi": "252173",
		"latitud": "41.66974122410236",
		"longitud": "1.1248318585380386",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer del Mas d’en Colom, 143",
		"informacio_web": "https://masdecolom.com/",
		"tipologia": "Equipament Cultural (teatre, auditori, museu)",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-23T13:31:00.000"
	},
	{
		":id": "row-reri.zy6b.2d7y",
		":version": "rv-e76t-5nqi_zdk6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Museu Comarcal de l'Urgell - Tàrrega",
		"indicador_refugi": "252173|MUSEU_COMARCAL_DE_LURGELL_-_TARREGA",
		"municipi": "Tàrrega",
		"codi_municipi": "252173",
		"latitud": "41.64597550370037",
		"longitud": "1.1391807386403696",
		"accessibilitat": "Sí",
		"aigua": "No",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Major, 11",
		"informacio_web": "https://ciutadaniatarrega.cat/",
		"tipologia": "Equipament Cultural (teatre, auditori, museu)",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-01T09:02:00.000"
	},
	{
		":id": "row-2nhh.rmk2~knpx",
		":version": "rv-7ckf-ziz6.ikym",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casa de Cultura",
		"indicador_refugi": "252173|CASA_DE_CULTURA",
		"municipi": "Tàrrega",
		"codi_municipi": "252173",
		"latitud": "41.646385981638566",
		"longitud": "1.1398164367900003",
		"accessibilitat": "No",
		"aigua": "No",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Les Piques, 1",
		"informacio_web": "https://ciutadaniatarrega.cat/",
		"tipologia": "Ajuntament / Equipament Administratiu",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-01T09:07:00.000"
	},
	{
		":id": "row-8xwu~tnjg-6ds3",
		":version": "rv-xgcn-bw44.5e4w",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Oficina d'Acció Social, Habitatge, Salut i Feminismes",
		"indicador_refugi": "252173|OFICINA_DACCIO_SOCIAL_HABITATGE_SALUT_I_FEMINISMES",
		"municipi": "Tàrrega",
		"codi_municipi": "252173",
		"latitud": "41.65276611550447",
		"longitud": "1.1387952944618847",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Sant Pelegrí, 74",
		"informacio_web": "https://ciutadaniatarrega.cat/",
		"tipologia": "Ajuntament / Equipament Administratiu",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-01T09:10:00.000"
	},
	{
		":id": "row-nwza~hccy~zwr5",
		":version": "rv-ut8a-m2na_bduy",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Local social del Talladell",
		"indicador_refugi": "252173|LOCAL_SOCIAL_DEL_TALLADELL",
		"municipi": "Tàrrega",
		"codi_municipi": "252173",
		"latitud": "41.64985039164518",
		"longitud": "1.1664185386405694",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. de Sant Pere, 5, El Talladell",
		"informacio_web": "https://ciutadaniatarrega.cat/",
		"tipologia": "Sala Polivalent",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-01T10:32:00.000"
	},
	{
		":id": "row-isvd~pt7i~tcht",
		":version": "rv-98nd.je38-e3xc",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Local social de Santa Maria de Montmagastrell",
		"indicador_refugi": "252173|LOCAL_SOCIAL_DE_SANTA_MARIA_DE_MONTMAGASTRELL",
		"municipi": "Tàrrega",
		"codi_municipi": "252173",
		"latitud": "41.72025741826607",
		"longitud": "1.1058633321887446",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Passeig de Catalunya, s/n, Santa Maria de Montmagastrell",
		"informacio_web": "https://ciutadaniatarrega.cat/",
		"tipologia": "Sala Polivalent",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-01T10:36:00.000"
	},
	{
		":id": "row-7jap-4mm2~3xtg",
		":version": "rv-8547~b7p5-ype5",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscines municipals d'Altet",
		"indicador_refugi": "252173|PISCINES_MUNICIPALS_DALTET",
		"municipi": "Tàrrega",
		"codi_municipi": "252173",
		"latitud": "41.683225287774356",
		"longitud": "1.1418483963137882",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pl. Major, s/n, Altet",
		"informacio_web": "https://ciutadaniatarrega.cat/",
		"tipologia": "Piscines descobertes",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-01T10:38:00.000"
	},
	{
		":id": "row-hgxe.w2v8_t25n",
		":version": "rv-kva6~s5xw-acyb",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscines municipals de Claravalls",
		"indicador_refugi": "252173|PISCINES_MUNICIPALS_DE_CLARAVALLS",
		"municipi": "Tàrrega",
		"codi_municipi": "252173",
		"latitud": "41.707507667936525",
		"longitud": "1.1260546277257568",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Partida nova, s/n, Claravalls",
		"informacio_web": "https://ciutadaniatarrega.cat/",
		"tipologia": "Piscines descobertes",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-01T10:40:00.000"
	},
	{
		":id": "row-iara.dg6b_zf46",
		":version": "rv-25e5~9re5~fgsv",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Local social de La Figuerosa",
		"indicador_refugi": "252173|LOCAL_SOCIAL_DE_LA_FIGUEROSA",
		"municipi": "Tàrrega",
		"codi_municipi": "252173",
		"latitud": "41.696818750236964",
		"longitud": "1.168406401348469",
		"accessibilitat": "No",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pl. de la Bassa, s/n, La Figuerosa",
		"informacio_web": "https://ciutadaniatarrega.cat/",
		"tipologia": "Sala Polivalent",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-01T10:43:00.000"
	},
	{
		":id": "row-cs8b.cudt_kbxx",
		":version": "rv-kevc_rvut~4izx",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Local social de Claravalls",
		"indicador_refugi": "252173|LOCAL_SOCIAL_DE_CLARAVALLS",
		"municipi": "Tàrrega",
		"codi_municipi": "252173",
		"latitud": "41.70404259249487",
		"longitud": "1.1258289962338872",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. de les Escoles, s/n, Claravalls",
		"informacio_web": "https://ciutadaniatarrega.cat/",
		"tipologia": "Sala Polivalent",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-01T10:46:00.000"
	},
	{
		":id": "row-jt4a-w9xb~c6u7",
		":version": "rv-uucf-cp6y_mrhx",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic",
		"indicador_refugi": "082750|CENTRE_CIVIC",
		"municipi": "Tavèrnoles",
		"codi_municipi": "082750",
		"latitud": "41.95226696",
		"longitud": "2.32604351",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Montseny, 2",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-9v3x-ywva_zjzt",
		":version": "rv-gb7k~bgns.ugwy",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "082802|PISCINA_MUNICIPAL",
		"municipi": "Tavertet",
		"codi_municipi": "082802",
		"latitud": "41.99409192",
		"longitud": "2.41578629",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Jaume Balmes, 45",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-3g4w~23xa~t75y",
		":version": "rv-dev6_4k4r~gs4b",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Pavelló Poliesportiu",
		"indicador_refugi": "252206|PAVELLO_POLIESPORTIU",
		"municipi": "Térmens",
		"codi_municipi": "252206",
		"latitud": "41.71640434",
		"longitud": "0.76159311",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pg. Pau Casals, 29",
		"tipologia": "Poliesportiu",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-bquk~ru7s.vq25",
		":version": "rv-ww4f~87gf_fhrc",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cultural Sant Joan",
		"indicador_refugi": "252206|CENTRE_CULTURAL_SANT_JOAN",
		"municipi": "Térmens",
		"codi_municipi": "252206",
		"latitud": "41.71896834",
		"longitud": "0.7588261",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Esglèsia, 1",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-q55a_ywgf_cryv",
		":version": "rv-kvzj_563y_ki8z",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Campus UPC",
		"indicador_refugi": "082798|BIBLIOTECA_CAMPUS_UPC",
		"municipi": "Terrassa",
		"codi_municipi": "082798",
		"latitud": "41.56376555",
		"longitud": "2.02151345",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Pl. del Campus, 1",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-dqx7.59am_hhmy",
		":version": "rv-ckva_md5e~jviy",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Terrassa - Casal",
		"indicador_refugi": "082798|CASAL_CIVIC_I_COMUNITARI_TERRASSA_CASAL",
		"municipi": "Terrassa",
		"codi_municipi": "082798",
		"latitud": "41.5706352",
		"longitud": "2.0022225",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de Wagner, 2",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-43mt~ea78.rrtn",
		":version": "rv-a2dt~75rz~vqgf",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de Guernika",
		"indicador_refugi": "082798|PARC_DE_GUERNIKA",
		"municipi": "Terrassa",
		"codi_municipi": "082798",
		"latitud": "41.56521507",
		"longitud": "2.04216374",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Álava - C. Burgos",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-z45b~bjji.i9eq",
		":version": "rv-wghy-zpr8_zq4y",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Districte 2",
		"indicador_refugi": "082798|BIBLIOTECA_DISTRICTE_2",
		"municipi": "Terrassa",
		"codi_municipi": "082798",
		"latitud": "41.56468638",
		"longitud": "2.02944373",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Sant Cosme, 157",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-ngcw_54in~3xu3",
		":version": "rv-4m4x_27um-8i6w",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic Avel·lí Estrenjer",
		"indicador_refugi": "082798|CENTRE_CIVIC_AVEL_LI_ESTRENJER",
		"municipi": "Terrassa",
		"codi_municipi": "082798",
		"latitud": "41.57692023",
		"longitud": "2.00628977",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. de la Cultura, 5",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-kg7z~wx2y.nwwz",
		":version": "rv-if2g-2mnx~4tj4",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça Catalunya",
		"indicador_refugi": "082798|PLACA_CATALUNYA",
		"municipi": "Terrassa",
		"codi_municipi": "082798",
		"latitud": "41.56668167",
		"longitud": "2.02562548",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. Barcelona, s/n",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-6iht~64vm~iyu8",
		":version": "rv-b7sn-fxz4.zy2i",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça Federico Garcia Lorca",
		"indicador_refugi": "082798|PLACA_FEDERICO_GARCIA_LORCA",
		"municipi": "Terrassa",
		"codi_municipi": "082798",
		"latitud": "41.57369309",
		"longitud": "2.0365246",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. de Talamanca, 35",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-pkti-y5ki~34qy",
		":version": "rv-emv2.cpp4-m2h6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Terrassa - Sant llorenç",
		"indicador_refugi": "082798|CASAL_CIVIC_I_COMUNITARI_TERRASSA_SANT_LLORENC",
		"municipi": "Terrassa",
		"codi_municipi": "082798",
		"latitud": "41.5797875",
		"longitud": "2.0263177",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Camí Font de les Canyes, 15",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-2qdv~usqg.g3jk",
		":version": "rv-56jz_8sqk_a9p5",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Equipament socioesportiu La Cogullada",
		"indicador_refugi": "082798|EQUIPAMENT_SOCIOESPORTIU_LA_COGULLADA",
		"municipi": "Terrassa",
		"codi_municipi": "082798",
		"latitud": "41.55461375",
		"longitud": "2.00243426",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. de Joaquim de Sagrera, 15",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-jyej.8ixr~zny9",
		":version": "rv-pzvr-me5j-htwq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal de Les Arenes",
		"indicador_refugi": "082798|PISCINA_MUNICIPAL_DE_LES_ARENES",
		"municipi": "Terrassa",
		"codi_municipi": "082798",
		"latitud": "41.57095518",
		"longitud": "2.03889924",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Tibidabo, 60",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-pq6g.znxt.c2er",
		":version": "rv-n48k-xn9i_z5zz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc del Nord",
		"indicador_refugi": "082798|PARC_DEL_NORD",
		"municipi": "Terrassa",
		"codi_municipi": "082798",
		"latitud": "41.57093642",
		"longitud": "2.01341854",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Parc del Nord",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-xm3d~hmr3.thcp",
		":version": "rv-h9nc~4bhs-qkcs",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça Doctor Robert i Passeig Comte d'Egara",
		"indicador_refugi": "082798|PLACA_DOCTOR_ROBERT_I_PASSEIG_COMTE_D_EGARA",
		"municipi": "Terrassa",
		"codi_municipi": "082798",
		"latitud": "41.56333652",
		"longitud": "2.0169851",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Doctor Robert",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-6w78~czhi-6xi2",
		":version": "rv-3z7z~wjfb-6wsd",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jardins de Salvador Allende",
		"indicador_refugi": "082798|JARDINS_DE_SALVADOR_ALLENDE",
		"municipi": "Terrassa",
		"codi_municipi": "082798",
		"latitud": "41.55482261",
		"longitud": "2.02725649",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Av. de Les Glòries Catalanes, 131",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-gvns.wfrk_gwy2",
		":version": "rv-7d8t-cytk~b8ga",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Terrassa - Ca n'anglada",
		"indicador_refugi": "082798|CASAL_CIVIC_I_COMUNITARI_TERRASSA_CA_N_ANGLADA",
		"municipi": "Terrassa",
		"codi_municipi": "082798",
		"latitud": "41.5646715",
		"longitud": "2.0184381",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de Sant Tomàs, 2",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-ppzf~3uen.bgsb",
		":version": "rv-2umd.gaau_xgf8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Terrassa - Can boada",
		"indicador_refugi": "082798|CASAL_CIVIC_I_COMUNITARI_TERRASSA_CAN_BOADA",
		"municipi": "Terrassa",
		"codi_municipi": "082798",
		"latitud": "41.569095",
		"longitud": "1.9807426",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de Príncep de Viana, s/n",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-9dvd.pxfm.u9mi",
		":version": "rv-4ud6.4mrx~3p47",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Serra Galliners",
		"indicador_refugi": "082798|PARC_SERRA_GALLINERS",
		"municipi": "Terrassa",
		"codi_municipi": "082798",
		"latitud": "41.53546271",
		"longitud": "2.03815162",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. de Joan Santamaria",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-jgva-2vc5-2x6s",
		":version": "rv-r6f5~38x5_z47v",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Terrassa - Can jofresa",
		"indicador_refugi": "082798|CASAL_CIVIC_I_COMUNITARI_TERRASSA_CAN_JOFRESA",
		"municipi": "Terrassa",
		"codi_municipi": "082798",
		"latitud": "41.5492624",
		"longitud": "1.9988615",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. d'Igualada, s/n",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-gqa3_pus9_fbrf",
		":version": "rv-yquf.8bcs.um54",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bosc de Vilardell",
		"indicador_refugi": "082798|BOSC_DE_VILARDELL",
		"municipi": "Terrassa",
		"codi_municipi": "082798",
		"latitud": "41.55778472",
		"longitud": "2.04015536",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Camí dels Monjos, 1",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-ux7p.tq2t.dufx",
		":version": "rv-nyqh~5akg.exke",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça Can Tusell",
		"indicador_refugi": "082798|PLACA_CAN_TUSELL",
		"municipi": "Terrassa",
		"codi_municipi": "082798",
		"latitud": "41.58192762",
		"longitud": "2.01832935",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Pl. Can Tusell",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-ejzt~4dxc_jphq",
		":version": "rv-zzi8.4hfw-btcz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de Sant Jordi",
		"indicador_refugi": "082798|PARC_DE_SANT_JORDI",
		"municipi": "Terrassa",
		"codi_municipi": "082798",
		"latitud": "41.56322507",
		"longitud": "2.00386523",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. de Josep Freixa i Argemí, 11",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-hz29~nwrw.g7fu",
		":version": "rv-ynqu~e2sc.55ei",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Districte 3",
		"indicador_refugi": "082798|BIBLIOTECA_DISTRICTE_3",
		"municipi": "Terrassa",
		"codi_municipi": "082798",
		"latitud": "41.55591253",
		"longitud": "2.02046857",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. del Germà Joaquim, 66",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-td92~yuqv_wjjv",
		":version": "rv-7fkz-tdki.8tbz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Alberg municipal",
		"indicador_refugi": "082798|ALBERG_MUNICIPAL",
		"municipi": "Terrassa",
		"codi_municipi": "082798",
		"latitud": "41.57000174",
		"longitud": "2.00744363",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pg. del Vint-i-dos de Juliol, 216",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-uhqz~wkst_9dmh",
		":version": "rv-f2vz_hu9t.y8h5",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça de Ca n'Anglada",
		"indicador_refugi": "082798|PLACA_DE_CA_N_ANGLADA",
		"municipi": "Terrassa",
		"codi_municipi": "082798",
		"latitud": "41.5640938",
		"longitud": "2.0301652",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. de Ca n'Anglada",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-4wpc_7qa9.4fv6",
		":version": "rv-u4ak~9kek.zqxp",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic Montserrat Roig",
		"indicador_refugi": "082798|CENTRE_CIVIC_MONTSERRAT_ROIG",
		"municipi": "Terrassa",
		"codi_municipi": "082798",
		"latitud": "41.56455743",
		"longitud": "2.02732144",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. de Barcelona, 180",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-9z6s-4nbt_vtzk",
		":version": "rv-yzxn_adw6_db8w",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jardí Arquitecte Coll i Bacardí",
		"indicador_refugi": "082798|JARDI_ARQUITECTE_COLL_I_BACARDI",
		"municipi": "Terrassa",
		"codi_municipi": "082798",
		"latitud": "41.55603479",
		"longitud": "1.99696134",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de Calderón de la Barca, 24",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-f947_3uir.2qws",
		":version": "rv-s7hz-gmdb.hsvt",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça Antoni Escudé",
		"indicador_refugi": "082798|PLACA_ANTONI_ESCUDE",
		"municipi": "Terrassa",
		"codi_municipi": "082798",
		"latitud": "41.58363638",
		"longitud": "2.01745029",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Pl. Antoni Escudé",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-87jf.zi3b-c4n2",
		":version": "rv-m58n.fczm_75bf",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal de La Maurina",
		"indicador_refugi": "082798|PISCINA_MUNICIPAL_DE_LA_MAURINA",
		"municipi": "Terrassa",
		"codi_municipi": "082798",
		"latitud": "41.56389808",
		"longitud": "1.9934219",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Felip II, 39",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-hr6b.yr63-vp25",
		":version": "rv-3a28-3tg3-imn6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Terrassa - les Arenes",
		"indicador_refugi": "082798|CASAL_CIVIC_I_COMUNITARI_TERRASSA_LES_ARENES",
		"municipi": "Terrassa",
		"codi_municipi": "082798",
		"latitud": "41.5728014",
		"longitud": "2.0316079",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. del Farell, 2",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-cp7u~i4vg_7bvf",
		":version": "rv-k4nq.dby4.iyp9",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal cívic Montserrat/Torre-sana/Vilardell",
		"indicador_refugi": "082798|CASAL_CIVIC_MONTSERRAT_TORRE_SANA_VILARDELL",
		"municipi": "Terrassa",
		"codi_municipi": "082798",
		"latitud": "41.56058599",
		"longitud": "2.03865606",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de Salamanca, 35",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-regm~828s_6n97",
		":version": "rv-zmi8.rxb2_wtdh",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Districte 6",
		"indicador_refugi": "082798|BIBLIOTECA_DISTRICTE_6",
		"municipi": "Terrassa",
		"codi_municipi": "082798",
		"latitud": "41.57732476",
		"longitud": "2.02586101",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Rbla. de Francesc Macià, 193",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-hxwm_kzbz.ak2h",
		":version": "rv-843z_4car-j669",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça Frederica Montseny",
		"indicador_refugi": "082798|PLACA_FREDERICA_MONTSENY",
		"municipi": "Terrassa",
		"codi_municipi": "082798",
		"latitud": "41.56379152",
		"longitud": "2.04142043",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Álaba, 3",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-v8br_f34f.mju9",
		":version": "rv-dmgf_ipzj.7iwf",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Terrassa - Can roca",
		"indicador_refugi": "082798|CASAL_CIVIC_I_COMUNITARI_TERRASSA_CAN_ROCA",
		"municipi": "Terrassa",
		"codi_municipi": "082798",
		"latitud": "41.5792874",
		"longitud": "1.9946351",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. d'Alcoi, 81",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-miij.iukk-wi36",
		":version": "rv-gayp-tfk9_hgqh",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Recepció del Teatre Alegria",
		"indicador_refugi": "082798|RECEPCIO_DEL_TEATRE_ALEGRIA",
		"municipi": "Terrassa",
		"codi_municipi": "082798",
		"latitud": "41.5641599",
		"longitud": "2.01083025",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "No",
		"adreca": "C. Gaudí, 15",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-36na_n8zq-rigt",
		":version": "rv-47se-az8g.xvcp",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Terrassa - Ca n'aurell",
		"indicador_refugi": "082798|CASAL_CIVIC_I_COMUNITARI_TERRASSA_CA_N_AURELL",
		"municipi": "Terrassa",
		"codi_municipi": "082798",
		"latitud": "41.5620194",
		"longitud": "1.9864111",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de Nicolau Talló, 191",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-ctmj~d77p.etq3",
		":version": "rv-fuut.vg5c~vhbe",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de la Cogullada",
		"indicador_refugi": "082798|PARC_DE_LA_COGULLADA",
		"municipi": "Terrassa",
		"codi_municipi": "082798",
		"latitud": "41.55155737",
		"longitud": "2.0035672",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. ďEdison, 123",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-4w93_df6q_8n5e",
		":version": "rv-npbp_pqdz~xg3p",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça Primer de Maig",
		"indicador_refugi": "082798|PLACA_PRIMER_DE_MAIG",
		"municipi": "Terrassa",
		"codi_municipi": "082798",
		"latitud": "41.57706498",
		"longitud": "2.0221358",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Pl. Primer de Maig",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-r3yq~3ad2.m3nr",
		":version": "rv-fvuz_t7hb~kkhy",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Districte 5",
		"indicador_refugi": "082798|BIBLIOTECA_DISTRICTE_5",
		"municipi": "Terrassa",
		"codi_municipi": "082798",
		"latitud": "41.57563852",
		"longitud": "2.00965867",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Jocs Olímpics, 7",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-fwtd.bcvd_qkcd",
		":version": "rv-u6ms.cy4g.h32u",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal de Sant Llorenç",
		"indicador_refugi": "082798|PISCINA_MUNICIPAL_DE_SANT_LLORENC",
		"municipi": "Terrassa",
		"codi_municipi": "082798",
		"latitud": "41.57719484",
		"longitud": "2.03061081",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Castellsapera, 7",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-9jt3-nmz7-uixw",
		":version": "rv-3cmz-dvhs_55yw",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Terrassa - Pla de bonaire",
		"indicador_refugi": "082798|CASAL_CIVIC_I_COMUNITARI_TERRASSA_PLA_DE_BONAIRE",
		"municipi": "Terrassa",
		"codi_municipi": "082798",
		"latitud": "41.582492",
		"longitud": "2.0146285",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de Sabadell, s/n",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-zdi4-g73e.mysm",
		":version": "rv-p8gv.76sq_afjs",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Nacions Unides Sud",
		"indicador_refugi": "082798|PARC_NACIONS_UNIDES_SUD",
		"municipi": "Terrassa",
		"codi_municipi": "082798",
		"latitud": "41.58192902",
		"longitud": "2.011985",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. del Parlament, 32",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-5359~4ery-k4jq",
		":version": "rv-c2rf-bp9b.bpec",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Arxiu Històric de Terrassa",
		"indicador_refugi": "082798|ARXIU_HISTORIC_DE_TERRASSA",
		"municipi": "Terrassa",
		"codi_municipi": "082798",
		"latitud": "41.55321212",
		"longitud": "2.01624408",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Baldrich, 268",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-h4x6_a9ng-7sgu",
		":version": "rv-p3dr.2m9a_xutt",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal cívic Can Boada",
		"indicador_refugi": "082798|CASAL_CIVIC_CAN_BOADA",
		"municipi": "Terrassa",
		"codi_municipi": "082798",
		"latitud": "41.56927469",
		"longitud": "2.0011234",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de Joan d'Àustria, 11",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-evgp~usg8-a3ms",
		":version": "rv-pmda_vszs_urw6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Central (BCT)",
		"indicador_refugi": "082798|BIBLIOTECA_CENTRAL_BCT",
		"municipi": "Terrassa",
		"codi_municipi": "082798",
		"latitud": "41.56909435",
		"longitud": "2.00992711",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Pg. de les lletres, 1",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-j7ww~gz3z-47uu",
		":version": "rv-ezqb_dbag_np66",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Terrassa - la Maurina",
		"indicador_refugi": "082798|CASAL_CIVIC_I_COMUNITARI_TERRASSA_LA_MAURINA",
		"municipi": "Terrassa",
		"codi_municipi": "082798",
		"latitud": "41.5641447",
		"longitud": "1.9770783",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de Núria, 175 (cant. Franc Comtat)",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-u9yf~rsyv~waas",
		":version": "rv-ga4z~au8d~snzm",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de Vallparadís",
		"indicador_refugi": "082798|PARC_DE_VALLPARADIS",
		"municipi": "Terrassa",
		"codi_municipi": "082798",
		"latitud": "41.56561426",
		"longitud": "2.01862902",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Jardí de Vallparadís",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-a3c6~4h7x_zveg",
		":version": "rv-gsdt~wbz5-zd9y",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal cívic Francisca Redondo",
		"indicador_refugi": "082798|CASAL_CIVIC_FRANCISCA_REDONDO",
		"municipi": "Terrassa",
		"codi_municipi": "082798",
		"latitud": "41.56179671",
		"longitud": "1.99420429",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. de la Maurina, 2",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-u75j_aze8~qgrb",
		":version": "rv-8kqv_cp55~q9wt",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal de Vallparadís",
		"indicador_refugi": "082798|PISCINA_MUNICIPAL_DE_VALLPARADIS",
		"municipi": "Terrassa",
		"codi_municipi": "082798",
		"latitud": "41.55792152",
		"longitud": "2.02024354",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Jdins. de Vallparadís, s/n",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-gjaq_krv8.3kyi",
		":version": "rv-k8rw_udmg_ts5b",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Districte 4",
		"indicador_refugi": "082798|BIBLIOTECA_DISTRICTE_4",
		"municipi": "Terrassa",
		"codi_municipi": "082798",
		"latitud": "41.55698761",
		"longitud": "1.99861858",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Infant Martí, 183",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-zjzb_ewxh.cj52",
		":version": "rv-dw7q.9mdh~3udz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Terrassa - Sant Pere Nord",
		"indicador_refugi": "082798|CASAL_CIVIC_I_COMUNITARI_TERRASSA_SANT_PERE_NORD",
		"municipi": "Terrassa",
		"codi_municipi": "082798",
		"latitud": "41.5774399",
		"longitud": "2.0243088",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Rbla. de Francesc Macià, 257",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-b9v7-uisv-2hze",
		":version": "rv-ck6x~kdvu.uzbk",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic Maria Aurélia Capmany",
		"indicador_refugi": "082798|CENTRE_CIVIC_MARIA_AURELIA_CAPMANY",
		"municipi": "Terrassa",
		"codi_municipi": "082798",
		"latitud": "41.55738652",
		"longitud": "1.99973642",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. ďÀngel Sallent, 55",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-53uy_9csv.zkyx",
		":version": "rv-jz8x-qkjj~8uvi",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal cívic Vapor Gran",
		"indicador_refugi": "082798|CASAL_CIVIC_VAPOR_GRAN",
		"municipi": "Terrassa",
		"codi_municipi": "082798",
		"latitud": "41.56003859",
		"longitud": "2.013629",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pg. del Vapor Gran, 39",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-cr6v.8wvk~brry",
		":version": "rv-z95e.pmhv.zi5c",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de Les Fonts",
		"indicador_refugi": "082798|PARC_DE_LES_FONTS",
		"municipi": "Terrassa",
		"codi_municipi": "082798",
		"latitud": "41.52072307",
		"longitud": "2.03538374",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Parc de Les Fonts",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-vc4x~69bg~qh2n",
		":version": "rv-uauf_h5mn-hhcz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Càmping Alberg municipal de Tivissa",
		"indicador_refugi": "431508|CAMPING_ALBERG_MUNICIPAL_DE_TIVISSA",
		"municipi": "Tivissa",
		"codi_municipi": "431508",
		"latitud": "41.04174279",
		"longitud": "0.73870651",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Foig, 3",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-knaj-mxcx_kbq8",
		":version": "rv-qw7f.gzij~vwh4",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de les Feixetes",
		"indicador_refugi": "082830|PARC_DE_LES_FEIXETES",
		"municipi": "Tona",
		"codi_municipi": "082830",
		"latitud": "41.85287973",
		"longitud": "2.22579724",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. del Castell, 36",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-gm8s-83i6-djz8",
		":version": "rv-ujtu.x4nz_6ses",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bar Can Codina",
		"indicador_refugi": "082830|BAR_CAN_CODINA",
		"municipi": "Tona",
		"codi_municipi": "082830",
		"latitud": "41.84947959",
		"longitud": "2.22772867",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "No",
		"adreca": "Ctra. de Manresa, 2",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-vz82_8esq.kki9",
		":version": "rv-8na9.t3ww.7h89",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Roqueta",
		"indicador_refugi": "082830|PARC_ROQUETA",
		"municipi": "Tona",
		"codi_municipi": "082830",
		"latitud": "41.85980209",
		"longitud": "2.22907217",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Sebastià Roqueta, s/n",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-prwq.vbkx-k6e8",
		":version": "rv-zbvj_r9eg.jcyu",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jardins de l'Espai Muriel Casals",
		"indicador_refugi": "082830|JARDINS_DE_L_ESPAI_MURIEL_CASALS",
		"municipi": "Tona",
		"codi_municipi": "082830",
		"latitud": "41.84720338",
		"longitud": "2.22199115",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Jaume Balmes, 51",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-au6e.crft.et4e",
		":version": "rv-tke9.8din.4ng6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca municipal de Tordera",
		"indicador_refugi": "082845|BIBLIOTECA_MUNICIPAL_DE_TORDERA",
		"municipi": "Tordera",
		"codi_municipi": "082845",
		"latitud": "41.69682217",
		"longitud": "2.72173744",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de Maragall, 6",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-yky9-zsa5-c3dr",
		":version": "rv-nj74_5thd.b2cg",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina Municipal",
		"indicador_refugi": "082845|PISCINA_MUNICIPAL",
		"municipi": "Tordera",
		"codi_municipi": "082845",
		"latitud": "41.704582781225525",
		"longitud": "2.720243110468618",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carretera de l'Estació 92",
		"tipologia": "Piscines descobertes",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-22T11:56:00.000"
	},
	{
		":id": "row-vj8x_58e5-qn3c",
		":version": "rv-5sn2-ev6f.r4zf",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina Municipal Mas Mora",
		"indicador_refugi": "082845|PISCINA_MUNICIPAL_MAS_MORA",
		"municipi": "Tordera",
		"codi_municipi": "082845",
		"latitud": "41.70567508955579",
		"longitud": "2.7396350816332475",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Urbanització Mas Mora",
		"tipologia": "Piscines descobertes",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-22T12:01:00.000"
	},
	{
		":id": "row-3wv2~94m2~bskm",
		":version": "rv-q4w2~juiu.b463",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "L'esplai",
		"indicador_refugi": "082845|LESPLAI",
		"municipi": "Tordera",
		"codi_municipi": "082845",
		"latitud": "41.701890884879035",
		"longitud": "2.7160305104685154",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Jardins Alcalde Sagrera S/N",
		"tipologia": "Casal de Gent Gran",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-22T12:06:00.000"
	},
	{
		":id": "row-gnj5~fijb-tncy",
		":version": "rv-nhbs-2b7w_ayis",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de Joves",
		"indicador_refugi": "082845|CASAL_DE_JOVES",
		"municipi": "Tordera",
		"codi_municipi": "082845",
		"latitud": "41.69193434906992",
		"longitud": "2.7162834816327086",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Can Pujades 9",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-22T12:10:00.000"
	},
	{
		":id": "row-dnck.9upy_xiqr",
		":version": "rv-j3b6-6ttq~erpg",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Torelló",
		"indicador_refugi": "082858|CASAL_CIVIC_I_COMUNITARI_TORELLO",
		"municipi": "Torelló",
		"codi_municipi": "082858",
		"latitud": "42.0447017",
		"longitud": "2.2592711",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de Rocaprevera, 31",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-7yug.j4r2-q6tg",
		":version": "rv-fpsz~x23s-ew4b",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre social St Joan Baptista",
		"indicador_refugi": "082861|CENTRE_SOCIAL_ST_JOAN_BAPTISTA",
		"municipi": "Torre de Claramunt, la",
		"codi_municipi": "082861",
		"latitud": "41.53412739",
		"longitud": "1.65924413",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Piscina, s/n",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-wye9_d8ur_tsrw",
		":version": "rv-jk62.whpv.8dab",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre social Pinedes Armengol",
		"indicador_refugi": "082861|CENTRE_SOCIAL_PINEDES_ARMENGOL",
		"municipi": "Torre de Claramunt, la",
		"codi_municipi": "082861",
		"latitud": "41.51613824",
		"longitud": "1.6198034",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Font de l'Armengol, s/n",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-upnt_mem2~dqxz",
		":version": "rv-myuj.x2em~dcep",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "El Cafè de La Torre",
		"indicador_refugi": "431515|EL_CAFE_DE_LA_TORRE",
		"municipi": "Torre de Fontaubella, la",
		"codi_municipi": "431515",
		"latitud": "41.12465962",
		"longitud": "0.86387078",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Major, 5",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-n3x9-77ec_x8cn",
		":version": "rv-3iq3_kkhk.kiid",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal de la Torre de Fontaubella",
		"indicador_refugi": "431515|PISCINA_MUNICIPAL_DE_LA_TORRE_DE_FONTAUBELLA",
		"municipi": "Torre de Fontaubella, la",
		"codi_municipi": "431515",
		"latitud": "41.12434541",
		"longitud": "0.86334964",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. dels esports, s/n",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-zxjc_gcxu~nirn",
		":version": "rv-4ray-srxu.zqsh",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal social",
		"indicador_refugi": "252265|CASAL_SOCIAL",
		"municipi": "Torrebesses",
		"codi_municipi": "252265",
		"latitud": "41.42610707",
		"longitud": "0.59555573",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Planeta, 32-34",
		"tipologia": "Sala polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-cejt~9prf-6vzh",
		":version": "rv-8xwi-jqgh-5pkv",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça del microclima",
		"indicador_refugi": "252265|PLACA_DEL_MICROCLIMA",
		"municipi": "Torrebesses",
		"codi_municipi": "252265",
		"latitud": "41.42663824598549",
		"longitud": "0.5949003286308375",
		"accessibilitat": "Sí",
		"aigua": "No",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "a la intersecció dels carrers Toll i Mestre Emili Pujol",
		"informacio_web": "Obert els 365 dies de l'any",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-04T14:32:00.000"
	},
	{
		":id": "row-inpd~2nad-6fid",
		":version": "rv-d62t~aeie.bah7",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "LLAR DE JUBILATS",
		"indicador_refugi": "252304|LLAR_DE_JUBILATS",
		"municipi": "Torregrossa",
		"codi_municipi": "252304",
		"latitud": "41.57984",
		"longitud": "0.83146",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C/Sant Roc",
		"informacio_web": "www.torregrossa.cat",
		"tipologia": "Casal de Gent Gran",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-01T13:49:00.000"
	},
	{
		":id": "row-sa28_5xg8_jhem",
		":version": "rv-5qyn-dvga_my57",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Barbacoes",
		"indicador_refugi": "252304|BARBACOES",
		"municipi": "Torregrossa",
		"codi_municipi": "252304",
		"latitud": "41.5574",
		"longitud": "0.83531",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Camí Les Borges",
		"informacio_web": "www.torregrossa.cat",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-01T13:51:00.000"
	},
	{
		":id": "row-kwjz-ktjp-tw63",
		":version": "rv-yq83-j5ej-7bs6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic",
		"indicador_refugi": "252311|CENTRE_CIVIC",
		"municipi": "Torrelameu",
		"codi_municipi": "252311",
		"latitud": "41.70444964",
		"longitud": "0.70355115",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. de Balaguer, 5, 25138 Torrelameu, Lleida",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-ni2i-tyus-hu5y",
		":version": "rv-eehy_wbzn_mnnb",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre de dia",
		"indicador_refugi": "082877|CENTRE_DE_DIA",
		"municipi": "Torrelavit",
		"codi_municipi": "082877",
		"latitud": "41.44320345",
		"longitud": "1.7304173",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de M. Segimon Tomeu, 29, 08775 Torrelavit, Barcelona",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-7mb2.5yfr-kciu",
		":version": "rv-msch~v5cm_nhjz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "082877|PISCINA_MUNICIPAL",
		"municipi": "Torrelavit",
		"codi_municipi": "082877",
		"latitud": "41.44873835",
		"longitud": "1.72956455",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de les Escoles, 3, 08775 Torrelavit, Barcelona",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-bukn~23cn~bqwn",
		":version": "rv-sd79.n5wz_f8gs",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal cultura",
		"indicador_refugi": "082877|CASAL_CULTURA",
		"municipi": "Torrelavit",
		"codi_municipi": "082877",
		"latitud": "41.44643573",
		"longitud": "1.72987382",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. del Molí, 29, 08775 Torrelavit, Barcelona",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-aw6k.cy5x.zsf3",
		":version": "rv-6k9e~paeu-2ig6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre de serveis per a la gent gran",
		"indicador_refugi": "082877|CENTRE_DE_SERVEIS_PER_A_LA_GENT_GRAN",
		"municipi": "Torrelavit",
		"codi_municipi": "082877",
		"latitud": "41.44293833709089",
		"longitud": "1.7304397992481295",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Mossèn Segimon Tomeu, 29",
		"informacio_web": "De dilluns a divendres de 9 a 14hores",
		"tipologia": "Casal de Gent Gran",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-19T14:03:00.000"
	},
	{
		":id": "row-wwfh~44y3_v4v9",
		":version": "rv-64r5~f6ue~utdz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de Cultura",
		"indicador_refugi": "082877|CASAL_DE_CULTURA",
		"municipi": "Torrelavit",
		"codi_municipi": "082877",
		"latitud": "41.44657367294525",
		"longitud": "1.7295062910287329",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Molí, 29",
		"informacio_web": "Matins de 9 a 14hores",
		"tipologia": "Centre Cívic",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-19T14:07:00.000"
	},
	{
		":id": "row-qaby.insa_gerw",
		":version": "rv-yq3h-ya9x_d6bv",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Sala de plens Ajuntament de Torrent",
		"indicador_refugi": "171978|SALA_DE_PLENS_AJUNTAMENT_DE_TORRENT",
		"municipi": "Torrent",
		"codi_municipi": "171978",
		"latitud": "41.95197275",
		"longitud": "3.12813517",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Ajuntament, 1",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-tufq~huxf~dj9m",
		":version": "rv-it3d~d3xc_tzx2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Emd",
		"indicador_refugi": "171997|EMD",
		"municipi": "Torroella de Montgrí",
		"codi_municipi": "171997",
		"latitud": "42.05489127",
		"longitud": "3.20142155",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. del Port, 25, 17258 L'Estartit, Girona",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-9cp8.zbsk~rkdw",
		":version": "rv-cs7i-u3tc-xzf2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Museu de la Mediterrània",
		"indicador_refugi": "171997|MUSEU_DE_LA_MEDITERRANIA",
		"municipi": "Torroella de Montgrí",
		"codi_municipi": "171997",
		"latitud": "42.04151932",
		"longitud": "3.12463842",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. d'Ullà, 31, 17257 Torroella de Montgrí, Girona",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-qr2k~whqk-pa2p",
		":version": "rv-gvwz-edhr~wtu3",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Mar de Llibres",
		"indicador_refugi": "171997|BIBLIOTECA_MAR_DE_LLIBRES",
		"municipi": "Torroella de Montgrí",
		"codi_municipi": "171997",
		"latitud": "42.05299038",
		"longitud": "3.19647026",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de Guillem de Montgrí, 31, 17258 L'Estartit, Girona",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-j7p3.ncrs~qkvx",
		":version": "rv-5yp3~uhqh~p8w2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Pere Blasi",
		"indicador_refugi": "171997|BIBLIOTECA_PERE_BLASI",
		"municipi": "Torroella de Montgrí",
		"codi_municipi": "171997",
		"latitud": "42.04072163",
		"longitud": "3.12453147",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de la Porta Nova, 54, 17257 Torroella de Montgrí, Girona",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-jrfm_pkm6_8wmv",
		":version": "rv-hb3v.km5v-aih3",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CASAL DE GENT GRAN \"PONT DE LLIERCA\"",
		"indicador_refugi": "172001|CASAL_DE_GENT_GRAN_\"PONT_DE_LLIERCA\"",
		"municipi": "Tortellà",
		"codi_municipi": "172001",
		"latitud": "42.232966",
		"longitud": "2.629824",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "No",
		"adreca": "PLAÇA MERCAT, 22 TORTELLÀ",
		"tipologia": "Casal de Gent Gran",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-23T07:48:00.000"
	},
	{
		":id": "row-kr9f~6986-fuei",
		":version": "rv-wcfd~6kft.qshw",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "PISCINA MUNICIPAL",
		"indicador_refugi": "172001|PISCINA_MUNICIPAL",
		"municipi": "Tortellà",
		"codi_municipi": "172001",
		"latitud": "42.227616",
		"longitud": "2.634454",
		"accessibilitat": "No",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "No",
		"lavabo": "No",
		"adreca": "CTRA. ARGELAGUER, S/N  - TORTELLÀ",
		"tipologia": "Piscines descobertes",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-23T07:50:00.000"
	},
	{
		":id": "row-89xc_8iab_ck8w",
		":version": "rv-wqam-84px~8y2g",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Tortosa",
		"indicador_refugi": "431554|CASAL_CIVIC_I_COMUNITARI_TORTOSA",
		"municipi": "Tortosa",
		"codi_municipi": "431554",
		"latitud": "40.81469398",
		"longitud": "0.51671331",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Alfara de Carles, 27-33",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-wwgf~9pc9_5i57",
		":version": "rv-h8mm~kqyp-b85g",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Ajuntament de Tortosa",
		"indicador_refugi": "431554|AJUNTAMENT_DE_TORTOSA",
		"municipi": "Tortosa",
		"codi_municipi": "431554",
		"latitud": "40.81109518",
		"longitud": "0.52079188",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Espanya, s/n",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-p8kv~3vxy.kfzx",
		":version": "rv-pzhi~cx3h~pkbd",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Complex esportiu Win",
		"indicador_refugi": "431554|COMPLEX_ESPORTIU_WIN",
		"municipi": "Tortosa",
		"codi_municipi": "431554",
		"latitud": "40.81376625",
		"longitud": "0.51492685",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. 1 d'octubre, 14-15",
		"tipologia": "Poliesportiu",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-2i4a_5pki-xrcz",
		":version": "rv-23us-cym2.4ynz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Marcel·lí Domingo",
		"indicador_refugi": "431554|BIBLIOTECA_MARCEL_LI_DOMINGO",
		"municipi": "Tortosa",
		"codi_municipi": "431554",
		"latitud": "40.81391187",
		"longitud": "0.52326344",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. de la Mercè, 6",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-8saj.uxqn-kjxe",
		":version": "rv-82pk_me2i.fzdy",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Tremp",
		"indicador_refugi": "252347|CASAL_CIVIC_I_COMUNITARI_TREMP",
		"municipi": "Tremp",
		"codi_municipi": "252347",
		"latitud": "42.1624336",
		"longitud": "0.893825",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Parc del Pinell, s/n (C. F)",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-b7ks~bx3r.754b",
		":version": "rv-ra8p-h6xi.mjzs",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca pública Maria Barbal",
		"indicador_refugi": "252347|BIBLIOTECA_PUBLICA_MARIA_BARBAL",
		"municipi": "Tremp",
		"codi_municipi": "252347",
		"latitud": "42.16528446",
		"longitud": "0.89254613",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. de Catalunya, 6, 25620 Tremp, Lleida",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-mn78.358n.s9mi",
		":version": "rv-qnuy-n8za-367v",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal de Tremp",
		"indicador_refugi": "252347|PISCINA_MUNICIPAL_DE_TREMP",
		"municipi": "Tremp",
		"codi_municipi": "252347",
		"latitud": "42.1621613",
		"longitud": "0.89825412",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. D, 25620 Tremp, Lleida (PARC DEL PINELL)",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-anji.jkbq_zft7",
		":version": "rv-f7nq-gmsq~ccw9",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Planta Baixa de l'Ajuntament de Tremp",
		"indicador_refugi": "252347|PLANTA_BAIXA_DE_LAJUNTAMENT_DE_TREMP",
		"municipi": "Tremp",
		"codi_municipi": "252347",
		"latitud": "42.167190629367155",
		"longitud": "0.8959889418835005",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "25620",
		"informacio_web": "https://www.ajuntamentdetremp.cat",
		"tipologia": "Ajuntament / Equipament Administratiu",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-09T13:25:00.000"
	},
	{
		":id": "row-2b3c-pch3-2r4u",
		":version": "rv-gjnj.5t93.epbh",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic",
		"indicador_refugi": "172044|CENTRE_CIVIC",
		"municipi": "Ullà",
		"codi_municipi": "172044",
		"latitud": "42.04805685",
		"longitud": "3.11329879",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Dalt, 24",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-gyr9.ihqe_6e39",
		":version": "rv-d6f8_6r7a-us9u",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CASAL CULTURAL D'ULLASTRELL",
		"indicador_refugi": "082900|CASAL_CULTURAL_DULLASTRELL",
		"municipi": "Ullastrell",
		"codi_municipi": "082900",
		"latitud": "41.527306",
		"longitud": "1.957983",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "CARRER JOSEP FORNELL S/N",
		"informacio_web": "https://www.ullastrell.cat/el-municipi/guia-del-municipi/equipaments/casal-cultural.html",
		"tipologia": "Centre Cívic",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-04T08:37:00.000"
	},
	{
		":id": "row-2nwy~mf58-2mft",
		":version": "rv-bmyi_nry7-8cg6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "PISTA POLIESPORTIVA CASAL",
		"indicador_refugi": "082900|PISTA_POLIESPORTIVA_CASAL",
		"municipi": "Ullastrell",
		"codi_municipi": "082900",
		"latitud": "41.52684",
		"longitud": "1.957865",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "CARRER JOSEP FORNELL, S/N",
		"informacio_web": "https://www.ullastrell.cat/el-municipi/guia-del-municipi/equipaments/pista-poliesportiva.html",
		"tipologia": "Pavelló Esportiu",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-04T08:45:00.000"
	},
	{
		":id": "row-6etc_guet-8d8h",
		":version": "rv-5vr6.td8j~zuz2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic",
		"indicador_refugi": "431573|CENTRE_CIVIC",
		"municipi": "Ulldemolins",
		"codi_municipi": "431573",
		"latitud": "41.32147278",
		"longitud": "0.87631266",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de la Saltadora, 26, 43363 Ulldemolins, Tarragona",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-j9xu-b2rx~epvb",
		":version": "rv-jvbw_vzth.nc3p",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "431573|PISCINA_MUNICIPAL",
		"municipi": "Ulldemolins",
		"codi_municipi": "431573",
		"latitud": "41.31945671",
		"longitud": "0.87960898",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. Duc de Cardona, 13, 43363 Ulldemolins, Tarragona",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-58je_mubx_fymr",
		":version": "rv-e7de.n845_z44k",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívc",
		"indicador_refugi": "172039|CENTRE_CIVC",
		"municipi": "Ultramort",
		"codi_municipi": "172039",
		"latitud": "42.03767904",
		"longitud": "3.03604433",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Torroella, s/n",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-dnbk.gny7~5unx",
		":version": "rv-5qk3.d27j_d6bj",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscines municipals de Barruera",
		"indicador_refugi": "250432|PISCINES_MUNICIPALS_DE_BARRUERA",
		"municipi": "Vall de Boí, la",
		"codi_municipi": "250432",
		"latitud": "42.502863",
		"longitud": "0.797085",
		"accessibilitat": "No",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Del Eiu",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-3giz.axtk.b2am",
		":version": "rv-azui~ujbm-gkpc",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "252385|PISCINA_MUNICIPAL",
		"municipi": "Vallbona de les Monges",
		"codi_municipi": "252385",
		"latitud": "41.53906854",
		"longitud": "1.08800114",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pg. Montesquiu, 25268 Vallbona de les Monges, Lleida",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-8drk~s93j-jfit",
		":version": "rv-8mq5~j4u2.cyay",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "PISCINES MUNICIPALS",
		"indicador_refugi": "252402|PISCINES_MUNICIPALS",
		"municipi": "Vallfogona de Balaguer",
		"codi_municipi": "252402",
		"latitud": "41.75279562512019",
		"longitud": "0.8212564157118267",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C/ BELLCAIRE, 39",
		"tipologia": "Piscines descobertes",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-09T13:18:00.000"
	},
	{
		":id": "row-jf2p-dtdd~xbhf",
		":version": "rv-343c-wr29~z22h",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "AJUNTAMENT",
		"indicador_refugi": "252402|AJUNTAMENT",
		"municipi": "Vallfogona de Balaguer",
		"codi_municipi": "252402",
		"latitud": "41.75232305328587",
		"longitud": "0.8156953384283077",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C/ MAJOR, 29",
		"informacio_web": "9:00 a 14:00",
		"tipologia": "Ajuntament / Equipament Administratiu",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-09T13:20:00.000"
	},
	{
		":id": "row-xhs6~zbvp_9mfc",
		":version": "rv-avt3~qrtk.ez26",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "PLAÇA SANT MIQUEL",
		"indicador_refugi": "252402|PLACA_SANT_MIQUEL",
		"municipi": "Vallfogona de Balaguer",
		"codi_municipi": "252402",
		"latitud": "41.75251306111933",
		"longitud": "0.8136330752860261",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "PLAÇA SANT MIQUEL",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-09T13:37:00.000"
	},
	{
		":id": "row-8mzh_4zn3~jf99",
		":version": "rv-4xqh_8bky~c4nc",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CENTRE CÍVIC",
		"indicador_refugi": "252402|CENTRE_CIVIC",
		"municipi": "Vallfogona de Balaguer",
		"codi_municipi": "252402",
		"latitud": "41.75102531748975",
		"longitud": "0.8170734539566508",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "CENTRE CÍVIC",
		"tipologia": "Centre Cívic",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-09T13:41:00.000"
	},
	{
		":id": "row-yc56.t52a_77u4",
		":version": "rv-6ku5_zze4.d9e5",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "PLAÇA 16 JUTGES",
		"indicador_refugi": "252402|PLACA_16_JUTGES",
		"municipi": "Vallfogona de Balaguer",
		"codi_municipi": "252402",
		"latitud": "41.75127771833613",
		"longitud": "0.8170621766563133",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "PLAÇA 16 JUTGES",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-09T13:42:00.000"
	},
	{
		":id": "row-frk9_rbpq~sqby",
		":version": "rv-q3y3_q546.5jqp",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "PLAÇA DEL ROSER",
		"indicador_refugi": "252402|PLACA_DEL_ROSER",
		"municipi": "Vallfogona de Balaguer",
		"codi_municipi": "252402",
		"latitud": "41.752242005719715",
		"longitud": "0.8182088587913268",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "PLAÇA DEL ROSER",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-09T13:44:00.000"
	},
	{
		":id": "row-p32g_my4i~d4ye",
		":version": "rv-xa5x~bbiz.rpnq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "PLAÇA JOAN FÀBREGAS",
		"indicador_refugi": "252402|PLACA_JOAN_FABREGAS",
		"municipi": "Vallfogona de Balaguer",
		"codi_municipi": "252402",
		"latitud": "41.752489954007416",
		"longitud": "0.8210564347692064",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "PLAÇA JOAN FÀBREGAS",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-09T13:45:00.000"
	},
	{
		":id": "row-8cpy_griv.s4ba",
		":version": "rv-b9zu-2795~uyd9",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "PLAÇA DEL TAPIADOR",
		"indicador_refugi": "252402|PLACA_DEL_TAPIADOR",
		"municipi": "Vallfogona de Balaguer",
		"codi_municipi": "252402",
		"latitud": "41.75026176009146",
		"longitud": "0.8065020188647934",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "PLAÇA DEL TAPIADOR",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-09T13:47:00.000"
	},
	{
		":id": "row-8xen-yknt_rxkm",
		":version": "rv-zc9c-fv8f-3g6w",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "PLAÇA SANTA MARGARIDA",
		"indicador_refugi": "252402|PLACA_SANTA_MARGARIDA",
		"municipi": "Vallfogona de Balaguer",
		"codi_municipi": "252402",
		"latitud": "41.783304698462516",
		"longitud": "0.8442689548954665",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "PLAÇA SANTA MARGARIDA - LA RÀPITA",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-09T13:49:00.000"
	},
	{
		":id": "row-y2k4~cvwn~3j9e",
		":version": "rv-3dku.vkz4.cs3a",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "PLAÇA LA LLÀGRIMA",
		"indicador_refugi": "252402|PLACA_LA_LLAGRIMA",
		"municipi": "Vallfogona de Balaguer",
		"codi_municipi": "252402",
		"latitud": "41.793306577579585",
		"longitud": "0.8234046921580322",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "CARRER ALMATÀ - HOSTAL NOU I LA CODOSA",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-09T13:51:00.000"
	},
	{
		":id": "row-8a89~2baa.9krd",
		":version": "rv-arsj_8966~pna3",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "PLAÇA DE LA CODOSA",
		"indicador_refugi": "252402|PLACA_DE_LA_CODOSA",
		"municipi": "Vallfogona de Balaguer",
		"codi_municipi": "252402",
		"latitud": "41.79236289938432",
		"longitud": "0.8225998669968663",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "PLAÇA DE LA CODOSA - HOSTAL NOU I LA CODOSA",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-09T13:54:00.000"
	},
	{
		":id": "row-be9m_4hkz_jcin",
		":version": "rv-fdrm-xqyn~q54s",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "PLAÇA SANT JOAN",
		"indicador_refugi": "252402|PLACA_SANT_JOAN",
		"municipi": "Vallfogona de Balaguer",
		"codi_municipi": "252402",
		"latitud": "41.78693333255807",
		"longitud": "0.8217184166850545",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "HOSTAL NOU I LA CODOSA",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-09T13:58:00.000"
	},
	{
		":id": "row-8e5d.ra5v-ffk5",
		":version": "rv-7cqc~qebb-c9x4",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina pública municipal",
		"indicador_refugi": "431592|PISCINA_PUBLICA_MUNICIPAL",
		"municipi": "Vallfogona de Riucorb",
		"codi_municipi": "431592",
		"latitud": "41.56427737",
		"longitud": "1.23772201",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Johan Cruyff",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-2s3s.ndy2-ysy2",
		":version": "rv-fisy~tgmy_b79g",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Sala polivalent",
		"indicador_refugi": "082943|SALA_POLIVALENT",
		"municipi": "Vallgorguina",
		"codi_municipi": "082943",
		"latitud": "41.64801476",
		"longitud": "2.51005898",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Església, 13",
		"tipologia": "Sala polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-t55t_3jft-pmyf",
		":version": "rv-vdzx.m5k6-h6m8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Local Associació propietaris Baronia del Montseny",
		"indicador_refugi": "082943|LOCAL_ASSOCIACIO_PROPIETARIS_BARONIA_DEL_MONTSENY",
		"municipi": "Vallgorguina",
		"codi_municipi": "082943",
		"latitud": "41.66212423",
		"longitud": "2.46579985",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Av. del Montseny, 0",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-3avt_vh3p-6nu3",
		":version": "rv-c7pi_3f64~mp5a",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Ajuntament de Vallirana",
		"indicador_refugi": "082956|AJUNTAMENT_DE_VALLIRANA",
		"municipi": "Vallirana",
		"codi_municipi": "082956",
		"latitud": "41.38811122",
		"longitud": "1.93203515",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Major 329, Vallirana, Barcelona",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-qmcv~nbbc-eqpd",
		":version": "rv-if9b_kz82~7m6h",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Espai central de Joves",
		"indicador_refugi": "082956|ESPAI_CENTRAL_DE_JOVES",
		"municipi": "Vallirana",
		"codi_municipi": "082956",
		"latitud": "41.38694871",
		"longitud": "1.93269379",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. Parellada, 6-8",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-wurw.e9in~weh5",
		":version": "rv-bksm~m4vm.vyeb",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal joves Vallirana",
		"indicador_refugi": "082956|CASAL_JOVES_VALLIRANA",
		"municipi": "Vallirana",
		"codi_municipi": "082956",
		"latitud": "41.38263877",
		"longitud": "1.92605336",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Major, 616, 08759 Vallirana, Barcelona",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-spsh-ij4v-wewg",
		":version": "rv-35ch.debf.kmmz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bilbioteca Josep Maria López Picó",
		"indicador_refugi": "082956|BILBIOTECA_JOSEP_MARIA_LOPEZ_PICO",
		"municipi": "Vallirana",
		"codi_municipi": "082956",
		"latitud": "41.3899774",
		"longitud": "1.93461898",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Ptge. Bon Retir, 6, 08759 Vallirana, Barcelona",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-4zks.mh82~6snq",
		":version": "rv-ptd8_ha47_qjmd",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Pavelló municipal Vallirana",
		"indicador_refugi": "082956|PAVELLO_MUNICIPAL_VALLIRANA",
		"municipi": "Vallirana",
		"codi_municipi": "082956",
		"latitud": "41.38172152",
		"longitud": "1.92930527",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de l'Església, 30, 08759 Vallirana, Barcelona",
		"tipologia": "Poliesportiu",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-c6re~n8xk_f89q",
		":version": "rv-db5b.wae6-tdwe",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Vallirana",
		"indicador_refugi": "082956|CASAL_CIVIC_I_COMUNITARI_VALLIRANA",
		"municipi": "Vallirana",
		"codi_municipi": "082956",
		"latitud": "41.3855442",
		"longitud": "1.9304982",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. de l'Esport, s/n",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-ky4k_kdvs.r5s9",
		":version": "rv-xp8y_vnik-4a64",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casa Mestre",
		"indicador_refugi": "082956|CASA_MESTRE",
		"municipi": "Vallirana",
		"codi_municipi": "082956",
		"latitud": "41.39029606",
		"longitud": "1.9370293",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Major, 178, 08759 Vallirana - Barcelona",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-t79v_75as.v9iu",
		":version": "rv-63pk~6q4w_kata",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Masia Molí de Can Batlle",
		"indicador_refugi": "082956|MASIA_MOLI_DE_CAN_BATLLE",
		"municipi": "Vallirana",
		"codi_municipi": "082956",
		"latitud": "41.38410941",
		"longitud": "1.93265865",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Molí, 2, 08759 Vallirana, Barcelona",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-hdwd_ec6w-zhqi",
		":version": "rv-igh3~3yaf_ic3c",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Local social",
		"indicador_refugi": "172095|LOCAL_SOCIAL",
		"municipi": "Vall-llobrega",
		"codi_municipi": "172095",
		"latitud": "41.880751",
		"longitud": "3.12595799",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Rbla. de l'Esglèsia",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-sx2s_cg9b~9ytk",
		":version": "rv-ht8x_8jn3_aw75",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Font transitable Països Catalans",
		"indicador_refugi": "172095|FONT_TRANSITABLE_PAISOS_CATALANS",
		"municipi": "Vall-llobrega",
		"codi_municipi": "172095",
		"latitud": "41.879374",
		"longitud": "3.126593",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Raval de Mar amb C. Joaquim Ruyra",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-j4a6-5q92_vx2n",
		":version": "rv-vcji_5xr2~dvef",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "431606|PISCINA_MUNICIPAL",
		"municipi": "Vallmoll",
		"codi_municipi": "431606",
		"latitud": "41.24681982",
		"longitud": "1.24655856",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Joan Manel Serrat, s/n",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-ps7k.dmqq-6bm7",
		":version": "rv-ws7a-5z26-ksga",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Tirant lo Balnc",
		"indicador_refugi": "431606|BIBLIOTECA_TIRANT_LO_BALNC",
		"municipi": "Vallmoll",
		"codi_municipi": "431606",
		"latitud": "41.24366631",
		"longitud": "1.2489779",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Unió, 30",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-fjzc-wh6z_n43r",
		":version": "rv-p89p~kydd-i4qd",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cultural",
		"indicador_refugi": "431606|CENTRE_CULTURAL",
		"municipi": "Vallmoll",
		"codi_municipi": "431606",
		"latitud": "41.24180312",
		"longitud": "1.25003122",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Ctra. de la Masó, s/n",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-98k2_uj7b.56wv",
		":version": "rv-64mj_txke~dpvz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça del Quarter",
		"indicador_refugi": "431613|PLACA_DEL_QUARTER",
		"municipi": "Valls",
		"codi_municipi": "431613",
		"latitud": "41.28675851",
		"longitud": "1.2527454",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. del Quarter",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-ecef_r2na~hgez",
		":version": "rv-j3kg-cr9f-75gp",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Barrau",
		"indicador_refugi": "431613|PARC_BARRAU",
		"municipi": "Valls",
		"codi_municipi": "431613",
		"latitud": "41.28917615",
		"longitud": "1.25705824",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Francesc Macià",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-in7m_u6yq-rq33",
		":version": "rv-7ifq-ep99.nqpt",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Vestíbul de l'Ajuntament de Valls",
		"indicador_refugi": "431613|VESTIBUL_DE_L_AJUNTAMENT_DE_VALLS",
		"municipi": "Valls",
		"codi_municipi": "431613",
		"latitud": "41.28431552",
		"longitud": "1.2477455",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. del Blat, 1",
		"tipologia": "Sala polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-5q8p.wixd.xgs5",
		":version": "rv-ajvd_mt93~3jt8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça de les Escudelles",
		"indicador_refugi": "431613|PLACA_DE_LES_ESCUDELLES",
		"municipi": "Valls",
		"codi_municipi": "431613",
		"latitud": "41.28336198",
		"longitud": "1.24878648",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. de les Escudelles",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-figa-988s~7wrc",
		":version": "rv-yww3-9wh8.nuar",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Oficina d'Informació i Turisme",
		"indicador_refugi": "431613|OFICINA_D_INFORMACIO_I_TURISME",
		"municipi": "Valls",
		"codi_municipi": "431613",
		"latitud": "41.28440133",
		"longitud": "1.24801467",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de la Cort, 3",
		"tipologia": "Sala polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-25fi-sagw-4ya2",
		":version": "rv-rp7c-fr6t_p7vj",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Pavelló Xavi Tondo",
		"indicador_refugi": "431613|PAVELLO_XAVI_TONDO",
		"municipi": "Valls",
		"codi_municipi": "431613",
		"latitud": "41.29550254",
		"longitud": "1.259988",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pg. President Tarradellas, 2-6",
		"tipologia": "Poliesportiu",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-rij4~krdf_a4dw",
		":version": "rv-y6qs.ky6u.9y3b",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Passeig dels Caputxins",
		"indicador_refugi": "431613|PASSEIG_DELS_CAPUTXINS",
		"municipi": "Valls",
		"codi_municipi": "431613",
		"latitud": "41.28760134",
		"longitud": "1.25161472",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pg. dels Caputxins",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-qg65~5stu.isj9",
		":version": "rv-jamj-hcmz~tukt",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça passeig Clariana",
		"indicador_refugi": "431613|PLACA_PASSEIG_CLARIANA",
		"municipi": "Valls",
		"codi_municipi": "431613",
		"latitud": "41.27989109",
		"longitud": "1.23900104",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pg. Clariana",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-zjr5_8spm-tsjh",
		":version": "rv-cuti~48vf~dkh7",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic Les Comarques",
		"indicador_refugi": "431613|CENTRE_CIVIC_LES_COMARQUES",
		"municipi": "Valls",
		"codi_municipi": "431613",
		"latitud": "41.28454628",
		"longitud": "1.24195257",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de la Vall d'Aran, 1",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-jgr4_p27v-y8p3",
		":version": "rv-jzwp.axcv.rxrz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça de la Xamora",
		"indicador_refugi": "431613|PLACA_DE_LA_XAMORA",
		"municipi": "Valls",
		"codi_municipi": "431613",
		"latitud": "41.29163815",
		"longitud": "1.25204562",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. de la Xamora",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-5662.53hi~vrye",
		":version": "rv-g8rg_62dh~5qqg",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc infantil dos de vuit",
		"indicador_refugi": "431613|PARC_INFANTIL_DOS_DE_VUIT",
		"municipi": "Valls",
		"codi_municipi": "431613",
		"latitud": "41.29660368",
		"longitud": "1.25781704",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Dos de vuit",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-midx~7fjh_q3kg",
		":version": "rv-bnxp_ydbg-bz22",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc infantil de Sant Francesc",
		"indicador_refugi": "431613|PARC_INFANTIL_DE_SANT_FRANCESC",
		"municipi": "Valls",
		"codi_municipi": "431613",
		"latitud": "41.28378379",
		"longitud": "1.25176322",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Sant Francesc",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-idfn~8k97-ydxp",
		":version": "rv-m79q_ez6j.yp67",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Museu de Valls",
		"indicador_refugi": "431613|MUSEU_DE_VALLS",
		"municipi": "Valls",
		"codi_municipi": "431613",
		"latitud": "41.28884745",
		"longitud": "1.25199501",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pg. dels Caputxins, 18",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-2qn5~ne92_9chn",
		":version": "rv-4fe6~u7sy.a7sq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Passeig de l'Estació",
		"indicador_refugi": "431613|PASSEIG_DE_L_ESTACIO",
		"municipi": "Valls",
		"codi_municipi": "431613",
		"latitud": "41.28767259",
		"longitud": "1.25628094",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pg. de l'Estació",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-q5mq-pb8k_hn2c",
		":version": "rv-frrp.tqen.knvn",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Mas Miquel",
		"indicador_refugi": "431613|PARC_MAS_MIQUEL",
		"municipi": "Valls",
		"codi_municipi": "431613",
		"latitud": "41.28589316",
		"longitud": "1.25603359",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Pau Parellada",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-te8q-an37~hrt8",
		":version": "rv-pzqn-hfdf_6k38",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Zona verda carrer Onze de Setembre",
		"indicador_refugi": "431613|ZONA_VERDA_CARRER_ONZE_DE_SETEMBRE",
		"municipi": "Valls",
		"codi_municipi": "431613",
		"latitud": "41.29299977",
		"longitud": "1.24739727",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Onze de Setembre",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-2tkx.szwt.yw38",
		":version": "rv-t7yj_eqdr.4tz5",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Passeig President Companys",
		"indicador_refugi": "431613|PASSEIG_PRESIDENT_COMPANYS",
		"municipi": "Valls",
		"codi_municipi": "431613",
		"latitud": "41.29386797",
		"longitud": "1.25852588",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pg. President Companys",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-z9ju-cwxp_z892",
		":version": "rv-7e7t_kwbf_5kuq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Vallsgenera",
		"indicador_refugi": "431613|VALLSGENERA",
		"municipi": "Valls",
		"codi_municipi": "431613",
		"latitud": "41.28849451",
		"longitud": "1.25235594",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Ctra. del Pla, 37 A",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-7e64.dyh2_f4dc",
		":version": "rv-54t6-uxbc~7v2k",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça Pompeu Fabra",
		"indicador_refugi": "431613|PLACA_POMPEU_FABRA",
		"municipi": "Valls",
		"codi_municipi": "431613",
		"latitud": "41.28774159",
		"longitud": "1.24645444",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Pompeu Fabra",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-uf76-huy8.6yxw",
		":version": "rv-bvp8_py8n_5jff",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc infantil Alentorn Ballester (barri del Bon Sol)",
		"indicador_refugi": "431613|PARC_INFANTIL_ALENTORN_BALLESTER_BARRI_DEL_BON_SOL",
		"municipi": "Valls",
		"codi_municipi": "431613",
		"latitud": "41.28584576",
		"longitud": "1.26894466",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Alentorn Ballester, 7B",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-5uvq_y77b-rjzn",
		":version": "rv-wnpw-7k8d~98v2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Ca Xapes",
		"indicador_refugi": "431613|CA_XAPES",
		"municipi": "Valls",
		"codi_municipi": "431613",
		"latitud": "41.2855",
		"longitud": "1.2493",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Muralla Sant Antoni, 97",
		"informacio_web": "Juliol: de dilluns a divendres de 9 h a 13 h i de 15 h a 20 h. Dissabtes de 16 h a 21 h. Diumenges: de 17 h a 20 h",
		"tipologia": "Centre Cívic",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-05T12:05:00.000"
	},
	{
		":id": "row-tmn2~t7qe.jau4",
		":version": "rv-m2e6_5t9c.rz4m",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc infantil Vilar",
		"indicador_refugi": "431613|PARC_INFANTIL_VILAR",
		"municipi": "Valls",
		"codi_municipi": "431613",
		"latitud": "41.2872",
		"longitud": "1.2585",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça Vila Romana",
		"informacio_web": "Espai exterior",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-05T12:12:00.000"
	},
	{
		":id": "row-9r5y-dpdw-eu6k",
		":version": "rv-szga.ama7.tywt",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Carles Cardó",
		"indicador_refugi": "431613|BIBLIOTECA_CARLES_CARDO",
		"municipi": "Valls",
		"codi_municipi": "431613",
		"latitud": "41.2844",
		"longitud": "1.2495",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça Pilar Prim",
		"informacio_web": "De dilluns a dijous de 10 h a 14 h i de 16 h a 20 h. Divendres: de 10 h a 14 h",
		"tipologia": "Biblioteca",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-05T12:32:00.000"
	},
	{
		":id": "row-23zv.pajw-4h2g",
		":version": "rv-rf3w.i8py_3xy8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bar de Noves de Segre",
		"indicador_refugi": "259062|BAR_DE_NOVES_DE_SEGRE",
		"municipi": "Valls d'Aguilar, les",
		"codi_municipi": "259062",
		"latitud": "42.29411",
		"longitud": "1.3418168",
		"accessibilitat": "No",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Diputat Garriga, 3",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-dieg-aci8_v79x",
		":version": "rv-p3j4~jw4j~qvs8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina Vandellòs",
		"indicador_refugi": "431628|PISCINA_VANDELLOS",
		"municipi": "Vandellòs i l'Hospitalet de l'Infant",
		"codi_municipi": "431628",
		"latitud": "41.01841344",
		"longitud": "0.83184656",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de les Flors",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-rbzh-yzds-hyxm",
		":version": "rv-jcyv.k3xy.6nmj",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina Masboquera",
		"indicador_refugi": "431628|PISCINA_MASBOQUERA",
		"municipi": "Vandellòs i l'Hospitalet de l'Infant",
		"codi_municipi": "431628",
		"latitud": "41.01934912",
		"longitud": "0.8578454",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de Baix",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-2g34~t6m3_2wpd",
		":version": "rv-ts2c-uezj.72sa",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina Hospitalet de L'Infant",
		"indicador_refugi": "431628|PISCINA_HOSPITALET_DE_L_INFANT",
		"municipi": "Vandellòs i l'Hospitalet de l'Infant",
		"codi_municipi": "431628",
		"latitud": "40.99181398",
		"longitud": "0.91374927",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de la Porrassa, 17",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-7bjd_6m5k~vd9y",
		":version": "rv-ri8x~yazk-yy2z",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Antigues Escoles",
		"indicador_refugi": "431628|ANTIGUES_ESCOLES",
		"municipi": "Vandellòs i l'Hospitalet de l'Infant",
		"codi_municipi": "431628",
		"latitud": "41.01873748",
		"longitud": "0.85738321",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Arrabal, 2-10",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-rf4u-6ycm_vst6",
		":version": "rv-fy7x.vscb_uwxj",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Les antigues Escoles",
		"indicador_refugi": "431628|LES_ANTIGUES_ESCOLES",
		"municipi": "Vandellòs i l'Hospitalet de l'Infant",
		"codi_municipi": "431628",
		"latitud": "41.01878994",
		"longitud": "0.88660513",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Nou",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-x383-pu2g.rg4f",
		":version": "rv-55nm~tbum~vdfh",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Sala Polivalent del Pavelló Cobert Esportiu municipal",
		"indicador_refugi": "431628|SALA_POLIVALENT_DEL_PAVELLO_COBERT_ESPORTIU_MUNICIPAL",
		"municipi": "Vandellòs i l'Hospitalet de l'Infant",
		"codi_municipi": "431628",
		"latitud": "41.01821799",
		"longitud": "0.83243648",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Les flors, 34",
		"tipologia": "Poliesportiu",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-2ex8~fcqp~dssu",
		":version": "rv-kns3.5577~53qq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de jubilats de L'Hospitalet de L'Infant",
		"indicador_refugi": "431628|CASAL_DE_JUBILATS_DE_L_HOSPITALET_DE_L_INFANT",
		"municipi": "Vandellòs i l'Hospitalet de l'Infant",
		"codi_municipi": "431628",
		"latitud": "40.99305501",
		"longitud": "0.9195187",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Alamanda, 6",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-xpqd.mui8_5qza",
		":version": "rv-7bkw.8e5m.wfup",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de Joves Vandellòs",
		"indicador_refugi": "431628|CASAL_DE_JOVES_VANDELLOS",
		"municipi": "Vandellòs i l'Hospitalet de l'Infant",
		"codi_municipi": "431628",
		"latitud": "41.01825281",
		"longitud": "0.83228396",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Ptge. Cal Marino, s/n",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-aavj-jbsb.daf5",
		":version": "rv-7t57_mh7u_p8fy",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casa de Cultura Blanca d'Anjou",
		"indicador_refugi": "431628|CASA_DE_CULTURA_BLANCA_D_ANJOU",
		"municipi": "Vandellòs i l'Hospitalet de l'Infant",
		"codi_municipi": "431628",
		"latitud": "40.99292831",
		"longitud": "0.92138963",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de les Escoles, 12",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-z7hz.yp9t~pwxv",
		":version": "rv-2p9k-evju~ff6w",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bar Restaurant Casal de Jubilats de Vandellòs",
		"indicador_refugi": "431628|BAR_RESTAURANT_CASAL_DE_JUBILATS_DE_VANDELLOS",
		"municipi": "Vandellòs i l'Hospitalet de l'Infant",
		"codi_municipi": "431628",
		"latitud": "41.02088841",
		"longitud": "0.83152201",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Ctra. Hospitalet-Mora, 39",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-4rbg.6vxv~jeij",
		":version": "rv-gh9y~x77x-8wuf",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "La Pèrgola",
		"indicador_refugi": "431628|LA_PERGOLA",
		"municipi": "Vandellòs i l'Hospitalet de l'Infant",
		"codi_municipi": "431628",
		"latitud": "40.9895118814475",
		"longitud": "0.9208656610309296",
		"accessibilitat": "Sí",
		"aigua": "No",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça Coll de Balaguer",
		"informacio_web": "Web Ajuntament de Vandellòs i l'Hospitalet de l'Infant",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-02T13:23:00.000"
	},
	{
		":id": "row-62rf-ya36.6x7w",
		":version": "rv-gu6u.vbyf.582m",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parròquia de Sant Pere Apòstol",
		"indicador_refugi": "431628|PARROQUIA_DE_SANT_PERE_APOSTOL",
		"municipi": "Vandellòs i l'Hospitalet de l'Infant",
		"codi_municipi": "431628",
		"latitud": "40.99063896539079",
		"longitud": "0.9234760558985282",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça de l'església, 1",
		"informacio_web": "Web Ajuntament de Vandellòs i l'Hospitalet de l'Infant",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-02T13:40:00.000"
	},
	{
		":id": "row-i7kt_nsmi.ncrc",
		":version": "rv-9vwx_6v88~39ja",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari El Vendrell",
		"indicador_refugi": "431634|CASAL_CIVIC_I_COMUNITARI_EL_VENDRELL",
		"municipi": "Vendrell, el",
		"codi_municipi": "431634",
		"latitud": "41.2233024",
		"longitud": "1.5317749",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de l'U d'Octubre, 12-14 (antic C. del General Prim)",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-tcd2.hd96~6u8u",
		":version": "rv-3g9b~yq8k.vc8s",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca pública Terra Baixa",
		"indicador_refugi": "431634|BIBLIOTECA_PUBLICA_TERRA_BAIXA",
		"municipi": "Vendrell, el",
		"codi_municipi": "431634",
		"latitud": "41.220041868790965",
		"longitud": "1.5340931590842855",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Major, 18",
		"informacio_web": "https://www.bibliotecaelvendrell.cat/",
		"tipologia": "Biblioteca",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-30T18:15:00.000"
	},
	{
		":id": "row-xbwr-sbrn~veq2",
		":version": "rv-rzzb~dx5w.s5jd",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Cívic l'Estació",
		"indicador_refugi": "431634|CENTRE_CIVIC_LESTACIO",
		"municipi": "Vendrell, el",
		"codi_municipi": "431634",
		"latitud": "41.22127777848576",
		"longitud": "1.5377759831149023",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Avinguda d'en Jaume Carner, 1",
		"informacio_web": "http://www.elvendrell.net/centre-civic-l-estacio",
		"tipologia": "Centre Cívic",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-30T18:18:00.000"
	},
	{
		":id": "row-qcrh~u9hh~e8tn",
		":version": "rv-6htw.an35-9pmr",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casa Museu Àngel Guimerà",
		"indicador_refugi": "431634|CASA_MUSEU_ANGEL_GUIMERA",
		"municipi": "Vendrell, el",
		"codi_municipi": "431634",
		"latitud": "41.22201563589469",
		"longitud": "1.5344165874448015",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Santa Anna, 10",
		"informacio_web": "https://museus.elvendrell.net/casa-museu-angel-guimera/",
		"tipologia": "Equipament Cultural (teatre, auditori, museu)",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-30T18:21:00.000"
	},
	{
		":id": "row-aush~hvsn~5f2d",
		":version": "rv-yr24~k8kn~277m",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Museu Deu",
		"indicador_refugi": "431634|MUSEU_DEU",
		"municipi": "Vendrell, el",
		"codi_municipi": "431634",
		"latitud": "41.221565346134284",
		"longitud": "1.5343684609551744",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça Nova, 6",
		"informacio_web": "https://museus.elvendrell.net/museu-deu/",
		"tipologia": "Equipament Cultural (teatre, auditori, museu)",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-30T18:23:00.000"
	},
	{
		":id": "row-fjvy.u24g~pjgv",
		":version": "rv-ukxx_2gr9-v52p",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Tabaris, museu fires i congressos",
		"indicador_refugi": "431634|TABARIS_MUSEU_FIRES_I_CONGRESSOS",
		"municipi": "Vendrell, el",
		"codi_municipi": "431634",
		"latitud": "41.18193443603985",
		"longitud": "1.523277412126071",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Avinguda Balneari, 3",
		"informacio_web": "https://tabaris.net/",
		"tipologia": "Equipament Cultural (teatre, auditori, museu)",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-30T18:26:00.000"
	},
	{
		":id": "row-jv79.25ys-5w7z",
		":version": "rv-x3tn_iqev.8ub2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casa Nadiua Pau Casals",
		"indicador_refugi": "431634|CASA_NADIUA_PAU_CASALS",
		"municipi": "Vendrell, el",
		"codi_municipi": "431634",
		"latitud": "41.22193784903992",
		"longitud": "1.5345265686375487",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Santa Anna, 4",
		"informacio_web": "https://museus.elvendrell.net/casa-nadiua-de-pau-casals/",
		"tipologia": "Equipament Cultural (teatre, auditori, museu)",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-30T18:29:00.000"
	},
	{
		":id": "row-cvvz-q3uy_4grh",
		":version": "rv-27if~utbh~ywky",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Sala Portal del Pardo",
		"indicador_refugi": "431634|SALA_PORTAL_DEL_PARDO",
		"municipi": "Vendrell, el",
		"codi_municipi": "431634",
		"latitud": "41.22021751249056",
		"longitud": "1.5339485379546873",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Major, 20",
		"informacio_web": "https://museus.elvendrell.net/sala-portal-del-pardo/",
		"tipologia": "Equipament Cultural (teatre, auditori, museu)",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-30T18:31:00.000"
	},
	{
		":id": "row-s4qm_t93x_nuj8",
		":version": "rv-gkxp_uxzu_m3z4",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Cívic de Coma-ruga",
		"indicador_refugi": "431634|CENTRE_CIVIC_DE_COMA-RUGA",
		"municipi": "Vendrell, el",
		"codi_municipi": "431634",
		"latitud": "41.184623626059334",
		"longitud": "1.5217198977934148",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "No",
		"adreca": "Avinguda de la Generalitat, 32",
		"informacio_web": "https://www.elvendrell.net/centre-civic-coma-ruga",
		"tipologia": "Centre Cívic",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-30T18:33:00.000"
	},
	{
		":id": "row-jysv~rg3a_sjj9",
		":version": "rv-ti6d~3b3y-ppir",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Ajuntament",
		"indicador_refugi": "431634|AJUNTAMENT",
		"municipi": "Vendrell, el",
		"codi_municipi": "431634",
		"latitud": "41.220234092700416",
		"longitud": "1.5347702091193332",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça Vella, 1",
		"informacio_web": "http://www.elvendrell.net/",
		"tipologia": "Ajuntament / Equipament Administratiu",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-30T18:35:00.000"
	},
	{
		":id": "row-kqqu-iv4x_hf27",
		":version": "rv-qrmu~wvde-tdbd",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Roquetes",
		"indicador_refugi": "431634|PARC_ROQUETES",
		"municipi": "Vendrell, el",
		"codi_municipi": "431634",
		"latitud": "41.22279692471635",
		"longitud": "1.5234701702725315",
		"accessibilitat": "No",
		"aigua": "No",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer de les Roquetes, s/n",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-30T18:37:00.000"
	},
	{
		":id": "row-vvmz.5eem_kk8p",
		":version": "rv-bjfd.stz9_m2hu",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "El Puig",
		"indicador_refugi": "431634|EL_PUIG",
		"municipi": "Vendrell, el",
		"codi_municipi": "431634",
		"latitud": "41.218444328023644",
		"longitud": "1.5396730877690685",
		"accessibilitat": "Sí",
		"aigua": "No",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer de Josep Tarradellas, s/n",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-30T18:39:00.000"
	},
	{
		":id": "row-322x_msdw_ipud",
		":version": "rv-7jqs.a6a2~parr",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça de la Font",
		"indicador_refugi": "431634|PLACA_DE_LA_FONT",
		"municipi": "Vendrell, el",
		"codi_municipi": "431634",
		"latitud": "41.20472565161424",
		"longitud": "1.5150119574460708",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer de les Basses, 5",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-30T18:41:00.000"
	},
	{
		":id": "row-fscf.e76z_96ej",
		":version": "rv-8vky-av62_b65m",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Àrea Recreativa del Fondo del Mata",
		"indicador_refugi": "431634|AREA_RECREATIVA_DEL_FONDO_DEL_MATA",
		"municipi": "Vendrell, el",
		"codi_municipi": "431634",
		"latitud": "41.18968622621279",
		"longitud": "1.4977485244589386",
		"accessibilitat": "No",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Camí de les Pedreres, s/n",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-30T18:43:00.000"
	},
	{
		":id": "row-qres-t4f8_nn3g",
		":version": "rv-fkf4-4ri2-y257",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Ermita de Sant Salvador",
		"indicador_refugi": "431634|ERMITA_DE_SANT_SALVADOR",
		"municipi": "Vendrell, el",
		"codi_municipi": "431634",
		"latitud": "41.185444924478276",
		"longitud": "1.5444057411539556",
		"accessibilitat": "Sí",
		"aigua": "No",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carretera de Sant Salvador, 18",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-30T18:45:00.000"
	},
	{
		":id": "row-365t~zyfu_utxn",
		":version": "rv-fq2t.zzgd.vb6z",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de la Muntanyeta",
		"indicador_refugi": "431634|PARC_DE_LA_MUNTANYETA",
		"municipi": "Vendrell, el",
		"codi_municipi": "431634",
		"latitud": "41.22238791974624",
		"longitud": "1.5436313700391577",
		"accessibilitat": "No",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer de la Rosa, s/n",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-30T18:48:00.000"
	},
	{
		":id": "row-2284.43c5_ghiu",
		":version": "rv-qz6t.wvr3~6uuc",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de la Ciutat d'Utrera",
		"indicador_refugi": "431634|PARC_DE_LA_CIUTAT_DUTRERA",
		"municipi": "Vendrell, el",
		"codi_municipi": "431634",
		"latitud": "41.21912430823926",
		"longitud": "1.5249078667899596",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer de la Garrotxa, s/n",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-30T18:50:00.000"
	},
	{
		":id": "row-df6p~d7g2-nwt9",
		":version": "rv-xn7i-k7y9-a7bh",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc dels Teletubbies",
		"indicador_refugi": "431634|PARC_DELS_TELETUBBIES",
		"municipi": "Vendrell, el",
		"codi_municipi": "431634",
		"latitud": "41.221979537861024",
		"longitud": "1.5214944667901305",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Alt Urgell, 32",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-30T18:52:00.000"
	},
	{
		":id": "row-g4vf.hsxe-tnww",
		":version": "rv-h72a-6xhg.xrub",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "El Riuet de Coma-ruga",
		"indicador_refugi": "431634|EL_RIUET_DE_COMA-RUGA",
		"municipi": "Vendrell, el",
		"codi_municipi": "431634",
		"latitud": "41.180237212005906",
		"longitud": "1.5241650066295913",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "No",
		"lavabo": "No",
		"adreca": "Plaça Trillas, s/n",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-30T18:54:00.000"
	},
	{
		":id": "row-q7q2.vgzn_hbn2",
		":version": "rv-i47w.w55w_xfw6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Antic Dispensari - Local entitats",
		"indicador_refugi": "172116|ANTIC_DISPENSARI_LOCAL_ENTITATS",
		"municipi": "Verges",
		"codi_municipi": "172116",
		"latitud": "42.06051686",
		"longitud": "3.04676076",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Plta. de l'1 d'octubre, 1",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-6b8n_e88p.26vv",
		":version": "rv-yjfb-gm6c_anik",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Santa Anna",
		"indicador_refugi": "082981|PARC_SANTA_ANNA",
		"municipi": "Vic",
		"codi_municipi": "082981",
		"latitud": "41.92022549",
		"longitud": "2.25821225",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Parc Santa Anna",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-qa4x_w9bz.9rew",
		":version": "rv-zfr8_ewrv-ffmp",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça Francesc Moragas",
		"indicador_refugi": "082981|PLACA_FRANCESC_MORAGAS",
		"municipi": "Vic",
		"codi_municipi": "082981",
		"latitud": "41.92318675",
		"longitud": "2.25558545",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Francesc Moragas",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-2kgr~a653.zpqh",
		":version": "rv-nqn4-kydx_87xn",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça Divina Pastora",
		"indicador_refugi": "082981|PLACA_DIVINA_PASTORA",
		"municipi": "Vic",
		"codi_municipi": "082981",
		"latitud": "41.93103051",
		"longitud": "2.26054215",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Divina Pastora",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-ujqg-gx4x_ug3w",
		":version": "rv-nnxp_m7rc_x6k7",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de l’Horta Vermella",
		"indicador_refugi": "082981|PARC_DE_L_HORTA_VERMELLA",
		"municipi": "Vic",
		"codi_municipi": "082981",
		"latitud": "41.92226414",
		"longitud": "2.26095224",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Parc de l’Horta Vermella",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-hwqm~8pr5~ya7j",
		":version": "rv-k25h-mwdx~uju4",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Jaume Balmes",
		"indicador_refugi": "082981|PARC_JAUME_BALMES",
		"municipi": "Vic",
		"codi_municipi": "082981",
		"latitud": "41.92673874",
		"longitud": "2.25374517",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Parc Jaume Balmes",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-6c8t~h5sa.7nbi",
		":version": "rv-ygez.i37d.p3ta",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Can Forcada",
		"indicador_refugi": "082981|PARC_CAN_FORCADA",
		"municipi": "Vic",
		"codi_municipi": "082981",
		"latitud": "41.92933925",
		"longitud": "2.25145694",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Parc Can Forcada",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-5i5j~i586_j2hd",
		":version": "rv-7rnz-yemp.e69w",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça Fra Joan",
		"indicador_refugi": "082981|PLACA_FRA_JOAN",
		"municipi": "Vic",
		"codi_municipi": "082981",
		"latitud": "41.92204963",
		"longitud": "2.24915627",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "No",
		"adreca": "Pl. Fra Joan",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-xgi9-hbjy.jeui",
		":version": "rv-bq6m.sw45~v2g8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça Josep Maria Pericas",
		"indicador_refugi": "082981|PLACA_JOSEP_MARIA_PERICAS",
		"municipi": "Vic",
		"codi_municipi": "082981",
		"latitud": "41.92404184",
		"longitud": "2.26141954",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Pl. Josep Maria Pericas",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-djqt.x5mf.649z",
		":version": "rv-56yy_zv7g.tx7w",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc del Blanqueig",
		"indicador_refugi": "082981|PARC_DEL_BLANQUEIG",
		"municipi": "Vic",
		"codi_municipi": "082981",
		"latitud": "41.92312034",
		"longitud": "2.24838704",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Parc del Blanqueig",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-bgjn-u3c9~n9t4",
		":version": "rv-2bbu~9kfr-pw77",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Interior Illa C. Ermita de Sant Sixt",
		"indicador_refugi": "082981|INTERIOR_ILLA_C_ERMITA_DE_SANT_SIXT",
		"municipi": "Vic",
		"codi_municipi": "082981",
		"latitud": "41.92966027",
		"longitud": "2.23902594",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "No",
		"adreca": "C. Ermita de Sant Sixt",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-v5ca.kbak.jpdd",
		":version": "rv-tzzt-zahy_hwwq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc d’Occitània",
		"indicador_refugi": "082981|PARC_D_OCCITANIA",
		"municipi": "Vic",
		"codi_municipi": "082981",
		"latitud": "41.93075427",
		"longitud": "2.24351161",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Parc d’Occitània",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-ktby~29pg~sja8",
		":version": "rv-udqs_ihqq.45ws",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Passeig Pep Ventura",
		"indicador_refugi": "082981|PASSEIG_PEP_VENTURA",
		"municipi": "Vic",
		"codi_municipi": "082981",
		"latitud": "41.92488174",
		"longitud": "2.24676176",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Pg. Pep Ventura",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-cxj6.78bg.556j",
		":version": "rv-68jx_832f_7kcy",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Pla del Maset",
		"indicador_refugi": "082981|PARC_PLA_DEL_MASET",
		"municipi": "Vic",
		"codi_municipi": "082981",
		"latitud": "41.91318967",
		"longitud": "2.23032939",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Parc Pla del Maset",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-my3y-7r7a.pdvx",
		":version": "rv-58dq~nms7.hgau",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Vall de Sau",
		"indicador_refugi": "082981|PARC_VALL_DE_SAU",
		"municipi": "Vic",
		"codi_municipi": "082981",
		"latitud": "41.92902019",
		"longitud": "2.26486973",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Parc Vall de Sau",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-unwc-kdcx-955a",
		":version": "rv-ck3e_wxah_avap",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Josep Maria Anglada Abadal",
		"indicador_refugi": "082981|PARC_JOSEP_MARIA_ANGLADA_ABADAL",
		"municipi": "Vic",
		"codi_municipi": "082981",
		"latitud": "41.92893893",
		"longitud": "2.25384785",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Parc Josep Maria Anglada Abadal",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-695m.7644~hebt",
		":version": "rv-4pif-89w4.zp4s",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Doctor Jordi Sala",
		"indicador_refugi": "082981|PARC_DOCTOR_JORDI_SALA",
		"municipi": "Vic",
		"codi_municipi": "082981",
		"latitud": "41.93460225",
		"longitud": "2.24890071",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "No",
		"adreca": "Parc Doctor Jordi Sala",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-vyty_6wky~t3d5",
		":version": "rv-p7gz.jpdq_n3ck",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Passatge Sant Marc",
		"indicador_refugi": "082981|PASSATGE_SANT_MARC",
		"municipi": "Vic",
		"codi_municipi": "082981",
		"latitud": "41.91800765",
		"longitud": "2.2563761",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "No",
		"adreca": "Ptge. Sant Marc",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-2p7v.c6ky-4h6m",
		":version": "rv-pis7.ssfi.7s4g",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Sant Jaume",
		"indicador_refugi": "082981|PARC_SANT_JAUME",
		"municipi": "Vic",
		"codi_municipi": "082981",
		"latitud": "41.92140693",
		"longitud": "2.25822331",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Parc Sant Jaume",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-qepw-kn2q-4an8",
		":version": "rv-4urs-qyfn.8j3y",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Santa Clara Vella",
		"indicador_refugi": "082981|PARC_SANTA_CLARA_VELLA",
		"municipi": "Vic",
		"codi_municipi": "082981",
		"latitud": "41.93380465",
		"longitud": "2.25942849",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Parc Santa Clara Vella",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-svyv-susn_a8jh",
		":version": "rv-cqzb~fa2e.cgjj",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Fèlix Macià Bonaplata",
		"indicador_refugi": "082981|PARC_FELIX_MACIA_BONAPLATA",
		"municipi": "Vic",
		"codi_municipi": "082981",
		"latitud": "41.93060046",
		"longitud": "2.26186938",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Parc Fèlix Macià Bonaplata",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-y94m~p5zr-r9ar",
		":version": "rv-5cc2~ku2h~srab",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Horta de’n Pau",
		"indicador_refugi": "082981|PARC_HORTA_DE_N_PAU",
		"municipi": "Vic",
		"codi_municipi": "082981",
		"latitud": "41.92508226",
		"longitud": "2.24934262",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "No",
		"adreca": "Parc Horta de’n Pau",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-wjmk.xxcd~sd6j",
		":version": "rv-h49z-pcmg_mezf",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Renfe - Mn. Gudiol",
		"indicador_refugi": "082981|RENFE_MN_GUDIOL",
		"municipi": "Vic",
		"codi_municipi": "082981",
		"latitud": "41.92960608",
		"longitud": "2.24878377",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Renfe - Mn Gudiol",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-n569~kagm-yrfj",
		":version": "rv-enas-mzm5-mmxi",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de l’Avinguda dels Països Catalans amb el carrer del Remei",
		"indicador_refugi": "082981|PARC_DE_L_AVINGUDA_DELS_PAISOS_CATALANS_AMB_EL_CARRER_DEL_REMEI",
		"municipi": "Vic",
		"codi_municipi": "082981",
		"latitud": "41.92103259",
		"longitud": "2.24914247",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Parc de l’Av. dels Països Catalans amb el C. del Remei",
		"tipologia": "Parc densament arbrat",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-mzu8-8nsp.5ncy",
		":version": "rv-htj4-6adf_272d",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Era d'en Sellés",
		"indicador_refugi": "082981|PARC_ERA_DEN_SELLES",
		"municipi": "Vic",
		"codi_municipi": "082981",
		"latitud": "41.93524157438571",
		"longitud": "2.253290286399838",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer d'Ató, Bisbe",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-19T12:47:00.000"
	},
	{
		":id": "row-c8wm~4ifx_tp3b",
		":version": "rv-aa9i.pqgq.pr5k",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Horta de la Sínia",
		"indicador_refugi": "082981|PARC_HORTA_DE_LA_SINIA",
		"municipi": "Vic",
		"codi_municipi": "082981",
		"latitud": "41.91978361459529",
		"longitud": "2.2499232497815775",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Av. Països Catalans",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-19T12:52:00.000"
	},
	{
		":id": "row-den3.8275_2svr",
		":version": "rv-kvmm_arm4-2eji",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Jaume Portell",
		"indicador_refugi": "082981|PARC_JAUME_PORTELL",
		"municipi": "Vic",
		"codi_municipi": "082981",
		"latitud": "41.92654447211196",
		"longitud": "2.257621419473653",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer dels Pellaires",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-19T12:54:00.000"
	},
	{
		":id": "row-4ucn-zv5p~eces",
		":version": "rv-hpjj-didg_9c7p",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Miquel Coll i Alentorn",
		"indicador_refugi": "082981|PARC_MIQUEL_COLL_I_ALENTORN",
		"municipi": "Vic",
		"codi_municipi": "082981",
		"latitud": "41.9143229620239",
		"longitud": "2.256599455954583",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Av. Rafael de Casanova",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-19T12:56:00.000"
	},
	{
		":id": "row-ccvp_j5mn~ez3n",
		":version": "rv-6tqz~gbia~yzc6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Pasqual Blanca",
		"indicador_refugi": "082981|PARC_PASQUAL_BLANCA",
		"municipi": "Vic",
		"codi_municipi": "082981",
		"latitud": "41.935196243855245",
		"longitud": "2.262583877005662",
		"accessibilitat": "Sí",
		"aigua": "No",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Av. de Sant Bernat Calbó",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-19T12:59:00.000"
	},
	{
		":id": "row-cptc~qg7q~me6w",
		":version": "rv-u6mi-hemp~xdb3",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Sant Llatzer",
		"indicador_refugi": "082981|PARC_SANT_LLATZER",
		"municipi": "Vic",
		"codi_municipi": "082981",
		"latitud": "41.9278856658995",
		"longitud": "2.2730638161068035",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Av. de Miquel dels Sants Salarich i Torrents",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-19T13:01:00.000"
	},
	{
		":id": "row-cibt_5e74.9wzm",
		":version": "rv-hrji~xrpd_4pxd",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Xavier Roca i Viñas",
		"indicador_refugi": "082981|PARC_XAVIER_ROCA_I_VIÑAS",
		"municipi": "Vic",
		"codi_municipi": "082981",
		"latitud": "41.92663523015437",
		"longitud": "2.2660393150664953",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer del Prat d'en Galliners",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-19T13:03:00.000"
	},
	{
		":id": "row-v5qr-fzz9-uurp",
		":version": "rv-4zvu-qrkc.34sw",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Club Natació Vic – ETB",
		"indicador_refugi": "082981|CLUB_NATACIO_VIC_–_ETB",
		"municipi": "Vic",
		"codi_municipi": "082981",
		"latitud": "41.92043001842664",
		"longitud": "2.256440649613599",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Josep Maria Pallàs, 1",
		"tipologia": "Piscines descobertes",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-19T13:10:00.000"
	},
	{
		":id": "row-fq7c-gj3g~mexy",
		":version": "rv-i3ev_abvu.nith",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Esportiu Municipal Patí Vic",
		"indicador_refugi": "082981|CENTRE_ESPORTIU_MUNICIPAL_PATI_VIC",
		"municipi": "Vic",
		"codi_municipi": "082981",
		"latitud": "41.93266540718037",
		"longitud": "2.2401649656879434",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Avinguda Olímpia, 15",
		"informacio_web": "https://www.vic.cat/serveis/esports/esports/centre-esportiu-municipal-pati-vic",
		"tipologia": "Piscines descobertes",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-19T13:12:00.000"
	},
	{
		":id": "row-w723-9paj.vtcf",
		":version": "rv-dbad~q9gq~9tif",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Pilarín Bayés",
		"indicador_refugi": "082981|BIBLIOTECA_PILARIN_BAYES",
		"municipi": "Vic",
		"codi_municipi": "082981",
		"latitud": "41.92491925331466",
		"longitud": "2.253948628262944",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Passeig de la Generalitat, 1",
		"informacio_web": "https://www.bibliotecapilarinbayes.cat/",
		"tipologia": "Biblioteca",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-19T13:16:00.000"
	},
	{
		":id": "row-b4xa~i353.3jnw",
		":version": "rv-ms8t~8qpc~ss8r",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Joan Rigau i Sala",
		"indicador_refugi": "172137|BIBLIOTECA_JOAN_RIGAU_I_SALA",
		"municipi": "Vidreres",
		"codi_municipi": "172137",
		"latitud": "41.78849327",
		"longitud": "2.78100251",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Orient, 18",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-sbxr.s49c~zjkg",
		":version": "rv-6x3e_y7q8.ewdp",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Can Ribotic",
		"indicador_refugi": "172155|CAN_RIBOTIC",
		"municipi": "Vilablareix",
		"codi_municipi": "172155",
		"latitud": "41.95228524",
		"longitud": "2.7936114",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Perelló, 124",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-edb5.mrxs.kbmf",
		":version": "rv-zkik.8u7w.d3m4",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "172155|PISCINA_MUNICIPAL",
		"municipi": "Vilablareix",
		"codi_municipi": "172155",
		"latitud": "41.95294995",
		"longitud": "2.79353799",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Trav. Marroc, 5",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-xh57~vee3_7jbs",
		":version": "rv-wqmi-tkdk~apt4",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Cívic De Viladamat",
		"indicador_refugi": "172174|CENTRE_CIVIC_DE_VILADAMAT",
		"municipi": "Viladamat",
		"codi_municipi": "172174",
		"latitud": "42.13258299",
		"longitud": "3.0743858",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. de l'1 d'octubre, 1",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-jiqe~hqjz_gc9n",
		":version": "rv-we25~9uy4_gkgb",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "ESCOLES GALLINERS",
		"indicador_refugi": "172180|ESCOLES_GALLINERS",
		"municipi": "Vilademuls",
		"codi_municipi": "172180",
		"latitud": "42.14869",
		"longitud": "2.873225",
		"accessibilitat": "No",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "GIV 5131",
		"tipologia": "Sala Polivalent",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-02T10:46:00.000"
	},
	{
		":id": "row-3xqn_bcj6_9a44",
		":version": "rv-pnif~bb3t_c6rb",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "LOCAL 1 D'OCTUBRE",
		"indicador_refugi": "172180|LOCAL_1_DOCTUBRE",
		"municipi": "Vilademuls",
		"codi_municipi": "172180",
		"latitud": "42.11523",
		"longitud": "2.87449",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "SANT ESTEVE DE GUIALBES",
		"tipologia": "Sala Polivalent",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-02T10:51:00.000"
	},
	{
		":id": "row-5ppu_cmqt-xu5n",
		":version": "rv-wpfv-j8zi-yckp",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "TEATRE-LOCAL POLIVALENT",
		"indicador_refugi": "172180|TEATRE-LOCAL_POLIVALENT",
		"municipi": "Vilademuls",
		"codi_municipi": "172180",
		"latitud": "42.083726",
		"longitud": "2.882622",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "VILAFRESER",
		"tipologia": "Sala Polivalent",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-02T10:54:00.000"
	},
	{
		":id": "row-ej3w~cs6n_w9n5",
		":version": "rv-g93j~xe7b~mm3q",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Espai jove La Nau",
		"indicador_refugi": "083054|ESPAI_JOVE_LA_NAU",
		"municipi": "Vilafranca del Penedès",
		"codi_municipi": "083054",
		"latitud": "41.355344",
		"longitud": "1.70352",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "c/ Baltà de Cela, 45-47",
		"informacio_web": "https://mediambient.vilafranca.cat/sostenibilitat/refugis-climatics",
		"tipologia": "Centre Cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-06-22T14:34:00.000"
	},
	{
		":id": "row-rnnr_ausi~j3ed",
		":version": "rv-m3kg.hkng.qvce",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de la gent gran de l'Espirall",
		"indicador_refugi": "083054|CASAL_DE_LA_GENT_GRAN_DE_L_ESPIRALL",
		"municipi": "Vilafranca del Penedès",
		"codi_municipi": "083054",
		"latitud": "41.35388863",
		"longitud": "1.70161546",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Gelida, 15",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-fkfb~sp3n_vyuf",
		":version": "rv-q9g2~jha7-93m9",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de la gent gran del Tívoli",
		"indicador_refugi": "083054|CASAL_DE_LA_GENT_GRAN_DEL_TIVOLI",
		"municipi": "Vilafranca del Penedès",
		"codi_municipi": "083054",
		"latitud": "41.34292081",
		"longitud": "1.69773431",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Parlament, 14",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-wanh.rczp-d5fi",
		":version": "rv-n6bq~wquj-gjw3",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Oficina de turisme",
		"indicador_refugi": "083054|OFICINA_DE_TURISME",
		"municipi": "Vilafranca del Penedès",
		"codi_municipi": "083054",
		"latitud": "41.34613262",
		"longitud": "1.69631005",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Hermenegild Clascar, 2",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-vfii~j6ym-mm2g",
		":version": "rv-bh8x~mimb~t9hv",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Vilafranca del Penedès",
		"indicador_refugi": "083054|CASAL_CIVIC_I_COMUNITARI_VILAFRANCA_DEL_PENEDES",
		"municipi": "Vilafranca del Penedès",
		"codi_municipi": "083054",
		"latitud": "41.348478",
		"longitud": "1.1203958",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de Peguera, 1",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-vjn8_xj44_qgef",
		":version": "rv-6837-tbmr-9p6f",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "L'escorxador",
		"indicador_refugi": "083054|L_ESCORXADOR",
		"municipi": "Vilafranca del Penedès",
		"codi_municipi": "083054",
		"latitud": "41.34938655",
		"longitud": "1.69683577",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Escorxador, 19",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-usgc.iehd_pvie",
		":version": "rv-vefu_mr3r-swhw",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Creu Roja Vilafranca",
		"indicador_refugi": "083054|CREU_ROJA_VILAFRANCA",
		"municipi": "Vilafranca del Penedès",
		"codi_municipi": "083054",
		"latitud": "41.34378887",
		"longitud": "1.69200547",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Eugeni d'Ors, 22",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-reg5.3v3d-rn3r",
		":version": "rv-jcep_jnqs_wvwk",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Torras I Bages",
		"indicador_refugi": "083054|BIBLIOTECA_TORRAS_I_BAGES",
		"municipi": "Vilafranca del Penedès",
		"codi_municipi": "083054",
		"latitud": "41.347603",
		"longitud": "1.695762",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça de l'Oli, 20",
		"informacio_web": "https://mediambient.vilafranca.cat/sostenibilitat/refugis-climatics",
		"tipologia": "Equipament Cultural (teatre, auditori, museu)",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-06-22T14:40:00.000"
	},
	{
		":id": "row-twnc.jei4.ammz",
		":version": "rv-bfp5_a9ef.66vp",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Vinseum",
		"indicador_refugi": "083054|VINSEUM",
		"municipi": "Vilafranca del Penedès",
		"codi_municipi": "083054",
		"latitud": "41.34676489",
		"longitud": "1.69686795",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. de Jaume I, 1",
		"tipologia": "Espai cultural",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-n5nj~npv3_9cmh",
		":version": "rv-wegr-anx7~32iq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Complex Aquàtic (hall)",
		"indicador_refugi": "083054|COMPLEX_AQUATIC_HALL",
		"municipi": "Vilafranca del Penedès",
		"codi_municipi": "083054",
		"latitud": "41.34832743",
		"longitud": "1.68340326",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Antic de Sant Martí, 12",
		"tipologia": "Poliesportiu",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-skiy-zdsg_abg8",
		":version": "rv-n3hb-fgfz_rh95",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Basílica de Santa Maria",
		"indicador_refugi": "083054|BASILICA_DE_SANTA_MARIA",
		"municipi": "Vilafranca del Penedès",
		"codi_municipi": "083054",
		"latitud": "41.34712",
		"longitud": "1.697198",
		"accessibilitat": "Sí",
		"aigua": "No",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça de Jaume I, 2",
		"informacio_web": "https://mediambient.vilafranca.cat/sostenibilitat/refugis-climatics",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-22T13:29:00.000"
	},
	{
		":id": "row-mu9x_mgpa-ke5g",
		":version": "rv-u475.yxek-wkpp",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Mercat Sant Salvador",
		"indicador_refugi": "083054|MERCAT_SANT_SALVADOR",
		"municipi": "Vilafranca del Penedès",
		"codi_municipi": "083054",
		"latitud": "41.342043",
		"longitud": "1.69297",
		"accessibilitat": "Sí",
		"aigua": "No",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "c/ Francesc Macià, 1",
		"informacio_web": "https://mediambient.vilafranca.cat/sostenibilitat/refugis-climatics",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-22T14:24:00.000"
	},
	{
		":id": "row-qxbd.57y3.dezr",
		":version": "rv-v5nu.j5f2.pm62",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic Punt de Trobada",
		"indicador_refugi": "172235|CENTRE_CIVIC_PUNT_DE_TROBADA",
		"municipi": "Vilajuïga",
		"codi_municipi": "172235",
		"latitud": "42.32758966",
		"longitud": "3.0939555",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Pl. Onze de Setembre, s/n",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-x3bs~m3h6~d8pt",
		":version": "rv-ke59_cnuw_ac3e",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal de Vilajuïga",
		"indicador_refugi": "172235|PISCINA_MUNICIPAL_DE_VILAJUIGA",
		"municipi": "Vilajuïga",
		"codi_municipi": "172235",
		"latitud": "42.33509168",
		"longitud": "3.09421128",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Zona esportiva Mas Bartret",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-2dv5~wfvk-gwgz",
		":version": "rv-fi6p.rn8c~d477",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Escola El Diví Mestre",
		"indicador_refugi": "431750|ESCOLA_EL_DIVI_MESTRE",
		"municipi": "Vilalba dels Arcs",
		"codi_municipi": "431750",
		"latitud": "41.118283706305185",
		"longitud": "0.4086717095661447",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C/ Gandesa, S/N",
		"tipologia": "Escola / Institut",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-16T15:50:00.000"
	},
	{
		":id": "row-v3kt~eve2_4y49",
		":version": "rv-2t8b_x6ep-rcjb",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Rossinyol",
		"indicador_refugi": "431750|CASAL_ROSSINYOL",
		"municipi": "Vilalba dels Arcs",
		"codi_municipi": "431750",
		"latitud": "41.12072529999091",
		"longitud": "0.40775633840189124",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "No",
		"adreca": "C/ Rossinyol, 8",
		"tipologia": "Equipament Cultural (teatre, auditori, museu)",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-16T16:44:00.000"
	},
	{
		":id": "row-tmea~gnzs_nmpb",
		":version": "rv-e3f9_ukvw.6fb6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Ajuntament",
		"indicador_refugi": "431750|AJUNTAMENT",
		"municipi": "Vilalba dels Arcs",
		"codi_municipi": "431750",
		"latitud": "41.121182560354605",
		"longitud": "0.4100306955263697",
		"accessibilitat": "No",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "No",
		"adreca": "Plaça de la Vila, 3",
		"tipologia": "Ajuntament / Equipament Administratiu",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-16T16:47:00.000"
	},
	{
		":id": "row-mf8v~mk58-wphk",
		":version": "rv-25ud_uahj-iapb",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Pavelló municipal",
		"indicador_refugi": "431750|PAVELLO_MUNICIPAL",
		"municipi": "Vilalba dels Arcs",
		"codi_municipi": "431750",
		"latitud": "41.12161900043192",
		"longitud": "0.4042156664901893",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "No",
		"lavabo": "No",
		"adreca": "C/ Rossinyol, 31",
		"tipologia": "Pavelló Esportiu",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-16T16:48:00.000"
	},
	{
		":id": "row-zmpi.bgur.w8i6",
		":version": "rv-kwrk-wr34~rc53",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Font lúdica",
		"indicador_refugi": "083067|FONT_LUDICA",
		"municipi": "Vilalba Sasserra",
		"codi_municipi": "083067",
		"latitud": "41.65394",
		"longitud": "2.4403",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C/ Montseny, 10",
		"informacio_web": "www.vilalbasasserra.cat",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-04T13:20:00.000"
	},
	{
		":id": "row-jcfg.9km3-bsbr",
		":version": "rv-m2m3.dpau-p47f",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "172240|PISCINA_MUNICIPAL",
		"municipi": "Vilallonga de Ter",
		"codi_municipi": "172240",
		"latitud": "42.33126416",
		"longitud": "2.30919195",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Zona Esportiva de Vilallonga de Ter (prop Ctra. GIV-5264)",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-rggx_4e3p.ch3q",
		":version": "rv-xmz7_crxw.zwcm",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca de Vilallonga del Camp",
		"indicador_refugi": "431665|BIBLIOTECA_DE_VILALLONGA_DEL_CAMP",
		"municipi": "Vilallonga del Camp",
		"codi_municipi": "431665",
		"latitud": "41.21071001",
		"longitud": "1.20741793",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Ctra. de Valls, 1, primer pis, 43141 Vilallonga del Camp, Tarragona",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-ikfv-rsxv-rgtq",
		":version": "rv-fxih_nwrb_s63r",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Sala Mestre Ramon Tubau",
		"indicador_refugi": "172288|SALA_MESTRE_RAMON_TUBAU",
		"municipi": "Vilanant",
		"codi_municipi": "172288",
		"latitud": "42.25470036",
		"longitud": "2.88988496",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de la placeta, 3",
		"tipologia": "Sala polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-m9gw-iiv3.dp8j",
		":version": "rv-ffad_4h6i_4zy2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscines municipals",
		"indicador_refugi": "252483|PISCINES_MUNICIPALS",
		"municipi": "Vilanova de Bellpuig",
		"codi_municipi": "252483",
		"latitud": "41.61720159",
		"longitud": "0.96390413",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. eral, s/n",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-95q2~2tzd-rqm5",
		":version": "rv-ayzf~p9g4_4mt9",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Glòria Tudela",
		"indicador_refugi": "252483|BIBLIOTECA_GLORIA_TUDELA",
		"municipi": "Vilanova de Bellpuig",
		"codi_municipi": "252483",
		"latitud": "41.61480514",
		"longitud": "0.96110322",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Doctor Gassol, 1",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-eejh.xe5c.5uvb",
		":version": "rv-2ka2.epew_yv6i",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "LLAR MUNICIPAL GENT GRAN",
		"indicador_refugi": "252483|LLAR_MUNICIPAL_GENT_GRAN",
		"municipi": "Vilanova de Bellpuig",
		"codi_municipi": "252483",
		"latitud": "41.61374324439703",
		"longitud": "0.9619960548644277",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "No",
		"adreca": "CARRER PARE PACÍFIC, 2",
		"informacio_web": "Tots els dies de 16 a 20 h",
		"tipologia": "Casal de Gent Gran",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-16T13:47:00.000"
	},
	{
		":id": "row-twri.dauf.y4de",
		":version": "rv-j7tn_tcap_akqz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Pavelló municipal per a usos socioculturals",
		"indicador_refugi": "252542|PAVELLO_MUNICIPAL_PER_A_USOS_SOCIOCULTURALS",
		"municipi": "Vilanova de la Barca",
		"codi_municipi": "252542",
		"latitud": "41.690067",
		"longitud": "0.728856",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C/ESGLÉSIA, S/N",
		"informacio_web": "www.vilanovadelabarca.cat",
		"tipologia": "Sala Polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-06-02T14:00:00.000"
	},
	{
		":id": "row-f5ts.ayfe_ca9i",
		":version": "rv-pqbx.v4dq_j64t",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "PISCINA MUNICIPAL DE VILANOVA DE SEGRIÀ",
		"indicador_refugi": "252516|PISCINA_MUNICIPAL_DE_VILANOVA_DE_SEGRIA",
		"municipi": "Vilanova de Segrià",
		"codi_municipi": "252516",
		"latitud": "41.4246",
		"longitud": "0.36574",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C/ CAMÍ D'ALGUAIRE",
		"tipologia": "Piscines descobertes",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-22T21:46:00.000"
	},
	{
		":id": "row-vtfd~7cjn.wu8a",
		":version": "rv-48tw_pkbd-qa55",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de la gent gran",
		"indicador_refugi": "083020|CASAL_DE_LA_GENT_GRAN",
		"municipi": "Vilanova del Camí",
		"codi_municipi": "083020",
		"latitud": "41.57268172",
		"longitud": "1.63946252",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. Sant Josep, 36",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-4cxi~furh.9ir7",
		":version": "rv-hiss-4i4t~p45k",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre d'innovació Anoia",
		"indicador_refugi": "083020|CENTRE_D_INNOVACIO_ANOIA",
		"municipi": "Vilanova del Camí",
		"codi_municipi": "083020",
		"latitud": "41.57246534",
		"longitud": "1.65660375",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. dels impressors, 12, Vilanova del Camí",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-xr4y-374q~aa4r",
		":version": "rv-t47b~h23a-gdaz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca municipal Vilanova del Camí",
		"indicador_refugi": "083020|BIBLIOTECA_MUNICIPAL_VILANOVA_DEL_CAMI",
		"municipi": "Vilanova del Camí",
		"codi_municipi": "083020",
		"latitud": "41.57630165",
		"longitud": "1.63651848",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "C. de la Verge de Núria, 1, 08788 Vilanova del Camí, Barcelona",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-4aa4.fkji~t2nd",
		":version": "rv-dqi6.7v9i.44k2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Espai jove Can Muscons",
		"indicador_refugi": "083020|ESPAI_JOVE_CAN_MUSCONS",
		"municipi": "Vilanova del Camí",
		"codi_municipi": "083020",
		"latitud": "41.56899781",
		"longitud": "1.6341234",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Camí del cementiri, 15, 08788 Vilanova del Camí",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-gmm9~bg6j.dzdi",
		":version": "rv-gxn2.w2as_ec2i",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic Barri la Pau",
		"indicador_refugi": "083020|CENTRE_CIVIC_BARRI_LA_PAU",
		"municipi": "Vilanova del Camí",
		"codi_municipi": "083020",
		"latitud": "41.5733499",
		"longitud": "1.64473704",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de la Verge del Cap, 26, 08788 Vilanova del Camí, Barcelona",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-iqdf-wzjj_mmja",
		":version": "rv-4un6~ep37.4afd",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina Municipal de Can Rabassa",
		"indicador_refugi": "089024|PISCINA_MUNICIPAL_DE_CAN_RABASSA",
		"municipi": "Vilanova del Vallès",
		"codi_municipi": "089024",
		"latitud": "41.54297923",
		"longitud": "2.30324135",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Camí de Vilassar, 18, 08410 Vilanova del Vallès",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:38:00.000"
	},
	{
		":id": "row-dhqa-8t2w_tyk8",
		":version": "rv-crdk_i2vr.6jga",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Contravent",
		"indicador_refugi": "089024|BIBLIOTECA_CONTRAVENT",
		"municipi": "Vilanova del Vallès",
		"codi_municipi": "089024",
		"latitud": "41.55174735",
		"longitud": "2.28629735",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Pl. Països Catalans, 4",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-6egz.sr26-hme4",
		":version": "rv-sb2k-ebeg~ek59",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Cultural: sala cinema i sala polivalent",
		"indicador_refugi": "431671|CENTRE_CULTURAL_SALA_CINEMA_I_SALA_POLIVALENT",
		"municipi": "Vilanova d'Escornalbou",
		"codi_municipi": "431671",
		"latitud": "41.11403",
		"longitud": "0.936513",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Cosme Toda, 19",
		"informacio_web": "Obertura en períodes d'onada de calor d'11:30 h a 19:30 h",
		"tipologia": "Equipament Cultural (teatre, auditori, museu)",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-23T11:04:00.000"
	},
	{
		":id": "row-j6fv~fpk2~h42s",
		":version": "rv-gb3e~ztzg-cqiu",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Local Gent Gran",
		"indicador_refugi": "431671|LOCAL_GENT_GRAN",
		"municipi": "Vilanova d'Escornalbou",
		"codi_municipi": "431671",
		"latitud": "41.114001",
		"longitud": "0.936487",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Cosme Toda, 19 1r",
		"informacio_web": "Obertura en període d'onada de calor de 11:30h. a 19:30 h.",
		"tipologia": "Casal de Gent Gran",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-23T11:09:00.000"
	},
	{
		":id": "row-jfw6-apjn.8v7h",
		":version": "rv-p2ju.tp9x.gv3i",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina Municipal",
		"indicador_refugi": "431671|PISCINA_MUNICIPAL",
		"municipi": "Vilanova d'Escornalbou",
		"codi_municipi": "431671",
		"latitud": "41.111247",
		"longitud": "0.938023",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Arbocet, s/n - Pavelló Municipal",
		"informacio_web": "Obertura a tot el públic en general en períodes d'onada de calor d'11:30 a 19:30 h",
		"tipologia": "Piscines descobertes",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-23T11:12:00.000"
	},
	{
		":id": "row-5eja-vhfn-rybb",
		":version": "rv-j2wk~n74e-usdk",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Ajuntament - Sala de Plens",
		"indicador_refugi": "431671|AJUNTAMENT_-_SALA_DE_PLENS",
		"municipi": "Vilanova d'Escornalbou",
		"codi_municipi": "431671",
		"latitud": "41.113135",
		"longitud": "0.937144",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça de la Vila, 1",
		"informacio_web": "Horari obertura de l'Ajuntament de 08:00 a 15:00 h.",
		"tipologia": "Ajuntament / Equipament Administratiu",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-23T11:14:00.000"
	},
	{
		":id": "row-6uti-jaae_fiki",
		":version": "rv-jckc-yemp-4r7w",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Cultural de l'Arbocet",
		"indicador_refugi": "431671|CENTRE_CULTURAL_DE_LARBOCET",
		"municipi": "Vilanova d'Escornalbou",
		"codi_municipi": "431671",
		"latitud": "41.105354",
		"longitud": "0.9608",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. de Baix, 6 - L'Arbocet",
		"informacio_web": "Obertura en períodes d'onada de calor d'11:30 a 19:30 h",
		"tipologia": "Sala Polivalent",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-23T12:01:00.000"
	},
	{
		":id": "row-f5r9.7a77_5cys",
		":version": "rv-ds5h_k4r6_mvab",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Armand Cardona",
		"indicador_refugi": "083073|BIBLIOTECA_ARMAND_CARDONA",
		"municipi": "Vilanova i la Geltrú",
		"codi_municipi": "083073",
		"latitud": "41.22203249",
		"longitud": "1.71463179",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Menendez Pelayo, 15-17",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-96mh_dfyr_qgt7",
		":version": "rv-83nh_2njy~qbmp",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic Molí de Vent",
		"indicador_refugi": "083073|CENTRE_CIVIC_MOLI_DE_VENT",
		"municipi": "Vilanova i la Geltrú",
		"codi_municipi": "083073",
		"latitud": "41.22084777",
		"longitud": "1.70988271",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. aigua, 203-205",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-ayu6.id83_czr7",
		":version": "rv-ehfu~gv7h-btmu",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic de Mar",
		"indicador_refugi": "083073|CENTRE_CIVIC_DE_MAR",
		"municipi": "Vilanova i la Geltrú",
		"codi_municipi": "083073",
		"latitud": "41.21699074",
		"longitud": "1.73146661",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pg. Marítim, 73",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-bgsk-mwqi_2yde",
		":version": "rv-a5v6~i6ws~8cb6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic el Tacó",
		"indicador_refugi": "083073|CENTRE_CIVIC_EL_TACO",
		"municipi": "Vilanova i la Geltrú",
		"codi_municipi": "083073",
		"latitud": "41.23445786",
		"longitud": "1.72686611",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. Vilafranca del Penedès, 26",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-k3bx-un5s_jiq5",
		":version": "rv-hc3r-vrs8_dzgq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic la Geltrú",
		"indicador_refugi": "083073|CENTRE_CIVIC_LA_GELTRU",
		"municipi": "Vilanova i la Geltrú",
		"codi_municipi": "083073",
		"latitud": "41.2256799",
		"longitud": "1.73145865",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Assumpció Alumnes Obrers, 1",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-jig9_g9xy_w6dz",
		":version": "rv-svjf-v6i9_sma8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Joan Oliva",
		"indicador_refugi": "083073|BIBLIOTECA_JOAN_OLIVA",
		"municipi": "Vilanova i la Geltrú",
		"codi_municipi": "083073",
		"latitud": "41.22455847",
		"longitud": "1.7255597",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. de la Vila, 13",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:41:00.000"
	},
	{
		":id": "row-de5r-j4zb_7gbu",
		":version": "rv-7p78.5ykw.eyr6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic Sant Joan",
		"indicador_refugi": "083073|CENTRE_CIVIC_SANT_JOAN",
		"municipi": "Vilanova i la Geltrú",
		"codi_municipi": "083073",
		"latitud": "41.22243346",
		"longitud": "1.71847754",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Jardins Francesc Macià, s/n",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-hq8n.ti2r-zjxg",
		":version": "rv-y6g4-5hid_mquq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic La Collada Sis Camins",
		"indicador_refugi": "083073|CENTRE_CIVIC_LA_COLLADA_SIS_CAMINS",
		"municipi": "Vilanova i la Geltrú",
		"codi_municipi": "083073",
		"latitud": "41.22604684",
		"longitud": "1.69586887",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Turbina, 19",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-rqxy.p9u9.cvbi",
		":version": "rv-bx2q.pctc-au8f",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Local jove",
		"indicador_refugi": "431704|LOCAL_JOVE",
		"municipi": "Vila-rodona",
		"codi_municipi": "431704",
		"latitud": "41.31035224",
		"longitud": "1.35777587",
		"accessibilitat": "No",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Casal de Vila-rodona, s/n",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-fzvy.4irc.s2ar",
		":version": "rv-sen2.vfdq~7xme",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "431704|PISCINA_MUNICIPAL",
		"municipi": "Vila-rodona",
		"codi_municipi": "431704",
		"latitud": "41.30958958",
		"longitud": "1.35706482",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Pagesia Catalana, s/n",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:37:00.000"
	},
	{
		":id": "row-waeu.fw2z~49fd",
		":version": "rv-gnwb~uxwq-8k7a",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca municipal",
		"indicador_refugi": "431704|BIBLIOTECA_MUNICIPAL",
		"municipi": "Vila-rodona",
		"codi_municipi": "431704",
		"latitud": "41.31046369",
		"longitud": "1.35858419",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de les Hortes, 4",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:39:00.000"
	},
	{
		":id": "row-2e45_2mdv-xe63",
		":version": "rv-ai9m_pyeb.3aqs",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça dels Països Catalans",
		"indicador_refugi": "431711|PLACA_DELS_PAISOS_CATALANS",
		"municipi": "Vila-seca",
		"codi_municipi": "431711",
		"latitud": "41.108074",
		"longitud": "1.148873",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça dels Països Catalans, 43480 Vila-seca",
		"informacio_web": "https://vila-seca.cat/refugis-climatics",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-02T14:31:00.000"
	},
	{
		":id": "row-hni6_y23v_fthu",
		":version": "rv-hmvc_q5ye.u5qg",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de l'Albereda de Folc",
		"indicador_refugi": "431711|PARC_DE_LALBEREDA_DE_FOLC",
		"municipi": "Vila-seca",
		"codi_municipi": "431711",
		"latitud": "41.108478",
		"longitud": "1.139214",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Avinguda de la Generalitat, 43480 Vila-seca",
		"informacio_web": "https://vila-seca.cat/refugis-climatics",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-02T14:41:00.000"
	},
	{
		":id": "row-ybvp~c9f5-823j",
		":version": "rv-dxdr~6tip.yz7d",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de l'Hort del Pep",
		"indicador_refugi": "431711|PARC_DE_LHORT_DEL_PEP",
		"municipi": "Vila-seca",
		"codi_municipi": "431711",
		"latitud": "41.112095",
		"longitud": "1.150334",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Galceran de Pinós, 43480 Vila-seca",
		"informacio_web": "https://vila-seca.cat/refugis-climatics",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-02T14:43:00.000"
	},
	{
		":id": "row-k6f8-j6up~fe7f",
		":version": "rv-br4y~5ic4_q2mf",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de la Torre d'en Dolça",
		"indicador_refugi": "431711|PARC_DE_LA_TORRE_DEN_DOLCA",
		"municipi": "Vila-seca",
		"codi_municipi": "431711",
		"latitud": "41.098988",
		"longitud": "1.160086",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carretera Vila-seca - La Pineda, 43480 Vila-seca",
		"informacio_web": "https://vila-seca.cat/refugis-climatics",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-02T14:48:00.000"
	},
	{
		":id": "row-2tc5~h9us_whwb",
		":version": "rv-zhhz-7xiy-f796",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Antics Rentadors",
		"indicador_refugi": "431711|ANTICS_RENTADORS",
		"municipi": "Vila-seca",
		"codi_municipi": "431711",
		"latitud": "41.110497",
		"longitud": "1.144324",
		"accessibilitat": "Sí",
		"aigua": "No",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer de la Font, 43480 Vila-seca",
		"informacio_web": "https://vila-seca.cat/refugis-climatics",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-03T09:24:00.000"
	},
	{
		":id": "row-aev5.vx3w_snnr",
		":version": "rv-qiv8~wgjb.s4e9",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de l'Escorxador",
		"indicador_refugi": "431711|PARC_DE_LESCORXADOR",
		"municipi": "Vila-seca",
		"codi_municipi": "431711",
		"latitud": "41.108831",
		"longitud": "1.146593",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer de l'Escorxador, 43480 Vila-seca",
		"informacio_web": "https://vila-seca.cat/refugis-climatics",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-03T09:25:00.000"
	},
	{
		":id": "row-w2vt-3bjf_iwq2",
		":version": "rv-zyq8~ctxf~mpuk",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de l'Estació",
		"indicador_refugi": "431711|PARC_DE_LESTACIO",
		"municipi": "Vila-seca",
		"codi_municipi": "431711",
		"latitud": "41.112383",
		"longitud": "1.150603",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer de Galceran de Pinós, 43480 Vila-seca",
		"informacio_web": "https://vila-seca.cat/refugis-climatics",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-03T09:28:00.000"
	},
	{
		":id": "row-cip7.jbsb.fjjg",
		":version": "rv-frq2-wqte~sj9s",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jardins del Castell",
		"indicador_refugi": "431711|JARDINS_DEL_CASTELL",
		"municipi": "Vila-seca",
		"codi_municipi": "431711",
		"latitud": "41.114208",
		"longitud": "1.147645",
		"accessibilitat": "Sí",
		"aigua": "No",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer del Castell, 43480 Vila-seca",
		"informacio_web": "https://vila-seca.cat/refugis-climatics",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-03T09:29:00.000"
	},
	{
		":id": "row-7dpr.6cvq-6d5k",
		":version": "rv-qday.4idy~j5cz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jardins de la Plaça de l'Església Vella",
		"indicador_refugi": "431711|JARDINS_DE_LA_PLACA_DE_LESGLESIA_VELLA",
		"municipi": "Vila-seca",
		"codi_municipi": "431711",
		"latitud": "41.113188",
		"longitud": "1.148195",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer del Castell, 43480 Vila-seca",
		"informacio_web": "https://vila-seca.cat/refugis-climatics",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-03T11:10:00.000"
	},
	{
		":id": "row-mmdg_74h9-h2dz",
		":version": "rv-i9z9_p65c-pmsz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça de l'Església",
		"indicador_refugi": "431711|PLACA_DE_LESGLESIA",
		"municipi": "Vila-seca",
		"codi_municipi": "431711",
		"latitud": "41.111491",
		"longitud": "1.144875",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça de l'Església, 43480 Vila-seca",
		"informacio_web": "https://vila-seca.cat/refugis-climatics",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-03T11:11:00.000"
	},
	{
		":id": "row-txcq_hdfe-94j2",
		":version": "rv-hezg~jbv4_c8dt",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça de Joan Miró",
		"indicador_refugi": "431711|PLACA_DE_JOAN_MIRO",
		"municipi": "Vila-seca",
		"codi_municipi": "431711",
		"latitud": "41.111709",
		"longitud": "1.137937",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer de Fra Joan Fernando Salvadó, 43480 Vila-seca",
		"informacio_web": "https://vila-seca.cat/refugis-climatics",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-03T11:12:00.000"
	},
	{
		":id": "row-xpai~uqu6~rgcr",
		":version": "rv-4gb9~6qi5~evuq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de les Illes",
		"indicador_refugi": "431711|PARC_DE_LES_ILLES",
		"municipi": "Vila-seca",
		"codi_municipi": "431711",
		"latitud": "41.105744",
		"longitud": "1.147687",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer de Josep Maria Folch i Torres, 43480 Vila-seca",
		"informacio_web": "https://vila-seca.cat/refugis-climatics",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-03T11:14:00.000"
	},
	{
		":id": "row-ti8d_48pi-yzqr",
		":version": "rv-ay5x.pd6m-r2dv",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc dels Aragalls",
		"indicador_refugi": "431711|PARC_DELS_ARAGALLS",
		"municipi": "Vila-seca",
		"codi_municipi": "431711",
		"latitud": "41.106628",
		"longitud": "1.151069",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer d'Ausiàs Marc, 43480 Vila-seca",
		"informacio_web": "https://vila-seca.cat/refugis-climatics",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-03T11:15:00.000"
	},
	{
		":id": "row-3gha_mihy_yefe",
		":version": "rv-t2kr~8kk7.26yj",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de Bernat Sportella",
		"indicador_refugi": "431711|PARC_DE_BERNAT_SPORTELLA",
		"municipi": "Vila-seca",
		"codi_municipi": "431711",
		"latitud": "41.113658",
		"longitud": "1.144999",
		"accessibilitat": "Sí",
		"aigua": "No",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer de Reus, 43480 Vila-seca",
		"informacio_web": "https://vila-seca.cat/refugis-climatics",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-03T11:16:00.000"
	},
	{
		":id": "row-isuz~xub7.dbei",
		":version": "rv-y6ki~yzs3~5m3q",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc dels Geganters",
		"indicador_refugi": "431711|PARC_DELS_GEGANTERS",
		"municipi": "Vila-seca",
		"codi_municipi": "431711",
		"latitud": "41.109885",
		"longitud": "1.140434",
		"accessibilitat": "Sí",
		"aigua": "No",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer del Mas Calvó, 43480 Vila-seca",
		"informacio_web": "https://vila-seca.cat/refugis-climatics",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-03T11:18:00.000"
	},
	{
		":id": "row-mnr4~iime_s34a",
		":version": "rv-ixmn~zpz2-z977",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jardí de Joan Amades",
		"indicador_refugi": "431711|JARDI_DE_JOAN_AMADES",
		"municipi": "Vila-seca",
		"codi_municipi": "431711",
		"latitud": "41.109677",
		"longitud": "1.14314",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Avinguda de la Verge de Montserrat, 43480 Vila-seca",
		"informacio_web": "https://vila-seca.cat/refugis-climatics",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-03T11:19:00.000"
	},
	{
		":id": "row-vpnk.m5un~srv4",
		":version": "rv-52mi~g5t8.pf7q",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Ajuntament de Vila-seca",
		"indicador_refugi": "431711|AJUNTAMENT_DE_VILA-SECA",
		"municipi": "Vila-seca",
		"codi_municipi": "431711",
		"latitud": "41.110919",
		"longitud": "1.144868",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça de l'Església, 26, 43480 Vila-seca",
		"informacio_web": "https://vila-seca.cat/refugis-climatics",
		"tipologia": "Ajuntament / Equipament Administratiu",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-03T11:20:00.000"
	},
	{
		":id": "row-q3rc.47ky~k45e",
		":version": "rv-yegf~jh5t.cbna",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Espai Jove Casa dels Obrers",
		"indicador_refugi": "431711|ESPAI_JOVE_CASA_DELS_OBRERS",
		"municipi": "Vila-seca",
		"codi_municipi": "431711",
		"latitud": "41.110659",
		"longitud": "1.144621",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer de Sant Antoni, 24, 43480 Vila-seca",
		"informacio_web": "https://vila-seca.cat/refugis-climatics",
		"tipologia": "Ajuntament / Equipament Administratiu",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-03T11:21:00.000"
	},
	{
		":id": "row-2e4s_dsff_46za",
		":version": "rv-qnxr.46nr~bg8i",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Servei d'Ocupació i Creació d'Empresa",
		"indicador_refugi": "431711|SERVEI_DOCUPACIO_I_CREACIO_DEMPRESA",
		"municipi": "Vila-seca",
		"codi_municipi": "431711",
		"latitud": "41.112341",
		"longitud": "1.146699",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer de l'Hospital, 1, 43480 Vila-seca",
		"informacio_web": "https://vila-seca.cat/refugis-climatics",
		"tipologia": "Ajuntament / Equipament Administratiu",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-03T11:24:00.000"
	},
	{
		":id": "row-4798_f5px_9cvc",
		":version": "rv-3g7i.53yh_5hnh",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Cívic i Cultural el Colomí",
		"indicador_refugi": "431711|CENTRE_CIVIC_I_CULTURAL_EL_COLOMI",
		"municipi": "Vila-seca",
		"codi_municipi": "431711",
		"latitud": "41.111399",
		"longitud": "1.149903",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer de Tarragona, 22, 43480 Vila-seca",
		"informacio_web": "https://vila-seca.cat/refugis-climatics",
		"tipologia": "Centre Cívic",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-03T11:28:00.000"
	},
	{
		":id": "row-sv66-ip7b-53nn",
		":version": "rv-a4a8~2f2x_6y6y",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Pública Municipal",
		"indicador_refugi": "431711|BIBLIOTECA_PUBLICA_MUNICIPAL",
		"municipi": "Vila-seca",
		"codi_municipi": "431711",
		"latitud": "41.1100241",
		"longitud": "1.14757",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer de Tarragona, 7, 43480 Vila-seca",
		"informacio_web": "https://vila-seca.cat/refugis-climatics",
		"tipologia": "Biblioteca",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-03T11:37:00.000"
	},
	{
		":id": "row-8pty.jg8p~nu3j",
		":version": "rv-h3jc_pg96.4c4q",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Sala Sicart (Castell de Vila-seca)",
		"indicador_refugi": "431711|SALA_SICART_(CASTELL_DE_VILA-SECA)",
		"municipi": "Vila-seca",
		"codi_municipi": "431711",
		"latitud": "41.114616",
		"longitud": "1.147439",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer del Castell, 38, 43480 Vila-seca",
		"informacio_web": "https://vila-seca.cat/refugis-climatics",
		"tipologia": "Sala Polivalent",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-04T09:42:00.000"
	},
	{
		":id": "row-pq8x-q3fz-5szk",
		":version": "rv-hmpa~ffga~urpb",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina exterior Vila-seca",
		"indicador_refugi": "431711|PISCINA_EXTERIOR_VILA-SECA",
		"municipi": "Vila-seca",
		"codi_municipi": "431711",
		"latitud": "41.1019145",
		"longitud": "1.14987",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Avinguda Alcalde Pere Molas, 26, 43480 Vila-seca",
		"informacio_web": "https://vila-seca.cat/refugis-climatics",
		"tipologia": "Piscines descobertes",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-04T09:44:00.000"
	},
	{
		":id": "row-cjnt_wuva.gtxm",
		":version": "rv-3rzv_vs3i-q8zm",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina interior Vila-seca",
		"indicador_refugi": "431711|PISCINA_INTERIOR_VILA-SECA",
		"municipi": "Vila-seca",
		"codi_municipi": "431711",
		"latitud": "41.1019145",
		"longitud": "1.14987",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Avinguda Alcalde Pere Molas, 26, 43480 Vila-seca",
		"informacio_web": "https://vila-seca.cat/refugis-climatics",
		"tipologia": "Piscina Coberta",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-04T09:45:00.000"
	},
	{
		":id": "row-tvu4-rp4j~9bsv",
		":version": "rv-r4hn.rpuh~8bx3",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc dels Prats",
		"indicador_refugi": "431711|PARC_DELS_PRATS",
		"municipi": "Vila-seca",
		"codi_municipi": "431711",
		"latitud": "41.083824",
		"longitud": "1.186547",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer d'Amadeus Vives, 43481 La Pineda",
		"informacio_web": "https://vila-seca.cat/refugis-climatics",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-04T10:34:00.000"
	},
	{
		":id": "row-fvk8~8php~7u3x",
		":version": "rv-zman~k3fc.kz5r",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc del Pinar de Perruquet",
		"indicador_refugi": "431711|PARC_DEL_PINAR_DE_PERRUQUET",
		"municipi": "Vila-seca",
		"codi_municipi": "431711",
		"latitud": "41.076415",
		"longitud": "1.181999",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Passeig de Pau Casals, 43481 La Pineda",
		"informacio_web": "https://vila-seca.cat/refugis-climatics",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-04T10:36:00.000"
	},
	{
		":id": "row-xgut~r37g.w3ib",
		":version": "rv-ysqh-tbwx.utec",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de la Tanca",
		"indicador_refugi": "431711|PARC_DE_LA_TANCA",
		"municipi": "Vila-seca",
		"codi_municipi": "431711",
		"latitud": "41.08105",
		"longitud": "1.181039",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer d'Amadeu Vives, 43481 Vila-seca",
		"informacio_web": "https://vila-seca.cat/refugis-climatics",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-04T10:38:00.000"
	},
	{
		":id": "row-gcre-4q7c_8amd",
		":version": "rv-hg3d~tjpc.e96d",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de les Arenes",
		"indicador_refugi": "431711|PARC_DE_LES_ARENES",
		"municipi": "Vila-seca",
		"codi_municipi": "431711",
		"latitud": "41.080148",
		"longitud": "1.178143",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer de Pau Vidal, 43481 La Pineda",
		"informacio_web": "https://vila-seca.cat/refugis-climatics",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-04T10:39:00.000"
	},
	{
		":id": "row-mc6t.u7d3-i8f8",
		":version": "rv-t7jz~favu.fahf",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Cívic i Cultural de la Pineda",
		"indicador_refugi": "431711|CENTRE_CIVIC_I_CULTURAL_DE_LA_PINEDA",
		"municipi": "Vila-seca",
		"codi_municipi": "431711",
		"latitud": "41.080399",
		"longitud": "1.179091",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer d'Alfredo Kraus, 20, 43481 La Pineda",
		"informacio_web": "https://vila-seca.cat/refugis-climatics",
		"tipologia": "Centre Cívic",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-04T10:40:00.000"
	},
	{
		":id": "row-zsf7-46qa_4dwt",
		":version": "rv-tri3-pj6g-bv7a",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de Ramon Roig",
		"indicador_refugi": "431711|PARC_DE_RAMON_ROIG",
		"municipi": "Vila-seca",
		"codi_municipi": "431711",
		"latitud": "41.129952",
		"longitud": "1.128908",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer de Sant Joan, 43206 La Plana",
		"informacio_web": "https://vila-seca.cat/refugis-climatics",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-04T11:07:00.000"
	},
	{
		":id": "row-nw67.xg83~bjfj",
		":version": "rv-9w56_k5t4.5wbr",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Cívic i Cultural de la Plana",
		"indicador_refugi": "431711|CENTRE_CIVIC_I_CULTURAL_DE_LA_PLANA",
		"municipi": "Vila-seca",
		"codi_municipi": "431711",
		"latitud": "41.12967",
		"longitud": "1.128561",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer d'Almeria, 29, 43206 La Plana",
		"informacio_web": "https://vila-seca.cat/refugis-climatics",
		"tipologia": "Centre Cívic",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-04T11:08:00.000"
	},
	{
		":id": "row-ft9i.4hbr-scdh",
		":version": "rv-ftns-vzu6.4b2e",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc can Rafart",
		"indicador_refugi": "082140|PARC_CAN_RAFART",
		"municipi": "Vilassar de Dalt",
		"codi_municipi": "082140",
		"latitud": "41.51877006207332",
		"longitud": "2.361095456600291",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "c/ Rafart, 2",
		"informacio_web": "07:00 - 23:00",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-25T12:05:00.000"
	},
	{
		":id": "row-ebj6_2dj9-6nyv",
		":version": "rv-ut56.qmx4~x3vm",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Riera Salvet (Barri del Pi)",
		"indicador_refugi": "082140|RIERA_SALVET_(BARRI_DEL_PI)",
		"municipi": "Vilassar de Dalt",
		"codi_municipi": "082140",
		"latitud": "41.513648470686775",
		"longitud": "2.3629436978340945",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "c/ Del Pi",
		"informacio_web": "horari: espai oert",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-25T14:45:00.000"
	},
	{
		":id": "row-nu3i_kwxf-fimc",
		":version": "rv-h32j.qp3v_yn7v",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Pineda Forns Romans",
		"indicador_refugi": "082140|PINEDA_FORNS_ROMANS",
		"municipi": "Vilassar de Dalt",
		"codi_municipi": "082140",
		"latitud": "41.51611039151594",
		"longitud": "2.368618736812529",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "c/ Camí de Mataró, 46-48",
		"informacio_web": "horari: espai obert",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-25T14:49:00.000"
	},
	{
		":id": "row-v7jf-98wg-sspx",
		":version": "rv-2934_c8fj_8n97",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Patis Espai Cívic Les Escoles",
		"indicador_refugi": "082140|PATIS_ESPAI_CIVIC_LES_ESCOLES",
		"municipi": "Vilassar de Dalt",
		"codi_municipi": "082140",
		"latitud": "41.513056040750385",
		"longitud": "2.3602800700695545",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "c/ Camí de can Pons, 21",
		"informacio_web": "07:00 - 22:00",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-25T14:51:00.000"
	},
	{
		":id": "row-wtzb.7pku~yk84",
		":version": "rv-5d5a~9597.58ys",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jardinets Anton Feliu",
		"indicador_refugi": "082140|JARDINETS_ANTON_FELIU",
		"municipi": "Vilassar de Dalt",
		"codi_municipi": "082140",
		"latitud": "41.51659543978594",
		"longitud": "2.358812597462281",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "c/ Anselm Clavé, 2-4",
		"informacio_web": "07:00 - 22:00",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-25T14:54:00.000"
	},
	{
		":id": "row-mh47~w9yk-quqj",
		":version": "rv-iim7.m6ww~7jhr",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina Municipal",
		"indicador_refugi": "082140|PISCINA_MUNICIPAL",
		"municipi": "Vilassar de Dalt",
		"codi_municipi": "082140",
		"latitud": "41.51971305055574",
		"longitud": "2.356296712083836",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "c/ Marquès de Barbarà, 11",
		"informacio_web": "08:00 - 20:00",
		"tipologia": "Piscines descobertes",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-25T14:58:00.000"
	},
	{
		":id": "row-v4ae_dzwv-hams",
		":version": "rv-ezmp_txma.kjam",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jardí Masia can Banús",
		"indicador_refugi": "082140|JARDI_MASIA_CAN_BANUS",
		"municipi": "Vilassar de Dalt",
		"codi_municipi": "082140",
		"latitud": "41.51936521006548",
		"longitud": "2.356484662103597",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "c/ Marquès de Barbarà, 9",
		"informacio_web": "09:00 - 17:00",
		"tipologia": "Parcs i jardins",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-26T14:26:00.000"
	},
	{
		":id": "row-39wv_fkv2_cwmx",
		":version": "rv-xpjm~mek9~smfh",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Local social",
		"indicador_refugi": "431726|LOCAL_SOCIAL",
		"municipi": "Vilaverd",
		"codi_municipi": "431726",
		"latitud": "41.33737925",
		"longitud": "1.17722807",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pl. de La Bàscula S/N",
		"tipologia": "Sala Polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-06-08T17:10:00.000"
	},
	{
		":id": "row-jaqi-8bnu-cuuc",
		":version": "rv-kni7.t6zz.qape",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal de Vilaverd",
		"indicador_refugi": "431726|PISCINA_MUNICIPAL_DE_VILAVERD",
		"municipi": "Vilaverd",
		"codi_municipi": "431726",
		"latitud": "41.337847",
		"longitud": "1.175813",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Camí Ermita s/n",
		"tipologia": "Piscines descobertes",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-08T17:04:00.000"
	},
	{
		":id": "row-zngq_dxdw~d4au",
		":version": "rv-g8x8-zp37.66yz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal de Vilobí del Penedès",
		"indicador_refugi": "083041|PISCINA_MUNICIPAL_DE_VILOBI_DEL_PENEDES",
		"municipi": "Vilobí del Penedès",
		"codi_municipi": "083041",
		"latitud": "41.38873634",
		"longitud": "1.6644333",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "No",
		"adreca": "Av. Generalitat, s/n",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-qkuh-arss.cer2",
		":version": "rv-2rn5-qd5z_9wgg",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Sala d'actes Can Roscada",
		"indicador_refugi": "172333|SALA_D_ACTES_CAN_ROSCADA",
		"municipi": "Vilobí d'Onyar",
		"codi_municipi": "172333",
		"latitud": "41.88839665",
		"longitud": "2.74275567",
		"accessibilitat": "Sí",
		"aigua": "No",
		"area_descans": "Sí",
		"adreca": "Trv. del primer d'octubre de 2017, 2",
		"tipologia": "Sala polivalent",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-mfh9-8437-newf",
		":version": "rv-na9b-ar8b~wa6y",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Llar de Jubilats",
		"indicador_refugi": "172333|LLAR_DE_JUBILATS",
		"municipi": "Vilobí d'Onyar",
		"codi_municipi": "172333",
		"latitud": "41.887712",
		"longitud": "2.739873",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Empordà, 5 de Vilobí d'Onyar",
		"informacio_web": "tarda",
		"tipologia": "Casal de Gent Gran",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-07-09T10:28:00.000"
	},
	{
		":id": "row-w3mb.bua6-tnff",
		":version": "rv-ya8h_sutx-kqry",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal de Vilopriu",
		"indicador_refugi": "172327|PISCINA_MUNICIPAL_DE_VILOPRIU",
		"municipi": "Vilopriu",
		"codi_municipi": "172327",
		"latitud": "42.14912006",
		"longitud": "2.9895998",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Zona esportiva, s/n, 17466 Vilopriu",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-29pv.p7uv-tvaf",
		":version": "rv-vjpk~xmw4.bvrf",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre de serveis",
		"indicador_refugi": "252555|CENTRE_DE_SERVEIS",
		"municipi": "Vinaixa",
		"codi_municipi": "252555",
		"latitud": "41.42803665",
		"longitud": "0.97648256",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Ctra. de tarragona, 3",
		"tipologia": "Equipament cívic",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:34:00.000"
	},
	{
		":id": "row-iyhx_k37g~jswd",
		":version": "rv-pucm~wqcw_ttd2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina",
		"indicador_refugi": "252555|PISCINA",
		"municipi": "Vinaixa",
		"codi_municipi": "252555",
		"latitud": "41.4293627",
		"longitud": "0.97077472",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Trav. Escoles, s/n",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:35:00.000"
	},
	{
		":id": "row-pahe_quey~kj3i",
		":version": "rv-ieqz~k7et_wjqx",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Col·legi",
		"indicador_refugi": "252555|COL_LEGI",
		"municipi": "Vinaixa",
		"codi_municipi": "252555",
		"latitud": "41.4288676",
		"longitud": "0.97345898",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Ctra. de Lleida, 41",
		"tipologia": "Escola / Institut",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-06-01T10:30:00.000"
	},
	{
		":id": "row-kyb9-i8nw-j52g",
		":version": "rv-g2mq_4ki6.ba9u",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Ajuntament",
		"indicador_refugi": "252555|AJUNTAMENT",
		"municipi": "Vinaixa",
		"codi_municipi": "252555",
		"latitud": "41.42821988",
		"longitud": "0.97511854",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça dels Arbres,2",
		"tipologia": "Ajuntament / Equipament Administratiu",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-06-01T10:33:00.000"
	},
	{
		":id": "row-585r_q2yg.kmwz",
		":version": "rv-c53w~uune~4mbn",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "431779|PISCINA_MUNICIPAL",
		"municipi": "Vinebre",
		"codi_municipi": "431779",
		"latitud": "41.185577",
		"longitud": "0.590914",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Carrerada, s/n",
		"tipologia": "Piscina",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:42:00.000"
	},
	{
		":id": "row-b5rr.qiy3~tqz8",
		":version": "rv-v33e_7j3a.m9nd",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "EMBARCADOR",
		"indicador_refugi": "431779|EMBARCADOR",
		"municipi": "Vinebre",
		"codi_municipi": "431779",
		"latitud": "41.174772",
		"longitud": "0.601249",
		"accessibilitat": "Sí",
		"aigua": "No",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "43179A015000380000DR",
		"tipologia": "Altres",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-01T11:34:00.000"
	},
	{
		":id": "row-u3r2-fhxn.5dp6",
		":version": "rv-exg3.kbr7_reqq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "SALA CINE",
		"indicador_refugi": "431779|SALA_CINE",
		"municipi": "Vinebre",
		"codi_municipi": "431779",
		"latitud": "41.183900659516745",
		"longitud": "0.5911749989054811",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "PLAÇA AJUNTAMENT, 6",
		"tipologia": "Sala Polivalent",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-01T11:40:00.000"
	},
	{
		":id": "row-bxre~pzuv_rmc5",
		":version": "rv-n45w-5qxg-9bhk",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "LLAR JUBILATS",
		"indicador_refugi": "431779|LLAR_JUBILATS",
		"municipi": "Vinebre",
		"codi_municipi": "431779",
		"latitud": "41.18437148257204",
		"longitud": "0.5906767175615208",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "CARRER DE LA TORR, 22 BAIX",
		"tipologia": "Casal de Gent Gran",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-01T11:43:00.000"
	},
	{
		":id": "row-2t7n~nbwb~bu4u",
		":version": "rv-cwbf-gqk5.h2b9",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca municipal",
		"indicador_refugi": "431785|BIBLIOTECA_MUNICIPAL",
		"municipi": "Vinyols i els Arcs",
		"codi_municipi": "431785",
		"latitud": "41.11298526",
		"longitud": "1.03769358",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Ptge. d'1 d'octubre",
		"tipologia": "Biblioteca",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-jp6k.wjjy.ed2k",
		":version": "rv-rdcy~9kef.qiiv",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Llar de jubilats els Arcs",
		"indicador_refugi": "431785|LLAR_DE_JUBILATS_ELS_ARCS",
		"municipi": "Vinyols i els Arcs",
		"codi_municipi": "431785",
		"latitud": "41.06856869",
		"longitud": "1.06216582",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "No",
		"adreca": "C. Josep Maria Folch i Torres, 5",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:36:00.000"
	},
	{
		":id": "row-y97k_e437.q2bv",
		":version": "rv-v9wk.pwcj~9k9f",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Llar de jubilats Vinyols",
		"indicador_refugi": "431785|LLAR_DE_JUBILATS_VINYOLS",
		"municipi": "Vinyols i els Arcs",
		"codi_municipi": "431785",
		"latitud": "41.11486883",
		"longitud": "1.04027383",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. del Centre",
		"tipologia": "Altres",
		"origen_identificador": "historicDadesObertes2025",
		"ultima_actualitzacio": "2026-05-14T13:40:00.000"
	},
	{
		":id": "row-a52s~ch5t_vfnu",
		":version": "rv-zhcw.jkqe-xs2n",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Municipal",
		"indicador_refugi": "431785|CASAL_MUNICIPAL",
		"municipi": "Vinyols i els Arcs",
		"codi_municipi": "431785",
		"latitud": "41.11318191439669",
		"longitud": "1.0376902175381542",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Ptge. d'1 d'Octubre, s/n",
		"tipologia": "Sala Polivalent",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-02T12:49:00.000"
	},
	{
		":id": "row-uar4.tzmj_js37",
		":version": "rv-x6s4.ymqj-cchw",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Local Social de Viver",
		"indicador_refugi": "083089|LOCAL_SOCIAL_DE_VIVER",
		"municipi": "Viver i Serrateix",
		"codi_municipi": "083089",
		"latitud": "41.956279108984994",
		"longitud": "1.8138777154818542",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "No",
		"lavabo": "No",
		"adreca": "Crta de Navàs a Serrateix (BV4235) km 10.2",
		"tipologia": "Centre Cívic",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-12T12:26:00.000"
	},
	{
		":id": "row-q4u5_wvyc.242v",
		":version": "rv-uj98_h98e_kxp8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "PISCINES MUNICIPALS",
		"indicador_refugi": "430521|PISCINES_MUNICIPALS",
		"municipi": "Xerta",
		"codi_municipi": "430521",
		"latitud": "40.90909",
		"longitud": "0.49364",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "CAMÍ DEL PORTAL, 17",
		"informacio_web": "http://www.xerta.cat/nuclis-de-poblacio-23",
		"tipologia": "Piscines descobertes",
		"origen_identificador": "Municipi",
		"ultima_actualitzacio": "2026-06-11T09:06:00.000"
	},
	{
		":id": "row-qe3i~rnce-5q5c",
		":version": "rv-x24k~ez75-8qtm",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bib. Barceloneta-La Fraternitat",
		"indicador_refugi": "080193|BIB_BARCELONETA_LA_FRATERNITAT",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.37923",
		"longitud": "2.188872",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Felícia Fuster i Viladecans, 8-10",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/1138134103",
		"tipologia": "Biblioteques",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ab9q.ku75_s2a3",
		":version": "rv-5m55-8y7y-e4rs",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bib. Bon Pastor - Josefina Castellví",
		"indicador_refugi": "080193|BIB_BON_PASTOR_JOSEFINA_CASTELLVI",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.4352",
		"longitud": "2.204677",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Estadella, 64",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400098833",
		"tipologia": "Biblioteques",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-vatg_xr7t-qpew",
		":version": "rv-jxbc-ed8e-fh4k",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bib. Camp de l'Arpa - Caterina Albert",
		"indicador_refugi": "080193|BIB_CAMP_DE_L_ARPA_CATERINA_ALBERT",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.4158",
		"longitud": "2.182298",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Indústria, 295",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400299968",
		"tipologia": "Biblioteques",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-jz6v~iiss~hxx6",
		":version": "rv-2rj4_2uv8_q2ap",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bib. Canyelles - M. Àngels Rivas",
		"indicador_refugi": "080193|BIB_CANYELLES_M_ANGELS_RIVAS",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.4438",
		"longitud": "2.16434",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Rda. de La Guineueta Vella, 34",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086005760",
		"tipologia": "Biblioteques",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ydxr.94x9.3nva",
		":version": "rv-c5yh-4r7r.xf4g",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bib. Clarà",
		"indicador_refugi": "080193|BIB_CLARA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.39994",
		"longitud": "2.129474",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Doctor Carulla, 22-24",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99329122806",
		"tipologia": "Biblioteques",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-5t3w.svbm~y3h2",
		":version": "rv-77i4.pg2p_yd8k",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bib. Collserola - Josep Miracle",
		"indicador_refugi": "080193|BIB_COLLSEROLA_JOSEP_MIRACLE",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.41539",
		"longitud": "2.102547",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Elisa Moragas i Badia, 16-34",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400010089",
		"tipologia": "Biblioteques",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-njyg~pc4s~4stc",
		":version": "rv-8an3-pxcb~fbiq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bib. El Carmel - Juan Marsé",
		"indicador_refugi": "080193|BIB_EL_CARMEL_JUAN_MARSE",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.42103",
		"longitud": "2.155116",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Murtra, 135-145",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400061992",
		"tipologia": "Biblioteques",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-myxj.8698.ixy2",
		":version": "rv-7425~yk77.2uh5",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bib. El Clot - Josep Benet",
		"indicador_refugi": "080193|BIB_EL_CLOT_JOSEP_BENET",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.4026",
		"longitud": "2.18805",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pl. de les Glòries Catalanes, 37-38",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400329623",
		"tipologia": "Biblioteques",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-pmyw.u7z2~ffnt",
		":version": "rv-fizf.htnu-x3zq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bib. Esquerra de l'Eixample - Agustí Centelles",
		"indicador_refugi": "080193|BIB_ESQUERRA_DE_L_EIXAMPLE_AGUSTI_CENTELLES",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.3869",
		"longitud": "2.15205",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Comte d’Urgell, 145-147",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400270325",
		"tipologia": "Biblioteques",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-k79g-tx28.u8ad",
		":version": "rv-r5wh_qkn3~s66g",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bib. Fort Pienc - Ana María Moix",
		"indicador_refugi": "080193|BIB_FORT_PIENC_ANA_MARIA_MOIX",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.39559",
		"longitud": "2.182465",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pl. del Fort Pienc, 4-5",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400037765",
		"tipologia": "Biblioteques",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-k8ws~2q72.rxuk",
		":version": "rv-tipr-vk3c.2rng",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bib. Francesc Candel",
		"indicador_refugi": "080193|BIB_FRANCESC_CANDEL",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.36181",
		"longitud": "2.136295",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Amnistia Internacional, 10",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086021426",
		"tipologia": "Biblioteques",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-mrda~jaf8~bfdu",
		":version": "rv-sytz-2h4q.z5t7",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bib. Francesca Bonnemaison",
		"indicador_refugi": "080193|BIB_FRANCESCA_BONNEMAISON",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38649",
		"longitud": "2.176176",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Sant Pere més Baix, 7",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086001171",
		"tipologia": "Biblioteques",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-g5sq-cica_5hhy",
		":version": "rv-mfav~ph28~rxk3",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bib. Gòtic - Andreu Nin",
		"indicador_refugi": "080193|BIB_GOTIC_ANDREU_NIN",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.37849",
		"longitud": "2.176065",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. La Rambla, 30-32",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400243881",
		"tipologia": "Biblioteques",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-v6rf~j7sx_mqp5",
		":version": "rv-enpd.fkrg~f3eq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bib. Guinardó - Mercè Rodoreda",
		"indicador_refugi": "080193|BIB_GUINARDO_MERCE_RODOREDA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.41289",
		"longitud": "2.162447",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Camèlies, 76-80",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99083114355",
		"tipologia": "Biblioteques",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-qqhm.y538_drid",
		":version": "rv-jvtr-dnhe-7ith",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bib. Horta - Can Mariner",
		"indicador_refugi": "080193|BIB_HORTA_CAN_MARINER",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.43114",
		"longitud": "2.160751",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Vent, 1",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400196643",
		"tipologia": "Biblioteques",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-gmju-qjd6.yyak",
		":version": "rv-3suc-s4zf~txm7",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bib. Ignasi Iglésias - Can Fabra",
		"indicador_refugi": "080193|BIB_IGNASI_IGLESIAS_CAN_FABRA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.43397",
		"longitud": "2.191338",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Segre, 24-32",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400019598",
		"tipologia": "Biblioteques",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-k8k9~diwj-arw4",
		":version": "rv-jmcr~sbrh~maxx",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bib. Joan Miró",
		"indicador_refugi": "080193|BIB_JOAN_MIRO",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.37885",
		"longitud": "2.149248",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Parc Joan Miró / Vilamarí, 61",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92168151705",
		"tipologia": "Biblioteques",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-879h~6gh3.ym65",
		":version": "rv-6was_tdqi-4czs",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bib. La Sagrera - Marina Clotet",
		"indicador_refugi": "080193|BIB_LA_SAGRERA_MARINA_CLOTET",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.42591",
		"longitud": "2.193781",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Josep Soldevila, 9",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400227877",
		"tipologia": "Biblioteques",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-gq6j_2jp6-bqjm",
		":version": "rv-xpi9_3t68.gsza",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bib. Les Roquetes - Rafa Juncadella",
		"indicador_refugi": "080193|BIB_LES_ROQUETES_RAFA_JUNCADELLA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.4454",
		"longitud": "2.177121",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Via Favència, 288 B",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086010318",
		"tipologia": "Biblioteques",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-3shp_tedw-dst8",
		":version": "rv-e9p2.sa5u~7brw",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bib. Montbau - Albert Pérez Baró",
		"indicador_refugi": "080193|BIB_MONTBAU_ALBERT_PEREZ_BARO",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.42918",
		"longitud": "2.14197",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Arquitectura, 8",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/94286172503",
		"tipologia": "Biblioteques",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-w5yu-84ws-5huy",
		":version": "rv-jnie_vrud_8aka",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bib. Montserrat Abelló",
		"indicador_refugi": "080193|BIB_MONTSERRAT_ABELLO",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38371",
		"longitud": "2.135285",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Comtes de Bell-lloc, 192-200",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086002115",
		"tipologia": "Biblioteques",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-kkkk.xjys.5cj6",
		":version": "rv-q4fk.t93d_52pm",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bib. Nou Barris - Aurora Díaz Plaja",
		"indicador_refugi": "080193|BIB_NOU_BARRIS_AURORA_DIAZ_PLAJA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.43684",
		"longitud": "2.17123",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pl. Major de Nou Barris, 2",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/97135114148",
		"tipologia": "Biblioteques",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-av3j.9zq8.cq6w",
		":version": "rv-assp_tnvd~ppmk",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bib. Poblenou - Manuel Arranz",
		"indicador_refugi": "080193|BIB_POBLENOU_MANUEL_ARRANZ",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.4014",
		"longitud": "2.204543",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Joncar, 35",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400224356",
		"tipologia": "Biblioteques",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-uahh_6ukx.9u7s",
		":version": "rv-xf5w-jegk_qgay",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bib. Poble Sec - Francesc Boix",
		"indicador_refugi": "080193|BIB_POBLE_SEC_FRANCESC_BOIX",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.37395",
		"longitud": "2.164043",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Blai, 34",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/1242142943",
		"tipologia": "Biblioteques",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-wa5q_2hus_ei3i",
		":version": "rv-37ix-atfa-gcm9",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bib. Ramon d'Alòs - Moner",
		"indicador_refugi": "080193|BIB_RAMON_D_ALOS_MONER",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.41635",
		"longitud": "2.2115",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Rbla. de Prim, 87-89 (Centre Cívic)",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086001838",
		"tipologia": "Biblioteques",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-5cu8~rcs4~tvtx",
		":version": "rv-ntde_ftpm.aqfy",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bib. Sant Antoni - Joan Oliver",
		"indicador_refugi": "080193|BIB_SANT_ANTONI_JOAN_OLIVER",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.37741",
		"longitud": "2.162796",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Comte Borrell,44-46",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400188956",
		"tipologia": "Biblioteques",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-byh5-heqv-qx2s",
		":version": "rv-svaq~pzct_85xh",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bib. Sant Gervasi - Joan Maragall",
		"indicador_refugi": "080193|BIB_SANT_GERVASI_JOAN_MARAGALL",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.40596",
		"longitud": "2.135993",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Sant Gervasi de Cassoles, 85",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400342694",
		"tipologia": "Biblioteques",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-pdb8-pe9u.274m",
		":version": "rv-nk5c-grb6-psei",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bib. Sant Pau - Santa Creu",
		"indicador_refugi": "080193|BIB_SANT_PAU_SANTA_CREU",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38049",
		"longitud": "2.170353",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Carme, 47 / Hospital, 56",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086000482",
		"tipologia": "Biblioteques",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-capm-et9j~byjm",
		":version": "rv-g962~upgu.irby",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bib. Sofia Barat",
		"indicador_refugi": "080193|BIB_SOFIA_BARAT",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.39471",
		"longitud": "2.171522",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Girona, 64-68 (interior d'illa)",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086004289",
		"tipologia": "Biblioteques",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-3tud~8dte~y6up",
		":version": "rv-nwie~79sq.67pg",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bib. Vallcarca i els Penitents - M. Antonieta Cot",
		"indicador_refugi": "080193|BIB_VALLCARCA_I_ELS_PENITENTS_M_ANTONIETA_COT",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.42004",
		"longitud": "2.139675",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pg. de la Vall d'Hebron, 65-69",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400273433",
		"tipologia": "Biblioteques",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-v9kp~gjsu_5kv3",
		":version": "rv-622w~qbrg.93xe",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bib. Vapor Vell",
		"indicador_refugi": "080193|BIB_VAPOR_VELL",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.37693",
		"longitud": "2.134752",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Ptge. Vapor Vell, s/n",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/249121118",
		"tipologia": "Biblioteques",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-2bng_dp49-vcns",
		":version": "rv-qdpk_9kmv~3jj4",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bib. Vila de Gràcia - Rosa M. Arquimbau",
		"indicador_refugi": "080193|BIB_VILA_DE_GRACIA_ROSA_M_ARQUIMBAU",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.4015",
		"longitud": "2.158232",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Torrent de l’Olla, 104",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/2123115923",
		"tipologia": "Biblioteques",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-9p9f-zy8g_pkty",
		":version": "rv-s6n4.sckd~ifty",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bib. Vilapicina i la Torre Llobeta - Carmen Laforet",
		"indicador_refugi": "080193|BIB_VILAPICINA_I_LA_TORRE_LLOBETA_CARMEN_LAFORET",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.42703",
		"longitud": "2.175994",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pl. de Carmen Laforet, 11",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99021111627",
		"tipologia": "Biblioteques",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-dg39~ter8~7i3g",
		":version": "rv-dus6.jz7r.qud4",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bib. Zona Nord - Mària Sánchez",
		"indicador_refugi": "080193|BIB_ZONA_NORD_MARIA_SANCHEZ",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.46127",
		"longitud": "2.179893",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Vallcivera, 3 bis",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400236720",
		"tipologia": "Biblioteques",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-vuyu~snyk~2aii",
		":version": "rv-x6rg~sdhu_cfn9",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bib. Les Corts - Miquel Llongueras",
		"indicador_refugi": "080193|BIB_LES_CORTS_MIQUEL_LLONGUERAS",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.37801",
		"longitud": "2.121843",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Trav. de Les Corts, 58",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/284153819",
		"tipologia": "Biblioteques",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-bay5_5wbk-usrf",
		":version": "rv-sjjb_9w9z_27qw",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CEM Can Cuyàs",
		"indicador_refugi": "080193|CEM_CAN_CUYAS",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.45992",
		"longitud": "2.168133",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No (aire lliure)",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Av. Rasos de Peguera",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086037277",
		"tipologia": "Complexos esportius",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-8k2b-pkmd_3akp",
		":version": "rv-wut4.ss5p_f3jr",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CEM Can Felipa",
		"indicador_refugi": "080193|CEM_CAN_FELIPA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.40405",
		"longitud": "2.201405",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pl. Josep M. Huertas Claveria, 1",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92168153135",
		"tipologia": "Complexos esportius",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-5aj7-wwsm.byi9",
		":version": "rv-fx3m~b7fz~y2n6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CEM Can Ricart",
		"indicador_refugi": "080193|CEM_CAN_RICART",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.37753",
		"longitud": "2.170761",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "C. Sant Oleguer, 10",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086038230",
		"tipologia": "Complexos esportius",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-apyu.i5jq_ar23",
		":version": "rv-jbw6.eh8f.xun6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CEM Can Toda",
		"indicador_refugi": "080193|CEM_CAN_TODA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.41538",
		"longitud": "2.158172",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Ctra. dEl Carmel, 5",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086003375",
		"tipologia": "Complexos esportius",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-e2pr.p5ez_e8wm",
		":version": "rv-6g63_ev4h~jx38",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CEM El Carmel",
		"indicador_refugi": "080193|CEM_EL_CARMEL",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.42321",
		"longitud": "2.158577",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Pedrell",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92132091748",
		"tipologia": "Complexos esportius",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-a25f_6jg7-fupq",
		":version": "rv-39b7.rasz_qaky",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CEM Les Corts",
		"indicador_refugi": "080193|CEM_LES_CORTS",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38541",
		"longitud": "2.133598",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Trav. de Les Corts, 252-254",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99186122857",
		"tipologia": "Complexos esportius",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-5czy-j275_b3v4",
		":version": "rv-vard-47ar-cjct",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CEM Mundet",
		"indicador_refugi": "080193|CEM_MUNDET",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.43576",
		"longitud": "2.147158",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Olympe de Gouges, s/n",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400110854",
		"tipologia": "Complexos esportius",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-3we7-wryr-xudm",
		":version": "rv-z2kk.cuih.di8w",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CEM Perill",
		"indicador_refugi": "080193|CEM_PERILL",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.39943",
		"longitud": "2.161522",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Perill",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92168175469",
		"tipologia": "Complexos esportius",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-xcur_gvem-nj4x",
		":version": "rv-rva4~yd7b-wtk7",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CEM Piscines Picornell",
		"indicador_refugi": "080193|CEM_PISCINES_PICORNELL",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.36601",
		"longitud": "2.151086",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Av. de l'Estadi, 30",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92168175397",
		"tipologia": "Complexos esportius",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-46p5_78ic-58h5",
		":version": "rv-fhgu-tbjv_ib62",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CEM Putxet",
		"indicador_refugi": "080193|CEM_PUTXET",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.40973",
		"longitud": "2.141296",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Marmellà, 23",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400247031",
		"tipologia": "Complexos esportius",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-q3w2.yj48-r2b2",
		":version": "rv-veir.ditf_apqf",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CEM Sagrada Família",
		"indicador_refugi": "080193|CEM_SAGRADA_FAMILIA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.40729",
		"longitud": "2.17932",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Cartagena, 231-239",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/75990492186",
		"tipologia": "Complexos esportius",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ghaq_td98.qkwa",
		":version": "rv-mn3i~23kt~yjcn",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CEM Vintró",
		"indicador_refugi": "080193|CEM_VINTRO",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.40669",
		"longitud": "2.186298",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Consell de Cent, 623-627",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/93050115049",
		"tipologia": "Complexos esportius",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ugat-rh28.ahhe",
		":version": "rv-bdqn~tdma.tdcp",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CEM Trinitat Vella",
		"indicador_refugi": "080193|CEM_TRINITAT_VELLA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.45124",
		"longitud": "2.193849",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Via Bàrcino, 84",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92168175394",
		"tipologia": "Complexos esportius",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-995p-45qe.5vpb",
		":version": "rv-8j7c_8eeu.ixs4",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CUESB",
		"indicador_refugi": "080193|CUESB",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.39898",
		"longitud": "2.201438",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Llacuna, 25",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086031399",
		"tipologia": "Altres",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-8hg5~dk33.umm5",
		":version": "rv-z8vs~4tb5~bhr5",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "El Centre de la Platja",
		"indicador_refugi": "080193|EL_CENTRE_DE_LA_PLATJA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38309",
		"longitud": "2.194477",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Platja Somorrostro. Sota Porxos Passeig marítim. Front Hospital del Mar",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400147294",
		"tipologia": "Equipaments Ambientals",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-5np2.h5gz_fp4x",
		":version": "rv-fyy7-nksb.kdke",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "La Fàbrica del Sol",
		"indicador_refugi": "080193|LA_FABRICA_DEL_SOL",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38219",
		"longitud": "2.191758",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pg. Salvat Papasseit s/n",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99117135915",
		"tipologia": "Equipaments Ambientals",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-m5xx~pijm_v37n",
		":version": "rv-a3yw.n8au-ygtx",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de barri Raval",
		"indicador_refugi": "080193|CASAL_DE_BARRI_RAVAL",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.37694",
		"longitud": "2.167179",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Reina Amàlia, 31",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400271344",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-iz9d.wv5w-5v4x",
		":version": "rv-uedi_rnik~68sc",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CC Besós i Maresme",
		"indicador_refugi": "080193|CC_BESOS_I_MARESME",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.41635",
		"longitud": "2.211497",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Rbla. de Prim, 87-89",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/93316140842",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-8xpt-q5p9~gqwx",
		":version": "rv-vpsi-j8uh_bcs8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de barri Congrés Indians",
		"indicador_refugi": "080193|CASAL_DE_BARRI_CONGRES_INDIANS",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.42399",
		"longitud": "2.179412",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Manigua 25-35",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086034049",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-8buh.2nuz-5rs3",
		":version": "rv-s3kt~c5bj_m97v",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CC Carmel",
		"indicador_refugi": "080193|CC_CARMEL",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.42029",
		"longitud": "2.151204",
		"accessibilitat": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Santuari, 27",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086031534",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-fyqw_v7km~5vjt",
		":version": "rv-cge9.548n-8648",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CC Cotxeres de Sants",
		"indicador_refugi": "080193|CC_COTXERES_DE_SANTS",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.3753",
		"longitud": "2.136897",
		"accessibilitat": "Sí (excepte lavabos)",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Sants, 79",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086002380",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-xbqj-inff-c7fh",
		":version": "rv-p64z-9jk2~24u2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CC El Sortidor",
		"indicador_refugi": "080193|CC_EL_SORTIDOR",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.3721",
		"longitud": "2.162548",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pl. del Sortidor, 12",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99120120846",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-znzq_snv5_cqfc",
		":version": "rv-cgnp-yx96.sywm",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CC Vil.la Urània",
		"indicador_refugi": "080193|CC_VIL_LA_URANIA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.40151",
		"longitud": "2.14989",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Saragossa, 29",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400179932",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-y6iq.vnjz.am5j",
		":version": "rv-ekbu~e644_5af3",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CC Baró de Viver",
		"indicador_refugi": "080193|CC_BARO_DE_VIVER",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.44617",
		"longitud": "2.200389",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Quito, 8",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086004979",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-uduk~iwfu.appr",
		":version": "rv-ifn6~mage.2qtx",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CC Can Basté",
		"indicador_refugi": "080193|CC_CAN_BASTE",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.43049",
		"longitud": "2.173233",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pg. Fabra i Puig, 274-276",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/95124132926",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-x9sz.s33v~4juj",
		":version": "rv-i4pc-xn27~5vzf",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CC Can Verdaguer",
		"indicador_refugi": "080193|CC_CAN_VERDAGUER",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.43409",
		"longitud": "2.179183",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Piferrer, 94-100",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400313145",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-k33c-dcqx-bh5b",
		":version": "rv-n6qi-jzzx-6w39",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Cívic Casa Golferichs",
		"indicador_refugi": "080193|CENTRE_CIVIC_CASA_GOLFERICHS",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38085",
		"longitud": "2.156407",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "G.V. Corts Catalanes, 491",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086008869",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-dy7i_yhwj~kxna",
		":version": "rv-jx4q_7mb5_sp8g",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CC Casa Orlandai",
		"indicador_refugi": "080193|CC_CASA_ORLANDAI",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.39836",
		"longitud": "2.124672",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Jaume Piquet",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400180423",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-6af7_e8xp_abwf",
		":version": "rv-47zr.snbe~j7bj",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CC Casinet d'Hostafrancs",
		"indicador_refugi": "080193|CC_CASINET_D_HOSTAFRANCS",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.37786",
		"longitud": "2.143222",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Rector Triadó, 53",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086002472",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-rpny-73wb~ndu9",
		":version": "rv-ecc3.5b5d~xc2h",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Mas Guinardó",
		"indicador_refugi": "080193|CASAL_MAS_GUINARDO",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.41608",
		"longitud": "2.173342",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Altres",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pl. Salvador Riera, 2",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400265137",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-7nca.56jj-envj",
		":version": "rv-vaqz-4uqz.7ppz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CC Joan Oliver Pere Quart",
		"indicador_refugi": "080193|CC_JOAN_OLIVER_PERE_QUART",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.37933",
		"longitud": "2.127776",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Comandant Benítez, 6",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99125133528",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-d7hv_pjqi~fbu8",
		":version": "rv-5vyp_9as6_5hnq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Cultural La  Casa Elizalde",
		"indicador_refugi": "080193|CENTRE_CULTURAL_LA_CASA_ELIZALDE",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.39452",
		"longitud": "2.165883",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. València, 302",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086007784",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-4bp4_ez97-g6yr",
		":version": "rv-u5jw~ks42-kgqw",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Cívic La Sedeta",
		"indicador_refugi": "080193|CENTRE_CIVIC_LA_SEDETA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.40558",
		"longitud": "2.167688",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Sicília, 321",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086004419",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-b829-yv5e~aqdr",
		":version": "rv-qqa2-6h7b~7sc5",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Cívic Matas i Ramis",
		"indicador_refugi": "080193|CENTRE_CIVIC_MATAS_I_RAMIS",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.43279",
		"longitud": "2.160724",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Feliu i Codina, 20",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086035681",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-gxc2_jdx9~a5nk",
		":version": "rv-xy7m.fpaf-bzbf",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CC Tomasa Cuevas - Les Corts",
		"indicador_refugi": "080193|CC_TOMASA_CUEVAS_LES_CORTS",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38482",
		"longitud": "2.128342",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Dolors Masferrer i Bosch, 33-35",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99026095631",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-yg6d~dk9v~mupk",
		":version": "rv-c55m.7svn.xpmy",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre cívic Torre Llobeta",
		"indicador_refugi": "080193|CENTRE_CIVIC_TORRE_LLOBETA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.42693",
		"longitud": "2.173966",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Santa Fe, 2 bis",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086004700",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-28yc.s5fu_tn4i",
		":version": "rv-u96t~wrgw.3akm",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de Gent Gran Mediterrània",
		"indicador_refugi": "080193|CASAL_DE_GENT_GRAN_MEDITERRANIA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.3803",
		"longitud": "2.192316",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Conreria, 1-9",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/97161084732",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-byu6-3pex-rfy8",
		":version": "rv-f3re~kdh4~23mv",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "La Lleialtat Santsenca",
		"indicador_refugi": "080193|LA_LLEIALTAT_SANTSENCA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.3729",
		"longitud": "2.136665",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Olzinelles, 31",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400477380",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-vn6g-fxtp-5hz5",
		":version": "rv-srmp_p9cc.q3ws",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de Barri Transformadors",
		"indicador_refugi": "080193|CASAL_DE_BARRI_TRANSFORMADORS",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.39344",
		"longitud": "2.178587",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Ausiàs Marc, 60",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400637478",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-r456-yb3b-fuak",
		":version": "rv-ajcq_pw77.xe9d",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Cívic Cotxeres Borrell",
		"indicador_refugi": "080193|CENTRE_CIVIC_COTXERES_BORRELL",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.37557",
		"longitud": "2.162919",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Viladomat, 2-8",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/2011131453",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-7q8p_wqc8_vph2",
		":version": "rv-ebmy_pyi5_zfam",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Barri Ateneu el Poblet",
		"indicador_refugi": "080193|CASAL_BARRI_ATENEU_EL_POBLET",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.40235",
		"longitud": "2.170377",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Nàpols, 268",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400578431",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-mz8w_btiq-5rh3",
		":version": "rv-a4e5_g5kf.k6f2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Cívic Zona Nord",
		"indicador_refugi": "080193|CENTRE_CIVIC_ZONA_NORD",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.46068",
		"longitud": "2.178346",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Vallcivera, 14",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086019602",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-vr8u.pcv3~v99d",
		":version": "rv-kjup-dus3~sxra",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CC Sagrera - La Barraca",
		"indicador_refugi": "080193|CC_SAGRERA_LA_BARRACA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.42397",
		"longitud": "2.189151",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Martí Molins, 29",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086005115",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-b3fi-322b~t6hd",
		":version": "rv-gq2y-scg4-mruc",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Museu de Cultures del Món",
		"indicador_refugi": "080193|MUSEU_DE_CULTURES_DEL_MON",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38504",
		"longitud": "2.180911",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Montcada, 12-14",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400367586",
		"tipologia": "Museus",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-e4dh.msmc.4qxm",
		":version": "rv-68xv_km2m_jfak",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Museu d'Història de Barcelona - Avantcambra Saló del Tinell",
		"indicador_refugi": "080193|MUSEU_D_HISTORIA_DE_BARCELONA_AVANTCAMBRA_SALO_DEL_TINELL",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38428",
		"longitud": "2.177341",
		"accessibilitat": "Sí",
		"aigua": "No",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pl. del Rei",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/2071125357",
		"tipologia": "Museus",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-c4m7.s92m_r8vb",
		":version": "rv-m5a5_z9np_cwiq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Museu d'Història de Barcelona - Pati de Padellàs",
		"indicador_refugi": "080193|MUSEU_D_HISTORIA_DE_BARCELONA_PATI_DE_PADELLAS",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.3838",
		"longitud": "2.177751",
		"accessibilitat": "Sí",
		"aigua": "No",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Veguer",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400147599",
		"tipologia": "Museus",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ancr.2iuv_ffn9",
		":version": "rv-k9ec.5muq-prkp",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Museu Frederic Marès",
		"indicador_refugi": "080193|MUSEU_FREDERIC_MARES",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38418",
		"longitud": "2.176805",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pl. Sant Iu, 5-6",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086001132",
		"tipologia": "Museus",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-hdip_5iwy-hkpn",
		":version": "rv-9z9k-c2b3_mbit",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Museu del Disseny de Barcelona - Dhub",
		"indicador_refugi": "080193|MUSEU_DEL_DISSENY_DE_BARCELONA_DHUB",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.40257",
		"longitud": "2.188034",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pl. De les Glòries, 37-38",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400218118",
		"tipologia": "Museus",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-52mt~q5xn.2hcs",
		":version": "rv-synx-mrig.yriu",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Museu Reial Monestir de Santa Maria de Pedralbes",
		"indicador_refugi": "080193|MUSEU_REIAL_MONESTIR_DE_SANTA_MARIA_DE_PEDRALBES",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.39534",
		"longitud": "2.11212",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Baixada del Monestir, 9",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086005213",
		"tipologia": "Museus",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-6dpt.avkf-2ewc",
		":version": "rv-wrck_ejjs.z28j",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Museu de Ciències Naturals de Barcelona - Museu Blau",
		"indicador_refugi": "080193|MUSEU_DE_CIENCIES_NATURALS_DE_BARCELONA_MUSEU_BLAU",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.41078",
		"longitud": "2.220481",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Fòrum. Pl. Leonardo da Vinci, 4-5",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400090058",
		"tipologia": "Museus",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ui5h~4mm9-3rvn",
		":version": "rv-umeh_36qa_aszr",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Museu Etnològic",
		"indicador_refugi": "080193|MUSEU_ETNOLOGIC",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.36887",
		"longitud": "2.156166",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pg. Santa Madrona, s/n",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086000174",
		"tipologia": "Museus",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-xf5s-eeqp-uz6g",
		":version": "rv-s7zr~7dj8_uuxp",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jardí Botànic Històric",
		"indicador_refugi": "080193|JARDI_BOTANIC_HISTORIC",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.36719",
		"longitud": "2.152699",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Av. Montanyans, 30-32",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400064283",
		"tipologia": "Parcs i Jardins",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-q3wp~g3nb~2jzu",
		":version": "rv-edrd_wrud.rvdj",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jardins de Ramon Margalef",
		"indicador_refugi": "080193|JARDINS_DE_RAMON_MARGALEF",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.36609",
		"longitud": "2.152965",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Av. Estadi, 42-48",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086011925",
		"tipologia": "Parcs i Jardins",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-4igz.8s74_fijq",
		":version": "rv-6xvw.3u42.ab9b",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jardí de l'Umbracle",
		"indicador_refugi": "080193|JARDI_DE_L_UMBRACLE",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.36737",
		"longitud": "2.158019",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Pg. Santa Madrona, 25",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400715967",
		"tipologia": "Parcs i Jardins",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-bc52-6mws~q475",
		":version": "rv-zk2v-biv6_vnnp",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jardins de Can Sentmenat",
		"indicador_refugi": "080193|JARDINS_DE_CAN_SENTMENAT",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.40262",
		"longitud": "2.115102",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Can Caralleu, 6-14",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/95081125600",
		"tipologia": "Parcs i Jardins",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ssaj.4uyz.a6h8",
		":version": "rv-wcrc.72uj-8t5k",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jardins de Joan  Brossa",
		"indicador_refugi": "080193|JARDINS_DE_JOAN_BROSSA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.36867",
		"longitud": "2.165013",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Pl. Dante, 9999",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400036180",
		"tipologia": "Parcs i Jardins",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-qauy.u3n6~abkq",
		":version": "rv-p7gk.rw69~jbki",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jardins de la Maternitat (manteniment Diputació)",
		"indicador_refugi": "080193|JARDINS_DE_LA_MATERNITAT_MANTENIMENT_DIPUTACIO",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38132",
		"longitud": "2.126252",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Trav. de Les Corts, 159",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/95143083146",
		"tipologia": "Parcs i Jardins",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-5ivr-zkkz.pczg",
		":version": "rv-v2tp_wnit-zvv6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jardins de la Tamarita",
		"indicador_refugi": "080193|JARDINS_DE_LA_TAMARITA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.41091",
		"longitud": "2.135331",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Pg. Sant Gervasi, 47-49",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/94165112247",
		"tipologia": "Parcs i Jardins",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ezsq.gtmn.xcss",
		":version": "rv-dxm2.jimh_f8f4",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jardins de Laribal",
		"indicador_refugi": "080193|JARDINS_DE_LARIBAL",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.36812",
		"longitud": "2.158483",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Pg. Santa Madrona, 25",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99329085212",
		"tipologia": "Parcs i Jardins",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-6mai.cp9p_wccu",
		":version": "rv-68s5~vi44.dwvr",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jardins de Palau de Pedralbes (gestionat per la Generalitat)",
		"indicador_refugi": "080193|JARDINS_DE_PALAU_DE_PEDRALBES_GESTIONAT_PER_LA_GENERALITAT",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38655",
		"longitud": "2.118435",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Av. Diagonal, 686",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086010494",
		"tipologia": "Parcs i Jardins",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-qwu9-jt3h.ahhz",
		":version": "rv-ed8v-beh2_nydh",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jardins de Pedro Muñoz Seca",
		"indicador_refugi": "080193|JARDINS_DE_PEDRO_MUNOZ_SECA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.42773",
		"longitud": "2.140747",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "C. Arquitectura, 1",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/97202125642",
		"tipologia": "Parcs i Jardins",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-z5zk.whff_3rh8",
		":version": "rv-kfpm.5zbc-mr62",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jardins de Piscines i Esports",
		"indicador_refugi": "080193|JARDINS_DE_PISCINES_I_ESPORTS",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.39314",
		"longitud": "2.135608",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "C. Doctor Fleming, 8",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400349080",
		"tipologia": "Parcs i Jardins",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-e6bd-z4we.d7py",
		":version": "rv-rj8w~dy72_dtn5",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc dEl Poblenou",
		"indicador_refugi": "080193|PARC_DEL_POBLENOU",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.39728",
		"longitud": "2.207471",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Av. Litoral, 59-71",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/96113125023",
		"tipologia": "Parcs i Jardins",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-3xgm~rg7j-t7h7",
		":version": "rv-54bh.28nr-kwwz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Espai enjardinat de la Via Trajana",
		"indicador_refugi": "080193|ESPAI_ENJARDINAT_DE_LA_VIA_TRAJANA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.42896",
		"longitud": "2.203714",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "C. Santander, 58",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400738079",
		"tipologia": "Parcs i Jardins",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ncti.769m~ina6",
		":version": "rv-9qaf-hfvw.pum5",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jardins de Vil·la Amèlia",
		"indicador_refugi": "080193|JARDINS_DE_VIL_LA_AMELIA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.39391",
		"longitud": "2.121187",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Eduardo Conde, 22",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086011931",
		"tipologia": "Parcs i Jardins",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-s5fs.c98n~nv6i",
		":version": "rv-uv2s~bhbz_2hem",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jardins del Dr.Pla i Armengol",
		"indicador_refugi": "080193|JARDINS_DEL_DR_PLA_I_ARMENGOL",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.41601",
		"longitud": "2.16992",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Av. Mare de Déu de Montserrat, 132",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400643473",
		"tipologia": "Parcs i Jardins",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-acqr.x9di~ng72",
		":version": "rv-5twn~epzk_75gg",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Mirador dEl Poble-sec",
		"indicador_refugi": "080193|MIRADOR_DEL_POBLE_SEC",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.37208",
		"longitud": "2.170647",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Pg. Montjuïc, 59",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/95125123610",
		"tipologia": "Parcs i Jardins",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-e95p_jmmz~gru4",
		":version": "rv-qbnk~ujpg.5i8x",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Creueta del Coll",
		"indicador_refugi": "080193|PARC_CREUETA_DEL_COLL",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.41926",
		"longitud": "2.146252",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pg. de la Mare de Déu del Coll, 77",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086020872",
		"tipologia": "Parcs i Jardins",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-fwqx-3zzg.ti9n",
		":version": "rv-tsd6.kkdz_djnz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de Can Sabaté",
		"indicador_refugi": "080193|PARC_DE_CAN_SABATE",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.36437",
		"longitud": "2.13775",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "C. Mineria, 16",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086029921",
		"tipologia": "Parcs i Jardins",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-xspt_syih.wzci",
		":version": "rv-3sj8-6zbe.7i5g",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de Cervantes",
		"indicador_refugi": "080193|PARC_DE_CERVANTES",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38457",
		"longitud": "2.109439",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Av. Diagonal, 706",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086010721",
		"tipologia": "Parcs i Jardins",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-keak-e5dx~s3kc",
		":version": "rv-sufq_c7zu.53gf",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de Diagonal Mar",
		"indicador_refugi": "080193|PARC_DE_DIAGONAL_MAR",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.40849",
		"longitud": "2.212232",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "C. Llull, 356 - 360",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99085102712",
		"tipologia": "Parcs i Jardins",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-5uqh~vrrh.cy6h",
		":version": "rv-n2pc_2h4p.6aat",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de Josep Maria Serra i Martí",
		"indicador_refugi": "080193|PARC_DE_JOSEP_MARIA_SERRA_I_MARTI",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.44296",
		"longitud": "2.165954",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "C. Miguel Hernández, 16",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/97248100532",
		"tipologia": "Parcs i Jardins",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-2dmi-98zt~b3f4",
		":version": "rv-r8q9_er3s_38ia",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de la Barceloneta",
		"indicador_refugi": "080193|PARC_DE_LA_BARCELONETA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38206",
		"longitud": "2.193838",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pg. Marítim de la Barceloneta, 15-21",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/96269141552",
		"tipologia": "Parcs i Jardins",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-4k39.92g4-gwna",
		":version": "rv-jnp2_p94g_659m",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de La Ciutadella",
		"indicador_refugi": "080193|PARC_DE_LA_CIUTADELLA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38634",
		"longitud": "2.185382",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pg. de Picasso, 21",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086011921",
		"tipologia": "Parcs i Jardins",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-gif7.xttv-62xi",
		":version": "rv-hj4z~y265-j7mi",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de la Font Florida",
		"indicador_refugi": "080193|PARC_DE_LA_FONT_FLORIDA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.36863",
		"longitud": "2.14105",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "C. Font Florida, 102",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/95125123838",
		"tipologia": "Parcs i Jardins",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-b88h~mszs-q6kb",
		":version": "rv-ephm_rauv.bmd6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de la Pegaso",
		"indicador_refugi": "080193|PARC_DE_LA_PEGASO",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.42689",
		"longitud": "2.190739",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "C. Sagrera 179-197",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086017159",
		"tipologia": "Parcs i Jardins",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-99cc~74xi_9tyf",
		":version": "rv-hq3v~gviu-jyqb",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de les Aigües",
		"indicador_refugi": "080193|PARC_DE_LES_AIGUES",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.41358",
		"longitud": "2.165481",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Pl. Alfons el Savi, 3",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086011955",
		"tipologia": "Parcs i Jardins",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-jdms_bi8j_ce9h",
		":version": "rv-45vz-xhuf.dhg4",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de Monterols",
		"indicador_refugi": "080193|PARC_DE_MONTEROLS",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.40161",
		"longitud": "2.139774",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "C. Muntaner, 450",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086011940",
		"tipologia": "Parcs i Jardins",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-wj2g-p2md-t4st",
		":version": "rv-gy2q.a9p7~w7sz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de Sant Martí",
		"indicador_refugi": "080193|PARC_DE_SANT_MARTI",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.4199",
		"longitud": "2.198052",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "C. Menorca, 64",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086029922",
		"tipologia": "Parcs i Jardins",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-j847_ffyh.awgk",
		":version": "rv-txec-t8sy_jntv",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc del Centre de Poblenou",
		"indicador_refugi": "080193|PARC_DEL_CENTRE_DE_POBLENOU",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.40679",
		"longitud": "2.199757",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Av. Diagonal, 130",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400201005",
		"tipologia": "Parcs i Jardins",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-kbi4-ef8w~qdgb",
		":version": "rv-g4yq~k9sa.imn9",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc dEl Clot",
		"indicador_refugi": "080193|PARC_DEL_CLOT",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.40847",
		"longitud": "2.190015",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "C. Escultors Claperós, 55-63",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086017160",
		"tipologia": "Parcs i Jardins",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-qbk9~dxqg~gshm",
		":version": "rv-pmu9.vigi_p48w",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc dEl Guinardó",
		"indicador_refugi": "080193|PARC_DEL_GUINARDO",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.41949",
		"longitud": "2.169614",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "C. Garriga i Roca, 1-13",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086011954",
		"tipologia": "Parcs i Jardins",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-wxqc-v35f.rp7w",
		":version": "rv-67j8~dned-nbg7",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc del Mirador del Migdia",
		"indicador_refugi": "080193|PARC_DEL_MIRADOR_DEL_MIGDIA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.35976",
		"longitud": "2.152844",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Pg. del Migdia, 156 - 174",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/1116122215",
		"tipologia": "Parcs i Jardins",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-w5fb-kb7z.kn4b",
		":version": "rv-2q8m.zp43.txj8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc del Putxet",
		"indicador_refugi": "080193|PARC_DEL_PUTXET",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.40775",
		"longitud": "2.142518",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "C. Manacor, 9",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086011938",
		"tipologia": "Parcs i Jardins",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-8fke_gx6d-sfhd",
		":version": "rv-8rk4-f4up-sczg",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc dEl Turó de la Peira",
		"indicador_refugi": "080193|PARC_DEL_TURO_DE_LA_PEIRA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.43346",
		"longitud": "2.163447",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Pg. Fabra i Puig, 396",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086011958",
		"tipologia": "Parcs i Jardins",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-986f.gee3_5in2",
		":version": "rv-jivg_u6bn-5c98",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Espanya Industrial",
		"indicador_refugi": "080193|PARC_ESPANYA_INDUSTRIAL",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.37654",
		"longitud": "2.139874",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "C. Muntadas, 1",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086015836",
		"tipologia": "Parcs i Jardins",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-pwin~i7rv_gzib",
		":version": "rv-45eg.eqp5_7zux",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Esportiu Can Dragó",
		"indicador_refugi": "080193|PARC_ESPORTIU_CAN_DRAGO",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.43659",
		"longitud": "2.183157",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "C. Rosselló i Porcel, 7",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/98294161742",
		"tipologia": "Parcs i Jardins",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-s9gt~5abw.93uc",
		":version": "rv-e87s_nfcy-3qfd",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Park Güell",
		"indicador_refugi": "080193|PARK_GUELL",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.41351",
		"longitud": "2.153127",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Olot, 7",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086011949",
		"tipologia": "Parcs i Jardins",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-habf-2mia~zrrz",
		":version": "rv-ydv9.zuxj-gfq3",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Guineueta",
		"indicador_refugi": "080193|PARC_GUINEUETA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.43905",
		"longitud": "2.174489",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Pl. de la República, 9*LB",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086011957",
		"tipologia": "Parcs i Jardins",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-8ybp~mupn-nbtx",
		":version": "rv-svg6_rhby~3534",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça de la Farga",
		"indicador_refugi": "080193|PLACA_DE_LA_FARGA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.37245",
		"longitud": "2.138837",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Pl. Farga, 1",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400738073",
		"tipologia": "Parcs i Jardins",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-pwts~7dgg_dbiw",
		":version": "rv-my5d-jzes.qy6z",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Turó Park",
		"indicador_refugi": "080193|TURO_PARK",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.39411",
		"longitud": "2.141916",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Av. Pau Casals, 19",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086011942",
		"tipologia": "Parcs i Jardins",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-jbd3~zfh7.k98m",
		":version": "rv-v8w2-pkrf~b9j9",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Pati de l'escola Font d'en Fargas",
		"indicador_refugi": "080193|PATI_DE_L_ESCOLA_FONT_D_EN_FARGAS",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.42267",
		"longitud": "2.16522",
		"accessibilitat": "No",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Pg. Font d'en Fargas, 65",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400737861",
		"tipologia": "Patis d'Escola",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-2xni.7qy7.443k",
		":version": "rv-x4ib~5nf3~cvd9",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Pati de l'escola Rius i Taulet",
		"indicador_refugi": "080193|PATI_DE_L_ESCOLA_RIUS_I_TAULET",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.4079",
		"longitud": "2.15034",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Pl. Lesseps, 19",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400780755",
		"tipologia": "Patis d'Escola",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-c6qu_r2bn-8pwp",
		":version": "rv-msiu~82tr_qwpc",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CEM Olímpics Vall d'Hebron",
		"indicador_refugi": "080193|CEM_OLIMPICS_VALL_D_HEBRON",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.42817",
		"longitud": "2.144965",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pg. Vall Hebron, 166-176",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92170123435",
		"tipologia": "Complexos esportius",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-w3wi-zabj-bswf",
		":version": "rv-8ucf_vvcc-4qua",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CEM Can Dragó",
		"indicador_refugi": "080193|CEM_CAN_DRAGO",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.43655",
		"longitud": "2.183086",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Rosselló i Pòrcel, 7",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086032989",
		"tipologia": "Complexos esportius",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-emqi~urbd-y3fz",
		":version": "rv-prt6.amdw-zg4t",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CEM Bac de Roda",
		"indicador_refugi": "080193|CEM_BAC_DE_RODA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.41445",
		"longitud": "2.194065",
		"accessibilitat": "Sí",
		"aigua": "No",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Rbla. Guipúscoa, 23-25",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/98056162156",
		"tipologia": "Complexos esportius",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-wd8k~u6kp.4q54",
		":version": "rv-2pju-x9a4-wfg4",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CEM Júpiter",
		"indicador_refugi": "080193|CEM_JUPITER",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.41765",
		"longitud": "2.202128",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "C. Agricultura, 232",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086005147",
		"tipologia": "Complexos esportius",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-z4ie.2syg_prem",
		":version": "rv-ttyd~jkxm_yepy",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CEM Can Caralleu",
		"indicador_refugi": "080193|CEM_CAN_CARALLEU",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.40162",
		"longitud": "2.110814",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Esports, 2-8",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086010504",
		"tipologia": "Complexos esportius",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-2u4m~xi9k-mauz",
		":version": "rv-t2q4_uz4m.9pt2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CEM Cotxeres",
		"indicador_refugi": "080193|CEM_COTXERES",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.4267",
		"longitud": "2.176853",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pl. de Carmen Laforet, 7",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400270882",
		"tipologia": "Complexos esportius",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-u2g2_uveq_pn2s",
		":version": "rv-bfxv-sizv-mka4",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CEM Claror",
		"indicador_refugi": "080193|CEM_CLAROR",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.40447",
		"longitud": "2.170997",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Sardenya, 333",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92168152807",
		"tipologia": "Complexos esportius",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-j5g6_xfqd_dxvc",
		":version": "rv-s2g7.g5s5~mbej",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CEM Parc de la Ciutadella",
		"indicador_refugi": "080193|CEM_PARC_DE_LA_CIUTADELLA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38535",
		"longitud": "2.18634",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pg. Circumval·lació, 1",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/93053131509",
		"tipologia": "Complexos esportius",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-2igg_6cas-sprz",
		":version": "rv-dqqn_ef7b_i6zt",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CC Can Castelló",
		"indicador_refugi": "080193|CC_CAN_CASTELLO",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.3991",
		"longitud": "2.139963",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Castelló, 1-7",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400197043",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-fjme.taij_zcmh",
		":version": "rv-q3ew_zdd6-8qmz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de la Trinitat",
		"indicador_refugi": "080193|PARC_DE_LA_TRINITAT",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.44865",
		"longitud": "2.194313",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pg. Santa Coloma, 60",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/93188125133",
		"tipologia": "Parcs i Jardins",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-vwvz.j35z-2329",
		":version": "rv-nzn9.zwkd~3r7e",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casa de les aigües",
		"indicador_refugi": "080193|CASA_DE_LES_AIGUES",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.4542081",
		"longitud": "2.1866053",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Ctra. de Ribes 103-111",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400780769",
		"tipologia": "Parcs i Jardins",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-dgv9.qsyd~ar28",
		":version": "rv-tsbk-aak3-wuwq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jardins de la Massana",
		"indicador_refugi": "080193|JARDINS_DE_LA_MASSANA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.427",
		"longitud": "2.17931",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "C. Felip II, 216",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99106095835",
		"tipologia": "Parcs i Jardins",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-pfyv~y2c3-i94k",
		":version": "rv-je7g~h4mu-3puh",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bib. Gabriel García Márquez",
		"indicador_refugi": "080193|BIB_GABRIEL_GARCIA_MARQUEZ",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.41717",
		"longitud": "2.20009",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pl. de Carmen Balcells Segalà, 1",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400659716",
		"tipologia": "Biblioteques",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-jm4c-q8f6_iwit",
		":version": "rv-piip-wkaj-dnxa",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de Gent Gran Baró de Viver",
		"indicador_refugi": "080193|CASAL_DE_GENT_GRAN_BARO_DE_VIVER",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.44617",
		"longitud": "2.200389",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Quito, 8",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086011152",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-wufk_fxgn.xmv3",
		":version": "rv-dux5-6443-vtee",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Gent Gran Carlit",
		"indicador_refugi": "080193|CASAL_GENT_GRAN_CARLIT",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.39731",
		"longitud": "2.174749",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Roger de Flor, 162",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/95062124013",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-xa5p-5zy6_28cu",
		":version": "rv-9tmy_3ixb.98yw",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Espai de Gent Gran M. Aurèlia Capmany",
		"indicador_refugi": "080193|ESPAI_DE_GENT_GRAN_M_AURELIA_CAPMANY",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.39029",
		"longitud": "2.15891",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Enric Granados, 47",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92184122533",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ck3u-49rt.xq88",
		":version": "rv-p4tr-pgb8-2yn8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Gent Gran Sant Cristòfol",
		"indicador_refugi": "080193|CASAL_GENT_GRAN_SANT_CRISTOFOL",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.358",
		"longitud": "2.135181",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Bronze, 5",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/1344091708",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-mzw4_9bxw.sqvg",
		":version": "rv-4xvn~x5tn_zdzd",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Gent Gran La Capa",
		"indicador_refugi": "080193|CASAL_GENT_GRAN_LA_CAPA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.35996",
		"longitud": "2.142622",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Alts Forns, 82-86",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/95025093613",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-niqe~pm33-uwze",
		":version": "rv-f29s-35qj_264b",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Espai Gent Gran El Polvorí",
		"indicador_refugi": "080193|ESPAI_GENT_GRAN_EL_POLVORI",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.36349",
		"longitud": "2.141508",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Guadalquivir 2",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086011107",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-jnc3_537f_udzx",
		":version": "rv-nmmw-r3wd~3uyn",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de Gent Gran Poble-sec",
		"indicador_refugi": "080193|CASAL_DE_GENT_GRAN_POBLE_SEC",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.37208",
		"longitud": "2.162533",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pl. del Sortidor, 12",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086011112",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-vjqi~6zwa_88cv",
		":version": "rv-4zrk_vax5-ks5u",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de gent gran Cotxeres de Sants",
		"indicador_refugi": "080193|CASAL_DE_GENT_GRAN_COTXERES_DE_SANTS",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.3746",
		"longitud": "2.136394",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Ptge. Fructuós Gelabert, s/n",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086002379",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-25wx_sk8t-53ue",
		":version": "rv-g63d.dxrf-q9aw",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CGG Can Castelló",
		"indicador_refugi": "080193|CGG_CAN_CASTELLO",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.3991",
		"longitud": "2.139963",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Castelló, 1-7",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086032960",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-bay9-furv-nt8y",
		":version": "rv-jcz7-8k7d.vwvu",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de GG Sant Ildefons",
		"indicador_refugi": "080193|CASAL_DE_GG_SANT_ILDEFONS",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.39689",
		"longitud": "2.147447",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. de Marià Cubí, 111",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086011117",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-s6gz-5qxk-4ruv",
		":version": "rv-26c8.3qdg.s86u",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CGG Baix Guinardó",
		"indicador_refugi": "080193|CGG_BAIX_GUINARDO",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.40945",
		"longitud": "2.168134",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Marina, 380",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/98293140237",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-435i~wvy3-9xfj",
		":version": "rv-y4rj~xejk_iub5",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CGG Horta",
		"indicador_refugi": "080193|CGG_HORTA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.43435",
		"longitud": "2.161593",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Feliu i Codina, 37",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400079710",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-63jf-5kv3.m5fv",
		":version": "rv-iftt.29n5~4ppb",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CGG Sant Genís",
		"indicador_refugi": "080193|CGG_SANT_GENIS",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.42603",
		"longitud": "2.137926",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Naïm, 10",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400521766",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-tg56_j3dq-fpum",
		":version": "rv-mvba~aive~y5sn",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CGG Vall Hebron",
		"indicador_refugi": "080193|CGG_VALL_HEBRON",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.43235",
		"longitud": "2.146808",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Arquitecte Moragas, 5",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400215764",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-spg7~ahbf~83cv",
		":version": "rv-d5gi~ixxz-vhtx",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Cívic Teixonera",
		"indicador_refugi": "080193|CENTRE_CIVIC_TEIXONERA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.42252",
		"longitud": "2.144592",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Arenys, 75",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/95020142037",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-svag_zhsh~twgc",
		":version": "rv-yuym-ytqz.w2aj",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CGG Navas",
		"indicador_refugi": "080193|CGG_NAVAS",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.41686",
		"longitud": "2.181542",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Capella, 16",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086029816",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-egt9-8xnj-p72f",
		":version": "rv-h5fy_yi2g_27vv",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CGG La Palmera",
		"indicador_refugi": "080193|CGG_LA_PALMERA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.42273",
		"longitud": "2.185015",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Olesa, 41-43",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086011154",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-4gm4_w9ik~jd5m",
		":version": "rv-p7e7_28v5.t8uk",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CGG Bascònia",
		"indicador_refugi": "080193|CGG_BASCONIA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.4360140622945",
		"longitud": "2.18702115945097",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Bascònia 42",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086026574",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ywr6_mnzi~eip8",
		":version": "rv-cksx-aax4~vmyu",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CGG BonPastor",
		"indicador_refugi": "080193|CGG_BONPASTOR",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.4381",
		"longitud": "2.205187",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Ardevol s/n",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086011153",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-cypm_8pa6~zfpf",
		":version": "rv-8mrn_jim8~7nt8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CGG Trinitat Vella",
		"indicador_refugi": "080193|CGG_TRINITAT_VELLA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.45009",
		"longitud": "2.189354",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Ctra. de Ribes, 85",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400658013",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-imm8-gtxr_mfqt",
		":version": "rv-b9au~7iqv.4muc",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CC Trinitat Vella",
		"indicador_refugi": "080193|CC_TRINITAT_VELLA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.45161",
		"longitud": "2.191178",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Foradada, 36",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086017153",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-pa4r_w3sb-s6gr",
		":version": "rv-v5pz-schb_dnsu",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CC Bon Pastor",
		"indicador_refugi": "080193|CC_BON_PASTOR",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.4348",
		"longitud": "2.204793",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pl. Robert Gerhard, 3",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086029928",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-u3bq~kw2b_7tdy",
		":version": "rv-3w8y_9wem.crct",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CPG Joan Maragall",
		"indicador_refugi": "080193|CPG_JOAN_MARAGALL",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.41337",
		"longitud": "2.217492",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Bermejo, 1",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086033691",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-uxxw_mmt5.b3x3",
		":version": "rv-5ez4_vzw6_28kq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CPG La Verneda Alta",
		"indicador_refugi": "080193|CPG_LA_VERNEDA_ALTA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.42548",
		"longitud": "2.204736",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Binèfar, 16",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086010421",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-hmmm-zams~tkjd",
		":version": "rv-7f5h~xzyg~8nhg",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CPG Joan Casanelles",
		"indicador_refugi": "080193|CPG_JOAN_CASANELLES",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.41177",
		"longitud": "2.193098",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Concili de Trento, 35",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400153850",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-v3k6_svz7-kb4i",
		":version": "rv-b7mb~4253.uxpk",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CPG Parc del Clot",
		"indicador_refugi": "080193|CPG_PARC_DEL_CLOT",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.40854",
		"longitud": "2.191703",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pl. Joan Casanelles, 1",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400369552",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-dsgj_v4f5-p7ak",
		":version": "rv-r6z4.qxg3_rryt",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CPG de Ca L’Isidret",
		"indicador_refugi": "080193|CPG_DE_CA_L_ISIDRET",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.41673",
		"longitud": "2.206812",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Josep Pla, 174",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400707246",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-agsn.885d_9siu",
		":version": "rv-pgtk-umvy-g7wg",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CPG Quatre Cantons",
		"indicador_refugi": "080193|CPG_QUATRE_CANTONS",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.40679",
		"longitud": "2.204013",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Camí Antic de Valencia, 96",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400245996",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-bhxb-9jcy-zu3d",
		":version": "rv-xyxi_eznu-6y92",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CPG El Taulat",
		"indicador_refugi": "080193|CPG_EL_TAULAT",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.40141",
		"longitud": "2.204581",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Llull, 214",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086011175",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-c5ku~iyaj_7g3p",
		":version": "rv-atgj-7tpz.7tck",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CPG Parc Sandaru",
		"indicador_refugi": "080193|CPG_PARC_SANDARU",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.39168",
		"longitud": "2.184574",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Buenaventura Muñoz, 21",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086011165",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-7x93-dfcp~6iez",
		":version": "rv-5gst.ii5u~8pdy",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Pati de l'escola Ramon Llull",
		"indicador_refugi": "080193|PATI_DE_L_ESCOLA_RAMON_LLULL",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.40099",
		"longitud": "2.17767",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Av. Diagonal, 275",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400780836",
		"tipologia": "Patis d'Escola",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-sw94~ndfa~384b",
		":version": "rv-um7a_hu6i_9cba",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de gent gran Can Novell",
		"indicador_refugi": "080193|CASAL_DE_GENT_GRAN_CAN_NOVELL",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38233",
		"longitud": "2.134141",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Caballero, 29",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400694393",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-s9f4-wpby_ss48",
		":version": "rv-jdft~ikci-pz25",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de gent gran Pati Llimona",
		"indicador_refugi": "080193|CASAL_DE_GENT_GRAN_PATI_LLIMONA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38163",
		"longitud": "2.179707",
		"accessibilitat": "Sí (excepte lavabos)",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Correu Vell, 5",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086011059",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-7vta_qni8-5uv2",
		":version": "rv-q8vc-uxzb-gkuv",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bib. Sagrada Família - Josep M. Ainaud de Lasarte",
		"indicador_refugi": "080193|BIB_SAGRADA_FAMILIA_JOSEP_M_AINAUD_DE_LASARTE",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.4057",
		"longitud": "2.176274",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Provença, 480",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400187152",
		"tipologia": "Biblioteques",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-4b9t-98wt-wpab",
		":version": "rv-qsh4.2sui.45u6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Seu del Districte de Ciutat Vella",
		"indicador_refugi": "080193|SEU_DEL_DISTRICTE_DE_CIUTAT_VELLA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38396",
		"longitud": "2.16931",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pl. de Vicenç Martorell, 6",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400738969",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-pyhg~wqta-egjk",
		":version": "rv-u2rj_2vep-besj",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CC Convent Sant Agustí",
		"indicador_refugi": "080193|CC_CONVENT_SANT_AGUSTI",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38743",
		"longitud": "2.181695",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. del Comerç, 36",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/98286141841",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-gste~u7ee.ygxa",
		":version": "rv-vx4v-igiy~uqvd",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Espai Jove Palau Alòs",
		"indicador_refugi": "080193|ESPAI_JOVE_PALAU_ALOS",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38818",
		"longitud": "2.178533",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Sant Pere Més Baix, 55",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400270019",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-8jak.u5ca.tnrc",
		":version": "rv-dfzp_p8pa~jtkf",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Seu Districte de l'Eixample",
		"indicador_refugi": "080193|SEU_DISTRICTE_DE_L_EIXAMPLE",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.39578",
		"longitud": "2.169425",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Aragó, 311",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400738971",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-dpi5_t3uf.s6au",
		":version": "rv-pjc8-tqd7_uq7q",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de gent gran Sant Ramon",
		"indicador_refugi": "080193|CASAL_DE_GENT_GRAN_SANT_RAMON",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.3775",
		"longitud": "2.113564",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Cardenal Reig, 11",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/2107115305",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-6cak~zhr9-mif5",
		":version": "rv-2dgk_hdb7_tb3u",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CC Josep M Trias i Peitx",
		"indicador_refugi": "080193|CC_JOSEP_M_TRIAS_I_PEITX",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.3778",
		"longitud": "2.121739",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Riera Blanca, 1-3",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/90120343",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-3bfy~uxwi~j2h5",
		":version": "rv-mv45.yxvd-7bay",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CC Pere Pruna",
		"indicador_refugi": "080193|CC_PERE_PRUNA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.4033",
		"longitud": "2.131208",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Ganduixer, 130",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/136112242",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-2hr5-e7cv.huge",
		":version": "rv-uvc9_kj9x_jpk8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casa de l'Aigua de Trinitat Nova",
		"indicador_refugi": "080193|CASA_DE_L_AIGUA_DE_TRINITAT_NOVA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.45359",
		"longitud": "2.187544",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Garbí, 2",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400576085",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-jzan.uy9i-gx48",
		":version": "rv-g6br.paun_f4t4",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de barri Can Portabella",
		"indicador_refugi": "080193|CASAL_DE_BARRI_CAN_PORTABELLA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.4291",
		"longitud": "2.193945",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Virgili, 18",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400143980",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-hcav.zr4i_6wnk",
		":version": "rv-kd5n.6b4x-f4su",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de Barri Torre de La Sagrera",
		"indicador_refugi": "080193|CASAL_DE_BARRI_TORRE_DE_LA_SAGRERA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.42385",
		"longitud": "2.192038",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Berenguer de Palou, 64",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400549439",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-d82n~c2kc-82pv",
		":version": "rv-jry4-zjf8~fb7x",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Pati de l'Escola Bressol Municipal Pau",
		"indicador_refugi": "080193|PATI_DE_L_ESCOLA_BRESSOL_MUNICIPAL_PAU",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.37671",
		"longitud": "2.140099",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No (aire lliure)",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C/ Muntades 1",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400737876",
		"tipologia": "Patis d'Escola Bressol",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-nf2d-wzrb-6a9k",
		":version": "rv-abky.6ry4.ig47",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Pati de l'Escola Bressol Municipal El Cargol",
		"indicador_refugi": "080193|PATI_DE_L_ESCOLA_BRESSOL_MUNICIPAL_EL_CARGOL",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.42709",
		"longitud": "2.167203",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No (aire lliure)",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C/ Mossèn Josep Bundó, 6",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400737879",
		"tipologia": "Patis d'Escola Bressol",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-tbks.2jfc-3pzn",
		":version": "rv-ss9j.fmqq-skzh",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Pati de l'Escola Bressol Municipal Gràcia",
		"indicador_refugi": "080193|PATI_DE_L_ESCOLA_BRESSOL_MUNICIPAL_GRACIA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.40816",
		"longitud": "2.149672",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No (aire lliure)",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C/ Maignon, 2,",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400776970",
		"tipologia": "Patis d'Escola Bressol",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-tm6m_te6i-mqgy",
		":version": "rv-9qck~z8w4_dxkq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Pati de l'Escola Bressol Municipal Ralet",
		"indicador_refugi": "080193|PATI_DE_L_ESCOLA_BRESSOL_MUNICIPAL_RALET",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.44255",
		"longitud": "2.182902",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No (aire lliure)",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C/Joaquim valls, 10",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400737886",
		"tipologia": "Patis d'Escola Bressol",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-esvn~hku5_sbq8",
		":version": "rv-96zm_22uz.qt3u",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CCCB, Centre de Cultura Contemporània de Barcelona",
		"indicador_refugi": "080193|CCCB_CENTRE_DE_CULTURA_CONTEMPORANIA_DE_BARCELONA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.3837",
		"longitud": "2.166633",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. de Montalegre, 5",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/94042144909",
		"tipologia": "Museus",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-hikr~pugk.sw8r",
		":version": "rv-is2h.cn9q_vxa4",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "MACBA",
		"indicador_refugi": "080193|MACBA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38305",
		"longitud": "2.166922",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pl. dels Àngels, 1",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/94354123927",
		"tipologia": "Museus",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-7z4n_c53q~kwuw",
		":version": "rv-4wws.rnmb~qg3z",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Espai de gent gran Esquerra de l'Eixample",
		"indicador_refugi": "080193|ESPAI_DE_GENT_GRAN_ESQUERRA_DE_L_EIXAMPLE",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38691",
		"longitud": "2.149037",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Rosselló, 78-80",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400080055",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-mcgu_9zpj~ab93",
		":version": "rv-z8wm~i6gr_gg2p",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CGG Mossèn Clapés",
		"indicador_refugi": "080193|CGG_MOSSEN_CLAPES",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.44283",
		"longitud": "2.187734",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Gran de Sant Andreu, 467 Passatge Interior",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400143470",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-7t5d.hppz_wmz6",
		":version": "rv-3eyh-w6vw-3uha",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Pati de l'Escola Bressol Municipal Valldaura",
		"indicador_refugi": "080193|PATI_DE_L_ESCOLA_BRESSOL_MUNICIPAL_VALLDAURA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.43711",
		"longitud": "2.156376",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No (aire lliure)",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pg. Valldaura, 18",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400737889",
		"tipologia": "Patis d'Escola Bressol",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-b659.7p6p~tvsi",
		":version": "rv-6cij_pqyd_wved",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Pati de l'Escola Bressol Municipal Canigó",
		"indicador_refugi": "080193|PATI_DE_L_ESCOLA_BRESSOL_MUNICIPAL_CANIGO",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38252",
		"longitud": "2.16775",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No (aire lliure)",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C/ Àngels, 7",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400737891",
		"tipologia": "Patis d'Escola Bressol",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-zat5.fzrp_smdg",
		":version": "rv-yius~z5e3-kgb3",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Espai Montserrat Olivella",
		"indicador_refugi": "080193|ESPAI_MONTSERRAT_OLIVELLA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38697",
		"longitud": "2.145548",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Calàbria, 260",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400548914",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-vf9f.kvt9_n35t",
		":version": "rv-kk7z-ugax_b3pz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CC Font de la Guatlla",
		"indicador_refugi": "080193|CC_FONT_DE_LA_GUATLLA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.37046",
		"longitud": "2.147601",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Rabí Rubèn, 22",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/94322130925",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-axne-66kp~9vmk",
		":version": "rv-n4zw-fqhe.jp28",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre d’Informació del Parc Natural de la Serra de Collserola",
		"indicador_refugi": "080193|CENTRE_D_INFORMACIO_DEL_PARC_NATURAL_DE_LA_SERRA_DE_COLLSEROLA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.41968",
		"longitud": "2.101238",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Ctra. de l’Església, 92",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086029624",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-3bj8~za69~uay4",
		":version": "rv-kzkd.yrs7_gfkc",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Pati de l'escola Mercè Rodoreda",
		"indicador_refugi": "080193|PATI_DE_L_ESCOLA_MERCE_RODOREDA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.44591",
		"longitud": "2.185579",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "C. del Vesuvi, 35  (entrada per Av. Meridiana)",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400737906",
		"tipologia": "Patis d'Escola",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-w2ex-zhan~z55m",
		":version": "rv-7vy7.e92x_98d4",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Rector Gabriel Ferraté (UPC)",
		"indicador_refugi": "080193|BIBLIOTECA_RECTOR_GABRIEL_FERRATE_UPC",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38771",
		"longitud": "2.112624",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Jordi Girona, 1-3",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/96355142237",
		"tipologia": "Biblioteques",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-i7z2~vnpx.bd7k",
		":version": "rv-9hvt.7dye.4q93",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca de l'Escola Tècnica Superior d'Enginyeria Industrial de Barcelona (UPC)",
		"indicador_refugi": "080193|BIBLIOTECA_DE_L_ESCOLA_TECNICA_SUPERIOR_D_ENGINYERIA_INDUSTRIAL_DE_BARCELONA_UPC",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38483",
		"longitud": "2.115259",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Av. Diagonal, 647",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086010030",
		"tipologia": "Biblioteques",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-kqb5-8axm-vrcj",
		":version": "rv-fp4x_74t3-yp7g",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Oriol Bohigas de l'Escola Tècnica Superior d'Arquitectura de Barcelona (UPC)",
		"indicador_refugi": "080193|BIBLIOTECA_ORIOL_BOHIGAS_DE_L_ESCOLA_TECNICA_SUPERIOR_D_ARQUITECTURA_DE_BARCELONA_UPC",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38501",
		"longitud": "2.115974",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Av. Diagonal, 649",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086001950",
		"tipologia": "Biblioteques",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-5evr.hb6g.fwjt",
		":version": "rv-qh5z.una9-74ef",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca de l'Escola d'Enginyeria Barcelona Est (UPC)",
		"indicador_refugi": "080193|BIBLIOTECA_DE_L_ESCOLA_D_ENGINYERIA_BARCELONA_EST_UPC",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.41352",
		"longitud": "2.220763",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Eduard Maristany, 16",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086019686",
		"tipologia": "Biblioteques",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-d4vf~43gw_tu9v",
		":version": "rv-ezm8.exqn-g2px",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca de l'Escola Politècnica Superior d'Edificació de Barcelona (UPC)",
		"indicador_refugi": "080193|BIBLIOTECA_DE_L_ESCOLA_POLITECNICA_SUPERIOR_D_EDIFICACIO_DE_BARCELONA_UPC",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38375",
		"longitud": "2.11275",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Av. Doctor Marañón, 44-50",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400737844",
		"tipologia": "Biblioteques",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-3nh2~rwin~kvmp",
		":version": "rv-mtbw.a4rn~5zye",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca de la Facultat de Matemàtiques i Estadística (UPC)",
		"indicador_refugi": "080193|BIBLIOTECA_DE_LA_FACULTAT_DE_MATEMATIQUES_I_ESTADISTICA_UPC",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38353",
		"longitud": "2.115839",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Pau Gargallo, 14",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/94102143353",
		"tipologia": "Biblioteques",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-byy7~4b3q_96fm",
		":version": "rv-6c6w.scp9-mbr9",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca de la Facultat de Nàutica de Barcelona (UPC)",
		"indicador_refugi": "080193|BIBLIOTECA_DE_LA_FACULTAT_DE_NAUTICA_DE_BARCELONA_UPC",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38235",
		"longitud": "2.184515",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pla de Palau, 18",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086008698",
		"tipologia": "Biblioteques",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-f9nn~bzsn_f7jk",
		":version": "rv-rhau.qqtg~ne8r",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de Barri Can Travi de la Vall d'Hebron",
		"indicador_refugi": "080193|CASAL_DE_BARRI_CAN_TRAVI_DE_LA_VALL_D_HEBRON",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.43288",
		"longitud": "2.151471",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Av. Cardenal Vidal i Barraquer 45",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400234295",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-i2pk~hitd~wrj7",
		":version": "rv-58af~cwya_7s7i",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Institut Català de La Salut",
		"indicador_refugi": "080193|INSTITUT_CATALA_DE_LA_SALUT",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38754",
		"longitud": "2.165229",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "G.V. Corts Catalanes, 587",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086009231",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-trjh.nust~r36b",
		":version": "rv-cbna_5uxh.bdjf",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Basílica de Sant Josep Oriol",
		"indicador_refugi": "080193|BASILICA_DE_SANT_JOSEP_ORIOL",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38361",
		"longitud": "2.15784",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Diputació, 149",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400737866",
		"tipologia": "Centres de culte",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-p2uq~cjjh~5nbv",
		":version": "rv-adyb.cdyp~uicb",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parròquia de Santa Maria de Sants",
		"indicador_refugi": "080193|PARROQUIA_DE_SANTA_MARIA_DE_SANTS",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.37449",
		"longitud": "2.136876",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pl. Bonet i Moixí, 5",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400737868",
		"tipologia": "Centres de culte",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-8qp4_egrr.m7jc",
		":version": "rv-a2zh~axkg~8sy9",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Hospital de Sant Pau",
		"indicador_refugi": "080193|HOSPITAL_DE_SANT_PAU",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.41512",
		"longitud": "2.173587",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Sant Quintí, 89",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086003435",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-yy6f.6we3~z7vw",
		":version": "rv-fcn4~6jnq~syew",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parròquia del Crist Rei",
		"indicador_refugi": "080193|PARROQUIA_DEL_CRIST_REI",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.42354",
		"longitud": "2.187757",
		"accessibilitat": "Sí",
		"aigua": "No",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "C. Martí Molins, 45",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400737872",
		"tipologia": "Centres de culte",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-4b3x_nwpu-pnrf",
		":version": "rv-349a_4rex.qjh9",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parròquia de la Puríssima Concepció",
		"indicador_refugi": "080193|PARROQUIA_DE_LA_PURISSIMA_CONCEPCIO",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.39451",
		"longitud": "2.167161",
		"accessibilitat": "Sí",
		"aigua": "No",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Aragó, 299 (entrada per C. Roger de Llúria 70)",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400737873",
		"tipologia": "Centres de culte",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-idje.ghka.c4qy",
		":version": "rv-ebvr_8n2r~jyk9",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Torre Jussana- Serveis per a associacions",
		"indicador_refugi": "080193|TORRE_JUSSANA_SERVEIS_PER_A_ASSOCIACIONS",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.42946",
		"longitud": "2.151921",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Av. Cardenal Vidal i Barraquer, 30",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086014771",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-md3f-twvd-pc9q",
		":version": "rv-idd4.2uhc_c42s",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Barri Can Baró-Pirineu",
		"indicador_refugi": "080193|CASAL_BARRI_CAN_BARO_PIRINEU",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.41761",
		"longitud": "2.162226",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Josep Serrano, 59-71",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400184358",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-i768~mj8c-vdpp",
		":version": "rv-dfeg.ivqq.dix4",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de Barri del Maresme",
		"indicador_refugi": "080193|CASAL_DE_BARRI_DEL_MARESME",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.41392",
		"longitud": "2.211523",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Puigcerdà, 100-102",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400715842",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-np6t_fx3u~c926",
		":version": "rv-rd68.agg2_zbwu",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Cívic el Coll - La Bruguera",
		"indicador_refugi": "080193|CENTRE_CIVIC_EL_COLL_LA_BRUGUERA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.4186",
		"longitud": "2.149887",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Aldea, 15",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92127125234",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-w73u-gg83-4gyf",
		":version": "rv-3k9e.vq73_ibgv",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de Barri Can Carol",
		"indicador_refugi": "080193|CASAL_DE_BARRI_CAN_CAROL",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.41239",
		"longitud": "2.145957",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Cambrils, 26",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400647227",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ibfq-w3es.m3mj",
		":version": "rv-gfmj.3qmk.h7y6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de Barri Cardener",
		"indicador_refugi": "080193|CASAL_DE_BARRI_CARDENER",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.41008",
		"longitud": "2.156989",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Cardener, 45",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400006116",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-nw7e_vrzm_sk5j",
		":version": "rv-68pi_w3cq-c7if",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Espai Jove La Fontana",
		"indicador_refugi": "080193|ESPAI_JOVE_LA_FONTANA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.40321",
		"longitud": "2.152462",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Gran de Gràcia, 190-192",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400219575",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-miyp_yzrn~4fqq",
		":version": "rv-kqgz.72nf-hchq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de Barri La Barraca d'El Carmel",
		"indicador_refugi": "080193|CASAL_DE_BARRI_LA_BARRACA_D_EL_CARMEL",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.42486",
		"longitud": "2.157359",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Llobregós 107-113",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400618157",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-xunt_9c3b-xevv",
		":version": "rv-e3w9-wfj8-pa5m",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre d'arts Santa Mònica",
		"indicador_refugi": "080193|CENTRE_D_ARTS_SANTA_MONICA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.37751",
		"longitud": "2.175824",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. La Rambla, 7",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92168151955",
		"tipologia": "Entitats culturals",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-rdyr~7h9s~d8ec",
		":version": "rv-jec8_njwx~u5rw",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Fundació Festa Major de Gràcia - Can Musons",
		"indicador_refugi": "080193|FUNDACIO_FESTA_MAJOR_DE_GRACIA_CAN_MUSONS",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.40607",
		"longitud": "2.156642",
		"accessibilitat": "Sí",
		"aigua": "No",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. de l'Alzina, 9",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400090807",
		"tipologia": "Entitats culturals",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-jnaq_jt3p.3ntd",
		":version": "rv-ivfi-2x3n.scpe",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Fundació Privada Enllaç",
		"indicador_refugi": "080193|FUNDACIO_PRIVADA_ENLLAC",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.40206",
		"longitud": "2.169197",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Rosselló, 328",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400293976",
		"tipologia": "Altres",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-wssg_ye43_kq7b",
		":version": "rv-58ee_fxbs-mimp",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Lluïsos de Gràcia",
		"indicador_refugi": "080193|LLUISOS_DE_GRACIA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.40717",
		"longitud": "2.155376",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pl. del Nord, 7-10",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400737883",
		"tipologia": "Entitats culturals",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-wjrr~h7fp.jx33",
		":version": "rv-gm2p.jp6t-hngi",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Museu Olímpic i de l'Esport Joan Antoni Samaranch",
		"indicador_refugi": "080193|MUSEU_OLIMPIC_I_DE_L_ESPORT_JOAN_ANTONI_SAMARANCH",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.36651",
		"longitud": "2.157516",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Av. de l'Estadi, 60",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400179658",
		"tipologia": "Museus",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-wfhy~86e6-c4bz",
		":version": "rv-fkjy.rrut.idff",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Mercat del Besòs",
		"indicador_refugi": "080193|MERCAT_DEL_BESOS",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.4192",
		"longitud": "2.215113",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Jaume Huguet, 38",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086009790",
		"tipologia": "Mercats",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-mh7v.49yc_zt5y",
		":version": "rv-pe42-dy6d~4iaq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Mercat de la Concepció",
		"indicador_refugi": "080193|MERCAT_DE_LA_CONCEPCIO",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.3958",
		"longitud": "2.16943",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Aragó, 311 bis",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086009449",
		"tipologia": "Mercats",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-izts.e2x5-d4fq",
		":version": "rv-rdwe~xn35~mtdj",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Mercat del Clot",
		"indicador_refugi": "080193|MERCAT_DEL_CLOT",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.40759",
		"longitud": "2.188633",
		"accessibilitat": "Sí",
		"aigua": "No",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pl. del Mercat, 26",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086009788",
		"tipologia": "Mercats",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-47f5.s4cv.imdd",
		":version": "rv-pn3j_9cpp~56b9",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Mercat del Fort Pienc",
		"indicador_refugi": "080193|MERCAT_DEL_FORT_PIENC",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.39591",
		"longitud": "2.18241",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pl. Fort Pienc, 3",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400069155",
		"tipologia": "Mercats",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-jwsk~cnd8~bsx3",
		":version": "rv-av5s.e5aa-3ncg",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Mercat d'Hostafrancs",
		"indicador_refugi": "080193|MERCAT_D_HOSTAFRANCS",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.37513",
		"longitud": "2.143832",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Creu Coberta, 93",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086009454",
		"tipologia": "Mercats",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-j23f~q8ey~dpvc",
		":version": "rv-4aei.x678_69yn",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Mercat del Ninot",
		"indicador_refugi": "080193|MERCAT_DEL_NINOT",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38782",
		"longitud": "2.1544",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Mallorca,133",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086009451",
		"tipologia": "Mercats",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-6r3z.axnr.2a9q",
		":version": "rv-equ3_9eaj_t5iz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Mercat del Poblenou-Unió",
		"indicador_refugi": "080193|MERCAT_DEL_POBLENOU_UNIO",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.401",
		"longitud": "2.205423",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pl. Unió, 25",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086009791",
		"tipologia": "Mercats",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ppw8-tubk_esjz",
		":version": "rv-p3b3_8pt7-7e6s",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Mercat de Sant Antoni",
		"indicador_refugi": "080193|MERCAT_DE_SANT_ANTONI",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.37918",
		"longitud": "2.162061",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Urgell, 1",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086009452",
		"tipologia": "Mercats",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-hnqh.xqva~6ry2",
		":version": "rv-mypq~kg3y~8vra",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Mercat de Sant Martí",
		"indicador_refugi": "080193|MERCAT_DE_SANT_MARTI",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.41863",
		"longitud": "2.205298",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Puigcerdà, 206-212",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086009789",
		"tipologia": "Mercats",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-kngy~j44s_nwgc",
		":version": "rv-px2h.87bg-59wv",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Mercat de Santa Caterina",
		"indicador_refugi": "080193|MERCAT_DE_SANTA_CATERINA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38636",
		"longitud": "2.178161",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Av. Francesc Cambó, 16",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086009448",
		"tipologia": "Mercats",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-vz2v_n7t5-z567",
		":version": "rv-q7ve.9vnp~ntr6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Mercat del Bon Pastor",
		"indicador_refugi": "080193|MERCAT_DEL_BON_PASTOR",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.43598",
		"longitud": "2.206155",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Sant Adrià, 154-162",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086009784",
		"tipologia": "Mercats",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-yjbj~p8v5-zd5k",
		":version": "rv-yvv9-krid~kb7c",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Mercat del Carmel",
		"indicador_refugi": "080193|MERCAT_DEL_CARMEL",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.42388",
		"longitud": "2.155566",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Llobregós, 149",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086009775",
		"tipologia": "Mercats",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-qtci~ci4t_kvcn",
		":version": "rv-bf4x.unrf-yixy",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Mercat de Ciutat Meridiana",
		"indicador_refugi": "080193|MERCAT_DE_CIUTAT_MERIDIANA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.46169",
		"longitud": "2.177788",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Costabona, 4",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086009782",
		"tipologia": "Mercats",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-pb8i-9ruv.kymw",
		":version": "rv-ugga_xuew~eu7h",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Mercat de Les Corts",
		"indicador_refugi": "080193|MERCAT_DE_LES_CORTS",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38381",
		"longitud": "2.129857",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Trav. de Les Corts, 215",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086009457",
		"tipologia": "Mercats",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-53vp.bqgk-tz3u",
		":version": "rv-z23e_cg69.ddjp",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Mercat de Lesseps",
		"indicador_refugi": "080193|MERCAT_DE_LESSEPS",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.40901",
		"longitud": "2.151947",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Verdi, 200-210",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086009464",
		"tipologia": "Mercats",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ru32~6s5x.w5v7",
		":version": "rv-wdbv-d4ei.tvdi",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Mercat de Vall d'Hebron",
		"indicador_refugi": "080193|MERCAT_DE_VALL_D_HEBRON",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.42404",
		"longitud": "2.142439",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pg. Vall d'Hebron, 130-134",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086009777",
		"tipologia": "Mercats",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-d6nj.8jnq~gqne",
		":version": "rv-kjzj-ri3s-m2sz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Sala Polivalent Montbau",
		"indicador_refugi": "080193|SALA_POLIVALENT_MONTBAU",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.42958",
		"longitud": "2.142501",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Domènech i Montaner, 3",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400301905",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-j2n5.epae.uvks",
		":version": "rv-ehhx.r6w9.eern",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Font d'En Fargues",
		"indicador_refugi": "080193|CASAL_FONT_D_EN_FARGUES",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.42431",
		"longitud": "2.16522",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Pedrell, 67-69",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086003483",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-6im9_zhvz~bpan",
		":version": "rv-yy38-g3wg~tvai",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Càndida Pérez, Jardins de (Compte Borrell 44)",
		"indicador_refugi": "080193|CANDIDA_PEREZ_JARDINS_DE_COMPTE_BORRELL_44",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.37768",
		"longitud": "2.163102",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Jardins Càndida Pérez, 0",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400226468",
		"tipologia": "Interiors d’Illa",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-4iyc_wp9n_6ts7",
		":version": "rv-4wd8~yjya_h7h6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Carlit, Jardins del (Roger de Flor 160)",
		"indicador_refugi": "080193|CARLIT_JARDINS_DEL_ROGER_DE_FLOR_160",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.39731",
		"longitud": "2.175274",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "C. Roger de Flor, 146",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/95062123700",
		"tipologia": "Interiors d’Illa",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-xj5f.7a22.xvch",
		":version": "rv-mq38-a3rw.zvmm",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Carme Biada, Jardins de (Bruc 153 - Roger de Llúria 132)",
		"indicador_refugi": "080193|CARME_BIADA_JARDINS_DE_BRUC_153_ROGER_DE_LLURIA_132",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.39838",
		"longitud": "2.1628",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Jardins Carme Biada, 0",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400184041",
		"tipologia": "Interiors d’Illa",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-uw9a_vd9s.6x5p",
		":version": "rv-jac6-jmve_83y3",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Clotilde Cerdà, Jardins de (Marina 197 - Sardenya 254)",
		"indicador_refugi": "080193|CLOTILDE_CERDA_JARDINS_DE_MARINA_197_SARDENYA_254",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.40016",
		"longitud": "2.17861",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "C. Consell de Cent, 486",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99117134859",
		"tipologia": "Interiors d’Illa",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-uyjm-u3y2-cgfg",
		":version": "rv-9iyb_5xuz_ikp8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Constança d'Aragó, Jardins (Roger de Flor 194)",
		"indicador_refugi": "080193|CONSTANCA_D_ARAGO_JARDINS_ROGER_DE_FLOR_194",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.39906",
		"longitud": "2.172981",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "C. Roger de Flor, 194",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400260339",
		"tipologia": "Interiors d’Illa",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-rckc-xme7.2v2r",
		":version": "rv-aj7b_q57k-9et6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Emma de Barcelona, Jardins d' (Comte Borrell 159)",
		"indicador_refugi": "080193|EMMA_DE_BARCELONA_JARDINS_D_COMTE_BORRELL_159",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38239",
		"longitud": "2.155181",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "C. Comte Borrell, 159",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/335195642",
		"tipologia": "Interiors d’Illa",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ysm3.qhaw-4vvy",
		":version": "rv-nfuy_7smv_wdud",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Lina Ódena, Jardins  (Ali Bei 121 - Sardenya 170)",
		"indicador_refugi": "080193|LINA_ODENA_JARDINS_ALI_BEI_121_SARDENYA_170",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.39636",
		"longitud": "2.183556",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "C. Alí Bei, 115",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400047563",
		"tipologia": "Interiors d’Illa",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-2cms_b4ey.eexw",
		":version": "rv-5kp6~dhgy_uai4",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Maria Matilde Almendros, Jardins (Calàbria 90-92)",
		"indicador_refugi": "080193|MARIA_MATILDE_ALMENDROS_JARDINS_CALABRIA_90_92",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.3793",
		"longitud": "2.15627",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Jardins Maria Matilde Almendros, 0",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400194129",
		"tipologia": "Interiors d’Illa",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-rk65-9cep~mvhw",
		":version": "rv-i56i~8i3a_f2yn",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Montserrat Roig, Jardins de (Rosselló 490 - Provença 533)",
		"indicador_refugi": "080193|MONTSERRAT_ROIG_JARDINS_DE_ROSSELLO_490_PROVENCA_533",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.40869",
		"longitud": "2.178846",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Jardins Montserrat Roig, 0",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/96142123016",
		"tipologia": "Interiors d’Illa",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-xaaz_5fuj_mniw",
		":version": "rv-yc5w-fw9e.qz4y",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Paula Montal, Jardins de (Viladomat 149 - 151)",
		"indicador_refugi": "080193|PAULA_MONTAL_JARDINS_DE_VILADOMAT_149_151",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38142",
		"longitud": "2.154069",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Jardins Paula Montal, 0",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400063147",
		"tipologia": "Interiors d’Illa",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-qans.dmxd.b29q",
		":version": "rv-bcza~v8av~2tun",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Safo, Jardins de  (Llança, C. 48 - Roma, Av. 20)",
		"indicador_refugi": "080193|SAFO_JARDINS_DE_LLANCA_C_48_ROMA_AV_20",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38065",
		"longitud": "2.145994",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Jardins Safo, 0",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/1183122853",
		"tipologia": "Interiors d’Illa",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-mh9s_67ie~njx3",
		":version": "rv-ivk6~t73y_abue",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Tete Montoliu, Jardins (Sepúlveda 88)",
		"indicador_refugi": "080193|TETE_MONTOLIU_JARDINS_SEPULVEDA_88",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.37871",
		"longitud": "2.157611",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Jardins Tete Montoliu, 0",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400175567",
		"tipologia": "Interiors d’Illa",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-n65z-fs7r~y64f",
		":version": "rv-jdwc_p24z_8jge",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Torre de les Aigües, Jardí (Roger de Llúria 56)",
		"indicador_refugi": "080193|TORRE_DE_LES_AIGUES_JARDI_ROGER_DE_LLURIA_56",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.39331",
		"longitud": "2.169639",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "C. Roger de Llúria, 56",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086030520",
		"tipologia": "Interiors d’Illa",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-6x5g_7jbd~bqqd",
		":version": "rv-9rpw.fccd.irqc",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Tres Tombs, Jardins (Manso 28 - Calàbria 8)",
		"indicador_refugi": "080193|TRES_TOMBS_JARDINS_MANSO_28_CALABRIA_8",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.37606",
		"longitud": "2.160819",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "C. Calàbria, 940",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/1128115652",
		"tipologia": "Interiors d’Illa",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-zxjh.8m66.du5z",
		":version": "rv-8s67_fzmz-jj2u",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Fabra i Coats: Fàbrica de Creació",
		"indicador_refugi": "080193|FABRA_I_COATS_FABRICA_DE_CREACIO",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.43376",
		"longitud": "2.190814",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Sant Adrià, 20",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400193035",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-kcc3-dzqs.7bai",
		":version": "rv-xsej~a8dc_4yai",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Pati de l'Escola Bressol Municipal L'Esquirol",
		"indicador_refugi": "080193|PATI_DE_L_ESCOLA_BRESSOL_MUNICIPAL_L_ESQUIROL",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.37229",
		"longitud": "2.139195",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No (aire lliure)",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C Noguera Pallaresa, 32",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400737907",
		"tipologia": "Patis d'Escola Bressol",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-khhs-mezy_8v7j",
		":version": "rv-2uuj.dqng_p9wz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Pati de l'Escola Bressol Municipal Margalló",
		"indicador_refugi": "080193|PATI_DE_L_ESCOLA_BRESSOL_MUNICIPAL_MARGALLO",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.42006",
		"longitud": "2.203971",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No (aire lliure)",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C Concili de Trento, 249",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400737908",
		"tipologia": "Patis d'Escola Bressol",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ceh6~uh4k-az9x",
		":version": "rv-g8qt.2ewr~v997",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CC Can Deu",
		"indicador_refugi": "080193|CC_CAN_DEU",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38677",
		"longitud": "2.132505",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pl. de la Concòrdia, 13",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086017856",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-hryi-7zgt.3iwi",
		":version": "rv-sm8w.pbu2_9p5z",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CC Parc Sandaru",
		"indicador_refugi": "080193|CC_PARC_SANDARU",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.39172",
		"longitud": "2.184738",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Buenaventura Muñoz, 21",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400161204",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ptv5.vamv_9kxs",
		":version": "rv-5axr-67ih.8pkk",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CC Sant Martí",
		"indicador_refugi": "080193|CC_SANT_MARTI",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.41661",
		"longitud": "2.198577",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Selva de Mar, 215",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086005093",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-hc5e-t9ut.5s9k",
		":version": "rv-myhn_akem-2amx",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CC Can Felipa",
		"indicador_refugi": "080193|CC_CAN_FELIPA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.40365",
		"longitud": "2.200478",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pl. Josep Maria Huertas Claveria, 1",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086035490",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-bk2y~sabp-5i4u",
		":version": "rv-t5st.ny7u.9b4n",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de Barri La Llacuna",
		"indicador_refugi": "080193|CASAL_DE_BARRI_LA_LLACUNA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.40285",
		"longitud": "2.190664",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Bolívia, 49",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400579089",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-fw75-5kvb_j9hn",
		":version": "rv-ya8j-hqad_z9x6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de gent gran Josep Trueta",
		"indicador_refugi": "080193|CASAL_DE_GENT_GRAN_JOSEP_TRUETA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.37692",
		"longitud": "2.167251",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Reina Amàlia, 31",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086011061",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ui9c-ey9z~c88n",
		":version": "rv-84e5_q2nc_8ucx",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de gent gran Josep Tarradellas",
		"indicador_refugi": "080193|CASAL_DE_GENT_GRAN_JOSEP_TARRADELLAS",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38194",
		"longitud": "2.167146",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pl. Caramelles, 3",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92150113813",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-pyz2~t43n-nxgn",
		":version": "rv-79sv_4yte~kbeg",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "La Ludo",
		"indicador_refugi": "080193|LA_LUDO",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38681",
		"longitud": "2.188081",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Pas Institut Escola, 1. Parc de la Ciutadella",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/69133728",
		"tipologia": "Equipaments Ambientals",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-zbcc~yamq_kywu",
		":version": "rv-4ujs~4wub_q432",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CEM Sardenya",
		"indicador_refugi": "080193|CEM_SARDENYA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.41214",
		"longitud": "2.162182",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "C. Sardenya, 549",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/97178123551",
		"tipologia": "Complexos esportius",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-fqnh-efwc_e5q9",
		":version": "rv-bj47.tjyf~36kk",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de Persones Grans Casc Antic",
		"indicador_refugi": "080193|CASAL_DE_PERSONES_GRANS_CASC_ANTIC",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38737",
		"longitud": "2.178657",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Mestres Casals i Martorell, 2-16",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400659719",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-amvn_mbnb-v9j9",
		":version": "rv-j4gj_w8h4-pmff",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Associació de veïnes i veïns dEl Clot-Camp de l'Arpa",
		"indicador_refugi": "080193|ASSOCIACIO_DE_VEINES_I_VEINS_DEL_CLOT_CAMP_DE_L_ARPA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.41028",
		"longitud": "2.185959",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Sibelius, 3",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086010413",
		"tipologia": "Altres",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-nyu3-mic5~tpe2",
		":version": "rv-ibib~wn35~3ahx",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscines Descoberta del CEM Bac de Roda",
		"indicador_refugi": "080193|PISCINES_DESCOBERTA_DEL_CEM_BAC_DE_RODA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.41435",
		"longitud": "2.194073",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Rbla. Guipúscoa, 25",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400110882",
		"tipologia": "Piscines",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-24ra-qr7i~prri",
		":version": "rv-jvsh~snfh~5ufu",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina Descoberta del CEM Can Toda",
		"indicador_refugi": "080193|PISCINA_DESCOBERTA_DEL_CEM_CAN_TODA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.41535",
		"longitud": "2.158164",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Ramiro de Maeztu, 25",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086003372",
		"tipologia": "Piscines",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-r3pe~8urd~fdq7",
		":version": "rv-j8eg~gv2j.4n35",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina Coberta del CEM Aiguajoc Borrell",
		"indicador_refugi": "080193|PISCINA_COBERTA_DEL_CEM_AIGUAJOC_BORRELL",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.37638",
		"longitud": "2.163747",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Compte Borrell, 21-33",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/96319161157",
		"tipologia": "Piscines",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-v67g_8rc3_hx4n",
		":version": "rv-w68h-waxr-fh2z",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscines Cobertes del CEM Artesania",
		"indicador_refugi": "080193|PISCINES_COBERTES_DEL_CEM_ARTESANIA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.44416",
		"longitud": "2.171071",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Artesania, 63",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400110352",
		"tipologia": "Piscines",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ng7v_wpcy.zie9",
		":version": "rv-3jtf_pa5u~k576",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina Coberta del CEM Piscines Bernat Picornell",
		"indicador_refugi": "080193|PISCINA_COBERTA_DEL_CEM_PISCINES_BERNAT_PICORNELL",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.36629",
		"longitud": "2.150628",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Av. de l'Estadi, 30-38",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/94125141220",
		"tipologia": "Piscines",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-y6et~rt3f~74fm",
		":version": "rv-hj4k_krzs_mwp9",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina Descoberta del CEM Can Caralleu",
		"indicador_refugi": "080193|PISCINA_DESCOBERTA_DEL_CEM_CAN_CARALLEU",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.40156",
		"longitud": "2.111093",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. dels Esports, 2-8",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086010501",
		"tipologia": "Piscines",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-jdy9_3r9z-trte",
		":version": "rv-4zhs~5dcc-9q9w",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina Coberta del CEM Can Felipa",
		"indicador_refugi": "080193|PISCINA_COBERTA_DEL_CEM_CAN_FELIPA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.40365",
		"longitud": "2.200481",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pl.  Josep Mª Huertas Claveria, 1",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/98168115723",
		"tipologia": "Piscines",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-rzmp.skvq.u996",
		":version": "rv-ck9v_n8pq_f3wj",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina Coberta del CEM Can Ricart",
		"indicador_refugi": "080193|PISCINA_COBERTA_DEL_CEM_CAN_RICART",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.37728",
		"longitud": "2.170923",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. St. Oleguer, 10",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400164786",
		"tipologia": "Piscines",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-cd4j.n99j.avyz",
		":version": "rv-6a3v_7px4~spqg",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina Coberta del CEM dEl Carmel",
		"indicador_refugi": "080193|PISCINA_COBERTA_DEL_CEM_DEL_CARMEL",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.42317",
		"longitud": "2.158547",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Pedrell, 192-202",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400060119",
		"tipologia": "Piscines",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-8v3b_hpuu~2zsj",
		":version": "rv-u9in_unjv~ffer",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscines Cobertes del CEM Claror",
		"indicador_refugi": "080193|PISCINES_COBERTES_DEL_CEM_CLAROR",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.40464",
		"longitud": "2.171457",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Sardenya, 333",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086020201",
		"tipologia": "Piscines",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-7kbf.ssb4.ixq9",
		":version": "rv-w3b7~v9yw-tyiw",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina Coberta del CEM Colom",
		"indicador_refugi": "080193|PISCINA_COBERTA_DEL_CEM_COLOM",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.37796",
		"longitud": "2.176246",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. La Rambla, 18",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/94276105023",
		"tipologia": "Piscines",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-tint_2u2j_tfvt",
		":version": "rv-2fcw_2cyt-n5pv",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscines Cobertes del CEM Cotxeres Borbó",
		"indicador_refugi": "080193|PISCINES_COBERTES_DEL_CEM_COTXERES_BORBO",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.42648",
		"longitud": "2.17706",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Ramón Albó, 47-57",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400276356",
		"tipologia": "Piscines",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-mze5~v5j8~j4f9",
		":version": "rv-t4xy_74v6_k2uj",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina Descoberta del CEM de Sant Sebastià",
		"indicador_refugi": "080193|PISCINA_DESCOBERTA_DEL_CEM_DE_SANT_SEBASTIA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.37358",
		"longitud": "2.188742",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pl. del Mar, s/n",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/98110133629",
		"tipologia": "Piscines",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-mgdq_tyep-qjnk",
		":version": "rv-xuk8_iakc.s4yc",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina Coberta del CEM Estació del Nord",
		"indicador_refugi": "080193|PISCINA_COBERTA_DEL_CEM_ESTACIO_DEL_NORD",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.39393",
		"longitud": "2.183183",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Nàpols, 42-44",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99133121652",
		"tipologia": "Piscines",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-u2yd.9t3u.srds",
		":version": "rv-i5zq.sqtn~eck6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina Descoberta del CEM Guinardó",
		"indicador_refugi": "080193|PISCINA_DESCOBERTA_DEL_CEM_GUINARDO",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.41702",
		"longitud": "2.173619",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "c. Torrent d'en Melis s/n",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400110852",
		"tipologia": "Piscines",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-kz2g.9qx2.ew4b",
		":version": "rv-6f2t~3gek_scu9",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscines Cobertes del CEM Horta",
		"indicador_refugi": "080193|PISCINES_COBERTES_DEL_CEM_HORTA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.43359",
		"longitud": "2.161094",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "SI",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Feliu i Codina, 27",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/93307114429",
		"tipologia": "Piscines",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-qb9e.ikme.5a6w",
		":version": "rv-xzvu~gwng.fq2e",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina Coberta del CEM Joan Miró",
		"indicador_refugi": "080193|PISCINA_COBERTA_DEL_CEM_JOAN_MIRO",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.37846",
		"longitud": "2.150983",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "si",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Diputació, 17-19",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/1057133310",
		"tipologia": "Piscines",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-gbac_wvg7~h3vi",
		":version": "rv-kjua~g2i2~nj5d",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscines Cobertes del CEM Júpiter",
		"indicador_refugi": "080193|PISCINES_COBERTES_DEL_CEM_JUPITER",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.41772",
		"longitud": "2.201996",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Agricultura, 232",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400110897",
		"tipologia": "Piscines",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-zzma_xqzt~up75",
		":version": "rv-mb33.zm9k_wxmu",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscines Cobertes del CEM l'Espanya Industrial",
		"indicador_refugi": "080193|PISCINES_COBERTES_DEL_CEM_L_ESPANYA_INDUSTRIAL",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.37741",
		"longitud": "2.14192",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Parc de l'Espanya Industrial, s/n",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/93327121407",
		"tipologia": "Piscines",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-qqnp_j97k-hspp",
		":version": "rv-n3xt_st6t-3532",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina Coberta del CEM La Bordeta",
		"indicador_refugi": "080193|PISCINA_COBERTA_DEL_CEM_LA_BORDETA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.37241",
		"longitud": "2.139625",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Noguera Pallaresa, 34-42",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400110957",
		"tipologia": "Piscines",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-6fjd.9jfx_i8w6",
		":version": "rv-ns2k~mq2g_mgf7",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina Coberta del CEM La Verneda",
		"indicador_refugi": "080193|PISCINA_COBERTA_DEL_CEM_LA_VERNEDA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.42513",
		"longitud": "2.204367",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "SI",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Binèfar, 10-14",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086023364",
		"tipologia": "Piscines",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-7wkr-nvcr-2q5h",
		":version": "rv-wpae-p3qq_d3q4",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscines Cobertes del CEM Les Corts",
		"indicador_refugi": "080193|PISCINES_COBERTES_DEL_CEM_LES_CORTS",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38569",
		"longitud": "2.134193",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Trav. de Les Corts, 252-254",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/117132415",
		"tipologia": "Piscines",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ftzf.t5td_rvzy",
		":version": "rv-f83n_8ehx.4bxi",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscines Cobertes del CEM Maresme",
		"indicador_refugi": "080193|PISCINES_COBERTES_DEL_CEM_MARESME",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.41321",
		"longitud": "2.213982",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Pallars, 484",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400036999",
		"tipologia": "Piscines",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-gkpf_ck6t-jyhr",
		":version": "rv-rt5r_iwk4_24em",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina Coberta del CEM Marítim",
		"indicador_refugi": "080193|PISCINA_COBERTA_DEL_CEM_MARITIM",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38447",
		"longitud": "2.194867",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pg. Marítim Barceloneta, 33",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400322471",
		"tipologia": "Piscines",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-wbcw.r43q-2c97",
		":version": "rv-5zma_ia8v.fhk7",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscines Cobertes del CEM Mundet",
		"indicador_refugi": "080193|PISCINES_COBERTES_DEL_CEM_MUNDET",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.43591",
		"longitud": "2.142863",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Olympe de Gouges, s/n",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400322478",
		"tipologia": "Piscines",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-fvf7~i5y2.2583",
		":version": "rv-cu6r_xnuj-ktiw",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina Coberta del CEM Nova Icària",
		"indicador_refugi": "080193|PISCINA_COBERTA_DEL_CEM_NOVA_ICARIA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.39236",
		"longitud": "2.197997",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Av. Icària, 167",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/312152814",
		"tipologia": "Piscines",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ukex~q6hr_7gnn",
		":version": "rv-n6rc_uubd-ervm",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina Coberta del CEM Parc de la Ciutadella",
		"indicador_refugi": "080193|PISCINA_COBERTA_DEL_CEM_PARC_DE_LA_CIUTADELLA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38553",
		"longitud": "2.186413",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pg. de Circumval·lació, 1",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400144112",
		"tipologia": "Piscines",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-zini~2te4~gny6",
		":version": "rv-jvm3~e98z_tg7i",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscines Cobertes del CEM Putxet",
		"indicador_refugi": "080193|PISCINES_COBERTES_DEL_CEM_PUTXET",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.40972",
		"longitud": "2.14131",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Marmellà, 23",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400247088",
		"tipologia": "Piscines",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-quyn.ewc9~hp63",
		":version": "rv-ebng-p7cd~ucp5",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscines Cobertes del CEM Sagrada Família",
		"indicador_refugi": "080193|PISCINES_COBERTES_DEL_CEM_SAGRADA_FAMILIA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.40725",
		"longitud": "2.179314",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Cartagena, 231-239",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/98301132224",
		"tipologia": "Piscines",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-kges_are8~tthy",
		":version": "rv-emjk~aage.39he",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscines Cobertes del CEM Sant Andreu - La Sagrera",
		"indicador_refugi": "080193|PISCINES_COBERTES_DEL_CEM_SANT_ANDREU_LA_SAGRERA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.42977",
		"longitud": "2.192734",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Sta. Coloma, 25",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400322493",
		"tipologia": "Piscines",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-93pg~nqye~pzam",
		":version": "rv-76m7.rdff.x6jz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscines Cobertes del CEM Sardenya",
		"indicador_refugi": "080193|PISCINES_COBERTES_DEL_CEM_SARDENYA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.41209",
		"longitud": "2.162226",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Sardenya, 549-553",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99147085139",
		"tipologia": "Piscines",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ynt3~ajct_nep4",
		":version": "rv-zfv2~tysp.8vsw",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina Coberta del CEM Trinitat Vella",
		"indicador_refugi": "080193|PISCINA_COBERTA_DEL_CEM_TRINITAT_VELLA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.45145",
		"longitud": "2.193105",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "si",
		"adreca": "Via Bàrcino 84-86",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086010810",
		"tipologia": "Piscines",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-25d5.syjy_qeys",
		":version": "rv-ewmf_ymaj~scgr",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina Coberta del CEM Vintró - Joan Alentorn",
		"indicador_refugi": "080193|PISCINA_COBERTA_DEL_CEM_VINTRO_JOAN_ALENTORN",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.40665",
		"longitud": "2.186275",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Consell de Cent, 623-627",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99165122406",
		"tipologia": "Piscines",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-vufw-vwhz-32vh",
		":version": "rv-fus2_2v8g.essf",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina Descoberta del Centre Municipal Tennis Vall Hebron",
		"indicador_refugi": "080193|PISCINA_DESCOBERTA_DEL_CENTRE_MUNICIPAL_TENNIS_VALL_HEBRON",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.42975",
		"longitud": "2.145472",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pg. Vall d'Hebron, 178-196",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400110881",
		"tipologia": "Piscines",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-z8hq_95dy_nyph",
		":version": "rv-bp6m_vz9p_76f7",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina Descoberta del CEM Bon Pastor",
		"indicador_refugi": "080193|PISCINA_DESCOBERTA_DEL_CEM_BON_PASTOR",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.43818",
		"longitud": "2.201731",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "SI",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Costa Daurada, 12",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/98188181031",
		"tipologia": "Piscines",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-szjz~c35g_kvhj",
		":version": "rv-decq~d9sz.yvwr",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina Coberta del CEM Can Cuyàs",
		"indicador_refugi": "080193|PISCINA_COBERTA_DEL_CEM_CAN_CUYAS",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.45988",
		"longitud": "2.168115",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "SI",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Av. Rasos de Peguera, 242",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/93057134404",
		"tipologia": "Piscines",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-mx3m_hjk3-qaty",
		":version": "rv-iykv.pyva~9z8p",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina Coberta del CEM Olimpics Vall Hebron",
		"indicador_refugi": "080193|PISCINA_COBERTA_DEL_CEM_OLIMPICS_VALL_HEBRON",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.42807",
		"longitud": "2.144382",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pg. Vall d'Hebron, 166-176",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99301125047",
		"tipologia": "Piscines",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-y7ac_dt4k-si7v",
		":version": "rv-y7bf~2jyh_6djn",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina Coberta del CEM Turó de la Peira",
		"indicador_refugi": "080193|PISCINA_COBERTA_DEL_CEM_TURO_DE_LA_PEIRA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.43286",
		"longitud": "2.172184",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "SI",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Sant Iscle, 50",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400644388",
		"tipologia": "Piscines",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-89wv-gmr9.b3re",
		":version": "rv-s6b2~bb7v.canc",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina Descoberta de La Clota",
		"indicador_refugi": "080193|PISCINA_DESCOBERTA_DE_LA_CLOTA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.42609",
		"longitud": "2.149446",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pl. Clota, s/n",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/97331093926",
		"tipologia": "Piscines",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-f5vu.gs58~9eyq",
		":version": "rv-8qmj-qiif-eddg",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscines Municipals Montjuïc",
		"indicador_refugi": "080193|PISCINES_MUNICIPALS_MONTJUIC",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.36906",
		"longitud": "2.164596",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Av. Miramar, 31-37",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086000228",
		"tipologia": "Piscines",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-gizr-v2tc~w6bv",
		":version": "rv-hrpd_5z6p-93uk",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina Coberta del CEM Piscina Sant Jordi",
		"indicador_refugi": "080193|PISCINA_COBERTA_DEL_CEM_PISCINA_SANT_JORDI",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38906",
		"longitud": "2.147353",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. París, 114",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086002693",
		"tipologia": "Piscines",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-rp7r_55ae~xwuh",
		":version": "rv-8b5c~yegc~ixne",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscines Cobertes del CEM Can Dragó",
		"indicador_refugi": "080193|PISCINES_COBERTES_DEL_CEM_CAN_DRAGO",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.43657",
		"longitud": "2.183127",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Roselló i Porcel, 7-11",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400322483",
		"tipologia": "Piscines",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-4y2b.azkt~fcj7",
		":version": "rv-ffnp-p6sx_yca5",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscines Coberta del CEM Perill",
		"indicador_refugi": "080193|PISCINES_COBERTA_DEL_CEM_PERILL",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.3994",
		"longitud": "2.161506",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Perill, 16-22",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086031187",
		"tipologia": "Piscines",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ab75.jrad~upyv",
		":version": "rv-4qp5_p7jb~dhxf",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina del Llac del Parc de la Creueta del Coll",
		"indicador_refugi": "080193|PISCINA_DEL_LLAC_DEL_PARC_DE_LA_CREUETA_DEL_COLL",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.41861",
		"longitud": "2.148139",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No (aire lliure)",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pg. Mare de Déu del Coll, 89",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/93302114541",
		"tipologia": "Piscines",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-pe65~7nzg.gwyx",
		":version": "rv-sczg.ptnn~cncc",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Artesà Tradicionàrius - CAT",
		"indicador_refugi": "080193|CENTRE_ARTESA_TRADICIONARIUS_CAT",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.40255",
		"longitud": "2.154436",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pl. Anna Frank",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400737894",
		"tipologia": "Entitats culturals",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-vszj.qpwh-36r8",
		":version": "rv-vuzz_c7ti_razk",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Comercial Arenas de Barcelona",
		"indicador_refugi": "080193|CENTRE_COMERCIAL_ARENAS_DE_BARCELONA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.3763",
		"longitud": "2.149305",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "G.V. Corts Catalanes, 373-385",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400267330",
		"tipologia": "Centres comercials",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-axmc~3es9_f8pv",
		":version": "rv-ce8t-g4d5~ranv",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Comercial Diagonal Mar",
		"indicador_refugi": "080193|CENTRE_COMERCIAL_DIAGONAL_MAR",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.40967",
		"longitud": "2.21573",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Av. Diagonal, 3",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/1313140637",
		"tipologia": "Centres comercials",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-k6yq-wsdu-sqeq",
		":version": "rv-rk9k.ej27_cai3",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre d'Atenció Integral (CAI) Marina",
		"indicador_refugi": "080193|CENTRE_D_ATENCIO_INTEGRAL_CAI_MARINA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.35952",
		"longitud": "2.145259",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Foc, 97",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400737609",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-i4ea-4fii~cxj4",
		":version": "rv-39gr_qveh_ij2k",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Clínica Sant Antoni",
		"indicador_refugi": "080193|CLINICA_SANT_ANTONI",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.35574",
		"longitud": "2.143519",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Sant Eloi, 6-8",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400279672",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-tg59_xvfn-dhny",
		":version": "rv-pjru.fhmc_epsh",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Pati de l'escola Seat",
		"indicador_refugi": "080193|PATI_DE_L_ESCOLA_SEAT",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.35988",
		"longitud": "2.137412",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Mecànica, 24 (entrada pel Pg. Zona Franca, 171 B)",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400737910",
		"tipologia": "Patis d'Escola",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-qykf_6pyj.m8du",
		":version": "rv-e34x.bxpf~kvnu",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parròquia de Santa Agnés",
		"indicador_refugi": "080193|PARROQUIA_DE_SANTA_AGNES",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.40102",
		"longitud": "2.14446",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Sant Elies, 23",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400738061",
		"tipologia": "Centres de culte",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-hdm6-t3fi-ikqb",
		":version": "rv-khy6_ami2.cwda",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parròquia de Sant Vicenç de Sarrià",
		"indicador_refugi": "080193|PARROQUIA_DE_SANT_VICENC_DE_SARRIA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.39985",
		"longitud": "2.12152",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pl. Sarrià, 10",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400738062",
		"tipologia": "Centres de culte",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-wkfg-s66t~fsfw",
		":version": "rv-gtp2~qqif~ev3s",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Punt d'Activitat de Creu Roja a Sants-Montjuïc",
		"indicador_refugi": "080193|PUNT_D_ACTIVITAT_DE_CREU_ROJA_A_SANTS_MONTJUIC",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.36111",
		"longitud": "2.135446",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Francesc Boix Campo, 6",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400738067",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-8fqv_2r4q~qpzc",
		":version": "rv-6bzs-hyhn-g6ym",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parròquia de Sant Miquel del Port",
		"indicador_refugi": "080193|PARROQUIA_DE_SANT_MIQUEL_DEL_PORT",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38001",
		"longitud": "2.188571",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Sant Miquel, 39",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400738065",
		"tipologia": "Centres de culte",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-854a_944y.j9k2",
		":version": "rv-6dge_uuf5_f8xz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de Barri La Cosa Nostra",
		"indicador_refugi": "080193|CASAL_DE_BARRI_LA_COSA_NOSTRA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.43387",
		"longitud": "2.167966",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Biure, 1",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400143979",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-szbv-rubv~i2gg",
		":version": "rv-xkf2~absj-z7m2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de Barri Verdun",
		"indicador_refugi": "080193|CASAL_DE_BARRI_VERDUN",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.44407",
		"longitud": "2.17517",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Luz Casanova, 4",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400246329",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-msk4_uy3e-qqvg",
		":version": "rv-tyuy.g53a-sd25",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de Barri de Vallbona",
		"indicador_refugi": "080193|CASAL_DE_BARRI_DE_VALLBONA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.46437",
		"longitud": "2.185937",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Oristà, 8-10",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99026102727",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-wy32-biwn.2ctk",
		":version": "rv-rh3v_w5gn~gu9b",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de les Tretze Roses",
		"indicador_refugi": "080193|PARC_DE_LES_TRETZE_ROSES",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.35155",
		"longitud": "2.140259",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "C. d'Ascó, 22",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400737923",
		"tipologia": "Parcs i Jardins",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-26sg_exj4_9hwf",
		":version": "rv-6ab3~f8xs~8dd4",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parròquia de Maria Mitjancera",
		"indicador_refugi": "080193|PARROQUIA_DE_MARIA_MITJANCERA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38494",
		"longitud": "2.143992",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Entença, 198-200",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400740107",
		"tipologia": "Centres de culte",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-6n4z-ehqj-99mb",
		":version": "rv-uwxv_jy8y_fr37",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Mercat de l'Abaceria",
		"indicador_refugi": "080193|MERCAT_DE_L_ABACERIA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.40331",
		"longitud": "2.164824",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pg. Sant Joan, 181",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086009463",
		"tipologia": "Mercats",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-dx7q_7nq7_m9jv",
		":version": "rv-n29s_bqfc~hnwh",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jocs d'aigua de Canyelles",
		"indicador_refugi": "080193|JOCS_D_AIGUA_DE_CANYELLES",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.4423",
		"longitud": "2.162721",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No (aire lliure)",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "C. Juan Ramón Jiménez, 14",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400656486",
		"tipologia": "Jocs d'aigua",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-r2dp-k4fj-uwiv",
		":version": "rv-muzn.vm2v_d7rg",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jocs d'aigua de les Rieres d'Horta",
		"indicador_refugi": "080193|JOCS_D_AIGUA_DE_LES_RIERES_D_HORTA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.4309",
		"longitud": "2.155467",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No (aire lliure)",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Av. Estatut de Catalunya, 21",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400695979",
		"tipologia": "Jocs d'aigua",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-r6qf.gez9~xkv4",
		":version": "rv-868h~c3ku-kzyi",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jocs d'aigua de Bon Pastor",
		"indicador_refugi": "080193|JOCS_D_AIGUA_DE_BON_PASTOR",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.43774",
		"longitud": "2.207129",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No (aire lliure)",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Pl. de la Lluita per les Llibertats",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400740126",
		"tipologia": "Jocs d'aigua",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-67m4-mhba~uqcx",
		":version": "rv-jnwc-u2ja~7r9f",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jocs d'aigua del Canòdrom",
		"indicador_refugi": "080193|JOCS_D_AIGUA_DEL_CANODROM",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.42722",
		"longitud": "2.183146",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No (aire lliure)",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "C. Can Ros, 35",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400740235",
		"tipologia": "Jocs d'aigua",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-295m_r7ks~myi5",
		":version": "rv-mtmr.m8vc-ctia",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centro Galego de Barcelona",
		"indicador_refugi": "080193|CENTRO_GALEGO_DE_BARCELONA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.37939",
		"longitud": "2.174737",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Rambla, 35-37",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086010651",
		"tipologia": "Entitats culturals",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-wjmc-tuy8_nidw",
		":version": "rv-79ew-pymd~9sgd",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Fundació Casa Asil Sant Andreu de Palomar",
		"indicador_refugi": "080193|FUNDACIO_CASA_ASIL_SANT_ANDREU_DE_PALOMAR",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.4388",
		"longitud": "2.186085",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Agustí i Milà, 72",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400740124",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-avun.dt6q-rqyk",
		":version": "rv-8r4z-vy4f.7j46",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari - La Barceloneta",
		"indicador_refugi": "080193|CASAL_CIVIC_I_COMUNITARI_LA_BARCELONETA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38045",
		"longitud": "2.188552",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Baluard, 28",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086011057",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-8hqg~zrbj.znen",
		":version": "rv-vz89.gv74~i8ww",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari - Horta",
		"indicador_refugi": "080193|CASAL_CIVIC_I_COMUNITARI_HORTA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.4266",
		"longitud": "2.156329",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Tolrà, 13-21 bxs",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/94110141919",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-u8kw.wkiq-gguk",
		":version": "rv-2c8e-hqet-d3te",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari - Guineueta",
		"indicador_refugi": "080193|CASAL_CIVIC_I_COMUNITARI_GUINEUETA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.44035",
		"longitud": "2.16655",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Guineueta, 19",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086026114",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-fif3_ueph~eg6x",
		":version": "rv-2amm-8iac~79de",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari - Prosperitat",
		"indicador_refugi": "080193|CASAL_CIVIC_I_COMUNITARI_PROSPERITAT",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.44193",
		"longitud": "2.180498",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. de Pablo Iglesias, 8",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400038461",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-xf8i.z5xv-kxbg",
		":version": "rv-mury-fd79.6q3h",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari - Trinitat Vella",
		"indicador_refugi": "080193|CASAL_CIVIC_I_COMUNITARI_TRINITAT_VELLA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.44975",
		"longitud": "2.191259",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. de la Madriguera, 38-42 baixos",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400513760",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-97ar_tezk-5ykt",
		":version": "rv-tace_s649~w786",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari - Verdum",
		"indicador_refugi": "080193|CASAL_CIVIC_I_COMUNITARI_VERDUM",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.44423",
		"longitud": "2.175522",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Luz Casanova, 8-10",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400595416",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-nwkm~iysm_ahrn",
		":version": "rv-579y_cc4k-smc2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari - Verdum Artesania",
		"indicador_refugi": "080193|CASAL_CIVIC_I_COMUNITARI_VERDUM_ARTESANIA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.44243",
		"longitud": "2.172552",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. de l'Artesania, 96-98",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400079150",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-r82k~dg4x_erqu",
		":version": "rv-9pxu_gp5d_u7hh",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari - Bac de Roda",
		"indicador_refugi": "080193|CASAL_CIVIC_I_COMUNITARI_BAC_DE_RODA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.41443",
		"longitud": "2.195884",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Bac de Roda, 190",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086011160",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-g36m_6sfk_2rh2",
		":version": "rv-w2z7-93tt_6bip",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari - La Pau",
		"indicador_refugi": "080193|CASAL_CIVIC_I_COMUNITARI_LA_PAU",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.42316",
		"longitud": "2.20858",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Pere Verges 1, 8a planta",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400144312",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-f32k-hfym~8453",
		":version": "rv-sq5g_xct7.uj3m",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari - Sants",
		"indicador_refugi": "080193|CASAL_CIVIC_I_COMUNITARI_SANTS",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38005",
		"longitud": "2.1335",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Violant Hongria Rna Aragó, 135",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086011106",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-yzu2~rzpd_3jhk",
		":version": "rv-zpiw_49br-7q2p",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jocs d'aigua de la font de la pl. Maresme",
		"indicador_refugi": "080193|JOCS_D_AIGUA_DE_LA_FONT_DE_LA_PL_MARESME",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.41213",
		"longitud": "2.215649",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No (aire lliure)",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Pl. del Maresme",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400757468",
		"tipologia": "Jocs d'aigua",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-kd4g.sydy-adyy",
		":version": "rv-99rq~hwj9_6hwu",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jocs d'aigua de la plaça de les Caramelles",
		"indicador_refugi": "080193|JOCS_D_AIGUA_DE_LA_PLACA_DE_LES_CARAMELLES",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38231",
		"longitud": "2.167777",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No (aire lliure)",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Pl. de les Caramelles",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400757467",
		"tipologia": "Jocs d'aigua",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-f2uq.abdp-xexh",
		":version": "rv-e89f~26gr-q6xd",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jocs d'aigua dels jardins de Sant Joan de Déu - Illa Diagonal",
		"indicador_refugi": "080193|JOCS_D_AIGUA_DELS_JARDINS_DE_SANT_JOAN_DE_DEU_ILLA_DIAGONAL",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38902",
		"longitud": "2.135393",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No (aire lliure)",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Av. Diagonal, 557",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400757466",
		"tipologia": "Jocs d'aigua",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-4bek-2qtk_2d2k",
		":version": "rv-i6cr_cx5t_wubk",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jocs d'aigua de la Plaça de les Glòries",
		"indicador_refugi": "080193|JOCS_D_AIGUA_DE_LA_PLACA_DE_LES_GLORIES",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.40407",
		"longitud": "2.185749",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No (aire lliure)",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Pl. de les Glòries Catalanes",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400757464",
		"tipologia": "Jocs d'aigua",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-4tq5~dc5h-r7v4",
		":version": "rv-wktp-6yi4~vv83",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Ton i Guida",
		"indicador_refugi": "080193|CENTRE_TON_I_GUIDA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.44633",
		"longitud": "2.175171",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Romaní, 6",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400143973",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-aibf.p4kh.jsgy",
		":version": "rv-xt6q.82hp_xsgg",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de Barri de Torre Baró",
		"indicador_refugi": "080193|CASAL_DE_BARRI_DE_TORRE_BARO",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.45951",
		"longitud": "2.180674",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Av. d'Escolapi Càncer, 5",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400143974",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-hjnv_fuha-vh8w",
		":version": "rv-wvuz.r2up-qrfs",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de Barri de Prosperitat",
		"indicador_refugi": "080193|CASAL_DE_BARRI_DE_PROSPERITAT",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.44162",
		"longitud": "2.179794",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pl. d'Àngel Pestaña",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086025446",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-hwuk_z363~6ih9",
		":version": "rv-56yz.fzae_ms5j",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de Barri Trinitat Nova - Som La Pera",
		"indicador_refugi": "080193|CASAL_DE_BARRI_TRINITAT_NOVA_SOM_LA_PERA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.45266",
		"longitud": "2.187632",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. de Garbí, 3",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400582519",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-cucb_m3t4-hufb",
		":version": "rv-vkqi~pdkv~4e3v",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bib. Sarrià - J.V.Foix",
		"indicador_refugi": "080193|BIB_SARRIA_J_V_FOIX",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.39956",
		"longitud": "2.121155",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pl. de Sarrià, 1",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400672437",
		"tipologia": "Biblioteques",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-9zef_5789-zw4m",
		":version": "rv-7axc_6h5q_t5a3",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Civic Sant Andreu",
		"indicador_refugi": "080193|CENTRE_CIVIC_SANT_ANDREU",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.43084",
		"longitud": "2.189411",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Gran de Sant Andreu, 111",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086004879",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-3ntx_hqsg~bgq6",
		":version": "rv-iiu2.3xj2_t9iq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Sala Pepita Casanelles (CC Casa del Rellotge)",
		"indicador_refugi": "080193|SALA_PEPITA_CASANELLES_CC_CASA_DEL_RELLOTGE",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.36095",
		"longitud": "2.138005",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pl. de l'Orgull, 1",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400180624",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-f3i7_22h8_qqid",
		":version": "rv-865w-tjn4_era5",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CC Albareda",
		"indicador_refugi": "080193|CC_ALBAREDA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.37399",
		"longitud": "2.17325",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. d'Albareda, 22",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400304670",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-6vzz_reqw~597k",
		":version": "rv-ix5c_bjpk_g5ks",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Col·legi de Metges de Barcelona",
		"indicador_refugi": "080193|COL_LEGI_DE_METGES_DE_BARCELONA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.40421",
		"longitud": "2.129325",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pg. de la Bonanova, 47",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086005338",
		"tipologia": "Altres",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-xwc8_ukk7-k7ef",
		":version": "rv-9fpg~b7ty~6snd",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Foodcoop BCN",
		"indicador_refugi": "080193|FOODCOOP_BCN",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38557",
		"longitud": "2.157338",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Ptge. d'Aragó, 9",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400685645",
		"tipologia": "Altres",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-wews-npbg_v6tq",
		":version": "rv-zk7u-qrx7~43dd",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Sala Barcelona del Museu Terra",
		"indicador_refugi": "080193|SALA_BARCELONA_DEL_MUSEU_TERRA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.40203",
		"longitud": "2.196899",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. de Pere IV, 141",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400727187",
		"tipologia": "Museus",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-xv3i~v4e4-t9iw",
		":version": "rv-ke78_jz5e.w4mf",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Associació de Comerciants Creu Coberta",
		"indicador_refugi": "080193|ASSOCIACIO_DE_COMERCIANTS_CREU_COBERTA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.376",
		"longitud": "2.143145",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Callao, 9",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086010309",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-nehb-nknt_r72z",
		":version": "rv-6dke_ynpf~3i2r",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casa Sanzano",
		"indicador_refugi": "080193|CASA_SANZANO",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.40471",
		"longitud": "2.176492",
		"accessibilitat": "Altres",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Lepant, 276",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400765984",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-hij3.h4um-gag2",
		":version": "rv-evyy.tz64-r9gb",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Farmàcia Jacas Mateu",
		"indicador_refugi": "080193|FARMACIA_JACAS_MATEU",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.40335",
		"longitud": "2.177716",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "C. València, 470",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/75990129747",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-4iwj-uxf7~gzmm",
		":version": "rv-qxxn~7fuw.vi4q",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Llibreria Byron",
		"indicador_refugi": "080193|LLIBRERIA_BYRON",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38338",
		"longitud": "2.161679",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. de Casanova, 32",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400659129",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-wzc2_tg3p~cv32",
		":version": "rv-kr8v-hwic.eedx",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Espai Social Torrent d'en Mariner",
		"indicador_refugi": "080193|ESPAI_SOCIAL_TORRENT_D_EN_MARINER",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.40369",
		"longitud": "2.170008",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Ptge. de Mariner, 13-17",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400691993",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-asb6~uv9n-8br3",
		":version": "rv-f3fi-iun3-5bdc",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Fundació Gentis - Concili de Trento",
		"indicador_refugi": "080193|FUNDACIO_GENTIS_CONCILI_DE_TRENTO",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.4114",
		"longitud": "2.192965",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Concili de Trento, 42, Baixos – Local 1",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400447894",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-pmpe_2utt_f4mi",
		":version": "rv-wszz_8ftw_ty3m",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Fundació Gentis - Raval",
		"indicador_refugi": "080193|FUNDACIO_GENTIS_RAVAL",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.37955",
		"longitud": "2.170168",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Sant Rafael 10, Baixos (=C. Maria Casas Mira, 10, Baixos)",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400766053",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-rfqn.ketp-83nv",
		":version": "rv-phv2.zrht~jdfa",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "EAP Sardenya",
		"indicador_refugi": "080193|EAP_SARDENYA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.40948",
		"longitud": "2.165579",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Sardenya, 466",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/1015170605",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-6hru.jqm8.5qyp",
		":version": "rv-dj9r.xpiw_4ekt",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Pati de l'escola Lluís Vives i d'Institut Lluís Vives",
		"indicador_refugi": "080193|PATI_DE_L_ESCOLA_LLUIS_VIVES_I_D_INSTITUT_LLUIS_VIVES",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.37177",
		"longitud": "2.128533",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "C. Canalejas, 107 (entrada pel C. Riera Blanca)",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400758401",
		"tipologia": "Patis d'Escola",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ww6t.hfgi.autr",
		":version": "rv-v4uh-kbvn_5c84",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca de l'escola Mercè Rodoreda",
		"indicador_refugi": "080193|BIBLIOTECA_DE_L_ESCOLA_MERCE_RODOREDA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.44581",
		"longitud": "2.185406",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. del Vesuvi, 35  (entrada per Av. Meridiana)",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400758411",
		"tipologia": "Biblioteques",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-tym6~v97g~knn4",
		":version": "rv-yy2i-wkya_jefb",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jocs d'aigua dels Entorns Casa de l'Aigua Trinitat Vella",
		"indicador_refugi": "080193|JOCS_D_AIGUA_DELS_ENTORNS_CASA_DE_L_AIGUA_TRINITAT_VELLA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.453",
		"longitud": "2.188282",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No (aire lliure)",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Carretera de Ribes, 103 - 111",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400758415",
		"tipologia": "Jocs d'aigua",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-293b.56gp_bb9r",
		":version": "rv-gsxu~bszx~fnat",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Maremagnum",
		"indicador_refugi": "080193|MAREMAGNUM",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.37511",
		"longitud": "2.183021",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Moll d'Espanya 5-6",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/95128134914",
		"tipologia": "Centres comercials",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-fu5g~9qjr-m837",
		":version": "rv-gszw~ynk9-dtay",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bebe-Té",
		"indicador_refugi": "080193|BEBE_TE",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.37584",
		"longitud": "2.161338",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Parlament, 7",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400582148",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-fc8t.7m3h-q627",
		":version": "rv-fk2m~ymqp-2xd3",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Siente",
		"indicador_refugi": "080193|SIENTE",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.41068",
		"longitud": "2.182774",
		"accessibilitat": "No",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Rogent, 96",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400766097",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-wej6-da9r~24e5",
		":version": "rv-dusn.qzve~2ggd",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Equipament Municipal de Plaça Sarrià",
		"indicador_refugi": "080193|EQUIPAMENT_MUNICIPAL_DE_PLACA_SARRIA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.39956",
		"longitud": "2.121155",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pl. de Sarrià, 1-4",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400758810",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ihy9.btz4-8ins",
		":version": "rv-x6ra_5rux.zt22",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Fundació Privada Avismón-Catalunya",
		"indicador_refugi": "080193|FUNDACIO_PRIVADA_AVISMON_CATALUNYA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.37367",
		"longitud": "2.134907",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. dels Jocs Florals, 59",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/97160101028",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-rxz5-urua_aumb",
		":version": "rv-4d6u~rfe9~t8hr",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Mercat de la Marina",
		"indicador_refugi": "080193|MERCAT_DE_LA_MARINA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.36052",
		"longitud": "2.139182",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí (gratuït)",
		"adreca": "Pg. Zona Franca 178-180",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086009456",
		"tipologia": "Mercats",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-rpc9-5imb-z4c6",
		":version": "rv-yk92_25cq_txb4",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Store Endesa",
		"indicador_refugi": "080193|STORE_ENDESA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.42942",
		"longitud": "2.159097",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Baixada de la Plana, 33",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400766100",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-yvsz.epgx.cbh2",
		":version": "rv-rkcb-m7g7_rwek",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Farmàcia Marina Oriol",
		"indicador_refugi": "080193|FARMACIA_MARINA_ORIOL",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.40124",
		"longitud": "2.202309",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Llull, 187",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086001777",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ahqm.jb7h_26mh",
		":version": "rv-vt9v.296u.nw5u",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CC Gand House",
		"indicador_refugi": "080193|CC_GAND_HOUSE",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.40179",
		"longitud": "2.202294",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Marià Aguilo, 72",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400766115",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-22sm~88hj~dwwt",
		":version": "rv-tz4m-vvnz~7sc3",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CAP Vallcarca Sant Gervasi",
		"indicador_refugi": "080193|CAP_VALLCARCA_SANT_GERVASI",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.4167",
		"longitud": "2.141258",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Av. De Vallcarca, 169-205",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400110414",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-p7pz~xtzk~jf4j",
		":version": "rv-mgef.mfkn_jj4x",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre de Teràpies Sàlvia",
		"indicador_refugi": "080193|CENTRE_DE_TERAPIES_SALVIA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.37446",
		"longitud": "2.158557",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Ricart, 3 local 1",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400766118",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-c8hf_t6iz~a2i7",
		":version": "rv-2tps~wqd8_deap",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Digicopy Verdaguer",
		"indicador_refugi": "080193|DIGICOPY_VERDAGUER",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.39708",
		"longitud": "2.167953",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "C. Girona, 119",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/98132142540",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-m7w9-7vvc_tstj",
		":version": "rv-9ysc~5jy2.sp35",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Institut Dental Sant Jordi",
		"indicador_refugi": "080193|INSTITUT_DENTAL_SANT_JORDI",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.41479",
		"longitud": "2.181333",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Indústria, 298-300",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400664990",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-jngq-ngrp-m99h",
		":version": "rv-fpmj_2a28_24jw",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CGG Montmany",
		"indicador_refugi": "080193|CGG_MONTMANY",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.40506",
		"longitud": "2.159132",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Montmany, 45",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086033482",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-spk6~rzxa-zqhh",
		":version": "rv-fvx5_4t4i~kvmh",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CGG Penitents",
		"indicador_refugi": "080193|CGG_PENITENTS",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.42113",
		"longitud": "2.140286",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Passeig Vall d'Hebron, 76-78",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/154110817",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-3iuq-ntp5~h9rc",
		":version": "rv-an4e-ivra_fgsb",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Farmàcia 24 Hores Antoni Torres",
		"indicador_refugi": "080193|FARMACIA_24_HORES_ANTONI_TORRES",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38864",
		"longitud": "2.159183",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "C. Aribau, 62",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/75990017682",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-kdpc_hpdt~zep2",
		":version": "rv-sha6~jvcu-mmtk",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Farmacia Virrei Amat",
		"indicador_refugi": "080193|FARMACIA_VIRREI_AMAT",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.43062",
		"longitud": "2.174537",
		"accessibilitat": "Sí",
		"aigua": "No",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "C. del Doctor Pi i Molist, 1",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/75990049036",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-yxe6-yhda.ifu4",
		":version": "rv-pct9~te33~hgbj",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Llanes Santa Eulàlia",
		"indicador_refugi": "080193|LLANES_SANTA_EULALIA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.43065",
		"longitud": "2.172745",
		"accessibilitat": "No",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Pere d'Artés, 6",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400766141",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-3dsr-fyvy~hprj",
		":version": "rv-4knh~wmex-kxad",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "V Natura",
		"indicador_refugi": "080193|V_NATURA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.43017",
		"longitud": "2.176241",
		"accessibilitat": "Sí",
		"aigua": "No",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Pg. de Fabra i Puig, 205",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400766145",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-bbxa-39kg.38dx",
		":version": "rv-mey3.tvd8-hdm5",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Moda interior dona i home Alfonsita",
		"indicador_refugi": "080193|MODA_INTERIOR_DONA_I_HOME_ALFONSITA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.43018",
		"longitud": "2.175361",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Pg. de Fabra i Puig, 223-225",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/96082091627",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-jw9q-eecw_sv2x",
		":version": "rv-g5nk~fa59-x26h",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "El rei del Peix",
		"indicador_refugi": "080193|EL_REI_DEL_PEIX",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.43026",
		"longitud": "2.186018",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Rbla. de Fabra i Puig, 78",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400766158",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-dgi7.um39.dbkz",
		":version": "rv-buxg~xvgy.vptf",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Xarcuteria Gasch",
		"indicador_refugi": "080193|XARCUTERIA_GASCH",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.4302",
		"longitud": "2.18684",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Rbla. de Fabra i Puig, 88-92",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400766159",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-bpuq_7fcz_p2b6",
		":version": "rv-xekh-g6v5_xrpu",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Farmàcia Estruch",
		"indicador_refugi": "080193|FARMACIA_ESTRUCH",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.37336",
		"longitud": "2.131451",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Rbla. de Badal, 156",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/75990144518",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-qibw~aar8-5ibu",
		":version": "rv-5jr8-haf5~4j22",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Alibri Llibreria",
		"indicador_refugi": "080193|ALIBRI_LLIBRERIA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38792",
		"longitud": "2.16485",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Balmes, 26",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/75990552606",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-5amb-tux6~5qmj",
		":version": "rv-iq9j_4ixk.6f52",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Manantial de salud",
		"indicador_refugi": "080193|MANANTIAL_DE_SALUD",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38366",
		"longitud": "2.169546",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "C. d'en Xuclà, 23",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/75990419327",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-3wgv_jety_tvwu",
		":version": "rv-ytft.gux2.j3xv",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Farmàcia Morera",
		"indicador_refugi": "080193|FARMACIA_MORERA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.39186",
		"longitud": "2.179096",
		"accessibilitat": "Sí",
		"aigua": "No",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Pg. Sant Joan, 3",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/75990000684",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-nvnx_xnez_26fa",
		":version": "rv-m8ps.bvd4_egbr",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Farmàcia Borràs",
		"indicador_refugi": "080193|FARMACIA_BORRAS",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.43921",
		"longitud": "2.179991",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Pg. Valldaura, 247",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/75990130798",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-rryy.jicv-ngwx",
		":version": "rv-3vmw~8qu3-dz5z",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Seu del Districte de Les Corts",
		"indicador_refugi": "080193|SEU_DEL_DISTRICTE_DE_LES_CORTS",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.3858",
		"longitud": "2.129818",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pl. Comas, 18",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400762003",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-mua7~pdjz.vh6d",
		":version": "rv-tspi~ff2z-ggsk",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Pati de l'Escola Bressol Municipal Pla de Fornells",
		"indicador_refugi": "080193|PATI_DE_L_ESCOLA_BRESSOL_MUNICIPAL_PLA_DE_FORNELLS",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.44818",
		"longitud": "2.178725",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No (aire lliure)",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C/ Dels Nou Barris, 12",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400762409",
		"tipologia": "Patis d'Escola Bressol",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-wq7k-rszj-7ukh",
		":version": "rv-aazf~ytxf_ijnf",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Pati de l'Escola Bressol Municipal El Palomar",
		"indicador_refugi": "080193|PATI_DE_L_ESCOLA_BRESSOL_MUNICIPAL_EL_PALOMAR",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.43631",
		"longitud": "2.187186",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No (aire lliure)",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C/de Malalts, 45",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400762448",
		"tipologia": "Patis d'Escola Bressol",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-5tvc-yhwq-6c7a",
		":version": "rv-effq_p2me.cgz9",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Kinesalut Barcelona",
		"indicador_refugi": "080193|KINESALUT_BARCELONA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.43571",
		"longitud": "2.188297",
		"accessibilitat": "sense dades",
		"aigua": "Sense Dades",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "sense dades",
		"adreca": "C. Pons i Gallarza, 20",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400710085",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-r4ae~u6v9-y9bm",
		":version": "rv-bavd_4qnk-7wtx",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Oficina Occident",
		"indicador_refugi": "080193|OFICINA_OCCIDENT",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.43422",
		"longitud": "2.188302",
		"accessibilitat": "sense dades",
		"aigua": "Sense Dades",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "sense dades",
		"adreca": "C. Rubén Darío, 27",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400766161",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-qzti.s86k~ek6k",
		":version": "rv-947k-brgk~gdah",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Botiga \"Equip\" (moda)",
		"indicador_refugi": "080193|BOTIGA_EQUIP_MODA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.43398",
		"longitud": "2.189175",
		"accessibilitat": "sense dades",
		"aigua": "Sense Dades",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "sense dades",
		"adreca": "Riera de Sant Andreu, 1",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400766162",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-amcn.ppjz-tch9",
		":version": "rv-6s6i.qvye~pitd",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Kids and Us",
		"indicador_refugi": "080193|KIDS_AND_US",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.43393",
		"longitud": "2.186393",
		"accessibilitat": "sense dades",
		"aigua": "Sense Dades",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "sense dades",
		"adreca": "C. d'Ignasi Iglésias, 85",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400442237",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-jdjq~zfzq~b6qg",
		":version": "rv-3ywi.srk3~yqrv",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Quiromassatges Pardos",
		"indicador_refugi": "080193|QUIROMASSATGES_PARDOS",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.43305",
		"longitud": "2.188528",
		"accessibilitat": "sense dades",
		"aigua": "Sense Dades",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "sense dades",
		"adreca": "C. de Coroleu, 6",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400766164",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-g96q_8izz_xrnb",
		":version": "rv-8gmt~vqze.wmxy",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Several Café",
		"indicador_refugi": "080193|SEVERAL_CAFE",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.43274",
		"longitud": "2.189206",
		"accessibilitat": "sense dades",
		"aigua": "Sense Dades",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "sense dades",
		"adreca": "C. Gran de Sant Andreu, 165",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400766165",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-b52r.msdy-22gk",
		":version": "rv-e4ka.cg2w~25vn",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Formatgeria Ireneu",
		"indicador_refugi": "080193|FORMATGERIA_IRENEU",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.4312",
		"longitud": "2.189283",
		"accessibilitat": "sense dades",
		"aigua": "Sense Dades",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "sense dades",
		"adreca": "C. Gran de Sant Andreu, 117",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400766166",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-tgsc_t5ry.2et5",
		":version": "rv-k43j.vrtk~vjwq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Farmàcia Carolina León",
		"indicador_refugi": "080193|FARMACIA_CAROLINA_LEON",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.43048",
		"longitud": "2.189545",
		"accessibilitat": "sense dades",
		"aigua": "Sense Dades",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "sense dades",
		"adreca": "C. Gran de Sant Andreu, 91",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086004882",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-vafr_w6gi~5tf2",
		":version": "rv-7tdk-hkz2~zkbh",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Carns i embotits \"Ca la Nuri\"",
		"indicador_refugi": "080193|CARNS_I_EMBOTITS_CA_LA_NURI",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.43323",
		"longitud": "2.185702",
		"accessibilitat": "sense dades",
		"aigua": "Sense Dades",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "sense dades",
		"adreca": "Pl. de les Palemeres, 11",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400766167",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-iyxh-q8dq~uujf",
		":version": "rv-h5w9.epqg-w2qf",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Farmàcia Isa Santos",
		"indicador_refugi": "080193|FARMACIA_ISA_SANTOS",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.433",
		"longitud": "2.185778",
		"accessibilitat": "sense dades",
		"aigua": "Sense Dades",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "sense dades",
		"adreca": "Pl. de les Palemeres, 9",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/75990114598",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ybnz-rjz7.tymt",
		":version": "rv-m85h_3x9p~puq6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Diambaar (moda)",
		"indicador_refugi": "080193|DIAMBAAR_MODA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.42911",
		"longitud": "2.188032",
		"accessibilitat": "sense dades",
		"aigua": "Sense Dades",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "sense dades",
		"adreca": "C. Nadal, 40",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400766188",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-hecc~yxhf-5kw5",
		":version": "rv-qfwu.tep3_m2jq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Grup dental Santponç",
		"indicador_refugi": "080193|GRUP_DENTAL_SANTPONC",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.43188",
		"longitud": "2.190924",
		"accessibilitat": "sense dades",
		"aigua": "Sense Dades",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "sense dades",
		"adreca": "C. Dr. Santponç, 28",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400766190",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-7a77~3suc_5asc",
		":version": "rv-bt7d_ut3m-xg9v",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Nova de Sant Andreu",
		"indicador_refugi": "080193|NOVA_DE_SANT_ANDREU",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.43178",
		"longitud": "2.18939",
		"accessibilitat": "sense dades",
		"aigua": "Sense Dades",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "sense dades",
		"adreca": "C. Gran de Sant Andreu, 142",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400766191",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-3srz_2u6h-xj9q",
		":version": "rv-tyrb.ztdj.tu2e",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Citydogs Store - Sant Andreu",
		"indicador_refugi": "080193|CITYDOGS_STORE_SANT_ANDREU",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.43561",
		"longitud": "2.190736",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. del Doctor Balari i Jovany, 9",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400766193",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-3d58-wfgs_uis3",
		":version": "rv-dxdt-pnm4~kfap",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Restaurant La Comtal",
		"indicador_refugi": "080193|RESTAURANT_LA_COMTAL",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.43583",
		"longitud": "2.190462",
		"accessibilitat": "sense dades",
		"aigua": "Sense Dades",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "sense dades",
		"adreca": "C. de l'Ajuntament, 9",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400605576",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-e8fa_ggk5_kbi8",
		":version": "rv-ai8h.63zg.e6ec",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Merceria Perelló",
		"indicador_refugi": "080193|MERCERIA_PERELLO",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.43568",
		"longitud": "2.189541",
		"accessibilitat": "sense dades",
		"aigua": "Sense Dades",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "sense dades",
		"adreca": "C. Gran de Sant Andreu, 261",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400766082",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-mnsd.wsbf-szs5",
		":version": "rv-t2mx_4gdz.nsc3",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Abans morta que senzilla (moda)",
		"indicador_refugi": "080193|ABANS_MORTA_QUE_SENZILLA_MODA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.43571",
		"longitud": "2.189619",
		"accessibilitat": "sense dades",
		"aigua": "Sense Dades",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "sense dades",
		"adreca": "C. Gran de Sant Andreu, 259",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400766080",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-wrpt~put2_vz4m",
		":version": "rv-k3gv.rcdz-mru3",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "La boutique del peluquero",
		"indicador_refugi": "080193|LA_BOUTIQUE_DEL_PELUQUERO",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.435",
		"longitud": "2.189449",
		"accessibilitat": "sense dades",
		"aigua": "Sense Dades",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "sense dades",
		"adreca": "C. Gran de Sant Andreu, 239",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400766074",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-iegv_cz38-y2zs",
		":version": "rv-vexi.f6kk~6iwx",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "La botiga de la Pepi",
		"indicador_refugi": "080193|LA_BOTIGA_DE_LA_PEPI",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.43496",
		"longitud": "2.189233",
		"accessibilitat": "sense dades",
		"aigua": "Sense Dades",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "sense dades",
		"adreca": "C. Mercat, 4",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400766068",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-3kd6.cdce.gce5",
		":version": "rv-u3dx_ecg2-cb5i",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Col·legi Oficial d'Infermeres i Infermers de Barcelona",
		"indicador_refugi": "080193|COL_LEGI_OFICIAL_D_INFERMERES_I_INFERMERS_DE_BARCELONA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.40707",
		"longitud": "2.208131",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. de Pujades, 350",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086001164",
		"tipologia": "Altres",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ee3a-ysuc_pt7u",
		":version": "rv-dhi8-6jyz.9xhr",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "VRoom Escape",
		"indicador_refugi": "080193|VROOM_ESCAPE",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.42593",
		"longitud": "2.190034",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Pacífic 19, Baixos, Local 1",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400766064",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-pqf6_ucrt-3j63",
		":version": "rv-e5na_9rm6~szgv",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Llibrería Ulises",
		"indicador_refugi": "080193|LLIBRERIA_ULISES",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.4261",
		"longitud": "2.188956",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Pacífic, 34",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400766063",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-3axj.sfhk~6wr7",
		":version": "rv-m24q.t26p~sdm9",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Farmàcia Carlota Miravitlles Gultresa",
		"indicador_refugi": "080193|FARMACIA_CARLOTA_MIRAVITLLES_GULTRESA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.41517",
		"longitud": "2.198466",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. de Julián Besteiro, 3",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/75990291699",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-pcq8-45nk.7v9w",
		":version": "rv-8e2g.hzub~zafg",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Farmàcia David Folch",
		"indicador_refugi": "080193|FARMACIA_DAVID_FOLCH",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.4325567",
		"longitud": "2.1555175",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Fàtima 10, baixos",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/75990054149",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-8kqi~6yqz_zts7",
		":version": "rv-mkuw~cehm~im3p",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Farmàcia De La Rambla",
		"indicador_refugi": "080193|FARMACIA_DE_LA_RAMBLA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.42462",
		"longitud": "2.208469",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Rambla Guipúscoa, 174",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400748805",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-9r54.78q3~5dy8",
		":version": "rv-y5de~apnt.pj7y",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Farmàcia Marcos Molina",
		"indicador_refugi": "080193|FARMACIA_MARCOS_MOLINA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.43635",
		"longitud": "2.205577",
		"accessibilitat": "Sí",
		"aigua": "No",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "C. de Sant Adrià, 131",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/75990225326",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-wxnq~cjpj.3spb",
		":version": "rv-z48c_qtpm~prbs",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Soledad Pérez Fisioterapia",
		"indicador_refugi": "080193|SOLEDAD_PEREZ_FISIOTERAPIA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.427102849691",
		"longitud": "2.15708993956947",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Rambla del Carmel, 6",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400145611",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-5c68~a4n6-5zfx",
		":version": "rv-tjhr~ju6a~vckr",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Hospital Universitari Sagrat Cor",
		"indicador_refugi": "080193|HOSPITAL_UNIVERSITARI_SAGRAT_COR",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38896",
		"longitud": "2.145559",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Viladomat 288",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086002636",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-xk2a~y62f-kvcy",
		":version": "rv-wtfx~5xie~aaa5",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Collell (moda)",
		"indicador_refugi": "080193|COLLELL_MODA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.42956",
		"longitud": "2.160326",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Tajo, 69",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400781055",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-zjmx~fgam_34wu",
		":version": "rv-8r3y_f7rc_7wbj",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Cor d'Horta Eix Comercial",
		"indicador_refugi": "080193|COR_D_HORTA_EIX_COMERCIAL",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.42957",
		"longitud": "2.160193",
		"accessibilitat": "No",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "C/ Tajo, 71 (botiga 2); Enviaments a Tajo 69 (botiga de la presidenta de Cor d'Horta)",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400477124",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-cthm.6ei6~zy3r",
		":version": "rv-e8ep.8u5w-64rq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Abacus Fabra I Puig",
		"indicador_refugi": "080193|ABACUS_FABRA_I_PUIG",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.43039",
		"longitud": "2.18102",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Passeig Fabra i Puig, 196",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400400153",
		"tipologia": "Centres comercials",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-akye.psv3~pnsd",
		":version": "rv-uu3f~nkst_tga2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jardí de les Tres Torres",
		"indicador_refugi": "080193|JARDI_DE_LES_TRES_TORRES",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.39874726",
		"longitud": "2.13415046",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Rda. General Mitre, 76",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400780996",
		"tipologia": "Parcs i Jardins",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-5n82.mpfi-m5np",
		":version": "rv-btpx-mu6p-3w2f",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina Descoberta del CEM Parc de la Ciutadella",
		"indicador_refugi": "080193|PISCINA_DESCOBERTA_DEL_CEM_PARC_DE_LA_CIUTADELLA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38553",
		"longitud": "2.186413",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No (aire lliure)",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pg. de Circumval·lació, 1",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400293637",
		"tipologia": "Piscines",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-va5h.nx9v_9vkg",
		":version": "rv-ttd7~da66.d96x",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina Coberta del CEM Mundet",
		"indicador_refugi": "080193|PISCINA_COBERTA_DEL_CEM_MUNDET",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.43591",
		"longitud": "2.142863",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Olympe de Gouges, s/n",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/93179131212",
		"tipologia": "Piscines",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-dcg6_9inz~nn2j",
		":version": "rv-y6q6-69wx.pfz9",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscines Cobertes del CEM Bac de Roda",
		"indicador_refugi": "080193|PISCINES_COBERTES_DEL_CEM_BAC_DE_RODA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.41435",
		"longitud": "2.194073",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Rbla. Guipúscoa, 25",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400038777",
		"tipologia": "Piscines",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-2c7y.748f_ys8t",
		":version": "rv-g79e~79ve-mrk4",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina Coberta del CEM Bon Pastor",
		"indicador_refugi": "080193|PISCINA_COBERTA_DEL_CEM_BON_PASTOR",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.43818",
		"longitud": "2.201731",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Costa Daurada, 12",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400322487",
		"tipologia": "Piscines",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-59ft-xwgv-4rhm",
		":version": "rv-8vsv~dfg5.yauc",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina Coberta del CEM Can Caralleu",
		"indicador_refugi": "080193|PISCINA_COBERTA_DEL_CEM_CAN_CARALLEU",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.40156",
		"longitud": "2.111093",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. dels Esports, 2-8",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400228653",
		"tipologia": "Piscines",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-m9g8~em44-ehbc",
		":version": "rv-6rz3-7u82_esiy",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscines Descobertes del CEM Piscines Bernat Picornell",
		"indicador_refugi": "080193|PISCINES_DESCOBERTES_DEL_CEM_PISCINES_BERNAT_PICORNELL",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.36629",
		"longitud": "2.150628",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No (aire lliure)",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Av. de l'Estadi, 30-38",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/94125142139",
		"tipologia": "Piscines",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-pu9b_cny3-z8e8",
		":version": "rv-kyes~buv2_8e7c",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Llac del CEM Can Dragó",
		"indicador_refugi": "080193|LLAC_DEL_CEM_CAN_DRAGO",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.43657",
		"longitud": "2.183127",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No (aire lliure)",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Roselló i Porcel, 7-11",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/94147122530",
		"tipologia": "Piscines",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-74rt_6qea~j5rf",
		":version": "rv-6e7a.b5bb~6r9u",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina Coberta del CEM de Sant Sebastià",
		"indicador_refugi": "080193|PISCINA_COBERTA_DEL_CEM_DE_SANT_SEBASTIA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.37358",
		"longitud": "2.188742",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pl. del Mar, s/n",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/97302140150",
		"tipologia": "Piscines",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-4h6g_5bzj_82b9",
		":version": "rv-n8va~29hk~qtm4",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina Descoberta del CEM Trinitat Vella",
		"indicador_refugi": "080193|PISCINA_DESCOBERTA_DEL_CEM_TRINITAT_VELLA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.45145",
		"longitud": "2.193105",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No (aire lliure)",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Via Bàrcino, 84-86",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086010811",
		"tipologia": "Piscines",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-m9vi.ufcf.b4xd",
		":version": "rv-iu27_sgkf~hmbb",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscines Cobertes del CEM Guinardó",
		"indicador_refugi": "080193|PISCINES_COBERTES_DEL_CEM_GUINARDO",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.41702",
		"longitud": "2.173619",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Telègraf, 31-45",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400322475",
		"tipologia": "Piscines",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-nudr~3z9k~kvfy",
		":version": "rv-2b7a-j9y2-gnc3",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscines Cobertes del CEM Can Toda",
		"indicador_refugi": "080193|PISCINES_COBERTES_DEL_CEM_CAN_TODA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.41535",
		"longitud": "2.158164",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Ramiro de Maeztu, 25",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086003371",
		"tipologia": "Piscines",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-pkpx.3azi.vgwz",
		":version": "rv-u4n9_5pix-t9m6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jocs d'aigua de Joan Raventós",
		"indicador_refugi": "080193|JOCS_D_AIGUA_DE_JOAN_RAVENTOS",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.4035872",
		"longitud": "2.1169262",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No (aire lliure)",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Carrer Major de Sarrià 242",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400780974",
		"tipologia": "Jocs d'aigua",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-k8xs~csq8~uvyr",
		":version": "rv-hwwn~wx65.zgif",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jocs d'aigua de Carme Simó",
		"indicador_refugi": "080193|JOCS_D_AIGUA_DE_CARME_SIMO",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.3829675",
		"longitud": "2.1794427",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No (aire lliure)",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Carrer del Sots-Tinent Navarro, 12",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400780973",
		"tipologia": "Jocs d'aigua",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-72js.fx65~6dwb",
		":version": "rv-z8t4~zvrd~ee3a",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jocs d'aigua del Parc de Santiburcio",
		"indicador_refugi": "080193|JOCS_D_AIGUA_DEL_PARC_DE_SANTIBURCIO",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.4435387",
		"longitud": "2.1882884",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No (aire lliure)",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Carrer Gran de Sant Andreu, 505",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400780972",
		"tipologia": "Jocs d'aigua",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-8h5e.8pzb_mcjp",
		":version": "rv-qs5h.zbws_an6b",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jocs d'aigua de Lolita Torrentó",
		"indicador_refugi": "080193|JOCS_D_AIGUA_DE_LOLITA_TORRENTO",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.4131371",
		"longitud": "2.186578",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No (aire lliure)",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Av Meridiana 181",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400780969",
		"tipologia": "Jocs d'aigua",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-wi4u~zvpu~jdnk",
		":version": "rv-48sg.jxhu~3q4z",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jocs d'aigua d'Avinguda Mistral",
		"indicador_refugi": "080193|JOCS_D_AIGUA_D_AVINGUDA_MISTRAL",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.3769365",
		"longitud": "2.1577779",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No (aire lliure)",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Av. de Mistral, 41-43",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400780968",
		"tipologia": "Jocs d'aigua",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ciqq.x4ik_yvy9",
		":version": "rv-97p7~db37_knt9",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jocs d'aigua de Joan Pelegrí",
		"indicador_refugi": "080193|JOCS_D_AIGUA_DE_JOAN_PELEGRI",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.3757959",
		"longitud": "2.1423853",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No (aire lliure)",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Carrer de Miquel Bleach 24",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400780967",
		"tipologia": "Jocs d'aigua",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-cmzh-pcie_6q2q",
		":version": "rv-khbs-7s8d.ppfp",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jocs d'aigua del Baix Guinardó",
		"indicador_refugi": "080193|JOCS_D_AIGUA_DEL_BAIX_GUINARDO",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.4047673",
		"longitud": "2.1632812",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No (aire lliure)",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Travessera de Gràcia 381",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400780965",
		"tipologia": "Jocs d'aigua",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-mih2~juw6~csix",
		":version": "rv-yvbw.fpbm_89u4",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jocs d'aigua de Justa Freire",
		"indicador_refugi": "080193|JOCS_D_AIGUA_DE_JUSTA_FREIRE",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.3536649",
		"longitud": "2.1384097",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No (aire lliure)",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "C. de Miquel Porter i Moix 22",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400780962",
		"tipologia": "Jocs d'aigua",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-rrd4.x5pr_yqeg",
		":version": "rv-szyu-4j2z~xr7t",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Mercat de la Barceloneta",
		"indicador_refugi": "080193|MERCAT_DE_LA_BARCELONETA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.3799145",
		"longitud": "2.1893886",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça Poeta Boscà, 1-2",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086009445",
		"tipologia": "Mercats",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-p6qs~8iuw_xb8d",
		":version": "rv-cq89-7ncz~7sak",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Mercat de Sant Gervasi",
		"indicador_refugi": "080193|MERCAT_DE_SANT_GERVASI",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.4056154",
		"longitud": "2.138591",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça Joaquim Folguera, 6",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086009462",
		"tipologia": "Mercats",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-mjhv.wytx~hyka",
		":version": "rv-af8p-dh8x_y2br",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bosc de l'Aula Ambiental del Bosc Turull",
		"indicador_refugi": "080193|BOSC_DE_L_AULA_AMBIENTAL_DEL_BOSC_TURULL",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.4132662",
		"longitud": "2.1470935",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Passeig de Turull, 2",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400397214",
		"tipologia": "Parcs i Jardins",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-uhc8_skt8.ivwg",
		":version": "rv-tux5.d4am-cwxn",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "La Masia de la Guineueta",
		"indicador_refugi": "080193|LA_MASIA_DE_LA_GUINEUETA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.43753136",
		"longitud": "2.16930497",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça de Ca n'Ensenya, s/n",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400065443",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-tfu7~4gt5-et7b",
		":version": "rv-vvmm_4654~whh9",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de Gent Gran de Roquetes",
		"indicador_refugi": "080193|CASAL_DE_GENT_GRAN_DE_ROQUETES",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.4460721",
		"longitud": "2.1744819",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça dels Titellaires, 1",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/94052175818",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-atsb_qqtk~knc6",
		":version": "rv-vatv.pa6s.kvmi",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de Gent Gran Casa Nostra",
		"indicador_refugi": "080193|CASAL_DE_GENT_GRAN_CASA_NOSTRA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.43275252",
		"longitud": "2.17614027",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer de la Maladeta, 38",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086011148",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-yaec_f23p~s3ek",
		":version": "rv-nssg-xz4v.ajgg",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de Gent Gran Vilapicina i la Torre Llobeta",
		"indicador_refugi": "080193|CASAL_DE_GENT_GRAN_VILAPICINA_I_LA_TORRE_LLOBETA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.42691",
		"longitud": "2.1764078",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça de Carmen Laforet, 11",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400287230",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-h7nm-4jiy_gdv8",
		":version": "rv-f4bw-jq8w.ugew",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Espai comunitari Torre Júlia",
		"indicador_refugi": "080193|ESPAI_COMUNITARI_TORRE_JULIA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.4458602",
		"longitud": "2.1808932",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Via Favència, 348-350",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400780950",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-5m7u-vev4~r23f",
		":version": "rv-vdch_2v95.ri49",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Canòdrom - Ateneu d'Innovació Digital i Democràtica",
		"indicador_refugi": "080193|CANODROM_ATENEU_D_INNOVACIO_DIGITAL_I_DEMOCRATICA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.4274947",
		"longitud": "2.183322",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Concepción Arenal 165",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400407793",
		"tipologia": "Altres",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-88ky-9rcp_tpab",
		":version": "rv-jw8t_kwp3.k937",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre de Vida Comunitària de Trinitat Vella",
		"indicador_refugi": "080193|CENTRE_DE_VIDA_COMUNITARIA_DE_TRINITAT_VELLA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.4507231",
		"longitud": "2.1891833",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carretera de Ribes, 59",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400691864",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-82yb_mzi3_vctu",
		":version": "rv-zfez~fcmr_t2ym",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de Barri Espai Antoni Miró Peris",
		"indicador_refugi": "080193|CASAL_DE_BARRI_ESPAI_ANTONI_MIRO_PERIS",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.41285176",
		"longitud": "2.18452812",
		"accessibilitat": "si",
		"aigua": "Sí",
		"climatitzacio": "si",
		"area_descans": "Sí",
		"lavabo": "SI",
		"adreca": "Plaça de Carme Montoriol, 10",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400201447",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-pzp9_27ex_3tjz",
		":version": "rv-hyga-vzs5_rqxz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de Barri Besòs",
		"indicador_refugi": "080193|CASAL_DE_BARRI_BESOS",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.4171152311895",
		"longitud": "2.21468165460701",
		"accessibilitat": "si",
		"aigua": "Sí",
		"climatitzacio": "si",
		"area_descans": "Sí",
		"lavabo": "si",
		"adreca": "c. Cristóbal de Moura, 232",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400023006",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-mpbf-y5p3_d8xz",
		":version": "rv-j8xr-5mqd-aysx",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Seu del Districte de Sant Martí",
		"indicador_refugi": "080193|SEU_DEL_DISTRICTE_DE_SANT_MARTI",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.4086531",
		"longitud": "2.1923116",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Pl. Valentí Almirall, 1",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400780928",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-xzr7~8vpi.54cd",
		":version": "rv-u3m2-cdei~5bek",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Espai Veïnal Olzinelles",
		"indicador_refugi": "080193|ESPAI_VEINAL_OLZINELLES",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.3728383",
		"longitud": "2.1365287",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Olzinelles, 30",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400765478",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-5yzm_5tfz.2if6",
		":version": "rv-i2g5-zdnm_yqk7",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Espai Jove la Bàscula",
		"indicador_refugi": "080193|ESPAI_JOVE_LA_BASCULA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.3584786",
		"longitud": "2.1442062",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Foc, 128",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086026021",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-uvxa.mkqh~3jz6",
		":version": "rv-75nt-6vrs_b5sp",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Espai Jove Casa Sagnier",
		"indicador_refugi": "080193|ESPAI_JOVE_CASA_SAGNIER",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.4018751",
		"longitud": "2.1445129",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "si",
		"adreca": "C. Brusi, 61",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400191463",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-dptv~7wcx~wess",
		":version": "rv-ucts~8yvc~bmkw",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Espai de Gent Gran Germanetes",
		"indicador_refugi": "080193|ESPAI_DE_GENT_GRAN_GERMANETES",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.3819303",
		"longitud": "2.1547109",
		"accessibilitat": "si",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Viladomat, 142",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400753482",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-xxmq~bq3t_s7fd",
		":version": "rv-uajf_gbu4.zava",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Espai Jove Ca la Panarra",
		"indicador_refugi": "080193|ESPAI_JOVE_CA_LA_PANARRA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.3850453",
		"longitud": "2.1285745",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Dolors Masferrer, 29",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400010469",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-hgkx_s847~5488",
		":version": "rv-svkn_dtte.a6qj",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Abacus Urquinaona",
		"indicador_refugi": "080193|ABACUS_URQUINAONA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.39073",
		"longitud": "2.175013",
		"accessibilitat": "Sí",
		"aigua": "No",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer d'Ausiàs Marc, 16",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/75990020440",
		"tipologia": "Centres comercials",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-zaz4~8h3k.wdid",
		":version": "rv-pqgm-kkjd-iayi",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Espai Abacus Enric Granados",
		"indicador_refugi": "080193|ESPAI_ABACUS_ENRIC_GRANADOS",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.39385",
		"longitud": "2.154607",
		"accessibilitat": "Sí",
		"aigua": "No",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer d'Enric Granados, 112",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400722915",
		"tipologia": "Centres comercials",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-gz28~x5k2-pnhu",
		":version": "rv-d7v4_7ytq_4mu5",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Abacus Illa Diagonal",
		"indicador_refugi": "080193|ABACUS_ILLA_DIAGONAL",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38974",
		"longitud": "2.13523",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Avinguda Diagonal, 545-557",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400234862",
		"tipologia": "Centres comercials",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-xphg_qbcs.rzi3",
		":version": "rv-nzmj.9asf.a75t",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Església Evangèlica Unida De Barcelona",
		"indicador_refugi": "080193|ESGLESIA_EVANGELICA_UNIDA_DE_BARCELONA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.43196",
		"longitud": "2.1791",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Santapau, 102",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400780883",
		"tipologia": "Centres de culte",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-qes2~6ts5_2jjb",
		":version": "rv-bv7k.bcpb_359y",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Pati de l'escola Drassanes",
		"indicador_refugi": "080193|PATI_DE_L_ESCOLA_DRASSANES",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.37908",
		"longitud": "2.177236",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "C. Nou de Sant Francesc, 11 (entrada pel C. d’en Rull)",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400780872",
		"tipologia": "Patis d'Escola",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-r5yj_mi7z-6m8i",
		":version": "rv-vb2g~cwwn~ufry",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Pati de l'escola Antoni Brusi",
		"indicador_refugi": "080193|PATI_DE_L_ESCOLA_ANTONI_BRUSI",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.3912306177642",
		"longitud": "2.18969489693352",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "C. Sardenya, 27",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400780869",
		"tipologia": "Patis d'Escola",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ydhq_mn75_e27b",
		":version": "rv-6x5f~q6pm-fx4r",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Pati de l'escola Baldiri Reixac",
		"indicador_refugi": "080193|PATI_DE_L_ESCOLA_BALDIRI_REIXAC",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.4138954697183",
		"longitud": "2.15304342391782",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "C. Olot, 1-13 (Recinte Parc Güell)",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400780866",
		"tipologia": "Patis d'Escola",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-6p7w-s5ke-qcgb",
		":version": "rv-2x47_eckq~ysta",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Pati de l'escola Torrent de Can Carabassa",
		"indicador_refugi": "080193|PATI_DE_L_ESCOLA_TORRENT_DE_CAN_CARABASSA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.42681",
		"longitud": "2.161066",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "C. Llobregós, 17-23 (entrada per la porta de la rampa)",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400780864",
		"tipologia": "Patis d'Escola",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-d85k-swqq~pr5b",
		":version": "rv-6d33-m5wk.2icv",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Pati de l'institut Escola Tramuntana",
		"indicador_refugi": "080193|PATI_DE_L_INSTITUT_ESCOLA_TRAMUNTANA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.43871",
		"longitud": "2.189824",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "C. de Guardiola i Feliu, 7-9 (entrada pel C. Lanzarote)",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400758413",
		"tipologia": "Patis d'Escola",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-5kta_n8bz.dkqw",
		":version": "rv-ju7b-h8pn.hh3i",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Ca l'Alier - Centre d’Innovació Urbana",
		"indicador_refugi": "080193|CA_L_ALIER_CENTRE_D_INNOVACIO_URBANA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.40986",
		"longitud": "2.203492",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C Pere IV, 362",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400605048",
		"tipologia": "Altres",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-bcgp.vbx5~8be8",
		":version": "rv-q94w_y9fi~ij65",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Oficina de atención al público de Endesa",
		"indicador_refugi": "080193|OFICINA_DE_ATENCION_AL_PUBLICO_DE_ENDESA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38729",
		"longitud": "2.1659397",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Gran Via de les Corts Catalanes  608",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/98184131023",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-hw24-bnmx~qyg5",
		":version": "rv-bwn6-38eq_qb3n",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Gremi de reformes d'interiors",
		"indicador_refugi": "080193|GREMI_DE_REFORMES_D_INTERIORS",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.4389749",
		"longitud": "2.1908598",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Passeig de Torras i Bages 55",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400469849",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-9ccy_q6gk-t4ry",
		":version": "rv-nf2u~jb5u_yefz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Oficina de Bonavista Apartments",
		"indicador_refugi": "080193|OFICINA_DE_BONAVISTA_APARTMENTS",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.3977983",
		"longitud": "2.1590463",
		"accessibilitat": "Altres",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Bonavista, 4",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400780855",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-9si3~2s5n.32uc",
		":version": "rv-u33w~y3vg.5cxp",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bloc4BCN - Espai Cooperatiu",
		"indicador_refugi": "080193|BLOC4BCN_ESPAI_COOPERATIU",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.3696150521122",
		"longitud": "2.13746324733179",
		"accessibilitat": "Altres",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer de la Constitució, 19",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400708893",
		"tipologia": "Altres",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-qsir-gnwa~xm73",
		":version": "rv-675h-48ma-m2xj",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Església Evangèlica Baptista de Gràcia (EEBG)",
		"indicador_refugi": "080193|ESGLESIA_EVANGELICA_BAPTISTA_DE_GRACIA_EEBG",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.40952",
		"longitud": "2.151394",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Verdi 191",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400781746",
		"tipologia": "Centres de culte",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-gr6z_n5y4~zvah",
		":version": "rv-8mpd~p6ux~g3kn",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Fnac Rambles",
		"indicador_refugi": "080193|FNAC_RAMBLES",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.37327",
		"longitud": "2.168369",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "La Rambla de Canaletes, 131",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/98314113344",
		"tipologia": "Centres comercials",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-e7kh_yq5b-2636",
		":version": "rv-p2m4.ihin~kdmj",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Associació Catalana de Recursos Assistencials (ACRA)",
		"indicador_refugi": "080193|ASSOCIACIO_CATALANA_DE_RECURSOS_ASSISTENCIALS_ACRA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.37911",
		"longitud": "2.155798",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer de Calàbria, 236 -240 (local)",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086038572",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-spsw.ttk3_gcxc",
		":version": "rv-z9vp.gd5w_fxn5",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Farmàcia Dr. Jesús Paterna",
		"indicador_refugi": "080193|FARMACIA_DR_JESUS_PATERNA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.41899",
		"longitud": "2.210454",
		"accessibilitat": "Sí",
		"aigua": "No",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Bernat Metge, 6-8 (local6)",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/98357092109",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-a99g.g5ju.jxaj",
		":version": "rv-ush3-mqff_3udy",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Farmàcia Amílcar",
		"indicador_refugi": "080193|FARMACIA_AMILCAR",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.42991",
		"longitud": "2.172032",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer d'Amílcar 7",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/75990014864",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-z9w4_dhqz.cs55",
		":version": "rv-8p5w-xstb.kb38",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jocs d'aigua de la Plaça de Harry Walker",
		"indicador_refugi": "080193|JOCS_D_AIGUA_DE_LA_PLACA_DE_HARRY_WALKER",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.4397626279174",
		"longitud": "2.18150331438045",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No (aire lliure)",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Plaça de Harry Walker",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400781745",
		"tipologia": "Jocs d'aigua",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-cpg6~rc6x_auqc",
		":version": "rv-ky4g~y4p3.s8pt",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "INTERIOR:  Hall CCCB (mes d'agost)",
		"indicador_refugi": "080193|INTERIOR_HALL_CCCB_MES_D_AGOST",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.3837",
		"longitud": "2.166633",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. de Montalegre, 5",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/94042144909",
		"tipologia": "Museus",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ae8m_6wqq-vf59",
		":version": "rv-kffj_fze7~csy7",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "INTERIOR: Vestíbul CCCB planta -1 (16 juny-13 setembre)",
		"indicador_refugi": "080193|INTERIOR_VESTIBUL_CCCB_PLANTA_1_16_JUNY_13_SETEMBRE",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.3837",
		"longitud": "2.166633",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. de Montalegre, 5",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/94042144909",
		"tipologia": "Museus",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-cmkt-bney-7tue",
		":version": "rv-p93y-t9qk.iz9a",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "INTERIOR: Espai familiar CCCB planta 0 (16 juny-6 setembre, tardes)",
		"indicador_refugi": "080193|INTERIOR_ESPAI_FAMILIAR_CCCB_PLANTA_0_16_JUNY_6_SETEMBRE_TARDES",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.3837",
		"longitud": "2.166633",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. de Montalegre, 5",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/94042144909",
		"tipologia": "Museus",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ynqh~aip8_iuqq",
		":version": "rv-aa4q.bce6_5zap",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "EXTERIOR: Pati de les Dones CCCB (obert cada dia)",
		"indicador_refugi": "080193|EXTERIOR_PATI_DE_LES_DONES_CCCB_OBERT_CADA_DIA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.3837",
		"longitud": "2.166633",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "No",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. de Montalegre, 5",
		"informacio_web": "https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/94042144909",
		"tipologia": "Museus",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-jhgk_4v3c-qas6",
		":version": "rv-fip9-jd6m.ncka",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "EAP Dreta Eixample",
		"indicador_refugi": "080193|EAP_DRETA_EIXAMPLE",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.39887",
		"longitud": "2.172714",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer de Roger de Flor, 194",
		"informacio_web": "NA",
		"tipologia": "_Microrefugis",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-jb9t.urky_w2b3",
		":version": "rv-e39i~fax9-vrqh",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Facultat Blanquerna - cafeteria",
		"indicador_refugi": "080193|FACULTAT_BLANQUERNA_CAFETERIA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.41141",
		"longitud": "2.132668",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer del Císter, 34",
		"informacio_web": "NA",
		"tipologia": "Universitats",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-nygx_cmdf-at2x",
		":version": "rv-9wms_z5is-g9sv",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Reclau Projecte i Obra SL",
		"indicador_refugi": "080193|RECLAU_PROJECTE_I_OBRA_SL",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.37213",
		"longitud": "2.126748",
		"accessibilitat": "Sí",
		"aigua": "No",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Riera Blanca, 105",
		"informacio_web": "NA",
		"tipologia": "Altres",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-wbwm_hj86.8vsu",
		":version": "rv-99me.xxwi-4rwa",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Comercial L'illa Diagonal",
		"indicador_refugi": "080193|CENTRE_COMERCIAL_L_ILLA_DIAGONAL",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38952",
		"longitud": "2.134703",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Avinguda Diagonal 545",
		"informacio_web": "NA",
		"tipologia": "Centres comercials",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-vvfr_d3gr_kd2h",
		":version": "rv-4pa9~sg9j_gtn5",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "The Book Bar",
		"indicador_refugi": "080193|THE_BOOK_BAR",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.43869",
		"longitud": "2.188913",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Gran de Sant Andreu 368",
		"informacio_web": "NA",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-c5j3_8rs9_2dhg",
		":version": "rv-femx~at5k.5vdg",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Botiga Consum Avinguda De Madrid 46",
		"indicador_refugi": "080193|BOTIGA_CONSUM_AVINGUDA_DE_MADRID_46",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.37712",
		"longitud": "2.125477",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Avinguda de Madrid, 46",
		"informacio_web": "NA",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-m3fy~33ap-ki34",
		":version": "rv-dnp8~vadt_7ifm",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Botiga Consum Avinguda De Roma",
		"indicador_refugi": "080193|BOTIGA_CONSUM_AVINGUDA_DE_ROMA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38146",
		"longitud": "2.146779",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Avinguda de Roma, 32",
		"informacio_web": "NA",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-4h2n.jpny-j76p",
		":version": "rv-cpkp~uw3m_6qca",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Botiga Consum Lluçà",
		"indicador_refugi": "080193|BOTIGA_CONSUM_LLUCA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38217",
		"longitud": "2.130911",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer de Lluçà, 19",
		"informacio_web": "NA",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-82s4-7de3_db33",
		":version": "rv-cubt.s4ek.ynf5",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Botiga Consum Sants",
		"indicador_refugi": "080193|BOTIGA_CONSUM_SANTS",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.37539",
		"longitud": "2.135879",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer de Sants, 208",
		"informacio_web": "NA",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-wzqa_zcvv~2uhc",
		":version": "rv-tmv7-mmnm_ay6p",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Botiga Consum Roselló 346",
		"indicador_refugi": "080193|BOTIGA_CONSUM_ROSELLO_346",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.39086",
		"longitud": "2.154038",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer del Rosselló, 344",
		"informacio_web": "NA",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-2i6a~7zwa~hrrc",
		":version": "rv-q8re.zqef_incu",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Botiga Consum Meridiana",
		"indicador_refugi": "080193|BOTIGA_CONSUM_MERIDIANA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.42226",
		"longitud": "2.186832",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Avinguda Meridiana, 260",
		"informacio_web": "NA",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ax4j~9ip2.t3za",
		":version": "rv-gn4z_htq7.j79w",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Botiga Consum D'entença",
		"indicador_refugi": "080193|BOTIGA_CONSUM_D_ENTENCA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.37676",
		"longitud": "2.154562",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer d'Entença, 28",
		"informacio_web": "NA",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-vnmf.vv8v_6fhx",
		":version": "rv-a9uf.4kye_4ndu",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Botiga Consum Compte Borrell",
		"indicador_refugi": "080193|BOTIGA_CONSUM_COMPTE_BORRELL",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38692",
		"longitud": "2.149971",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer del Comte Borrell, 13",
		"informacio_web": "NA",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-m22g-u2zh~qiux",
		":version": "rv-y59n~zc96~nhgt",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Botiga Consum República Argentina",
		"indicador_refugi": "080193|BOTIGA_CONSUM_REPUBLICA_ARGENTINA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.41326",
		"longitud": "2.1387",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Avinguda de la República Argentina, 269",
		"informacio_web": "NA",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-egjh_d6cu-6hry",
		":version": "rv-ig7n-2krx~85ze",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Botiga Consum Avinguda De Madrid 160",
		"indicador_refugi": "080193|BOTIGA_CONSUM_AVINGUDA_DE_MADRID_160",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38027",
		"longitud": "2.131317",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Avinguda de Madrid, 160",
		"informacio_web": "NA",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-h9zx_7rkr~zaun",
		":version": "rv-ubyn~x59r~aw7d",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Botiga Consum Comte D'urgell",
		"indicador_refugi": "080193|BOTIGA_CONSUM_COMTE_D_URGELL",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38348",
		"longitud": "2.156527",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer del Comte d'Urgell, 87",
		"informacio_web": "NA",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-u4ep.4g4i.dn6z",
		":version": "rv-ny2p~nisf.gupu",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Botiga Consum Balmes",
		"indicador_refugi": "080193|BOTIGA_CONSUM_BALMES",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.40245",
		"longitud": "2.145526",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Balmes, 306",
		"informacio_web": "NA",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-f84c.966m_mkxq",
		":version": "rv-7jxr-8w6i~4hx3",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Botiga Consum Alcúdia",
		"indicador_refugi": "080193|BOTIGA_CONSUM_ALCUDIA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.43629",
		"longitud": "2.17463",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Alcúdia, 47",
		"informacio_web": "NA",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-jc3b_7mh8_wh5z",
		":version": "rv-mih2-cz7d_y7qe",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Botiga Consum Avinguda Icària",
		"indicador_refugi": "080193|BOTIGA_CONSUM_AVINGUDA_ICARIA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.39041",
		"longitud": "2.196072",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Avinguda Icària, 164",
		"informacio_web": "NA",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-hh3r~yhwg~rgbh",
		":version": "rv-wanm~zwnc.kdkp",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Botiga Consum Berruguete",
		"indicador_refugi": "080193|BOTIGA_CONSUM_BERRUGUETE",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.4340777469097",
		"longitud": "2.14847422886811",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Berruguete, 106",
		"informacio_web": "NA",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-x6ih~3keg_t9hm",
		":version": "rv-ttmv~pp5b-zrjj",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Botiga Consum Villarroel",
		"indicador_refugi": "080193|BOTIGA_CONSUM_VILLARROEL",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.38079",
		"longitud": "2.162216",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Villarroel, 15",
		"informacio_web": "NA",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-bsaf-5kd4~h9tf",
		":version": "rv-kg52_3qpc-mq3z",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Botiga Consum Fabra I Puig",
		"indicador_refugi": "080193|BOTIGA_CONSUM_FABRA_I_PUIG",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.4302",
		"longitud": "2.18684",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Rambla de Fabra i Puig, 55",
		"informacio_web": "NA",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-drem.adhj_vnbh",
		":version": "rv-kfpq~dzh4_2m2d",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Botiga Consum Gran De Sant Andreu",
		"indicador_refugi": "080193|BOTIGA_CONSUM_GRAN_DE_SANT_ANDREU",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.43824",
		"longitud": "2.189",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Gran de Sant Andreu, 356",
		"informacio_web": "NA",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-wyz4_rh6d.tzwu",
		":version": "rv-idas-biu8-zs5j",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Botiga Consum Berenguer De Palou",
		"indicador_refugi": "080193|BOTIGA_CONSUM_BERENGUER_DE_PALOU",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.42279",
		"longitud": "2.191999",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Berenguer de Palou, 52",
		"informacio_web": "NA",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-hqjf.8xns.6n87",
		":version": "rv-txgq_yn6e_chpf",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Nivell Estudi De Cuines",
		"indicador_refugi": "080193|NIVELL_ESTUDI_DE_CUINES",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.40552",
		"longitud": "2.164701",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Travessera de Gràcia 254",
		"informacio_web": "NA",
		"tipologia": "_microRefugi",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-3f7u-dysz_zkbz",
		":version": "rv-raf7-7sc5-a8qg",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CSS Maternitat Sant Ramon i Pedralbes",
		"indicador_refugi": "080193|CSS_MATERNITAT_SANT_RAMON_I_PEDRALBES",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.3799831380478",
		"longitud": "2.12602712962141",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Travessera de les Corts, 122 baixos",
		"informacio_web": "NA",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ij6g.9pgp-b7qi",
		":version": "rv-kjim~h747-ddjx",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Espai 3 Ulls",
		"indicador_refugi": "080193|ESPAI_3_ULLS",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.4490810616817",
		"longitud": "2.18459437805967",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer de la Pedrosa, 16",
		"informacio_web": "NA",
		"tipologia": "Equipaments de proximitat",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-nxi8.g748.dhv4",
		":version": "rv-v27m~d6ur_z53x",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Filmoteca de Catalunya",
		"indicador_refugi": "080193|FILMOTECA_DE_CATALUNYA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.3788782537339",
		"longitud": "2.17067349137114",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Plaça de Salvador Seguí, 1-9",
		"informacio_web": "NA",
		"tipologia": "Entitats culturals",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-n6qa-z4k5-gctc",
		":version": "rv-mnsi~vkgd~umpc",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Escola de música Sant Gervasi",
		"indicador_refugi": "080193|ESCOLA_DE_MUSICA_SANT_GERVASI",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.4086450783298",
		"longitud": "2.13530007741581",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Folgueroles, 10",
		"informacio_web": "NA",
		"tipologia": "_Microrefugis",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-e63i~v7qd.brc7",
		":version": "rv-cpqe~84uz~t29p",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Farmàcia Marta Ibáñez Gimeno",
		"indicador_refugi": "080193|FARMACIA_MARTA_IBANEZ_GIMENO",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.399318741449",
		"longitud": "2.17137105011407",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Avinguda Diagonal, 319",
		"informacio_web": "NA",
		"tipologia": "_Microrefugis",
		"origen_identificador": "Ajuntament de Barcelona",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ih57_qrwb-bbtb",
		":version": "rv-xenj-bhbq.33hx",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Cívic Vista Alegre",
		"indicador_refugi": "80569|CENTRE_CIVIC_VISTA_ALEGRE",
		"municipi": "Castelldefels",
		"codi_municipi": "80569",
		"latitud": "41.28935201",
		"longitud": "1.981171685",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de Mansió, 31",
		"informacio_web": "https://www.castelldefels.org/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-67g9.bmv7-thrg",
		":version": "rv-f5ei~j2jr.wnwn",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Espai del Mar",
		"indicador_refugi": "80569|ESPAI_DEL_MAR",
		"municipi": "Castelldefels",
		"codi_municipi": "80569",
		"latitud": "41.26526642",
		"longitud": "1.96427668",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "Pg. Marítim, 271-275",
		"informacio_web": "https://www.castelldefels.org/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-8snt_sdcr-pq3d",
		":version": "rv-x7xt_h6rc_dzbz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Edifici de la República",
		"indicador_refugi": "80569|EDIFICI_DE_LA_REPUBLICA",
		"municipi": "Castelldefels",
		"codi_municipi": "80569",
		"latitud": "41.28022385",
		"longitud": "1.976226797",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "C. Arcadi Balaguer, 27-29",
		"informacio_web": "https://www.castelldefels.org/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-f3gr.6t4c.j6wd",
		":version": "rv-th98.28rj.f36b",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Ramon Fernández Jurado",
		"indicador_refugi": "80569|BIBLIOTECA_RAMON_FERNANDEZ_JURADO",
		"municipi": "Castelldefels",
		"codi_municipi": "80569",
		"latitud": "41.28286651",
		"longitud": "1.978031623",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "C. Bisbe Urquinaona, 19-21",
		"informacio_web": "https://www.castelldefels.org/",
		"tipologia": "Biblioteca",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-xxgj_uv67_zyk7",
		":version": "rv-b82q_merz.rcus",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Cívic Frederic Mompou",
		"indicador_refugi": "80569|CENTRE_CIVIC_FREDERIC_MOMPOU",
		"municipi": "Castelldefels",
		"codi_municipi": "80569",
		"latitud": "41.28515768",
		"longitud": "1.979819379",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "Pl. Joan XXIII, 10",
		"informacio_web": "https://www.castelldefels.org/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-z2wy.cjmh~mm9n",
		":version": "rv-g5bu~rr6t_xfrv",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Central de Cornellà (BCC)",
		"indicador_refugi": "80734|BIBLIOTECA_CENTRAL_DE_CORNELLA_BCC",
		"municipi": "Cornellà de Llobregat",
		"codi_municipi": "80734",
		"latitud": "41.36124048",
		"longitud": "2.078505613",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "C. de Mossèn Andreu, 15",
		"informacio_web": "https://www.cornella.cat/",
		"tipologia": "Biblioteca",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-msyn_qvng_ci69",
		":version": "rv-kgcv~mzt8_amg6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Marta Mata (BMM)",
		"indicador_refugi": "80734|BIBLIOTECA_MARTA_MATA_BMM",
		"municipi": "Cornellà de Llobregat",
		"codi_municipi": "80734",
		"latitud": "41.35242856",
		"longitud": "2.070963119",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "C. Joaquim Rubió i Ors, 184",
		"informacio_web": "https://www.cornella.cat/",
		"tipologia": "Biblioteca",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-dxhh~zmsx~fi3w",
		":version": "rv-iwm4_5f2m-xxv8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Sant Ildefons",
		"indicador_refugi": "80734|BIBLIOTECA_SANT_ILDEFONS",
		"municipi": "Cornellà de Llobregat",
		"codi_municipi": "80734",
		"latitud": "41.36314484",
		"longitud": "2.086294193",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "Pl. Carles Navales",
		"informacio_web": "https://www.cornella.cat/",
		"tipologia": "Biblioteca",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-qkqm-v9ew-redr",
		":version": "rv-crb3_vzx9~ecsk",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casa de la Vila",
		"indicador_refugi": "81252|CASA_DE_LA_VILA",
		"municipi": "Montcada i Reixac",
		"codi_municipi": "81252",
		"latitud": "41.48558611",
		"longitud": "2.187916937",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"adreca": "C. Major, 32",
		"informacio_web": "https://www.montcada.cat/",
		"tipologia": "Ajuntament",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-8gbv_3zwi~xt8w",
		":version": "rv-dzv5.b9pp.3ess",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Ajuntament de Montcada i Reixach",
		"indicador_refugi": "81252|AJUNTAMENT_DE_MONTCADA_I_REIXACH",
		"municipi": "Montcada i Reixac",
		"codi_municipi": "81252",
		"latitud": "41.48003001",
		"longitud": "2.187351828",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"adreca": "Av. Unitat, 6",
		"informacio_web": "https://www.montcada.cat/",
		"tipologia": "Ajuntament",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-avxd-qce2_kf37",
		":version": "rv-kjpx-2pip-v3ug",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Espai cultural Kursaal",
		"indicador_refugi": "81252|ESPAI_CULTURAL_KURSAAL",
		"municipi": "Montcada i Reixac",
		"codi_municipi": "81252",
		"latitud": "41.47104651",
		"longitud": "2.183909182",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"adreca": "C. Masia, 39",
		"informacio_web": "https://www.montcada.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-jb3b-cv7z_wsea",
		":version": "rv-dvcq_jbu2~4mm2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre de Promoció Econòmica Mas Rampinyo",
		"indicador_refugi": "81252|CENTRE_DE_PROMOCIO_ECONOMICA_MAS_RAMPINYO",
		"municipi": "Montcada i Reixac",
		"codi_municipi": "81252",
		"latitud": "41.49774691",
		"longitud": "2.183229868",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"adreca": "C. Alt de Sant Pere, 73",
		"informacio_web": "https://www.montcada.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-7a9w-s22s~gqad",
		":version": "rv-vvqy-q5i7-bfuc",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Elisenda",
		"indicador_refugi": "81252|BIBLIOTECA_ELISENDA",
		"municipi": "Montcada i Reixac",
		"codi_municipi": "81252",
		"latitud": "41.49205658",
		"longitud": "2.185790116",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"adreca": "C. Tarragona, 32",
		"informacio_web": "https://www.montcada.cat/",
		"tipologia": "Biblioteca",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-xvcq-igpy~biri",
		":version": "rv-uuxe-ht7i_456f",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Monserrat Roig",
		"indicador_refugi": "82114|BIBLIOTECA_MONSERRAT_ROIG",
		"municipi": "Sant Feliu de Llobregat",
		"codi_municipi": "82114",
		"latitud": "41.38274109",
		"longitud": "2.049271119",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "C. Verge de Montserrat, 1-3",
		"informacio_web": "https://www.santfeliu.cat/go.faces?xmid=1",
		"tipologia": "Biblioteca",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-dret-khu5-9evi",
		":version": "rv-ug8z-bgg9.e49i",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Poliesportiu Municipal Gornal",
		"indicador_refugi": "81017|POLIESPORTIU_MUNICIPAL_GORNAL",
		"municipi": "L'Hospitalet de Llobregat",
		"codi_municipi": "81017",
		"latitud": "41.3603826",
		"longitud": "2.117918999",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "C. de Can Trias, 20",
		"informacio_web": "https://www.l-h.cat/",
		"tipologia": "Equipament esportiu",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-2t8y.cg7f~in5g",
		":version": "rv-d48z_24cf~tryx",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Poliesportiu Municipal del Centre Marcel·lí Maneja",
		"indicador_refugi": "81017|POLIESPORTIU_MUNICIPAL_DEL_CENTRE_MARCEL_LI_MANEJA",
		"municipi": "L'Hospitalet de Llobregat",
		"codi_municipi": "81017",
		"latitud": "41.36119123",
		"longitud": "2.096524098",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "C. de la Riera de l’Escorxador,15",
		"informacio_web": "https://www.l-h.cat/",
		"tipologia": "Equipament esportiu",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-tbg6.xz24_y4a3",
		":version": "rv-ubva~2axc-ibxt",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Jordi Rubió i Balaguer",
		"indicador_refugi": "82009|BIBLIOTECA_JORDI_RUBIO_I_BALAGUER",
		"municipi": "Sant Boi de Llobregat",
		"codi_municipi": "82009",
		"latitud": "41.34080437",
		"longitud": "2.035469669",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "C. de Baldiri Aleu, 6-8",
		"informacio_web": "https://www.santboi.cat/",
		"tipologia": "Biblioteca",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-i3c3~am2f_qkxf",
		":version": "rv-cfyh-a2b4-2em6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de Can Massallera",
		"indicador_refugi": "82009|CASAL_DE_CAN_MASSALLERA",
		"municipi": "Sant Boi de Llobregat",
		"codi_municipi": "82009",
		"latitud": "41.34210324",
		"longitud": "2.043346116",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "C. de Mallorca, 30",
		"informacio_web": "https://www.santboi.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-jd9v_p5es.zdqv",
		":version": "rv-c57g.x3ci_xxcq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Cal Ninyo (zona de bar)",
		"indicador_refugi": "82009|CAL_NINYO_ZONA_DE_BAR",
		"municipi": "Sant Boi de Llobregat",
		"codi_municipi": "82009",
		"latitud": "41.34661654",
		"longitud": "2.041677153",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "C. Major, 43",
		"informacio_web": "https://www.santboi.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-p5xd-i7yx.3fzv",
		":version": "rv-guiu~nqba.bxqb",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de Barri Montserratina",
		"indicador_refugi": "83015|CASAL_DE_BARRI_MONTSERRATINA",
		"municipi": "Viladecans",
		"codi_municipi": "83015",
		"latitud": "41.32039559",
		"longitud": "2.010697431",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "Pl. Constitució, 4",
		"informacio_web": "https://www.viladecans.cat/ca",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-qgt2-ucvu_i4nh",
		":version": "rv-ytm9~gr7w_s88c",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Pública Can Peixauet",
		"indicador_refugi": "82457|BIBLIOTECA_PUBLICA_CAN_PEIXAUET",
		"municipi": "Santa Coloma de Gramenet",
		"codi_municipi": "82457",
		"latitud": "41.44414263",
		"longitud": "2.210203225",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"adreca": "Av. de la Generalitat, 98",
		"informacio_web": "https://www.gramenet.cat/",
		"tipologia": "Biblioteca",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-vyvq~erz3-szjd",
		":version": "rv-bpfd.uhcv~z7yw",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Pública del Fondo",
		"indicador_refugi": "82457|BIBLIOTECA_PUBLICA_DEL_FONDO",
		"municipi": "Santa Coloma de Gramenet",
		"codi_municipi": "82457",
		"latitud": "41.44952248",
		"longitud": "2.217466599",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"adreca": "C. Massenet, 28-30",
		"informacio_web": "https://www.gramenet.cat/",
		"tipologia": "Biblioteca",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-6gyn~brw2_cj2g",
		":version": "rv-5ayw~53yz.88zu",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca de Singuerlín -Salvador Cabré",
		"indicador_refugi": "82457|BIBLIOTECA_DE_SINGUERLIN_SALVADOR_CABRE",
		"municipi": "Santa Coloma de Gramenet",
		"codi_municipi": "82457",
		"latitud": "41.45905396",
		"longitud": "2.205819564",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"adreca": "Pl. Sagrada Família, s/n",
		"informacio_web": "https://www.gramenet.cat/",
		"tipologia": "Biblioteca",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-p8vt-wua2_78zp",
		":version": "rv-tecj_kgyq-hyed",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Central",
		"indicador_refugi": "82457|BIBLIOTECA_CENTRAL",
		"municipi": "Santa Coloma de Gramenet",
		"codi_municipi": "82457",
		"latitud": "41.45291238",
		"longitud": "2.207731074",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"adreca": "Jardí de Can Sisteré, s/n",
		"informacio_web": "https://www.gramenet.cat/",
		"tipologia": "Biblioteca",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-59zp.j29b.f2pc",
		":version": "rv-63dx-9dgt-wwnz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de la Gent Gran",
		"indicador_refugi": "89045|CASAL_DE_LA_GENT_GRAN",
		"municipi": "Badia del Vallès",
		"codi_municipi": "89045",
		"latitud": "41.50852574",
		"longitud": "2.114151936",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"adreca": "Av. de Burgos amb c. de la Bètica, s/n",
		"informacio_web": "https://www.badiadelvalles.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-mt7w~ah4j.dtz2",
		":version": "rv-5dxp~zd3j~hsxs",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Vicente Aleixandre",
		"indicador_refugi": "89045|BIBLIOTECA_VICENTE_ALEIXANDRE",
		"municipi": "Badia del Vallès",
		"codi_municipi": "89045",
		"latitud": "41.50641015",
		"longitud": "2.117109273",
		"accessibilitat": "SÍ",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"adreca": "AAv. de la Mediterrània, s/n",
		"informacio_web": "https://www.badiadelvalles.cat/",
		"tipologia": "Biblioteca",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-7zkw-spge~rncw",
		":version": "rv-pjt4~u8hq~nb6i",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de gent gran Casa de la Mina",
		"indicador_refugi": "81252|CASAL_DE_GENT_GRAN_CASA_DE_LA_MINA",
		"municipi": "Montcada i Reixac",
		"codi_municipi": "81252",
		"latitud": "41.49357623",
		"longitud": "2.189305202",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"adreca": "Av. De la Unitat s/n",
		"informacio_web": "https://www.montcada.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-xn5d_8a4x-8n9t",
		":version": "rv-vbkm.bvkb.4yzy",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Cívic Sant Ildefons",
		"indicador_refugi": "80734|CENTRE_CIVIC_SANT_ILDEFONS",
		"municipi": "Cornellà de Llobregat",
		"codi_municipi": "80734",
		"latitud": "41.36532394",
		"longitud": "2.080159518",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "C. Gerdera, s/n",
		"informacio_web": "https://www.cornella.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ach8~mjyf~dfam",
		":version": "rv-pjyq_h32x~dksq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Complex aquàtic i esportiu Can Mercader (recepció )",
		"indicador_refugi": "80734|COMPLEX_AQUATIC_I_ESPORTIU_CAN_MERCADER_RECEPCIO",
		"municipi": "Cornellà de Llobregat",
		"codi_municipi": "80734",
		"latitud": "41.35744917",
		"longitud": "2.085082299",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "Crta de L'Hospitalet s/n",
		"informacio_web": "https://www.cornella.cat/",
		"tipologia": "Equipament esportiu",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ix7m_dskf~gctx",
		":version": "rv-s63i.xgxm-bfkh",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Esportiu Llobregat (recepció)",
		"indicador_refugi": "80734|PARC_ESPORTIU_LLOBREGAT_RECEPCIO",
		"municipi": "Cornellà de Llobregat",
		"codi_municipi": "80734",
		"latitud": "41.3486172",
		"longitud": "2.072580786",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "Av. Baix Llobregat, s/n",
		"informacio_web": "https://www.cornella.cat/",
		"tipologia": "Equipament esportiu",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-v59c~6tyy~mw4n",
		":version": "rv-vg7a~samf~8ri6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Citilab",
		"indicador_refugi": "80734|CITILAB",
		"municipi": "Cornellà de Llobregat",
		"codi_municipi": "80734",
		"latitud": "41.3598648",
		"longitud": "2.061789135",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "Pl. Can Surís, s/n",
		"informacio_web": "https://www.cornella.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-bqf3.e9xk.attf",
		":version": "rv-4kp8.aq8r_6248",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Torre Barrina",
		"indicador_refugi": "81017|TORRE_BARRINA",
		"municipi": "L'Hospitalet de Llobregat",
		"codi_municipi": "81017",
		"latitud": "41.37523566",
		"longitud": "2.117521041",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "Ctra. de Collblanc, 67",
		"informacio_web": "https://www.l-h.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-49ys~9e8w~yuis",
		":version": "rv-7xxd_2wqa~2cmw",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Cultural Santa Eulàlia",
		"indicador_refugi": "81017|CENTRE_CULTURAL_SANTA_EULALIA",
		"municipi": "L'Hospitalet de Llobregat",
		"codi_municipi": "81017",
		"latitud": "41.36780681",
		"longitud": "2.127635363",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "C. de Santa Eulàlia, 60",
		"informacio_web": "https://www.l-h.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-vumt~u7i6-9nzc",
		":version": "rv-qby2_w9pc-7hsv",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Mercat Municipal de La Florida",
		"indicador_refugi": "81017|MERCAT_MUNICIPAL_DE_LA_FLORIDA",
		"municipi": "L'Hospitalet de Llobregat",
		"codi_municipi": "81017",
		"latitud": "41.36546533",
		"longitud": "2.127223053",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "C. Sevilla, 2",
		"informacio_web": "https://www.l-h.cat/",
		"tipologia": "Mercat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-3pe8-k9av.y56z",
		":version": "rv-tin5.4i3m_hisz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de la Gent Gran Pubilla Casas",
		"indicador_refugi": "81017|CASAL_DE_LA_GENT_GRAN_PUBILLA_CASAS",
		"municipi": "L'Hospitalet de Llobregat",
		"codi_municipi": "81017",
		"latitud": "41.3735841",
		"longitud": "2.104633529",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "C. d’Amadeu Vives, 1",
		"informacio_web": "https://www.l-h.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-pxqv-9x6n~eqbr",
		":version": "rv-sbxz.vz7a_ttgq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de Gent Gran Bellvitge - L'Ermita",
		"indicador_refugi": "81017|CASAL_DE_GENT_GRAN_BELLVITGE_L_ERMITA",
		"municipi": "L'Hospitalet de Llobregat",
		"codi_municipi": "81017",
		"latitud": "41.34860601",
		"longitud": "2.110180361",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "C.de l’Ermita de Bellvitge, 40",
		"informacio_web": "https://www.l-h.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-h9fn-u46x_eh97",
		":version": "rv-y8mp.5p6e-3mv3",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de Gent Gran Ca N'Arús",
		"indicador_refugi": "81017|CASAL_DE_GENT_GRAN_CA_N_ARUS",
		"municipi": "L'Hospitalet de Llobregat",
		"codi_municipi": "81017",
		"latitud": "41.35809562",
		"longitud": "2.102430908",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "Av. del Carrilet, 312",
		"informacio_web": "https://www.l-h.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-xszi_eqv4.mk6k",
		":version": "rv-tb9h.r9w3.682q",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Can Casacuberta",
		"indicador_refugi": "80155|CAN_CASACUBERTA",
		"municipi": "Badalona",
		"codi_municipi": "80155",
		"latitud": "41.44543851",
		"longitud": "2.246964266",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "Carrer Mossèn Anton, 40-48 08912 Badalona",
		"informacio_web": "https://www.badalona.cat/",
		"tipologia": "Biblioteca",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-yncv.4mgr.dkew",
		":version": "rv-v8rz-vvyv-3uzn",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Font de la Mina",
		"indicador_refugi": "81944|BIBLIOTECA_FONT_DE_LA_MINA",
		"municipi": "Sant Adrià del Besòs",
		"codi_municipi": "81944",
		"latitud": "41.41927349",
		"longitud": "2.219108451",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"adreca": "C. Ponent, 21-25",
		"informacio_web": "https://www.sant-adria.cat/",
		"tipologia": "Biblioteca",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-6dav-auew_hyne",
		":version": "rv-dqqq.jm8p.p69h",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca de Sant Adrià",
		"indicador_refugi": "81944|BIBLIOTECA_DE_SANT_ADRIA",
		"municipi": "Sant Adrià del Besòs",
		"codi_municipi": "81944",
		"latitud": "41.43152598",
		"longitud": "2.215083788",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"adreca": "Pl. Guillermo Vidaña i Haro, s/n",
		"informacio_web": "https://www.sant-adria.cat/",
		"tipologia": "Biblioteca",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-4ya9_a5dj_5mt4",
		":version": "rv-6jvt.2pwj-unqr",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Cultural Besòs",
		"indicador_refugi": "81944|CENTRE_CULTURAL_BESOS",
		"municipi": "Sant Adrià del Besòs",
		"codi_municipi": "81944",
		"latitud": "41.421119",
		"longitud": "2.214987734",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Josep Tarradellas, s/n",
		"informacio_web": "https://www.sant-adria.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-gbw6-zrqq_7xwn",
		":version": "rv-zrvb-ezme.2mzx",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Dalt de la Vila",
		"indicador_refugi": "81944|CASAL_DALT_DE_LA_VILA",
		"municipi": "Sant Adrià del Besòs",
		"codi_municipi": "81944",
		"latitud": "41.43406847",
		"longitud": "2.214509761",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Església, 13",
		"informacio_web": "https://www.sant-adria.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-mu5z_ahbs-4irs",
		":version": "rv-sf3s-9hpm~tr6h",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de Gent Gran Fiveller",
		"indicador_refugi": "81944|CASAL_DE_GENT_GRAN_FIVELLER",
		"municipi": "Sant Adrià del Besòs",
		"codi_municipi": "81944",
		"latitud": "41.43056792",
		"longitud": "2.220291843",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"adreca": "C. Joan Fiveller, 11-13",
		"informacio_web": "https://www.sant-adria.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-545x.pcxa.re9r",
		":version": "rv-bxff_e7fn-qmki",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Can Baratau",
		"indicador_refugi": "82824|BIBLIOTECA_CAN_BARATAU",
		"municipi": "Tiana",
		"codi_municipi": "82824",
		"latitud": "41.48255665",
		"longitud": "2.269018992",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"adreca": "C. Lola Anglada, 10",
		"informacio_web": "https://tiana.cat/",
		"tipologia": "Biblioteca",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-3inr_vy8p.su2k",
		":version": "rv-de47_mtwp-qfg8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Llar de les Persones Grans",
		"indicador_refugi": "82824|LLAR_DE_LES_PERSONES_GRANS",
		"municipi": "Tiana",
		"codi_municipi": "82824",
		"latitud": "41.48168802",
		"longitud": "2.268373379",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"adreca": "C. Anselm Clavé, 20",
		"informacio_web": "https://tiana.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-gu7v~menf_3n2a",
		":version": "rv-k6i6.h373_8tnh",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc del Castell",
		"indicador_refugi": "80569|PARC_DEL_CASTELL",
		"municipi": "Castelldefels",
		"codi_municipi": "80569",
		"latitud": "41.28365952",
		"longitud": "1.979074747",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Castell, 1",
		"informacio_web": "https://refugisclimatics.amb.cat",
		"tipologia": "Parc AMB",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-tbe3-d3r3_t7kc",
		":version": "rv-983n~wnvn_9h63",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de la Muntanyeta",
		"indicador_refugi": "80569|PARC_DE_LA_MUNTANYETA",
		"municipi": "Castelldefels",
		"codi_municipi": "80569",
		"latitud": "41.28069187",
		"longitud": "1.973255948",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Doctor Fleming, 79",
		"informacio_web": "https://www.castelldefels.org/",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-kjep~d7k7~rivp",
		":version": "rv-x4zz.xm46.2z6a",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de Can Mercader",
		"indicador_refugi": "80734|PARC_DE_CAN_MERCADER",
		"municipi": "Cornellà de Llobregat",
		"codi_municipi": "80734",
		"latitud": "41.35744749",
		"longitud": "2.085108448",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Ctra. de l’Hospitalet, 78",
		"informacio_web": "https://refugisclimatics.amb.cat",
		"tipologia": "Parc AMB",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-3y5n-h4q9-ukc3",
		":version": "rv-n9fe_5jak~ctzh",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc del Canal de la Infanta",
		"indicador_refugi": "80734|PARC_DEL_CANAL_DE_LA_INFANTA",
		"municipi": "Cornellà de Llobregat",
		"codi_municipi": "80734",
		"latitud": "41.36116019",
		"longitud": "2.063064396",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C.Maria Aurèlia Capmany, 14",
		"informacio_web": "https://refugisclimatics.amb.cat",
		"tipologia": "Parc AMB",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-6czz_4j9d-fiaa",
		":version": "rv-t73b.cfr3.q8we",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de Rosa Sensat",
		"indicador_refugi": "80734|PARC_DE_ROSA_SENSAT",
		"municipi": "Cornellà de Llobregat",
		"codi_municipi": "80734",
		"latitud": "41.3549517",
		"longitud": "2.074326246",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Vicenç Llivina, s/n",
		"informacio_web": "https://www.cornella.cat/",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-wsa8.6e2c.j389",
		":version": "rv-8fmz~jxar_mu8p",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de Joan Fuster",
		"indicador_refugi": "81252|PARC_DE_JOAN_FUSTER",
		"municipi": "Montcada i Reixac",
		"codi_municipi": "81252",
		"latitud": "41.49315898",
		"longitud": "2.187069467",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. de Joan Fuster  s/n",
		"informacio_web": "https://www.montcada.cat/",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-2jnv-489v~yhkb",
		":version": "rv-pamv~nwag-uxa5",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc d'Europa",
		"indicador_refugi": "82114|PARC_D_EUROPA",
		"municipi": "Sant Feliu de Llobregat",
		"codi_municipi": "82114",
		"latitud": "41.3858391",
		"longitud": "2.057773007",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Marquès de Monistrol",
		"informacio_web": "https://www.santfeliu.cat/go.faces?xmid=1",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-d572-cuby.7x24",
		":version": "rv-z56j-2xd2_j55h",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jardins del Palau Falguera",
		"indicador_refugi": "82114|JARDINS_DEL_PALAU_FALGUERA",
		"municipi": "Sant Feliu de Llobregat",
		"codi_municipi": "82114",
		"latitud": "41.38055403",
		"longitud": "2.042403168",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. de Ramón i Cajal, 2",
		"informacio_web": "https://www.santfeliu.cat/go.faces?xmid=1",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-4mwd-gy5s-xm8x",
		":version": "rv-dfr9-emg6~hej8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc del Llobregat",
		"indicador_refugi": "82114|PARC_DEL_LLOBREGAT",
		"municipi": "Sant Feliu de Llobregat",
		"codi_municipi": "82114",
		"latitud": "41.38315853",
		"longitud": "2.038229577",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Ctra. del Pla, 90",
		"informacio_web": "https://refugisclimatics.amb.cat",
		"tipologia": "Parc AMB",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-82c7-eq6p.6w5p",
		":version": "rv-rj5y-b5mb.bpwm",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de Can Buxeres",
		"indicador_refugi": "81017|PARC_DE_CAN_BUXERES",
		"municipi": "L'Hospitalet de Llobregat",
		"codi_municipi": "81017",
		"latitud": "41.36462869",
		"longitud": "2.095921166",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Ctra. d’Esplugues, 1",
		"informacio_web": "https://refugisclimatics.amb.cat",
		"tipologia": "Parc AMB",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-4gsq~9duz.4esx",
		":version": "rv-rfij~7ssp.f67b",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de les Planes",
		"indicador_refugi": "81017|PARC_DE_LES_PLANES",
		"municipi": "L'Hospitalet de Llobregat",
		"codi_municipi": "81017",
		"latitud": "41.36736051",
		"longitud": "2.105249403",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. del Teide, 88",
		"informacio_web": "https://refugisclimatics.amb.cat",
		"tipologia": "Parc AMB",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-6asz.9bny~7rb2",
		":version": "rv-9zg7-ngvz_rnnv",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de l'Alhambra",
		"indicador_refugi": "81017|PARC_DE_L_ALHAMBRA",
		"municipi": "L'Hospitalet de Llobregat",
		"codi_municipi": "81017",
		"latitud": "41.36288494",
		"longitud": "2.130322469",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Alhambra, 22",
		"informacio_web": "https://www.l-h.cat/",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-bzgs.avdg_rh2c",
		":version": "rv-eayz_v7bw~mg36",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de Can Julià",
		"indicador_refugi": "82009|PARC_DE_CAN_JULIA",
		"municipi": "Sant Boi de Llobregat",
		"codi_municipi": "82009",
		"latitud": "41.34407834",
		"longitud": "2.046363713",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Bonaventura Calopa, s/n",
		"informacio_web": "https://www.santboi.cat/",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-wbft.9hkd-mt5f",
		":version": "rv-i4m3_jku3-s4gg",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de Marianao",
		"indicador_refugi": "82009|PARC_DE_MARIANAO",
		"municipi": "Sant Boi de Llobregat",
		"codi_municipi": "82009",
		"latitud": "41.3478877",
		"longitud": "2.023003543",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Lledoners, 1",
		"informacio_web": "https://www.santboi.cat/",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-fsxq_f435~pkf2",
		":version": "rv-x2mf.ww49_rbvd",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça dels Focs de Sant Joan",
		"indicador_refugi": "82009|PLACA_DELS_FOCS_DE_SANT_JOAN",
		"municipi": "Sant Boi de Llobregat",
		"codi_municipi": "82009",
		"latitud": "41.3340529",
		"longitud": "2.040681366",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. dels Focs de Sant Joan",
		"informacio_web": "https://www.santboi.cat/",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-v8qt-wrpu_cv5h",
		":version": "rv-d65c~9m9b.cvqn",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de la Muntanyeta",
		"indicador_refugi": "82009|PARC_DE_LA_MUNTANYETA",
		"municipi": "Sant Boi de Llobregat",
		"codi_municipi": "82009",
		"latitud": "41.34197384",
		"longitud": "2.033606126",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Mare de Déu del Pilar",
		"informacio_web": "https://refugisclimatics.amb.cat",
		"tipologia": "Parc AMB",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-bv2d-vecm~p758",
		":version": "rv-eb5a-cdji~3mrv",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc del Torrent Ballester",
		"indicador_refugi": "83015|PARC_DEL_TORRENT_BALLESTER",
		"municipi": "Viladecans",
		"codi_municipi": "83015",
		"latitud": "41.31628564",
		"longitud": "2.011525984",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. de Josep Tarradellas, 34",
		"informacio_web": "https://www.viladecans.cat/ca",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-448d.kp3q~ybbw",
		":version": "rv-cwrn.jxkr.qbqk",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de la Torre Roja",
		"indicador_refugi": "83015|PARC_DE_LA_TORRE_ROJA",
		"municipi": "Viladecans",
		"codi_municipi": "83015",
		"latitud": "41.3216489",
		"longitud": "2.020470028",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Marià Sanjuan Cuchí, 11",
		"informacio_web": "https://refugisclimatics.amb.cat",
		"tipologia": "Parc AMB",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-itde~a2y2~vxs4",
		":version": "rv-mpva.r5p2.42wd",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de Can Zam",
		"indicador_refugi": "82457|PARC_DE_CAN_ZAM",
		"municipi": "Santa Coloma de Gramenet",
		"codi_municipi": "82457",
		"latitud": "41.45617741",
		"longitud": "2.196707603",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Víctor Hugo, 70",
		"informacio_web": "https://refugisclimatics.amb.cat",
		"tipologia": "Parc AMB",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-8ks7_s4xa.fx6t",
		":version": "rv-iibp.dzxi_vbur",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de les Illes Balears",
		"indicador_refugi": "89045|PARC_DE_LES_ILLES_BALEARS",
		"municipi": "Badia del Vallès",
		"codi_municipi": "89045",
		"latitud": "41.50602582",
		"longitud": "2.120436941",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Menorca, s/n",
		"informacio_web": "https://www.badiadelvalles.cat/",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-zur2_ky5g-eti4",
		":version": "rv-rp8x_5fc3.6men",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Nou",
		"indicador_refugi": "81691|PARC_NOU",
		"municipi": "el Prat de Llobregat",
		"codi_municipi": "81691",
		"latitud": "41.31399299",
		"longitud": "2.090063488",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Ronda sud",
		"informacio_web": "https://refugisclimatics.amb.cat",
		"tipologia": "Parc AMB",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-srtb~f8vj~zd27",
		":version": "rv-uynn.kwk8_ezex",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc  Pi Gros",
		"indicador_refugi": "82634|PARC_PI_GROS",
		"municipi": "Sant Vicenç dels Horts",
		"codi_municipi": "82634",
		"latitud": "41.39584317",
		"longitud": "2.003002107",
		"accessibilitat": "SÍ",
		"area_descans": "Sí",
		"adreca": "Trav. d'Aragó",
		"informacio_web": "https://refugisclimatics.amb.cat",
		"tipologia": "Parc AMB",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-8xaj-hfnr_bpy4",
		":version": "rv-28kz_8q5f.y9sy",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de Can Solei i Ca l'Arnús",
		"indicador_refugi": "80155|PARC_DE_CAN_SOLEI_I_CA_L_ARNUS",
		"municipi": "Badalona",
		"codi_municipi": "80155",
		"latitud": "41.45658526",
		"longitud": "2.253143675",
		"accessibilitat": "SÍ",
		"area_descans": "Sí",
		"adreca": "Riera Canyadó,51\nC/ Seu d'Urgell,30",
		"informacio_web": "https://refugisclimatics.amb.cat",
		"tipologia": "Parc AMB",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-72u9-e4yb.tbck",
		":version": "rv-hvfb_jyn6~u977",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de Torreblanca",
		"indicador_refugi": "82172|PARC_DE_TORREBLANCA",
		"municipi": "Sant Joan Despí",
		"codi_municipi": "82172",
		"latitud": "41.37803008",
		"longitud": "2.056170778",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Ctra. Reial, 159",
		"informacio_web": "https://refugisclimatics.amb.cat",
		"tipologia": "Parc AMB",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-582h-vqqw.qwr8",
		":version": "rv-7uan.stvs_z6r6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Can Vidalet",
		"indicador_refugi": "80771|CAN_VIDALET",
		"municipi": "Esplugues de Llobregat",
		"codi_municipi": "80771",
		"latitud": "41.37525034",
		"longitud": "2.097142908",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Avinguda Navarra, 205",
		"informacio_web": "https://refugisclimatics.amb.cat",
		"tipologia": "Parc AMB",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ee9d_s4cx.p4my",
		":version": "rv-sea5.934f~8vsv",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Arbreda de la Rambleta",
		"indicador_refugi": "81944|ARBREDA_DE_LA_RAMBLETA",
		"municipi": "Sant Adrià del Besòs",
		"codi_municipi": "81944",
		"latitud": "41.43052454",
		"longitud": "2.215444901",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pg. de la Rambleta Joan Llandrich",
		"informacio_web": "https://www.sant-adria.cat/",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-wmne~hcjn~c4vs",
		":version": "rv-cq23_ep7v.4m2v",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça de Salvador Espriu",
		"indicador_refugi": "82824|PLACA_DE_SALVADOR_ESPRIU",
		"municipi": "Tiana",
		"codi_municipi": "82824",
		"latitud": "41.47794022",
		"longitud": "2.27183133",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Pau Casals, 2",
		"informacio_web": "https://tiana.cat/",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-azqw-j36n-9j78",
		":version": "rv-7t58.vdrj-ixzk",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de l’Antic Camp de Futbol",
		"indicador_refugi": "82824|PARC_DE_L_ANTIC_CAMP_DE_FUTBOL",
		"municipi": "Tiana",
		"codi_municipi": "82824",
		"latitud": "41.47874252",
		"longitud": "2.26971371",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pg. Vilesa, 28",
		"informacio_web": "https://tiana.cat/",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ts78-kpk5~8q4z",
		":version": "rv-z7su-jice-egm2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de Joan Armengol",
		"indicador_refugi": "82824|PARC_DE_JOAN_ARMENGOL",
		"municipi": "Tiana",
		"codi_municipi": "82824",
		"latitud": "41.48640113",
		"longitud": "2.270070681",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Camí de Dalt d’Alella, s/n",
		"informacio_web": "https://tiana.cat/",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-64ec_vcs8_tbmi",
		":version": "rv-4b3u.s7e8_3mnu",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Clara Campoamor",
		"indicador_refugi": "80734|BIBLIOTECA_CLARA_CAMPOAMOR",
		"municipi": "Cornellà de Llobregat",
		"codi_municipi": "80734",
		"latitud": "41.36060131",
		"longitud": "2.062447071",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "Crta. de Sant Joan Despí, 901",
		"informacio_web": "https://www.cornella.cat/",
		"tipologia": "Biblioteca",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-wc68_nipy.3rz5",
		":version": "rv-qwug.dbjm~796r",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Teresa Pamies",
		"indicador_refugi": "80734|BIBLIOTECA_TERESA_PAMIES",
		"municipi": "Cornellà de Llobregat",
		"codi_municipi": "80734",
		"latitud": "41.35327852",
		"longitud": "2.085760946",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "Pg. dels Ferrocarrils Catalans, 187",
		"informacio_web": "https://www.cornella.cat/",
		"tipologia": "Biblioteca",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ba42-yf6q~qvqn",
		":version": "rv-veag-dgy6.3sht",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Esteve Paluzié",
		"indicador_refugi": "82520|BIBLIOTECA_ESTEVE_PALUZIE",
		"municipi": "Barberà del Vallès",
		"codi_municipi": "82520",
		"latitud": "41.5209186",
		"longitud": "2.121145989",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "Catalans, 187",
		"informacio_web": "https://www.bdv.cat/",
		"tipologia": "Biblioteca",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-tcn9-dqpx~fxwk",
		":version": "rv-k5yv-3bxg_xrki",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Cívic Ca N'Amiguet",
		"indicador_refugi": "82520|CENTRE_CIVIC_CA_N_AMIGUET",
		"municipi": "Barberà del Vallès",
		"codi_municipi": "82520",
		"latitud": "41.52452205",
		"longitud": "2.124268039",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "Via Sant Oleguer, 20",
		"informacio_web": "https://www.bdv.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-vr8p~3guq-xivm",
		":version": "rv-k4yr-2mnq.nqfc",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Mercat 11 de setembre",
		"indicador_refugi": "82520|MERCAT_11_DE_SETEMBRE",
		"municipi": "Barberà del Vallès",
		"codi_municipi": "82520",
		"latitud": "41.51781815",
		"longitud": "2.124588125",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "C. Verge de l'Assumpció, 32",
		"informacio_web": "https://www.bdv.cat/",
		"tipologia": "Mercat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-atte.uvmc_e96c",
		":version": "rv-jqve_53gi_g4vr",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Teatre Municipal Cooperativa",
		"indicador_refugi": "82520|TEATRE_MUNICIPAL_COOPERATIVA",
		"municipi": "Barberà del Vallès",
		"codi_municipi": "82520",
		"latitud": "41.51655864",
		"longitud": "2.127340226",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "Ptge.  Cooperativa, 5",
		"informacio_web": "https://www.bdv.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-u379_kurj-d64v",
		":version": "rv-xqqf_kw28_8487",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre de Formació Torre d'en Gorgs",
		"indicador_refugi": "82520|CENTRE_DE_FORMACIO_TORRE_D_EN_GORGS",
		"municipi": "Barberà del Vallès",
		"codi_municipi": "82520",
		"latitud": "41.51149557",
		"longitud": "2.119997449",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "C. Torre d'en Gorgs, 40",
		"informacio_web": "https://www.bdv.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-tg76.n6xy_zuk7",
		":version": "rv-3fnc.ehkj-ath3",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de Can Serra",
		"indicador_refugi": "82520|PARC_DE_CAN_SERRA",
		"municipi": "Barberà del Vallès",
		"codi_municipi": "82520",
		"latitud": "41.51297586",
		"longitud": "2.125091948",
		"accessibilitat": "SÍ",
		"area_descans": "Sí",
		"adreca": "Pg. Doctor Moragas",
		"informacio_web": "https://www.bdv.cat/",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-p6h7_m8vw_xjtn",
		":version": "rv-qs62~uvtz-as89",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça de la Constitució",
		"indicador_refugi": "82520|PLACA_DE_LA_CONSTITUCIO",
		"municipi": "Barberà del Vallès",
		"codi_municipi": "82520",
		"latitud": "41.52066518",
		"longitud": "2.12157832",
		"accessibilitat": "SÍ",
		"area_descans": "Sí",
		"adreca": "C.  Marquesos de Barberà, 192",
		"informacio_web": "https://www.bdv.cat/",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-q6z2~img8-din2",
		":version": "rv-jnce.grb5.z48v",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça de l'Esport",
		"indicador_refugi": "82520|PLACA_DE_L_ESPORT",
		"municipi": "Barberà del Vallès",
		"codi_municipi": "82520",
		"latitud": "41.51935198",
		"longitud": "2.12241985",
		"accessibilitat": "SÍ",
		"area_descans": "Sí",
		"adreca": "Pg. Doctor Moragas, 268",
		"informacio_web": "https://www.bdv.cat/",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-prd4~2gr9_6f7y",
		":version": "rv-gzym~s3jh-uzjn",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça de la Unitat",
		"indicador_refugi": "82520|PLACA_DE_LA_UNITAT",
		"municipi": "Barberà del Vallès",
		"codi_municipi": "82520",
		"latitud": "41.51705558",
		"longitud": "2.130455306",
		"accessibilitat": "SÍ",
		"area_descans": "Sí",
		"adreca": "C. Nemesi Valls",
		"informacio_web": "https://www.bdv.cat/",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-652i.cg4h_3jmc",
		":version": "rv-xww3-iip5-53kg",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca de Pallejà",
		"indicador_refugi": "81574|BIBLIOTECA_DE_PALLEJA",
		"municipi": "Pallejà",
		"codi_municipi": "81574",
		"latitud": "41.42168358",
		"longitud": "1.996917863",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "Av. Prat de la Riba, 10",
		"informacio_web": "https://www.palleja.cat/",
		"tipologia": "Biblioteca",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-y6sg-veet.h5gg",
		":version": "rv-kmnw_n9kp~sbkj",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de Gent Gran",
		"indicador_refugi": "81574|CASAL_DE_GENT_GRAN",
		"municipi": "Pallejà",
		"codi_municipi": "81574",
		"latitud": "41.42538121",
		"longitud": "1.997589889",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "C. Pau Claris, 36",
		"informacio_web": "https://www.palleja.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-n3td~upbh-bgcv",
		":version": "rv-eqfh.sud4~a9s9",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de la Molinada",
		"indicador_refugi": "81574|PARC_DE_LA_MOLINADA",
		"municipi": "Pallejà",
		"codi_municipi": "81574",
		"latitud": "41.42164958",
		"longitud": "1.997802643",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Mare de Déu de Loreto",
		"informacio_web": "https://refugisclimatics.amb.cat",
		"tipologia": "Parc AMB",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-pwja~93x5.j7vh",
		":version": "rv-vbkk.3avu_4efn",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Tirant Lo Blanc",
		"indicador_refugi": "81265|BIBLIOTECA_TIRANT_LO_BLANC",
		"municipi": "Montgat",
		"codi_municipi": "81265",
		"latitud": "41.46884",
		"longitud": "2.274308013",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "Rda. dels Països Catalans, s/n",
		"informacio_web": "https://www.montgat.cat/",
		"tipologia": "Biblioteca",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-imdu-fsxv-vvzz",
		":version": "rv-t48y-qyxt_uxx2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de Gent Gran Joan Maragall",
		"indicador_refugi": "81265|CASAL_DE_GENT_GRAN_JOAN_MARAGALL",
		"municipi": "Montgat",
		"codi_municipi": "81265",
		"latitud": "41.46417131",
		"longitud": "2.273856536",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "Ctra. de Mataró, 113",
		"informacio_web": "https://www.montgat.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-j7yf_ut74~b3cs",
		":version": "rv-fd6s-wmqn_hbpa",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de Riera d'en Font",
		"indicador_refugi": "81265|PARC_DE_RIERA_D_EN_FONT",
		"municipi": "Montgat",
		"codi_municipi": "81265",
		"latitud": "41.46891357",
		"longitud": "2.284461573",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Riera d'en Font",
		"informacio_web": "https://www.montgat.cat/",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-jkii-tfq7-4fgx",
		":version": "rv-cpvc_9mqw_jkif",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc del Tramvia",
		"indicador_refugi": "81265|PARC_DEL_TRAMVIA",
		"municipi": "Montgat",
		"codi_municipi": "81265",
		"latitud": "41.47110416",
		"longitud": "2.275618429",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. Jordana, 92",
		"informacio_web": "https://refugisclimatics.amb.cat",
		"tipologia": "Parc AMB",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-hn7g-3hyw-dzdr",
		":version": "rv-q6nk.u96p~b4cx",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de Maria Regordosa-Masot",
		"indicador_refugi": "81803|PARC_DE_MARIA_REGORDOSA_MASOT",
		"municipi": "Ripollet",
		"codi_municipi": "81803",
		"latitud": "41.4919293",
		"longitud": "2.151341807",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Nostra Senyora dels Àngels",
		"informacio_web": "https://refugisclimatics.amb.cat",
		"tipologia": "Parc AMB",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-yd5j.skqe_azg3",
		":version": "rv-jqc2~dy8g-igwg",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre de Gent Gran Cireres",
		"indicador_refugi": "82172|CENTRE_DE_GENT_GRAN_CIRERES",
		"municipi": "Sant Joan Despí",
		"codi_municipi": "82172",
		"latitud": "41.36855508",
		"longitud": "2.076298034",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "C. Sant Francesc de Sales, 1",
		"informacio_web": "https://sjdespi.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-kn7v~4fs5-psns",
		":version": "rv-rgsd.fbau-zh2i",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Miquel Martí i Pol",
		"indicador_refugi": "82172|BIBLIOTECA_MIQUEL_MARTI_I_POL",
		"municipi": "Sant Joan Despí",
		"codi_municipi": "82172",
		"latitud": "41.3691764",
		"longitud": "2.071281947",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"adreca": "Av. de Barcelona, 83-85",
		"informacio_web": "https://sjdespi.cat/",
		"tipologia": "Biblioteca",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-mr2f~um4r.u3sr",
		":version": "rv-caqe-ra9h~xzde",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Poliesportiu Municipal Francesc Calvet",
		"indicador_refugi": "82172|POLIESPORTIU_MUNICIPAL_FRANCESC_CALVET",
		"municipi": "Sant Joan Despí",
		"codi_municipi": "82172",
		"latitud": "41.36832652",
		"longitud": "2.064174956",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "Avinguda de Barcelona, 45",
		"informacio_web": "https://sjdespi.cat/",
		"tipologia": "Equipament esportiu",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-mpd4-hd8u~5zee",
		":version": "rv-swum~t2hd-9be4",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Cívic Antoni Gaudí",
		"indicador_refugi": "82172|CENTRE_CIVIC_ANTONI_GAUDI",
		"municipi": "Sant Joan Despí",
		"codi_municipi": "82172",
		"latitud": "41.37322164",
		"longitud": "2.06948322",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Plaça l'Estatut, 5",
		"informacio_web": "https://sjdespi.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-zb5f.f7k4.pkgu",
		":version": "rv-dwtw_ee77-gp4b",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Poliesportiu Salvador Gimeno",
		"indicador_refugi": "82172|POLIESPORTIU_SALVADOR_GIMENO",
		"municipi": "Sant Joan Despí",
		"codi_municipi": "82172",
		"latitud": "41.36849262",
		"longitud": "2.052048034",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "C. Major, 75",
		"informacio_web": "https://sjdespi.cat/",
		"tipologia": "Equipament esportiu",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ptdn~bhcu-rcn8",
		":version": "rv-ubes~tv57.xdfg",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Cívic Pla del Vent - Torreblanca",
		"indicador_refugi": "82172|CENTRE_CIVIC_PLA_DEL_VENT_TORREBLANCA",
		"municipi": "Sant Joan Despí",
		"codi_municipi": "82172",
		"latitud": "41.37688453",
		"longitud": "2.059522505",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "C. Rubió i Tuduri,5",
		"informacio_web": "https://sjdespi.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-w5bx~r742~6kqa",
		":version": "rv-gfn7-cued_787k",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Cultural Mercè Rodoreda",
		"indicador_refugi": "82172|CENTRE_CULTURAL_MERCE_RODOREDA",
		"municipi": "Sant Joan Despí",
		"codi_municipi": "82172",
		"latitud": "41.36709099",
		"longitud": "2.054065399",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"adreca": "C. Major, 69",
		"informacio_web": "https://sjdespi.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-3khd-vdui.jv6s",
		":version": "rv-u22t_3ibe.vif8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de la Fontsanta",
		"indicador_refugi": "82172|PARC_DE_LA_FONTSANTA",
		"municipi": "Sant Joan Despí",
		"codi_municipi": "82172",
		"latitud": "41.36984549",
		"longitud": "2.070341758",
		"accessibilitat": "SÍ",
		"adreca": "C. de la Fontsanta, s/n",
		"informacio_web": "https://refugisclimatics.amb.cat",
		"tipologia": "Parc AMB",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-g38u_kgkm.2had",
		":version": "rv-vwys~jhh8.q7d6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Cívic Fontetes",
		"indicador_refugi": "82665|CENTRE_CIVIC_FONTETES",
		"municipi": "Cerdanyola del Vallès",
		"codi_municipi": "82665",
		"latitud": "41.49069939",
		"longitud": "2.148394114",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "C. dels Reis, 30",
		"informacio_web": "https://www.cerdanyola.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-wvev.betw-cgbc",
		":version": "rv-dbzf~ufb9-t5cv",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Cívic Banús-Bonasort",
		"indicador_refugi": "82665|CENTRE_CIVIC_BANUS_BONASORT",
		"municipi": "Cerdanyola del Vallès",
		"codi_municipi": "82665",
		"latitud": "41.49097301",
		"longitud": "2.134717301",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "Pl. de Sant Medir, s/n",
		"informacio_web": "https://www.cerdanyola.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-qmu6~gjts.ysms",
		":version": "rv-5je5.rf2q.9bjq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Cívic Serraperera",
		"indicador_refugi": "82665|CENTRE_CIVIC_SERRAPERERA",
		"municipi": "Cerdanyola del Vallès",
		"codi_municipi": "82665",
		"latitud": "41.49737898",
		"longitud": "2.125944568",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "C. Sant Casimir, s/n",
		"informacio_web": "https://www.cerdanyola.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-5p6q~a47x~zcxh",
		":version": "rv-a2ch-cstq-c8zt",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Central",
		"indicador_refugi": "82665|BIBLIOTECA_CENTRAL",
		"municipi": "Cerdanyola del Vallès",
		"codi_municipi": "82665",
		"latitud": "41.49260045",
		"longitud": "2.142111654",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "Pl. Enric Granados, 1",
		"informacio_web": "https://www.cerdanyola.cat/",
		"tipologia": "Biblioteca",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-nc44~6zq3~wviv",
		":version": "rv-9g6d.tbaz-nwkw",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de Cordelles",
		"indicador_refugi": "82665|PARC_DE_CORDELLES",
		"municipi": "Cerdanyola del Vallès",
		"codi_municipi": "82665",
		"latitud": "41.49621282",
		"longitud": "2.133401174",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Diagonal, 45",
		"informacio_web": "https://www.cerdanyola.cat/",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-fteu~cj54~dm8t",
		":version": "rv-7wqy~587p_z72i",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Mercat de Fontetes",
		"indicador_refugi": "82665|MERCAT_DE_FONTETES",
		"municipi": "Cerdanyola del Vallès",
		"codi_municipi": "82665",
		"latitud": "41.49078791",
		"longitud": "2.146544394",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "C. dels Reis, 22",
		"informacio_web": "https://www.cerdanyola.cat/",
		"tipologia": "Mercat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-8kag.u5ng-dfq5",
		":version": "rv-k6mc_4xjk-umrk",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Mercat de Serraperera",
		"indicador_refugi": "82665|MERCAT_DE_SERRAPERERA",
		"municipi": "Cerdanyola del Vallès",
		"codi_municipi": "82665",
		"latitud": "41.49425998",
		"longitud": "2.133762584",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "C. Sant Casimir, s/n",
		"informacio_web": "https://www.cerdanyola.cat/",
		"tipologia": "Mercat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-jg66.qpgi~czm3",
		":version": "rv-8vua~4r2e_8y53",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc del Turonet",
		"indicador_refugi": "82665|PARC_DEL_TURONET",
		"municipi": "Cerdanyola del Vallès",
		"codi_municipi": "82665",
		"latitud": "41.48794378",
		"longitud": "2.147702156",
		"accessibilitat": "SÍ",
		"area_descans": "Sí",
		"adreca": "C. de Pizarro, 34",
		"informacio_web": "https://refugisclimatics.amb.cat",
		"tipologia": "Parc AMB",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-fyf9-pv5y~5m39",
		":version": "rv-dykf.gxbd.rxtq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc esportiu municipal Guiera",
		"indicador_refugi": "82665|PARC_ESPORTIU_MUNICIPAL_GUIERA",
		"municipi": "Cerdanyola del Vallès",
		"codi_municipi": "82665",
		"latitud": "41.48329409",
		"longitud": "2.139039841",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "Av. de Guiera, 6",
		"informacio_web": "https://www.cerdanyola.cat/",
		"tipologia": "Equipament esportiu",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-wbs7-haeh-22p7",
		":version": "rv-576i-4c4e_agcd",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Museu de Ca n'Oliver",
		"indicador_refugi": "82665|MUSEU_DE_CA_N_OLIVER",
		"municipi": "Cerdanyola del Vallès",
		"codi_municipi": "82665",
		"latitud": "41.48081187",
		"longitud": "2.133918417",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "C. València, 19",
		"informacio_web": "https://www.cerdanyola.cat/",
		"tipologia": "Museus",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-4vhx_ra8h-sa4v",
		":version": "rv-k6mu_bx5x~ts9f",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bosc de Volpelleres",
		"indicador_refugi": "82055|BOSC_DE_VOLPELLERES",
		"municipi": "Sant Cugat del Vallès",
		"codi_municipi": "82055",
		"latitud": "41.48532419",
		"longitud": "2.074365612",
		"accessibilitat": "SÍ",
		"area_descans": "Sí",
		"adreca": "C. d'Alfons d'Aragó",
		"informacio_web": "https://www.santcugat.cat/",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-jzkb-urrh.277v",
		":version": "rv-9cev~7kj2~fmx8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jardins del Monestir",
		"indicador_refugi": "82055|JARDINS_DEL_MONESTIR",
		"municipi": "Sant Cugat del Vallès",
		"codi_municipi": "82055",
		"latitud": "41.47464496",
		"longitud": "2.085708654",
		"accessibilitat": "SÍ",
		"area_descans": "Sí",
		"adreca": "Pl.de l'Om,1",
		"informacio_web": "https://www.santcugat.cat/",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-gcxw~6beu~7hef",
		":version": "rv-yr9t_pg3u~gpt2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Central",
		"indicador_refugi": "82055|PARC_CENTRAL",
		"municipi": "Sant Cugat del Vallès",
		"codi_municipi": "82055",
		"latitud": "41.47346844",
		"longitud": "2.073531766",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "C. de Manel Farrés, s/n",
		"informacio_web": "https://www.santcugat.cat/",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ay2y_k4ib_nbu4",
		":version": "rv-nzk7.xn23-aad2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de Torrent de Ferrussons",
		"indicador_refugi": "82055|PARC_DE_TORRENT_DE_FERRUSSONS",
		"municipi": "Sant Cugat del Vallès",
		"codi_municipi": "82055",
		"latitud": "41.48067279",
		"longitud": "2.089130296",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "C. Torrent de Ferrussons",
		"informacio_web": "https://www.santcugat.cat/",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-8zx8-t3v7_vdpj",
		":version": "rv-3um9.r4d4_tigw",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de Torreblanca",
		"indicador_refugi": "82055|CASAL_DE_TORREBLANCA",
		"municipi": "Sant Cugat del Vallès",
		"codi_municipi": "82055",
		"latitud": "41.47033335",
		"longitud": "2.091823206",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "Av. Pla del Vinyet, 81-85",
		"informacio_web": "https://www.santcugat.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-3hxi_2xz3-5yj8",
		":version": "rv-yjxe~aquy~2e52",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Mercat municipal de Torreblanca",
		"indicador_refugi": "82055|MERCAT_MUNICIPAL_DE_TORREBLANCA",
		"municipi": "Sant Cugat del Vallès",
		"codi_municipi": "82055",
		"latitud": "41.47058258",
		"longitud": "2.090010067",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "Av. de la Torre Blanca, 10",
		"informacio_web": "https://www.santcugat.cat/",
		"tipologia": "Mercat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-bzu3.j7t4-tv2t",
		":version": "rv-379c-7vka~ef6i",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Central Gabriel Ferrater",
		"indicador_refugi": "82055|BIBLIOTECA_CENTRAL_GABRIEL_FERRATER",
		"municipi": "Sant Cugat del Vallès",
		"codi_municipi": "82055",
		"latitud": "41.46938361",
		"longitud": "2.088293371",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "Av. del Pla del Vinyet, 40",
		"informacio_web": "https://www.santcugat.cat/",
		"tipologia": "Biblioteca",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-wk8u.sind-ma89",
		":version": "rv-ybzi~e74g_78m5",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Ajuntament de Sant Cugat del Vallès",
		"indicador_refugi": "82055|AJUNTAMENT_DE_SANT_CUGAT_DEL_VALLES",
		"municipi": "Sant Cugat del Vallès",
		"codi_municipi": "82055",
		"latitud": "41.47039726",
		"longitud": "2.085181107",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "Pl.de la Vila, 1",
		"informacio_web": "https://www.santcugat.cat/",
		"tipologia": "Ajuntament",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-zkaj_iejd~sb67",
		":version": "rv-tu8a~e54s-zyqv",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "La Unió Santcugatenca",
		"indicador_refugi": "82055|LA_UNIO_SANTCUGATENCA",
		"municipi": "Sant Cugat del Vallès",
		"codi_municipi": "82055",
		"latitud": "41.47159793",
		"longitud": "2.080513055",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "Av. de Josep Anselm Clavé, 13-17",
		"informacio_web": "https://www.santcugat.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-mn6u-cpac-zp8u",
		":version": "rv-z9dr.83p5~e3rj",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc del Turó de Can Mates",
		"indicador_refugi": "82055|PARC_DEL_TURO_DE_CAN_MATES",
		"municipi": "Sant Cugat del Vallès",
		"codi_municipi": "82055",
		"latitud": "41.47529965",
		"longitud": "2.06195221",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "C. Ramon Llull, 18",
		"informacio_web": "https://www.santcugat.cat/",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-x5ca-9ygu_yj2b",
		":version": "rv-mmg4.twit~m2zf",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de Mira-sol",
		"indicador_refugi": "82055|CASAL_DE_MIRA_SOL",
		"municipi": "Sant Cugat del Vallès",
		"codi_municipi": "82055",
		"latitud": "41.46784201",
		"longitud": "2.046305366",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "C. de Mallorca, 42",
		"informacio_web": "https://www.santcugat.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-wuxp_xyvx_259m",
		":version": "rv-s3mc-8kqm~kkjd",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Miquel Batllori (Volpelleres)",
		"indicador_refugi": "82055|BIBLIOTECA_MIQUEL_BATLLORI_VOLPELLERES",
		"municipi": "Sant Cugat del Vallès",
		"codi_municipi": "82055",
		"latitud": "41.4840802",
		"longitud": "2.065491464",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "C.  de Pau Muñoz i Castanyer, 3-5",
		"informacio_web": "https://www.santcugat.cat/",
		"tipologia": "Biblioteca",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-hnwy-raty_apc3",
		":version": "rv-w6yr-3jy5_qmcw",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Mercat municipal Volpelleres",
		"indicador_refugi": "82055|MERCAT_MUNICIPAL_VOLPELLERES",
		"municipi": "Sant Cugat del Vallès",
		"codi_municipi": "82055",
		"latitud": "41.4815794",
		"longitud": "2.070636766",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "C. de Benet Cortada,15",
		"informacio_web": "https://www.santcugat.cat/",
		"tipologia": "Mercat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-sphm-8k25.r26v",
		":version": "rv-9eud~u5ji~f8mr",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Cívic Les Planes",
		"indicador_refugi": "82055|CENTRE_CIVIC_LES_PLANES",
		"municipi": "Sant Cugat del Vallès",
		"codi_municipi": "82055",
		"latitud": "41.43389472",
		"longitud": "2.093997768",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "Pl .del Coll de la Creu d'en Blau, 7",
		"informacio_web": "https://www.santcugat.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-npug~7uu2~t5x9",
		":version": "rv-4mht-hx4z_yt7d",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Social i Sanitari de la Floresta",
		"indicador_refugi": "82055|CENTRE_SOCIAL_I_SANITARI_DE_LA_FLORESTA",
		"municipi": "Sant Cugat del Vallès",
		"codi_municipi": "82055",
		"latitud": "41.44499402",
		"longitud": "2.074828287",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "C. Pearson, 36",
		"informacio_web": "https://www.santcugat.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-fscm-pexu-z3m8",
		":version": "rv-eu7g~bzhw-sh4x",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de Gent Gran de Valldoreix",
		"indicador_refugi": "82055|CASAL_DE_GENT_GRAN_DE_VALLDOREIX",
		"municipi": "Sant Cugat del Vallès",
		"codi_municipi": "82055",
		"latitud": "41.45862105",
		"longitud": "2.063069842",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "C. de Tibidabo, 5",
		"informacio_web": "https://www.santcugat.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-2tim_6kry_3rb5",
		":version": "rv-h8w9.s8n7_hrzn",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Pessarrodona (Mira-sol)",
		"indicador_refugi": "82055|BIBLIOTECA_PESSARRODONA_MIRA_SOL",
		"municipi": "Sant Cugat del Vallès",
		"codi_municipi": "82055",
		"latitud": "41.46972942",
		"longitud": "2.061649885",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "Pl. Ausiàs March, 2",
		"informacio_web": "https://www.santcugat.cat/",
		"tipologia": "Biblioteca",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-gi3p~vys5~9ngz",
		":version": "rv-jxfk-5ssx~8z7h",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Vall d'Or (Valldoreix)",
		"indicador_refugi": "82055|BIBLIOTECA_VALL_D_OR_VALLDOREIX",
		"municipi": "Sant Cugat del Vallès",
		"codi_municipi": "82055",
		"latitud": "41.45737847",
		"longitud": "2.047910729",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "Rbla. Mossèn Jacint Verdaguer, 185",
		"informacio_web": "https://www.santcugat.cat/",
		"tipologia": "Biblioteca",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-kv4x-bzgf-ty9s",
		":version": "rv-m2sp.uun7_e53r",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de Can Barriga",
		"indicador_refugi": "80155|PARC_DE_CAN_BARRIGA",
		"municipi": "Badalona",
		"codi_municipi": "80155",
		"latitud": "41.45593017",
		"longitud": "2.241149953",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. de Martí Pujol, 410",
		"informacio_web": "https://www.badalona.cat/",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-dryu_f5sn-3py3",
		":version": "rv-x6yh-xhrp_mv8c",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca  Lloreda",
		"indicador_refugi": "80155|BIBLIOTECA_LLOREDA",
		"municipi": "Badalona",
		"codi_municipi": "80155",
		"latitud": "41.44993584",
		"longitud": "2.230616755",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "Av. Catalunya, 56-62",
		"informacio_web": "https://www.badalona.cat/",
		"tipologia": "Biblioteca",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-w7ps-kvxf.hfii",
		":version": "rv-wprc_nzg8~nemy",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Pomar",
		"indicador_refugi": "80155|BIBLIOTECA_POMAR",
		"municipi": "Badalona",
		"codi_municipi": "80155",
		"latitud": "41.46478509",
		"longitud": "2.25046354",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "Av.Primer de Maig, s/n",
		"informacio_web": "https://www.badalona.cat/",
		"tipologia": "Biblioteca",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-iqsv_pbav_jnj3",
		":version": "rv-wbft.qs6d~t7ei",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Canyadó i Casagemes",
		"indicador_refugi": "80155|BIBLIOTECA_CANYADO_I_CASAGEMES",
		"municipi": "Badalona",
		"codi_municipi": "80155",
		"latitud": "41.45627424",
		"longitud": "2.257127046",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "C. Jacinto Benavente, 3",
		"informacio_web": "https://www.badalona.cat/",
		"tipologia": "Biblioteca",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-u2wd_sqke.drsg",
		":version": "rv-nu7j~2uvi.xmuf",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Cultural El Carme",
		"indicador_refugi": "80155|CENTRE_CULTURAL_EL_CARME",
		"municipi": "Badalona",
		"codi_municipi": "80155",
		"latitud": "41.45075166",
		"longitud": "2.248552354",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "C. Francesc Layret, 78",
		"informacio_web": "https://www.badalona.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-crbf_rqde.cs2j",
		":version": "rv-ktp5.myiu-nb8d",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de la Solidaritat Can Pepus",
		"indicador_refugi": "80155|CASAL_DE_LA_SOLIDARITAT_CAN_PEPUS",
		"municipi": "Badalona",
		"codi_municipi": "80155",
		"latitud": "41.44613092",
		"longitud": "2.240498199",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "C. Francesc Macià, 104",
		"informacio_web": "https://www.badalona.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-brx8_n5rg~wepg",
		":version": "rv-zt6t-em4t~i7a6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de Nelson Mandela",
		"indicador_refugi": "80155|PARC_DE_NELSON_MANDELA",
		"municipi": "Badalona",
		"codi_municipi": "80155",
		"latitud": "41.45550101",
		"longitud": "2.239148167",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "C. Migjorn, 67A",
		"informacio_web": "https://www.badalona.cat/",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-erxa~9x79~8i2h",
		":version": "rv-q8s4-a2gm~735y",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de Nova Lloreda",
		"indicador_refugi": "80155|PARC_DE_NOVA_LLOREDA",
		"municipi": "Badalona",
		"codi_municipi": "80155",
		"latitud": "41.45001341",
		"longitud": "2.231893304",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Rambla de Sant Joan",
		"informacio_web": "https://www.badalona.cat/",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-66nz~qnzx~tgwk",
		":version": "rv-ptfq-4egu_h6cs",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Torrents i Lladó",
		"indicador_refugi": "80155|PARC_TORRENTS_I_LLADO",
		"municipi": "Badalona",
		"codi_municipi": "80155",
		"latitud": "41.4617382",
		"longitud": "2.239429234",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. Martí Pujol, 614",
		"informacio_web": "https://www.badalona.cat/",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-24w2.rmcd.yqjd",
		":version": "rv-vziz~kiqz~v4tq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça Amistat",
		"indicador_refugi": "80155|PLACA_AMISTAT",
		"municipi": "Badalona",
		"codi_municipi": "80155",
		"latitud": "41.43872475",
		"longitud": "2.21953006",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Reus, s/n",
		"informacio_web": "https://www.badalona.cat/",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-rywx_t3ti.39xh",
		":version": "rv-w5mv~cxtp_j5gk",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "La CIBA",
		"indicador_refugi": "82457|LA_CIBA",
		"municipi": "Santa Coloma de Gramenet",
		"codi_municipi": "82457",
		"latitud": "41.44996063",
		"longitud": "2.203528768",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "Pg. de Llorenç Serra, 64",
		"informacio_web": "https://www.gramenet.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-z7j3_a5kp.qq39",
		":version": "rv-w7ry-4nyr-v5d7",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina Municipal de Can  Millars (recepció)",
		"indicador_refugi": "80734|PISCINA_MUNICIPAL_DE_CAN_MILLARS_RECEPCIO",
		"municipi": "Cornellà de Llobregat",
		"codi_municipi": "80734",
		"latitud": "41.35609647",
		"longitud": "2.076811627",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "C. Bonavista, 70",
		"informacio_web": "https://www.cornella.cat/",
		"tipologia": "Equipament esportiu",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ezze_e6ab.3ym8",
		":version": "rv-tidb.6puz_xphs",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Mercat de Sant Ildefons",
		"indicador_refugi": "80734|MERCAT_DE_SANT_ILDEFONS",
		"municipi": "Cornellà de Llobregat",
		"codi_municipi": "80734",
		"latitud": "41.36215786",
		"longitud": "2.083292638",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "Av. de Sant Ildefons, s/n",
		"informacio_web": "https://www.cornella.cat/",
		"tipologia": "Mercat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-jihm.a4ue.a42w",
		":version": "rv-9vyb~bsjp_95y3",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Mercat Centre",
		"indicador_refugi": "80734|MERCAT_CENTRE",
		"municipi": "Cornellà de Llobregat",
		"codi_municipi": "80734",
		"latitud": "41.35323231",
		"longitud": "2.071476572",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "Pl. Lluís Companys, s/n",
		"informacio_web": "https://www.cornella.cat/",
		"tipologia": "Mercat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-6zvj.n2bg_824t",
		":version": "rv-az4n.99kh~cb6a",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Mercat Mersans",
		"indicador_refugi": "80734|MERCAT_MERSANS",
		"municipi": "Cornellà de Llobregat",
		"codi_municipi": "80734",
		"latitud": "41.36125072",
		"longitud": "2.075218387",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "Pl. Marsans, s/n",
		"informacio_web": "https://www.cornella.cat/",
		"tipologia": "Mercat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-3m3q.kw4u_uem8",
		":version": "rv-zxmm~hav2-xciy",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de Cultura",
		"indicador_refugi": "81944|CASAL_DE_CULTURA",
		"municipi": "Sant Adrià del Besòs",
		"codi_municipi": "81944",
		"latitud": "41.42669993",
		"longitud": "2.223430226",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "C. Mare de Déu del Carme, 22",
		"informacio_web": "https://www.sant-adria.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-m4hc_whd3_5e7c",
		":version": "rv-z6f8.xrmr_fd8j",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de Gent Gran de Via Trajana",
		"indicador_refugi": "81944|CASAL_DE_GENT_GRAN_DE_VIA_TRAJANA",
		"municipi": "Sant Adrià del Besòs",
		"codi_municipi": "81944",
		"latitud": "41.42676382",
		"longitud": "2.208476453",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "Av. Ferrocarril, 11-13",
		"informacio_web": "https://www.sant-adria.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-fnee.d5ic~j9d5",
		":version": "rv-th39-28hv-kfu6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc del Mamut-Venux",
		"indicador_refugi": "82634|PARC_DEL_MAMUT_VENUX",
		"municipi": "Sant Vicenç dels Horts",
		"codi_municipi": "82634",
		"latitud": "41.39733584",
		"longitud": "2.009974385",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Ctra. Sant Boi, 59",
		"informacio_web": "https://svh.cat/",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-fcfc.s886-2xxx",
		":version": "rv-ab9h_txjp.jziv",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casa de la Vila",
		"indicador_refugi": "82634|CASA_DE_LA_VILA",
		"municipi": "Sant Vicenç dels Horts",
		"codi_municipi": "82634",
		"latitud": "41.39325189",
		"longitud": "2.009574552",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "Pl. de la Vila, 1",
		"informacio_web": "https://svh.cat/",
		"tipologia": "Ajuntament",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-w2qt~dgtd~2w6j",
		":version": "rv-ww6s_2sm3~hisa",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Cultural i Cívic Virgínia Amposta",
		"indicador_refugi": "82634|CENTRE_CULTURAL_I_CIVIC_VIRGINIA_AMPOSTA",
		"municipi": "Sant Vicenç dels Horts",
		"codi_municipi": "82634",
		"latitud": "41.39822409",
		"longitud": "2.009559673",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "C. Antoni Mampel, 1-3",
		"informacio_web": "https://svh.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-egbm~9trf-kia2",
		":version": "rv-dnwq.xy9e-cwnk",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Cívic de la Guàrdia",
		"indicador_refugi": "82634|CENTRE_CIVIC_DE_LA_GUARDIA",
		"municipi": "Sant Vicenç dels Horts",
		"codi_municipi": "82634",
		"latitud": "41.3909864",
		"longitud": "2.003831045",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "C. Mestre Ramon Camps, 86",
		"informacio_web": "https://svh.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ex79.wme2.c6ez",
		":version": "rv-ung5~v9bs-ze4d",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Municipal Les Voltes",
		"indicador_refugi": "82634|BIBLIOTECA_MUNICIPAL_LES_VOLTES",
		"municipi": "Sant Vicenç dels Horts",
		"codi_municipi": "82634",
		"latitud": "41.39300429",
		"longitud": "2.011483821",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "C. Nou, 7",
		"informacio_web": "https://svh.cat/",
		"tipologia": "Biblioteca",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-y6sc~cufy.4eqq",
		":version": "rv-su6j~ymst_xp6k",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Social El Mil·lenari",
		"indicador_refugi": "82212|CENTRE_SOCIAL_EL_MIL_LENARI",
		"municipi": "Sant Just Desvern",
		"codi_municipi": "82212",
		"latitud": "41.38362993",
		"longitud": "2.079374469",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "C. d’Àngel Guimerà, 1",
		"informacio_web": "https://santjust.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ke97_zzht_wbwj",
		":version": "rv-ch8u-gwpi~vmud",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Cívic Salvador Espriu",
		"indicador_refugi": "82212|CENTRE_CIVIC_SALVADOR_ESPRIU",
		"municipi": "Sant Just Desvern",
		"codi_municipi": "82212",
		"latitud": "41.38189102",
		"longitud": "2.070347415",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "C. Tudona, s/n",
		"informacio_web": "https://santjust.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-y422_wfhh~dcsy",
		":version": "rv-z2vk.ygtg~wrhs",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Joan Margarit",
		"indicador_refugi": "82212|BIBLIOTECA_JOAN_MARGARIT",
		"municipi": "Sant Just Desvern",
		"codi_municipi": "82212",
		"latitud": "41.38689802",
		"longitud": "2.075623992",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "C. Carles Mercader, 17",
		"informacio_web": "https://santjust.cat/",
		"tipologia": "Biblioteca",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-gq2b-6j7r_g2uk",
		":version": "rv-kbfs~6aat-nykq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Cívic Soledat Sans Serafini",
		"indicador_refugi": "82212|CENTRE_CIVIC_SOLEDAT_SANS_SERAFINI",
		"municipi": "Sant Just Desvern",
		"codi_municipi": "82212",
		"latitud": "41.38790912",
		"longitud": "2.061872851",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "C. Maria Montessori, 2",
		"informacio_web": "https://santjust.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-mtbr~3cqq_ybfr",
		":version": "rv-cfkm.m8xk_v4mf",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Cívic Joan Maragall",
		"indicador_refugi": "82212|CENTRE_CIVIC_JOAN_MARAGALL",
		"municipi": "Sant Just Desvern",
		"codi_municipi": "82212",
		"latitud": "41.38172146",
		"longitud": "2.080306829",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "C. Major, 17",
		"informacio_web": "https://santjust.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-c2s8~s4ue_9thg",
		":version": "rv-6bex_nv5h.qzi7",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Ajuntament",
		"indicador_refugi": "82444|AJUNTAMENT",
		"municipi": "Santa Coloma de Cervelló",
		"codi_municipi": "82444",
		"latitud": "41.36884541",
		"longitud": "2.016175633",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "C. Pau Casals, 26-34",
		"informacio_web": "https://www.santacolomadecervello.cat/",
		"tipologia": "Ajuntament",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ddvn-k9m9_9qbp",
		":version": "rv-4kx4~jj94~xxsd",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Camet de la Colonia Güell",
		"indicador_refugi": "82444|CAMET_DE_LA_COLONIA_GUELL",
		"municipi": "Santa Coloma de Cervelló",
		"codi_municipi": "82444",
		"latitud": "41.36190064",
		"longitud": "2.02898969",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Barrau, s/n",
		"informacio_web": "https://www.santacolomadecervello.cat/",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-u4u4.b9vv-tyvt",
		":version": "rv-b3qc-9mf9_uza8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Colònia Güell",
		"indicador_refugi": "82444|CASAL_COLONIA_GUELL",
		"municipi": "Santa Coloma de Cervelló",
		"codi_municipi": "82444",
		"latitud": "41.36222075",
		"longitud": "2.027584687",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "C. Claudi Güell, 1",
		"informacio_web": "https://www.santacolomadecervello.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-sk4y~qf5u-jgp8",
		":version": "rv-35qr-xkqj~6bzq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de Can Corts",
		"indicador_refugi": "80734|PARC_DE_CAN_CORTS",
		"municipi": "Cornellà de Llobregat",
		"codi_municipi": "80734",
		"latitud": "41.36132577",
		"longitud": "2.065378923",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. Can Corts, 38A",
		"informacio_web": "https://refugisclimatics.amb.cat",
		"tipologia": "Parc AMB",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-h3qq-mgfx-npcu",
		":version": "rv-8bjd_sr2a~isd5",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de la  Gent Gran Gavarra",
		"indicador_refugi": "80734|CASAL_DE_LA_GENT_GRAN_GAVARRA",
		"municipi": "Cornellà de Llobregat",
		"codi_municipi": "80734",
		"latitud": "41.35882133",
		"longitud": "2.072706471",
		"adreca": "C. Bellaterra, 2",
		"informacio_web": "https://www.cornella.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-reyg_hhpw~uh9q",
		":version": "rv-6itz.3vfy.mxey",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Cívic Tovalloles",
		"indicador_refugi": "82114|CENTRE_CIVIC_TOVALLOLES",
		"municipi": "Sant Feliu de Llobregat",
		"codi_municipi": "82114",
		"latitud": "41.38609382",
		"longitud": "2.04496761",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "C. Riera de la Salut, 7",
		"informacio_web": "https://www.santfeliu.cat/go.faces?xmid=1",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-xrah-kdhx_x3x7",
		":version": "rv-sh6q-dghk-qmqj",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Civic Mas Lluí",
		"indicador_refugi": "82114|CENTRE_CIVIC_MAS_LLUI",
		"municipi": "Sant Feliu de Llobregat",
		"codi_municipi": "82114",
		"latitud": "41.38554311",
		"longitud": "2.053520957",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "Carrer Estelí, 10-12",
		"informacio_web": "https://www.santfeliu.cat/go.faces?xmid=1",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ffe6~dhpk-d8tn",
		":version": "rv-v893.v77g.9kjv",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc i piscines de la Muntanyeta",
		"indicador_refugi": "82009|PARC_I_PISCINES_DE_LA_MUNTANYETA",
		"municipi": "Sant Boi de Llobregat",
		"codi_municipi": "82009",
		"latitud": "41.34006053",
		"longitud": "2.032031195",
		"accessibilitat": "SÍ",
		"adreca": "Ronda  Sant Ramon, 155",
		"informacio_web": "https://www.santboi.cat/",
		"tipologia": "Piscina",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-vvmp-qrz5_fjce",
		":version": "rv-mjmr~qfby~pr8m",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscines Fontsanta",
		"indicador_refugi": "82172|PISCINES_FONTSANTA",
		"municipi": "Sant Joan Despí",
		"codi_municipi": "82172",
		"latitud": "41.37089134",
		"longitud": "2.070308435",
		"accessibilitat": "SÍ",
		"adreca": "C. del Marquès de Monistrol, 30,",
		"informacio_web": "https://sjdespi.cat/",
		"tipologia": "Piscina",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-q2zu_snic_dtne",
		":version": "rv-abaq~4hhr_7c4v",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina Parc Central",
		"indicador_refugi": "82055|PISCINA_PARC_CENTRAL",
		"municipi": "Sant Cugat del Vallès",
		"codi_municipi": "82055",
		"latitud": "41.47343595",
		"longitud": "2.076352741",
		"accessibilitat": "SÍ",
		"adreca": "C. Rovellat, 37",
		"informacio_web": "https://www.santcugat.cat/",
		"tipologia": "Piscina",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-cxqx_7erx_tkaa",
		":version": "rv-a6be_xfs7_g5pn",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina de la Floresta",
		"indicador_refugi": "82055|PISCINA_DE_LA_FLORESTA",
		"municipi": "Sant Cugat del Vallès",
		"codi_municipi": "82055",
		"latitud": "41.44677887",
		"longitud": "2.070080679",
		"accessibilitat": "SÍ",
		"adreca": "C. Ginjoler, 6",
		"informacio_web": "https://www.santcugat.cat/",
		"tipologia": "Piscina",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-3g5u-ga9d-zu32",
		":version": "rv-xhuj_wgnq~2g3i",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina Valldoreix",
		"indicador_refugi": "82055|PISCINA_VALLDOREIX",
		"municipi": "Sant Cugat del Vallès",
		"codi_municipi": "82055",
		"latitud": "41.44980675",
		"longitud": "2.056161989",
		"accessibilitat": "SÍ",
		"adreca": "Pg. Guineu, 36",
		"informacio_web": "info@cevalldoreix.com",
		"tipologia": "Piscina",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-52id_868w.xt4p",
		":version": "rv-a32j-bxzn_saya",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Complex Esportiu Torribera",
		"indicador_refugi": "82457|COMPLEX_ESPORTIU_TORRIBERA",
		"municipi": "Santa Coloma de Gramenet",
		"codi_municipi": "82457",
		"latitud": "41.46489567",
		"longitud": "2.212778879",
		"accessibilitat": "SÍ",
		"adreca": "C.Castella, s/n",
		"informacio_web": "https://www.gramenet.cat/",
		"tipologia": "Piscina",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-7vxt_8fyc~m5ve",
		":version": "rv-ayiq_id5f.7hg9",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Complex Esportiu DUIN Can Zam",
		"indicador_refugi": "82457|COMPLEX_ESPORTIU_DUIN_CAN_ZAM",
		"municipi": "Santa Coloma de Gramenet",
		"codi_municipi": "82457",
		"latitud": "41.45524026",
		"longitud": "2.203084047",
		"accessibilitat": "SÍ",
		"adreca": "C. Víctor Hugo, s/n",
		"informacio_web": "https://www.gramenet.cat/",
		"tipologia": "Piscina",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ekqq-wp54.74e9",
		":version": "rv-crzs_5rm3.egad",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina Municipal Les fontetes Turonet",
		"indicador_refugi": "82665|PISCINA_MUNICIPAL_LES_FONTETES_TURONET",
		"municipi": "Cerdanyola del Vallès",
		"codi_municipi": "82665",
		"latitud": "41.48611929",
		"longitud": "2.145363143",
		"accessibilitat": "SÍ",
		"adreca": "C. Pizarro, s/n",
		"informacio_web": "https://www.cerdanyola.cat/",
		"tipologia": "Piscina",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-f5p5_thh6_utsk",
		":version": "rv-9kgs~pjpv_zuhu",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Zona esportiva municipal bosc tancat",
		"indicador_refugi": "82665|ZONA_ESPORTIVA_MUNICIPAL_BOSC_TANCAT",
		"municipi": "Cerdanyola del Vallès",
		"codi_municipi": "82665",
		"latitud": "41.50213709",
		"longitud": "2.129873209",
		"accessibilitat": "SÍ",
		"adreca": "C. Riu Sec, s/n",
		"informacio_web": "https://www.cerdanyola.cat/",
		"tipologia": "Piscina",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-m8x5_bgr7~26ar",
		":version": "rv-m3uk.dwpp.ysc8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina Municipal Montflorit",
		"indicador_refugi": "82665|PISCINA_MUNICIPAL_MONTFLORIT",
		"municipi": "Cerdanyola del Vallès",
		"codi_municipi": "82665",
		"latitud": "41.48110298",
		"longitud": "2.130773308",
		"accessibilitat": "SÍ",
		"adreca": "C. Mare de Déu dels Dolors, 19",
		"informacio_web": "https://www.cerdanyola.cat/",
		"tipologia": "Piscina",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-njy9.hyz5_j3ia",
		":version": "rv-k8i9-qza4.2z57",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal de Sant Antoni - La Blava",
		"indicador_refugi": "82634|PISCINA_MUNICIPAL_DE_SANT_ANTONI_LA_BLAVA",
		"municipi": "Sant Vicenç dels Horts",
		"codi_municipi": "82634",
		"latitud": "41.38332668",
		"longitud": "1.994980581",
		"accessibilitat": "SÍ",
		"adreca": "Avi. Mas Picó, s/n",
		"informacio_web": "https://svh.cat/",
		"tipologia": "Piscina",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-5jky.2uxm.2fvi",
		":version": "rv-j5uz~k65m_n9bu",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina Can Via",
		"indicador_refugi": "82444|PISCINA_CAN_VIA",
		"municipi": "Santa Coloma de Cervelló",
		"codi_municipi": "82444",
		"latitud": "41.36559935",
		"longitud": "2.007715558",
		"accessibilitat": "SÍ",
		"adreca": "C. Rossinyol, 20",
		"informacio_web": "https://www.santacolomadecervello.cat/",
		"tipologia": "Piscina",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-we3c.2546.wv36",
		":version": "rv-ghii.v6y7-s7t5",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscines exteriors de les Instal·lacions Esportives Municipals",
		"indicador_refugi": "89045|PISCINES_EXTERIORS_DE_LES_INSTAL_LACIONS_ESPORTIVES_MUNICIPALS",
		"municipi": "Badia del Vallès",
		"codi_municipi": "89045",
		"latitud": "41.51445824",
		"longitud": "2.113236627",
		"accessibilitat": "SÍ",
		"adreca": "Av. Tibidabo",
		"informacio_web": "https://www.badiadelvalles.cat/",
		"tipologia": "Piscina",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-99ap~mu8t~tp85",
		":version": "rv-wspu.2eiq.j7t4",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Municipal Can Baró",
		"indicador_refugi": "80728|BIBLIOTECA_MUNICIPAL_CAN_BARO",
		"municipi": "Corbera de Llobregat",
		"codi_municipi": "80728",
		"latitud": "41.41486587",
		"longitud": "1.931144771",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "C. Sant Salvador, 25",
		"informacio_web": "https://www.corberadellobregat.cat/",
		"tipologia": "Biblioteca",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-kyuu-86xw.cfu2",
		":version": "rv-8r5f-y7rb-tpme",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de la gent gran Les Magnòlies",
		"indicador_refugi": "80728|CASAL_DE_LA_GENT_GRAN_LES_MAGNOLIES",
		"municipi": "Corbera de Llobregat",
		"codi_municipi": "80728",
		"latitud": "41.41259978",
		"longitud": "1.928281808",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "C. Progrés, 1",
		"informacio_web": "https://www.corberadellobregat.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-mw8e-xf28_69ri",
		":version": "rv-pquh~52is-qpuv",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de les Palmeres",
		"indicador_refugi": "80728|PARC_DE_LES_PALMERES",
		"municipi": "Corbera de Llobregat",
		"codi_municipi": "80728",
		"latitud": "41.41681685",
		"longitud": "1.920439443",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Raval, 26",
		"informacio_web": "https://refugisclimatics.amb.cat",
		"tipologia": "Parc AMB",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-tvz4~7zvq-uwtq",
		":version": "rv-7etu~4222-zr8y",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Miquel Martí i Pol",
		"indicador_refugi": "80728|PARC_MIQUEL_MARTI_I_POL",
		"municipi": "Corbera de Llobregat",
		"codi_municipi": "80728",
		"latitud": "41.41457086",
		"longitud": "1.922663085",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Josep Tarradellas, 24",
		"informacio_web": "https://www.corberadellobregat.cat/",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-jku2-sjyp~vn7u",
		":version": "rv-aam5~e2ct-upp6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Carrer Pau Bruna",
		"indicador_refugi": "81580|PARC_CARRER_PAU_BRUNA",
		"municipi": "Corbera de Llobregat",
		"codi_municipi": "81580",
		"latitud": "41.41518595",
		"longitud": "1.931005329",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Sant Antoni, 24",
		"informacio_web": "https://www.elpapiol.cat/",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-uz4z_9vxh-bpdy",
		":version": "rv-f8qt_tnbb.3e7u",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Aigüestortes",
		"indicador_refugi": "81960|BIBLIOTECA_AIGUESTORTES",
		"municipi": "Sant Andreu de la Barca",
		"codi_municipi": "81960",
		"latitud": "41.44941853",
		"longitud": "1.967279732",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "Av. Constitució, 24",
		"informacio_web": "https://www.sabarca.cat/",
		"tipologia": "Biblioteca",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-8rjn_bntw.3r9g",
		":version": "rv-sks4~i2iv.udq6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de la Gent gran María Aurelia Campmany",
		"indicador_refugi": "81960|CASAL_DE_LA_GENT_GRAN_MARIA_AURELIA_CAMPMANY",
		"municipi": "Sant Andreu de la Barca",
		"codi_municipi": "81960",
		"latitud": "41.45082219",
		"longitud": "1.970490826",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "Pg.  Generalitat, 0",
		"informacio_web": "https://www.sabarca.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-sqaq-233n~ymrt",
		":version": "rv-2kc6~j2sw.dv5q",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Ajuntament",
		"indicador_refugi": "81960|AJUNTAMENT",
		"municipi": "Sant Andreu de la Barca",
		"codi_municipi": "81960",
		"latitud": "41.45007775",
		"longitud": "1.971295807",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "Pl. Ajuntament, 1",
		"informacio_web": "https://www.sabarca.cat/",
		"tipologia": "Ajuntament",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-xjmi~nkgt-f2g6",
		":version": "rv-jf8j~4kxz.8ziy",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre de Recursos Associatius",
		"indicador_refugi": "81960|CENTRE_DE_RECURSOS_ASSOCIATIUS",
		"municipi": "Sant Andreu de la Barca",
		"codi_municipi": "81960",
		"latitud": "41.44712012",
		"longitud": "1.974563038",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "Pl. Anselm Clavé, 12",
		"informacio_web": "https://www.sabarca.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-nm94-pupa~wdj6",
		":version": "rv-sssk_nmk8-gajj",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina d’estiu de Can Salvi",
		"indicador_refugi": "81960|PISCINA_D_ESTIU_DE_CAN_SALVI",
		"municipi": "Sant Andreu de la Barca",
		"codi_municipi": "81960",
		"latitud": "41.44832551",
		"longitud": "1.962790045",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "Av. Constitució, 0",
		"informacio_web": "https://www.sabarca.cat/",
		"tipologia": "Piscina",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-az4a-ndjv_y5dz",
		":version": "rv-uaei~6rwp-6kas",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Solana",
		"indicador_refugi": "81960|PARC_SOLANA",
		"municipi": "Sant Andreu de la Barca",
		"codi_municipi": "81960",
		"latitud": "41.44745952",
		"longitud": "1.977886267",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C.l Doctor Vila, 11",
		"informacio_web": "https://refugisclimatics.amb.cat",
		"tipologia": "Parc AMB",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-skg7~ek4t.eq3i",
		":version": "rv-eyqi.yquw-yeny",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Central",
		"indicador_refugi": "81960|PARC_CENTRAL",
		"municipi": "Sant Andreu de la Barca",
		"codi_municipi": "81960",
		"latitud": "41.45007239",
		"longitud": "1.969519778",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Parc Central",
		"informacio_web": "https://www.sabarca.cat/",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-mn87_heph-n38z",
		":version": "rv-z4bt.y32b.g5tn",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina municipal",
		"indicador_refugi": "80207|PISCINA_MUNICIPAL",
		"municipi": "Begues",
		"codi_municipi": "80207",
		"latitud": "41.33817821",
		"longitud": "1.920751027",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "C.Vallirana, s/n",
		"informacio_web": "https://www.begues.cat/",
		"tipologia": "Piscina",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-uxza.awxk-hww7",
		":version": "rv-cn4f_j9tf~gx4n",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre civic El Roure",
		"indicador_refugi": "80207|CENTRE_CIVIC_EL_ROURE",
		"municipi": "Begues",
		"codi_municipi": "80207",
		"latitud": "41.33044999",
		"longitud": "1.918214272",
		"aigua": "Sí",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "Pl. 1 d'Octubre de 2017, 1",
		"informacio_web": "https://www.begues.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-xiek_4n6c_22cz",
		":version": "rv-ezxn.ybug_gape",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca la Ginesta",
		"indicador_refugi": "80207|BIBLIOTECA_LA_GINESTA",
		"municipi": "Begues",
		"codi_municipi": "80207",
		"latitud": "41.33041439",
		"longitud": "1.9181651",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "Pl. 1 d'Octubre de 2017, 1",
		"informacio_web": "https://www.begues.cat/",
		"tipologia": "Biblioteca",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-3ddp~saax~3fkr",
		":version": "rv-w542~aezj~trq5",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "l'Escorxador",
		"indicador_refugi": "80207|L_ESCORXADOR",
		"municipi": "Begues",
		"codi_municipi": "80207",
		"latitud": "41.3309081",
		"longitud": "1.91850168",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "Av. Sitges, 12",
		"informacio_web": "https://www.begues.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-cgh2~5jnc-rzt5",
		":version": "rv-pqzf.eg9i-rp6q",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "El Fixu Espai Jove El Fixu",
		"indicador_refugi": "80207|EL_FIXU_ESPAI_JOVE_EL_FIXU",
		"municipi": "Begues",
		"codi_municipi": "80207",
		"latitud": "41.33840225",
		"longitud": "1.920550225",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "C. de Vallirana, s/n",
		"informacio_web": "https://www.begues.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-3pma~sz2c~hcxd",
		":version": "rv-vpqv-srea.2q43",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "OAC Cal Pere Vell",
		"indicador_refugi": "80207|OAC_CAL_PERE_VELL",
		"municipi": "Begues",
		"codi_municipi": "80207",
		"latitud": "41.33084156",
		"longitud": "1.92228974",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "C. Major, 14",
		"informacio_web": "https://www.begues.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-jjnk_eq3v~gvhw",
		":version": "rv-2xa8-pqan.pv4v",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CEM La Plana",
		"indicador_refugi": "80771|CEM_LA_PLANA",
		"municipi": "Esplugues de Llobregat",
		"codi_municipi": "80771",
		"latitud": "41.37463015",
		"longitud": "2.088212655",
		"accessibilitat": "Si",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Plaça Catalunya, s/n",
		"informacio_web": "https://www.esplugues.cat/",
		"tipologia": "Equipament esportiu",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-9rnn_r6r6.sguu",
		":version": "rv-bu6u-yvvg~mz45",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina Parc Torrents",
		"indicador_refugi": "80771|PISCINA_PARC_TORRENTS",
		"municipi": "Esplugues de Llobregat",
		"codi_municipi": "80771",
		"latitud": "41.37495173",
		"longitud": "2.090795396",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "Torrent d'en Farré (rampes d'accés des de pl. Catalunya, av. Cornellà i des del Jardí del Mirador)",
		"informacio_web": "https://www.esplugues.cat/",
		"tipologia": "Piscina",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-abru~dj8h_mats",
		":version": "rv-jf3v_nz4k-pi2m",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Pare Miquel d'Esplugues",
		"indicador_refugi": "80771|BIBLIOTECA_PARE_MIQUEL_D_ESPLUGUES",
		"municipi": "Esplugues de Llobregat",
		"codi_municipi": "80771",
		"latitud": "41.37604604",
		"longitud": "2.08147356",
		"accessibilitat": "Si",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Carrer d'Àngel Guimerà, 106",
		"informacio_web": "https://www.esplugues.cat/",
		"tipologia": "Biblioteca",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ufe7_8px9-x693",
		":version": "rv-674h_hqbh~w5q8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Mercat La Plana",
		"indicador_refugi": "80771|MERCAT_LA_PLANA",
		"municipi": "Esplugues de Llobregat",
		"codi_municipi": "80771",
		"latitud": "41.37271396",
		"longitud": "2.084401083",
		"accessibilitat": "Si",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Avinguda de Cornellà, 87",
		"informacio_web": "https://www.esplugues.cat/",
		"tipologia": "Mercat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-9b6b~pibm_u4vq",
		":version": "rv-4rbt~ff74-ej38",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Edifici Molí",
		"indicador_refugi": "80771|EDIFICI_MOLI",
		"municipi": "Esplugues de Llobregat",
		"codi_municipi": "80771",
		"latitud": "41.3726023",
		"longitud": "2.097376168",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"adreca": "Carrer Verge de la Mercè 1",
		"informacio_web": "https://www.esplugues.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-zmk9_3th3_z5dv",
		":version": "rv-kdfi~v7e2~wc52",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "La Baronda",
		"indicador_refugi": "80771|LA_BARONDA",
		"municipi": "Esplugues de Llobregat",
		"codi_municipi": "80771",
		"latitud": "41.37554059",
		"longitud": "2.090424094",
		"accessibilitat": "Si",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Carrer de la Riba, 36",
		"informacio_web": "https://www.esplugues.cat/",
		"tipologia": "ajuntament",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-enqk-kc32_y9dn",
		":version": "rv-gfku~3ick~xghg",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jardins del Parc Sanitari Sant Joan de Déu",
		"indicador_refugi": "82009|JARDINS_DEL_PARC_SANITARI_SANT_JOAN_DE_DEU",
		"municipi": "Sant Boi de Llobregat",
		"codi_municipi": "82009",
		"latitud": "41.35305327",
		"longitud": "2.032034112",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "C.Dr. Antoni Pujadas, 42",
		"informacio_web": "https://www.santboi.cat/",
		"tipologia": "Privat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-tfxk.7th3~rk2u",
		":version": "rv-auzh.8wvd_urt4",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Cívic Jardins de la Pau",
		"indicador_refugi": "81691|CENTRE_CIVIC_JARDINS_DE_LA_PAU",
		"municipi": "El Prat de Llobregat",
		"codi_municipi": "81691",
		"latitud": "41.32244192",
		"longitud": "2.09880456",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "Jardins de la Pau, s/n",
		"informacio_web": "https://www.elprat.cat/ciutat-i-territori/emergencia-climatica/refugis-climatics",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-q8ep~ep83_y24z",
		":version": "rv-y3pk_kajb~cxex",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Cívic Sant Jordi - Ribera Baixa",
		"indicador_refugi": "81691|CENTRE_CIVIC_SANT_JORDI_RIBERA_BAIXA",
		"municipi": "El Prat de Llobregat",
		"codi_municipi": "81691",
		"latitud": "41.3198033",
		"longitud": "2.086258237",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "C. Dolores Ibarruri, 45",
		"informacio_web": "https://www.elprat.cat/ciutat-i-territori/emergencia-climatica/refugis-climatics",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ae7w-nq4n-gqgw",
		":version": "rv-2ha3~y5qw-wu9x",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Cultural El Remolar",
		"indicador_refugi": "81691|CENTRE_CULTURAL_EL_REMOLAR",
		"municipi": "El Prat de Llobregat",
		"codi_municipi": "81691",
		"latitud": "41.32349637",
		"longitud": "2.090020597",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "C.Ramon Llull, 12",
		"informacio_web": "https://www.elprat.cat/ciutat-i-territori/emergencia-climatica/refugis-climatics",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-etae.tsjc~sa8b",
		":version": "rv-ejd9_mvjk.pnnb",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Cèntric Espai Cultural",
		"indicador_refugi": "81691|CENTRIC_ESPAI_CULTURAL",
		"municipi": "El Prat de Llobregat",
		"codi_municipi": "81691",
		"latitud": "41.32224613",
		"longitud": "2.094016207",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "Pl. Catalunya, 39-41",
		"informacio_web": "https://www.elprat.cat/ciutat-i-territori/emergencia-climatica/refugis-climatics",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-2pr3~auj8.i6hh",
		":version": "rv-pfeg~58qu_hvnq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Cívic Palmira Domènech",
		"indicador_refugi": "81691|CENTRE_CIVIC_PALMIRA_DOMENECH",
		"municipi": "El Prat de Llobregat",
		"codi_municipi": "81691",
		"latitud": "41.33025674",
		"longitud": "2.100560424",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "C. Lo Gaiter del Llobregat, 112",
		"informacio_web": "https://www.elprat.cat/ciutat-i-territori/emergencia-climatica/refugis-climatics",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-9vbw~ptvy-7nzc",
		":version": "rv-p3mh~r683.datj",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre de Promoció Econòmica",
		"indicador_refugi": "81691|CENTRE_DE_PROMOCIO_ECONOMICA",
		"municipi": "El Prat de Llobregat",
		"codi_municipi": "81691",
		"latitud": "41.32995944",
		"longitud": "2.103740383",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "C. de les Moreres, 48",
		"informacio_web": "https://www.elprat.cat/ciutat-i-territori/emergencia-climatica/refugis-climatics",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-qfeg~szfp.uamz",
		":version": "rv-wyaf-2p4v~3w5z",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Cases d'en Puig - edifici annex",
		"indicador_refugi": "81691|CASES_D_EN_PUIG_EDIFICI_ANNEX",
		"municipi": "El Prat de Llobregat",
		"codi_municipi": "81691",
		"latitud": "41.32465378",
		"longitud": "2.093193792",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "Pl. Agricultura, 4",
		"informacio_web": "https://www.elprat.cat/ciutat-i-territori/emergencia-climatica/refugis-climatics",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-gcse.i8hy_4rwj",
		":version": "rv-ifei_mce6-9zs3",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CEM Estruch",
		"indicador_refugi": "81691|CEM_ESTRUCH",
		"municipi": "El Prat de Llobregat",
		"codi_municipi": "81691",
		"latitud": "41.32844242",
		"longitud": "2.104124013",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "Av.Pare Andreu de Palma, 9",
		"informacio_web": "https://www.elprat.cat/ciutat-i-territori/emergencia-climatica/refugis-climatics",
		"tipologia": "Equipament esportiu",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-44ej_zd6s_tevt",
		":version": "rv-5zt7~dw5x.z6iz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CEM Sagnier",
		"indicador_refugi": "81691|CEM_SAGNIER",
		"municipi": "El Prat de Llobregat",
		"codi_municipi": "81691",
		"latitud": "41.32156205",
		"longitud": "2.082727012",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "C. Frederica Montseny",
		"informacio_web": "https://www.elprat.cat/ciutat-i-territori/emergencia-climatica/refugis-climatics",
		"tipologia": "Equipament esportiu",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-cm4t-b83t-mwi7",
		":version": "rv-axun.3s2d.iizq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Municipal de Vela",
		"indicador_refugi": "81691|CENTRE_MUNICIPAL_DE_VELA",
		"municipi": "El Prat de Llobregat",
		"codi_municipi": "81691",
		"latitud": "41.28783567",
		"longitud": "2.105818112",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "Pg. Platja, 3",
		"informacio_web": "https://www.elprat.cat/ciutat-i-territori/emergencia-climatica/refugis-climatics",
		"tipologia": "Equipament esportiu",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-6rxm.yh3d_5vd8",
		":version": "rv-ggai-uxg6~jxz2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça de Pere Calders",
		"indicador_refugi": "81691|PLACA_DE_PERE_CALDERS",
		"municipi": "El Prat de Llobregat",
		"codi_municipi": "81691",
		"latitud": "41.32581249",
		"longitud": "2.103915007",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Pl. Pere Calders",
		"informacio_web": "https://www.elprat.cat/ciutat-i-territori/emergencia-climatica/refugis-climatics",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-hx4c-hssy.wkvp",
		":version": "rv-bxb4.fnft-maki",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça de l'Estany de Sant Maurici",
		"indicador_refugi": "81691|PLACA_DE_L_ESTANY_DE_SANT_MAURICI",
		"municipi": "El Prat de Llobregat",
		"codi_municipi": "81691",
		"latitud": "41.32131522",
		"longitud": "2.092354012",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Pl. de l'Estany de Sant Maurici",
		"informacio_web": "https://www.elprat.cat/ciutat-i-territori/emergencia-climatica/refugis-climatics",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-7tnq_kjd2_dkm2",
		":version": "rv-9v6v-3wq7~tqfu",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de la Solidaritat",
		"indicador_refugi": "81691|PARC_DE_LA_SOLIDARITAT",
		"municipi": "El Prat de Llobregat",
		"codi_municipi": "81691",
		"latitud": "41.32223126",
		"longitud": "2.084537488",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Av. Verge de Montserrat, 254",
		"informacio_web": "https://www.elprat.cat/ciutat-i-territori/emergencia-climatica/refugis-climatics",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-83pj_7cfc_2yup",
		":version": "rv-xsid~ag7d~pyar",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jardins de la Pau",
		"indicador_refugi": "81691|JARDINS_DE_LA_PAU",
		"municipi": "El Prat de Llobregat",
		"codi_municipi": "81691",
		"latitud": "41.32140538",
		"longitud": "2.0975214",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Jardins de la Pau",
		"informacio_web": "https://www.elprat.cat/ciutat-i-territori/emergencia-climatica/refugis-climatics",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-jbjd_7ksm-w9sx",
		":version": "rv-h49e~thrc_3b9h",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Fondo d’en Peixo",
		"indicador_refugi": "81691|FONDO_D_EN_PEIXO",
		"municipi": "El Prat de Llobregat",
		"codi_municipi": "81691",
		"latitud": "41.32805431",
		"longitud": "2.090605896",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "C. Penedès, s/n",
		"informacio_web": "https://www.elprat.cat/ciutat-i-territori/emergencia-climatica/refugis-climatics",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-esps.fhtx_urtk",
		":version": "rv-yhtt-fjjs-2yx2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça de Louis Braille",
		"indicador_refugi": "81691|PLACA_DE_LOUIS_BRAILLE",
		"municipi": "El Prat de Llobregat",
		"codi_municipi": "81691",
		"latitud": "41.32551218",
		"longitud": "2.103046453",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Pl. Louis Braille",
		"informacio_web": "https://www.elprat.cat/ciutat-i-territori/emergencia-climatica/refugis-climatics",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-qfkh_73mu_gd33",
		":version": "rv-47p8-vw4e~e8jv",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Espai Dioptra",
		"indicador_refugi": "82824|ESPAI_DIOPTRA",
		"municipi": "Tiana",
		"codi_municipi": "82824",
		"latitud": "41.4832183",
		"longitud": "2.271692001",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "C. Cals Frares, 29",
		"informacio_web": "https://tiana.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-zjj7-xadx.mg5u",
		":version": "rv-sqne.hve6-7n22",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "CEM Bonaigua",
		"indicador_refugi": "82212|CEM_BONAIGUA",
		"municipi": "Sant Just Desvern",
		"codi_municipi": "82212",
		"latitud": "41.39051965",
		"longitud": "2.075394362",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"adreca": "Pg.Muntanya, 25",
		"informacio_web": "https://santjust.cat/",
		"tipologia": "Equipament esportiu",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-dpa5~87tx-7f6g",
		":version": "rv-4nzt~7s2w_mwpw",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Can Comamala",
		"indicador_refugi": "82634|CAN_COMAMALA",
		"municipi": "Sant Vicenç dels Horts",
		"codi_municipi": "82634",
		"latitud": "41.39624767",
		"longitud": "2.008082188",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "C. Mossèn Jacint Verdaguer, 105-113",
		"informacio_web": "https://svh.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-248k~3zmg-9ffk",
		":version": "rv-52ur-rkyk_rebg",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Moli dels Frares",
		"indicador_refugi": "82634|MOLI_DELS_FRARES",
		"municipi": "Sant Vicenç dels Horts",
		"codi_municipi": "82634",
		"latitud": "41.40332415",
		"longitud": "2.000896801",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "C. C, 1",
		"informacio_web": "https://svh.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-22pu_bgmw-fias",
		":version": "rv-dvct_jhzc.ak2f",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça Lluís Companys",
		"indicador_refugi": "80543|PLACA_LLUIS_COMPANYS",
		"municipi": "Castellbisbal",
		"codi_municipi": "80543",
		"latitud": "41.47826781",
		"longitud": "1.982101689",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Pl. Lluís Companys",
		"informacio_web": "https://www.castellbisbal.cat/",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-8mgk~a3xj-svpy",
		":version": "rv-6x3y_pvad~v3gx",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Neus Català- Parc de les Destreses (A, B,C)",
		"indicador_refugi": "80543|PARC_NEUS_CATALA_PARC_DE_LES_DESTRESES_A_B_C",
		"municipi": "Castellbisbal",
		"codi_municipi": "80543",
		"latitud": "41.4723498",
		"longitud": "1.984591636",
		"accessibilitat": "Si, Si, Si",
		"adreca": "C. Àngel Guimerà - C. Països Catalans, 38",
		"informacio_web": "https://www.castellbisbal.cat/",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-4z72~53jr.bvf7",
		":version": "rv-6axa~u6fn-vy8p",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de la Gent Gran",
		"indicador_refugi": "80543|CASAL_DE_LA_GENT_GRAN",
		"municipi": "Castellbisbal",
		"codi_municipi": "80543",
		"latitud": "41.47476114",
		"longitud": "1.981026917",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "C. Sant Joan, 2",
		"informacio_web": "https://www.castellbisbal.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-fv5b_shb9~s7yn",
		":version": "rv-h5uw_e593.bj7t",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca",
		"indicador_refugi": "80543|BIBLIOTECA",
		"municipi": "Castellbisbal",
		"codi_municipi": "80543",
		"latitud": "41.47482656",
		"longitud": "1.982561825",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"climatitzacio": "SI",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "Av. Pau Casals, 16",
		"informacio_web": "https://www.castellbisbal.cat/",
		"tipologia": "Biblioteca",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-yiem-tcef-85fy",
		":version": "rv-ujyd~n2nv_dsg3",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de Barri de Sant Ildefons",
		"indicador_refugi": "80734|CASAL_DE_BARRI_DE_SANT_ILDEFONS",
		"municipi": "Cornellà de Llobregat",
		"codi_municipi": "80734",
		"latitud": "41.36644686",
		"longitud": "2.082839826",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "C Marià Cubí, 111",
		"informacio_web": "https://www.cornella.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-friy~ean9~y2cn",
		":version": "rv-pxn3.d7f9.gdwj",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina Municipal",
		"indicador_refugi": "81580|PISCINA_MUNICIPAL",
		"municipi": "El Papiol",
		"codi_municipi": "81580",
		"latitud": "41.43698655",
		"longitud": "2.015304137",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer d'en Pau Casals, s/n",
		"informacio_web": "https://www.elpapiol.cat/",
		"tipologia": "Piscina",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-caam~qtnd-nwwb",
		":version": "rv-awjm~ibkf-7rm7",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Edifici Ajuntament",
		"indicador_refugi": "81580|EDIFICI_AJUNTAMENT",
		"municipi": "El Papiol",
		"codi_municipi": "81580",
		"latitud": "41.43798745",
		"longitud": "2.011031487",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Avinguda de la Generalitat de Catalunya, 7-9",
		"informacio_web": "https://www.elpapiol.cat/",
		"tipologia": "ajuntament",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-vpyc.uqzq~wrwd",
		":version": "rv-sfca~z37n~7fvi",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Valentí Almirall",
		"indicador_refugi": "81580|BIBLIOTECA_VALENTI_ALMIRALL",
		"municipi": "El Papiol",
		"codi_municipi": "81580",
		"latitud": "41.44045091",
		"longitud": "2.012501393",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Passatge Parellada, 1",
		"informacio_web": "https://www.elpapiol.cat/",
		"tipologia": "Biblioteca",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-kceh.8baj_8cpr",
		":version": "rv-ns59-dgdm~msnc",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina Municipal de l'Escorxador",
		"indicador_refugi": "82114|PISCINA_MUNICIPAL_DE_L_ESCORXADOR",
		"municipi": "Sant Feliu de Llobregat",
		"codi_municipi": "82114",
		"latitud": "41.37862365",
		"longitud": "2.040380748",
		"accessibilitat": "SÍ",
		"adreca": "Carrer Ramon y Cajal, 49",
		"informacio_web": "https://www.santfeliu.cat/go.faces?xmid=1",
		"tipologia": "Piscina",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-mppy-2rqk-x4kh",
		":version": "rv-p8iw.wavk.fbtv",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Cívic Les Planes",
		"indicador_refugi": "82172|CENTRE_CIVIC_LES_PLANES",
		"municipi": "Sant Joan Despí",
		"codi_municipi": "82172",
		"latitud": "41.36863407",
		"longitud": "2.074936864",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "C. de John F.Kennedy, 4,",
		"informacio_web": "https://sjdespi.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-rrgf-ik8v-bgki",
		":version": "rv-siw2.9vu2_dara",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de Can Sostres",
		"indicador_refugi": "82896|PARC_DE_CAN_SOSTRES",
		"municipi": "Torrelles de Llobregat",
		"codi_municipi": "82896",
		"latitud": "41.35674595",
		"longitud": "1.982306314",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. Papa Joan XXIII, 4",
		"informacio_web": "https://www.torrelles.cat/",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-vjcb.hpyb.8tdc",
		":version": "rv-ddzh-zzfb_hbvk",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Municipal",
		"indicador_refugi": "89058|BIBLIOTECA_MUNICIPAL",
		"municipi": "La Palma de Cervelló",
		"codi_municipi": "89058",
		"latitud": "41.41325404",
		"longitud": "1.965644392",
		"adreca": "Pl. Cervantes, 4",
		"informacio_web": "https://www.lapalmadecervello.cat/",
		"tipologia": "Biblioteca",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-9eyw.k22d.j893",
		":version": "rv-2uz4~zpah~wngk",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Espigol",
		"indicador_refugi": "89058|PARC_ESPIGOL",
		"municipi": "La Palma de Cervelló",
		"codi_municipi": "89058",
		"latitud": "41.41419538",
		"longitud": "1.966631439",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C.Joan XXIII, 2",
		"informacio_web": "https://www.lapalmadecervello.cat/",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-a2me-28mp~cmhn",
		":version": "rv-mim4.b4cz.3v2e",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc l'Olivera",
		"indicador_refugi": "89058|PARC_L_OLIVERA",
		"municipi": "La Palma de Cervelló",
		"codi_municipi": "89058",
		"latitud": "41.41311736",
		"longitud": "1.969369897",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "C. del Canigó, 9",
		"informacio_web": "https://www.lapalmadecervello.cat/",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-3ydd_bbfx.bjms",
		":version": "rv-fjnj.28dk_45nv",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Complex aquàtic i esportiu Can Mercader (piscina )",
		"indicador_refugi": "80734|COMPLEX_AQUATIC_I_ESPORTIU_CAN_MERCADER_PISCINA",
		"municipi": "Cornellà de Llobregat",
		"codi_municipi": "80734",
		"latitud": "41.35861457",
		"longitud": "2.086550248",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "Crta de L'Hospitalet s/n",
		"informacio_web": "https://www.cornella.cat/",
		"tipologia": "Piscina",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-v9eh_d48m-yemv",
		":version": "rv-djmf.z22f~tdsw",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Esportiu Llobregat (piscina)",
		"indicador_refugi": "80734|PARC_ESPORTIU_LLOBREGAT_PISCINA",
		"municipi": "Cornellà de Llobregat",
		"codi_municipi": "80734",
		"latitud": "41.34796404",
		"longitud": "2.071809891",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "Av. Baix Llobregat, s/n",
		"informacio_web": "https://www.cornella.cat/",
		"tipologia": "Piscina",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-zaxv-br4k.rw26",
		":version": "rv-skic-754t.eg4u",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina Millars (piscina)",
		"indicador_refugi": "80734|PISCINA_MILLARS_PISCINA",
		"municipi": "Cornellà de Llobregat",
		"codi_municipi": "80734",
		"latitud": "41.35609563",
		"longitud": "2.076707258",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "C. Bonavista, 70",
		"informacio_web": "https://www.cornella.cat/",
		"tipologia": "Piscina",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-hgzk~dz22-3c3x",
		":version": "rv-kh3a_r3et_wdhq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de Torreblanca",
		"indicador_refugi": "82212|PARC_DE_TORREBLANCA",
		"municipi": "Sant Just Desvern",
		"codi_municipi": "82212",
		"latitud": "41.37803008",
		"longitud": "2.056170778",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Ctra. Reial, 159",
		"informacio_web": "https://refugisclimatics.amb.cat",
		"tipologia": "Parc AMB",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-7km4~m6d7_icx7",
		":version": "rv-9p7c-yrtc-n7tk",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc del Tramvia",
		"indicador_refugi": "82824|PARC_DEL_TRAMVIA",
		"municipi": "Tiana",
		"codi_municipi": "82824",
		"latitud": "41.47110416",
		"longitud": "2.275618429",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Av. Jordana, 92",
		"informacio_web": "https://refugisclimatics.amb.cat",
		"tipologia": "Parc AMB",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ivkz.pfsp~2tgi",
		":version": "rv-vutc.uigk~dg39",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Cívic Roses",
		"indicador_refugi": "82114|CENTRE_CIVIC_ROSES",
		"municipi": "Sant Feliu de Llobregat",
		"codi_municipi": "82114",
		"latitud": "41.38355267",
		"longitud": "2.053332702",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "C. Tibidabo, 18-20",
		"informacio_web": "https://www.santfeliu.cat/go.faces?xmid=1",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-g9rq.28xj_cjgw",
		":version": "rv-yg2k_6yb7.6hea",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de la Gent Gran",
		"indicador_refugi": "82114|CASAL_DE_LA_GENT_GRAN",
		"municipi": "Sant Feliu de Llobregat",
		"codi_municipi": "82114",
		"latitud": "41.38164796",
		"longitud": "2.048548013",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"climatitzacio": "SÍ",
		"area_descans": "Sí",
		"lavabo": "SÍ",
		"adreca": "C. Pi i Margall, 45",
		"informacio_web": "https://www.santfeliu.cat/go.faces?xmid=1",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-twnd~tmx4.sac7",
		":version": "rv-fgqk_y87g-abvh",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina Municipal Tiana",
		"indicador_refugi": "82824|PISCINA_MUNICIPAL_TIANA",
		"municipi": "Tiana",
		"codi_municipi": "82824",
		"latitud": "41.49125929",
		"longitud": "2.261242404",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "C. Eduard Fontseré, s/n.",
		"informacio_web": "https://tiana.cat/",
		"tipologia": "Piscina",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ubg9_zkb6.6mnt",
		":version": "rv-jxz4.xb9f-mm2y",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jardins de les Moreres",
		"indicador_refugi": "81017|JARDINS_DE_LES_MORERES",
		"municipi": "L'Hospitalet de Llobregat",
		"codi_municipi": "81017",
		"latitud": "41.36731976",
		"longitud": "2.08953765",
		"accessibilitat": "Si",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Carrer de l'Estronci, 36",
		"informacio_web": "https://www.l-h.cat/",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ux3i_kjrg~sedz",
		":version": "rv-ejb4_4js2.y257",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça dels Cirerers",
		"indicador_refugi": "81017|PLACA_DELS_CIRERERS",
		"municipi": "L'Hospitalet de Llobregat",
		"codi_municipi": "81017",
		"latitud": "41.36520246",
		"longitud": "2.089733667",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Pl. dels Cirerers",
		"informacio_web": "https://www.l-h.cat/",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-jn4e~qrkm.wkuf",
		":version": "rv-tg46-ni9i.pi4g",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça de la Carpa",
		"indicador_refugi": "81017|PLACA_DE_LA_CARPA",
		"municipi": "L'Hospitalet de Llobregat",
		"codi_municipi": "81017",
		"latitud": "41.36667794",
		"longitud": "2.100032855",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Pl. de la Carpa",
		"informacio_web": "https://www.l-h.cat/",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ehp9_s5nz.syqh",
		":version": "rv-kmx7.prxr~9rn3",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de Can Creixells",
		"indicador_refugi": "81017|PARC_DE_CAN_CREIXELLS",
		"municipi": "L'Hospitalet de Llobregat",
		"codi_municipi": "81017",
		"latitud": "41.36364153",
		"longitud": "2.103555487",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Riera del Canyet, 43 08906",
		"informacio_web": "https://www.l-h.cat/",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-9d2w~v37k~w5rx",
		":version": "rv-avz7.zcbi_qm7c",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de la Serp",
		"indicador_refugi": "81017|PARC_DE_LA_SERP",
		"municipi": "L'Hospitalet de Llobregat",
		"codi_municipi": "81017",
		"latitud": "41.36188009",
		"longitud": "2.10892334",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Carrer de Segòvia, 2, 08901",
		"informacio_web": "https://www.l-h.cat/",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-4f4x~bt54.v4me",
		":version": "rv-kk27~mqgx_ruan",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça de Lluís Companys",
		"indicador_refugi": "81017|PLACA_DE_LLUIS_COMPANYS",
		"municipi": "L'Hospitalet de Llobregat",
		"codi_municipi": "81017",
		"latitud": "41.35959021",
		"longitud": "2.103071996",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Pl. de Lluís Companys, 08901",
		"informacio_web": "https://www.l-h.cat/",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-wzjb.dau7.d6eu",
		":version": "rv-5rnr.qyam~fz5z",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jardins de Can Sumarro",
		"indicador_refugi": "81017|JARDINS_DE_CAN_SUMARRO",
		"municipi": "L'Hospitalet de Llobregat",
		"codi_municipi": "81017",
		"latitud": "41.36035504",
		"longitud": "2.096453173",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Carrer de Barcelona, 2, 08901 L'Hospitalet de Llobregat",
		"informacio_web": "https://www.l-h.cat/",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-aqkw~mmts-n6i9",
		":version": "rv-xrx2-23ft.mr4b",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de la Marquesa",
		"indicador_refugi": "81017|PARC_DE_LA_MARQUESA",
		"municipi": "L'Hospitalet de Llobregat",
		"codi_municipi": "81017",
		"latitud": "41.37518897",
		"longitud": "2.117540622",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Carrer de la Riera Blanca, 08903 L'Hospitalet de Llobregat",
		"informacio_web": "https://www.l-h.cat/",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-bj5v_nvgx-djk2",
		":version": "rv-jcvn-42ix~nu6n",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça d'Ernest Lluch",
		"indicador_refugi": "81017|PLACA_D_ERNEST_LLUCH",
		"municipi": "L'Hospitalet de Llobregat",
		"codi_municipi": "81017",
		"latitud": "41.37535285",
		"longitud": "2.113555618",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Avinguda de la Granvia de l’Hospitalet, 08902 L'Hospitalet de Llobregat",
		"informacio_web": "https://www.l-h.cat/",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ngba-wec8.n5jp",
		":version": "rv-2k4e~6v94_6zpn",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jardins de Tecla Sala",
		"indicador_refugi": "81017|JARDINS_DE_TECLA_SALA",
		"municipi": "L'Hospitalet de Llobregat",
		"codi_municipi": "81017",
		"latitud": "41.36648517",
		"longitud": "2.116104756",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Avinguda de Josep Tarradellas i Joan, 44, 08901 L'Hospitalet de Llobregat",
		"informacio_web": "https://www.l-h.cat/",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-mua7-8g27_twje",
		":version": "rv-3wqd~s6gz_ep5t",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de la Cabana",
		"indicador_refugi": "81017|PARC_DE_LA_CABANA",
		"municipi": "L'Hospitalet de Llobregat",
		"codi_municipi": "81017",
		"latitud": "41.36520666",
		"longitud": "2.1148697",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Carrer d'Enric Prat de la Riba, 2, 08901 L'Hospitalet de Llobregat",
		"informacio_web": "https://www.l-h.cat/",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-243m.nrms-26vt",
		":version": "rv-c82y.3a9h-dbzw",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça de Milagros Consarnau i Sabaté",
		"indicador_refugi": "81017|PLACA_DE_MILAGROS_CONSARNAU_I_SABATE",
		"municipi": "L'Hospitalet de Llobregat",
		"codi_municipi": "81017",
		"latitud": "41.36552235",
		"longitud": "2.129642499",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Carrer de l'Aprestadora, 08902 L'Hospitalet de Llobregat",
		"informacio_web": "https://www.l-h.cat/",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-rwz5_fje5_ie3y",
		":version": "rv-h2sg_2k4z~9fc6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Avinguda de Carmen Amaya",
		"indicador_refugi": "81017|AVINGUDA_DE_CARMEN_AMAYA",
		"municipi": "L'Hospitalet de Llobregat",
		"codi_municipi": "81017",
		"latitud": "41.35589422",
		"longitud": "2.117571901",
		"accessibilitat": "Si",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Avinguda de Carmen Amaya, 08902 L'Hospitalet de Llobregat",
		"informacio_web": "https://www.l-h.cat/",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-u35v.vvuj~vrwv",
		":version": "rv-vr9z.5s2i~ny42",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Passeig de Bellvitge",
		"indicador_refugi": "81017|PASSEIG_DE_BELLVITGE",
		"municipi": "L'Hospitalet de Llobregat",
		"codi_municipi": "81017",
		"latitud": "41.35391857",
		"longitud": "2.112557768",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Passeig de Bellvitge, 08907 L'Hospitalet de Llobregat",
		"informacio_web": "https://www.l-h.cat/",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-uerq~9ujs.dn2f",
		":version": "rv-6xhw~jcju_auph",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Rambla de Marina",
		"indicador_refugi": "81017|RAMBLA_DE_MARINA",
		"municipi": "L'Hospitalet de Llobregat",
		"codi_municipi": "81017",
		"latitud": "41.35133022",
		"longitud": "2.110815534",
		"accessibilitat": "Si",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Rambla de la Marina, 08907 L'Hospitalet de Llobregat",
		"informacio_web": "https://www.l-h.cat/",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-cgap-sxz9_j6zs",
		":version": "rv-skij~bsaq.9dpp",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de Bellvitge",
		"indicador_refugi": "81017|PARC_DE_BELLVITGE",
		"municipi": "L'Hospitalet de Llobregat",
		"codi_municipi": "81017",
		"latitud": "41.34868353",
		"longitud": "2.111057279",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Rambla de la Marina, 08907 L'Hospitalet de Llobregat",
		"informacio_web": "https://www.l-h.cat/",
		"tipologia": "Parc AMB",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ynjx_gqq4_si3n",
		":version": "rv-83cb_en62.x4wq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Nou Casal de Gent Gran de Sant Josep",
		"indicador_refugi": "81017|NOU_CASAL_DE_GENT_GRAN_DE_SANT_JOSEP",
		"municipi": "L'Hospitalet de Llobregat",
		"codi_municipi": "81017",
		"latitud": "41.36093626",
		"longitud": "2.10750808",
		"accessibilitat": "Si",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "C. Migdia, 12 (cantonada amb c. Castillejos) (08901)",
		"informacio_web": "https://www.l-h.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-nubz.yq84.jrzw",
		":version": "rv-sca7_6m8b_743n",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre de Transformació Digital de l’Hospitalet «La Florida 6.0\"",
		"indicador_refugi": "81017|CENTRE_DE_TRANSFORMACIO_DIGITAL_DE_L_HOSPITALET_LA_FLORIDA_6_0",
		"municipi": "L'Hospitalet de Llobregat",
		"codi_municipi": "81017",
		"latitud": "41.37051876",
		"longitud": "2.108255976",
		"accessibilitat": "Si",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "Av. Primavera, 71, 2n pis (08905)",
		"informacio_web": "https://www.l-h.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-neiv_2iju-wuiw",
		":version": "rv-jgty~ajgx.h4qu",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Oficina Jove de L’Hospitalet",
		"indicador_refugi": "81017|OFICINA_JOVE_DE_L_HOSPITALET",
		"municipi": "L'Hospitalet de Llobregat",
		"codi_municipi": "81017",
		"latitud": "41.34858243",
		"longitud": "2.11005915",
		"accessibilitat": "Si",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "c. Ermita de Bellvitge, 40 (08907)",
		"informacio_web": "https://www.l-h.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-2njm_6a5c-f5ex",
		":version": "rv-jpex_qpsa_f8zx",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Municipal de Gent Gran de Can Serra",
		"indicador_refugi": "81017|CASAL_MUNICIPAL_DE_GENT_GRAN_DE_CAN_SERRA",
		"municipi": "L'Hospitalet de Llobregat",
		"codi_municipi": "81017",
		"latitud": "41.36743182",
		"longitud": "2.10080697",
		"accessibilitat": "Si",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "c. Castellbó, 45 (08906)",
		"informacio_web": "https://www.l-h.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-eky7-4yyr.2nb2",
		":version": "rv-baqe-nep8.2fhj",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Municipal de Gent Gran de Santa Eulàlia",
		"indicador_refugi": "81017|CASAL_MUNICIPAL_DE_GENT_GRAN_DE_SANTA_EULALIA",
		"municipi": "L'Hospitalet de Llobregat",
		"codi_municipi": "81017",
		"latitud": "41.3660246",
		"longitud": "2.126267441",
		"accessibilitat": "Si",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "Pl. dels Avis, 12 (08902)",
		"informacio_web": "https://www.l-h.cat/",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-czh4-tc2g.5bps",
		":version": "rv-xqxw_vycs-ez7e",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre d’Art Metropolità Tecla Sala",
		"indicador_refugi": "81017|CENTRE_D_ART_METROPOLITA_TECLA_SALA",
		"municipi": "L'Hospitalet de Llobregat",
		"codi_municipi": "81017",
		"latitud": "41.36712205",
		"longitud": "2.11640923",
		"accessibilitat": "Si",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "Av. Josep Tarradellas i Joan, 44 (08901)",
		"informacio_web": "https://www.l-h.cat/",
		"tipologia": "Museus",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-darb~zatk-9vda",
		":version": "rv-yykw-ct8q-a9nq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca de Bellvitge",
		"indicador_refugi": "81017|BIBLIOTECA_DE_BELLVITGE",
		"municipi": "L'Hospitalet de Llobregat",
		"codi_municipi": "81017",
		"latitud": "41.35136856",
		"longitud": "2.11425106",
		"accessibilitat": "Si",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "Pl. de la Cultura, 1 (08907)",
		"informacio_web": "https://www.l-h.cat/",
		"tipologia": "Biblioteca",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-rv35~2i9x-ncki",
		":version": "rv-wqf9_vbxf~i2x7",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca de Can Sumarro",
		"indicador_refugi": "81017|BIBLIOTECA_DE_CAN_SUMARRO",
		"municipi": "L'Hospitalet de Llobregat",
		"codi_municipi": "81017",
		"latitud": "41.35976824",
		"longitud": "2.096243921",
		"accessibilitat": "Si",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "c. Riera de l’Escorxador, 2 (08901)",
		"informacio_web": "https://www.l-h.cat/",
		"tipologia": "Biblioteca",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ni2m-v3z8.5bb2",
		":version": "rv-xdeq-db5j.tx6h",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Josep Janés",
		"indicador_refugi": "81017|BIBLIOTECA_JOSEP_JANES",
		"municipi": "L'Hospitalet de Llobregat",
		"codi_municipi": "81017",
		"latitud": "41.37455898",
		"longitud": "2.12155649",
		"accessibilitat": "Si",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "c. Dr. Martí i Julià, 33 (08904)",
		"informacio_web": "https://www.l-h.cat/",
		"tipologia": "Biblioteca",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-tjxu.qxsq~qkig",
		":version": "rv-4j9r~u5xe_r28p",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca de La Bòbila",
		"indicador_refugi": "81017|BIBLIOTECA_DE_LA_BOBILA",
		"municipi": "L'Hospitalet de Llobregat",
		"codi_municipi": "81017",
		"latitud": "41.37288568",
		"longitud": "2.101042168",
		"accessibilitat": "Si",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "Pl. de La Bòbila, 1 (08906)",
		"informacio_web": "https://www.l-h.cat/",
		"tipologia": "Biblioteca",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-is5c~d4p8-vhnc",
		":version": "rv-6mqx-5m7n-gqfp",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca de La Florida",
		"indicador_refugi": "81017|BIBLIOTECA_DE_LA_FLORIDA",
		"municipi": "L'Hospitalet de Llobregat",
		"codi_municipi": "81017",
		"latitud": "41.3696471",
		"longitud": "2.10738257",
		"accessibilitat": "Si",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "Av. Masnou, 40 (08905)",
		"informacio_web": "https://www.l-h.cat/",
		"tipologia": "Biblioteca",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ts8r.ji3k_p4sk",
		":version": "rv-yrgp_ztm2-swc2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca de la Plaça Europa",
		"indicador_refugi": "81017|BIBLIOTECA_DE_LA_PLACA_EUROPA",
		"municipi": "L'Hospitalet de Llobregat",
		"codi_municipi": "81017",
		"latitud": "41.35956334",
		"longitud": "2.12288191",
		"accessibilitat": "Si",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "Av. Amadeu Torner, 57 (08902)",
		"informacio_web": "https://www.l-h.cat/",
		"tipologia": "Biblioteca",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-2r5d_qh92_u2qh",
		":version": "rv-b7jx-8d3w_y2rn",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bibliomercat de Santa Eulàlia",
		"indicador_refugi": "81017|BIBLIOMERCAT_DE_SANTA_EULALIA",
		"municipi": "L'Hospitalet de Llobregat",
		"codi_municipi": "81017",
		"latitud": "41.36586073",
		"longitud": "2.1272105",
		"accessibilitat": "Si",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "c. Muns, 2 - parades del mercat (08902)",
		"informacio_web": "https://www.l-h.cat/",
		"tipologia": "Biblioteca",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-4m8b_3ddn.y7xj",
		":version": "rv-mxe7-ym4m~c9u5",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Comercial Màgic Badalona",
		"indicador_refugi": "80155|CENTRE_COMERCIAL_MAGIC_BADALONA",
		"municipi": "Badalona",
		"codi_municipi": "80155",
		"latitud": "41.44436819",
		"longitud": "2.23161754",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "Carrer de la Concòrdia, 1,   08917",
		"informacio_web": "https://www.badalona.cat/",
		"tipologia": "Privat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-fsda~dfg7~9yy2",
		":version": "rv-pehg.3jbg_7bdb",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Comercial Montigalà",
		"indicador_refugi": "80155|CENTRE_COMERCIAL_MONTIGALA",
		"municipi": "Badalona",
		"codi_municipi": "80155",
		"latitud": "41.45567932",
		"longitud": "2.226992045",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "Pg d'Olof Palme, 36, 08917",
		"informacio_web": "https://www.badalona.cat/",
		"tipologia": "Privat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-y95a~nfrt~a7cg",
		":version": "rv-8cb8-4bug_4rjj",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Fundació Ana Ribot",
		"indicador_refugi": "81574|FUNDACIO_ANA_RIBOT",
		"municipi": "Pallejà",
		"codi_municipi": "81574",
		"latitud": "41.42123015",
		"longitud": "1.99870209",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "Carrer Vallès i Ribot, 2, 08780",
		"informacio_web": "www.palleja.cat",
		"tipologia": "Privat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-439t-5q4h_z47r",
		":version": "rv-ji2w~nx97_p7nf",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça Europa",
		"indicador_refugi": "83015|PLACA_EUROPA",
		"municipi": "Viladecans",
		"codi_municipi": "83015",
		"latitud": "41.31608034",
		"longitud": "2.021774032",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Carrer de Jaume Balmes, 1B, 08840 Viladecans",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-3jzu-csdj-jdvq",
		":version": "rv-ngrc~i76b~rxfz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Rambla Modolell",
		"indicador_refugi": "83015|RAMBLA_MODOLELL",
		"municipi": "Viladecans",
		"codi_municipi": "83015",
		"latitud": "41.31788092",
		"longitud": "2.019840069",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Rambla de Modolell, 08840 Viladecans",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-n3xq_x2xd_qz83",
		":version": "rv-cvsp_jqty.ay8w",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Jardins de Magdalena Modolell",
		"indicador_refugi": "83015|JARDINS_DE_MAGDALENA_MODOLELL",
		"municipi": "Viladecans",
		"codi_municipi": "83015",
		"latitud": "41.31623455",
		"longitud": "2.019291974",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Carrer del Sol, 2, 08840 Viladecans",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ffym~dkz7~8a48",
		":version": "rv-cmb5-9n92~mwve",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça Tete Montoliu",
		"indicador_refugi": "83015|PLACA_TETE_MONTOLIU",
		"municipi": "Viladecans",
		"codi_municipi": "83015",
		"latitud": "41.31037014",
		"longitud": "2.012204249",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Avinguda de Gavà, 58, 08840 Viladecans",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-hfi4.55a7_y6gk",
		":version": "rv-y5w4_63q2_dhkw",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de Can Guardiola",
		"indicador_refugi": "83015|PARC_DE_CAN_GUARDIOLA",
		"municipi": "Viladecans",
		"codi_municipi": "83015",
		"latitud": "41.31259587",
		"longitud": "1.998628994",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Carrer de Can Tries, 15, 08840 Viladecans",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-2yjm.9dqk.angr",
		":version": "rv-2tv8_apxp_d8ra",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bosc de Can Ginestar",
		"indicador_refugi": "83015|BOSC_DE_CAN_GINESTAR",
		"municipi": "Viladecans",
		"codi_municipi": "83015",
		"latitud": "41.32358838",
		"longitud": "2.012349218",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Carrer del Salze / carrer del Roure, 08840 Viladecans",
		"informacio_web": "https://www.viladecans.cat/es/bosque-de-can-ginestar",
		"tipologia": "Parc AMB",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-8tds.zepi_f3ev",
		":version": "rv-fzbp-h8k9~gbq2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Piscina Podium Viladecans - Joan Masgrau",
		"indicador_refugi": "83015|PISCINA_PODIUM_VILADECANS_JOAN_MASGRAU",
		"municipi": "Viladecans",
		"codi_municipi": "83015",
		"latitud": "41.3206735",
		"longitud": "2.022766022",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"lavabo": "Si",
		"adreca": "Carrer de Pompeu Fabra, 5, 08840 Viladecans",
		"informacio_web": "Podium | Atrium + Podium | Viladecans Esports",
		"tipologia": "Piscina",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-eu7m_4kfp.zcs9",
		":version": "rv-f9e2.8red~ywkg",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Ateneu d'entitats Pablo Picasso",
		"indicador_refugi": "83015|ATENEU_D_ENTITATS_PABLO_PICASSO",
		"municipi": "Viladecans",
		"codi_municipi": "83015",
		"latitud": "41.32002376",
		"longitud": "2.01760431",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "Passatge de Sant Ramon, 2, 08840 Viladecans",
		"informacio_web": "Ateneu d’Entitats Pablo Picasso | Ajuntament de Viladecans",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ysrz.z7tr_tt6x",
		":version": "rv-zyyc~czgs-ntvp",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de barri La Unión",
		"indicador_refugi": "83015|CASAL_DE_BARRI_LA_UNION",
		"municipi": "Viladecans",
		"codi_municipi": "83015",
		"latitud": "41.31783924",
		"longitud": "2.012282399",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "Carrer del Dos de Maig, 41, 08840 Viladecans",
		"informacio_web": "Casal de Barri la Unión | Ajuntament de Viladecans",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-hzdp~x5hu.pmm7",
		":version": "rv-64xv.uf9s-zykh",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca de Viladecans",
		"indicador_refugi": "83015|BIBLIOTECA_DE_VILADECANS",
		"municipi": "Viladecans",
		"codi_municipi": "83015",
		"latitud": "41.31465487",
		"longitud": "2.014458108",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "Avinguda Josep Tarradellas i Joan, 16, 08840 Viladecans",
		"informacio_web": "Viladecans. Biblioteca de Viladecans - Biblioteca Virtual",
		"tipologia": "Biblioteca",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-rtr6_ii46_3fjw",
		":version": "rv-jf78~jvk3~v9yg",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de la Timba",
		"indicador_refugi": "80689|PARC_DE_LA_TIMBA",
		"municipi": "Cervelló",
		"codi_municipi": "80689",
		"latitud": "41.39425892",
		"longitud": "1.960091442",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Carrer de la Pau, 13, 08758 Cervelló",
		"informacio_web": "Parc de la Timba - Territori - Àrea Metropolitana de Barcelona",
		"tipologia": "Parc AMB",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-skeb_zppg-yk87",
		":version": "rv-4546.5bw7_in6m",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de la gent gran Josep Tarradellas",
		"indicador_refugi": "80689|CASAL_DE_LA_GENT_GRAN_JOSEP_TARRADELLAS",
		"municipi": "Cervelló",
		"codi_municipi": "80689",
		"latitud": "41.39613696",
		"longitud": "1.95654444",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "Carrer Major, 85, 08758 Cervelló",
		"informacio_web": "Casal de Gent Gran Josep Tarradellas - Ajuntament de Cervelló",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-k5g7-w6u3.mndr",
		":version": "rv-vinf.9wzx.s67g",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Municipal",
		"indicador_refugi": "80689|BIBLIOTECA_MUNICIPAL",
		"municipi": "Cervelló",
		"codi_municipi": "80689",
		"latitud": "41.39601158",
		"longitud": "1.957653148",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "Plaça de la Biblioteca , 1 - 08758 Cervelló",
		"informacio_web": "Biblioteca Municipal - Ajuntament de Cervelló",
		"tipologia": "Biblioteca",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-asik~5a3e_qxib",
		":version": "rv-aahm-y8q4_2t4u",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc del Mil·leni",
		"indicador_refugi": "80898|PARC_DEL_MIL_LENI",
		"municipi": "Gavà",
		"codi_municipi": "80898",
		"latitud": "41.30266294",
		"longitud": "1.995024174",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Avinguda de les Bòbiles, 1, 08850 Gavà",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-pirn-hmvc~rjsq",
		":version": "rv-s8zm_9ajs.6rcu",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc dels Creixents",
		"indicador_refugi": "80898|PARC_DELS_CREIXENTS",
		"municipi": "Gavà",
		"codi_municipi": "80898",
		"latitud": "41.30533986",
		"longitud": "1.993565365",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Avinguda de Joan Carles I amb carrer de Santa Teresa",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-gqrq.92ak_vqgt",
		":version": "rv-59tg-6k99.rq9k",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Torre Lluc",
		"indicador_refugi": "80898|PARC_TORRE_LLUC",
		"municipi": "Gavà",
		"codi_municipi": "80898",
		"latitud": "41.30658193",
		"longitud": "2.005194154",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Carrer de Salvador Lluch, 27, 08850 Gavà",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-7vq7.jzyn.292e",
		":version": "rv-mu4c~4tic.kyh8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça de les Panes",
		"indicador_refugi": "80898|PLACA_DE_LES_PANES",
		"municipi": "Gavà",
		"codi_municipi": "80898",
		"latitud": "41.30001208",
		"longitud": "2.003293533",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Plaça de les Panes",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-8ruc-q2yz.wzdq",
		":version": "rv-dxmk.wnzm_6sv7",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc del Calamot",
		"indicador_refugi": "80898|PARC_DEL_CALAMOT",
		"municipi": "Gavà",
		"codi_municipi": "80898",
		"latitud": "41.29897841",
		"longitud": "2.000359245",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Avinguda de Joan Carles I, s/n, 08850 Gavà",
		"informacio_web": "Parc del Calamot - Territori - Àrea Metropolitana de Barcelona",
		"tipologia": "Parc AMB",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-p2ru_bkh7~dpmf",
		":version": "rv-cbhs~kbmb_ndcm",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Rambla",
		"indicador_refugi": "80898|RAMBLA",
		"municipi": "Gavà",
		"codi_municipi": "80898",
		"latitud": "41.30544302",
		"longitud": "2.007411542",
		"accessibilitat": "Si",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Rambla de Maria Casas i Rambla de Joaquim Vayreda",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-qzyh~tjpw.ks6q",
		":version": "rv-xxn8~rawu~yc26",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Marian Colomé",
		"indicador_refugi": "80898|BIBLIOTECA_MARIAN_COLOME",
		"municipi": "Gavà",
		"codi_municipi": "80898",
		"latitud": "41.30961521",
		"longitud": "2.000046642",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "Carrer de Jaume I, 5 bis, 08850 Gavà",
		"informacio_web": "Gavà. Biblioteca Marian Colomé - Biblioteca Virtual",
		"tipologia": "Biblioteca",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-wwj7.jqpy.syz5",
		":version": "rv-bqkx~kn92-cgw6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca Josep Soler i Vidal",
		"indicador_refugi": "80898|BIBLIOTECA_JOSEP_SOLER_I_VIDAL",
		"municipi": "Gavà",
		"codi_municipi": "80898",
		"latitud": "41.30364555",
		"longitud": "1.998562826",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "Plaça de Jaume Balmes, s/n",
		"informacio_web": "Gavà-Biblioteca Josep Soler Vidal - Biblioteca Virtual",
		"tipologia": "Biblioteca",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-c4x8_8fs8.5yfr",
		":version": "rv-vbps~qhsd.bqqi",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de la gent gran Can Tintorer",
		"indicador_refugi": "80898|CASAL_DE_LA_GENT_GRAN_CAN_TINTORER",
		"municipi": "Gavà",
		"codi_municipi": "80898",
		"latitud": "41.31084881",
		"longitud": "1.993773377",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "Camí de Can Tries, s/n",
		"informacio_web": "Casal Municipal de la Gent Gran Can Tintorer - Gavà",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-wge6.y3v3.cxa8",
		":version": "rv-kdec_sey9_i9bw",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de la gent gran Torre Lluc",
		"indicador_refugi": "80898|CASAL_DE_LA_GENT_GRAN_TORRE_LLUC",
		"municipi": "Gavà",
		"codi_municipi": "80898",
		"latitud": "41.30606616",
		"longitud": "2.00576373",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "Carrer Centre, 3",
		"informacio_web": "Casal Municipal de la Gent Gran Torre Lluc - Gavà",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-d8zx_tmsy~f84h",
		":version": "rv-a89p~hqx3-wgth",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Espai jove La Casa Gran",
		"indicador_refugi": "80898|ESPAI_JOVE_LA_CASA_GRAN",
		"municipi": "Gavà",
		"codi_municipi": "80898",
		"latitud": "41.30489656",
		"longitud": "2.00549561",
		"accessibilitat": "Si",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Carrer Major, 37, 08850 Gavà",
		"informacio_web": "Espai Jove de La Casa Gran - Gavà",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-75uj_req9~wijy",
		":version": "rv-586k.saes_tfdi",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de Cultura",
		"indicador_refugi": "82520|CASAL_DE_CULTURA",
		"municipi": "Barberà del Vallès",
		"codi_municipi": "82520",
		"latitud": "41.51691867",
		"longitud": "2.128907886",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "Carrer Nemesi Valls, 35, 08210 Barberà del Vallès",
		"informacio_web": "Casal de Cultura | Ayuntamiento de Barberá del Vallés",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-8428-emrg~73y8",
		":version": "rv-tcfq-78g9-gyhw",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Centre Comercial Baricentro",
		"indicador_refugi": "82520|CENTRE_COMERCIAL_BARICENTRO",
		"municipi": "Barberà del Vallès",
		"codi_municipi": "82520",
		"latitud": "41.50777337",
		"longitud": "2.138088088",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "N-150, km 6, 7, 08210 Barberà del Vallès",
		"informacio_web": "Actualidad Baricentro « Baricentro.es",
		"tipologia": "Privat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-yrw9.px8v~va69",
		":version": "rv-ggci_6bsm~xe6s",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal l'Olivera",
		"indicador_refugi": "82009|CASAL_L_OLIVERA",
		"municipi": "Sant Boi de Llobregat",
		"codi_municipi": "82009",
		"latitud": "41.3514158",
		"longitud": "2.029375466",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "Plaça de Montserrat Roig, 1, 08830 Sant Boi de Llobregat",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-uzrj-rgq4_5ssy",
		":version": "rv-szwq.6cec_xmhn",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de barri de la Ciutat Cooperativa",
		"indicador_refugi": "82009|CASAL_DE_BARRI_DE_LA_CIUTAT_COOPERATIVA",
		"municipi": "Sant Boi de Llobregat",
		"codi_municipi": "82009",
		"latitud": "41.35697073",
		"longitud": "2.029812067",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "Carrer Pau Casals, 7, 08830 Sant Boi de Llobregat",
		"informacio_web": "Casal Ciutat Cooperativa-Molí Nou | Ajuntament de Sant Boi de Llobregat",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-269a.7stc-y8i9",
		":version": "rv-vgz8_cyjb.rw5q",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal de barri la Gralla",
		"indicador_refugi": "82009|CASAL_DE_BARRI_LA_GRALLA",
		"municipi": "Sant Boi de Llobregat",
		"codi_municipi": "82009",
		"latitud": "41.33318056",
		"longitud": "2.038057591",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "Plaça dels Gegants, 1, 08830 Sant Boi de Llobregat",
		"informacio_web": "La Gralla | Ajuntament de Sant Boi de Llobregat",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-d67x.9amm.bhf2",
		":version": "rv-3te8~gsnu-yubb",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Sala d'actes de Ca N'Ametller",
		"indicador_refugi": "81234|SALA_D_ACTES_DE_CA_N_AMETLLER",
		"municipi": "Molins de Rei",
		"codi_municipi": "81234",
		"latitud": "41.4140362",
		"longitud": "2.016360812",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "Carrer Jacint Verdaguer, 95 bis, Molins de Rei",
		"informacio_web": "Sala d’exposicions de Ca’n Ametller - Ajuntament de Molins de Rei",
		"tipologia": "Ajuntament",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-uav5_sgz4~cigg",
		":version": "rv-43n3.pjru-y92m",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Molí Jove - Aula d'estudi",
		"indicador_refugi": "81234|MOLI_JOVE_AULA_D_ESTUDI",
		"municipi": "Molins de Rei",
		"codi_municipi": "81234",
		"latitud": "41.41332854",
		"longitud": "2.014713008",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "Plaça de l'U d'Octubre de 2017, 5, Molins deRei",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-aupk-ee42~iizf",
		":version": "rv-rgz3.c4xp.ecek",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Biblioteca el Molí",
		"indicador_refugi": "81234|BIBLIOTECA_EL_MOLI",
		"municipi": "Molins de Rei",
		"codi_municipi": "81234",
		"latitud": "41.41286902",
		"longitud": "2.014673412",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "Plaça de l'U d'Octubre de 2017, 2, 08750 Molins de Rei",
		"tipologia": "Biblioteca",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-iicm.a7ib-g64a",
		":version": "rv-jez8.u4ty~j3w9",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal d'avis Primer de Maig",
		"indicador_refugi": "81234|CASAL_D_AVIS_PRIMER_DE_MAIG",
		"municipi": "Molins de Rei",
		"codi_municipi": "81234",
		"latitud": "41.40678905",
		"longitud": "2.020098486",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "Carrer Felip Canalies, s/n, Molins de Rei",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-hmdy_wisq_ah6m",
		":version": "rv-ehgq~pdba~9vce",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Oficina d'atenció ciutadana",
		"indicador_refugi": "81234|OFICINA_D_ATENCIO_CIUTADANA",
		"municipi": "Molins de Rei",
		"codi_municipi": "81234",
		"latitud": "41.41204285",
		"longitud": "2.01636173",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "Si",
		"adreca": "Carrer Rubió i Ors, 2-4, Molins deRei",
		"tipologia": "Ajuntament",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-mgp7-wf4e-e6bx",
		":version": "rv-k6j6~tspb_nzhy",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça de l'Estatut",
		"indicador_refugi": "82172|PLACA_DE_L_ESTATUT",
		"municipi": "Sant Joan Despí",
		"codi_municipi": "82172",
		"latitud": "41.37277067",
		"longitud": "2.069935031",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Plaça de l'Estatut, 1, 08970 Sant Joan Despí",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-5yya_8grc-6kb7",
		":version": "rv-ymui~6gxd-u2v9",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Plaça del Batiport",
		"indicador_refugi": "82172|PLACA_DEL_BATIPORT",
		"municipi": "Sant Joan Despí",
		"codi_municipi": "82172",
		"latitud": "41.36360689",
		"longitud": "2.0576165",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Plaça del Batiport, Sant Joan Despí",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-nj8i-ig44-w26z",
		":version": "rv-y9a8-ahft~w9ap",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc del Patufet",
		"indicador_refugi": "82042|PARC_DEL_PATUFET",
		"municipi": "Sant Climent de Llobregat",
		"codi_municipi": "82042",
		"latitud": "41.33874605",
		"longitud": "1.994501608",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"climatitzacio": "Si",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Carrer de les Comes, 08849 Sant Climent de Llobregat",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-c55q_bm5t_m7tb",
		":version": "rv-7tbb_p8xd_hay5",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bosc del Blanc",
		"indicador_refugi": "81580|BOSC_DEL_BLANC",
		"municipi": "El Papiol",
		"codi_municipi": "81580",
		"latitud": "41.43736359",
		"longitud": "2.005924078",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Carrer de Sant Jordi, 5, 08754 El Papiol",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-kw8k.ssvn-9a5d",
		":version": "rv-cq6u-wb3r-bm7c",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Mestre Voltes",
		"indicador_refugi": "81580|PARC_MESTRE_VOLTES",
		"municipi": "El Papiol",
		"codi_municipi": "81580",
		"latitud": "41.43744743",
		"longitud": "2.008173911",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"area_descans": "Sí",
		"lavabo": "No",
		"adreca": "Carrer d'Anselm Clavé, 14, 08754 El Papiol",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-tv3j~d8ie-3se8",
		":version": "rv-kwb5_yqpn.tjif",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de la Bastida",
		"indicador_refugi": "82457|PARC_DE_LA_BASTIDA",
		"municipi": "Santa Coloma de Gramenet",
		"codi_municipi": "82457",
		"latitud": "41.45803074",
		"longitud": "2.215239114",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Carrer de Santa Eulàlia, 83, 08921 Santa Coloma de Gramenet",
		"tipologia": "Parc AMB",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-gq7x.s2hj~c88r",
		":version": "rv-a7ae.dda4-djvq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de Joan Oliver",
		"indicador_refugi": "89045|PARC_DE_JOAN_OLIVER",
		"municipi": "Badia del Vallès",
		"codi_municipi": "89045",
		"latitud": "41.50729314",
		"longitud": "2.116012638",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Carrer de la Manxa, 13, 08214 Badia del Vallès",
		"tipologia": "Parc AMB",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-y4h8_cqcq~yrk4",
		":version": "rv-4wvt_tg6a_xycv",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de Can Lluc",
		"indicador_refugi": "82444|PARC_DE_CAN_LLUC",
		"municipi": "Santa Coloma de Cervelló",
		"codi_municipi": "82444",
		"latitud": "41.36942275",
		"longitud": "2.017446355",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Avinguda Can Lluch, 19, 08690 Santa Coloma de Cervelló",
		"tipologia": "Parc AMB",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-dz98_mnjs~m7j6",
		":version": "rv-am93~chwb_4q6b",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc del Mil·lenari",
		"indicador_refugi": "82212|PARC_DEL_MIL_LENARI",
		"municipi": "Sant Just Desvern",
		"codi_municipi": "82212",
		"latitud": "41.38364765",
		"longitud": "2.078739977",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Passatge del Mercat, s/n, 08960 Sant Just Desvern",
		"tipologia": "Parc AMB",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-h5jp.f6jw~e4ig",
		":version": "rv-7zak~i42r-gnai",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc de Torreblanca",
		"indicador_refugi": "82212|PARC_DE_TORREBLANCA",
		"municipi": "Sant Feliu de Llobregat",
		"codi_municipi": "82212",
		"latitud": "41.37803008",
		"longitud": "2.056170778",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Ctra. Reial, 159",
		"informacio_web": "https://refugisclimatics.amb.cat",
		"tipologia": "Parc AMB",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-e486.4wkw-ithp",
		":version": "rv-e8p3_dy7d.m2gd",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc d'Oriol Martorell",
		"indicador_refugi": "8180|PARC_D_ORIOL_MARTORELL",
		"municipi": "Ripollet",
		"codi_municipi": "8180",
		"latitud": "41.50422083",
		"longitud": "2.155038867",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Carrer Barberà del Vallès, 7",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-bahp-uszm.rvqd",
		":version": "rv-3jb4.b2ru~4y3h",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Parc Gassó Vargas",
		"indicador_refugi": "8180|PARC_GASSO_VARGAS",
		"municipi": "Ripollet",
		"codi_municipi": "8180",
		"latitud": "41.50299956",
		"longitud": "2.159400826",
		"accessibilitat": "Si",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Rambla dels Pinetons, 6",
		"tipologia": "Parc",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-5bjp-tcmn~ch8u",
		":version": "rv-9re6-fbcg~ngwk",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Bosc del Pinetons",
		"indicador_refugi": "8180|BOSC_DEL_PINETONS",
		"municipi": "Ripollet",
		"codi_municipi": "8180",
		"latitud": "41.50629042",
		"longitud": "2.16014409",
		"accessibilitat": "SÍ",
		"aigua": "Sí",
		"area_descans": "Sí",
		"adreca": "Avinguda del Mediterrani",
		"informacio_web": "https://refugisclimatics.amb.cat",
		"tipologia": "Parc AMB",
		"origen_identificador": "AMB",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-mi5i-754t_9y99",
		":version": "rv-qtix.pce2-4t2d",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Les Franqueses",
		"indicador_refugi": "080863|CASAL_CIVIC_I_COMUNITARI_LES_FRANQUESES",
		"municipi": "Les Franqueses del Vallès",
		"codi_municipi": "080863",
		"latitud": "41.6277108300567",
		"longitud": "2.29569241963774",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Avinguda Santa Eulàlia, 7",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "Drets Socials i Inclusió",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-fkyz~66b8_gt79",
		":version": "rv-iw4v-dt2q~8wwp",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal Cívic i Comunitari Rubí (Magallanes)",
		"indicador_refugi": "081846|CASAL_CIVIC_I_COMUNITARI_RUBI_MAGALLANES",
		"municipi": "Rubí",
		"codi_municipi": "081846",
		"latitud": "41.4899006129316",
		"longitud": "2.03566668721835",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer Magallanes, 60",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "Drets Socials i Inclusió",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-mpmn-rskq.pw79",
		":version": "rv-izh2~kr4x_n2zk",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal per a Gent Gran Baix Camp",
		"indicador_refugi": "430385|CASAL_PER_A_GENT_GRAN_BAIX_CAMP",
		"municipi": "Cambrils",
		"codi_municipi": "430385",
		"latitud": "41.069809636619",
		"longitud": "1.0577873650102",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer de Beltran de Cambrils, 2",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "Drets Socials i Inclusió",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-y4sv_n8qt-dpvu",
		":version": "rv-7a6c_29eb.knyx",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal per a Gent Gran Cerdanyola",
		"indicador_refugi": "082665|CASAL_PER_A_GENT_GRAN_CERDANYOLA",
		"municipi": "Cerdanyola del Vallès",
		"codi_municipi": "082665",
		"latitud": "41.484506341916",
		"longitud": "2.14492012594745",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Avinguda de Lesseps, 4",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "Drets Socials i Inclusió",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-fpu9~rz9d-wgpg",
		":version": "rv-wvb2.pmau-4k35",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal per a Gent Gran Font dels Capellans",
		"indicador_refugi": "081136|CASAL_PER_A_GENT_GRAN_FONT_DELS_CAPELLANS",
		"municipi": "Manresa",
		"codi_municipi": "081136",
		"latitud": "41.7309045372673",
		"longitud": "1.84045074063855",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer de la Font dels Capellans, 85",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "Drets Socials i Inclusió",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-jhtv~up7t_tq9x",
		":version": "rv-cbhj.bezi-exyc",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal per a Gent Gran Gràcia",
		"indicador_refugi": "080193|CASAL_PER_A_GENT_GRAN_GRACIA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.4013120345978",
		"longitud": "2.16000181560553",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer de Siracusa, 23",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "Drets Socials i Inclusió",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-pu2e_9hmh_wm6x",
		":version": "rv-xuxw-pexv_ppsz",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal per a Gent Gran Horta",
		"indicador_refugi": "080193|CASAL_PER_A_GENT_GRAN_HORTA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.4255240215088",
		"longitud": "2.15110703519081",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer de Josep Sangenís, 75",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "Drets Socials i Inclusió",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-s2jp-bz37-epnk",
		":version": "rv-jyn9.yez8-zz74",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal per a Gent Gran Jaume Nualart",
		"indicador_refugi": "080734|CASAL_PER_A_GENT_GRAN_JAUME_NUALART",
		"municipi": "Cornellà de Llobregat",
		"codi_municipi": "080734",
		"latitud": "41.358116536816",
		"longitud": "2.07766894242841",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer de l'Anoia, 8",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "Drets Socials i Inclusió",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-pips.9ei3.ras5",
		":version": "rv-zrwj-w8be.n7dr",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal per a Gent Gran La Trinitat Nova",
		"indicador_refugi": "080193|CASAL_PER_A_GENT_GRAN_LA_TRINITAT_NOVA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.4477977316648",
		"longitud": "2.18501302309001",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer de la Fosca, 4-8",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "Drets Socials i Inclusió",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-x7gm~eyf6_ijcj",
		":version": "rv-rzzf_urkg~ccg2",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal per a Gent Gran La Verneda",
		"indicador_refugi": "080193|CASAL_PER_A_GENT_GRAN_LA_VERNEDA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.420634563908",
		"longitud": "2.2008423440761",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer de Cantàbria, 28",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "Drets Socials i Inclusió",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-wws9_2cud-epvy",
		":version": "rv-n86u~pjvb.7thc",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal per a Gent Gran Les Corts",
		"indicador_refugi": "080193|CASAL_PER_A_GENT_GRAN_LES_CORTS",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.3879889442702",
		"longitud": "2.13911922111008",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer del Montnegre, 33",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "Drets Socials i Inclusió",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-a3a7~c6by.nwwf",
		":version": "rv-dh6p.9myd.uymq",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal per a Gent Gran Rubí (Lepant)",
		"indicador_refugi": "081846|CASAL_PER_A_GENT_GRAN_RUBI_LEPANT",
		"municipi": "Rubí",
		"codi_municipi": "081846",
		"latitud": "41.4992970060081",
		"longitud": "2.03493781574718",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer de Lepant, 31",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "Drets Socials i Inclusió",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ww23.aqee.gurx",
		":version": "rv-c28d.7p8k_5yxd",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Casal per a Gent Gran Sant Cugat del Vallès",
		"indicador_refugi": "082055|CASAL_PER_A_GENT_GRAN_SANT_CUGAT_DEL_VALLES",
		"municipi": "Sant Cugat del Vallès",
		"codi_municipi": "082055",
		"latitud": "41.4754742472575",
		"longitud": "2.0877422269997",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "Sí",
		"lavabo": "Sí",
		"adreca": "Carrer de Santa Rosa, 1",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "Drets Socials i Inclusió",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-83qy_xt88_y7v2",
		":version": "rv-9x3t~erv3.gzzp",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Residència per a Gent Gran Alchemika",
		"indicador_refugi": "080193|RESIDENCIA_PER_A_GENT_GRAN_ALCHEMIKA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.4161052208985",
		"longitud": "2.18110772594472",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "Sí",
		"adreca": "Carrer de Sant Antoni Maria Claret, 356-360",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "Drets Socials i Inclusió",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-836h_ht29_p4xw",
		":version": "rv-w3wk_dc5w-tccf",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Residència per a Gent Gran Balàfia I",
		"indicador_refugi": "251207|RESIDENCIA_PER_A_GENT_GRAN_BALAFIA_I",
		"municipi": "Lleida",
		"codi_municipi": "251207",
		"latitud": "41.6304599594668",
		"longitud": "0.625596554625549",
		"accessibilitat": "No",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "Sí",
		"adreca": "Carrer de José Olondriz Ostiz, 6",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "Drets Socials i Inclusió",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-f8gy~fmnc_ynyz",
		":version": "rv-qq5d.46wq_w6zr",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Residència per a Gent Gran Balàfia II",
		"indicador_refugi": "251207|RESIDENCIA_PER_A_GENT_GRAN_BALAFIA_II",
		"municipi": "Lleida",
		"codi_municipi": "251207",
		"latitud": "41.6294684398987",
		"longitud": "0.627302898580056",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "Sí",
		"adreca": "Carrer de Vic, 10",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "Drets Socials i Inclusió",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ds5d_tkqu.r6kk",
		":version": "rv-mx9y.z4ju_r95g",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Residència per a Gent Gran Bertran i Oriola",
		"indicador_refugi": "080193|RESIDENCIA_PER_A_GENT_GRAN_BERTRAN_I_ORIOLA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.3816770984348",
		"longitud": "2.18743609491257",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "Sí",
		"adreca": "Carrer de Carbonell, 4",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "Drets Socials i Inclusió",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-8y6h.bu23.bg2z",
		":version": "rv-9g9q.4biu~765k",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Residència per a Gent Gran Bon Pastor",
		"indicador_refugi": "080193|RESIDENCIA_PER_A_GENT_GRAN_BON_PASTOR",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.4389960638927",
		"longitud": "2.20233178523522",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "Sí",
		"adreca": "Carrer d'Augusto Cèsar Sandino, 7-9",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "Drets Socials i Inclusió",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-msum-vn6u~4dbe",
		":version": "rv-8gg7_emz9_bmix",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Residència per a Gent Gran Campdevànol",
		"indicador_refugi": "170366|RESIDENCIA_PER_A_GENT_GRAN_CAMPDEVANOL",
		"municipi": "Campdevànol",
		"codi_municipi": "170366",
		"latitud": "42.2235799356",
		"longitud": "2.1629462768413",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "Sí",
		"adreca": "Passeig Cortaló, 5",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "Drets Socials i Inclusió",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-53fx~ijqz~4j8f",
		":version": "rv-agi5-akht~piaa",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Residència per a Gent Gran Can Falguera",
		"indicador_refugi": "082114|RESIDENCIA_PER_A_GENT_GRAN_CAN_FALGUERA",
		"municipi": "Sant Feliu de Llobregat",
		"codi_municipi": "082114",
		"latitud": "41.3818126135733",
		"longitud": "2.0397741573056",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "Sí",
		"adreca": "Carrer de Jaume Ribas, 26-28",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "Drets Socials i Inclusió",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-gb52~wvv4_5kvw",
		":version": "rv-7wzy-bdxa-wsce",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Residència per a Gent Gran Comtes d'Urgell",
		"indicador_refugi": "250404|RESIDENCIA_PER_A_GENT_GRAN_COMTES_D_URGELL",
		"municipi": "Balaguer",
		"codi_municipi": "250404",
		"latitud": "41.7915057953778",
		"longitud": "0.817578282529475",
		"accessibilitat": "No",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "Sí",
		"adreca": "Carrer Sant Diego Califòrnia, 16-42",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "Drets Socials i Inclusió",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-nwth-jdbu~s26b",
		":version": "rv-4tdy.iu4s~999u",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Residència per a Gent Gran Conca de Barberà",
		"indicador_refugi": "430862|RESIDENCIA_PER_A_GENT_GRAN_CONCA_DE_BARBERA",
		"municipi": "Montblanc",
		"codi_municipi": "430862",
		"latitud": "41.3728346692586",
		"longitud": "1.1560406655878",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "Sí",
		"adreca": "Avinguda Manel Ribe, 46-48",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "Drets Socials i Inclusió",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-hkss~agxj~q4u4",
		":version": "rv-fqi4_xxkz.bjgx",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Residència per a Gent Gran Creu de Palau",
		"indicador_refugi": "170792|RESIDENCIA_PER_A_GENT_GRAN_CREU_DE_PALAU",
		"municipi": "Girona",
		"codi_municipi": "170792",
		"latitud": "41.9587078782874",
		"longitud": "2.8230715205192",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "Sí",
		"adreca": "Carrer Jocs Olímpics de Barcelona, 2",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "Drets Socials i Inclusió",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-fbfq_6yr8.x263",
		":version": "rv-6q4u~sphb-7eh9",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Residència per a Gent Gran El Mil·lenari",
		"indicador_refugi": "080193|RESIDENCIA_PER_A_GENT_GRAN_EL_MIL_LENARI",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.3771927474049",
		"longitud": "2.17255644587789",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "Sí",
		"adreca": "Carrer Nou de la Rambla, 47-49",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "Drets Socials i Inclusió",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-rb65~6k9v.sge3",
		":version": "rv-jv4v~b2uj_3ken",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Residència per a Gent Gran Els Arcs",
		"indicador_refugi": "170669|RESIDENCIA_PER_A_GENT_GRAN_ELS_ARCS",
		"municipi": "Figueres",
		"codi_municipi": "170669",
		"latitud": "42.2662506073456",
		"longitud": "2.94575007487455",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "Sí",
		"adreca": "Carrer d'Avinyonet, s/n",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "Drets Socials i Inclusió",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-645a.pece_iwvc",
		":version": "rv-chcw~bnhs.b94q",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Residència per a Gent Gran Feixa Llarga Laia González",
		"indicador_refugi": "081017|RESIDENCIA_PER_A_GENT_GRAN_FEIXA_LLARGA_LAIA_GONZALEZ",
		"municipi": "l'Hospitalet de Llobregat",
		"codi_municipi": "081017",
		"latitud": "41.3471645966786",
		"longitud": "2.10510578616733",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "Sí",
		"adreca": "Carrer de la Residencia, 14",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "Drets Socials i Inclusió",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-n6hc-tsd8.zvqw",
		":version": "rv-uu7w-bwac~pp6h",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Residència per a Gent Gran Font Florida",
		"indicador_refugi": "080193|RESIDENCIA_PER_A_GENT_GRAN_FONT_FLORIDA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.3676642559979",
		"longitud": "2.14171233143055",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "Sí",
		"adreca": "Carrer de la Font Florida, 98",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "Drets Socials i Inclusió",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-xja5_77ct~66uw",
		":version": "rv-ciqi~84x8~uvhw",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Residència per a Gent Gran Francisco Padilla",
		"indicador_refugi": "081017|RESIDENCIA_PER_A_GENT_GRAN_FRANCISCO_PADILLA",
		"municipi": "l'Hospitalet de Llobregat",
		"codi_municipi": "081017",
		"latitud": "41.3684634892621",
		"longitud": "2.10003026566586",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "Sí",
		"adreca": "Avinguda Electricitat, 35-43",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "Drets Socials i Inclusió",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-gtzj-s3nk-rd4b",
		":version": "rv-v64v_vv8a~y8j6",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Residència per a Gent Gran Gandesa",
		"indicador_refugi": "430640|RESIDENCIA_PER_A_GENT_GRAN_GANDESA",
		"municipi": "Gandesa",
		"codi_municipi": "430640",
		"latitud": "41.0512221132116",
		"longitud": "0.435442475162976",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "Sí",
		"adreca": "Carretera de Bot, 3",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "Drets Socials i Inclusió",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-jfs5_uu6i.nvj9",
		":version": "rv-9ghs-zgy3~eyu7",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Residència per a Gent Gran Gavà",
		"indicador_refugi": "080898|RESIDENCIA_PER_A_GENT_GRAN_GAVA",
		"municipi": "Gavà",
		"codi_municipi": "080898",
		"latitud": "41.3074893396193",
		"longitud": "2.00576236633656",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "Sí",
		"adreca": "Carrer de la Concòrdia, 24",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "Drets Socials i Inclusió",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-722y~axgs~2z6f",
		":version": "rv-pfbr~fa9e~ytej",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Residència per a Gent Gran Jaume Batlle",
		"indicador_refugi": "080193|RESIDENCIA_PER_A_GENT_GRAN_JAUME_BATLLE",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.3990338005161",
		"longitud": "2.20600472291919",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "Sí",
		"adreca": "Carrer de Fernando Poo, 45",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "Drets Socials i Inclusió",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-w9gc~f7ix-85wd",
		":version": "rv-uepd.tjk3.vsaa",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Residència per a Gent Gran Jaume I",
		"indicador_refugi": "430542|RESIDENCIA_PER_A_GENT_GRAN_JAUME_I",
		"municipi": "l'Espluga de Francolí",
		"codi_municipi": "430542",
		"latitud": "41.3951746592508",
		"longitud": "1.10375522466311",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "Sí",
		"adreca": "Carrer de Sant Vicenç de Paül, 20",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "Drets Socials i Inclusió",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-q335_buaa~77y6",
		":version": "rv-nru8.3g6n_a5bv",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Residència per a Gent Gran La Mercè",
		"indicador_refugi": "431482|RESIDENCIA_PER_A_GENT_GRAN_LA_MERCE",
		"municipi": "Tarragona",
		"codi_municipi": "431482",
		"latitud": "41.1180702932831",
		"longitud": "1.26208101454686",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "Sí",
		"adreca": "Camí de la Cuixa, 1B",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "Drets Socials i Inclusió",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-vgbx-yi23.ix3n",
		":version": "rv-kw6m.45qt_xnhw",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Residència per a Gent Gran La Sagrera",
		"indicador_refugi": "080193|RESIDENCIA_PER_A_GENT_GRAN_LA_SAGRERA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.4263852814859",
		"longitud": "2.19189366145783",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "Sí",
		"adreca": "Carrer de Berenguer de Palou, 102",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "Drets Socials i Inclusió",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-duk8-ijmr~ti24",
		":version": "rv-8s6b~n82h_7v66",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Residència per a Gent Gran La Sénia",
		"indicador_refugi": "430445|RESIDENCIA_PER_A_GENT_GRAN_LA_SENIA",
		"municipi": "la Sénia",
		"codi_municipi": "430445",
		"latitud": "40.6360532644159",
		"longitud": "0.27835174221843",
		"accessibilitat": "No",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "Sí",
		"adreca": "Carrer de Jaume I, 44",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "Drets Socials i Inclusió",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-tyht_s5yy~rnjy",
		":version": "rv-xb6s_fwi8.2bpk",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Residència per a Gent Gran L'Alta Ribagorça",
		"indicador_refugi": "251734|RESIDENCIA_PER_A_GENT_GRAN_L_ALTA_RIBAGORCA",
		"municipi": "el Pont de Suert",
		"codi_municipi": "251734",
		"latitud": "42.4059994884546",
		"longitud": "0.740468462764732",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "Sí",
		"adreca": "Carrer del Salencar, s/n",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "Drets Socials i Inclusió",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ue72-yxih.98zz",
		":version": "rv-i3bn~a8jn.hjpj",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Residència per a Gent Gran L'Ametlla",
		"indicador_refugi": "080057|RESIDENCIA_PER_A_GENT_GRAN_L_AMETLLA",
		"municipi": "l'Ametlla del Vallès",
		"codi_municipi": "080057",
		"latitud": "41.6567215228114",
		"longitud": "2.27445788362685",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "Sí",
		"adreca": "Carretera de Llerona, s/n (Finca Can Focs)",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "Drets Socials i Inclusió",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-cmzv~fqe8~2s58",
		":version": "rv-9vkx_b6g8_9pjb",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Residència per a Gent Gran Les Escoles Velles",
		"indicador_refugi": "430607|RESIDENCIA_PER_A_GENT_GRAN_LES_ESCOLES_VELLES",
		"municipi": "Flix",
		"codi_municipi": "430607",
		"latitud": "41.2285641215396",
		"longitud": "0.546840365448485",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "Sí",
		"adreca": "Carrer Escoles, 39",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "Drets Socials i Inclusió",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ut6i~2ui7-enys",
		":version": "rv-w7f7~xjis-fjmy",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Residència per a Gent Gran Mataró",
		"indicador_refugi": "081213|RESIDENCIA_PER_A_GENT_GRAN_MATARO",
		"municipi": "Mataró",
		"codi_municipi": "081213",
		"latitud": "41.5371094723841",
		"longitud": "2.42913544140014",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "Sí",
		"adreca": "Avinguda de la Gatassa, 43",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "Drets Socials i Inclusió",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-jmas-7ubw~9vmd",
		":version": "rv-n89z_3ffv-btkf",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Residència per a Gent Gran Mercat de Guinardó",
		"indicador_refugi": "080193|RESIDENCIA_PER_A_GENT_GRAN_MERCAT_DE_GUINARDO",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.419569699027",
		"longitud": "2.17813086345402",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "Sí",
		"adreca": "Carrer de l'Oblit, 29",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "Drets Socials i Inclusió",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-e7kz-2uek-5dpb",
		":version": "rv-cyyy_5qdk~93ys",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Residència per a Gent Gran Molí - Via Favència",
		"indicador_refugi": "080193|RESIDENCIA_PER_A_GENT_GRAN_MOLI_VIA_FAVENCIA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.4459346558448",
		"longitud": "2.18137958339877",
		"accessibilitat": "No",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "Sí",
		"adreca": "Carrer del Molí, 67",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "Drets Socials i Inclusió",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ygvw-w8cx_5c7g",
		":version": "rv-ghis.dmu7.t4bt",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Residència per a Gent Gran Móra la Nova",
		"indicador_refugi": "430944|RESIDENCIA_PER_A_GENT_GRAN_MORA_LA_NOVA",
		"municipi": "Móra la Nova",
		"codi_municipi": "430944",
		"latitud": "41.1063794844637",
		"longitud": "0.652202536565901",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "Sí",
		"adreca": "Camí de l'Estació, 2",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "Drets Socials i Inclusió",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-jsyv_967r~gbat",
		":version": "rv-b3c3_4j2x_tnuf",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Residència per a Gent Gran Mossèn Vidal i Aunós",
		"indicador_refugi": "080193|RESIDENCIA_PER_A_GENT_GRAN_MOSSEN_VIDAL_I_AUNOS",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.37057794182",
		"longitud": "2.14029142924946",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "Sí",
		"adreca": "Carrer de Navarra, 12-28",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "Drets Socials i Inclusió",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ut7f-abhm-hhqa",
		":version": "rv-j8rq.mpkz~44fd",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Residència per a Gent Gran Natzaret",
		"indicador_refugi": "430939|RESIDENCIA_PER_A_GENT_GRAN_NATZARET",
		"municipi": "Móra d'Ebre",
		"codi_municipi": "430939",
		"latitud": "41.0850115726277",
		"longitud": "0.633329336904647",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "Sí",
		"adreca": "Carrer de Maria del Miracle Descarrega, 8 (Ap. Co. 25)",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "Drets Socials i Inclusió",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-udr8.by2t_nzic",
		":version": "rv-zy5s.r7qu_4xz8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Residència per a Gent Gran Onze de Setembre",
		"indicador_refugi": "081691|RESIDENCIA_PER_A_GENT_GRAN_ONZE_DE_SETEMBRE",
		"municipi": "el Prat de Llobregat",
		"codi_municipi": "081691",
		"latitud": "41.3203908549538",
		"longitud": "2.09768609745728",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "Sí",
		"adreca": "Avinguda Onze de Setembre, 81-83",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "Drets Socials i Inclusió",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-zgth_5fuu.2udw",
		":version": "rv-m29p_rb4a.c98v",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Residència per a Gent Gran Parc Serentill",
		"indicador_refugi": "080155|RESIDENCIA_PER_A_GENT_GRAN_PARC_SERENTILL",
		"municipi": "Badalona",
		"codi_municipi": "080155",
		"latitud": "41.4582665163626",
		"longitud": "2.24438191260511",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "Sí",
		"adreca": "Molí de la Torre, 62-75",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "Drets Socials i Inclusió",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-pa5g.ffuw~2nud",
		":version": "rv-jfwr~e5mg_utc4",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Residència per a Gent Gran Pare Batllori",
		"indicador_refugi": "080193|RESIDENCIA_PER_A_GENT_GRAN_PARE_BATLLORI",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.3732998390039",
		"longitud": "2.17162599165644",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "Sí",
		"adreca": "Carrer de Vila i Vilà, 39-41",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "Drets Socials i Inclusió",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-3i2g_24bf_n82s",
		":version": "rv-pa5s_xug5.m8wp",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Residència per a Gent Gran Poblenou",
		"indicador_refugi": "080193|RESIDENCIA_PER_A_GENT_GRAN_POBLENOU",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.4070694041723",
		"longitud": "2.21033270295255",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "Sí",
		"adreca": "Carrer de Llull, 328-332",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "Drets Socials i Inclusió",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-uypp~k4gv-9ivj",
		":version": "rv-ipzi~9u9f_gqfg",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Residència per a Gent Gran Porta",
		"indicador_refugi": "080193|RESIDENCIA_PER_A_GENT_GRAN_PORTA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.4325617741437",
		"longitud": "2.17622096083214",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "Sí",
		"adreca": "Carrer de la Maladeta, 30",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "Drets Socials i Inclusió",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-8d27-77w2-9hha",
		":version": "rv-kzqn-xsam_h6jk",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Residència per a Gent Gran Puig d'en Roca",
		"indicador_refugi": "170792|RESIDENCIA_PER_A_GENT_GRAN_PUIG_D_EN_ROCA",
		"municipi": "Girona",
		"codi_municipi": "170792",
		"latitud": "41.995251111007",
		"longitud": "2.81301768132973",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "Sí",
		"adreca": "Carrer d'Antoni Varés i Martinell, 37",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "Drets Socials i Inclusió",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-ywx7_7abp-dn92",
		":version": "rv-yimn.2wij_kbvw",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Residència per a Gent Gran Roger de Llúria",
		"indicador_refugi": "431233|RESIDENCIA_PER_A_GENT_GRAN_ROGER_DE_LLURIA",
		"municipi": "Reus",
		"codi_municipi": "431233",
		"latitud": "41.1581870382499",
		"longitud": "1.08891996519314",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "Sí",
		"adreca": "Carrer de Roger de Llúria, 2B-8",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "Drets Socials i Inclusió",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-64x6~wqf4-3ida",
		":version": "rv-jy5n_2qhz~it8r",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Residència per a Gent Gran Sant Bartomeu",
		"indicador_refugi": "250501|RESIDENCIA_PER_A_GENT_GRAN_SANT_BARTOMEU",
		"municipi": "Bellpuig",
		"codi_municipi": "250501",
		"latitud": "41.6203687922862",
		"longitud": "1.00884513624857",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "Sí",
		"adreca": "Carretera de Belianes, s/n",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "Drets Socials i Inclusió",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-tw6m.nv6z_zpk3",
		":version": "rv-f6b2_znzp~iw9f",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Residència per a Gent Gran Sant Josep",
		"indicador_refugi": "251207|RESIDENCIA_PER_A_GENT_GRAN_SANT_JOSEP",
		"municipi": "Lleida",
		"codi_municipi": "251207",
		"latitud": "41.6143438190187",
		"longitud": "0.611866854257835",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "Sí",
		"adreca": "Carrer de la Mercè, 10-12",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "Drets Socials i Inclusió",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-tgfr.n8mu_htcz",
		":version": "rv-wxsk~kt78_vb99",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Residència per a Gent Gran Sant Llorenç Savall",
		"indicador_refugi": "082233|RESIDENCIA_PER_A_GENT_GRAN_SANT_LLORENC_SAVALL",
		"municipi": "Sant Llorenç Savall",
		"codi_municipi": "082233",
		"latitud": "41.6724394779298",
		"longitud": "2.05402919929709",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "Sí",
		"adreca": "Carretera de Sabadell, km 18.5",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "Drets Socials i Inclusió",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-8hmw.gbdg_cqf7",
		":version": "rv-tgx7.xwc3-hz4f",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Residència per a Gent Gran Sant Pere Claver",
		"indicador_refugi": "252424|RESIDENCIA_PER_A_GENT_GRAN_SANT_PERE_CLAVER",
		"municipi": "Verdú",
		"codi_municipi": "252424",
		"latitud": "41.6082170948633",
		"longitud": "1.14658383200245",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "Sí",
		"adreca": "Carrer Molí de Vent, 2",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "Drets Socials i Inclusió",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-gszt-g9z8.whs4",
		":version": "rv-3kvp~vu3f.n5uc",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Residència per a Gent Gran Sant Roc",
		"indicador_refugi": "080155|RESIDENCIA_PER_A_GENT_GRAN_SANT_ROC",
		"municipi": "Badalona",
		"codi_municipi": "080155",
		"latitud": "41.4356846939835",
		"longitud": "2.22528050163319",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "Sí",
		"adreca": "Avinguda del Maresme, 182-190",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "Drets Socials i Inclusió",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-f99k-xxfu-mm6t",
		":version": "rv-dxu7~ked9-sykg",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Residència per a Gent Gran Sant Vicenç de Castellet",
		"indicador_refugi": "082628|RESIDENCIA_PER_A_GENT_GRAN_SANT_VICENC_DE_CASTELLET",
		"municipi": "Sant Vicenç de Castellet",
		"codi_municipi": "082628",
		"latitud": "41.6696399810634",
		"longitud": "1.8694860884499",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "Sí",
		"adreca": "Carrer del Poeta Maragall, 20",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "Drets Socials i Inclusió",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-wyqz_669m_xe3w",
		":version": "rv-h6hx~zyuu-eh4i",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Residència per a Gent Gran Santa Coloma de Gramenet",
		"indicador_refugi": "082457|RESIDENCIA_PER_A_GENT_GRAN_SANTA_COLOMA_DE_GRAMENET",
		"municipi": "Santa Coloma de Gramenet",
		"codi_municipi": "082457",
		"latitud": "41.4618626230239",
		"longitud": "2.20822225210892",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "Sí",
		"adreca": "Avinguda Ramón Berenguer, 68",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "Drets Socials i Inclusió",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-cxcm~ee4g-jbe2",
		":version": "rv-efrh_didg_g2i8",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Residència per a Gent Gran Santa Rosa",
		"indicador_refugi": "081249|RESIDENCIA_PER_A_GENT_GRAN_SANTA_ROSA",
		"municipi": "Mollet del Vallès",
		"codi_municipi": "081249",
		"latitud": "41.5420295144024",
		"longitud": "2.20320126001189",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "Sí",
		"adreca": "Carrer Álvarez de Castro, 53-57",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "Drets Socials i Inclusió",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-jwi3_2qve_2wch",
		":version": "rv-urmv.6z3u_i59z",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Residència per a Gent Gran Serafí Casanovas Sansa",
		"indicador_refugi": "252094|RESIDENCIA_PER_A_GENT_GRAN_SERAFI_CASANOVAS_SANSA",
		"municipi": "Sort",
		"codi_municipi": "252094",
		"latitud": "42.4079752759662",
		"longitud": "1.13319429849467",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "Sí",
		"adreca": "Carretera de la Seu d’Urgell, 12",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "Drets Socials i Inclusió",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-3eyw.tzak_38gd",
		":version": "rv-4u9w~uwg8-xe37",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Residència per a Gent Gran Terrassa",
		"indicador_refugi": "082798|RESIDENCIA_PER_A_GENT_GRAN_TERRASSA",
		"municipi": "Terrassa",
		"codi_municipi": "082798",
		"latitud": "41.583598614398",
		"longitud": "2.04004362708131",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "Sí",
		"adreca": "Carretera de Castellar, s/n (Finca Mossen Homs)",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "Drets Socials i Inclusió",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	},
	{
		":id": "row-2qqy-i9rc-u7hj",
		":version": "rv-tney_s4kg-4hwf",
		":created_at": "2026-07-15T08:38:46.939Z",
		":updated_at": "2026-07-15T08:38:46.939Z",
		"nom": "Residència per a Gent Gran Vallbona",
		"indicador_refugi": "080193|RESIDENCIA_PER_A_GENT_GRAN_VALLBONA",
		"municipi": "Barcelona",
		"codi_municipi": "080193",
		"latitud": "41.462648484099",
		"longitud": "2.18391207564431",
		"accessibilitat": "Sí",
		"aigua": "Sí",
		"climatitzacio": "Sí",
		"area_descans": "No",
		"lavabo": "Sí",
		"adreca": "Carrer Pierola, 22",
		"tipologia": "Equipament de proximitat",
		"origen_identificador": "Drets Socials i Inclusió",
		"ultima_actualitzacio": "2026-07-15T09:50:00.000"
	}
]
